(function() {
	for (
		var aa =
				"function" == typeof Object.defineProperties
					? Object.defineProperty
					: function(a, b, c) {
							if (c.get || c.set)
								throw new TypeError("ES3 does not support getters and setters.");
							a != Array.prototype && a != Object.prototype && (a[b] = c.value);
					  },
			k =
				"undefined" != typeof window && window === this
					? this
					: "undefined" != typeof global && null != global
					? global
					: this,
			m = ["String", "prototype", "repeat"],
			n = 0;
		n < m.length - 1;
		n++
	) {
		var p = m[n];
		p in k || (k[p] = {});
		k = k[p];
	}
	var ba = m[m.length - 1],
		r = k[ba],
		t = r
			? r
			: function(a) {
					var b;
					if (null == this)
						throw new TypeError(
							"The 'this' value for String.prototype.repeat must not be null or undefined"
						);
					b = this + "";
					if (0 > a || 1342177279 < a) throw new RangeError("Invalid count value");
					a |= 0;
					for (var c = ""; a; ) if ((a & 1 && (c += b), (a >>>= 1))) b += b;
					return c;
			  };
	t != r && null != t && aa(k, ba, { configurable: !0, writable: !0, value: t });
	var ca = this;
	function u(a) {
		return "string" == typeof a;
	}
	function v(a, b) {
		var c = a.split("."),
			d = ca;
		c[0] in d || !d.execScript || d.execScript("var " + c[0]);
		for (var e; c.length && (e = c.shift()); )
			c.length || void 0 === b
				? d[e]
					? (d = d[e])
					: (d = d[e] = {})
				: (d[e] = b);
	}
	function w(a, b) {
		function c() {}
		c.prototype = b.prototype;
		a.$ = b.prototype;
		a.prototype = new c();
		a.prototype.constructor = a;
		a.w = function(a, c, f) {
			for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++)
				d[e - 2] = arguments[e];
			return b.prototype[c].apply(a, d);
		};
	}
	var x = Array.prototype.indexOf
		? function(a, b, c) {
				return Array.prototype.indexOf.call(a, b, c);
		  }
		: function(a, b, c) {
				c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
				if (u(a)) return u(b) && 1 == b.length ? a.indexOf(b, c) : -1;
				for (; c < a.length; c++) if (c in a && a[c] === b) return c;
				return -1;
		  };
	function da(a, b) {
		a.sort(b || ea);
	}
	function ea(a, b) {
		return a > b ? 1 : a < b ? -1 : 0;
	}
	function fa(a, b) {
		this.a = a;
		this.h = !!b.i;
		this.c = b.b;
		this.m = b.type;
		this.l = !1;
		switch (this.c) {
			case ga:
			case ha:
			case ia:
			case ja:
			case ka:
			case la:
			case ma:
				this.l = !0;
		}
		this.g = b.defaultValue;
	}
	var ma = 1,
		la = 2,
		ga = 3,
		ha = 4,
		ia = 6,
		ja = 16,
		ka = 18;
	function na(a) {
		var b = [],
			c = 0,
			d;
		for (d in a) b[c++] = a[d];
		return b;
	}
	function oa(a, b) {
		this.c = a;
		this.a = {};
		for (var c = 0; c < b.length; c++) {
			var d = b[c];
			this.a[d.a] = d;
		}
	}
	function pa(a) {
		a = na(a.a);
		da(a, function(a, c) {
			return a.a - c.a;
		});
		return a;
	}
	function y() {
		this.a = {};
		this.g = this.f().a;
		this.c = this.h = null;
	}
	y.prototype.has = function(a) {
		return null != this.a[a.a];
	};
	y.prototype.get = function(a, b) {
		return A(this, a.a, b);
	};
	y.prototype.set = function(a, b) {
		B(this, a.a, b);
	};
	function qa(a, b) {
		for (var c = pa(a.f()), d = 0; d < c.length; d++) {
			var e = c[d],
				f = e.a;
			if (null != b.a[f]) {
				a.c && delete a.c[e.a];
				var g = 11 == e.c || 10 == e.c;
				if (e.h)
					for (var e = C(b, f) || [], h = 0; h < e.length; h++) {
						var l = a,
							q = f,
							z = g ? e[h].clone() : e[h];
						l.a[q] || (l.a[q] = []);
						l.a[q].push(z);
						l.c && delete l.c[q];
					}
				else
					(e = C(b, f)),
						g ? ((g = C(a, f)) ? qa(g, e) : B(a, f, e.clone())) : B(a, f, e);
			}
		}
	}
	y.prototype.clone = function() {
		var a = new this.constructor();
		a != this && ((a.a = {}), a.c && (a.c = {}), qa(a, this));
		return a;
	};
	function C(a, b) {
		var c = a.a[b];
		if (null == c) return null;
		if (a.h) {
			if (!(b in a.c)) {
				var d = a.h,
					e = a.g[b];
				if (null != c)
					if (e.h) {
						for (var f = [], g = 0; g < c.length; g++) f[g] = d.a(e, c[g]);
						c = f;
					} else c = d.a(e, c);
				return (a.c[b] = c);
			}
			return a.c[b];
		}
		return c;
	}
	function A(a, b, c) {
		var d = C(a, b);
		return a.g[b].h ? d[c || 0] : d;
	}
	function D(a, b) {
		var c;
		if (null != a.a[b]) c = A(a, b, void 0);
		else
			a: {
				c = a.g[b];
				if (void 0 === c.g) {
					var d = c.m;
					if (d === Boolean) c.g = !1;
					else if (d === Number) c.g = 0;
					else if (d === String) c.g = c.l ? "0" : "";
					else {
						c = new d();
						break a;
					}
				}
				c = c.g;
			}
		return c;
	}
	function ra(a, b) {
		return a.g[b].h
			? null != a.a[b]
				? a.a[b].length
				: 0
			: null != a.a[b]
			? 1
			: 0;
	}
	function B(a, b, c) {
		a.a[b] = c;
		a.c && (a.c[b] = c);
	}
	function E(a, b) {
		var c = [],
			d;
		for (d in b) 0 != d && c.push(new fa(d, b[d]));
		return new oa(a, c);
	}
	function F() {}
	F.prototype.c = function(a) {
		new a.c();
		throw Error("Unimplemented");
	};
	F.prototype.a = function(a, b) {
		if (11 == a.c || 10 == a.c)
			return b instanceof y ? b : this.c(a.m.prototype.f(), b);
		if (14 == a.c) {
			if (u(b) && sa.test(b)) {
				var c = Number(b);
				if (0 < c) return c;
			}
			return b;
		}
		if (!a.l) return b;
		c = a.m;
		if (c === String) {
			if ("number" == typeof b) return String(b);
		} else if (
			c === Number &&
			u(b) &&
			("Infinity" === b || "-Infinity" === b || "NaN" === b || sa.test(b))
		)
			return Number(b);
		return b;
	};
	var sa = /^-?[0-9]+$/;
	function G() {}
	w(G, F);
	G.prototype.c = function(a, b) {
		var c = new a.c();
		c.h = this;
		c.a = b;
		c.c = {};
		return c;
	};
	function H() {}
	w(H, G);
	H.prototype.a = function(a, b) {
		return 8 == a.c ? !!b : F.prototype.a.apply(this, arguments);
	};
	function I(a, b) {
		null != a && this.a.apply(this, arguments);
	}
	I.prototype.c = "";
	I.prototype.set = function(a) {
		this.c = "" + a;
	};
	I.prototype.a = function(a, b, c) {
		this.c += String(a);
		if (null != b)
			for (var d = 1; d < arguments.length; d++) this.c += arguments[d];
		return this;
	};
	I.prototype.toString = function() {
		return this.c;
	}; /*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
	function J() {
		y.call(this);
	}
	w(J, y);
	var ta = null;
	function K() {
		y.call(this);
	}
	w(K, y);
	var ua = null;
	function L() {
		y.call(this);
	}
	w(L, y);
	var wa = null;
	J.prototype.f = function() {
		var a = ta;
		a ||
			(ta = a = E(J, {
				0: { name: "NumberFormat", j: "i18n.phonenumbers.NumberFormat" },
				1: { name: "pattern", required: !0, b: 9, type: String },
				2: { name: "format", required: !0, b: 9, type: String },
				3: { name: "leading_digits_pattern", i: !0, b: 9, type: String },
				4: { name: "national_prefix_formatting_rule", b: 9, type: String },
				6: {
					name: "national_prefix_optional_when_formatting",
					b: 8,
					type: Boolean
				},
				5: { name: "domestic_carrier_code_formatting_rule", b: 9, type: String }
			}));
		return a;
	};
	J.f = J.prototype.f;
	K.prototype.f = function() {
		var a = ua;
		a ||
			(ua = a = E(K, {
				0: { name: "PhoneNumberDesc", j: "i18n.phonenumbers.PhoneNumberDesc" },
				2: { name: "national_number_pattern", b: 9, type: String },
				3: { name: "possible_number_pattern", b: 9, type: String },
				9: { name: "possible_length", i: !0, b: 5, type: Number },
				10: { name: "possible_length_local_only", i: !0, b: 5, type: Number },
				6: { name: "example_number", b: 9, type: String },
				7: { name: "national_number_matcher_data", b: 12, type: String },
				8: { name: "possible_number_matcher_data", b: 12, type: String }
			}));
		return a;
	};
	K.f = K.prototype.f;
	L.prototype.f = function() {
		var a = wa;
		a ||
			(wa = a = E(L, {
				0: { name: "PhoneMetadata", j: "i18n.phonenumbers.PhoneMetadata" },
				1: { name: "general_desc", b: 11, type: K },
				2: { name: "fixed_line", b: 11, type: K },
				3: { name: "mobile", b: 11, type: K },
				4: { name: "toll_free", b: 11, type: K },
				5: { name: "premium_rate", b: 11, type: K },
				6: { name: "shared_cost", b: 11, type: K },
				7: { name: "personal_number", b: 11, type: K },
				8: { name: "voip", b: 11, type: K },
				21: { name: "pager", b: 11, type: K },
				25: { name: "uan", b: 11, type: K },
				27: { name: "emergency", b: 11, type: K },
				28: { name: "voicemail", b: 11, type: K },
				24: { name: "no_international_dialling", b: 11, type: K },
				9: { name: "id", required: !0, b: 9, type: String },
				10: { name: "country_code", b: 5, type: Number },
				11: { name: "international_prefix", b: 9, type: String },
				17: { name: "preferred_international_prefix", b: 9, type: String },
				12: { name: "national_prefix", b: 9, type: String },
				13: { name: "preferred_extn_prefix", b: 9, type: String },
				15: { name: "national_prefix_for_parsing", b: 9, type: String },
				16: { name: "national_prefix_transform_rule", b: 9, type: String },
				18: {
					name: "same_mobile_and_fixed_line_pattern",
					b: 8,
					defaultValue: !1,
					type: Boolean
				},
				19: { name: "number_format", i: !0, b: 11, type: J },
				20: { name: "intl_number_format", i: !0, b: 11, type: J },
				22: {
					name: "main_country_for_code",
					b: 8,
					defaultValue: !1,
					type: Boolean
				},
				23: { name: "leading_digits", b: 9, type: String },
				26: { name: "leading_zero_possible", b: 8, defaultValue: !1, type: Boolean }
			}));
		return a;
	};
	L.f = L.prototype.f;
	function M() {
		y.call(this);
	}
	var N;
	w(M, y);
	var xa = { v: 1, u: 5, s: 10, o: 20 };
	M.prototype.f = function() {
		N ||
			(N = E(M, {
				0: { name: "PhoneNumber", j: "i18n.phonenumbers.PhoneNumber" },
				1: { name: "country_code", required: !0, b: 5, type: Number },
				2: { name: "national_number", required: !0, b: 4, type: Number },
				3: { name: "extension", b: 9, type: String },
				4: { name: "italian_leading_zero", b: 8, type: Boolean },
				8: { name: "number_of_leading_zeros", b: 5, defaultValue: 1, type: Number },
				5: { name: "raw_input", b: 9, type: String },
				6: { name: "country_code_source", b: 14, defaultValue: 1, type: xa },
				7: { name: "preferred_domestic_carrier_code", b: 9, type: String }
			}));
		return N;
	};
	M.ctor = M;
	M.ctor.f =
		M.prototype.f; /*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
	var O = {
			1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(
				" "
			),
			7: ["RU", "KZ"],
			20: ["EG"],
			27: ["ZA"],
			30: ["GR"],
			31: ["NL"],
			32: ["BE"],
			33: ["FR"],
			34: ["ES"],
			36: ["HU"],
			39: ["IT", "VA"],
			40: ["RO"],
			41: ["CH"],
			43: ["AT"],
			44: ["GB", "GG", "IM", "JE"],
			45: ["DK"],
			46: ["SE"],
			47: ["NO", "SJ"],
			48: ["PL"],
			49: ["DE"],
			51: ["PE"],
			52: ["MX"],
			53: ["CU"],
			54: ["AR"],
			55: ["BR"],
			56: ["CL"],
			57: ["CO"],
			58: ["VE"],
			60: ["MY"],
			61: ["AU", "CC", "CX"],
			62: ["ID"],
			63: ["PH"],
			64: ["NZ"],
			65: ["SG"],
			66: ["TH"],
			81: ["JP"],
			82: ["KR"],
			84: ["VN"],
			86: ["CN"],
			90: ["TR"],
			91: ["IN"],
			92: ["PK"],
			93: ["AF"],
			94: ["LK"],
			95: ["MM"],
			98: ["IR"],
			211: ["SS"],
			212: ["MA", "EH"],
			213: ["DZ"],
			216: ["TN"],
			218: ["LY"],
			220: ["GM"],
			221: ["SN"],
			222: ["MR"],
			223: ["ML"],
			224: ["GN"],
			225: ["CI"],
			226: ["BF"],
			227: ["NE"],
			228: ["TG"],
			229: ["BJ"],
			230: ["MU"],
			231: ["LR"],
			232: ["SL"],
			233: ["GH"],
			234: ["NG"],
			235: ["TD"],
			236: ["CF"],
			237: ["CM"],
			238: ["CV"],
			239: ["ST"],
			240: ["GQ"],
			241: ["GA"],
			242: ["CG"],
			243: ["CD"],
			244: ["AO"],
			245: ["GW"],
			246: ["IO"],
			247: ["AC"],
			248: ["SC"],
			249: ["SD"],
			250: ["RW"],
			251: ["ET"],
			252: ["SO"],
			253: ["DJ"],
			254: ["KE"],
			255: ["TZ"],
			256: ["UG"],
			257: ["BI"],
			258: ["MZ"],
			260: ["ZM"],
			261: ["MG"],
			262: ["RE", "YT"],
			263: ["ZW"],
			264: ["NA"],
			265: ["MW"],
			266: ["LS"],
			267: ["BW"],
			268: ["SZ"],
			269: ["KM"],
			290: ["SH", "TA"],
			291: ["ER"],
			297: ["AW"],
			298: ["FO"],
			299: ["GL"],
			350: ["GI"],
			351: ["PT"],
			352: ["LU"],
			353: ["IE"],
			354: ["IS"],
			355: ["AL"],
			356: ["MT"],
			357: ["CY"],
			358: ["FI", "AX"],
			359: ["BG"],
			370: ["LT"],
			371: ["LV"],
			372: ["EE"],
			373: ["MD"],
			374: ["AM"],
			375: ["BY"],
			376: ["AD"],
			377: ["MC"],
			378: ["SM"],
			380: ["UA"],
			381: ["RS"],
			382: ["ME"],
			385: ["HR"],
			386: ["SI"],
			387: ["BA"],
			389: ["MK"],
			420: ["CZ"],
			421: ["SK"],
			423: ["LI"],
			500: ["FK"],
			501: ["BZ"],
			502: ["GT"],
			503: ["SV"],
			504: ["HN"],
			505: ["NI"],
			506: ["CR"],
			507: ["PA"],
			508: ["PM"],
			509: ["HT"],
			590: ["GP", "BL", "MF"],
			591: ["BO"],
			592: ["GY"],
			593: ["EC"],
			594: ["GF"],
			595: ["PY"],
			596: ["MQ"],
			597: ["SR"],
			598: ["UY"],
			599: ["CW", "BQ"],
			670: ["TL"],
			672: ["NF"],
			673: ["BN"],
			674: ["NR"],
			675: ["PG"],
			676: ["TO"],
			677: ["SB"],
			678: ["VU"],
			679: ["FJ"],
			680: ["PW"],
			681: ["WF"],
			682: ["CK"],
			683: ["NU"],
			685: ["WS"],
			686: ["KI"],
			687: ["NC"],
			688: ["TV"],
			689: ["PF"],
			690: ["TK"],
			691: ["FM"],
			692: ["MH"],
			800: ["001"],
			808: ["001"],
			850: ["KP"],
			852: ["HK"],
			853: ["MO"],
			855: ["KH"],
			856: ["LA"],
			870: ["001"],
			878: ["001"],
			880: ["BD"],
			881: ["001"],
			882: ["001"],
			883: ["001"],
			886: ["TW"],
			888: ["001"],
			960: ["MV"],
			961: ["LB"],
			962: ["JO"],
			963: ["SY"],
			964: ["IQ"],
			965: ["KW"],
			966: ["SA"],
			967: ["YE"],
			968: ["OM"],
			970: ["PS"],
			971: ["AE"],
			972: ["IL"],
			973: ["BH"],
			974: ["QA"],
			975: ["BT"],
			976: ["MN"],
			977: ["NP"],
			979: ["001"],
			992: ["TJ"],
			993: ["TM"],
			994: ["AZ"],
			995: ["GE"],
			996: ["KG"],
			998: ["UZ"]
		},
		ya = {
			AC: [
				,
				[, , "[46]\\d{4}|[01589]\\d{5}", , , , , , , [5, 6]],
				[, , "6[2-467]\\d{3}", , , , "62889", , , [5]],
				[, , "4\\d{4}", , , , "40123", , , [5]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AC",
				247,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "[01589]\\d{5}", , , , "542011", , , [6]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AD: [
				,
				[, , "[16]\\d{5,8}|[37-9]\\d{5}", , , , , , , [6, 8, 9]],
				[, , "[78]\\d{5}", , , , "712345", , , [6]],
				[, , "(?:3\\d|6(?:[0-8]|90\\d{2}))\\d{4}", , , , "312345", , , [6, 9]],
				[, , "180[02]\\d{4}", , , , "18001234", , , [8]],
				[, , "[19]\\d{5}", , , , "912345", , , [6]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AD",
				376,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})", "$1 $2", ["[137-9]|6[0-8]"]],
					[, "(\\d{4})(\\d{4})", "$1 $2", ["180", "180[02]"]],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["690"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "1800\\d{4}", , , , "18000000", , , [8]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AE: [
				,
				[, , "[2-79]\\d{7,8}|800\\d{2,9}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
				[, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8]],
				[, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
				[, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
				[, , "900[02]\\d{5}", , , , "900234567", , , [9]],
				[, , "700[05]\\d{5}", , , , "700012345", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AE",
				971,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([2-4679])(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-4679][2-8]"], "0$1"],
					[, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
					[, "([479]00)(\\d)(\\d{5})", "$1 $2 $3", ["[479]0"], "$1"],
					[, "([68]00)(\\d{2,9})", "$1 $2", ["60|8"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "600[25]\\d{5}", , , , "600212345", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AF: [
				,
				[, , "[2-7]\\d{8}", , , , , , , [9], [7]],
				[, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890"],
				[, , "7(?:[014-9]\\d{7}|2[89]\\d{6})", , , , "701234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AF",
				93,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([2-7]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AG: [
				,
				[, , "[2589]\\d{9}", , , , , , , [10], [7]],
				[, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234"],
				[
					,
					,
					"268(?:464|7(?:2\\d|3[246]|64|7[0-689]|8[02-68]))\\d{4}",
					,
					,
					,
					"2684641234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "26848[01]\\d{4}", , , , "2684801234"],
				"AG",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "26840[69]\\d{4}", , , , "2684061234"],
				,
				"268",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AI: [
				,
				[, , "[2589]\\d{9}", , , , , , , [10], [7]],
				[, , "2644(?:6[12]|9[78])\\d{4}", , , , "2644612345"],
				[
					,
					,
					"264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
					,
					,
					,
					"2642351234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"AI",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"264",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AL: [
				,
				[
					,
					,
					"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",
					,
					,
					,
					,
					,
					,
					[6, 7, 8, 9],
					[5]
				],
				[
					,
					,
					"(?:2(?:[168][1-9]|[247]\\d|9[1-7])|3(?:1[1-3]|[2-6]\\d|[79][1-8]|8[1-9])|4\\d{2}|5(?:1[1-4]|[2-578]\\d|6[1-5]|9[1-7])|8(?:[19][1-5]|[2-6]\\d|[78][1-7]))\\d{5}",
					,
					,
					,
					"22345678",
					,
					,
					[8]
				],
				[, , "6[6-9]\\d{7}", , , , "661234567", , , [9]],
				[, , "800\\d{4}", , , , "8001234", , , [7]],
				[, , "900\\d{3}", , , , "900123", , , [6]],
				[, , "808\\d{3}", , , , "808123", , , [6]],
				[, , "700\\d{5}", , , , "70012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				"AL",
				355,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(4)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[0-6]"], "0$1"],
					[, "(6[6-9])(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4[7-9]"], "0$1"],
					[, "(\\d{3})(\\d{3,5})", "$1 $2", ["[235][16-9]|8[016-9]|[79]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AM: [
				,
				[, , "[1-9]\\d{7}", , , , , , , [8], [5, 6]],
				[
					,
					,
					"(?:1[0-2]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}",
					,
					,
					,
					"10123456"
				],
				[, , "(?:4[1349]|55|77|9[1-9])\\d{6}", , , , "77123456"],
				[, , "800\\d{5}", , , , "80012345"],
				[, , "90[016]\\d{5}", , , , "90012345"],
				[, , "80[1-4]\\d{5}", , , , "80112345"],
				[, , "NA", , , , , , , [-1]],
				[, , "60(?:2[078]|[3-7]\\d|8[0-5])\\d{4}", , , , "60271234"],
				"AM",
				374,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"],
					[, "(\\d{2})(\\d{6})", "$1 $2", ["4[1349]|[5-7]|9[1-9]"], "0$1"],
					[, "(\\d{3})(\\d{5})", "$1 $2", ["[23]"], "(0$1)"],
					[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8|90"], "0 $1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AO: [
				,
				[, , "[29]\\d{8}", , , , , , , [9]],
				[, , "2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}", , , , "222123456"],
				[, , "9[1-49]\\d{7}", , , , "923123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AO",
				244,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AR: [
				,
				[, , "11\\d{8}|[2368]\\d{9}|9\\d{10}", , , , , , , [10, 11], [6, 7, 8]],
				[
					,
					,
					"11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}",
					,
					,
					,
					"1123456789",
					,
					,
					[10]
				],
				[
					,
					,
					"675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})",
					,
					,
					,
					"91123456789"
				],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AR",
				54,
				"00",
				"0",
				,
				,
				"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?",
				"9$1",
				,
				,
				[
					[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
					[, "(\\d{2})(\\d{4})", "$1-$2", ["[2-9]"], "$1"],
					[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"], "$1"],
					[, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9]"], "$1"],
					[, "(9)(11)(\\d{4})(\\d{4})", "$2 15-$3-$4", ["911"], "0$1"],
					[
						,
						"(9)(\\d{3})(\\d{3})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9(?:2[234689]|3[3-8])",
							"9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
						],
						"0$1"
					],
					[, "(9)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9[23]"], "0$1"],
					[, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
						],
						"0$1",
						,
						1
					],
					[, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
					[, "(\\d{3})", "$1", ["1[012]|911"], "$1"]
				],
				[
					[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
					[, "(9)(11)(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["911"]],
					[
						,
						"(9)(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3-$4",
						[
							"9(?:2[234689]|3[3-8])",
							"9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
						]
					],
					[, "(9)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", ["9[23]"]],
					[, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
						],
						"0$1",
						,
						1
					],
					[, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "810\\d{7}", , , , "8101234567", , , [10]],
				[, , "810\\d{7}", , , , "8101234567", , , [10]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AS: [
				,
				[, , "[5689]\\d{9}", , , , , , , [10], [7]],
				[, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234"],
				[, , "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", , , , "6847331234"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"AS",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"684",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AT: [
				,
				[, , "[1-9]\\d{3,12}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]],
				[
					,
					,
					"1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}",
					,
					,
					,
					"1234567890"
				],
				[
					,
					,
					"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
					,
					,
					,
					"664123456",
					,
					,
					[7, 8, 9, 10, 11, 12, 13]
				],
				[, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]],
				[
					,
					,
					"9(?:0[01]|3[019])\\d{6,10}",
					,
					,
					,
					"900123456",
					,
					,
					[9, 10, 11, 12, 13]
				],
				[
					,
					,
					"8(?:10\\d|2(?:[01]\\d|8\\d?))\\d{5,9}",
					,
					,
					,
					"810123456",
					,
					,
					[8, 9, 10, 11, 12, 13]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "780\\d{6,10}", , , , "780123456", , , [9, 10, 11, 12, 13]],
				"AT",
				43,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(116\\d{3})", "$1", ["116"], "$1"],
					[, "(1)(\\d{3,12})", "$1 $2", ["1"], "0$1"],
					[, "(5\\d)(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
					[, "(5\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5[079]"], "0$1"],
					[, "(5\\d)(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5[079]"], "0$1"],
					[
						,
						"(\\d{3})(\\d{3,10})",
						"$1 $2",
						["316|46|51|732|6(?:5[0-3579]|[6-9])|7(?:[28]0)|[89]"],
						"0$1"
					],
					[
						,
						"(\\d{4})(\\d{3,9})",
						"$1 $2",
						[
							"2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"
						],
						"0$1"
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}",
					,
					,
					,
					"50123",
					,
					,
					[5, 6, 7, 8, 9, 10, 11, 12, 13]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AU: [
				,
				[, , "1\\d{4,9}|[2-578]\\d{8}", , , , , , , [5, 6, 7, 8, 9, 10]],
				[
					,
					,
					"[237]\\d{8}|8(?:[6-8]\\d{3}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}",
					,
					,
					,
					"212345678",
					,
					,
					[9]
				],
				[
					,
					,
					"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					,
					,
					,
					"412345678",
					,
					,
					[9]
				],
				[, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
				[, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]],
				[
					,
					,
					"13(?:00\\d{3}|45[0-4]|\\d)\\d{3}",
					,
					,
					,
					"1300123456",
					,
					,
					[6, 8, 10]
				],
				[, , "500\\d{6}", , , , "500123456", , , [9]],
				[, , "550\\d{6}", , , , "550123456", , , [9]],
				"AU",
				61,
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]",
				"0",
				,
				,
				"0",
				,
				"0011",
				,
				[
					[, "([2378])(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]|14"], "0$1"],
					[, "(16)(\\d{3,4})", "$1 $2", ["16"], "0$1"],
					[, "(16)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"],
					[
						,
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["1(?:[38]0|90)", "1(?:[38]00|90)"],
						"$1"
					],
					[, "(180)(2\\d{3})", "$1 $2", ["180", "1802"], "$1"],
					[, "(19\\d)(\\d{3})", "$1 $2", ["19[13]"], "$1"],
					[, "(19\\d{2})(\\d{4})", "$1 $2", ["19[679]"], "$1"],
					[, "(13)(\\d{2})(\\d{2})", "$1 $2 $3", ["13[1-9]"], "$1"]
				],
				,
				[, , "16\\d{3,7}", , , , "1612345", , , [5, 6, 7, 8, 9]],
				1,
				,
				[
					,
					,
					"1(?:3(?:00\\d{3}|45[0-4]|\\d)\\d{3}|80(?:0\\d{6}|2\\d{3}))",
					,
					,
					,
					"1300123456",
					,
					,
					[6, 7, 8, 10]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AW: [
				,
				[, , "[25-9]\\d{6}", , , , , , , [7]],
				[, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"],
				[
					,
					,
					"(?:5(?:6\\d|9[2-478])|6(?:[039]0|22|4[01]|6[0-2])|7[34]\\d|9(?:6[45]|9[4-8]))\\d{4}",
					,
					,
					,
					"5601234"
				],
				[, , "800\\d{4}", , , , "8001234"],
				[, , "900\\d{4}", , , , "9001234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "28\\d{5}|501\\d{4}", , , , "5011234"],
				"AW",
				297,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AX: [
				,
				[
					,
					,
					"1\\d{5,11}|[35]\\d{5,9}|[27]\\d{4,9}|4\\d{5,10}|6\\d{7,9}|8\\d{6,9}",
					,
					,
					,
					,
					,
					,
					[5, 6, 7, 8, 9, 10, 11, 12]
				],
				[, , "18[1-8]\\d{3,9}", , , , "1812345678", , , [6, 7, 8, 9, 10, 11, 12]],
				[, , "4\\d{5,10}|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]],
				[, , "800\\d{4,7}", , , , "8001234567", , , [7, 8, 9, 10]],
				[, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AX",
				358,
				"00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))",
				"0",
				,
				,
				"0",
				,
				"00",
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[
					,
					,
					"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
					,
					,
					,
					"100123",
					,
					,
					[5, 6, 7, 8, 9, 10]
				],
				[
					,
					,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
					,
					,
					,
					"10112345",
					,
					,
					[5, 6, 7, 8, 9, 10]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			AZ: [
				,
				[, , "[1-9]\\d{8}", , , , , , , [9], [7]],
				[
					,
					,
					"(?:1[28]\\d{3}|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])\\d{2}|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}",
					,
					,
					,
					"123123456"
				],
				[, , "(?:36554|(?:4[04]|5[015]|60|7[07])\\d{3})\\d{4}", , , , "401234567"],
				[, , "88\\d{7}", , , , "881234567"],
				[, , "900200\\d{3}", , , , "900200123"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"AZ",
				994,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["(?:1[28]|2(?:[45]2|[0-36])|365)"],
						"(0$1)"
					],
					[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[4-8]"], "0$1"],
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BA: [
				,
				[, , "[3-9]\\d{7,8}", , , , , , , [8, 9], [6]],
				[, , "(?:[35]\\d|49)\\d{6}", , , , "30123456", , , [8]],
				[, , "6(?:03|44|71|[1-356])\\d{6}", , , , "61123456"],
				[, , "8[08]\\d{6}", , , , "80123456", , , [8]],
				[, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
				[, , "8[12]\\d{6}", , , , "82123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BA",
				387,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"],
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6[047]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "70[23]\\d{5}", , , , "70223456", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BB: [
				,
				[, , "[2589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7(?:37|57)|9(?:1[89]|63))\\d{4}",
					,
					,
					,
					"2464123456"
				],
				[
					,
					,
					"246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|8(?:[2-5]\\d|83))\\d{4}",
					,
					,
					,
					"2462501234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900\\d{7}|246976\\d{4}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "24631\\d{5}", , , , "2463101234"],
				"BB",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"246",
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"246(?:292|367|4(?:1[7-9]|3[01]|44|67)|736)\\d{4}",
					,
					,
					,
					"2464301234"
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BD: [
				,
				[, , "[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}", , , , , , , [6, 7, 8, 9, 10]],
				[
					,
					,
					"2(?:[45]\\d{3}|7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|41|6[1-35]|7[1-5]|8[1-8]|90)|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[0146-9]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}",
					,
					,
					,
					"27111234",
					,
					,
					[6, 7, 8, 9]
				],
				[
					,
					,
					"(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}",
					,
					,
					,
					"1812345678",
					,
					,
					[10]
				],
				[, , "80[03]\\d{7}", , , , "8001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "96(?:0[49]|1[0-4]|6[69])\\d{6}", , , , "9604123456", , , [10]],
				"BD",
				880,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(\\d{7,8})", "$1-$2", ["2"], "0$1"],
					[, "(\\d{2})(\\d{4,6})", "$1-$2", ["[3-79]1"], "0$1"],
					[
						,
						"(\\d{4})(\\d{3,6})",
						"$1-$2",
						[
							"1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"
						],
						"0$1"
					],
					[, "(\\d{3})(\\d{3,7})", "$1-$2", ["[3-79][2-9]|8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BE: [
				,
				[, , "[1-9]\\d{7,8}", , , , , , , [8, 9]],
				[
					,
					,
					"(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}|80[2-8]\\d{5}",
					,
					,
					,
					"12345678",
					,
					,
					[8]
				],
				[, , "4(?:6[0135-8]|[79]\\d|8[3-9])\\d{6}", , , , "470123456", , , [9]],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "(?:70[2-467]|90[0-79])\\d{5}", , , , "90123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BE",
				32,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[6-9]"], "0$1"],
					[
						,
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[23]|4[23]|9[2-4]"],
						"0$1"
					],
					[
						,
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[156]|7[018]|8(?:0[1-9]|[1-79])"],
						"0$1"
					],
					[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "78\\d{6}", , , , "78123456", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BF: [
				,
				[, , "[25-7]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"2(?:0(?:49|5[23]|9[016-9])|4(?:4[569]|5[4-6]|7[0179])|5(?:[34]\\d|50))\\d{4}",
					,
					,
					,
					"20491234"
				],
				[, , "(?:55[0-5]|6(?:[0-689]\\d|7[0-5]))\\d{5}|7\\d{7}", , , , "70123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BF",
				226,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BG: [
				,
				[, , "[23567]\\d{5,7}|[489]\\d{6,8}", , , , , , , [6, 7, 8, 9], [4, 5]],
				[
					,
					,
					"2\\d{5,7}|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}",
					,
					,
					,
					"2123456",
					,
					,
					[6, 7, 8]
				],
				[
					,
					,
					"(?:8[7-9]\\d|9(?:8\\d|99))\\d{6}|4(?:3[0789]|8\\d)\\d{5}",
					,
					,
					,
					"48123456",
					,
					,
					[8, 9]
				],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "90\\d{6}", , , , "90123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "700\\d{5}", , , , "70012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				"BG",
				359,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"],
					[, "(2)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"],
					[, "(\\d{3})(\\d{4})", "$1 $2", ["43[124-7]|70[1-9]"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[124-7]|70[1-9]"], "0$1"],
					[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[78]00"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["999"], "0$1"],
					[
						,
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
						"0$1"
					],
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["48|8[7-9]|9[08]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BH: [
				,
				[, , "[136-9]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d{2}))\\d{4}",
					,
					,
					,
					"17001234"
				],
				[
					,
					,
					"(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9]|7[0-6])))\\d{4}",
					,
					,
					,
					"36001234"
				],
				[, , "80\\d{6}", , , , "80123456"],
				[, , "(?:87|9[014578])\\d{6}", , , , "90123456"],
				[, , "84\\d{6}", , , , "84123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BH",
				973,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BI: [
				,
				[, , "[267]\\d{7}", , , , , , , [8]],
				[, , "22\\d{6}", , , , "22201234"],
				[, , "(?:29|6[189]|7[124-9])\\d{6}", , , , "79561234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BI",
				257,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BJ: [
				,
				[, , "[2689]\\d{7}|7\\d{3}", , , , , , , [4, 8]],
				[, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234", , , [8]],
				[, , "(?:6[1-8]|9[03-9])\\d{6}", , , , "90011234", , , [8]],
				[, , "7[3-5]\\d{2}", , , , "7312", , , [4]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "857[58]\\d{4}", , , , "85751234", , , [8]],
				"BJ",
				229,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "81\\d{6}", , , , "81123456", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BL: [
				,
				[, , "[56]\\d{8}", , , , , , , [9]],
				[, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"],
				[, , "690(?:0[0-7]|[1-9]\\d)\\d{4}", , , , "690301234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BL",
				590,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BM: [
				,
				[, , "[4589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}",
					,
					,
					,
					"4412345678"
				],
				[, , "441(?:[37]\\d|5[0-39])\\d{5}", , , , "4413701234"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"BM",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"441",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BN: [
				,
				[, , "[2-578]\\d{6}", , , , , , , [7]],
				[, , "2(?:[013-9]\\d|2[0-7])\\d{4}|[3-5]\\d{6}", , , , "2345678"],
				[, , "22[89]\\d{4}|[78]\\d{6}", , , , "7123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BN",
				673,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "([2-578]\\d{2})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BO: [
				,
				[, , "[23467]\\d{7}", , , , , , , [8], [7]],
				[
					,
					,
					"(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}",
					,
					,
					,
					"22123456"
				],
				[, , "[67]\\d{7}", , , , "71234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BO",
				591,
				"00(1\\d)?",
				"0",
				,
				,
				"0(1\\d)?",
				,
				,
				,
				[
					[, "([234])(\\d{7})", "$1 $2", ["[234]"], , "0$CC $1"],
					[, "([67]\\d{7})", "$1", ["[67]"], , "0$CC $1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BQ: [
				,
				[, , "[347]\\d{6}", , , , , , , [7]],
				[, , "(?:318[023]|416[023]|7(?:1[578]|50)\\d)\\d{3}", , , , "7151234"],
				[
					,
					,
					"(?:318[14-68]|416[15-9]|7(?:0[01]|7[07]|[89]\\d)\\d)\\d{3}",
					,
					,
					,
					"3181234"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BQ",
				599,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BR: [
				,
				[
					,
					,
					"[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",
					,
					,
					,
					,
					,
					,
					[8, 9, 10, 11]
				],
				[
					,
					,
					"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
					,
					,
					,
					"1123456789",
					,
					,
					[10]
				],
				[
					,
					,
					"1[1-9](?:7|9\\d)\\d{7}|(?:2[12478]|3[1-578]|[4689][1-9]|5[13-5]|7[13-579])(?:[6-8]|9\\d?)\\d{7}",
					,
					,
					,
					"11961234567",
					,
					,
					[10, 11]
				],
				[, , "800\\d{6,7}", , , , "800123456", , , [9, 10]],
				[, , "(?:300|[59]00\\d?)\\d{6}", , , , "300123456", , , [9, 10]],
				[
					,
					,
					"(?:300\\d(?:\\d{2})?|40(?:0\\d|20))\\d{4}",
					,
					,
					,
					"40041234",
					,
					,
					[8, 10]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BR",
				55,
				"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
				"0",
				,
				,
				"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
				"$2",
				,
				,
				[
					[, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9](?:[1-9]|0[1-9])"], "$1"],
					[, "(\\d{5})(\\d{4})", "$1-$2", ["9(?:[1-9]|0[1-9])"], "$1"],
					[, "(\\d{3,5})", "$1", ["1[125689]"], "$1"],
					[
						,
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						["[1-9][1-9]"],
						"($1)",
						"0 $CC ($1)"
					],
					[
						,
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						["(?:[14689][1-9]|2[12478]|3[1-578]|5[1-5]|7[13-579])9"],
						"($1)",
						"0 $CC ($1)"
					],
					[, "(\\d{4})(\\d{4})", "$1-$2", ["(?:300|40(?:0|20))"]],
					[, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"]
				],
				[
					[
						,
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						["[1-9][1-9]"],
						"($1)",
						"0 $CC ($1)"
					],
					[
						,
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						["(?:[14689][1-9]|2[12478]|3[1-578]|5[1-5]|7[13-579])9"],
						"($1)",
						"0 $CC ($1)"
					],
					[, "(\\d{4})(\\d{4})", "$1-$2", ["(?:300|40(?:0|20))"]],
					[, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "(?:300\\d|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BS: [
				,
				[, , "[2589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[3467]|8[0-4]|9[2-467])|461|502|6(?:0[1-3]|12|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
					,
					,
					,
					"2423456789"
				],
				[
					,
					,
					"242(?:3(?:5[79]|[79]5)|4(?:[2-4][1-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-9]|65|77)|6[34]6|727)\\d{4}",
					,
					,
					,
					"2423591234"
				],
				[, , "242300\\d{4}|8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"BS",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"242",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BT: [
				,
				[, , "[1-8]\\d{6,7}", , , , , , , [7, 8], [6]],
				[
					,
					,
					"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
					,
					,
					,
					"2345678",
					,
					,
					[7]
				],
				[, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BT",
				975,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1|77"]],
					[, "([2-8])(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BW: [
				,
				[, , "[2-79]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0235-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
					,
					,
					,
					"2401234",
					,
					,
					[7]
				],
				[, , "7(?:[1-6]\\d|7[014-8])\\d{5}", , , , "71123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "90\\d{5}", , , , "9012345", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "79[12][01]\\d{4}", , , , "79101234", , , [8]],
				"BW",
				267,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-6]"]],
					[, "(7\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]],
					[, "(90)(\\d{5})", "$1 $2", ["9"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BY: [
				,
				[
					,
					,
					"[1-4]\\d{8}|800\\d{3,7}|[89]\\d{9,10}",
					,
					,
					,
					,
					,
					,
					[6, 7, 8, 9, 10, 11],
					[5]
				],
				[
					,
					,
					"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
					,
					,
					,
					"152450911",
					,
					,
					[9]
				],
				[
					,
					,
					"(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}",
					,
					,
					,
					"294911911",
					,
					,
					[9]
				],
				[, , "8(?:0[13]|20\\d)\\d{7}|800\\d{3,7}", , , , "8011234567"],
				[, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "249\\d{6}", , , , "249123456", , , [9]],
				"BY",
				375,
				"810",
				"8",
				,
				,
				"8?0?",
				,
				"8~10",
				,
				[
					[
						,
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						["17[0-3589]|2[4-9]|[34]", "17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],
						"8 0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])",
							"1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"
						],
						"8 0$1"
					],
					[
						,
						"(\\d{4})(\\d{2})(\\d{3})",
						"$1 $2-$3",
						[
							"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
							"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
						],
						"8 0$1"
					],
					[, "([89]\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8[01]|9"], "8 $1"],
					[, "(82\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["82"], "8 $1"],
					[, "(800)(\\d{3})", "$1 $2", ["800"], "8 $1"],
					[, "(800)(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[
					,
					,
					"8(?:0[13]|10|20\\d)\\d{7}|800\\d{3,7}|902\\d{7}",
					,
					,
					,
					"82012345678"
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			BZ: [
				,
				[, , "[2-8]\\d{6}|0\\d{10}", , , , , , , [7, 11]],
				[
					,
					,
					"(?:2(?:[02]\\d|36)|[3-58][02]\\d|7(?:[02]\\d|32))\\d{4}",
					,
					,
					,
					"2221234",
					,
					,
					[7]
				],
				[, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]],
				[, , "0800\\d{7}", , , , "08001234123", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"BZ",
				501,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]],
					[, "(0)(800)(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CA: [
				,
				[, , "[2-9]\\d{9}|3\\d{6}", , , , , , , [7, 10]],
				[
					,
					,
					"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}|310\\d{4}",
					,
					,
					,
					"2042345678",
					,
					,
					[10]
				],
				[
					,
					,
					"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
					,
					,
					,
					"2042345678",
					,
					,
					[10]
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678", , , [10]],
				[, , "NA", , , , , , , [-1]],
				"CA",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CC: [
				,
				[, , "[1458]\\d{5,9}", , , , , , , [6, 7, 9, 10], [8]],
				[, , "89162\\d{4}", , , , "891621234", , , [9]],
				[
					,
					,
					"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					,
					,
					,
					"412345678",
					,
					,
					[9]
				],
				[, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
				[, , "190[0126]\\d{6}", , , , "1900123456", , , [10]],
				[, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 10]],
				[, , "500\\d{6}", , , , "500123456", , , [9]],
				[, , "550\\d{6}", , , , "550123456", , , [9]],
				"CC",
				61,
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]",
				"0",
				,
				,
				"0",
				,
				"0011",
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CD: [
				,
				[, , "[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}", , , , , , , [7, 9]],
				[, , "1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}", , , , "1234567"],
				[, , "8(?:[0-2459]\\d{2}|8)\\d{5}|9[017-9]\\d{7}", , , , "991234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CD",
				243,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["12"], "0$1"],
					[, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[0-2459]|9"], "0$1"],
					[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
					[, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CF: [
				,
				[, , "[278]\\d{7}", , , , , , , [8]],
				[, , "2[12]\\d{6}", , , , "21612345"],
				[, , "7[0257]\\d{6}", , , , "70012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "8776\\d{4}", , , , "87761234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CF",
				236,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CG: [
				,
				[, , "[028]\\d{8}", , , , , , , [9]],
				[, , "222[1-589]\\d{5}", , , , "222123456"],
				[, , "0[14-6]\\d{7}", , , , "061234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "800\\d{6}", , , , "800123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CG",
				242,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]],
					[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CH: [
				,
				[, , "[2-9]\\d{8}|860\\d{9}", , , , , , , [9, 12]],
				[
					,
					,
					"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
					,
					,
					,
					"212345678",
					,
					,
					[9]
				],
				[, , "7[5-9]\\d{7}", , , , "781234567", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "90[016]\\d{6}", , , , "900123456", , , [9]],
				[, , "84[0248]\\d{6}", , , , "840123456", , , [9]],
				[, , "878\\d{6}", , , , "878123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"CH",
				41,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[2-7]|[89]1"],
						"0$1"
					],
					[, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"],
					[
						,
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						["860"],
						"0$1"
					]
				],
				,
				[, , "74[0248]\\d{6}", , , , "740123456", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "5[18]\\d{7}", , , , "581234567", , , [9]],
				,
				,
				[, , "860\\d{9}", , , , "860123456789", , , [12]]
			],
			CI: [
				,
				[, , "[02-8]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}",
					,
					,
					,
					"21234567"
				],
				[
					,
					,
					"(?:0[1-9]|4\\d|5[14-9]|6[015-79]|7[57-9]|8[7-9])\\d{6}",
					,
					,
					,
					"01234567"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CI",
				225,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CK: [
				,
				[, , "[2-8]\\d{4}", , , , , , , [5]],
				[, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"],
				[, , "[5-8]\\d{4}", , , , "71234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CK",
				682,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{3})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CL: [
				,
				[, , "(?:[2-9]|600|123)\\d{7,8}", , , , , , , [9, 10, 11], [7, 8]],
				[
					,
					,
					"2(?:1962\\d{4}|2\\d{7}|32[0-2467]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d{7}",
					,
					,
					,
					"221234567",
					,
					,
					[9]
				],
				[, , "9[3-9]\\d{7}", , , , "961234567", , , [9]],
				[, , "800\\d{6}|1230\\d{7}", , , , "800123456", , , [9, 11]],
				[, , "NA", , , , , , , [-1]],
				[, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]],
				[, , "NA", , , , , , , [-1]],
				[, , "44\\d{7}", , , , "441234567", , , [9]],
				"CL",
				56,
				"(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0",
				"0",
				,
				,
				"0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))",
				,
				,
				,
				[
					[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"],
					[
						,
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["[357]|4[1-35]|6[13-57]"],
						"($1)",
						"$CC ($1)"
					],
					[, "(9)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"], "0$1"],
					[, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"], "$1"],
					[, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"], "$1"],
					[, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "$1"],
					[, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"],
					[, "(\\d{4,5})", "$1", ["[1-9]"], "$1"]
				],
				[
					[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"],
					[
						,
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["[357]|4[1-35]|6[13-57]"],
						"($1)",
						"$CC ($1)"
					],
					[, "(9)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"], "0$1"],
					[, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"], "$1"],
					[, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"], "$1"],
					[, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "$1"],
					[, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CM: [
				,
				[, , "[2368]\\d{7,8}", , , , , , , [8, 9]],
				[, , "2(?:22|33|4[23])\\d{6}", , , , "222123456", , , [9]],
				[, , "6[5-9]\\d{7}", , , , "671234567", , , [9]],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "88\\d{6}", , , , "88012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CM",
				237,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]],
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|88"]],
					[, "(800)(\\d{2})(\\d{3})", "$1 $2 $3", ["80"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CN: [
				,
				[
					,
					,
					"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",
					,
					,
					,
					,
					,
					,
					[7, 8, 9, 10, 11, 12],
					[5, 6]
				],
				[
					,
					,
					"21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})|80(?:29|6[03578]|7[018]|81)\\d{4}",
					,
					,
					,
					"1012345678"
				],
				[
					,
					,
					"1(?:[38]\\d|4[57]|5[0-35-9]|7[0-35-8])\\d{8}",
					,
					,
					,
					"13123456789",
					,
					,
					[11]
				],
				[, , "(?:10)?800\\d{7}", , , , "8001234567", , , [10, 12]],
				[, , "16[08]\\d{5}", , , , "16812345", , , [8]],
				[
					,
					,
					"400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
					,
					,
					,
					"4001234567",
					,
					,
					[7, 8, 9, 10, 11]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CN",
				86,
				"(1(?:[129]\\d{3}|79\\d{2}))?00",
				"0",
				,
				,
				"(1(?:[129]\\d{3}|79\\d{2}))|0",
				,
				"00",
				,
				[
					[, "(80\\d{2})(\\d{4})", "$1 $2", ["80[2678]"], "0$1", "$CC $1", 1],
					[, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]],
					[, "(\\d{5,6})", "$1", ["100|95"]],
					[
						,
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2\\d)[19]",
							"(?:10|2\\d)(?:10|9[56])",
							"(?:10|2\\d)(?:100|9[56])"
						],
						"0$1",
						"$CC $1"
					],
					[
						,
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						["[3-9]", "[3-9]\\d{2}[19]", "[3-9]\\d{2}(?:10|9[56])"],
						"0$1",
						"$CC $1"
					],
					[, "(\\d{3,4})(\\d{4})", "$1 $2", ["[2-9]"]],
					[, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1],
					[
						,
						"([12]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10[1-9]|2[02-9]",
							"10[1-9]|2[02-9]",
							"10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["807", "8078"],
						"0$1",
						"$CC $1",
						1
					],
					[, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-578]"], , "$CC $1"],
					[, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]],
					[, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]
				],
				[
					[, "(80\\d{2})(\\d{4})", "$1 $2", ["80[2678]"], "0$1", "$CC $1", 1],
					[, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]],
					[
						,
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2\\d)[19]",
							"(?:10|2\\d)(?:10|9[56])",
							"(?:10|2\\d)(?:100|9[56])"
						],
						"0$1",
						"$CC $1"
					],
					[
						,
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						["[3-9]", "[3-9]\\d{2}[19]", "[3-9]\\d{2}(?:10|9[56])"],
						"0$1",
						"$CC $1"
					],
					[, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1],
					[
						,
						"([12]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10[1-9]|2[02-9]",
							"10[1-9]|2[02-9]",
							"10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"
						],
						"0$1",
						"$CC $1",
						1
					],
					[
						,
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["807", "8078"],
						"0$1",
						"$CC $1",
						1
					],
					[, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-578]"], , "$CC $1"],
					[, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]],
					[, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[
					,
					,
					"(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}",
					,
					,
					,
					"4001234567",
					,
					,
					[10, 11, 12]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CO: [
				,
				[, , "(?:[13]\\d{0,3}|[24-8])\\d{7}", , , , , , , [8, 10, 11], [7]],
				[, , "[124-8][2-9]\\d{6}", , , , "12345678", , , [8]],
				[, , "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", , , , "3211234567", , , [10]],
				[, , "1800\\d{7}", , , , "18001234567", , , [11]],
				[, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CO",
				57,
				"00(?:4(?:[14]4|56)|[579])",
				"0",
				,
				,
				"0([3579]|4(?:44|56))?",
				,
				,
				,
				[
					[
						,
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1(?:8[2-9]|9[0-3]|[2-7])|[24-8]",
							"1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"
						],
						"($1)",
						"0$CC $1"
					],
					[, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"],
					[
						,
						"(1)(\\d{3})(\\d{7})",
						"$1-$2-$3",
						["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"],
						"0$1"
					]
				],
				[
					[
						,
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1(?:8[2-9]|9[0-3]|[2-7])|[24-8]",
							"1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"
						],
						"($1)",
						"0$CC $1"
					],
					[, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"],
					[
						,
						"(1)(\\d{3})(\\d{7})",
						"$1 $2 $3",
						["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"]
					]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CR: [
				,
				[, , "[24-9]\\d{7,9}", , , , , , , [8, 10]],
				[, , "2[0-24-7]\\d{6}", , , , "22123456", , , [8]],
				[
					,
					,
					"5(?:0[01]|7[0-3])\\d{5}|6(?:[0-4]\\d{3}|500[01])\\d{3}|(?:7[0-3]|8[3-9])\\d{6}",
					,
					,
					,
					"83123456",
					,
					,
					[8]
				],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "90[059]\\d{7}", , , , "9001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "210[0-6]\\d{4}|4\\d{7}|5100\\d{4}", , , , "40001234", , , [8]],
				"CR",
				506,
				"00",
				,
				,
				,
				"(19(?:0[012468]|1[09]|20|66|77|99))",
				,
				,
				,
				[
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], , "$CC $1"],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]0"], , "$CC $1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CU: [
				,
				[, , "[2-57]\\d{5,7}", , , , , , , [6, 7, 8], [4, 5]],
				[
					,
					,
					"2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}",
					,
					,
					,
					"71234567"
				],
				[, , "5\\d{7}", , , , "51234567", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CU",
				53,
				"119",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"],
					[, "(\\d{2})(\\d{4,6})", "$1 $2", ["[2-4]"], "(0$1)"],
					[, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CV: [
				,
				[, , "[259]\\d{6}", , , , , , , [7]],
				[
					,
					,
					"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
					,
					,
					,
					"2211234"
				],
				[, , "(?:9\\d|59)\\d{5}", , , , "9911234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CV",
				238,
				"0",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CW: [
				,
				[, , "[169]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}",
					,
					,
					,
					"94151234",
					,
					,
					[8]
				],
				[
					,
					,
					"9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",
					,
					,
					,
					"95181234",
					,
					,
					[8]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "60[0-2]\\d{4}", , , , "6001234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"CW",
				599,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-7]"]],
					[, "(9)(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]
				],
				,
				[, , "955\\d{5}", , , , "95581234", , , [8]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CX: [
				,
				[, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]],
				[, , "89164\\d{4}", , , , "891641234", , , [9]],
				[
					,
					,
					"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					,
					,
					,
					"412345678",
					,
					,
					[9]
				],
				[, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
				[, , "190[0126]\\d{6}", , , , "1900123456", , , [10]],
				[, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 8, 10]],
				[, , "500\\d{6}", , , , "500123456", , , [9]],
				[, , "550\\d{6}", , , , "550123456", , , [9]],
				"CX",
				61,
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]",
				"0",
				,
				,
				"0",
				,
				"0011",
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CY: [
				,
				[, , "[257-9]\\d{7}", , , , , , , [8]],
				[, , "2[2-6]\\d{6}", , , , "22345678"],
				[, , "9[4-79]\\d{6}", , , , "96123456"],
				[, , "800\\d{5}", , , , "80001234"],
				[, , "90[09]\\d{5}", , , , "90012345"],
				[, , "80[1-9]\\d{5}", , , , "80112345"],
				[, , "700\\d{5}", , , , "70012345"],
				[, , "NA", , , , , , , [-1]],
				"CY",
				357,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{6})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "(?:50|77)\\d{6}", , , , "77123456"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			CZ: [
				,
				[, , "[2-8]\\d{8}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]],
				[
					,
					,
					"2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}",
					,
					,
					,
					"212345678",
					,
					,
					[9]
				],
				[, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]],
				[, , "8[134]\\d{7}", , , , "811234567", , , [9]],
				[, , "70[01]\\d{6}", , , , "700123456", , , [9]],
				[, , "9[17]0\\d{6}", , , , "910123456", , , [9]],
				"CZ",
				420,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([2-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
					[, "(96\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["96"]],
					[, "(9\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9[36]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "9(?:5\\d|7[234])\\d{6}", , , , "972123456", , , [9]],
				,
				,
				[, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]
			],
			DE: [
				,
				[
					,
					,
					"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",
					,
					,
					,
					,
					,
					,
					[4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
					[3]
				],
				[
					,
					,
					"[246]\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-9]\\d)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})",
					,
					,
					,
					"30123456",
					,
					,
					[5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
				],
				[
					,
					,
					"1(?:5[0-25-9]\\d{8}|6[023]\\d{7,8}|7\\d{8,9})",
					,
					,
					,
					"15123456789",
					,
					,
					[10, 11]
				],
				[, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]],
				[
					,
					,
					"137[7-9]\\d{6}|900(?:[135]\\d{6}|9\\d{7})",
					,
					,
					,
					"9001234567",
					,
					,
					[10, 11]
				],
				[
					,
					,
					"1(?:3(?:7[1-6]\\d{6}|8\\d{4})|80\\d{5,11})",
					,
					,
					,
					"18012345",
					,
					,
					[7, 8, 9, 10, 11, 12, 13, 14]
				],
				[, , "700\\d{8}", , , , "70012345678", , , [11]],
				[, , "NA", , , , , , , [-1]],
				"DE",
				49,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(1\\d{2})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
					[, "(15\\d{3})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
					[, "(1\\d{3})(\\d{7})", "$1 $2", ["15"], "0$1"],
					[, "(\\d{2})(\\d{3,11})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
					[
						,
						"(\\d{3})(\\d{3,11})",
						"$1 $2",
						[
							"2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"
						],
						"0$1"
					],
					[
						,
						"(\\d{4})(\\d{2,11})",
						"$1 $2",
						[
							"[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])",
							"[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"
						],
						"0$1"
					],
					[, "(3\\d{4})(\\d{1,10})", "$1 $2", ["3"], "0$1"],
					[, "(800)(\\d{7,12})", "$1 $2", ["800"], "0$1"],
					[
						,
						"(\\d{3})(\\d)(\\d{4,10})",
						"$1 $2 $3",
						["(?:18|90)0|137", "1(?:37|80)|900[1359]"],
						"0$1"
					],
					[, "(1\\d{2})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
					[, "(18\\d{3})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
					[, "(18\\d{2})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
					[, "(18\\d)(\\d{8})", "$1 $2", ["18[2-579]"], "0$1"],
					[, "(700)(\\d{4})(\\d{4})", "$1 $2 $3", ["700"], "0$1"],
					[, "(138)(\\d{4})", "$1 $2", ["138"], "0$1"],
					[, "(15[013-68])(\\d{2})(\\d{8})", "$1 $2 $3", ["15[013-68]"], "0$1"],
					[, "(15[279]\\d)(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
					[, "(1[67]\\d)(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"]
				],
				,
				[
					,
					,
					"16(?:4\\d{1,10}|[89]\\d{1,11})",
					,
					,
					,
					"16412345",
					,
					,
					[4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
				],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"18(?:1\\d{5,11}|[2-9]\\d{8})",
					,
					,
					,
					"18500123456",
					,
					,
					[8, 9, 10, 11, 12, 13, 14]
				],
				,
				,
				[
					,
					,
					"1(?:5(?:(?:2\\d55|7\\d99|9\\d33)\\d{7}|(?:[034568]00|113)\\d{8})|6(?:013|255|399)\\d{7,8}|7(?:[015]13|[234]55|[69]33|[78]99)\\d{7,8})",
					,
					,
					,
					"177991234567",
					,
					,
					[12, 13]
				]
			],
			DJ: [
				,
				[, , "[27]\\d{7}", , , , , , , [8]],
				[, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"],
				[, , "77\\d{6}", , , , "77831001"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"DJ",
				253,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			DK: [
				,
				[, , "[2-9]\\d{7}", , , , , , , [8]],
				[, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"],
				[, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "20123456"],
				[, , "80\\d{6}", , , , "80123456"],
				[, , "90\\d{6}", , , , "90123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"DK",
				45,
				"00",
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			DM: [
				,
				[, , "[57-9]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}",
					,
					,
					,
					"7674201234"
				],
				[
					,
					,
					"767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[2-7])\\d{4}",
					,
					,
					,
					"7672251234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"DM",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"767",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			DO: [
				,
				[, , "[589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})",
					,
					,
					,
					"8092345678"
				],
				[, , "8[024]9[2-9]\\d{6}", , , , "8092345678"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"DO",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"8[024]9",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			DZ: [
				,
				[, , "(?:[1-4]|[5-9]\\d)\\d{7}", , , , , , , [8, 9]],
				[
					,
					,
					"(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}",
					,
					,
					,
					"12345678"
				],
				[
					,
					,
					"(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-6])\\d{6}",
					,
					,
					,
					"551234567",
					,
					,
					[9]
				],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
				[, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "98[23]\\d{6}", , , , "983123456", , , [9]],
				"DZ",
				213,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
					[
						,
						"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[5-8]"],
						"0$1"
					],
					[, "(9\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			EC: [
				,
				[, , "1\\d{9,10}|[2-8]\\d{7}|9\\d{8}", , , , , , , [8, 9, 10, 11], [7]],
				[, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8]],
				[
					,
					,
					"9(?:(?:39|[45][89]|7[7-9]|[89]\\d)\\d|6(?:[017-9]\\d|2[0-4]))\\d{5}",
					,
					,
					,
					"991234567",
					,
					,
					[9]
				],
				[, , "1800\\d{6,7}", , , , "18001234567", , , [10, 11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
				"EC",
				593,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[247]|[356][2-8]"], "(0$1)"],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"], "$1"]
				],
				[
					[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[247]|[356][2-8]"]],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"], "$1"]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			EE: [
				,
				[, , "1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}", , , , , , , [4, 5, 7, 8, 10]],
				[, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]],
				[
					,
					,
					"(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}",
					,
					,
					,
					"51234567",
					,
					,
					[7, 8]
				],
				[, , "800(?:0\\d{3}|1\\d|[2-9])\\d{3}", , , , "80012345", , , [7, 8, 10]],
				[, , "(?:40\\d{2}|900)\\d{4}", , , , "9001234", , , [7, 8]],
				[, , "NA", , , , , , , [-1]],
				[, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				"EE",
				372,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[
						,
						"([3-79]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]",
							"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"
						]
					],
					[, "(70)(\\d{2})(\\d{4})", "$1 $2 $3", ["70"]],
					[, "(8000)(\\d{3})(\\d{3})", "$1 $2 $3", ["800", "8000"]],
					[
						,
						"([458]\\d{3})(\\d{3,4})",
						"$1 $2",
						["40|5|8(?:00|[1-5])", "40|5|8(?:00[1-9]|[1-5])"]
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "1\\d{3,4}|800[2-9]\\d{3}", , , , "8002123", , , [4, 5, 7]],
				[
					,
					,
					"1(?:2[01245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[012])\\d{1,2}",
					,
					,
					,
					"12123",
					,
					,
					[4, 5]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			EG: [
				,
				[
					,
					,
					"1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}",
					,
					,
					,
					,
					,
					,
					[5, 8, 9, 10],
					[7]
				],
				[
					,
					,
					"(?:1(?:3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|[57][23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}|1[69]\\d{3}",
					,
					,
					,
					"234567890",
					,
					,
					[5, 8, 9]
				],
				[, , "1(?:0[0-269]|1[0-245]|2[0-278])\\d{7}", , , , "1001234567", , , [10]],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "900\\d{7}", , , , "9001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"EG",
				20,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[012]|[89]00"], "0$1"],
					[, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|[89][2-9]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			EH: [
				,
				[, , "[5-9]\\d{8}", , , , , , , [9]],
				[, , "528[89]\\d{5}", , , , "528812345"],
				[
					,
					,
					"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}",
					,
					,
					,
					"650123456"
				],
				[, , "80\\d{7}", , , , "801234567"],
				[, , "89\\d{7}", , , , "891234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "5924[01]\\d{4}", , , , "592401234"],
				"EH",
				212,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"528[89]",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ER: [
				,
				[, , "[178]\\d{6}", , , , , , , [7], [6]],
				[, , "1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}", , , , "8370362"],
				[, , "17[1-3]\\d{4}|7\\d{6}", , , , "7123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ER",
				291,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ES: [
				,
				[, , "[5-9]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"8(?:[13]0|[28][0-8]|[47][1-9]|5[01346-9]|6[0457-9])\\d{6}|9(?:[15]\\d{7}|[238][0-8]\\d{6}|4[1-9]\\d{6}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})",
					,
					,
					,
					"810123456"
				],
				[
					,
					,
					"(?:6\\d{6}|7[1-48]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}",
					,
					,
					,
					"612345678"
				],
				[, , "[89]00\\d{6}", , , , "800123456"],
				[, , "80[367]\\d{6}", , , , "803123456"],
				[, , "90[12]\\d{6}", , , , "901123456"],
				[, , "70\\d{7}", , , , "701234567"],
				[, , "NA", , , , , , , [-1]],
				"ES",
				34,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
					[
						,
						"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[568]|[79][0-8]"]
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "51\\d{7}", , , , "511234567"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ET: [
				,
				[, , "[1-59]\\d{8}", , , , , , , [9], [7]],
				[
					,
					,
					"(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
					,
					,
					,
					"111112345"
				],
				[, , "9(?:[1-468]\\d|5[89])\\d{6}", , , , "911234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ET",
				251,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([1-59]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FI: [
				,
				[, , "1\\d{4,11}|[2-9]\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
				[
					,
					,
					"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}",
					,
					,
					,
					"1312345678"
				],
				[, , "4\\d{5,10}|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]],
				[, , "800\\d{4,7}", , , , "8001234567", , , [7, 8, 9, 10]],
				[, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"FI",
				358,
				"00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))",
				"0",
				,
				,
				"0",
				,
				"00",
				,
				[
					[, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]00|[6-8]0)"], "0$1"],
					[, "(116\\d{3})", "$1", ["116"], "$1"],
					[, "(\\d{2})(\\d{4,10})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"],
					[, "(\\d)(\\d{4,11})", "$1 $2", ["[25689][1-8]|3"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[
					,
					,
					"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
					,
					,
					,
					"100123",
					,
					,
					[5, 6, 7, 8, 9, 10]
				],
				[
					,
					,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
					,
					,
					,
					"10112345",
					,
					,
					[5, 6, 7, 8, 9, 10]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FJ: [
				,
				[, , "[36-9]\\d{6}|0\\d{10}", , , , , , , [7, 11]],
				[, , "(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
				[, , "(?:7[0-8]|8[034679]|9\\d)\\d{5}", , , , "7012345", , , [7]],
				[, , "0800\\d{7}", , , , "08001234567", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"FJ",
				679,
				"0(?:0|52)",
				,
				,
				,
				,
				,
				"00",
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[36-9]"]],
					[, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FK: [
				,
				[, , "[2-7]\\d{4}", , , , , , , [5]],
				[, , "[2-47]\\d{4}", , , , "31234"],
				[, , "[56]\\d{4}", , , , "51234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"FK",
				500,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FM: [
				,
				[, , "[39]\\d{6}", , , , , , , [7]],
				[, , "3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}", , , , "3201234"],
				[, , "3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}", , , , "3501234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"FM",
				691,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FO: [
				,
				[, , "[2-9]\\d{5}", , , , , , , [6]],
				[, , "(?:20|[3-4]\\d|8[19])\\d{4}", , , , "201234"],
				[, , "(?:[27][1-9]|5\\d)\\d{4}", , , , "211234"],
				[, , "80[257-9]\\d{3}", , , , "802123"],
				[, , "90(?:[1345][15-7]|2[125-7]|99)\\d{2}", , , , "901123"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:6[0-36]|88)\\d{4}", , , , "601234"],
				"FO",
				298,
				"00",
				,
				,
				,
				"(10(?:01|[12]0|88))",
				,
				,
				,
				[[, "(\\d{6})", "$1", , , "$CC $1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			FR: [
				,
				[, , "[1-9]\\d{8}", , , , , , , [9]],
				[, , "[1-5]\\d{8}", , , , "123456789"],
				[, , "(?:6\\d|7[3-9])\\d{7}", , , , "612345678"],
				[, , "80[0-5]\\d{6}", , , , "801234567"],
				[, , "89[1-37-9]\\d{6}", , , , "891123456"],
				[, , "8(?:1[0-29]|2[0156]|84|90)\\d{6}", , , , "810123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "9\\d{8}", , , , "912345678"],
				"FR",
				33,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						["[1-79]"],
						"0$1"
					],
					[, "(1\\d{2})(\\d{3})", "$1 $2", ["11"], "$1"],
					[, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]
				],
				[
					[
						,
						"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						["[1-79]"],
						"0$1"
					],
					[, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "80[6-9]\\d{6}", , , , "806123456"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GA: [
				,
				[, , "0?\\d{7}", , , , , , , [7, 8]],
				[, , "01\\d{6}", , , , "01441234", , , [8]],
				[, , "0?[2-7]\\d{6}", , , , "06031234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GA",
				241,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"],
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GB: [
				,
				[, , "\\d{7,10}", , , , , , , [7, 9, 10], [4, 5, 6, 8]],
				[
					,
					,
					"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[012])\\d{7}|1(?:(?:1(?:3[0-48]|[46][0-4]|5[0126-9]|7[0-49]|8[01349])|21[0-7]|31[0-8]|[459]1\\d|61[0-46-9]))\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-4789]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1235679]|9[24578])|4(?:0[03-9]|[28][02-5789]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1235-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-5789])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[023678]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-5789]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-5789]|4[2-9]|5[0-579]|6[234789]|7[0124578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-4789]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[015789]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[234678]\\d{2}|16977[23]\\d{3}",
					,
					,
					,
					"1212345678",
					,
					,
					[9, 10]
				],
				[
					,
					,
					"7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}",
					,
					,
					,
					"7400123456",
					,
					,
					[10]
				],
				[, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}", , , , "8001234567"],
				[
					,
					,
					"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}",
					,
					,
					,
					"9012345678",
					,
					,
					[10]
				],
				[
					,
					,
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",
					,
					,
					,
					"8431234567",
					,
					,
					[7, 10]
				],
				[, , "70\\d{8}", , , , "7012345678", , , [10]],
				[, , "56\\d{8}", , , , "5612345678", , , [10]],
				"GB",
				44,
				"00",
				"0",
				" x",
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						["7(?:[1-5789]|62)", "7(?:[1-5789]|624)", "7(?:[1-5789]|6242)"],
						"0$1"
					],
					[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2|5[56]|7[06]"], "0$1"],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["1(?:1|\\d1)|3|9[018]"],
						"0$1"
					],
					[
						,
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:387|5(?:24|39)|697|768|946)",
							"1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"
						],
						"0$1"
					],
					[, "(1\\d{3})(\\d{5,6})", "$1 $2", ["1"], "0$1"],
					[
						,
						"(800)(\\d{4})",
						"$1 $2",
						["800", "8001", "80011", "800111", "8001111"],
						"0$1"
					],
					[
						,
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						["845", "8454", "84546", "845464"],
						"0$1"
					],
					[, "(8\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8(?:4[2-5]|7[0-3])"], "0$1"],
					[, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"],
					[, "([58]00)(\\d{6})", "$1 $2", ["[58]00"], "0$1"]
				],
				,
				[
					,
					,
					"76(?:0[012]\\d|2(?:[356]\\d|4[013-9])|4[0134]\\d|5[49]\\d|6[0-369]\\d|77\\d|81\\d|9[39]\\d)\\d{5}",
					,
					,
					,
					"7640123456",
					,
					,
					[10]
				],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GD: [
				,
				[, , "[4589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
					,
					,
					,
					"4732691234"
				],
				[
					,
					,
					"473(?:4(?:0[2-79]|1[04-9]|20|58)|5(?:2[01]|3[3-8])|901)\\d{4}",
					,
					,
					,
					"4734031234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"GD",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"473",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GE: [
				,
				[, , "[34578]\\d{8}", , , , , , , [9], [6]],
				[
					,
					,
					"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
					,
					,
					,
					"322123456"
				],
				[, , "5(?:14|5[01578]|68|7[0147-9]|9[0-35-9])\\d{6}", , , , "555123456"],
				[, , "800\\d{6}", , , , "800123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "706\\d{6}", , , , "706123456"],
				"GE",
				995,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"],
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "706\\d{6}", , , , "706123456"],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GF: [
				,
				[, , "[56]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"594(?:10|2[012457-9]|3[0-57-9]|4[3-9]|5[7-9]|6[0-3]|9[014])\\d{4}",
					,
					,
					,
					"594101234"
				],
				[, , "694(?:[04][0-7]|1[0-5]|3[018]|[29]\\d)\\d{4}", , , , "694201234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GF",
				594,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GG: [
				,
				[, , "[135789]\\d{6,9}", , , , , , , [7, 9, 10], [6]],
				[, , "1481\\d{6}", , , , "1481456789", , , [10]],
				[, , "7(?:781\\d|839\\d|911[17])\\d{5}", , , , "7781123456", , , [10]],
				[, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}", , , , "8001234567"],
				[, , "(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}", , , , "9012345678", , , [10]],
				[
					,
					,
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",
					,
					,
					,
					"8431234567",
					,
					,
					[7, 10]
				],
				[, , "70\\d{8}", , , , "7012345678", , , [10]],
				[, , "56\\d{8}", , , , "5612345678", , , [10]],
				"GG",
				44,
				"00",
				"0",
				" x",
				,
				"0",
				,
				,
				,
				,
				,
				[
					,
					,
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					,
					,
					,
					"7640123456",
					,
					,
					[10]
				],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GH: [
				,
				[, , "[235]\\d{8}|8\\d{7}", , , , , , , [8, 9], [7]],
				[
					,
					,
					"3(?:0[237]\\d|[167](?:2[0-6]|7\\d)|2(?:2[0-5]|7\\d)|3(?:2[0-3]|7\\d)|4(?:2[013-9]|3[01]|7\\d)|5(?:2[0-7]|7\\d)|8(?:2[0-2]|7\\d)|9(?:20|7\\d))\\d{5}",
					,
					,
					,
					"302345678",
					,
					,
					[9]
				],
				[
					,
					,
					"(?:2[034678]\\d|5(?:[0457]\\d|6[01]))\\d{6}",
					,
					,
					,
					"231234567",
					,
					,
					[9]
				],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GH",
				233,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"],
					[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GI: [
				,
				[, , "[2568]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"2(?:00\\d|1(?:6[24-7]|9\\d)|2(?:00|2[2457]))\\d{4}",
					,
					,
					,
					"20012345"
				],
				[, , "(?:5[46-8]|62)\\d{6}", , , , "57123456"],
				[, , "80\\d{6}", , , , "80123456"],
				[, , "8[1-689]\\d{6}", , , , "88123456"],
				[, , "87\\d{6}", , , , "87123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GI",
				350,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GL: [
				,
				[, , "[1-689]\\d{5}", , , , , , , [6]],
				[, , "(?:19|3[1-6]|6[14689]|8[14-79]|9\\d)\\d{4}", , , , "321000"],
				[, , "[245][2-9]\\d{4}", , , , "221234"],
				[, , "80\\d{4}", , , , "801234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "3[89]\\d{4}", , , , "381234"],
				"GL",
				299,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GM: [
				,
				[, , "[2-9]\\d{6}", , , , , , , [7]],
				[
					,
					,
					"(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
					,
					,
					,
					"5661234"
				],
				[, , "[23679]\\d{6}", , , , "3012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GM",
				220,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GN: [
				,
				[, , "[367]\\d{7,8}", , , , , , , [8, 9]],
				[
					,
					,
					"30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}",
					,
					,
					,
					"30241234",
					,
					,
					[8]
				],
				[, , "6[02356]\\d{7}", , , , "601123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "722\\d{6}", , , , "722123456", , , [9]],
				"GN",
				224,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]],
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GP: [
				,
				[, , "[56]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}",
					,
					,
					,
					"590201234"
				],
				[, , "690(?:0[0-7]|[1-9]\\d)\\d{4}", , , , "690301234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GP",
				590,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([56]90)(\\d{2})(\\d{4})", "$1 $2-$3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GQ: [
				,
				[, , "[23589]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}",
					,
					,
					,
					"333091234"
				],
				[, , "(?:222|55[15])\\d{6}", , , , "222123456"],
				[, , "80\\d[1-9]\\d{5}", , , , "800123456"],
				[, , "90\\d[1-9]\\d{5}", , , , "900123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GQ",
				240,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]],
					[, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GR: [
				,
				[, , "[26-9]\\d{9}", , , , , , , [10]],
				[
					,
					,
					"2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
					,
					,
					,
					"2123456789"
				],
				[, , "69\\d{8}", , , , "6912345678"],
				[, , "800\\d{7}", , , , "8001234567"],
				[, , "90[19]\\d{7}", , , , "9091234567"],
				[, , "8(?:0[16]|12|25)\\d{7}", , , , "8011234567"],
				[, , "70\\d{8}", , , , "7012345678"],
				[, , "NA", , , , , , , [-1]],
				"GR",
				30,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([27]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[2-9]1|[689]"]],
					[, "(2\\d{3})(\\d{6})", "$1 $2", ["2[2-9][02-9]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GT: [
				,
				[, , "[2-7]\\d{7}|1[89]\\d{9}", , , , , , , [8, 11]],
				[, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
				[, , "[345]\\d{7}", , , , "51234567", , , [8]],
				[, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
				[, , "19\\d{9}", , , , "19001112222", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GT",
				502,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]],
					[, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GU: [
				,
				[, , "[5689]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|47|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}",
					,
					,
					,
					"6713001234"
				],
				[
					,
					,
					"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|47|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}",
					,
					,
					,
					"6713001234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"GU",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				1,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"671",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GW: [
				,
				[, , "(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})", , , , , , , [7, 9]],
				[, , "443\\d{6}", , , , "443201234", , , [9]],
				[
					,
					,
					"9(?:5(?:5\\d|6[0-2])|6(?:5[0-2]|6\\d|9[012])|77\\d)\\d{5}",
					,
					,
					,
					"955012345",
					,
					,
					[9]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "40\\d{5}", , , , "4012345", , , [7]],
				"GW",
				245,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["44|9[567]"]],
					[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			GY: [
				,
				[, , "[2-46-9]\\d{6}", , , , , , , [7]],
				[
					,
					,
					"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
					,
					,
					,
					"2201234"
				],
				[, , "6\\d{6}", , , , "6091234"],
				[, , "(?:289|862)\\d{4}", , , , "2891234"],
				[, , "9008\\d{3}", , , , "9008123"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"GY",
				592,
				"001",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			HK: [
				,
				[, , "[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 11]],
				[, , "(?:[23]\\d|58)\\d{6}", , , , "21234567", , , [8]],
				[
					,
					,
					"(?:5[1-79]\\d|6\\d{2}|8[4-79]\\d|9(?:0[1-9]|[1-8]\\d))\\d{5}",
					,
					,
					,
					"51234567",
					,
					,
					[8]
				],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[
					,
					,
					"900(?:[0-24-9]\\d{7}|3\\d{1,4})",
					,
					,
					,
					"90012345678",
					,
					,
					[5, 6, 7, 8, 11]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "8[1-3]\\d{6}", , , , "81123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				"HK",
				852,
				"00(?:[126-9]|30|5[09])?",
				,
				,
				,
				,
				,
				"00",
				,
				[
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[235-7]|[89](?:0[1-9]|[1-9])"]],
					[, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"]],
					[, "(900)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["900"]],
					[, "(900)(\\d{2,5})", "$1 $2", ["900"]]
				],
				,
				[, , "7\\d{7}", , , , "71234567", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			HN: [
				,
				[, , "[237-9]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|7[01389]|8[0146-9]|9[012])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:16|4[03-5]|5\\d|6[4-6]|74)|6(?:[056]\\d|17|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}",
					,
					,
					,
					"22123456"
				],
				[, , "[37-9]\\d{7}", , , , "91234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"HN",
				504,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1-$2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			HR: [
				,
				[, , "[1-7]\\d{5,8}|[89]\\d{6,11}", , , , , , , [6, 7, 8, 9, 10, 11, 12]],
				[
					,
					,
					"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
					,
					,
					,
					"12345678",
					,
					,
					[8, 9]
				],
				[
					,
					,
					"9(?:[1-9]\\d{6,10}|01\\d{6,9})",
					,
					,
					,
					"912345678",
					,
					,
					[8, 9, 10, 11, 12]
				],
				[, , "80[01]\\d{4,7}", , , , "8001234567", , , [7, 8, 9, 10]],
				[, , "6(?:[01459]\\d{4,7})", , , , "611234", , , [6, 7, 8, 9]],
				[, , "NA", , , , , , , [-1]],
				[, , "7[45]\\d{4,7}", , , , "741234567", , , [6, 7, 8, 9]],
				[, , "NA", , , , , , , [-1]],
				"HR",
				385,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(1)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"],
					[, "(6[09])(\\d{4})(\\d{3})", "$1 $2 $3", ["6[09]"], "0$1"],
					[, "([67]2)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]2"], "0$1"],
					[, "([2-5]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"],
					[, "(9\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(9\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
					[, "(9\\d)(\\d{3,4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"], "0$1"],
					[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[0145]|7"], "0$1"],
					[, "(\\d{2})(\\d{3,4})(\\d{3})", "$1 $2 $3", ["6[0145]|7"], "0$1"],
					[, "(80[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"],
					[, "(80[01])(\\d{3,4})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "[76]2\\d{6,7}", , , , "62123456", , , [8, 9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			HT: [
				,
				[, , "[2-489]\\d{7}", , , , , , , [8]],
				[, , "2(?:[248]\\d|5[1-5]|94)\\d{5}", , , , "22453300"],
				[, , "(?:3[1-9]\\d|4\\d{2}|9(?:8[0-35]|9[5-9]))\\d{5}", , , , "34101234"],
				[, , "8\\d{7}", , , , "80012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "98[89]\\d{5}", , , , "98901234"],
				"HT",
				509,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			HU: [
				,
				[, , "[1-9]\\d{7,8}", , , , , , , [8, 9], [6]],
				[
					,
					,
					"(?:1\\d|2[2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|7[2-9]|8[2-57-9]|9[2-69])\\d{6}",
					,
					,
					,
					"12345678",
					,
					,
					[8]
				],
				[, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]],
				[, , "[48]0\\d{6}", , , , "80123456", , , [8]],
				[, , "9[01]\\d{6}", , , , "90123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "21\\d{7}", , , , "211234567", , , [9]],
				"HU",
				36,
				"00",
				"06",
				,
				,
				"06",
				,
				,
				,
				[
					[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "($1)"],
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "($1)"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "[48]0\\d{6}", , , , "80123456", , , [8]],
				[, , "38\\d{7}", , , , "381234567", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ID: [
				,
				[
					,
					,
					"(?:[1-79]\\d{6,10}|8\\d{7,11})",
					,
					,
					,
					,
					,
					,
					[7, 8, 9, 10, 11, 12],
					[5, 6]
				],
				[
					,
					,
					"2(?:1(?:14\\d{3}|[0-8]\\d{6,7}|500\\d{3}|9\\d{6})|2\\d{6,8}|4\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
					,
					,
					,
					"612345678",
					,
					,
					[7, 8, 9, 10, 11]
				],
				[
					,
					,
					"(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359]|9\\d)|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,10}",
					,
					,
					,
					"812345678",
					,
					,
					[9, 10, 11, 12]
				],
				[, , "177\\d{6,8}|800\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11]],
				[, , "809\\d{7}", , , , "8091234567", , , [10]],
				[, , "804\\d{7}", , , , "8041234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ID",
				62,
				"0(?:0[1789]|10(?:00|1[67]))",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{5,8})", "$1 $2", ["2[124]|[36]1"], "(0$1)"],
					[, "(\\d{3})(\\d{5,8})", "$1 $2", ["[4579]|2[035-9]|[36][02-9]"], "(0$1)"],
					[, "(8\\d{2})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"],
					[, "(8\\d{2})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8[1-35-9]"], "0$1"],
					[, "(1)(500)(\\d{3})", "$1 $2 $3", ["15"], "$1"],
					[, "(177)(\\d{6,8})", "$1 $2", ["17"], "0$1"],
					[, "(800)(\\d{5,7})", "$1 $2", ["800"], "0$1"],
					[, "(804)(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"],
					[, "(80\\d)(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80[79]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "8071\\d{6}", , , , "8071123456", , , [10]],
				[, , "1500\\d{3}|8071\\d{6}", , , , "8071123456", , , [7, 10]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IE: [
				,
				[, , "[124-9]\\d{6,9}", , , , , , , [7, 8, 9, 10], [5, 6]],
				[
					,
					,
					"1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})",
					,
					,
					,
					"2212345"
				],
				[, , "8(?:22\\d{6}|[35-9]\\d{7})", , , , "850123456", , , [9]],
				[, , "1800\\d{6}", , , , "1800123456", , , [10]],
				[, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]],
				[, , "18[59]0\\d{6}", , , , "1850123456", , , [10]],
				[, , "700\\d{6}", , , , "700123456", , , [9]],
				[, , "76\\d{7}", , , , "761234567", , , [9]],
				"IE",
				353,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(1)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"],
					[
						,
						"(\\d{2})(\\d{5})",
						"$1 $2",
						["2[24-9]|47|58|6[237-9]|9[35-9]"],
						"(0$1)"
					],
					[, "(\\d{3})(\\d{5})", "$1 $2", ["40[24]|50[45]"], "(0$1)"],
					[, "(48)(\\d{4})(\\d{4})", "$1 $2 $3", ["48"], "(0$1)"],
					[, "(818)(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"],
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[24-69]|7[14]"], "(0$1)"],
					[, "([78]\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["76|8[35-9]"], "0$1"],
					[, "(700)(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
					[
						,
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["1(?:8[059]|5)", "1(?:8[059]0|5)"],
						"$1"
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "18[59]0\\d{6}", , , , "1850123456", , , [10]],
				[, , "818\\d{6}", , , , "818123456", , , [9]],
				,
				,
				[, , "8[35-9]\\d{8}", , , , "8501234567", , , [10]]
			],
			IL: [
				,
				[
					,
					,
					"[17]\\d{6,9}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}",
					,
					,
					,
					,
					,
					,
					[4, 7, 8, 9, 10]
				],
				[, , "[2-489]\\d{7}", , , , "21234567", , , [8]],
				[
					,
					,
					"5(?:[02-47-9]\\d{2}|5(?:01|2[23]|3[2-4]|4[45]|5[5689]|6[67]|7[0178]|8[6-9]|9[4-9])|6[2-9]\\d)\\d{5}",
					,
					,
					,
					"501234567",
					,
					,
					[9]
				],
				[, , "1(?:80[019]\\d{3}|255)\\d{3}", , , , "1800123456", , , [7, 10]],
				[
					,
					,
					"1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}",
					,
					,
					,
					"1919123456",
					,
					,
					[8, 9, 10]
				],
				[, , "1700\\d{6}", , , , "1700123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"7(?:18\\d|2[23]\\d|3[237]\\d|47\\d|6[58]\\d|7\\d{2}|8(?:2\\d|33|55|77|81)|9[2579]\\d)\\d{5}",
					,
					,
					,
					"771234567",
					,
					,
					[9]
				],
				"IL",
				972,
				"0(?:0|1[2-9])",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([2-489])(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
					[, "([57]\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
					[, "(1)([7-9]\\d{2})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"], "$1"],
					[, "(1255)(\\d{3})", "$1-$2", ["125"], "$1"],
					[, "(1200)(\\d{3})(\\d{3})", "$1-$2-$3", ["120"], "$1"],
					[, "(1212)(\\d{2})(\\d{2})", "$1-$2-$3", ["121"], "$1"],
					[, "(1599)(\\d{6})", "$1-$2", ["15"], "$1"],
					[, "(\\d{4})", "*$1", ["[2-689]"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "1700\\d{6}|[2-689]\\d{3}", , , , "1700123456", , , [4, 10]],
				[, , "[2-689]\\d{3}|1599\\d{6}", , , , "1599123456", , , [4, 10]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IM: [
				,
				[, , "[135789]\\d{6,9}", , , , , , , [10], [6]],
				[, , "1624\\d{6}", , , , "1624456789"],
				[, , "7(?:4576|[59]24\\d)\\d{5}", , , , "7924123456"],
				[, , "808162\\d{4}", , , , "8081624567"],
				[, , "(?:872299|90[0167]624)\\d{4}", , , , "9016247890"],
				[, , "8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}", , , , "8456247890"],
				[, , "70\\d{8}", , , , "7012345678"],
				[, , "56\\d{8}", , , , "5612345678"],
				"IM",
				44,
				"00",
				"0",
				" x",
				,
				"0",
				,
				,
				,
				,
				,
				[, , "76242\\d{5}", , , , "7624212345"],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",
					,
					,
					,
					"5512345678"
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IN: [
				,
				[
					,
					,
					"008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",
					,
					,
					,
					,
					,
					,
					[8, 9, 10, 11, 12, 13],
					[6, 7]
				],
				[
					,
					,
					"(?:11|2[02]|33|4[04]|79)[2-7]\\d{7}|80[2-467]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-467])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-578]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}",
					,
					,
					,
					"1123456789",
					,
					,
					[10]
				],
				[
					,
					,
					"(?:7(?:0\\d{3}|19[0-5]\\d|2(?:[0235679]\\d{2}|[14][017-9]\\d|8(?:[0-59]\\d|[678][089]))|3(?:[05-8]\\d{2}|1(?:[089]\\d|7[5-8])|2(?:[0-49][089]|[5-8]\\d)|3[017-9]\\d|4(?:[07-9]\\d|11)|9(?:[016-9]\\d|[2-5][089]))|4(?:0\\d{2}|1(?:[015-9]\\d|[23][089]|4[089])|2(?:0[089]|[1-7][089]|[89]\\d)|3(?:[0-8][089]|9\\d)|4(?:[089]\\d|11|7[02-8])|[56]\\d[089]|7(?:[089]\\d|11|7[02-8])|8(?:[0-24-7][089]|[389]\\d)|9(?:[0-6][089]|7[089]|[89]\\d))|5(?:[0346-8]\\d{2}|1(?:[089]\\d|11|7[02-9])|2(?:[04-9]\\d|[123][089])|5[017-9]\\d|9(?:[0-6][089]|[7-9]\\d))|6(?:0(?:[0-47]\\d|[5689][089])|(?:1[0-257-9]|3[19]|[6-9]\\d)\\d|2(?:[0-4]\\d|50)|4(?:6[89]|[789][089])|5(?:[0-367][089]|[4589]\\d))|7(?:0(?:0[02-9]|[16][089]|[289]\\d|[37][89])|[1-9]\\d{2})|8(?:[0-79]\\d{2}|8(?:[08]\\d|11|7[02-9]|9[012]))|9(?:0(?:0[01]|[3-8]\\d|90)|7(?:[26-8]\\d|9[07-9])|8[0246-9]\\d|9(?:[03-9]\\d|11|2[234])))|8(?:0(?:[01589]\\d{2}|6[67]\\d|7(?:[2-8]\\d|9[056]))|1(?:[02-57-9]\\d{2}|1(?:[0135-9]\\d|22|44)|6[089]\\d)|2(?:0[08]\\d|[236-9]\\d{2}|480|5[1-9]\\d)|3(?:[0357-9]\\d{2}|1(?:02|7[02]|[89]\\d)|2(?:0\\d|8[0-6]|9[34])|4[1-9]\\d|6(?:[09]\\d|7[02-7]|8[124]))|[45]\\d{3}|6(?:[02457-9]\\d{2}|1[089]\\d|3(?:80|9[029])|6(?:[08]\\d|7[02-8]|9[01]))|7(?:0[07]|[1-69]\\d|70)\\d|8(?:[0-26-9]\\d|44|5[2-9])\\d|9(?:[035-9]\\d|1[29]|2[2-9]|4[0-8])\\d)|9\\d{4})\\d{5}",
					,
					,
					,
					"9987654321",
					,
					,
					[10]
				],
				[
					,
					,
					"00800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
					,
					,
					,
					"1800123456"
				],
				[, , "186[12]\\d{9}", , , , "1861123456789", , , [13]],
				[, , "1860\\d{7}", , , , "18603451234", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"IN",
				91,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"7(?:[02-8]|19|9[07-9])|8(?:0[015-9]|[13-69]|2[02-9]|7[01-69]|8[0-24-9])|9",
							"7(?:[078]|19[0-5]|2(?:[02356-9]|[14][017-9]|9[389])|3(?:[025-9]|1[07-9]|[34][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02346-9]|1[017-9]|5[017-9])|6(?:[05-9]|1[0-257-9]|2[0-5]|3[19]|4[6-9])|9(?:[09]|7[2-9]|8[0246-9]))|8(?:0(?:[01589]|6[67]|7[2-9])|1(?:[02-57-9]|1[0135-9]|6[089])|2(?:0[08]|[236-9]|48|5[1-9])|3(?:[0357-9]|1[07-9]|2[089]|4[1-9]|6[07-9])|[45]|6(?:[02457-9]|1[089]|3[89]|6[07-9])|7(?:0[07]|[1-69])|8(?:[0-26-9]|44|5[2-9])|9(?:[035-9]|1[29]|2[2-9]|4[0-8]))|9",
							"7(?:0|19[0-5]|2(?:[0235679]|[14][017-9]|8(?:[0-569]|[78][089])|9[389])|3(?:[05-8]|1(?:[089]|7[5-9])|2(?:[5-8]|[0-49][089])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2345][089]|40|7[0189]))|4(?:[056]|1(?:[0135-9]|[23][089]|2[089]|4[089])|2(?:0[089]|[1-7][089]|[89])|3(?:[0-8][089]|9)|4(?:[089]|11|7[02-8])|7(?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389])|9(?:[0-7][089]|[89]))|5(?:[0346-9]|1(?:[0189]|7[02-9])|2(?:[03-9]|[12][089])|5[017-9])|6(?:[06-9]|1[0-257-9]|2[0-5]|3[19]|4(?:6[89]|[7-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9[012]))|9(?:0|7(?:[2-8]|9[7-9])|8[0246-9]|9(?:[03-9]|11|2[234])))|8(?:0(?:[01589]|6[67]|7(?:[2-8]|9[056]))|1(?:[02-57-9]|1(?:[0135-9]|22|44)|6[089])|2(?:0[08]|[236-9]|48|5[1-9])|3(?:[0357-9]|1(?:[089]|7[02])|2(?:[09]|8[0-6])|4[1-9]|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|1[089]|3[89]|6(?:[08]|7[02-8]|9[01]))|7(?:0[07]|[1-69])|8(?:[0-26-9]|44|5[2-9])|9(?:[035-9]|1[29]|2[2-9]|4[0-8]))|9"
						],
						"0$1",
						,
						1
					],
					[
						,
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						["11|2[02]|33|4[04]|79[1-9]|80[2-46]"],
						"0$1",
						,
						1
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:2[0-249]|3[0-25]|4[145]|[569][14]|7[1257]|8[1346]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"
						],
						"0$1",
						,
						1
					],
					[
						,
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["1(?:[23579]|[468][1-9])|[2-8]"],
						"0$1",
						,
						1
					],
					[, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["008"], "0$1", , 1],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], "$1", , 1],
					[, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["160", "1600"], "$1", , 1],
					[, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], "$1", , 1],
					[, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["180", "1800"], "$1", , 1],
					[, "(\\d{4})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["186", "1860"], "$1", , 1],
					[
						,
						"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						["18[06]"],
						"$1",
						,
						1
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[
					,
					,
					"00800\\d{7}|1(?:600\\d{6}|8(?:0(?:0\\d{4,9}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))",
					,
					,
					,
					"1800123456"
				],
				[, , "140\\d{7}", , , , "1409305260", , , [10]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IO: [
				,
				[, , "3\\d{6}", , , , , , , [7]],
				[, , "37\\d{5}", , , , "3709100"],
				[, , "38\\d{5}", , , , "3801234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"IO",
				246,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IQ: [
				,
				[, , "[1-7]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]],
				[
					,
					,
					"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
					,
					,
					,
					"12345678",
					,
					,
					[8, 9]
				],
				[, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"IQ",
				964,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
					[, "([2-6]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"],
					[, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IR: [
				,
				[
					,
					,
					"[1-8]\\d{9}|9(?:[0-4]\\d{8}|9\\d{2,8})",
					,
					,
					,
					,
					,
					,
					[4, 5, 6, 7, 8, 9, 10]
				],
				[
					,
					,
					"(?:(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])\\d{3}|94(?:000|2\\d{2}))\\d{5}",
					,
					,
					,
					"2123456789",
					,
					,
					[10]
				],
				[, , "9(?:0[1-3]|[1-3]\\d|90)\\d{7}", , , , "9123456789", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:[2-6]0\\d|993)\\d{7}", , , , "9932123456", , , [10]],
				"IR",
				98,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(21)(\\d{3,5})", "$1 $2", ["21"], "0$1"],
					[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"],
					[, "(\\d{3})(\\d{3})", "$1 $2", ["9"], "0$1"],
					[, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["9"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"]
				],
				,
				[, , "943\\d{7}", , , , "9432123456", , , [10]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "9990\\d{0,6}", , , , "9990123456"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			IS: [
				,
				[, , "[4-9]\\d{6}|38\\d{7}", , , , , , , [7, 9]],
				[
					,
					,
					"(?:4(?:1[0-24-6]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[013-79]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}",
					,
					,
					,
					"4101234",
					,
					,
					[7]
				],
				[
					,
					,
					"38[589]\\d{6}|(?:6(?:1[1-8]|2[056]|3[089]|4[0167]|5[0159]|[67][0-69]|9\\d)|7(?:5[057]|6[0-2]|[78]\\d)|8(?:2[0-59]|3[0-4]|[469]\\d|5[1-9]))\\d{4}",
					,
					,
					,
					"6111234"
				],
				[, , "800\\d{4}", , , , "8001234", , , [7]],
				[, , "90\\d{5}", , , , "9011234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "49\\d{5}", , , , "4921234", , , [7]],
				"IS",
				354,
				"1(?:0(?:01|10|20)|100)|00",
				,
				,
				,
				,
				,
				"00",
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]],
					[, "(3\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "809\\d{4}", , , , "8091234", , , [7]],
				,
				,
				[
					,
					,
					"(?:6(?:2[1-478]|49|8\\d)|8(?:7[0189]|80)|95[48])\\d{4}",
					,
					,
					,
					"6211234",
					,
					,
					[7]
				]
			],
			IT: [
				,
				[
					,
					,
					"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",
					,
					,
					,
					,
					,
					,
					[6, 7, 8, 9, 10, 11]
				],
				[
					,
					,
					"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})",
					,
					,
					,
					"0212345678"
				],
				[
					,
					,
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					,
					,
					,
					"3123456789",
					,
					,
					[9, 10, 11]
				],
				[, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]],
				[
					,
					,
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					,
					,
					,
					"899123456",
					,
					,
					[6, 8, 9, 10]
				],
				[, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]],
				[, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]],
				[, , "55\\d{8}", , , , "5512345678", , , [10]],
				"IT",
				39,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|55"]],
					[, "(0[26])(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
					[, "(0[26])(\\d{4,6})", "$1 $2", ["0[26]"]],
					[, "(0\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]],
					[
						,
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[, "(0\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["0[13-57-9][2-46-8]"]],
					[, "(0\\d{3})(\\d{2,6})", "$1 $2", ["0[13-57-9][2-46-8]"]],
					[
						,
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						["[13]|8(?:00|4[08]|9[59])", "[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]
					],
					[, "(\\d{4})(\\d{4})", "$1 $2", ["894", "894[5-9]"]],
					[, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "848\\d{6}", , , , "848123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			JE: [
				,
				[, , "[135789]\\d{6,9}", , , , , , , [10], [6]],
				[, , "1534\\d{6}", , , , "1534456789"],
				[
					,
					,
					"7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}",
					,
					,
					,
					"7797712345"
				],
				[, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"],
				[, , "(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"],
				[
					,
					,
					"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}",
					,
					,
					,
					"8447034567"
				],
				[, , "701511\\d{4}", , , , "7015115678"],
				[, , "56\\d{8}", , , , "5612345678"],
				"JE",
				44,
				"00",
				"0",
				" x",
				,
				"0",
				,
				,
				,
				,
				,
				[
					,
					,
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					,
					,
					,
					"7640123456"
				],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}",
					,
					,
					,
					"5512345678"
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			JM: [
				,
				[, , "[589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[027-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}",
					,
					,
					,
					"8765123456"
				],
				[
					,
					,
					"876(?:2(?:[16-9]\\d|58)|[348]\\d{2}|5(?:0[3-9]|2[0-246-9]|6[0-24-9]|[3-578]\\d)|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}",
					,
					,
					,
					"8762101234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"JM",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"876",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			JO: [
				,
				[, , "[235-9]\\d{7,8}", , , , , , , [8, 9]],
				[
					,
					,
					"(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|3(?:00|33)|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|90))\\d{4}",
					,
					,
					,
					"62001234",
					,
					,
					[8]
				],
				[
					,
					,
					"7(?:55|7[025-9]|8[015-9]|9[0-25-9])\\d{6}",
					,
					,
					,
					"790123456",
					,
					,
					[9]
				],
				[, , "80\\d{6}", , , , "80012345", , , [8]],
				[, , "900\\d{5}", , , , "90012345", , , [8]],
				[, , "85\\d{6}", , , , "85012345", , , [8]],
				[, , "70\\d{7}", , , , "700123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"JO",
				962,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"],
					[, "(7)(\\d{4})(\\d{4})", "$1 $2 $3", ["7[457-9]"], "0$1"],
					[, "(\\d{3})(\\d{5,6})", "$1 $2", ["70|8[0158]|9"], "0$1"]
				],
				,
				[, , "74(?:66|77)\\d{5}", , , , "746612345", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			JP: [
				,
				[
					,
					,
					"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",
					,
					,
					,
					,
					,
					,
					[8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
				],
				[
					,
					,
					"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}",
					,
					,
					,
					"312345678",
					,
					,
					[9]
				],
				[, , "[7-9]0[1-9]\\d{7}", , , , "9012345678", , , [10]],
				[
					,
					,
					"120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})",
					,
					,
					,
					"120123456"
				],
				[, , "990\\d{6}", , , , "990123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "60\\d{7}", , , , "601234567", , , [9]],
				[, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]],
				"JP",
				81,
				"010",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"],
					[, "(\\d{4})(\\d{4})", "$1-$2", ["0077"], "$1"],
					[, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["0077"], "$1"],
					[, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["0088"], "$1"],
					[, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["00(?:37|66)"], "$1"],
					[, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["00(?:37|66)"], "$1"],
					[, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["00(?:37|66)"], "$1"],
					[, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["00(?:37|66)"], "$1"],
					[, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"],
					[
						,
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
						],
						"0$1"
					],
					[
						,
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)",
							"1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])",
							"1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						["2(?:9[14-79]|74|[34]7|[56]9)|82|993"],
						"0$1"
					],
					[
						,
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						["3|4(?:2[09]|7[01])|6[1-9]"],
						"0$1"
					],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]
				],
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"],
					[, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"],
					[
						,
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
						],
						"0$1"
					],
					[
						,
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)",
							"1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])",
							"1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						["2(?:9[14-79]|74|[34]7|[56]9)|82|993"],
						"0$1"
					],
					[
						,
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						["3|4(?:2[09]|7[01])|6[1-9]"],
						"0$1"
					],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]
				],
				[, , "20\\d{8}", , , , "2012345678", , , [10]],
				,
				,
				[
					,
					,
					"00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})",
					,
					,
					,
					"00777012"
				],
				[, , "570\\d{6}", , , , "570123456", , , [9]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KE: [
				,
				[, , "20\\d{6,7}|[4-9]\\d{6,9}", , , , , , , [7, 8, 9, 10]],
				[
					,
					,
					"20\\d{6,7}|4(?:[0136]\\d{7}|[245]\\d{5,7})|5(?:[08]\\d{7}|[1-79]\\d{5,7})|6(?:[01457-9]\\d{5,7}|[26]\\d{7})",
					,
					,
					,
					"202012345",
					,
					,
					[7, 8, 9]
				],
				[
					,
					,
					"7(?:[0-369]\\d|4[0-2]|5[0-6]|7[0-7]|8[0-25-9])\\d{6}",
					,
					,
					,
					"712123456",
					,
					,
					[9]
				],
				[, , "800[24-8]\\d{5,6}", , , , "800223456", , , [9, 10]],
				[, , "900[02-9]\\d{5}", , , , "900223456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KE",
				254,
				"000",
				"0",
				,
				,
				"005|0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"],
					[, "(\\d{3})(\\d{6})", "$1 $2", ["7"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KG: [
				,
				[, , "[235-8]\\d{8,9}", , , , , , , [9, 10], [5, 6]],
				[
					,
					,
					"(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
					,
					,
					,
					"312123456",
					,
					,
					[9]
				],
				[, , "(?:20[0-35]|5[124-7]\\d|7[07]\\d)\\d{6}", , , , "700123456", , , [9]],
				[, , "800\\d{6,7}", , , , "800123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KG",
				996,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[25-7]|31[25]"], "0$1"],
					[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[36]|[2-9])"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d)(\\d{3})", "$1 $2 $3 $4", ["8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KH: [
				,
				[, , "[1-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]],
				[
					,
					,
					"(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|23(?:4[234]|8\\d{2})\\d{4}",
					,
					,
					,
					"23756789",
					,
					,
					[8, 9]
				],
				[
					,
					,
					"(?:1(?:[013-79]\\d|[28]\\d{1,2})|2[3-6]48|3(?:[18]\\d{2}|[2-6]48)|4[2-4]48|5[2-5]48|6(?:[016-9]\\d|[2-5]48)|7(?:[07-9]\\d|[16]\\d{2}|[2-5]48)|8(?:[013-79]\\d|8\\d{2})|9(?:6\\d{2}|7\\d{1,2}|[0-589]\\d))\\d{5}",
					,
					,
					,
					"91234567",
					,
					,
					[8, 9]
				],
				[, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
				[, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KH",
				855,
				"00[14-9]",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1\\d[1-9]|[2-9]"], "0$1"],
					[, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KI: [
				,
				[, , "[2458]\\d{4}|3\\d{4,7}|7\\d{7}", , , , , , , [5, 8]],
				[
					,
					,
					"(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}|7(?:27|31|5[0-4])\\d{5}",
					,
					,
					,
					"31234"
				],
				[, , "7[23]0\\d{5}", , , , "72012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "30(?:0[01]\\d{2}|12(?:11|20))\\d{2}", , , , "30010000", , , [8]],
				"KI",
				686,
				"00",
				,
				,
				,
				"0",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KM: [
				,
				[, , "[3478]\\d{6}", , , , , , , [7]],
				[, , "7[4-7]\\d{5}", , , , "7712345"],
				[, , "[34]\\d{6}", , , , "3212345"],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:39[01]|8\\d{2})\\d{4}", , , , "8001234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KM",
				269,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KN: [
				,
				[, , "[589]\\d{9}", , , , , , , [10], [7]],
				[, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", , , , "8692361234"],
				[, , "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", , , , "8697652917"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"KN",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"869",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KP: [
				,
				[, , "1\\d{9}|[28]\\d{7}", , , , , , , [8, 10], [6, 7]],
				[, , "2\\d{7}|85\\d{6}", , , , "21234567", , , [8]],
				[, , "19[123]\\d{7}", , , , "1921234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KP",
				850,
				"00|99",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
					[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[
					,
					,
					"2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}",
					,
					,
					,
					"23821234",
					,
					,
					[8]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KR: [
				,
				[
					,
					,
					"007\\d{9,11}|[1-7]\\d{3,9}|8\\d{8}",
					,
					,
					,
					,
					,
					,
					[4, 5, 6, 8, 9, 10, 12, 13, 14],
					[3, 7]
				],
				[
					,
					,
					"(?:2|3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})",
					,
					,
					,
					"22123456",
					,
					,
					[4, 5, 6, 8, 9, 10]
				],
				[, , "1[0-26-9]\\d{7,8}", , , , "1000000000", , , [9, 10]],
				[, , "(?:00798\\d{0,2}|80)\\d{7}", , , , "801234567", , , [9, 12, 13, 14]],
				[, , "60[2-9]\\d{6}", , , , "602345678", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "50\\d{8}", , , , "5012345678", , , [10]],
				[, , "70\\d{8}", , , , "7012345678", , , [10]],
				"KR",
				82,
				"00(?:[124-68]|3\\d{2}|7(?:[0-8]\\d|9[0-79]))",
				"0",
				,
				,
				"0(8[1-46-8]|85\\d{2})?",
				,
				,
				,
				[
					[, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["00798"], "$1", "0$CC-$1"],
					[
						,
						"(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						["00798"],
						"$1",
						"0$CC-$1"
					],
					[
						,
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:0|1[19]|[69]9|5[458])|[57]0",
							"1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"
						],
						"0$1",
						"0$CC-$1"
					],
					[
						,
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]",
							"1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"
						],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d{3})(\\d)(\\d{4})", "$1-$2-$3", ["131", "1312"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						["131", "131[13-9]"],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["13[2-9]"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{2})(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3-$4",
						["30"],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"],
					[, "(\\d)(\\d{3,4})", "$1-$2", ["21[0-46-9]"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						["[3-6][1-9]1", "[3-6][1-9]1(?:[0-46-9])"],
						"0$1",
						"0$CC-$1"
					],
					[
						,
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1(?:5[246-9]|6[04678]|8[03579])",
							"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"
						],
						"$1",
						"0$CC-$1"
					]
				],
				[
					[
						,
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:0|1[19]|[69]9|5[458])|[57]0",
							"1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"
						],
						"0$1",
						"0$CC-$1"
					],
					[
						,
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]",
							"1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"
						],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d{3})(\\d)(\\d{4})", "$1-$2-$3", ["131", "1312"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						["131", "131[13-9]"],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["13[2-9]"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{2})(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3-$4",
						["30"],
						"0$1",
						"0$CC-$1"
					],
					[, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"],
					[, "(\\d)(\\d{3,4})", "$1-$2", ["21[0-46-9]"], "0$1", "0$CC-$1"],
					[
						,
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						["[3-6][1-9]1", "[3-6][1-9]1(?:[0-46-9])"],
						"0$1",
						"0$CC-$1"
					],
					[
						,
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1(?:5[246-9]|6[04678]|8[03579])",
							"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"
						],
						"$1",
						"0$CC-$1"
					]
				],
				[, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]],
				,
				,
				[, , "00798\\d{7,9}", , , , "007981234567", , , [12, 13, 14]],
				[
					,
					,
					"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))\\d{4}",
					,
					,
					,
					"15441234",
					,
					,
					[8]
				],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KW: [
				,
				[, , "[12569]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}",
					,
					,
					,
					"22345678"
				],
				[
					,
					,
					"(?:5(?:[05]\\d{2}|1[0-7]\\d|2(?:22|5[25])|66\\d)|6(?:0[034679]\\d|222|5[015-9]\\d|6\\d{2}|7[067]\\d|9[0369]\\d)|9(?:0[09]\\d|22\\d|4[01479]\\d|55\\d|6[0679]\\d|[79]\\d{2}|8[057-9]\\d))\\d{4}",
					,
					,
					,
					"50012345",
					,
					,
					[8]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"KW",
				965,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[
						,
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						["[16]|2(?:[0-35-9]|4[0-35-9])|9[024-9]|52[25]"]
					],
					[, "(\\d{3})(\\d{5})", "$1 $2", ["244|5(?:[015]|66)"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KY: [
				,
				[, , "[3589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}",
					,
					,
					,
					"3452221234"
				],
				[
					,
					,
					"345(?:32[1-9]|5(?:1[67]|2[5-7]|4[6-8]|76)|9(?:1[67]|2[2-9]|3[689]))\\d{4}",
					,
					,
					,
					"3453231234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}|345976\\d{4}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"KY",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "345849\\d{4}", , , , "3458491234"],
				,
				"345",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			KZ: [
				,
				[, , "(?:33\\d|7\\d{2}|80[09])\\d{7}", , , , , , , [10]],
				[
					,
					,
					"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
					,
					,
					,
					"7123456789"
				],
				[, , "7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}", , , , "7710009998"],
				[, , "800\\d{7}", , , , "8001234567"],
				[, , "809\\d{7}", , , , "8091234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "751\\d{7}", , , , "7511234567"],
				"KZ",
				7,
				"810",
				"8",
				,
				,
				"8",
				,
				"8~10",
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "751\\d{7}", , , , "7511234567"],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LA: [
				,
				[, , "[2-8]\\d{7,9}", , , , , , , [8, 9, 10], [6]],
				[
					,
					,
					"(?:2[13]|3(?:0\\d|[14])|[5-7][14]|41|8[1468])\\d{6}",
					,
					,
					,
					"21212862",
					,
					,
					[8, 9]
				],
				[
					,
					,
					"20(?:2[2389]|5[4-689]|7[6-8]|9[15-9])\\d{6}",
					,
					,
					,
					"2023123456",
					,
					,
					[10]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LA",
				856,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(20)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["20"], "0$1"],
					[, "([2-8]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"],
					[, "(30)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LB: [
				,
				[, , "[13-9]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:[14-6]\\d{2}|7(?:[2-57]\\d|62|8[0-7]|9[04-9])|8[02-9]\\d|9\\d{2})\\d{4}",
					,
					,
					,
					"1123456",
					,
					,
					[7]
				],
				[
					,
					,
					"(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3])|81\\d)\\d{5}",
					,
					,
					,
					"71123456"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "9[01]\\d{6}", , , , "90123456", , , [8]],
				[, , "80\\d{6}", , , , "80123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LB",
				961,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["[13-6]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]|9"],
						"0$1"
					],
					[
						,
						"([7-9]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["[89][01]|7(?:[01]|6[013-9]|8[89]|9[1-3])"]
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LC: [
				,
				[, , "[5789]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"758(?:4(?:30|5[0-9]|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}",
					,
					,
					,
					"7584305678"
				],
				[
					,
					,
					"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2[0-8]))\\d{4}",
					,
					,
					,
					"7582845678"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"LC",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"758",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LI: [
				,
				[, , "6\\d{8}|[23789]\\d{6}", , , , , , , [7, 9]],
				[
					,
					,
					"(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}",
					,
					,
					,
					"2345678",
					,
					,
					[7]
				],
				[
					,
					,
					"6(?:5(?:09|1\\d|20)|6(?:0[0-6]|10|2[06-9]|39))\\d{5}|7(?:[37-9]\\d|42|56)\\d{4}",
					,
					,
					,
					"660234567"
				],
				[, , "80(?:02[28]|9\\d{2})\\d{2}", , , , "8002222", , , [7]],
				[, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d{2}", , , , "9002222", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LI",
				423,
				"00",
				"0",
				,
				,
				"0|10(?:01|20|66)",
				,
				,
				,
				[
					[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[23789]"]],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[56]"]],
					[, "(69)(7\\d{2})(\\d{4})", "$1 $2 $3", ["697"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "870(?:28|87)\\d{2}", , , , "8702812", , , [7]],
				,
				,
				[, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]
			],
			LK: [
				,
				[, , "[1-9]\\d{8}", , , , , , , [9], [7]],
				[
					,
					,
					"(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
					,
					,
					,
					"112345678"
				],
				[, , "7[0125-8]\\d{7}", , , , "712345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LK",
				94,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{1})(\\d{6})", "$1 $2 $3", ["[1-689]"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LR: [
				,
				[, , "2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}", , , , , , , [7, 8, 9]],
				[, , "2\\d{7}", , , , "21234567", , , [8]],
				[
					,
					,
					"(?:20\\d{3}|330\\d{2}|4[67]\\d|5(?:55)?\\d{2}|77\\d{3}|88\\d{3})\\d{4}",
					,
					,
					,
					"770123456",
					,
					,
					[7, 9]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "332(?:02|[25]\\d)\\d{4}", , , , "332021234", , , [9]],
				"LR",
				231,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
					[, "([4-5])(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LS: [
				,
				[, , "[2568]\\d{7}", , , , , , , [8]],
				[, , "2\\d{7}", , , , "22123456"],
				[, , "[56]\\d{7}", , , , "50123456"],
				[, , "800[256]\\d{4}", , , , "80021234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LS",
				266,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LT: [
				,
				[, , "[3-9]\\d{7}", , , , , , , [8]],
				[, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"],
				[, , "6\\d{7}", , , , "61234567"],
				[, , "800\\d{5}", , , , "80012345"],
				[, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
				[, , "808\\d{5}", , , , "80812345"],
				[, , "700\\d{5}", , , , "70012345"],
				[, , "NA", , , , , , , [-1]],
				"LT",
				370,
				"00",
				"8",
				,
				,
				"[08]",
				,
				,
				,
				[
					[
						,
						"([34]\\d)(\\d{6})",
						"$1 $2",
						["37|4(?:1|5[45]|6[2-4])"],
						"(8-$1)",
						,
						1
					],
					[
						,
						"([3-6]\\d{2})(\\d{5})",
						"$1 $2",
						["3[148]|4(?:[24]|6[09])|528|6"],
						"(8-$1)",
						,
						1
					],
					[, "([7-9]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1],
					[, "(5)(2\\d{2})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", , 1]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "70[67]\\d{5}", , , , "70712345"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LU: [
				,
				[
					,
					,
					"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",
					,
					,
					,
					,
					,
					,
					[4, 5, 6, 7, 8, 9, 10, 11]
				],
				[
					,
					,
					"(?:2[2-9]\\d{2,9}|(?:[3457]\\d{2}|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8})",
					,
					,
					,
					"27123456"
				],
				[, , "6[2679][18]\\d{6}", , , , "628123456", , , [9]],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "90[015]\\d{5}", , , , "90012345", , , [8]],
				[, , "801\\d{5}", , , , "80112345", , , [8]],
				[, , "70\\d{6}", , , , "70123456", , , [8]],
				[
					,
					,
					"20(?:1\\d{5}|[2-689]\\d{1,7})",
					,
					,
					,
					"20201234",
					,
					,
					[4, 5, 6, 7, 8, 9, 10]
				],
				"LU",
				352,
				"00",
				,
				,
				,
				"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)",
				,
				,
				,
				[
					[
						,
						"(\\d{2})(\\d{3})",
						"$1 $2",
						["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],
						,
						"$CC $1"
					],
					[
						,
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],
						,
						"$CC $1"
					],
					[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20"], , "$CC $1"],
					[
						,
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4",
						["2(?:[0367]|4[3-8])"],
						,
						"$CC $1"
					],
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"],
					[
						,
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4 $5",
						["2(?:[0367]|4[3-8])"],
						,
						"$CC $1"
					],
					[
						,
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})",
						"$1 $2 $3 $4",
						[
							"2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:[1-9]|0[2-9])|9(?:[1-9]|0[2-46-9])"
						],
						,
						"$CC $1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						["70|80[01]|90[015]"],
						,
						"$CC $1"
					],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LV: [
				,
				[, , "[2689]\\d{7}", , , , , , , [8]],
				[, , "6\\d{7}", , , , "63123456"],
				[, , "2\\d{7}", , , , "21234567"],
				[, , "80\\d{6}", , , , "80123456"],
				[, , "90\\d{6}", , , , "90123456"],
				[, , "81\\d{6}", , , , "81123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LV",
				371,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "([2689]\\d)(\\d{3})(\\d{3})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			LY: [
				,
				[, , "[25679]\\d{8}", , , , , , , [9], [7]],
				[, , "(?:2[1345]|5[1347]|6[123479]|71)\\d{7}", , , , "212345678"],
				[, , "9[1-6]\\d{7}", , , , "912345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"LY",
				218,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([25679]\\d)(\\d{7})", "$1-$2", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MA: [
				,
				[, , "[5-9]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}",
					,
					,
					,
					"520123456"
				],
				[
					,
					,
					"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}",
					,
					,
					,
					"650123456"
				],
				[, , "80\\d{7}", , , , "801234567"],
				[, , "89\\d{7}", , , , "891234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "5924[01]\\d{4}", , , , "592401234"],
				"MA",
				212,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([5-7]\\d{2})(\\d{6})", "$1-$2", ["5(?:2[015-7]|3[0-4])|[67]"], "0$1"],
					[
						,
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						],
						"0$1"
					],
					[, "(5\\d{4})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]"], "0$1"],
					[
						,
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["5(?:4[067]|5[03])"],
						"0$1"
					],
					[, "(8[09])(\\d{7})", "$1-$2", ["8(?:0|9[013-9])"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MC: [
				,
				[, , "[34689]\\d{7,8}", , , , , , , [8, 9]],
				[, , "870\\d{5}|9[2-47-9]\\d{6}", , , , "99123456", , , [8]],
				[, , "3\\d{7}|4(?:4\\d|5[1-9])\\d{5}|6\\d{8}", , , , "612345678"],
				[, , "90\\d{6}", , , , "90123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MC",
				377,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"], "$1"],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
					[, "(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "870\\d{5}", , , , "87012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MD: [
				,
				[, , "[235-9]\\d{7}", , , , , , , [8]],
				[, , "(?:2[1-9]\\d|3[1-79]\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
				[
					,
					,
					"(?:562|6\\d{2}|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}",
					,
					,
					,
					"62112345"
				],
				[, , "800\\d{5}", , , , "80012345"],
				[, , "90[056]\\d{5}", , , , "90012345"],
				[, , "808\\d{5}", , , , "80812345"],
				[, , "NA", , , , , , , [-1]],
				[, , "3[08]\\d{6}", , , , "30123456"],
				"MD",
				373,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"],
					[, "([25-7]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["2[13-9]|[5-7]"], "0$1"],
					[, "([89]\\d{2})(\\d{5})", "$1 $2", ["[89]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "803\\d{5}", , , , "80312345"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ME: [
				,
				[, , "[2-9]\\d{7,8}", , , , , , , [8, 9], [6]],
				[
					,
					,
					"(?:20[2-8]|3(?:0[2-7]|[12][35-7]|3[4-7])|4(?:0[2367]|1[267])|5(?:0[467]|1[267]|2[367]))\\d{5}",
					,
					,
					,
					"30234567",
					,
					,
					[8]
				],
				[
					,
					,
					"6(?:00\\d|3[24]\\d|61\\d|7(?:[0-8]\\d|9(?:[3-9]|[0-2]\\d))|[89]\\d{2})\\d{4}",
					,
					,
					,
					"67622901"
				],
				[, , "80\\d{6}", , , , "80080002", , , [8]],
				[, , "(?:9(?:4[1568]|5[178]))\\d{5}", , , , "94515151", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "78[1-9]\\d{5}", , , , "78108780", , , [8]],
				"ME",
				382,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["[2-57-9]|6[036-9]", "[2-57-9]|6(?:[03689]|7(?:[0-8]|9[3-9]))"],
						"0$1"
					],
					[, "(67)(9)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["679", "679[0-2]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "77\\d{6}", , , , "77273012", , , [8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MF: [
				,
				[, , "[56]\\d{8}", , , , , , , [9]],
				[, , "590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}", , , , "590271234"],
				[, , "690(?:0[0-7]|[1-9]\\d)\\d{4}", , , , "690301234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MF",
				590,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MG: [
				,
				[, , "[23]\\d{8}", , , , , , , [9], [7]],
				[
					,
					,
					"20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}",
					,
					,
					,
					"202123456"
				],
				[, , "3[2-49]\\d{7}", , , , "321234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "22\\d{7}", , , , "221234567"],
				"MG",
				261,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([23]\\d)(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MH: [
				,
				[, , "[2-6]\\d{6}", , , , , , , [7]],
				[, , "(?:247|528|625)\\d{4}", , , , "2471234"],
				[, , "(?:235|329|45[56]|545)\\d{4}", , , , "2351234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "635\\d{4}", , , , "6351234"],
				"MH",
				692,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1-$2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MK: [
				,
				[, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]],
				[
					,
					,
					"(?:2(?:[23]\\d|5[124578]|6[01])|3(?:1[3-6]|[23][2-6]|4[2356])|4(?:[23][2-6]|4[3-6]|5[256]|6[25-8]|7[24-6]|8[4-6]))\\d{5}",
					,
					,
					,
					"22212345"
				],
				[, , "7(?:[0-25-8]\\d{2}|32\\d|421)\\d{4}", , , , "72345678"],
				[, , "800\\d{5}", , , , "80012345"],
				[, , "5[02-9]\\d{6}", , , , "50012345"],
				[, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MK",
				389,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
					[, "([347]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"],
					[, "([58]\\d{2})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ML: [
				,
				[, , "[246-9]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"(?:2(?:0(?:2\\d|7[0-8])|1(?:2[5-7]|[3-689]\\d))|44[1239]\\d)\\d{4}",
					,
					,
					,
					"20212345"
				],
				[, , "(?:2(?:079|17\\d)|[679]\\d{3}|8[239]\\d{2})\\d{4}", , , , "65012345"],
				[, , "80\\d{6}", , , , "80012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ML",
				223,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]],
					[, "(\\d{4})", "$1", ["67|74"]]
				],
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "80\\d{6}", , , , "80012345"],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MM: [
				,
				[
					,
					,
					"[1478]\\d{5,7}|[256]\\d{5,8}|9(?:[279]\\d{0,2}|[58]|[34]\\d{1,2}|6\\d?)\\d{6}",
					,
					,
					,
					,
					,
					,
					[6, 7, 8, 9, 10],
					[5]
				],
				[
					,
					,
					"1(?:2\\d{1,2}|[3-5]\\d|6\\d?|[89][0-6]\\d)\\d{4}|2(?:2(?:000\\d{3}|\\d{4})|3\\d{4}|4(?:0\\d{5}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5})|[6-9]\\d{4})|4(?:2[245-8]|3(?:[2-46]|56?)|[46][2-6]|5[3-5])\\d{4}|5(?:2(?:2(?:\\d{1,2})?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1(?:2(?:0|4\\d)?|[356])|2[2-6]|3[24-6]|4(?:2(?:4\\d)?|[3-6])|5[2-4]|6[2-8]|7(?:[2367]|4\\d|5\\d?|8[145]\\d)|8[245]|9(?:20?|4))\\d{4}|7(?:[04][24-8]|1(?:20?|[3-7])|22|3[2-4]|5[2-7])\\d{4}|8(?:1(?:2\\d{1,2}|[3-689]\\d)|2(?:2\\d|3(?:\\d|20)|[4-8]\\d)|3[24]\\d|4[24-7]\\d|5[245]\\d|6[23]\\d)\\d{3}",
					,
					,
					,
					"1234567",
					,
					,
					[6, 7, 8, 9]
				],
				[
					,
					,
					"17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2}|6[0-5]\\d)|3(?:[0-36]|4[069])\\d|4(?:0[0-4]\\d|[1379]\\d|2\\d{2}|4[0-589]\\d|5\\d{2}|88)|5[0-6]|61?\\d|7(?:3\\d|[6-9]\\d{2})|8\\d|9(?:1\\d|[5-7]\\d{2}|[089]))\\d{5}",
					,
					,
					,
					"92123456",
					,
					,
					[7, 8, 9, 10]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "1333\\d{4}", , , , "13331234", , , [8]],
				"MM",
				95,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1|2[245]"], "0$1"],
					[, "(2)(\\d{4})(\\d{4})", "$1 $2 $3", ["251"], "0$1"],
					[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["67|81"], "0$1"],
					[, "(\\d{2})(\\d{2})(\\d{3,4})", "$1 $2 $3", ["[4-8]"], "0$1"],
					[
						,
						"(9)(\\d{3})(\\d{4,6})",
						"$1 $2 $3",
						["9(?:2[0-4]|[35-9]|4[137-9])"],
						"0$1"
					],
					[
						,
						"(9)([34]\\d{4})(\\d{4})",
						"$1 $2 $3",
						["9(?:3[0-36]|4[0-57-9])"],
						"0$1"
					],
					[, "(9)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92[56]"], "0$1"],
					[, "(9)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["93"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MN: [
				,
				[, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [6, 7]],
				[
					,
					,
					"[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}",
					,
					,
					,
					"50123456"
				],
				[
					,
					,
					"(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}",
					,
					,
					,
					"88123456",
					,
					,
					[8]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "7[05-8]\\d{6}", , , , "75123456", , , [8]],
				"MN",
				976,
				"001",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([12]\\d)(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"],
					[, "([12]2\\d)(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"],
					[
						,
						"([12]\\d{3})(\\d{5})",
						"$1 $2",
						["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)2"],
						"0$1"
					],
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"], "$1"],
					[
						,
						"([12]\\d{4})(\\d{4,5})",
						"$1 $2",
						["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)[4-9]"],
						"0$1"
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MO: [
				,
				[, , "[268]\\d{7}", , , , , , , [8]],
				[, , "(?:28[2-57-9]|8[2-57-9]\\d)\\d{5}", , , , "28212345"],
				[, , "6(?:[2356]\\d|8[158])\\d{5}", , , , "66123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MO",
				853,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "([268]\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MP: [
				,
				[, , "[5689]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}",
					,
					,
					,
					"6702345678"
				],
				[
					,
					,
					"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}",
					,
					,
					,
					"6702345678"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"MP",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				1,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"670",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MQ: [
				,
				[, , "[56]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"596(?:0[2-5]|[12]0|3[05-9]|4[024-8]|[5-7]\\d|89|9[4-8])\\d{4}",
					,
					,
					,
					"596301234"
				],
				[, , "696(?:[0-479]\\d|5[0-4]|8[0-689])\\d{4}", , , , "696201234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MQ",
				596,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MR: [
				,
				[, , "[2-48]\\d{7}", , , , , , , [8]],
				[, , "25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}", , , , "35123456"],
				[, , "[234][0-46-9]\\d{6}", , , , "22123456"],
				[, , "800\\d{5}", , , , "80012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MR",
				222,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MS: [
				,
				[, , "[5689]\\d{9}", , , , , , , [10], [7]],
				[, , "664491\\d{4}", , , , "6644912345"],
				[, , "66449[2-6]\\d{4}", , , , "6644923456"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"MS",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"664",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MT: [
				,
				[, , "[2357-9]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"2(?:0(?:1[0-6]|3[1-4]|[69]\\d)|[1-357]\\d{2})\\d{4}",
					,
					,
					,
					"21001234"
				],
				[
					,
					,
					"(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|696|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}",
					,
					,
					,
					"96961234"
				],
				[, , "800[3467]\\d{4}", , , , "80071234"],
				[
					,
					,
					"5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168]\\d)|[12]\\d0[1-5])\\d{3}",
					,
					,
					,
					"50037123"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "3550\\d{4}", , , , "35501234"],
				"MT",
				356,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "7117\\d{4}", , , , "71171234"],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "501\\d{5}", , , , "50112345"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MU: [
				,
				[, , "[2-9]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(?:44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}",
					,
					,
					,
					"2012345"
				],
				[
					,
					,
					"5(?:2[59]\\d|4(?:2[1-389]|4\\d|7[1-9]|9\\d)|7\\d{2}|8(?:[0-25689]\\d|4[47]|7[15-8])|9[0-8]\\d)\\d{4}",
					,
					,
					,
					"52512345",
					,
					,
					[8]
				],
				[, , "80[012]\\d{4}", , , , "8001234", , , [7]],
				[, , "30\\d{5}", , , , "3012345", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]],
				"MU",
				230,
				"0(?:0|[2-7]0|33)",
				,
				,
				,
				,
				,
				"020",
				,
				[
					[, "([2-46-9]\\d{2})(\\d{4})", "$1 $2", ["[2-46-9]"]],
					[, "(5\\d{3})(\\d{4})", "$1 $2", ["5"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MV: [
				,
				[, , "[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})", , , , , , , [7, 10]],
				[
					,
					,
					"(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024568]|8[024689]|90))\\d{4}",
					,
					,
					,
					"6701234",
					,
					,
					[7]
				],
				[, , "(?:46[46]|7[3-9]\\d|9[15-9]\\d)\\d{4}", , , , "7712345", , , [7]],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "900\\d{7}", , , , "9001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MV",
				960,
				"0(?:0|19)",
				,
				,
				,
				,
				,
				"00",
				,
				[
					[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9(?:[1-9]|0[1-9])"]],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]00"]]
				],
				,
				[, , "781\\d{4}", , , , "7812345", , , [7]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "4[05]0\\d{4}", , , , "4001234", , , [7]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MW: [
				,
				[, , "(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}", , , , , , , [7, 9]],
				[, , "(?:1[2-9]|21\\d{2})\\d{5}", , , , "1234567"],
				[, , "(?:111|77\\d|88\\d|99\\d)\\d{6}", , , , "991234567", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MW",
				265,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], "0$1"],
					[, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1789]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MX: [
				,
				[, , "[1-9]\\d{9,10}", , , , , , , [10, 11], [7, 8]],
				[
					,
					,
					"(?:33|55|81)\\d{8}|(?:2(?:0[01]|2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}",
					,
					,
					,
					"2221234567",
					,
					,
					[10]
				],
				[
					,
					,
					"1(?:(?:33|55|81)\\d{8}|(?:2(?:2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})",
					,
					,
					,
					"12221234567",
					,
					,
					[11]
				],
				[, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]],
				[, , "900\\d{7}", , , , "9001234567", , , [10]],
				[, , "300\\d{7}", , , , "3001234567", , , [10]],
				[, , "500\\d{7}", , , , "5001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				"MX",
				52,
				"0[09]",
				"01",
				,
				,
				"0[12]|04[45](\\d{10})",
				"1$1",
				,
				,
				[
					[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"],
						"01 $1",
						,
						1
					],
					[
						,
						"(1)([358]\\d)(\\d{4})(\\d{4})",
						"044 $2 $3 $4",
						["1(?:33|55|81)"],
						"$1",
						,
						1
					],
					[
						,
						"(1)(\\d{3})(\\d{3})(\\d{4})",
						"044 $2 $3 $4",
						["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],
						"$1",
						,
						1
					]
				],
				[
					[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1],
					[
						,
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"],
						"01 $1",
						,
						1
					],
					[, "(1)([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3 $4", ["1(?:33|55|81)"]],
					[
						,
						"(1)(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"]
					]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MY: [
				,
				[, , "[13-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]],
				[, , "(?:3[2-9]\\d|[4-9][2-9])\\d{6}", , , , "323456789", , , [8, 9]],
				[
					,
					,
					"1(?:1[1-5]\\d{2}|[02-4679][2-9]\\d|59\\d{2}|8(?:1[23]|[2-9]\\d))\\d{5}",
					,
					,
					,
					"123456789",
					,
					,
					[9, 10]
				],
				[, , "1[378]00\\d{6}", , , , "1300123456", , , [10]],
				[, , "1600\\d{6}", , , , "1600123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "154\\d{7}", , , , "1541234567", , , [10]],
				"MY",
				60,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([4-79])(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"],
					[, "(3)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"],
					[
						,
						"([18]\\d)(\\d{3})(\\d{3,4})",
						"$1-$2 $3",
						["1[02-46-9][1-9]|8"],
						"0$1"
					],
					[, "(1)([36-8]00)(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]0"]],
					[, "(11)(\\d{4})(\\d{4})", "$1-$2 $3", ["11"], "0$1"],
					[, "(15[49])(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			MZ: [
				,
				[, , "[28]\\d{7,8}", , , , , , , [8, 9]],
				[, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
				[, , "8[2-7]\\d{7}", , , , "821234567", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"MZ",
				258,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([28]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]],
					[, "(80\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["80"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NA: [
				,
				[, , "[68]\\d{7,8}", , , , , , , [8, 9]],
				[
					,
					,
					"6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4(?:[024]|10?|3[15]?)|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[289]|7[01]|81)|4(?:17|2(?:[012]|7\\d?)|4(?:[06]|1\\d?)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|6[89]|7[01]))\\d{4}",
					,
					,
					,
					"61221234"
				],
				[, , "(?:60|8[125])\\d{7}", , , , "811234567", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "8701\\d{5}", , , , "870123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "8(?:3\\d{2}|86)\\d{5}", , , , "88612345"],
				"NA",
				264,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(8\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["8[1235]"], "0$1"],
					[, "(6\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"],
					[, "(88)(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
					[, "(870)(\\d{3})(\\d{3})", "$1 $2 $3", ["870"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NC: [
				,
				[, , "[2-57-9]\\d{5}", , , , , , , [6]],
				[, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"],
				[, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"],
				[, , "NA", , , , , , , [-1]],
				[, , "36\\d{4}", , , , "366711"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NC",
				687,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-46-9]|5[0-4]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NE: [
				,
				[, , "[0289]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
					,
					,
					,
					"20201234"
				],
				[, , "(?:8[089]|9\\d)\\d{6}", , , , "93123456"],
				[, , "08\\d{6}", , , , "08123456"],
				[, , "09\\d{6}", , , , "09123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NE",
				227,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[289]|09"]],
					[, "(08)(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NF: [
				,
				[, , "[13]\\d{5}", , , , , , , [6], [5]],
				[, , "(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}", , , , "106609"],
				[, , "3[58]\\d{4}", , , , "381234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NF",
				672,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{4})", "$1 $2", ["1"]],
					[, "(\\d)(\\d{5})", "$1 $2", ["3"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NG: [
				,
				[
					,
					,
					"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",
					,
					,
					,
					,
					,
					,
					[7, 8, 10, 11, 12, 13, 14],
					[5, 6]
				],
				[
					,
					,
					"[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}",
					,
					,
					,
					"12345678",
					,
					,
					[7, 8]
				],
				[
					,
					,
					"(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70(?:[1-689]\\d|7[0-3])|8(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))|90[235-9]\\d)\\d{6}",
					,
					,
					,
					"8021234567",
					,
					,
					[8, 10]
				],
				[, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NG",
				234,
				"009",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						["[12]|9(?:0[3-9]|[1-9])"],
						"0$1"
					],
					[
						,
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						["[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						["70|8[01]|90[235-9]"],
						"0$1"
					],
					[, "([78]00)(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]00"], "0$1"],
					[, "([78]00)(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]00"], "0$1"],
					[, "(78)(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NI: [
				,
				[, , "[12578]\\d{7}", , , , , , , [8]],
				[, , "2\\d{7}", , , , "21234567"],
				[, , "5(?:5[0-7]\\d{5}|[78]\\d{6})|7[5-8]\\d{6}|8\\d{7}", , , , "81234567"],
				[, , "1800\\d{4}", , , , "18001234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NI",
				505,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NL: [
				,
				[, , "1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}", , , , , , , [5, 6, 7, 8, 9, 10]],
				[
					,
					,
					"(?:1[0135-8]|2[02-69]|3[0-68]|4[0135-9]|[57]\\d|8[478])\\d{7}",
					,
					,
					,
					"101234567",
					,
					,
					[9]
				],
				[, , "6[1-58]\\d{7}", , , , "612345678", , , [9]],
				[, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]],
				[, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:6760|85\\d{2})\\d{5}", , , , "851234567", , , [9]],
				"NL",
				31,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"([1-578]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"],
						"0$1"
					],
					[
						,
						"([1-5]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
						"0$1"
					],
					[, "(6)(\\d{8})", "$1 $2", ["6[0-57-9]"], "0$1"],
					[, "(66)(\\d{7})", "$1 $2", ["66"], "0$1"],
					[, "(14)(\\d{3,4})", "$1 $2", ["14"], "$1"],
					[, "([89]0\\d)(\\d{4,7})", "$1 $2", ["80|9"], "0$1"]
				],
				,
				[, , "66\\d{7}", , , , "662345678", , , [9]],
				,
				,
				[, , "14\\d{3,4}", , , , "14123", , , [5, 6]],
				[
					,
					,
					"140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])",
					,
					,
					,
					"14020",
					,
					,
					[5, 6]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NO: [
				,
				[, , "0\\d{4}|[2-9]\\d{7}", , , , , , , [5, 8]],
				[
					,
					,
					"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
					,
					,
					,
					"21234567",
					,
					,
					[8]
				],
				[, , "(?:4[015-8]|5[89]|87|9\\d)\\d{6}", , , , "40612345", , , [8]],
				[, , "80[01]\\d{5}", , , , "80012345", , , [8]],
				[, , "82[09]\\d{5}", , , , "82012345", , , [8]],
				[, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]],
				[, , "880\\d{5}", , , , "88012345", , , [8]],
				[, , "85[0-5]\\d{5}", , , , "85012345", , , [8]],
				"NO",
				47,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([489]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]"]],
					[, "([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"],
				1,
				,
				[, , "81[23]\\d{5}", , , , "81212345", , , [8]]
			],
			NP: [
				,
				[
					,
					,
					"[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",
					,
					,
					,
					,
					,
					,
					[8, 10],
					[6, 7]
				],
				[
					,
					,
					"(?:1[0-6]\\d|2[13-79][2-6]|3[135-8][2-6]|4[146-9][2-6]|5[135-7][2-6]|6[13-9][2-6]|7[15-9][2-6]|8[1-46-9][2-6]|9[1-79][2-6])\\d{5}",
					,
					,
					,
					"14567890",
					,
					,
					[8]
				],
				[, , "9(?:6[013]|7[245]|8[0-24-6])\\d{7}", , , , "9841234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NP",
				977,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(1)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"],
					[
						,
						"(\\d{2})(\\d{6})",
						"$1-$2",
						["1[01]|[2-8]|9(?:[1-69]|7[15-9])"],
						"0$1"
					],
					[, "(9\\d{2})(\\d{7})", "$1-$2", ["9(?:6[013]|7[245]|8)"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NR: [
				,
				[, , "[458]\\d{6}", , , , , , , [7]],
				[, , "(?:444|888)\\d{4}", , , , "4441234"],
				[, , "55[5-9]\\d{4}", , , , "5551234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NR",
				674,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NU: [
				,
				[, , "[1-5]\\d{3}", , , , , , , [4]],
				[, , "[34]\\d{3}", , , , "4002"],
				[, , "[125]\\d{3}", , , , "1234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"NU",
				683,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			NZ: [
				,
				[, , "6[235-9]\\d{6}|[2-57-9]\\d{7,10}", , , , , , , [8, 9, 10, 11], [7]],
				[
					,
					,
					"(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}|24099\\d{3}",
					,
					,
					,
					"32345678",
					,
					,
					[8]
				],
				[
					,
					,
					"2(?:[028]\\d{7,8}|1(?:[03]\\d{5,7}|[12457]\\d{5,6}|[689]\\d{5})|[79]\\d{7})",
					,
					,
					,
					"211234567",
					,
					,
					[8, 9, 10]
				],
				[, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
				[, , "90\\d{7,9}", , , , "900123456", , , [9, 10, 11]],
				[, , "NA", , , , , , , [-1]],
				[, , "70\\d{7}", , , , "701234567", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"NZ",
				64,
				"0(?:0|161)",
				"0",
				,
				,
				"0",
				,
				"00",
				,
				[
					[
						,
						"([34679])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						["[346]|7[2-57-9]|9[1-9]"],
						"0$1"
					],
					[, "(24099)(\\d{3})", "$1 $2", ["240", "2409", "24099"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["21"], "0$1"],
					[
						,
						"(\\d{2})(\\d{3})(\\d{3,5})",
						"$1 $2 $3",
						["2(?:1[1-9]|[69]|7[0-35-9])|70|86"],
						"0$1"
					],
					[, "(2\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|5|[89]0"], "0$1"]
				],
				,
				[, , "[28]6\\d{6,7}", , , , "26123456", , , [8, 9]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			OM: [
				,
				[, , "(?:5|[279]\\d)\\d{6}|800\\d{5,6}", , , , , , , [7, 8, 9]],
				[, , "2[2-6]\\d{6}", , , , "23123456", , , [8]],
				[, , "7[19]\\d{6}|9(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "92123456", , , [8]],
				[, , "8007\\d{4,5}|500\\d{4}", , , , "80071234"],
				[, , "900\\d{5}", , , , "90012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"OM",
				968,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(2\\d)(\\d{6})", "$1 $2", ["2"]],
					[, "([79]\\d{3})(\\d{4})", "$1 $2", ["[79]"]],
					[, "([58]00)(\\d{4,6})", "$1 $2", ["[58]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PA: [
				,
				[, , "[1-9]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:1(?:0[0-8]|1[49]|2[37]|3[0137]|4[147]|5[05]|6[58]|7[0167]|8[58]|9[139])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[09]\\d|1[014-7]|2[0-3]|3[03]|4[03-57]|55|6[068]|7[06-8]|8[06-9])|4(?:3[013-69]|4\\d|7[0-589])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[469]0|5[06-9]|7[0-24-79]|8[7-9])|8(?:09|[34]\\d|5[0134]|8[02])|9(?:0[6-9]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}",
					,
					,
					,
					"2001234",
					,
					,
					[7]
				],
				[
					,
					,
					"(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[0-24-9])\\d{5}",
					,
					,
					,
					"60012345"
				],
				[, , "80[09]\\d{4}", , , , "8001234", , , [7]],
				[, , "(?:779|8(?:55|60|7[78])|9(?:00|81))\\d{4}", , , , "8601234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PA",
				507,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]],
					[, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PE: [
				,
				[, , "[14-9]\\d{7,8}", , , , , , , [8, 9], [6, 7]],
				[
					,
					,
					"(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}",
					,
					,
					,
					"11234567",
					,
					,
					[8]
				],
				[, , "9\\d{8}", , , , "912345678", , , [9]],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "805\\d{5}", , , , "80512345", , , [8]],
				[, , "801\\d{5}", , , , "80112345", , , [8]],
				[, , "80[24]\\d{5}", , , , "80212345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				"PE",
				51,
				"19(?:1[124]|77|90)00",
				"0",
				" Anexo ",
				,
				"0",
				,
				,
				,
				[
					[, "(1)(\\d{7})", "$1 $2", ["1"], "(0$1)"],
					[, "([4-8]\\d)(\\d{6})", "$1 $2", ["[4-7]|8[2-4]"], "(0$1)"],
					[, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"],
					[, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PF: [
				,
				[, , "4\\d{5,7}|8\\d{7}", , , , , , , [6, 8]],
				[, , "4(?:[09][45689]\\d|4)\\d{4}", , , , "40412345"],
				[, , "8[79]\\d{6}", , , , "87123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PF",
				689,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[09]|8[79]"]],
					[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "44\\d{4}", , , , "441234", , , [6]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PG: [
				,
				[, , "[1-9]\\d{6,7}", , , , , , , [7, 8]],
				[
					,
					,
					"(?:3[0-2]\\d|4[257]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}",
					,
					,
					,
					"3123456",
					,
					,
					[7]
				],
				[, , "(?:20150|68\\d{2}|7(?:[0-689]\\d|75)\\d{2})\\d{3}", , , , "6812345"],
				[, , "180\\d{4}", , , , "1801234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "27[568]\\d{4}", , , , "2751234", , , [7]],
				"PG",
				675,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-689]|27"]],
					[, "(\\d{4})(\\d{4})", "$1 $2", ["20|7"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PH: [
				,
				[
					,
					,
					"2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}",
					,
					,
					,
					,
					,
					,
					[6, 8, 9, 10, 11, 12, 13],
					[5, 7]
				],
				[
					,
					,
					"2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})",
					,
					,
					,
					"21234567",
					,
					,
					[6, 8, 9, 10]
				],
				[
					,
					,
					"(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[236-9]|5[056]|7[34-79]|89|9[4-9]))\\d{7}",
					,
					,
					,
					"9051234567",
					,
					,
					[10]
				],
				[, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PH",
				63,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"],
					[, "(2)(\\d{5})", "$1 $2", ["2"], "(0$1)"],
					[
						,
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])",
							"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
						],
						"(0$1)"
					],
					[
						,
						"(\\d{5})(\\d{4})",
						"$1 $2",
						["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
						"(0$1)"
					],
					[, "([3-8]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-8]"], "(0$1)"],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["81|9"], "0$1"],
					[, "(1800)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
					[, "(1800)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PK: [
				,
				[
					,
					,
					"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))",
					,
					,
					,
					,
					,
					,
					[8, 9, 10, 11, 12],
					[6, 7]
				],
				[
					,
					,
					"(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}",
					,
					,
					,
					"2123456789",
					,
					,
					[9, 10]
				],
				[
					,
					,
					"3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",
					,
					,
					,
					"3012345678",
					,
					,
					[10]
				],
				[, , "800\\d{5}", , , , "80012345", , , [8]],
				[, , "900\\d{5}", , , , "90012345", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "122\\d{6}", , , , "122044444", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"PK",
				92,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{2})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"
						],
						"(0$1)"
					],
					[
						,
						"(\\d{3})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"
						],
						"(0$1)"
					],
					[
						,
						"(\\d{2})(\\d{7,8})",
						"$1 $2",
						["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
						"(0$1)"
					],
					[
						,
						"(\\d{3})(\\d{6,7})",
						"$1 $2",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d[2-9]"
						],
						"(0$1)"
					],
					[, "(3\\d{2})(\\d{7})", "$1 $2", ["3"], "0$1"],
					[, "([15]\\d{3})(\\d{5,6})", "$1 $2", ["58[12]|1"], "(0$1)"],
					[, "(586\\d{2})(\\d{5})", "$1 $2", ["586"], "(0$1)"],
					[, "([89]00)(\\d{3})(\\d{2})", "$1 $2 $3", ["[89]00"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
					,
					,
					,
					"21111825888",
					,
					,
					[11, 12]
				],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PL: [
				,
				[, , "[12]\\d{6,8}|[3-57-9]\\d{8}|6\\d{5,8}", , , , , , , [6, 7, 8, 9]],
				[
					,
					,
					"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])\\d{7}|[12]2\\d{5}",
					,
					,
					,
					"123456789",
					,
					,
					[7, 9]
				],
				[, , "(?:5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "70\\d{7}", , , , "701234567", , , [9]],
				[, , "801\\d{6}", , , , "801234567", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "39\\d{7}", , , , "391234567", , , [9]],
				"PL",
				48,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[
						,
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]
					],
					[, "(\\d{2})(\\d{1})(\\d{4})", "$1 $2 $3", ["[12]2"]],
					[
						,
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["26|39|5[0137]|6[0469]|7[02389]|8[08]"]
					],
					[, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
					[, "(\\d{3})(\\d{3})", "$1 $2", ["64"]]
				],
				,
				[, , "64\\d{4,7}", , , , "641234567"],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PM: [
				,
				[, , "[45]\\d{5}", , , , , , , [6]],
				[, , "41\\d{4}", , , , "411234"],
				[, , "55\\d{4}", , , , "551234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PM",
				508,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([45]\\d)(\\d{2})(\\d{2})", "$1 $2 $3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PR: [
				,
				[, , "[5789]\\d{9}", , , , , , , [10], [7]],
				[, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678"],
				[, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"PR",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				1,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"787|939",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PS: [
				,
				[
					,
					,
					"[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})",
					,
					,
					,
					,
					,
					,
					[4, 5, 8, 9, 10],
					[7]
				],
				[
					,
					,
					"(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}",
					,
					,
					,
					"22234567",
					,
					,
					[8]
				],
				[, , "5[69]\\d{7}", , , , "599123456", , , [9]],
				[, , "1800\\d{6}", , , , "1800123456", , , [10]],
				[, , "1(?:4|9\\d)\\d{2}", , , , "19123", , , [4, 5]],
				[, , "1700\\d{6}", , , , "1700123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PS",
				970,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([2489])(2\\d{2})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"],
					[, "(5[69]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"],
					[, "(1[78]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[78]"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PT: [
				,
				[, , "[2-46-9]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}",
					,
					,
					,
					"212345678"
				],
				[, , "9(?:[1236]\\d{2}|480)\\d{5}", , , , "912345678"],
				[, , "80[02]\\d{6}", , , , "800123456"],
				[
					,
					,
					"6(?:0[178]|4[68])\\d{6}|76(?:0[1-57]|1[2-47]|2[237])\\d{5}",
					,
					,
					,
					"760123456"
				],
				[, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
				[, , "884[0-4689]\\d{5}", , , , "884123456"],
				[, , "30\\d{7}", , , , "301234567"],
				"PT",
				351,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(2\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]],
					[, "([2-46-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[3-9]|[346-9]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "7(?:0(?:7\\d|8[17]))\\d{5}", , , , "707123456"],
				,
				,
				[, , "600\\d{6}", , , , "600110000"]
			],
			PW: [
				,
				[, , "[2-8]\\d{6}", , , , , , , [7]],
				[
					,
					,
					"2552255|(?:277|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76))\\d{4}",
					,
					,
					,
					"2771234"
				],
				[, , "(?:6[234689]0|77[45789])\\d{4}", , , , "6201234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"PW",
				680,
				"01[12]",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			PY: [
				,
				[, , "5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}", , , , , , , [6, 7, 8, 9], [5]],
				[
					,
					,
					"(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}",
					,
					,
					,
					"212345678",
					,
					,
					[7, 8, 9]
				],
				[, , "9(?:6[12]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]],
				"PY",
				595,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{2})(\\d{5})",
						"$1 $2",
						["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],
						"(0$1)"
					],
					[
						,
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],
						"(0$1)"
					],
					[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"],
					[, "(\\d{3})(\\d{6})", "$1 $2", ["9[1-9]"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8700"]],
					[, "(\\d{3})(\\d{4,5})", "$1 $2", ["[2-8][1-9]"], "(0$1)"],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8][1-9]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "[2-9]0\\d{4,7}", , , , "201234567"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			QA: [
				,
				[, , "[2-8]\\d{6,7}", , , , , , , [7, 8]],
				[, , "4[04]\\d{6}", , , , "44123456", , , [8]],
				[, , "[3567]\\d{7}", , , , "33123456", , , [8]],
				[, , "800\\d{4}", , , , "8001234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"QA",
				974,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([28]\\d{2})(\\d{4})", "$1 $2", ["[28]"]],
					[, "([3-7]\\d{3})(\\d{4})", "$1 $2", ["[3-7]"]]
				],
				,
				[, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			RE: [
				,
				[, , "[268]\\d{8}", , , , , , , [9]],
				[, , "262\\d{6}", , , , "262161234"],
				[, , "6(?:9[23]|47)\\d{6}", , , , "692123456"],
				[, , "80\\d{7}", , , , "801234567"],
				[, , "89[1-37-9]\\d{6}", , , , "891123456"],
				[, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"RE",
				262,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				1,
				"262|6[49]|8",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			RO: [
				,
				[, , "[23]\\d{5,8}|[7-9]\\d{8}", , , , , , , [6, 9]],
				[
					,
					,
					"2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3(?:1\\d{4}(?:\\d{3})?|[3-6]\\d{7})",
					,
					,
					,
					"211234567"
				],
				[, , "7(?:[0-8]\\d{2}|99\\d)\\d{5}", , , , "712345678", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "90[036]\\d{6}", , , , "900123456", , , [9]],
				[, , "801\\d{6}", , , , "801123456", , , [9]],
				[, , "802\\d{6}", , , , "802123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"RO",
				40,
				"00",
				"0",
				" int ",
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"],
					[, "(\\d{2})(\\d{4})", "$1 $2", ["[23]1"], "0$1"],
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23][3-7]|[7-9]"], "0$1"],
					[, "(2\\d{2})(\\d{3})", "$1 $2", ["2[3-6]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "37\\d{7}", , , , "372123456", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			RS: [
				,
				[
					,
					,
					"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",
					,
					,
					,
					,
					,
					,
					[6, 7, 8, 9, 10, 11, 12],
					[5]
				],
				[
					,
					,
					"(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}",
					,
					,
					,
					"10234567",
					,
					,
					[7, 8, 9, 10, 11, 12]
				],
				[, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]],
				[, , "800\\d{3,9}", , , , "80012345"],
				[, , "(?:90[0169]|78\\d)\\d{3,7}", , , , "90012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"RS",
				381,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([23]\\d{2})(\\d{4,9})", "$1 $2", ["(?:2[389]|39)0"], "0$1"],
					[
						,
						"([1-3]\\d)(\\d{5,10})",
						"$1 $2",
						["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"],
						"0$1"
					],
					[, "(6\\d)(\\d{6,8})", "$1 $2", ["6"], "0$1"],
					[, "([89]\\d{2})(\\d{3,9})", "$1 $2", ["[89]"], "0$1"],
					[, "(7[26])(\\d{4,9})", "$1 $2", ["7[26]"], "0$1"],
					[, "(7[08]\\d)(\\d{4,9})", "$1 $2", ["7[08]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "7[06]\\d{4,10}", , , , "700123456"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			RU: [
				,
				[, , "[3489]\\d{9}", , , , , , , [10]],
				[
					,
					,
					"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
					,
					,
					,
					"3011234567"
				],
				[, , "9\\d{9}", , , , "9123456789"],
				[, , "80[04]\\d{7}", , , , "8001234567"],
				[, , "80[39]\\d{7}", , , , "8091234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"RU",
				7,
				"810",
				"8",
				,
				,
				"8",
				,
				"8~10",
				,
				[
					[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[1-79]"], "$1", , 1],
					[
						,
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						["[34689]"],
						"8 ($1)",
						,
						1
					],
					[, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]
				],
				[
					[
						,
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						["[34689]"],
						"8 ($1)",
						,
						1
					],
					[, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]
				],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			RW: [
				,
				[, , "[027-9]\\d{7,8}", , , , , , , [8, 9]],
				[, , "2[258]\\d{7}|06\\d{6}", , , , "250123456"],
				[, , "7[238]\\d{7}", , , , "720123456", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "900\\d{6}", , , , "900123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"RW",
				250,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "$1"],
					[, "([7-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"],
					[, "(0\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SA: [
				,
				[
					,
					,
					"1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",
					,
					,
					,
					,
					,
					,
					[8, 9, 10],
					[7]
				],
				[
					,
					,
					"11\\d{7}|1?(?:2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
					,
					,
					,
					"112345678",
					,
					,
					[8, 9]
				],
				[
					,
					,
					"(?:5(?:[013-689]\\d|7[0-26-8])|811\\d)\\d{6}",
					,
					,
					,
					"512345678",
					,
					,
					[9, 10]
				],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "92[05]\\d{6}", , , , "920012345", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SA",
				966,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([1-467])(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-467]"], "0$1"],
					[, "(1\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[1-467]"], "0$1"],
					[, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
					[, "(92\\d{2})(\\d{5})", "$1 $2", ["92"], "$1"],
					[, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "$1"],
					[, "(811)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SB: [
				,
				[, , "[1-9]\\d{4,6}", , , , , , , [5, 7]],
				[
					,
					,
					"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
					,
					,
					,
					"40123",
					,
					,
					[5]
				],
				[
					,
					,
					"48\\d{3}|7(?:30|[46-8]\\d|5[025-9]|9[0-5])\\d{4}|8[4-9]\\d{5}|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}",
					,
					,
					,
					"7421234"
				],
				[, , "1[38]\\d{3}", , , , "18123", , , [5]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "5[12]\\d{3}", , , , "51123", , , [5]],
				"SB",
				677,
				"0[01]",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{5})", "$1 $2", ["[7-9]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SC: [
				,
				[, , "[24689]\\d{5,6}", , , , , , , [7]],
				[, , "4[2-46]\\d{5}", , , , "4217123"],
				[, , "2[5-8]\\d{5}", , , , "2510123"],
				[, , "8000\\d{3}", , , , "8000000"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:64\\d|971)\\d{4}", , , , "6412345"],
				"SC",
				248,
				"0(?:[02]|10?)",
				,
				,
				,
				,
				,
				"00",
				,
				[[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SD: [
				,
				[, , "[19]\\d{8}", , , , , , , [9]],
				[, , "1(?:[125]\\d|8[3567])\\d{6}", , , , "121231234"],
				[, , "9[0-3569]\\d{7}", , , , "911231234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SD",
				249,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SE: [
				,
				[, , "[1-35-9]\\d{5,11}|4\\d{6,8}", , , , , , , [6, 7, 8, 9, 10, 12]],
				[
					,
					,
					"1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})",
					,
					,
					,
					"8123456",
					,
					,
					[7, 8, 9]
				],
				[, , "7[02369]\\d{7}", , , , "701234567", , , [9]],
				[, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]],
				[
					,
					,
					"649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}",
					,
					,
					,
					"9001234567",
					,
					,
					[7, 8, 9, 10]
				],
				[, , "77(?:0\\d{3}(?:\\d{3})?|[1-7]\\d{6})", , , , "771234567", , , [6, 9]],
				[, , "75[1-8]\\d{6}", , , , "751234567", , , [9]],
				[, , "NA", , , , , , , [-1]],
				"SE",
				46,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"],
					[
						,
						"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],
						"0$1"
					],
					[
						,
						"([1-469]\\d)(\\d{3})(\\d{2})",
						"$1-$2 $3",
						["1[136]|2[136]|3[356]|4[0246]|6[03]|90"],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						"0$1"
					],
					[, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"],
					[, "(77)(\\d{2})(\\d{2})", "$1-$2$3", ["7"], "0$1"],
					[, "(20)(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"],
					[
						,
						"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})",
						"$1-$2 $3 $4",
						["9[034]"],
						"0$1"
					],
					[, "(9[034]\\d)(\\d{4})", "$1-$2", ["9[034]"], "0$1"],
					[
						,
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4 $5",
						["25[245]|67[3-6]"],
						"0$1"
					]
				],
				[
					[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1 $2 $3 $4", ["8"]],
					[
						,
						"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]
					],
					[
						,
						"([1-469]\\d)(\\d{3})(\\d{2})",
						"$1 $2 $3",
						["1[136]|2[136]|3[356]|4[0246]|6[03]|90"]
					],
					[
						,
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						]
					],
					[
						,
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1 $2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						]
					],
					[, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7"]],
					[, "(77)(\\d{2})(\\d{2})", "$1 $2 $3", ["7"]],
					[, "(20)(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]],
					[, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9[034]"]],
					[, "(9[034]\\d)(\\d{4})", "$1 $2", ["9[034]"]],
					[
						,
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						["25[245]|67[3-6]"]
					]
				],
				[, , "74[02-9]\\d{6}", , , , "740123456", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "(?:25[245]|67[3-6])\\d{9}", , , , "254123456789", , , [12]]
			],
			SG: [
				,
				[, , "[36]\\d{7}|[17-9]\\d{7,10}", , , , , , , [8, 10, 11]],
				[, , "6[1-9]\\d{6}", , , , "61234567", , , [8]],
				[, , "(?:8[1-8]|9[0-8])\\d{6}", , , , "81234567", , , [8]],
				[, , "1?800\\d{7}", , , , "18001234567", , , [10, 11]],
				[, , "1900\\d{7}", , , , "19001234567", , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "3[12]\\d{6}", , , , "31234567", , , [8]],
				"SG",
				65,
				"0[0-3]\\d",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "([3689]\\d{3})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]],
					[, "(1[89]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[89]"]],
					[, "(7000)(\\d{4})(\\d{3})", "$1 $2 $3", ["70"]],
					[, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "7000\\d{7}", , , , "70001234567", , , [11]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SH: [
				,
				[, , "[256]\\d{4}", , , , , , , [4, 5]],
				[, , "2(?:[0-57-9]\\d|6[4-9])\\d{2}", , , , "22158"],
				[, , "[56]\\d{4}", , , , "51234", , , [5]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "262\\d{2}", , , , "26212", , , [5]],
				"SH",
				290,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SI: [
				,
				[, , "[1-7]\\d{6,7}|[89]\\d{4,7}", , , , , , , [5, 6, 7, 8]],
				[
					,
					,
					"(?:1\\d|[25][2-8]|3[24-8]|4[24-8]|7[3-8])\\d{6}",
					,
					,
					,
					"11234567",
					,
					,
					[8]
				],
				[, , "(?:[37][01]|4[0139]|51|6[48])\\d{6}", , , , "31234567", , , [8]],
				[, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
				[, , "90\\d{4,6}|89[1-3]\\d{2,5}", , , , "90123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:59|8[1-3])\\d{6}", , , , "59012345", , , [8]],
				"SI",
				386,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[12]|3[24-8]|4[24-8]|5[2-8]|7[3-8]"],
						"(0$1)"
					],
					[
						,
						"([3-7]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["[37][01]|4[0139]|51|6"],
						"0$1"
					],
					[, "([89][09])(\\d{3,6})", "$1 $2", ["[89][09]"], "0$1"],
					[, "([58]\\d{2})(\\d{5})", "$1 $2", ["59|8[1-3]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SJ: [
				,
				[, , "0\\d{4}|[45789]\\d{7}", , , , , , , [5, 8]],
				[, , "79\\d{6}", , , , "79123456", , , [8]],
				[, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "41234567", , , [8]],
				[, , "80[01]\\d{5}", , , , "80012345", , , [8]],
				[, , "82[09]\\d{5}", , , , "82012345", , , [8]],
				[, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]],
				[, , "880\\d{5}", , , , "88012345", , , [8]],
				[, , "85[0-5]\\d{5}", , , , "85012345", , , [8]],
				"SJ",
				47,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"],
				1,
				,
				[, , "81[23]\\d{5}", , , , "81212345", , , [8]]
			],
			SK: [
				,
				[, , "(?:[2-68]\\d{5,8}|9\\d{6,8})", , , , , , , [6, 7, 9]],
				[
					,
					,
					"2(?:1(?:6\\d{3,4}|7\\d{3})|[2-9]\\d{7})|[3-5][1-8](?:16\\d{2,3}|\\d{7})",
					,
					,
					,
					"221234567"
				],
				[
					,
					,
					"9(?:0(?:[1-8]\\d|9[1-9])|(?:1[0-24-9]|[45]\\d)\\d)\\d{5}",
					,
					,
					,
					"912123456",
					,
					,
					[9]
				],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "9(?:[78]\\d{7}|00\\d{6})", , , , "900123456", , , [9]],
				[, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
				"SK",
				421,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(1[67])(\\d{3,4})", "$1 $2 $3", ["21[67]"], "0$1"],
					[, "([3-5]\\d)(16)(\\d{2,3})", "$1 $2 $3", ["[3-5]"], "0$1"],
					[, "(2)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"],
					[, "([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"],
					[, "([689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"],
					[, "(9090)(\\d{3})", "$1 $2", ["9090"], "0$1"]
				],
				,
				[, , "9090\\d{3}", , , , "9090123", , , [7]],
				,
				,
				[
					,
					,
					"(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}|9090\\d{3}",
					,
					,
					,
					"800123456",
					,
					,
					[7, 9]
				],
				[, , "96\\d{7}", , , , "961234567", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SL: [
				,
				[, , "[2-9]\\d{7}", , , , , , , [8], [6]],
				[, , "[235]2[2-4][2-9]\\d{4}", , , , "22221234"],
				[
					,
					,
					"(?:2[15]|3[03-5]|4[04]|5[05]|66|7[6-9]|88|99)\\d{6}",
					,
					,
					,
					"25123456"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SL",
				232,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{2})(\\d{6})", "$1 $2", , "(0$1)"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SM: [
				,
				[, , "[05-7]\\d{7,9}", , , , , , , [8, 10], [6]],
				[, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10]],
				[, , "6[16]\\d{6}", , , , "66661212", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "7[178]\\d{6}", , , , "71123456", , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "5[158]\\d{6}", , , , "58001110", , , [8]],
				"SM",
				378,
				"00",
				,
				,
				,
				"(?:0549)?([89]\\d{5})",
				"0549$1",
				,
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]],
					[, "(0549)(\\d{6})", "$1 $2", ["0"]],
					[, "(\\d{6})", "0549 $1", ["[89]"]]
				],
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]],
					[, "(0549)(\\d{6})", "($1) $2", ["0"]],
					[, "(\\d{6})", "(0549) $1", ["[89]"]]
				],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SN: [
				,
				[, , "[3789]\\d{8}", , , , , , , [9]],
				[
					,
					,
					"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
					,
					,
					,
					"301012345"
				],
				[, , "7(?:[06-8]\\d|21|90)\\d{6}", , , , "701234567"],
				[, , "800\\d{6}", , , , "800123456"],
				[, , "88[4689]\\d{6}", , , , "884123456"],
				[, , "81[02468]\\d{6}", , , , "810123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "39[01]\\d{6}|3392\\d{5}|93330\\d{4}", , , , "933301234"],
				"SN",
				221,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]],
					[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SO: [
				,
				[, , "[1-9]\\d{5,8}", , , , , , , [6, 7, 8, 9]],
				[
					,
					,
					"(?:1\\d{1,2}|2[0-79]\\d|3[0-46-8]?\\d|4[0-7]?\\d|59\\d|8[125])\\d{4}",
					,
					,
					,
					"4012345",
					,
					,
					[6, 7]
				],
				[
					,
					,
					"(?:15\\d|2(?:4\\d|8)|3[59]\\d{2}|4[89]\\d{2}|6[1-9]?\\d{2}|7(?:[1-8]\\d|9\\d{1,2})|8[08]\\d{2}|9(?:0[67]|[2-9])\\d)\\d{5}",
					,
					,
					,
					"71123456",
					,
					,
					[7, 8, 9]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SO",
				252,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{6})", "$1", ["[134]"]],
					[, "(\\d)(\\d{6})", "$1 $2", ["2[0-79]|[13-5]"]],
					[, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]],
					[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]],
					[, "(\\d{2})(\\d{5,7})", "$1 $2", ["15|28|6[1-35-9]|799|9[2-9]"]],
					[
						,
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						["3[59]|4[89]|6[24-6]|79|8[08]|90"]
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SR: [
				,
				[, , "[2-8]\\d{5,6}", , , , , , , [6, 7]],
				[, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}", , , , "211234"],
				[, , "(?:7[124-7]|8[1-9])\\d{5}", , , , "7412345", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:6\\d{4}|90[0-4]\\d{3})", , , , "561234"],
				"SR",
				597,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-4]|5[2-58]"]],
					[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]],
					[, "(\\d{3})(\\d{4})", "$1-$2", ["59|[6-8]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SS: [
				,
				[, , "[19]\\d{8}", , , , , , , [9]],
				[, , "18\\d{7}", , , , "181234567"],
				[, , "(?:12|9[1257])\\d{7}", , , , "977123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SS",
				211,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ST: [
				,
				[, , "[29]\\d{6}", , , , , , , [7]],
				[, , "22\\d{5}", , , , "2221234"],
				[, , "9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d{2})\\d{3}", , , , "9812345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ST",
				239,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SV: [
				,
				[, , "[267]\\d{7}|[89]\\d{6}(?:\\d{4})?", , , , , , , [7, 8, 11]],
				[, , "2[1-6]\\d{6}", , , , "21234567", , , [8]],
				[, , "[67]\\d{7}", , , , "70123456", , , [8]],
				[, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]],
				[, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SV",
				503,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]],
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]],
					[, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SX: [
				,
				[, , "[5789]\\d{9}", , , , , , , [10], [7]],
				[, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678"],
				[, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678"],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
				[, , "900[2-9]\\d{6}", , , , "9002123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"SX",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"721",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SY: [
				,
				[, , "[1-59]\\d{7,8}", , , , , , , [8, 9], [6, 7]],
				[
					,
					,
					"(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}",
					,
					,
					,
					"112345678"
				],
				[, , "9(?:22|[3-589]\\d|6[024-9])\\d{6}", , , , "944567890", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SY",
				963,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1],
					[, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			SZ: [
				,
				[, , "[027]\\d{7}", , , , , , , [8]],
				[, , "2[2-5]\\d{6}", , , , "22171234"],
				[, , "7[6-8]\\d{6}", , , , "76123456"],
				[, , "0800\\d{4}", , , , "08001234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"SZ",
				268,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{4})(\\d{4})", "$1 $2", ["[027]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "0800\\d{4}", , , , "08001234"],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TA: [
				,
				[, , "8\\d{3}", , , , , , , [4]],
				[, , "8\\d{3}", , , , "8999"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TA",
				290,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TC: [
				,
				[, , "[5689]\\d{9}", , , , , , , [10], [7]],
				[, , "649(?:712|9(?:4\\d|50))\\d{4}", , , , "6497121234"],
				[
					,
					,
					"649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}",
					,
					,
					,
					"6492311234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "64971[01]\\d{4}", , , , "6497101234"],
				"TC",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"649",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TD: [
				,
				[, , "[2679]\\d{7}", , , , , , , [8]],
				[, , "22(?:[3789]0|5[0-5]|6[89])\\d{4}", , , , "22501234"],
				[, , "(?:6[023568]\\d|77\\d|9\\d{2})\\d{5}", , , , "63012345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TD",
				235,
				"00|16",
				,
				,
				,
				,
				,
				"00",
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TG: [
				,
				[, , "[29]\\d{7}", , , , , , , [8]],
				[, , "2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}", , , , "22212345"],
				[, , "9[0-389]\\d{6}", , , , "90112345"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TG",
				228,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[29]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TH: [
				,
				[, , "[2-9]\\d{7,8}|1\\d{3}(?:\\d{5,6})?", , , , , , , [4, 8, 9, 10]],
				[
					,
					,
					"(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
					,
					,
					,
					"21234567",
					,
					,
					[8]
				],
				[, , "(?:14|6[1-5]|[89]\\d)\\d{7}", , , , "812345678", , , [9]],
				[, , "1800\\d{6}", , , , "1800123456", , , [10]],
				[, , "1900\\d{6}", , , , "1900123456", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "6[08]\\d{7}", , , , "601234567", , , [9]],
				"TH",
				66,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
					[, "([13-9]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"],
					[, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], "$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "1\\d{3}", , , , "1100", , , [4]],
				[, , "1\\d{3}", , , , "1100", , , [4]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TJ: [
				,
				[, , "[3-589]\\d{8}", , , , , , , [9], [3, 5, 7]],
				[
					,
					,
					"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
					,
					,
					,
					"372123456"
				],
				[
					,
					,
					"(?:41[18]|5(?:0[125]|5\\d)|88\\d|9[0-35-9]\\d)\\d{6}",
					,
					,
					,
					"917123456"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TJ",
				992,
				"810",
				"8",
				,
				,
				"8",
				,
				"8~10",
				,
				[
					[
						,
						"([349]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						["[34]7|91[78]"],
						"(8) $1",
						,
						1
					],
					[
						,
						"([4589]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["4[148]|[58]|9(?:1[59]|[0235-9])"],
						"(8) $1",
						,
						1
					],
					[
						,
						"(331700)(\\d)(\\d{2})",
						"$1 $2 $3",
						["331", "3317", "33170", "331700"],
						"(8) $1",
						,
						1
					],
					[
						,
						"(\\d{4})(\\d)(\\d{4})",
						"$1 $2 $3",
						["3[1-5]", "3(?:[1245]|3(?:[02-9]|1[0-589]))"],
						"(8) $1",
						,
						1
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TK: [
				,
				[, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]],
				[, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"],
				[, , "7[2-4]\\d{2,5}", , , , "7290"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TK",
				690,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TL: [
				,
				[, , "[2-489]\\d{6}|7\\d{6,7}", , , , , , , [7, 8]],
				[, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]],
				[, , "7[3-8]\\d{6}", , , , "77212345", , , [8]],
				[, , "80\\d{5}", , , , "8012345", , , [7]],
				[, , "90\\d{5}", , , , "9012345", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "70\\d{5}", , , , "7012345", , , [7]],
				[, , "NA", , , , , , , [-1]],
				"TL",
				670,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]"]],
					[, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TM: [
				,
				[, , "[1-6]\\d{7}", , , , , , , [8]],
				[
					,
					,
					"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
					,
					,
					,
					"12345678"
				],
				[, , "6[1-9]\\d{6}", , , , "66123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TM",
				993,
				"810",
				"8",
				,
				,
				"8",
				,
				"8~10",
				,
				[
					[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"],
					[, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"],
					[, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["13|[2-5]"], "(8 $1)"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TN: [
				,
				[, , "[2-57-9]\\d{7}", , , , , , , [8]],
				[, , "3(?:[012]\\d|6[0-4]|91)\\d{5}|7\\d{7}|81200\\d{3}", , , , "71234567"],
				[, , "(?:[259]\\d|4[0-6])\\d{6}", , , , "20123456"],
				[, , "8010\\d{4}", , , , "80101234"],
				[, , "88\\d{6}", , , , "88123456"],
				[, , "8[12]10\\d{4}", , , , "81101234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TN",
				216,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TO: [
				,
				[, , "[02-8]\\d{4,6}", , , , , , , [5, 7]],
				[
					,
					,
					"(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}",
					,
					,
					,
					"20123",
					,
					,
					[5]
				],
				[, , "(?:7[578]|8[47-9])\\d{5}", , , , "7715123", , , [7]],
				[, , "0800\\d{3}", , , , "0800222", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TO",
				676,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{3})", "$1-$2", ["[1-6]|7[0-4]|8[05]"]],
					[, "(\\d{3})(\\d{4})", "$1 $2", ["7[5-9]|8[47-9]"]],
					[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TR: [
				,
				[, , "[2-589]\\d{9}|444\\d{4}", , , , , , , [7, 10]],
				[
					,
					,
					"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
					,
					,
					,
					"2123456789",
					,
					,
					[10]
				],
				[
					,
					,
					"5(?:(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{2}|6161)\\d{5}",
					,
					,
					,
					"5012345678",
					,
					,
					[10]
				],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "900\\d{7}", , , , "9001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TR",
				90,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["[23]|4(?:[0-35-9]|4[0-35-9])"],
						"(0$1)",
						,
						1
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["5[02-69]"],
						"0$1",
						,
						1
					],
					[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["51|[89]"], "0$1", , 1],
					[, "(444)(\\d{1})(\\d{3})", "$1 $2 $3", ["444"]]
				],
				,
				[, , "512\\d{7}", , , , "5123456789", , , [10]],
				,
				,
				[, , "444\\d{4}", , , , "4441444", , , [7]],
				[, , "444\\d{4}|850\\d{7}", , , , "4441444"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TT: [
				,
				[, , "[589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"868(?:2(?:01|[23]\\d)|6(?:0[79]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
					,
					,
					,
					"8682211234"
				],
				[
					,
					,
					"868(?:2(?:[789]\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
					,
					,
					,
					"8682911234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"TT",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"868",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "868619\\d{4}", , , , "8686191234"]
			],
			TV: [
				,
				[, , "[279]\\d{4,6}", , , , , , , [5, 6, 7]],
				[, , "2[02-9]\\d{3}", , , , "20123", , , [5]],
				[, , "(?:70\\d|90)\\d{4}", , , , "901234", , , [6, 7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"TV",
				688,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TW: [
				,
				[, , "2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}", , , , , , , [7, 8, 9, 10]],
				[
					,
					,
					"2(?:[235-8]\\d{7}|4\\d{6,7})|[3-8]\\d{7,8}",
					,
					,
					,
					"221234567",
					,
					,
					[8, 9]
				],
				[, , "9\\d{8}", , , , "912345678", , , [9]],
				[, , "800\\d{6}", , , , "800123456", , , [9]],
				[, , "20(?:2|[013-9]\\d{2})\\d{4}", , , , "203123456", , , [7, 9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "70\\d{8}", , , , "7012345678", , , [10]],
				"TW",
				886,
				"0(?:0[25679]|19)",
				"0",
				"#",
				,
				"0",
				,
				,
				,
				[
					[, "(20)(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"],
					[, "(20)(\\d{3})(\\d{4})", "$1 $2 $3", ["20[013-9]"], "0$1"],
					[
						,
						"([2-8])(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						["2[23-8]|[3-6]|[78][1-9]"],
						"0$1"
					],
					[, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["80|9"], "0$1"],
					[, "(70)(\\d{4})(\\d{4})", "$1 $2 $3", ["70"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			TZ: [
				,
				[, , "\\d{9}", , , , , , , [7, 9]],
				[, , "2[2-8]\\d{7}", , , , "222345678"],
				[, , "(?:6[2-9]|7[13-9])\\d{7}", , , , "621234567", , , [9]],
				[, , "80[08]\\d{6}", , , , "800123456", , , [9]],
				[, , "90\\d{7}", , , , "900123456", , , [9]],
				[, , "8(?:40|6[01])\\d{6}", , , , "840123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "41\\d{7}", , , , "412345678", , , [9]],
				"TZ",
				255,
				"00[056]",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([24]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"],
					[, "([67]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"],
					[, "([89]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}", , , , "800123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			UA: [
				,
				[, , "[3-9]\\d{8}", , , , , , , [9], [5, 6, 7]],
				[, , "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", , , , "311234567"],
				[, , "(?:39|50|6[36-8]|7[13]|9[1-9])\\d{7}", , , , "391234567"],
				[, , "800\\d{6}", , , , "800123456"],
				[, , "900\\d{6}", , , , "900123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "89\\d{7}", , , , "891234567"],
				"UA",
				380,
				"00",
				"0",
				,
				,
				"0",
				,
				"0~0",
				,
				[
					[
						,
						"([3-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|7|9[1-9]",
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"
						],
						"0$1"
					],
					[
						,
						"([3-689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90",
							"3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"
						],
						"0$1"
					],
					[
						,
						"([3-6]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])",
							"3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"
						],
						"0$1"
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			UG: [
				,
				[, , "\\d{9}", , , , , , , [9], [5, 6, 7]],
				[
					,
					,
					"20(?:[0147]\\d{2}|2(?:40|[5-9]\\d)|3(?:0[0-4]|[23]\\d)|5[0-4]\\d|6[035-9]\\d|8[0-2]\\d)\\d{4}|[34]\\d{8}",
					,
					,
					,
					"312345678"
				],
				[
					,
					,
					"7(?:(?:0[0-7]|[15789]\\d|30|4[0-4])\\d|2(?:[03]\\d|60))\\d{5}",
					,
					,
					,
					"712345678"
				],
				[, , "800[123]\\d{5}", , , , "800123456"],
				[, , "90[123]\\d{6}", , , , "901123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"UG",
				256,
				"00[057]",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[
						,
						"(\\d{3})(\\d{6})",
						"$1 $2",
						["[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"],
						"0$1"
					],
					[, "(\\d{2})(\\d{7})", "$1 $2", ["3|4(?:[1-5]|6[0-36-9])"], "0$1"],
					[, "(2024)(\\d{5})", "$1 $2", ["2024"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			US: [
				,
				[, , "[2-9]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}",
					,
					,
					,
					"2015550123"
				],
				[
					,
					,
					"(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}",
					,
					,
					,
					"2015550123"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"US",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				1,
				[
					[, "(\\d{3})(\\d{4})", "$1-$2", , , , 1],
					[, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", , , , 1]
				],
				[[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3"]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			UY: [
				,
				[, , "[2489]\\d{6,7}", , , , , , , [7, 8]],
				[, , "2\\d{7}|4[2-7]\\d{6}", , , , "21231234", , , [8]],
				[, , "9[1-9]\\d{6}", , , , "94231234", , , [8]],
				[, , "80[05]\\d{4}", , , , "8001234", , , [7]],
				[, , "90[0-8]\\d{4}", , , , "9001234", , , [7]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"UY",
				598,
				"0(?:1[3-9]\\d|0)",
				"0",
				" int. ",
				,
				"0",
				,
				"00",
				,
				[
					[, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]],
					[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9[1-9]"], "0$1"],
					[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]0"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			UZ: [
				,
				[, , "[679]\\d{8}", , , , , , , [9], [7]],
				[
					,
					,
					"(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
					,
					,
					,
					"662345678"
				],
				[
					,
					,
					"6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}",
					,
					,
					,
					"912345678"
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"UZ",
				998,
				"810",
				"8",
				,
				,
				"8",
				,
				"8~10",
				,
				[[, "([679]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "8 $1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VA: [
				,
				[
					,
					,
					"(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",
					,
					,
					,
					,
					,
					,
					[6, 8, 9, 10, 11]
				],
				[, , "06698\\d{5}", , , , "0669812345", , , [10]],
				[
					,
					,
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					,
					,
					,
					"3123456789",
					,
					,
					[9, 10, 11]
				],
				[, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]],
				[
					,
					,
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					,
					,
					,
					"899123456",
					,
					,
					[6, 8, 9, 10]
				],
				[, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]],
				[, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]],
				[, , "55\\d{8}", , , , "5512345678", , , [10]],
				"VA",
				39,
				"00",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "848\\d{6}", , , , "848123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VC: [
				,
				[, , "[5789]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
					,
					,
					,
					"7842661234"
				],
				[
					,
					,
					"784(?:4(?:3[0-4]|5[45]|89|9[0-58])|5(?:2[6-9]|3[0-4]))\\d{4}",
					,
					,
					,
					"7844301234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"VC",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"784",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VE: [
				,
				[, , "[24589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}",
					,
					,
					,
					"2121234567"
				],
				[, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
				[, , "800\\d{7}", , , , "8001234567"],
				[, , "900\\d{7}", , , , "9001234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"VE",
				58,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[[, "(\\d{3})(\\d{7})", "$1-$2", , "0$1", "$CC $1"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VG: [
				,
				[, , "[2589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})",
					,
					,
					,
					"2842291234"
				],
				[
					,
					,
					"284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})",
					,
					,
					,
					"2843001234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"VG",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"284",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VI: [
				,
				[, , "[3589]\\d{9}", , , , , , , [10], [7]],
				[
					,
					,
					"340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}",
					,
					,
					,
					"3406421234"
				],
				[
					,
					,
					"340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}",
					,
					,
					,
					"3406421234"
				],
				[, , "8(?:00|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
				[, , "900[2-9]\\d{6}", , , , "9002345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
				[, , "NA", , , , , , , [-1]],
				"VI",
				1,
				"011",
				"1",
				,
				,
				"1",
				,
				,
				1,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"340",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VN: [
				,
				[, , "[167]\\d{6,9}|[2-59]\\d{7,9}|8\\d{6,8}", , , , , , , [7, 8, 9, 10]],
				[
					,
					,
					"(?:2(?:[025-79]|1[0189]|[348][01])|3(?:[0136-9]|[25][01])|4\\d|5(?:[01][01]|[2-9])|6(?:[0-46-8]|5[01])|7(?:[02-79]|[18][01]))\\d{7}|8(?:[1-57]\\d|[689][0-79])\\d{6}",
					,
					,
					,
					"2101234567",
					,
					,
					[9, 10]
				],
				[
					,
					,
					"(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}|8[689]8\\d{6}",
					,
					,
					,
					"912345678",
					,
					,
					[9, 10]
				],
				[, , "1800\\d{4,6}", , , , "1800123456", , , [8, 9, 10]],
				[, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"VN",
				84,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([17]99)(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1],
					[
						,
						"([48])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						["4|8(?:[1-57]|[689][0-79])"],
						"0$1",
						,
						1
					],
					[
						,
						"([235-7]\\d)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						["2[025-79]|3[0136-9]|5[2-9]|6[0-46-8]|7[02-79]"],
						"0$1",
						,
						1
					],
					[, "(80)(\\d{5})", "$1 $2", ["80"], "0$1", , 1],
					[, "(69\\d)(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1],
					[
						,
						"([235-7]\\d{2})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						["2[1348]|3[25]|5[01]|65|7[18]"],
						"0$1",
						,
						1
					],
					[
						,
						"([89]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						["8[689]8|9"],
						"0$1",
						,
						1
					],
					[
						,
						"(1[2689]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["1(?:[26]|8[68]|99)"],
						"0$1",
						,
						1
					],
					[, "(1[89]00)(\\d{4,6})", "$1 $2", ["1[89]0"], "$1", , 1]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "[17]99\\d{4}|69\\d{5,6}", , , , "1992000", , , [7, 8]],
				[, , "[17]99\\d{4}|69\\d{5,6}|80\\d{5}", , , , "1992000", , , [7, 8]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			VU: [
				,
				[, , "[2-57-9]\\d{4,6}", , , , , , , [5, 7]],
				[
					,
					,
					"(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}",
					,
					,
					,
					"22123",
					,
					,
					[5]
				],
				[
					,
					,
					"(?:5(?:7[2-5]|[0-689]\\d)|7[013-7]\\d)\\d{4}",
					,
					,
					,
					"5912345",
					,
					,
					[7]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"VU",
				678,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "3[03]\\d{3}|900\\d{4}", , , , "30123"],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			WF: [
				,
				[, , "[4-8]\\d{5}", , , , , , , [6]],
				[, , "(?:50|68|72)\\d{4}", , , , "501234"],
				[, , "(?:50|68|72|8[23])\\d{4}", , , , "501234"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"WF",
				681,
				"00",
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "[48]0\\d{4}", , , , "401234"]
			],
			WS: [
				,
				[, , "[2-8]\\d{4,6}", , , , , , , [5, 6, 7]],
				[, , "(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}", , , , "22123", , , [5, 7]],
				[, , "(?:60|7[25-7]\\d)\\d{4}", , , , "601234", , , [6, 7]],
				[, , "800\\d{3}", , , , "800123", , , [6]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"WS",
				685,
				"0",
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(8\\d{2})(\\d{3,4})", "$1 $2", ["8"]],
					[, "(7\\d)(\\d{5})", "$1 $2", ["7"]],
					[, "(\\d{5})", "$1", ["[2-6]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			YE: [
				,
				[, , "[1-7]\\d{6,8}", , , , , , , [7, 8, 9], [6]],
				[
					,
					,
					"(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}",
					,
					,
					,
					"1234567",
					,
					,
					[7, 8]
				],
				[, , "7[0137]\\d{7}", , , , "712345678", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"YE",
				967,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([1-7])(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"],
					[, "(7\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["7[0137]"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			YT: [
				,
				[, , "[268]\\d{8}", , , , , , , [9]],
				[, , "269(?:6[0-4]|50)\\d{4}", , , , "269601234"],
				[, , "639\\d{6}", , , , "639123456"],
				[, , "80\\d{7}", , , , "801234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"YT",
				262,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				,
				,
				[, , "NA", , , , , , , [-1]],
				,
				"269|63",
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ZA: [
				,
				[, , "[1-79]\\d{8}|8\\d{4,8}", , , , , , , [5, 6, 7, 8, 9]],
				[
					,
					,
					"(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
					,
					,
					,
					"101234567",
					,
					,
					[9]
				],
				[
					,
					,
					"(?:6\\d|7[0-46-9])\\d{7}|8(?:[1-4]\\d{1,5}|5\\d{5})\\d{2}",
					,
					,
					,
					"711234567"
				],
				[, , "80\\d{7}", , , , "801234567", , , [9]],
				[, , "86[2-9]\\d{6}|9[0-2]\\d{7}", , , , "862345678", , , [9]],
				[, , "860\\d{6}", , , , "860123456", , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "87\\d{7}", , , , "871234567", , , [9]],
				"ZA",
				27,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "(860)(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
					[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
					[, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
					[
						,
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						["[1-79]|8(?:[0-57]|6[1-9])"],
						"0$1"
					]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "861\\d{6}", , , , "861123456", , , [9]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ZM: [
				,
				[, , "[289]\\d{8}", , , , , , , [9]],
				[, , "21[1-8]\\d{6}", , , , "211234567"],
				[, , "9(?:5[034589]|[67]\\d)\\d{6}", , , , "955123456"],
				[, , "800\\d{6}", , , , "800123456"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"ZM",
				260,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([29]\\d)(\\d{7})", "$1 $2", ["[29]"], "0$1"],
					[, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			ZW: [
				,
				[
					,
					,
					"2(?:[012457-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{8}",
					,
					,
					,
					,
					,
					,
					[5, 6, 7, 8, 9, 10],
					[3, 4]
				],
				[
					,
					,
					"(?:2(?:0(?:4\\d|5\\d{2})|2[278]\\d|48\\d|7(?:[1-7]\\d|[089]\\d{2})|8(?:[2-57-9]|[146]\\d{2})|98)|3(?:08|17|3[78]|7(?:[19]|[56]\\d)|8[37]|98)|5[15][78]|6(?:28\\d{2}|[36]7|75\\d|[69]8|8(?:7\\d|8)))\\d{3}|(?:2(?:1[39]|2[0157]|6[14]|7[35]|84)|329)\\d{7}|(?:1(?:3\\d{2}|9\\d|[4-8])|2(?:0\\d{2}|[569]\\d)|3(?:[26]|[013459]\\d)|5(?:0|5\\d{2}|[689]\\d)|6(?:[39]|[01246]\\d|[78]\\d{2}))\\d{3}|(?:29\\d|39|54)\\d{6}|(?:(?:25|54)83|2582\\d)\\d{3}|(?:4\\d{6,7}|9[2-9]\\d{4,5})",
					,
					,
					,
					"1312345"
				],
				[, , "7[1378]\\d{7}", , , , "711234567", , , [9]],
				[, , "800\\d{7}", , , , "8001234567", , , [10]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"86(?:1[12]|30|44|55|77|8[367]|99)\\d{6}",
					,
					,
					,
					"8686123456",
					,
					,
					[10]
				],
				"ZW",
				263,
				"00",
				"0",
				,
				,
				"0",
				,
				,
				,
				[
					[, "([49])(\\d{3})(\\d{2,4})", "$1 $2 $3", ["4|9[2-9]"], "0$1"],
					[, "(7\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["7"], "0$1"],
					[, "(86\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["86[24]"], "0$1"],
					[
						,
						"([2356]\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"2(?:0[45]|2[278]|[49]8|[78])|3(?:08|17|3[78]|7[1569]|8[37]|98)|5[15][78]|6(?:[29]8|[38]7|6[78]|75|[89]8)"
						],
						"0$1"
					],
					[
						,
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						["2(?:1[39]|2[0157]|6[14]|7[35]|84)|329"],
						"0$1"
					],
					[
						,
						"([1-356]\\d)(\\d{3,5})",
						"$1 $2",
						["1[3-9]|2[0569]|3[0-69]|5[05689]|6[0-46-9]"],
						"0$1"
					],
					[, "([235]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[23]9|54"], "0$1"],
					[
						,
						"([25]\\d{3})(\\d{3,5})",
						"$1 $2",
						["(?:25|54)8", "258[23]|5483"],
						"0$1"
					],
					[, "(8\\d{3})(\\d{6})", "$1 $2", ["86"], "0$1"],
					[, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			800: [
				,
				[, , "\\d{8}", , , , , , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "\\d{8}", , , , "12345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				800,
				,
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			808: [
				,
				[, , "\\d{8}", , , , , , , [8]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "\\d{8}", , , , "12345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				808,
				,
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d{4})(\\d{4})", "$1 $2"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			870: [
				,
				[, , "[35-7]\\d{8}", , , , , , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "(?:[356]\\d|7[6-8])\\d{7}", , , , "301234567"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				870,
				,
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			878: [
				,
				[, , "1\\d{11}", , , , , , , [12]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "10\\d{10}", , , , "101234567890"],
				"001",
				878,
				,
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			881: [
				,
				[, , "[67]\\d{8}", , , , , , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "[67]\\d{8}", , , , "612345678"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				881,
				,
				,
				,
				,
				,
				,
				,
				,
				[[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[67]"]]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			882: [
				,
				[, , "[13]\\d{6,11}", , , , , , , [7, 8, 9, 10, 11, 12]],
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}",
					,
					,
					,
					"3421234",
					,
					,
					[7, 9, 10]
				],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[
					,
					,
					"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|3(?:45|9\\d{3})\\d{7}",
					,
					,
					,
					"390123456789"
				],
				"001",
				882,
				,
				,
				,
				,
				,
				,
				,
				,
				[
					[, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]],
					[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]],
					[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]],
					[, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["348"]],
					[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1"]],
					[, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]],
					[, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["16|39"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "348[57]\\d{7}", , , , "34851234567", , , [11]]
			],
			883: [
				,
				[, , "51\\d{7}(?:\\d{3})?", , , , , , , [9, 12]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})", , , , "510012345"],
				"001",
				883,
				,
				,
				,
				,
				,
				,
				,
				1,
				[
					[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]],
					[, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]],
					[, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]]
				],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]]
			],
			888: [
				,
				[, , "\\d{11}", , , , , , , [11]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				888,
				,
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "\\d{11}", , , , "12345678901"],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			],
			979: [
				,
				[, , "\\d{9}", , , , , , , [9]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "\\d{9}", , , , "123456789"],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				"001",
				979,
				,
				,
				,
				,
				,
				,
				,
				1,
				[[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]],
				,
				[, , "NA", , , , , , , [-1]],
				,
				,
				[, , "NA", , , , , , , [-1]],
				[, , "NA", , , , , , , [-1]],
				1,
				,
				[, , "NA", , , , , , , [-1]]
			]
		}; /*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
	function P() {
		this.a = {};
	}
	P.a = function() {
		return P.c ? P.c : (P.c = new P());
	};
	var za = {
			0: "0",
			1: "1",
			2: "2",
			3: "3",
			4: "4",
			5: "5",
			6: "6",
			7: "7",
			8: "8",
			9: "9",
			"\uff10": "0",
			"\uff11": "1",
			"\uff12": "2",
			"\uff13": "3",
			"\uff14": "4",
			"\uff15": "5",
			"\uff16": "6",
			"\uff17": "7",
			"\uff18": "8",
			"\uff19": "9",
			"\u0660": "0",
			"\u0661": "1",
			"\u0662": "2",
			"\u0663": "3",
			"\u0664": "4",
			"\u0665": "5",
			"\u0666": "6",
			"\u0667": "7",
			"\u0668": "8",
			"\u0669": "9",
			"\u06f0": "0",
			"\u06f1": "1",
			"\u06f2": "2",
			"\u06f3": "3",
			"\u06f4": "4",
			"\u06f5": "5",
			"\u06f6": "6",
			"\u06f7": "7",
			"\u06f8": "8",
			"\u06f9": "9"
		},
		Aa = {
			0: "0",
			1: "1",
			2: "2",
			3: "3",
			4: "4",
			5: "5",
			6: "6",
			7: "7",
			8: "8",
			9: "9",
			"\uff10": "0",
			"\uff11": "1",
			"\uff12": "2",
			"\uff13": "3",
			"\uff14": "4",
			"\uff15": "5",
			"\uff16": "6",
			"\uff17": "7",
			"\uff18": "8",
			"\uff19": "9",
			"\u0660": "0",
			"\u0661": "1",
			"\u0662": "2",
			"\u0663": "3",
			"\u0664": "4",
			"\u0665": "5",
			"\u0666": "6",
			"\u0667": "7",
			"\u0668": "8",
			"\u0669": "9",
			"\u06f0": "0",
			"\u06f1": "1",
			"\u06f2": "2",
			"\u06f3": "3",
			"\u06f4": "4",
			"\u06f5": "5",
			"\u06f6": "6",
			"\u06f7": "7",
			"\u06f8": "8",
			"\u06f9": "9",
			A: "2",
			B: "2",
			C: "2",
			D: "3",
			E: "3",
			F: "3",
			G: "4",
			H: "4",
			I: "4",
			J: "5",
			K: "5",
			L: "5",
			M: "6",
			N: "6",
			O: "6",
			P: "7",
			Q: "7",
			R: "7",
			S: "7",
			T: "8",
			U: "8",
			V: "8",
			W: "9",
			X: "9",
			Y: "9",
			Z: "9"
		},
		Q = RegExp("^[+\uff0b]+"),
		Ba = RegExp("([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])"),
		Ca = RegExp("[+\uff0b0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]"),
		Da = /[\\\/] *x/,
		Ea = RegExp("[^0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9A-Za-z#]+$"),
		Fa = /(?:.*?[A-Za-z]){3}.*/,
		Ga = RegExp(
			"(?:;ext=([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})#?|[- ]+([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,5})#)$",
			"i"
		),
		Ha = RegExp(
			"^[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{2}$|^[+\uff0b]*(?:[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*]*[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]){3,}[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]*(?:;ext=([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})#?|[- ]+([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,5})#)?$",
			"i"
		),
		Ia = /(\$\d)/;
	function Ja(a) {
		var b = a.search(Ca);
		0 <= b
			? ((a = a.substring(b)),
			  (a = a.replace(Ea, "")),
			  (b = a.search(Da)),
			  0 <= b && (a = a.substring(0, b)))
			: (a = "");
		return a;
	}
	function Ka(a) {
		return 2 > a.length ? !1 : R(Ha, a);
	}
	function La(a) {
		return R(Fa, a) ? S(a, Aa) : S(a, za);
	}
	function Ma(a) {
		var b = La(a.toString());
		a.c = "";
		a.a(b);
	}
	function S(a, b) {
		for (var c = new I(), d, e = a.length, f = 0; f < e; ++f)
			(d = a.charAt(f)), (d = b[d.toUpperCase()]), null != d && c.a(d);
		return c.toString();
	}
	function T(a) {
		return null != a && isNaN(a) && a.toUpperCase() in ya;
	}
	function Na(a, b, c) {
		if (0 == A(b, 2) && null != b.a[5]) {
			var d = D(b, 5);
			if (0 < d.length) return d;
		}
		var d = D(b, 1),
			e = U(b);
		if (0 == c) return Oa(d, 0, e, "");
		if (!(d in O)) return e;
		a = V(a, d, W(d));
		b =
			null != b.a[3] && A(b, 3).length
				? 3 == c
					? ";ext=" + A(b, 3)
					: null != a.a[13]
					? A(a, 13) + D(b, 3)
					: " ext. " + D(b, 3)
				: "";
		a: {
			a = (C(a, 20) || []).length && 2 != c ? C(a, 20) || [] : C(a, 19) || [];
			for (var f, g = a.length, h = 0; h < g; ++h) {
				f = a[h];
				var l = ra(f, 3);
				if (!l || !e.search(A(f, 3, l - 1)))
					if (((l = new RegExp(A(f, 1))), R(l, e))) {
						a = f;
						break a;
					}
			}
			a = null;
		}
		a &&
			((g = a),
			(a = D(g, 2)),
			(f = new RegExp(A(g, 1))),
			D(g, 5),
			(g = D(g, 4)),
			(e =
				2 == c && null != g && 0 < g.length
					? e.replace(f, a.replace(Ia, g))
					: e.replace(f, a)),
			3 == c &&
				((e = e.replace(
					RegExp(
						"^[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+"
					),
					""
				)),
				(e = e.replace(
					RegExp(
						"[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+",
						"g"
					),
					"-"
				))));
		return Oa(d, c, e, b);
	}
	function V(a, b, c) {
		return "001" == c ? X(a, "" + b) : X(a, c);
	}
	function U(a) {
		var b = "" + A(a, 2);
		return null != a.a[4] && A(a, 4) ? Array(D(a, 8) + 1).join("0") + b : b;
	}
	function Oa(a, b, c, d) {
		switch (b) {
			case 0:
				return "+" + a + c + d;
			case 1:
				return "+" + a + " " + c + d;
			case 3:
				return "tel:+" + a + "-" + c + d;
			default:
				return c + d;
		}
	}
	function Pa(a, b) {
		switch (b) {
			case 4:
				return A(a, 5);
			case 3:
				return A(a, 4);
			case 1:
				return A(a, 3);
			case 0:
			case 2:
				return A(a, 2);
			case 5:
				return A(a, 6);
			case 6:
				return A(a, 8);
			case 7:
				return A(a, 7);
			case 8:
				return A(a, 21);
			case 9:
				return A(a, 25);
			case 10:
				return A(a, 28);
			default:
				return A(a, 1);
		}
	}
	function Qa(a, b) {
		return Y(a, A(b, 1))
			? Y(a, A(b, 5))
				? 4
				: Y(a, A(b, 4))
				? 3
				: Y(a, A(b, 6))
				? 5
				: Y(a, A(b, 8))
				? 6
				: Y(a, A(b, 7))
				? 7
				: Y(a, A(b, 21))
				? 8
				: Y(a, A(b, 25))
				? 9
				: Y(a, A(b, 28))
				? 10
				: Y(a, A(b, 2))
				? A(b, 18) || Y(a, A(b, 3))
					? 2
					: 0
				: !A(b, 18) && Y(a, A(b, 3))
				? 1
				: -1
			: -1;
	}
	function X(a, b) {
		if (null == b) return null;
		b = b.toUpperCase();
		var c = a.a[b];
		if (!c) {
			c = ya[b];
			if (!c) return null;
			c = new H().c(L.f(), c);
			a.a[b] = c;
		}
		return c;
	}
	function Y(a, b) {
		var c = a.length;
		return 0 < ra(b, 9) && -1 == x(C(b, 9) || [], c) ? !1 : R(D(b, 2), a);
	}
	function Ra(a, b) {
		if (!b) return null;
		var c = D(b, 1);
		if ((c = O[c]))
			if (1 == c.length) c = c[0];
			else
				a: {
					for (var d = U(b), e, f = c.length, g = 0; g < f; g++) {
						e = c[g];
						var h = X(a, e);
						if (null != h.a[23]) {
							if (!d.search(A(h, 23))) {
								c = e;
								break a;
							}
						} else if (-1 != Qa(d, h)) {
							c = e;
							break a;
						}
					}
					c = null;
				}
		else c = null;
		return c;
	}
	function W(a) {
		return (a = O[a]) ? a[0] : "ZZ";
	}
	function Sa(a, b) {
		var c = C(b, 9) || [],
			d = C(b, 10) || [],
			e = a.length;
		if (-1 < x(d, e)) return 0;
		d = c[0];
		return d == e
			? 0
			: d > e
			? 2
			: c[c.length - 1] < e
			? 3
			: -1 < x(c, e, 1)
			? 0
			: 3;
	}
	function Ta(a, b, c, d, e) {
		if (!a.length) return 0;
		a = new I(a);
		var f;
		b && (f = A(b, 11));
		null == f && (f = "NonMatch");
		var g = a.toString();
		if (g.length)
			if (Q.test(g)) (g = g.replace(Q, "")), (a.c = ""), a.a(La(g)), (f = 1);
			else {
				g = new RegExp(f);
				Ma(a);
				f = a.toString();
				if (f.search(g)) f = !1;
				else {
					var g = f.match(g)[0].length,
						h = f.substring(g).match(Ba);
					h && null != h[1] && 0 < h[1].length && "0" == S(h[1], za)
						? (f = !1)
						: ((a.c = ""), a.a(f.substring(g)), (f = !0));
				}
				f = f ? 5 : 20;
			}
		else f = 20;
		d && B(e, 6, f);
		if (20 != f) {
			if (2 >= a.c.length) throw Error("Phone number too short after IDD");
			a: {
				d = a.toString();
				if (d.length && "0" != d.charAt(0))
					for (a = d.length, f = 1; 3 >= f && f <= a; ++f)
						if (((b = parseInt(d.substring(0, f), 10)), b in O)) {
							c.a(d.substring(f));
							c = b;
							break a;
						}
				c = 0;
			}
			if (c) return B(e, 1, c), c;
			throw Error("Invalid country calling code");
		}
		if (
			b &&
			((f = D(b, 10)), (g = "" + f), (h = a.toString()), !h.lastIndexOf(g, 0))
		) {
			var l = new I(h.substring(g.length)),
				g = A(b, 1),
				h = new RegExp(D(g, 2));
			Ua(l, b, null);
			b = l.toString();
			if ((!R(h, a.toString()) && R(h, b)) || 3 == Sa(a.toString(), g))
				return c.a(b), d && B(e, 6, 10), B(e, 1, f), f;
		}
		B(e, 1, 0);
		return 0;
	}
	function Ua(a, b, c) {
		var d = a.toString(),
			e = d.length,
			f = A(b, 15);
		if (e && null != f && f.length) {
			var g = new RegExp("^(?:" + f + ")");
			if ((e = g.exec(d))) {
				var f = new RegExp(D(A(b, 1), 2)),
					h = R(f, d),
					l = e.length - 1;
				b = A(b, 16);
				if (null != b && b.length && null != e[l] && e[l].length) {
					if (((d = d.replace(g, b)), !h || R(f, d)))
						c && 0 < l && c.a(e[1]), a.set(d);
				} else if (!h || R(f, d.substring(e[0].length)))
					c && 0 < l && null != e[l] && c.a(e[1]), a.set(d.substring(e[0].length));
			}
		}
	}
	function Z(a, b, c) {
		if (!T(c) && 0 < b.length && "+" != b.charAt(0))
			throw Error("Invalid country calling code");
		return Va(a, b, c, !0);
	}
	function Va(a, b, c, d) {
		if (null == b)
			throw Error("The string supplied did not seem to be a phone number");
		if (250 < b.length)
			throw Error("The string supplied is too long to be a phone number");
		var e = new I(),
			f = b.indexOf(";phone-context=");
		if (0 < f) {
			var g = f + 15;
			if ("+" == b.charAt(g)) {
				var h = b.indexOf(";", g);
				0 < h ? e.a(b.substring(g, h)) : e.a(b.substring(g));
			}
			g = b.indexOf("tel:");
			e.a(b.substring(0 <= g ? g + 4 : 0, f));
		} else e.a(Ja(b));
		f = e.toString();
		g = f.indexOf(";isub=");
		0 < g && ((e.c = ""), e.a(f.substring(0, g)));
		if (!Ka(e.toString()))
			throw Error("The string supplied did not seem to be a phone number");
		f = e.toString();
		if (!(T(c) || (null != f && 0 < f.length && Q.test(f))))
			throw Error("Invalid country calling code");
		f = new M();
		d && B(f, 5, b);
		a: {
			b = e.toString();
			g = b.search(Ga);
			if (0 <= g && Ka(b.substring(0, g)))
				for (var h = b.match(Ga), l = h.length, q = 1; q < l; ++q)
					if (null != h[q] && 0 < h[q].length) {
						e.c = "";
						e.a(b.substring(0, g));
						b = h[q];
						break a;
					}
			b = "";
		}
		0 < b.length && B(f, 3, b);
		b = X(a, c);
		g = new I();
		h = 0;
		l = e.toString();
		try {
			h = Ta(l, b, g, d, f);
		} catch (z) {
			if ("Invalid country calling code" == z.message && Q.test(l)) {
				if (((l = l.replace(Q, "")), (h = Ta(l, b, g, d, f)), !h)) throw z;
			} else throw z;
		}
		h
			? ((e = W(h)), e != c && (b = V(a, h, e)))
			: (Ma(e),
			  g.a(e.toString()),
			  null != c
					? ((h = D(b, 10)), B(f, 1, h))
					: d && (delete f.a[6], f.c && delete f.c[6]));
		if (2 > g.c.length)
			throw Error("The string supplied is too short to be a phone number");
		b &&
			((a = new I()),
			(c = new I(g.toString())),
			Ua(c, b, a),
			2 != Sa(c.toString(), A(b, 1)) &&
				((g = c), d && 0 < a.toString().length && B(f, 7, a.toString())));
		d = g.toString();
		a = d.length;
		if (2 > a)
			throw Error("The string supplied is too short to be a phone number");
		if (17 < a)
			throw Error("The string supplied is too long to be a phone number");
		if (1 < d.length && "0" == d.charAt(0)) {
			B(f, 4, !0);
			for (a = 1; a < d.length - 1 && "0" == d.charAt(a); ) a++;
			1 != a && B(f, 8, a);
		}
		B(f, 2, parseInt(d, 10));
		return f;
	}
	function R(a, b) {
		var c = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a);
		return c && c[0].length == b.length ? !0 : !1;
	}
	v("intlTelInputUtils", {});
	v("intlTelInputUtils.formatNumber", function(a, b, c) {
		try {
			var d = P.a(),
				e = Z(d, a, b);
			return Na(d, e, "undefined" == typeof c ? 0 : c);
		} catch (f) {
			return a;
		}
	});
	v("intlTelInputUtils.getExampleNumber", function(a, b, c) {
		try {
			var d = P.a(),
				e;
			a: {
				if (T(a)) {
					var f = Pa(X(d, a), c);
					try {
						if (null != f.a[6]) {
							var g = A(f, 6);
							e = Va(d, g, a, !1);
							break a;
						}
					} catch (h) {}
				}
				e = null;
			}
			return Na(d, e, b ? 2 : 1);
		} catch (h) {
			return "";
		}
	});
	v("intlTelInputUtils.getExtension", function(a, b) {
		try {
			return A(Z(P.a(), a, b), 3);
		} catch (c) {
			return "";
		}
	});
	v("intlTelInputUtils.getNumberType", function(a, b) {
		try {
			var c = P.a(),
				d;
			var e = Z(c, a, b),
				f = Ra(c, e),
				g = V(c, D(e, 1), f);
			if (g) {
				var h = U(e);
				d = Qa(h, g);
			} else d = -1;
			return d;
		} catch (l) {
			return -99;
		}
	});
	v("intlTelInputUtils.getValidationError", function(a, b) {
		try {
			var c = P.a(),
				d;
			var e = Z(c, a, b),
				f = U(e),
				g = D(e, 1);
			if (g in O) {
				var h = V(c, g, W(g));
				d = Sa(f, A(h, 1));
			} else d = 1;
			return d;
		} catch (l) {
			return "Invalid country calling code" == l.message
				? 1
				: "The string supplied did not seem to be a phone number" == l.message
				? 4
				: "Phone number too short after IDD" == l.message ||
				  "The string supplied is too short to be a phone number" == l
				? 2
				: "The string supplied is too long to be a phone number" == l.message
				? 3
				: -99;
		}
	});
	v("intlTelInputUtils.isValidNumber", function(a, b) {
		try {
			var c = P.a(),
				d = Z(c, a, b),
				e;
			var f = Ra(c, d),
				g = D(d, 1),
				h = V(c, g, f),
				l;
			if (!(l = !h)) {
				var q;
				if ((q = "001" != f)) {
					var z,
						va = X(c, f);
					if (!va) throw Error("Invalid region code: " + f);
					z = D(va, 10);
					q = g != z;
				}
				l = q;
			}
			if (l) e = !1;
			else {
				var Wa = U(d);
				e = -1 != Qa(Wa, h);
			}
			return e;
		} catch (Xa) {
			return !1;
		}
	});
	v("intlTelInputUtils.numberFormat", {
		E164: 0,
		INTERNATIONAL: 1,
		NATIONAL: 2,
		RFC3966: 3
	});
	v("intlTelInputUtils.numberType", {
		FIXED_LINE: 0,
		MOBILE: 1,
		FIXED_LINE_OR_MOBILE: 2,
		TOLL_FREE: 3,
		PREMIUM_RATE: 4,
		SHARED_COST: 5,
		VOIP: 6,
		PERSONAL_NUMBER: 7,
		PAGER: 8,
		UAN: 9,
		VOICEMAIL: 10,
		UNKNOWN: -1
	});
	v("intlTelInputUtils.validationError", {
		IS_POSSIBLE: 0,
		INVALID_COUNTRY_CODE: 1,
		TOO_SHORT: 2,
		TOO_LONG: 3,
		NOT_A_NUMBER: 4
	});
})();

/**
 * @ngdoc overview
 * @name wildBieneHarvestApp
 * @description
 * # wildBieneHarvestApp
 *
 * Main module of the application.
 */

var env = {};

// Import variables if present (from env.js)
if (window) {
	Object.assign(env, window.__env);
}

angular
	.module('wildBieneHarvestApp', [
		'ngAnimate',
		'ngCookies',
		'ngResource',
		'ngSanitize',
		'ngMessages',
		// 'angucomplete',
		'ui.router',
		'ngMaterial',
		'ngIntlTelInput',
		'md.data.table',
		// 'ngFileUpload',
		'pascalprecht.translate',
		'fixed.table.header',
		'ng-currency'
	])
	.constant('SETTINGS', env)

	.config(function(
		$stateProvider,
		$locationProvider,
		$mdThemingProvider,
		ngIntlTelInputProvider,
		$mdDateLocaleProvider,
		$compileProvider,
		$translateProvider,
		$mdAriaProvider
	) {
		// Globally disables all ARIA warnings.
		$mdAriaProvider.disableWarnings();

		ngIntlTelInputProvider.set({
			defaultCountry: 'ch',
			preferredCountries: ['ch', 'de', 'it', 'fr'],
			formatOnDisplay: true,
			utilsScript: '/utils.js'
		});
		//fix to preserve routing behaviour before version 1.6
		//TODO: update routing and remove this:
		$locationProvider.hashPrefix('');
		//----->

		$translateProvider
			.fallbackLanguage('en')
			.preferredLanguage('en')
			.useSanitizeValueStrategy('escape')
			.useStaticFilesLoader({
				prefix: '/translations/',
				suffix: '/translations.json',
				$http: { skipAuthorization: true }
			});

		$compileProvider.aHrefSanitizationWhitelist(
			/^\s*(https?|local|data|chrome-extension|blob):/
		);

		$mdDateLocaleProvider.formatDate = function(date) {
			var m = moment(date);
			return m.isValid() ? m.utcOffset(2).format('DD-MM-YYYY') : '';
		};

		$mdDateLocaleProvider.parseDate = function(dateString) {
			var d = moment(dateString, 'DD-MM-YYYY', true)
				.utcOffset(2)
				.format();

			var m = moment(d);
			return m.isValid() ? m.toDate() : new Date(NaN);
		};
		$mdThemingProvider.definePalette('amazingPaletteName', {
			'50': 'E4783C',
			'100': 'E4783C',
			'200': 'E4783C',
			'300': 'E4783C',
			'400': 'E4783C',
			'500': '8f8a5c',
			'600': '8f8a5c',
			'700': '8f8a5c',
			'800': '8f8a5c',
			'900': '8f8a5c',
			A100: 'E4783C',
			A200: 'ff5252',
			A400: 'ff1744',
			A700: 'd50000',
			contrastDefaultColor: 'light', // whether, by default, text (contrast)
			// on this palette should be dark or light
			contrastDarkColors: [
				'50',
				'100', //hues which contrast should be 'dark' by default
				'200',
				'A100'
			],
			contrastLightColors: undefined // could also specify this if default was 'dark'
		});
		$mdThemingProvider
			.theme('default')
			.primaryPalette('amazingPaletteName')
			.warnPalette('orange');

		$stateProvider
			.state('home', {
				url: '/dashboard',
				templateUrl: 'views/dashboard.html',
				controller: 'DashboardCtrl'
			})
			.state('main', {
				url: '',
				templateUrl: 'views/dashboard.html',
				controller: 'DashboardCtrl'
			})
			.state('root', {
				url: '/',
				templateUrl: 'views/dashboard.html',
				controller: 'DashboardCtrl'
			})
			.state('station1', {
				url: '/beehome/account',
				templateUrl: 'views/customer-search.html',
				controller: 'CustomerSearchCtrl as stageOne',
				resolve: {
					availableProducts: function(AllProducts) {
						return AllProducts();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})
			.state('/harvestSettings', {
				url: '/harvest/settings',
				templateUrl: 'views/harvestsettings.html',
				controller: 'HarvestsettingsCtrl',
				resolve: {
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					}
				}
			})
			.state('harvestSettingsAuth', {
				url: '/harvest/settings/:org/:auth',
				templateUrl: 'views/harvestsettings.html',
				controller: 'HarvestsettingsCtrl',
				resolve: {
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					}
				}
			})
			.state('dashboard', {
				url: '/dashboard',
				templateUrl: 'views/dashboard.html',
				controller: 'DashboardCtrl'
			})
			.state('farmer', {
				url: '/farmer/account',
				templateUrl: 'views/customer-search.html',

				controller: 'CustomerSearchCtrl as farmerManagement',
				resolve: {
					availableProducts: function(AllProducts) {
						return AllProducts();
					}
				}
			})

			.state('contract', {
				url: '/farmer/account/:fid?house_code',
				templateUrl: 'views/farmer-customer.html',
				controller: 'ContractCtrl',
				params: {
					fid: null,
					action: null,
					orderID: null
				},
				resolve: {
					orders: function(OrderLoader, $stateParams) {
						return OrderLoader($stateParams.fid);
					},
					subscriptions: function(SubscriptionLoader, $stateParams) {
						return SubscriptionLoader($stateParams.fid);
					},
					client: function(ClientFactory, $stateParams) {
						return ClientFactory.getClient($stateParams.fid);
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})
			.state('salesOrders', {
				url: '/farmer/salesOrders',
				templateUrl: 'views/sales-orders.html',
				controller: 'SalesOrdersCtrl',
				resolve: {
					season: function(Session) {
						return Session.getFarmerSeason();
					}
				}
			})
			.state('deliveryManagement', {
				url: '/farmer/deliveries',
				templateUrl: 'views/deliverymanagement.html',
				controller: 'DeliverymanagementCtrl',
				resolve: {
					monthsRequests: function(monthlyRequests) {
						return monthlyRequests();
					}
				}
			})
			.state('managementSearch', {
				url: '/management/search',
				templateUrl: 'views/boxmanagement.html',
				controller: 'BoxmanagementCtrl',
				resolve: {
					season: function(Session) {
						return Session.getManagementSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				},
				params: {
					page: null
				}
			})
			.state('managementCheckin', {
				url: '/management/checkin',
				templateUrl: 'views/box-checkin.html',
				controller: 'BoxcheckinCtrl',
				params: {
					boxes: null
				}
			})
			.state('managementCheckout', {
				url: '/management/checkout',
				templateUrl: 'views/box-checkout.html',
				controller: 'BoxcheckoutCtrl',
				resolve: {
					xferReasons: function(XferReasonsLoader) {
						return XferReasonsLoader();
					}
				},
				params: {
					boxes: null
				}
			})
			.state('managementQRCode', {
				url: '/management/qrcode',
				template: '<qrcode-generator></qrcode-generator>'
			})
			.state('managementCreate', {
				url: '/management/box/create',
				templateUrl: 'views/createboxes.html',
				controller: 'CreateboxesCtrl',
				controllerAs: 'createBoxes'
			})
			.state('managementStatistics', {
				url: '/management/statistics',
				templateUrl: 'views/management-statistics.html',
				controller: 'ManagementstatisticsCtrl'
			})
			.state('managementLogs', {
				url: '/management/logs',
				templateUrl: 'views/management-logs.html',
				controller: 'ManagementlogsCtrl',
				resolve: {
					users: function(userService) {
						return userService.all();
					}
				}
			})
			.state('managementBox', {
				url: '/management/search/box/:bid?season',
				templateUrl: 'views/box.html',
				controller: 'BoxCtrl',
				resolve: {
					box: function(BoxLoader, $stateParams) {
						return BoxLoader($stateParams.bid, $stateParams.season);
					}
				}
			})
			.state('managementFridge', {
				url: '/management/search/fridge/:fid',
				templateUrl: 'views/fridge.html',
				controller: 'FridgeCtrl',
				resolve: {
					fridge: function(FridgeLoader, $stateParams) {
						return FridgeLoader($stateParams.fid);
					},
					season: function(Session) {
						return Session.getManagementSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('farmerCheckOut', {
				url: '/farmer/checkout',
				templateUrl: 'views/farmercheckout.html',
				controller: 'FarmercheckoutCtrl'
			})
			.state('farmerCheckIn', {
				url: '/farmer/checkin',
				templateUrl: 'views/farmercheckin.html',
				controller: 'FarmercheckinCtrl'
			})
			.state('/farmerSettings', {
				url: '/farmer/settings',
				templateUrl: 'views/farmersettings.html',
				controller: 'FarmersettingsCtrl',
				resolve: {
					auth: function() {
						return null;
					},
					org: function() {
						return null;
					}
				}
			})

			.state('farmerSettingsAuth', {
				url: '/farmer/settings/:org/:auth',
				templateUrl: 'views/farmersettings.html',
				controller: 'FarmersettingsCtrl',
				resolve: {
					org: function($stateParams) {
						return $stateParams.org;
					},
					auth: function($stateParams) {
						return $stateParams.auth;
					}
				}
			})

			.state('beehome-orders', {
				url: '/beehome/orders',
				templateUrl: 'views/beehome-orders.html',
				controller: 'BeehomeOrdersStateCtrl',
				resolve: {
					organisations: function(OrganisationFactory) {
						return OrganisationFactory.getMap();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('beehome-orders-new', {
				url: '/beehome/orders/new',
				templateUrl: 'views/beehome-order.html',
				controller: 'BeehomeOrderCtrl',
				resolve: {
					organisations: function(OrganisationFactory) {
						return OrganisationFactory.getMap();
					},
					order: function() {},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('beehome-orders-edit', {
				url: '/beehome/orders/:orderId',
				templateUrl: 'views/beehome-order.html',
				controller: 'BeehomeOrderCtrl',
				resolve: {
					organisations: function(OrganisationFactory) {
						return OrganisationFactory.getMap();
					},
					order: function(startpopSettings, $stateParams) {
						return startpopSettings.getOrder($stateParams.orderId);
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('beehome-vouchers', {
				url: '/beehome/vouchers',
				templateUrl: 'views/beehome-vouchers.html',
				controller: 'BeehomeVoucherCtrl as vouchers',
				resolve: {
					organisations: function(OrganisationFactory) {
						return OrganisationFactory.getMap();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})
			.state('admin-shopify-orders', {
				url: '/admin/shopify/orders',
				template: '<shopify-orders></shopify-orders>'
			})

			.state('history', {
				url: '/history/:object/:id',
				template: '<div history-directive></div>'
			})

			.state('client', {
				url: '/beehome/account/:cid?house_code',
				templateUrl: 'views/client.html',
				controller: 'ClientCtrl as client',
				resolve: {
					availableProducts: function(AllProducts) {
						return AllProducts();
					},
					client: function(ClientFactory, $stateParams) {
						return ClientFactory.getClient($stateParams.cid);
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('product-link', {
				url: '/harvest/product/:h_id',
				templateUrl: 'views/product-link.html',
				controller: 'ProductLinkCtrl as productLink',
				resolve: {
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('dispatch', {
				url: '/dispatch',
				templateUrl: 'views/dispatch.html',
				controller: 'DispatchCtrl'
			})

			.state('logout', {
				url: '/logout',
				templateUrl: 'views/about.html',
				controller: 'LogoutCtrl as logout'
			})
			.state('orders', {
				url: '/orders',
				templateUrl: 'views/orders.html',
				controller: 'OrdersCtrl'
			})
			.state('station2', {
				url: '/harvest/tubes',
				templateUrl: 'views/beehome-tubes.html',
				controller: 'StationCtrl as station',
				resolve: {
					insectTypes: function(AllSpecies) {
						return AllSpecies();
					},
					parasites: function(Allparasites) {
						return Allparasites();
					},
					currentStation: function() {
						return 2;
					},
					houseCode: function() {
						return null;
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('station2WithHouseCode', {
				url: '/harvest/tubes/:h_cd',
				templateUrl: 'views/beehome-tubes.html',
				controller: 'StationCtrl as station',
				resolve: {
					insectTypes: function(AllSpecies) {
						return AllSpecies();
					},
					parasites: function(Allparasites) {
						return Allparasites();
					},
					currentStation: function() {
						return 2;
					},
					houseCode: function($stateParams) {
						return $stateParams.h_cd;
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('station2WithHouseCodeAndAutoUpdate', {
				url: '/harvest/tubes/:h_cd/:autoUpdate',
				templateUrl: 'views/beehome-tubes.html',
				controller: 'StationCtrl as station',
				resolve: {
					insectTypes: function(AllSpecies) {
						return AllSpecies();
					},
					parasites: function(Allparasites) {
						return Allparasites();
					},
					currentStation: function() {
						return 2;
					},
					houseCode: function($stateParams) {
						return $stateParams.h_cd;
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('station3', {
				url: '/harvest/cocoons',
				templateUrl: 'views/station3.html',
				controller: 'StationCtrl as station',
				resolve: {
					insectTypes: function(AllSpecies) {
						return AllSpecies();
					},
					parasites: function(Allparasites) {
						return Allparasites();
					},
					currentStation: function() {
						return 3;
					},
					houseCode: function() {
						return null;
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('station3WithHouseCode', {
				url: '/harvest/cocoons/:h_cd',
				templateUrl: 'views/station3.html',
				controller: 'StationCtrl as station',
				resolve: {
					insectTypes: function(AllSpecies) {
						return AllSpecies();
					},
					parasites: function(Allparasites) {
						return Allparasites();
					},
					currentStation: function() {
						return 3;
					},
					houseCode: function($stateParams) {
						return $stateParams.h_cd;
					},
					season: function(harvestSettings) {
						return harvestSettings.getSeason();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('harvestCheck', {
				url: '/harvest/check',
				templateUrl: 'views/harvest-check.html',
				controller: 'HarvestCheckCtrl',
				resolve: {
					products: function(AllProducts) {
						return AllProducts();
					},
					users: function(userService) {
						return userService.all();
					}
				}
			})

			.state('adminOrganisations', {
				url: '/admin/organisations',
				template: '<organisation-panel></organisation-panel>',
				controller: 'AdminCtrlOrganisations as adminOrganisations'
			})

			.state({
				name: 'adminOrganisationSettings',
				url: '/admin/organisations/:orgId/settings',
				component: 'organisationSettingsTabs'
			})

			.state('adminProducts', {
				url: '/admin/products',
				templateUrl: 'views/admin-products.html',
				controller: 'AdminCtrlProducts as adminProducts'
			})
			.state('adminPacking', {
				url: '/admin/packaging',
				templateUrl: 'views/admin-packaging.html',
				controller: 'AdminCtrlPackaging as adminPackaging'
			});
	});

angular.element(document).ready(function() {
	// eslint-disable-next-line no-undef
	var keycloak = new Keycloak(env.keycloak);

	// On load, redirect to keycloak for login
	keycloak.init({ onLoad: 'login-required', promiseType: 'native' }).then(
		function() {
			angular.module('wildBieneHarvestApp').factory('Auth', function() {
				return keycloak;
			});

			// when user has successfully logged in, manually boostrap angular app
			angular.bootstrap(document, ['wildBieneHarvestApp']);
		},
		function() {
			console.log('Login failed.');
			window.location.reload();
		}
	);
});

var e = document.createElement('div');
e.id = 'fmlHzFJMkWDr';
e.style.display = 'none';
document.body.appendChild(e);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the wildBieneHarvestApp
 */
angular.module('wildBieneHarvestApp').controller('AboutCtrl', function() {
	this.awesomeThings = ['HTML5 Boilerplate', 'AngularJS', 'Karma'];
});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:CustomerSearchCtrl
 * @description
 * # CustomerSearchCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('CustomerSearchCtrl', function(
		$scope,
		$mdDialog,
		$timeout,
		$location,
		Session,
		AddressFactory,
		NotifyUser,
		clientSearchFactory
	) {
		Session.pageTitle = 'Account Search';
		$scope.stream = Session.stream;
		$scope.query = clientSearchFactory.query;
		$scope.getBillingAddress = getBillingAddress;
		$scope.searchInputChanged = searchInputChanged;
		$scope.submit = submit;
		$scope.open = open;
		$scope.matches = [];
		$scope.lastSearchSubmitted = 0;
		$scope.lastSearchReturned = 0;

		// Cache term and promise of the last performed search
		var last = {
			term: undefined,
			search: undefined
		};

		function getBillingAddress(addresses) {
			return AddressFactory.getBillingAddress(addresses);
		}

		function init() {
			if ($location.path().indexOf('farmer') > 0) {
				Session.setStream('farmer');
			} else {
				Session.setStream('beehome');
			}
			$scope.limitOptions = [20, 50, 100, 200];
			$scope.searchTerm = $location.search().q;
			$scope.searchInputChanged($scope.searchTerm, true);
		}

		$scope.getBillingContact = function(customerContacts, billingContact) {
			if (!billingContact && customerContacts) {
				for (var i = 0; i < customerContacts.length; i++) {
					if (customerContacts[i].tags.indexOf('BILLING') > -1) {
						billingContact = customerContacts[i].email;
					}
				}
			}
			return billingContact;
		};

		/**
		 * Update search as user is typing, but wait if its a document search.
		 * E.g. if user types OR-1 it we should wait until search is fully typed and submitted.
		 */
		function searchInputChanged(term, init) {
			// Only keep the last query in the browser history
			if (init) {
				$location.search({ q: term });
			} else {
				$location.search({ q: term }).replace();
			}

			// Clear results
			if (!term || term.length < 3) {
				return clear();
			}

			// Use cache
			if (term === last.term) {
				return last.search;
			}

			var searchId = ++$scope.lastSearchSubmitted;
			var search = clientSearchFactory.search(term, true).then(function(data) {
				return populate(searchId, data);
			});

			// Keep cache of last query for submit
			last = {
				term: term,
				search: search
			};

			// Show progress indicator
			$scope.promise = search;
			if ($scope.totalMatches === 0) {
				clear();
			}
			return search;
		}

		function clear() {
			$scope.matches = [];
			$scope.totalMatches = undefined;
		}

		/**
		 * It can happen that search results do not come back sequentially,
		 * because short search terms tend to have longer response times.
		 * If an earlier search comes back after a later search has already been processed,
		 * then ignore the earlier search result.
		 */
		function populate(searchId, data) {
			if (searchId > $scope.lastSearchReturned && data) {
				$scope.lastSearchReturned = searchId;
				$scope.matches = data.items;
				$scope.totalMatches = data.total_count;
			}
			return data;
		}

		function submit(term) {
			return searchInputChanged(term).then(function(data) {
				if (data.items.length === 1) {
					open(data.items[0]);
				}
			});
		}

		function open(item) {
			clientSearchFactory.openAccountPage(item);
		}

		$scope.addCustomer = function(ev) {
			$mdDialog
				.show({
					controller: 'AccountSummaryModalCtrl',
					controllerAs: 'ctrl',
					templateUrl: 'views/account-modal.html',
					targetEvent: ev,
					parent: angular.element(document.body),
					locals: {
						client: null
					},
					resolve: {
						organisations: function(AllOrganisations) {
							return AllOrganisations();
						},
						certifications: function(certificationFactory) {
							return certificationFactory.getCertifications();
						}
					},
					clickOutsideToClose: true
				})
				.then(
					function(data) {
						if (data) {
							$location.path('/' + Session.stream + '/account/' + data.client.id);
						}
					},
					function(error) {
						if (error) {
							NotifyUser('An error has occurred');
							console.warn(error);
						}
					}
				);
		};

		init();
	});

'use strict';

angular.module('wildBieneHarvestApp').factory('houseService', houseService);

function houseService($http, $location, $q, AlertUser, Session, SETTINGS) {
	var service = {
		getHouses: getHouses,
		resolveHouse: resolveHouse,
		getUrl: getUrl
	};

	return service;

	////////////////

	/**
	 * Get the list of houses with the given filter critera
	 */
	function getHouses(params) {
		return $http({
			url: SETTINGS.beehomeAPIBasePath + 'houses',
			method: 'GET',
			params: params
		}).then(
			response => response.data,
			response => AlertUser('Error ' + response.data.status, response.data.detail)
		);
	}

	/**
	 * Given an object with a house_id, fetch and add the house information.
	 */
	function resolveHouse(item) {
		if (!item.house_id) {
			return $q.when();
		}
		return $http
			.get(SETTINGS.beehomeAPIBasePath + 'houses/' + item.house_id)
			.then(
				response => (item.house = response.data),
				response => AlertUser('Error ' + response.data.status, response.data.detail)
			);
	}

	/**
	 * Return the link to the customer page
	 */
	function getUrl(house) {
		if (!house) {
			return;
		}
		var url = house.client_id
			? '#/beehome/account/' + house.client_id + '?house_code=' + house.code
			: '#/harvest/product/' + house.code;
		return check(url, 'BeeHarvest Customer');
	}

	/**
	 * If the appropriate access right is present and the current location is not the link location
	 * then return the link to the customer page
	 */
	function check(link, accessRight) {
		if (Session.rights.indexOf(accessRight) > -1) {
			return link === '#' + $location.url() ? null : link;
		}
	}
}

// 'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.Session
 * @description
 * # Session
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('Session', [
	'$rootScope',
	'$http',
	'SETTINGS',
	'$q',
	'farmerSettings',
	'harvestSettings',
	'cultures',
	'currencies',
	'AllPhrases',
	'contracts',
	'AllFarmerProductTypes',
	'allOrderPositionTypes',
	'noteReferences',
	'$translate',
	'Auth',
	function(
		$rootScope,
		$http,
		SETTINGS,
		$q,
		farmerSettings,
		harvestSettings,
		cultures,
		currencies,
		AllPhrases,
		contracts,
		AllFarmerProductTypes,
		allOrderPositionTypes,
		noteReferences,
		$translate,
		Auth
	) {
		var observerCallbacks = [];
		var dailyTargetCallbacks = [];
		this.farmerSeason;
		this.managementSeason;
		this.organisation = '';
		this.organisationID = 0;
		this.matches = [];
		this.stream = '';
		this.dailyCount = 0;
		this.rights = [];
		this.farmerSettings = farmerSettings;
		this.pageTitle = '';
		this.titleArea = 'NONE';
		this.activeProductID = '';
		this.cultureTypes = [];
		this.noteReferences = {};
		this.currencies = [];
		this.defaultClient = { id: '', name: '' };
		this.allPhrases = {};
		this.allContractTypes = {};
		this.allProducts = [];
		this.allPositions = {};
		this.leadTime = 0;
		this.allCountries = [];
		this.deliveryDaysAvailable = [];
		this.organisationVATs = [];
		this.paymentOptions = {};
		this.language = 'en';

		// eslint-disable-next-line no-unused-vars
		var that = this;

		this.setStream = function(route, pageTitle, titleArea) {
			if (this.stream != route) {
				this.matches = [];
				this.keywordString = '';
				this.keyCodeString = '';
				this.stream = route;
				if (this.stream == 'beehome') {
					this.harvestSeason = this.getHarvestSeason();
				}
				if (this.stream == 'farmer') {
					this.getDefaultClient();
					this.getAllFarmerProductTypes();
					this.farmerSeason = this.getFarmerSeason();
					this.getDefaultClient();
					this.getAllFarmerProductTypes();
				}
			}
			if (pageTitle) {
				this.pageTitle = pageTitle;
			}
			this.titleArea = titleArea || 'NONE';
			notifyObservers();
		};

		this.create = function() {
			var token = Auth.tokenParsed;
			this.loggedIn = true;
			this.fullName = token.name;
			this.organisationID = token.beeadmin.organisation.id;
			this.rights = token.resource_access.beeadmin.roles || [];
			this.language = token.locale || 'en';
			$translate.use(this.language);
			notifyObservers();
		};

		this.setFarmerSeason = function(season) {
			this.farmerSeason = season;
			notifyObservers();
		};
		this.setManagementSeason = function(season) {
			this.managementSeason = season;
			notifyObservers();
		};
		this.setHarvestSeason = function(season) {
			harvestSettings.setSeason(season);
			this.harvestSeason = season;

			notifyObservers();
		};

		this.destroy = function() {
			this.fullName = null;
			notifyObservers();
			Auth.logout({ redirectUri: location.origin });
		};
		this.getFarmerSeason = function() {
			var that = this;
			farmerSettings.getSeason().then(function(result) {
				that.farmerSeason = result;
			});

			return that.farmersSeason;
		};
		this.getManagementSeason = function() {
			var delay = $q.defer();

			var that = this;
			$http
				.get(SETTINGS.APIBasePath + '/settings/management-season/')
				.then(function(result) {
					that.managementSeason = result.data.season;
					delay.resolve(result.data.season);
				});
			// return that.managementSeason;
			return delay.promise;
		};
		this.getHarvestSeason = function() {
			var self = this;
			harvestSettings.getSeason().then(function(season) {
				self.harvestSeason = season;
				notifyObservers();
			});
			return self.harvestSeason;
		};
		this.getDefaultClient = function() {
			var that = this;
			farmerSettings.getDefaultClient().then(function(result) {
				that.defaultClient.id = result[0];
				that.defaultClient.name = result[1];
			});

			return that.defaultClient;
		};
		this.getSendHarvestMails = function(orgID) {
			var defer = $q.defer();
			var that = this;
			$http
				.get(SETTINGS.APIBasePath + 'harvest-mails/' + orgID)
				.then(function(result) {
					that.sendHarvestMails = result.data.sendMails === '1';
					defer.resolve(that.sendHarvestMails);
				});
			return defer.promise;
		};
		this.getName = function() {
			return this.fullName;
		};
		this.getLanguage = function() {
			if (this.language == 'undefined') {
				this.language = 'en';
			}
			return this.language;
		};
		this.setLanguage = function(language) {
			$translate.use(language);
		};
		this.registerObserverCallback = function(callback) {
			observerCallbacks.push(callback);
		};

		this.getOrganisationID = function() {
			return this.organisationID;
		};

		var notifyObservers = function() {
			angular.forEach(observerCallbacks, function(callback) {
				callback();
			});
		};
		this.registerDailyCountCallback = function(callback) {
			dailyTargetCallbacks.push(callback);
		};
		this.getDailyCount = function() {
			var that = this;
			$http.get(SETTINGS.APIBasePath + 'daily-count').then(function(result) {
				that.dailyCount = result.data.dailyCount;

				angular.forEach(dailyTargetCallbacks, function(callback) {
					callback();
				});
			});
		};

		this.getCultures = function() {
			var that = this;
			cultures.query(function(data) {
				for (var i = 0; i < data.length; i++) {
					that.cultureTypes[data[i].ID - 1] = data[i];
				}
			});
			return that.cultureTypes;
		};

		this.getNoteReferences = function() {
			var delay = $q.defer();
			var that = this;
			noteReferences.query(function(data) {
				that.noteReferences = data[0];
				delay.resolve(that.noteReferences);
			});
			return delay.promise;
		};

		this.getCurrencies = function() {
			var that = this;
			currencies.query(function(data) {
				that.currencies = data;
			});
		};

		this.getAllPhrases = function() {
			var that = this;
			AllPhrases().then(function(phrases) {
				that.allPhrases = phrases;
			});
		};

		this.resetAllPhrases = function() {
			var that = this;

			$rootScope.allPhraseList = null;
			AllPhrases().then(function(phrases) {
				that.allPhrases = phrases;
			});
		};

		this.getAllContractTypes = function() {
			var that = this;
			contracts.query(function(data) {
				that.allContractTypes = data;
			});
		};

		this.getAllFarmerProductTypes = function() {
			var that = this;
			AllFarmerProductTypes().then(function(data) {
				that.allProducts = data;
			});
		};

		this.getAllOrderPositionTypes = function() {
			var that = this;
			allOrderPositionTypes().then(function(result) {
				that.allPositions = result;
			});
		};

		this.getAllCountries = function() {
			var that = this;
			$http.get(SETTINGS.APIBasePath + 'countries').then(function(response) {
				that.allCountries = response.data;
			});
		};

		this.getOrganisationVATs = function() {
			var that = this;
			that.organisationID = that.getOrganisationID();
			if (that.organisationID > 0) {
				$http
					.get(SETTINGS.APIBasePath + '/organisation/' + that.organisationID)
					.then(function(response) {
						that.organisationVATs = response.data.rates;
						that.taxInclusive = response.data.taxInclusive;
						that.organisationCountry = response.data.country;
					});
			}
		};

		this.getPaymentOptions = function() {
			var that = this;
			$http.get(SETTINGS.APIBasePath + '/payment/options').then(function(result) {
				that.paymentOptions.types = result.data.types;
				that.paymentOptions.terms = result.data.terms;
			});
			return that.paymentOptions;
		};
		this.create();
		this.getHarvestSeason();
		this.getSendHarvestMails(this.organisationID);
		this.getManagementSeason();
		this.getFarmerSeason();
		this.getCultures();
		this.getNoteReferences();
		this.getCurrencies();

		this.getAllPhrases();
		this.getAllContractTypes();

		this.getAllOrderPositionTypes();
		this.getAllCountries();
		this.getOrganisationVATs();
		this.getPaymentOptions();
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.Datatables-Ajax
 * @description
 * # Datatables Ajax
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('DatatablesAjax', function(SETTINGS, Auth) {
		this.scope = null;
		this.infoText = 'Showing _START_ - _END_ of _TOTAL_ entries';

		this.setDataTables = function(
			scope,
			tableId,
			url,
			model,
			columns,
			order,
			clickable
		) {
			order = order || [];
			clickable = clickable || false;
			this.scope = scope;
			this.setExtTable(
				model,
				this.getTable(tableId).DataTable(
					this.setOptions(
						url,
						model,
						this.getModelRow(model),
						clickable,
						columns,
						order
					)
				)
			);
			if (clickable === true) {
				this.scope.setClickableRow(model);
			}
		};

		this.setAjax = function(url, method) {
			method = method || 'GET';
			return {
				url: SETTINGS.APIBasePath + url,
				method: method,
				headers: { Authorization: 'Bearer ' + Auth.token }
			};
		};

		this.setExtTable = function(model, table) {
			this.scope.$exttable[model] = table;
		};

		this.setOptions = function(url, model, rowId, clickable, columns, order) {
			order = order || [];
			var options = {};
			var that = this;

			options.destroy = true;
			options.processing = true;
			options.serverSide = true;
			options.ajax = this.setAjax(url);
			options.searching = true;
			options.autoWidth = false;
			options.responsive = true;
			options.lengthChange = true;
			options.lengthMenu = [
				[10, 20, 50, 100],
				[10, 20, 50, 100]
			];
			options.pageLength = 20;
			options.select = {
				style: 'multi'
			};
			options.columns = columns;
			options.createdRow = function(row, data) {
				if (clickable) {
					$(row).addClass('cursor-pointer');
					$(row)
						.find('td:eq(0)')
						.addClass('ignore-parent-click');
				}
				$(row).attr('id', data[rowId]);
			};
			options.columnDefs = [
				{
					targets: 0,
					checkboxes: {
						selectRow: true,
						selectCallback: function() {
							that.scope.$apply(function() {
								that.scope.$exttableSelected[model] = that.scope.$exttable[model]
									.column(0)
									.checkboxes.selected();
								if (typeof that.scope.selectCallback === 'function') {
									that.scope.selectCallback();
								}
							});
						}
					}
				},
				{
					data: null,
					defaultContent: '-',
					targets: '_all'
				}
			];
			options.language = {
				info: that.infoText
			};
			if (order.length) {
				options.order = order;
			}
			return options;
		};

		this.getTable = function(tableId) {
			return $('#' + tableId);
		};

		this.getModelRow = function(model) {
			return this.scope.rowIDs[model];
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:badmClient
 * @description;
 * # client-directive
 */
angular
	.module('wildBieneHarvestApp')
	.directive('accountSummary', function(
		$mdDialog,
		ClientFactory,
		ContactFactory,
		AddressFactory,
		productUtils,
		Session,
		buttonLabelService,
		ConfirmUser,
		NotifyUser,
		$location
	) {
		return {
			restict: 'EA',
			scope: { client: '=', clientProducts: '=', selectedTabIndex: '=' },
			templateUrl: 'views/account-summary-directive.html',
			link: function(scope) {
				// services

				function init() {
					scope.billingContact = {};
					scope.billingContact = ContactFactory.getBillingContact(
						scope.client.contacts
					);
					updateBillingAddress(scope.client.addresses);
					AddressFactory.registerListener(updateBillingAddress);
					scope.buttonLabelService = buttonLabelService;
				}

				function updateBillingAddress(addresses) {
					scope.client.addresses = addresses;
					scope.billingAddress = AddressFactory.getBillingAddress(
						scope.client.addresses
					);
				}
				/**
				 * Check if there is some cultures
				 */
				scope.checkIfThereIsSomeCultures = function() {
					return scope.customer.cultures.length > 0;
				};

				scope.goToAddressTab = function() {
					scope.selectedTabIndex = 3;
				};

				/**
				 * Delete customer
				 */
				scope.deleteClient = function() {
					var message = '';

					if (scope.client.contacts.length > 0) {
						message += '<p>The following contacts will be removed: <br>';
						angular.forEach(scope.client.contacts, function(element) {
							message +=
								'<strong>' +
								element.id +
								'</strong> ' +
								element.first_name +
								' ' +
								element.last_name +
								'<br>';
						});
					}

					if (scope.clientProducts && scope.clientProducts.length > 0) {
						message += '<p>The following houses will be released: <br>';
						angular.forEach(scope.clientProducts, function(element) {
							message += '<strong>' + element.code + '</strong><p>';
						});
					}

					message += '<p>' + 'Are you sure?';
					ConfirmUser('Deleting client ' + scope.client.id, message, function() {
						// Explicitly reassign product so that it shows up in product history
						angular.forEach(scope.clientProducts, function(product) {
							productUtils.reassignProduct(product.code, null);
						});

						ClientFactory.erase(scope.client.id).then(function() {
							NotifyUser('The client has been deleted');
							$location.path(Session.stream + '/account');
						});
					});
				};

				/**
				 * Toggle client editable
				 */
				scope.edit = function() {
					$mdDialog
						.show({
							controller: 'AccountSummaryModalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/account-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false,
							locals: {
								client: scope.client
							},
							resolve: {
								organisations: function(AllOrganisations) {
									return AllOrganisations();
								},
								certifications: function(certificationFactory) {
									return certificationFactory.getCertifications();
								}
							}
						})
						.then(
							function() {
								ClientFactory.getClient(scope.client.id).then(function(client) {
									scope.client = client;
									init();
								});
							},
							function(error) {
								if (error) {
									NotifyUser('An error has occurred');
									console.warn(error);
								}
							}
						);
				};
				init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:trackingNumber
 * @description replace tracking number with external link
 */
angular.module('wildBieneHarvestApp').directive('addressPicker', addressPicker);

function addressPicker($mdDialog, AddressFactory, ClientFactory) {
	return {
		restrict: 'E',
		require: { model: 'ngModel' },
		scope: {
			form: '=',
			client: '=',
			countries: '=',
			billing: '=',
			expanded: '='
		},
		templateUrl: 'views/address-picker.html',
		// eslint-disable-next-line no-unused-vars
		link: function postLink(scope, element, attrs, ctrl) {
			scope.name = attrs.name;
			scope.required = attrs.required;

			scope.onChange = onChange;
			scope.addAddress = addAddress;
			scope.editAddress = editAddress;
			scope.deleteAddress = deleteAddress;
			scope.filterSelected = filterSelected;

			ctrl.model.$render = render;

			function render() {
				scope.addressId = ctrl.model.$viewValue;
			}

			function onChange() {
				if (scope.addressId) {
					ctrl.model.$setValidity('required', true);
				} else {
					ctrl.model.$setValidity('required', false);
				}
				ctrl.model.$setViewValue(scope.addressId);
			}

			function addAddress() {
				var newAddress = scope.billing ? { tags: ['BILLING'] } : null;
				editAddress(newAddress);
			}

			function editAddress(address) {
				$mdDialog
					.show({
						controller: 'AddressmodalCtrl',
						controllerAs: 'ctrl',
						templateUrl: 'views/address-modal.html',
						parent: angular.element(document.body),
						clickOutsideToClose: true,
						fullscreen: false,
						locals: {
							address: address,
							client: scope.client,
							countryCode: scope.countries ? scope.countries[0] : null
						},
						resolve: {
							countries: function(AllCountries) {
								return AllCountries();
							}
						}
					})
					.then(function(response) {
						scope.addressId = response.data.id;
						onChange();
						ClientFactory.getClient(scope.client.id).then(reloadAddresses);
					});
			}

			function deleteAddress(address) {
				AddressFactory.erase(scope.client.id, address.id).then(reloadAddresses);
			}

			function reloadAddresses() {
				ClientFactory.getClient(scope.client.id).then(function(client) {
					scope.client.addresses = client.addresses;
				});
			}

			function filterSelected(address) {
				return (!scope.addressId && !address.id) || address.id === scope.addressId;
			}
		}
	};
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:clientTabs
 * @description;
 * # clientTabs
 */
angular.module('wildBieneHarvestApp').directive('clientTabs', function() {
	return {
		restict: 'EA',
		scope: { client: '=client', clientProducts: '=clientProducts' },
		templateUrl: 'views/client-tabs.html',
		link: function(scope) {
			scope.selectedTabIndex = 0;
		}
	};
});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:contactForm
 * @description
 * # contactForm
 */
angular
	.module('wildBieneHarvestApp')
	.directive('houseLink', function(houseService) {
		return {
			restrict: 'E',
			template:
				'<span ng-if="!house.code">{{houseId}}</span>' +
				'<a ng-if="house.code" class="general-link" ng-href="{{getUrl(house)}}">' +
				'{{house.code || houseId}}' +
				'</a>',
			scope: {
				house: '=ngModel',
				houseId: '='
			},

			link: function postLink(scope) {
				scope.getUrl = houseService.getUrl;
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ClientCtrl
 * @description
 * # ClientCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ClientCtrl', function(
		$scope,
		$stateParams,
		$mdDialog,
		SETTINGS,
		availableProducts,
		client,
		Session,
		season,
		AddressFactory
	) {
		$scope.season = season;
		$scope.barcodeLink = SETTINGS.barcodePath;
		$scope.clientID = $stateParams.cid;
		$scope.clientInfo = client;
		$scope.newProduct = {};
		$scope.productTypes = availableProducts;
		$scope.defaultAddress = AddressFactory.getBillingAddress(
			$scope.clientInfo.addresses
		);
		$scope.selectedProducts = [];
		Session.setStream('beehome', 'Account ' + client.id, 'CLIENT_SEARCH');
		if (!$scope.season) {
			var currentSeason = new Date().getFullYear();
			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						// angular.element($confirmButton).addClass('md-raised md-warn');
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('Harvest Season Not Set!')
				.textContent(
					'Your harvest season is currently not set. Would you like to set it or use the default season, ' +
						currentSeason +
						'?'
				)
				.ariaLabel('Harvest Season')
				.ok('Set Harvest Season')
				.cancel('Use Default Season');
			$mdDialog.show(confirm).then(
				function() {
					location.href = '#/harvest/settings';
				},
				function() {
					$scope.season = currentSeason;
					// Session.harvestSeason = currentSeason;
					// $scope.season = Session.harvestSeason;
					// $scope.updateClient();
				}
			);
		}
	});

'use strict';

/**
 * @ngdoc filter
 * @name wildBieneHarvestApp.filter:cleanData
 * @function
 * @description
 * # cleanData
 * Filter in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.filter('cleanData', function() {
		return function(input) {
			if (typeof input == 'string') {
				input = decodeURIComponent(escape(input));
				return input;
			}
			for (var property in input) {
				if (Object.prototype.hasOwnProperty.call(input, property)) {
					if (typeof input[property] == 'string') {
						input[property] = decodeURIComponent(escape(input[property]));
					}
				}
			}
			return input;
		};
	})
	.filter('range', function() {
		return function(input, total) {
			total = parseInt(total);

			for (var i = 0; i < total; i++) {
				input.push(i);
			}

			return input;
		};
	})
	.filter('uniqueArraybyId', function() {
		return function(collection, keyname) {
			var output = [],
				keys = [];

			angular.forEach(collection, function(item) {
				var key = item[keyname];
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					output.push(item);
				}
			});
			return output;
		};
	})
	.filter('titleCase', function() {
		return function(input) {
			input = input || '';
			return input.replace(/\w\S*/g, function(txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		};
	})
	.filter('parseDate', function() {
		return function(input) {
			return new Date(input);
		};
	})
	.filter('autoCompleteSearch', function($q, $timeout) {
		function lowerCaseSearchText(searchArray, field) {
			for (var i = 0; i < searchArray.length; i++) {
				searchArray[i].value = searchArray[i][field].toLowerCase();
			}
			return searchArray;
		}

		function createFilterFor(query) {
			var lowercaseQuery = query.toLowerCase();

			return function filterFn(searchArray) {
				return (
					searchArray.value.indexOf(lowercaseQuery) === 0 ||
					searchArray.value.indexOf(' ' + lowercaseQuery) > -1
				);
			};
		}

		return function(arrayItems, query, field) {
			var results = query
				? lowerCaseSearchText(arrayItems, field).filter(createFilterFor(query))
				: arrayItems;
			var deferred = $q.defer();
			$timeout(
				function() {
					deferred.resolve(results);
				},
				Math.random() * 1000,
				false
			);
			return deferred.promise;
		};
	});

'use strict';

/**
 * @ngdoc filter
 * @name wildBieneHarvestApp.filter:setphrasevalues
 * @function
 * @description
 * # setphrasevalues
 * Filter in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').filter('delimiter', function() {
	return function(num) {
		if (num === 0) {
			return 0;
		}

		if (num === undefined || num === null) {
			return;
		}
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
	};
});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.customer
 * @description
 * # customer
 * Factory in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('Customer', [
	'$resource',
	'SETTINGS',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'client/:id', {
			id: '@id'
		});
	}
]);

angular
	.module('wildBieneHarvestApp')
	.service('noteReferences', function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'note/references/');
	})
	.service('customerProducts', function($q, $http, SETTINGS) {
		this.fetchCustomerProductHouses = function(clientID, houseCode = null) {
			var delay = $q.defer();
			$http
				.get(SETTINGS.beehomeAPIBasePath + 'houses', {
					params: {
						client_id: clientID,
						code: houseCode
					}
				})
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};

		this.fetchCustomerProducts = function(tableSetup, clientID) {
			var delay = $q.defer();
			this.fetchCustomerProductHouses(clientID).then(res => {
				const houses = res.items;
				$http
					.post(SETTINGS.APIBasePath + 'filtered_client_products', {
						data: tableSetup,
						clientID: clientID
					})
					.then(function(response) {
						response.data.list.map(item => {
							var house = houses.find(
								house => Number(item.clientProductID) === house.id
							);
							if (house) {
								item.beehomeName = house.name;
							}
						});
						delay.resolve(response.data);
					});
			});
			return delay.promise;
		};

		this.fetchSingleProduct = function(tableSetup) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'filtered_client_products', {
					data: tableSetup
				})
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
	})

	.factory('Order', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'orders/:id', {
				id: '@id'
			});
		}
	])
	.factory('OrderLoader', [
		'Order',
		'orderService',
		'$q',
		'$state',
		function(Order, orderService, $q, $state) {
			return function(fid) {
				var delay = $q.defer();

				Order.get(
					{
						id: fid
					},
					function(orders) {
						angular.forEach(orders.orders, function(order) {
							orderService.calculateAdditionalProperties(order);
						});
						delay.resolve(orders.orders);
					},
					function() {
						delay.reject('unable to load Farmer ' + $state.params.fid);
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('Subscription', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'subscriptions/:id', {
				id: '@id'
			});
		}
	])
	.factory('SubscriptionLoader', [
		'Subscription',
		'$q',
		'$state',
		function(Subscription, $q, $state) {
			return function(fid) {
				var delay = $q.defer();

				Subscription.get(
					{
						id: fid
					},
					function(subscriptions) {
						delay.resolve(subscriptions.data);
					},
					function() {
						delay.reject('unable to load Subscription ' + $state.params.fid);
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('Note', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'notes/:id', {
				id: '@id'
			});
		}
	])

	.factory('CustomerLoader', [
		'Customer',
		'$q',
		'$state',
		'OrderLoader',
		'$http',
		'SETTINGS',
		'SubscriptionLoader',
		function(
			Customer,
			$q,
			$state,
			OrderLoader,
			$http,
			SETTINGS,
			SubscriptionLoader
		) {
			return function(cid) {
				var delay = $q.defer();
				if (typeof cid === 'undefined') {
					cid = $state.params.cid;
				}

				Customer.get(
					{
						id: cid
					},

					function(customer) {
						for (var i = customer.history.length - 1; i >= 0; i--) {
							customer.history[i].CRE_AT = new Date(customer.history[i].CRE_AT);
						}
						SubscriptionLoader(cid).then(function(subscriptions) {
							customer.subscriptions = subscriptions;
							OrderLoader(cid).then(function(orders) {
								customer.orders = orders;
								$http
									.get(SETTINGS.APIBasePath + 'certifications')
									.then(function(result) {
										var certifications = result.data;

										for (var i = 0; i < certifications.length; i++) {
											if (certifications[i].ID == customer.CERTIFICATION_ID) {
												customer.certification = certifications[i];
											}
										}
									});

								$http
									.get(
										SETTINGS.APIBasePath + '/sales-products/farmer/' + customer.OWNER_ID
									)
									.then(function(result) {
										customer.allProducts = result.data;
										delay.resolve(customer);
									});
							});
						});
					},
					function() {
						delay.reject('unable to load customer ' + $state.params.cid);
					}
				);
				return delay.promise;
			};
		}
	]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.productTypes
 * @description
 * # productTypes
 * Service in the wildBieneHarvestApp.
 */

const product_regexs = [
	{
		name: 'BeeHome Observer',
		regex: /^[0-9]{2}[A-Z][0-9]{4}$|^[0-9]{2}[MO][0-9]{6}$|^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	},
	{
		name: 'BeeHome Classic',
		regex: /^[0-9]{2}[A-Z][0-9]{4}$|^[0-9]{2}[MO][0-9]{6}$|^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	},
	{
		name: 'BeeHome Diversity',
		regex: /^[0-9]{2}[A-Z][0-9]{4}$|^[0-9]{2}[MO][0-9]{6}$|^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	},
	{
		name: 'BeeHome Pro',
		regex: /^[P][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	},
	{
		name: 'BeeHome One',
		regex: /^[0-9]{2}[A-Z][0-9]{4}$|^[0-9]{2}[MO][0-9]{6}$|^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	},
	{
		name: 'BeeHome Unknown',
		regex: /^[0-9]{2}[A-Z][0-9]{4}$|^[0-9]{2}[MO][0-9]{6}$|^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$/
	}
];
angular.module('wildBieneHarvestApp').factory('products', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return $resource(SETTINGS.APIBasePath + 'products/');
	}
]);

angular.module('wildBieneHarvestApp').factory('AllProducts', [
	'products',
	'$q',
	function(products, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			products.query(
				function(prods) {
					let unknownRegex = product_regexs.find(type => {
						return type.name == 'BeeHome Unknown';
					}).regex;
					delay.resolve(
						prods.map(product => {
							let productType = product_regexs.find(type => {
								return type.name == product.PROD_NAME;
							});
							product.regex =
								productType && productType.regex ? productType.regex : unknownRegex;
							return product;
						})
					);
				},
				function() {
					delay.reject('unable to fetch product Types');
				}
			);
			return delay.promise;
		};
	}
]);
angular.module('wildBieneHarvestApp').factory('categories', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return $resource(SETTINGS.APIBasePath + 'categories/');
	}
]);

angular.module('wildBieneHarvestApp').factory('AllCategories', [
	'categories',
	'$q',
	function(categories, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			categories.query(
				function(cats) {
					delay.resolve(cats);
				},
				function() {
					delay.reject('unable to fetch product categories');
				}
			);
			return delay.promise;
		};
	}
]);
angular.module('wildBieneHarvestApp').factory('productUtils', [
	'$q',
	'$http',
	'SETTINGS',
	function($q, $http, SETTINGS) {
		return {
			reassignProduct: function(houseCode, clientID) {
				var delay = $q.defer();
				$http
					.post(SETTINGS.APIBasePath + 'product/reassign', {
						data: {
							code: houseCode,
							user_id: clientID
						}
					})
					.then(function(data) {
						if (data.data.error) {
							alert('error');
						} else {
							delay.resolve(data.data);
						}
					});

				return delay.promise;
			}
		};
	}
]);
angular.module('wildBieneHarvestApp').factory('productCategories', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return $resource(SETTINGS.APIBasePath + 'product/categories');
	}
]);

angular.module('wildBieneHarvestApp').factory('AllProductCategories', [
	'productCategories',
	'$q',
	function(productCategories, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			productCategories.query(
				function(cats) {
					delay.resolve(cats);
				},
				function() {
					delay.reject('unable to fetch product Categories');
				}
			);
			return delay.promise;
		};
	}
]);

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:Station2Ctrl
 * @description
 * # Station2Ctrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('StationCtrl', function(
		$q,
		$scope,
		$http,
		$location,
		SETTINGS,
		$mdDialog,
		$timeout,
		ClientFactory,
		insectTypes,
		parasites,
		population,
		currentStation,
		houseCode,
		Session,
		printerService,
		AlertUser,
		$translate,
		season,
		users,
		$stateParams,
		NotifyUser,
		settingsFactory
	) {
		$scope.season = season;
		$scope.users = users;
		$scope.currentStation = currentStation;
		$scope.editable = Session.rights.indexOf('Edit Tubes') > -1;
		$scope.calculateCocoons = calculateCocoons;

		$scope.autoUpdateData = autoUpdateData;
		Session.setStream('beehome');

		$scope.species = insectTypes;
		$scope.allParasites = parasites;
		if (Session.rights.indexOf('Cocoon') > -1) {
			$scope.linkCocoon = true;
		}
		if (Session.rights.indexOf('Tube') > -1) {
			$scope.linkTube = true;
		}
		if (Session.rights.indexOf('BeeHarvest Customer') > -1) {
			$scope.linkCustomer = true;
		}

		$scope.insectToAdd = {};
		$scope.saveStatus = {};

		$scope.showSearch = true;
		$scope.showSource = false;
		$scope.popClass = 'flex-70';
		$scope.searchClass = 'col-sm-12 col-md-10 width-transition';
		$scope.barcodeLink = SETTINGS.barcodePath;

		Session.keyCodeString = houseCode;

		$scope.steps = {
			customer: true,
			tube: true,
			cocoon: true
		};
		$scope.updateLifeCycleRatio = updateLifeCycleRatio;

		$scope.getConfirmDialog = function(
			title,
			textContent,
			ariaLabel,
			okButtonString,
			cancelButtonString
		) {
			return $mdDialog
				.confirm()
				.title(title)
				.textContent(textContent)
				.ariaLabel(ariaLabel)
				.ok(okButtonString)
				.cancel(cancelButtonString);
		};
		let savedRatios = {
			SINGLE: 5.4,
			MIXED: 4.1,
			MULTI: 3.4
		};

		function fetchUpdateBeecareSatuses() {
			var sendData = $scope.activeProduct;
			sendData.season = $scope.season;
			sendData.trackTypeID = 1;
			return $http
				.post(SETTINGS.APIBasePath + 'product/getTicket', { data: sendData })
				.then(function(data) {
					var ticketData = data['data']['result'][0];
					if (ticketData) {
						if (!$scope.activeOrder) $scope.activeOrder = {};
						$scope.activeProduct.order = {};
						if (ticketData.ORDER_ID !== null) {
							return $http
								.get(SETTINGS.beehomeAPIBasePath + 'orders/' + ticketData.ORDER_ID)
								.then(response => {
									$scope.activeProduct.order = response.data;
									populateActiveProduct(ticketData);
								});
						} else {
							populateActiveProduct(ticketData);
						}
					}
				});
		}

		const populateActiveProduct = ticketData => {
			$scope.activeProduct.BEECARE_STEP1_COMPLETE =
				ticketData.BEECARE_STEP1_COMPLETE;
			$scope.activeProduct.BEECARE_STEP1_UPD_AT = ticketData.BEECARE_STEP1_UPD_AT;
			$scope.activeProduct.BEECARE_STEP1_UPD_BY = ticketData.BEECARE_STEP1_UPD_BY;
			$scope.activeProduct.BEECARE_STEP2_COMPLETE =
				ticketData.BEECARE_STEP2_COMPLETE;
			$scope.activeProduct.BEECARE_STEP2_UPD_AT = ticketData.BEECARE_STEP2_UPD_AT;
			$scope.activeProduct.BEECARE_STEP2_UPD_BY = ticketData.BEECARE_STEP2_UPD_BY;
			$scope.activeProduct.BEECARE_STEP3_COMPLETE =
				ticketData.BEECARE_STEP3_COMPLETE;
			$scope.activeProduct.BEECARE_STEP3_UPD_AT = ticketData.BEECARE_STEP3_UPD_AT;
			$scope.activeProduct.BEECARE_STEP3_UPD_BY = ticketData.BEECARE_STEP3_UPD_BY;
			$scope.activeProduct.BEECARE_STEP4_COMPLETE =
				ticketData.BEECARE_STEP4_COMPLETE;
			$scope.activeProduct.BEECARE_STEP4_UPD_AT = ticketData.BEECARE_STEP4_UPD_AT;
			$scope.activeProduct.BEECARE_STEP4_UPD_BY = ticketData.BEECARE_STEP4_UPD_BY;
			$scope.activeProduct.invoicedAt = ticketData.INVOICED_AT;
			$scope.activeProduct.SNAPSHOT_FN = ticketData.SNAPSHOT_FN;
			$scope.activeProduct.CONSIGNMENT_NR = ticketData.CONSIGNMENT_NR;
			$scope.activeProduct.activeHistoryID = ticketData.ID;
			$scope.activeProduct.ORDER_ID = ticketData.ORDER_ID;
			$scope.activeProduct.IS_PAID = ticketData.IS_PAID;
			$scope.activeProduct.TRX_DATE = ticketData.TRX_DATE;
			$scope.ratio = ticketData.TUBE_RATIO ? ticketData.TUBE_RATIO : 'SINGLE';
			//TODO: fetch default values
			$scope.ratioValue = ticketData.TUBE_RATIO_VALUE
				? ticketData.TUBE_RATIO_VALUE
				: savedRatios.SINGLE;
			$scope.tubePopulation = $scope.population.find(population => {
				return population.insectID == 1;
			});
			$scope.osmiaTubes = $scope.tubePopulation
				? $scope.tubePopulation.quantity
				: -1;

			if (ticketData[$scope.beecare_name] === '1') {
				$scope.saveStatus = $scope.defaultSpeciesStatus;
			}
		};
		//the main reset and init function:
		function refresh() {
			$scope.population = [];
			$scope.trayPopulation = [];
			$scope.cocoons = [];

			//ensure that other species is the last in the list.
			for (var i = 0; i < $scope.species.length; i++) {
				if (parseInt($scope.species[i].ID) === 10) {
					$scope.species.push($scope.species.splice(i, 1)[0]);
				}
			}
			for (var x = 0; x < $scope.species.length; x++) {
				if (
					[1, 20, 21].indexOf(Number($scope.species[x].ID)) !== -1 &&
					Number($scope.season) > 2019
				) {
					$scope.cocoons.push({
						insect: $scope.species[x].SPECIES,
						latin_name: $scope.species[x].SC_NAME,
						filename:
							'tubes_' +
							$scope.species[x].SC_NAME.replace(/\W/g, '').toLowerCase() +
							'.png',
						description: $scope.species[x].DESCRIPTION,
						quantity: 0,
						insectID: $scope.species[x].ID
					});
				}
				$scope.population.push({
					insect: $scope.species[x].SPECIES,
					latin_name: $scope.species[x].SC_NAME,
					filename:
						'tubes_' +
						$scope.species[x].SC_NAME.replace(/\W/g, '').toLowerCase() +
						'.png',
					description: $scope.species[x].DESCRIPTION,
					quantity: 0,
					weight: 0,
					insectID: $scope.species[x].ID
				});

				$scope.trayPopulation.push({
					insect: $scope.species[x].SPECIES,
					latin_name: $scope.species[x].SC_NAME,
					filename:
						'tubes_' +
						$scope.species[x].SC_NAME.replace(/\W/g, '').toLowerCase() +
						'.png',
					description: $scope.species[x].DESCRIPTION,
					quantity: 0,
					weight: 0,
					insectID: $scope.species[x].ID
				});
				if (
					($scope.species[x].PROCESS_CD === 'C' ||
						$scope.species[x].PROCESS_CD === 'B') &&
					Number($scope.season) < 2020
				) {
					$scope.cocoons.push({
						insect: $scope.species[x].SPECIES,
						latin_name: $scope.species[x].SC_NAME,
						filename:
							'cocoons_' +
							$scope.species[x].SC_NAME.replace(/\W/g, '').toLowerCase() +
							'.png',
						description: $scope.species[x].DESCRIPTION,
						quantity: 0,
						weight: 0,
						insectID: $scope.species[x].ID
					});
				}
			}

			$scope.houseParasites = [];
			$scope.parasites = [];
			for (var z = 0; z < $scope.allParasites.length; z++) {
				if (
					$scope.allParasites[z].PROCESS_CD == 'T' ||
					$scope.allParasites[z].PROCESS_CD == 'B'
				) {
					$scope.parasites.push({
						insect: $scope.allParasites[z].SPECIES,
						latin_name: $scope.allParasites[z].SC_NAME,
						filename:
							'parasites_' +
							$scope.allParasites[z].SC_NAME.replace(/\W/g, '').toLowerCase() +
							'.png',
						description: $scope.allParasites[z].DESCRIPTION,
						quantity: 0,
						weight: 0,
						insectID: $scope.allParasites[z].ID
					});
				}
				if (
					$scope.allParasites[z].PROCESS_CD === 'C' ||
					$scope.allParasites[z].PROCESS_CD === 'B'
				) {
					$scope.houseParasites.push({
						insect: $scope.allParasites[z].SPECIES,
						latin_name: $scope.allParasites[z].SC_NAME,
						filename:
							'parasites_' +
							$scope.allParasites[z].SC_NAME.replace(/\W/g, '').toLowerCase() +
							'.png',
						description: $scope.allParasites[z].DESCRIPTION,
						quantity: 0,
						weight: 0,
						insectID: $scope.allParasites[z].ID
					});
				}
			}

			switch (currentStation) {
				case 2:
					$translate('tubes.title').then(function(translation) {
						Session.pageTitle = translation;
					});

					$scope.beecare_name = 'BEECARE_STEP2_COMPLETE';
					$scope.defaultSpeciesStatus = {
						tube: 'saved',
						tray: 'saved',
						parasites: 'saved'
					};
					$scope.currentPath = 'harvest/tubes/';
					break;
				case 3:
					$translate('cocoons.title').then(function(translation) {
						Session.pageTitle = translation;
					});
					$scope.beecare_name = 'BEECARE_STEP3_COMPLETE';
					$scope.defaultSpeciesStatus = {
						cocoons: 'saved',
						cocoonParasites: 'saved'
					};
					$scope.currentPath = 'harvest/cocoons/';
					break;
				default:
					$scope.beecare_name = '';
					$scope.defaultSpeciesStatus = {};
					$scope.currentPath = 'beehome/account/';
					break;
			}
		}
		$scope.printQRCode = function() {
			$scope.$root.showLoader = true;
			printerService('qrCode', $scope.activeProduct.HOUSE_CD).then(function() {
				$scope.$root.showLoader = false;
			});
		};

		$scope.openDetails = function() {
			$scope.showSearch = true;
		};

		$scope.updateInsects = function(population, location) {
			for (var i = 0; i < population.length; i++) {
				var insectIdToCheck = population[i].insectID;
				population[i].quantity = Number(population[i].quantity);
				population[i].weight = Number(population[i].weight);
				var updated = false;
				for (var j = 0; j < location.length; j++) {
					if (insectIdToCheck === location[j].insectID) {
						location[j].quantity = population[i].quantity;
						location[j].weight = population[i].weight;
						updated = true;
					}
				}
				if (!updated) {
					location.push(population[i]);
				}
			}
		};

		$scope.changePath = function(path) {
			$location.path(path);
		};

		function displayMessage(title, msg) {
			AlertUser(title, msg);
		}

		function autoUpdateData(activeCode) {
			var parasitesStatus = angular.copy($scope.saveStatus['parasites']);
			lookupCode(activeCode).then(function() {
				if (
					$scope.activeProduct.PROD_CD.indexOf('_OB_') === -1 &&
					$scope.activeProduct.PROD_CD.indexOf('_DV_') === -1
				) {
					fetchUpdateBeecareSatuses().then(setProductComplete);
				} else {
					if (parasitesStatus == 'saved') {
						setProductComplete();
					}
				}
			});
		}

		function lookupCode(activeCode) {
			let defer = $q.defer();
			refresh();
			$scope.productError = null;
			$scope.saveStatus = {};
			$scope.showPanel = {
				ratio: true,
				tube: true,
				tray: true,
				parasites: true,
				cocoons: true,
				cocoonParasites: true
			};
			$scope.activeCode = activeCode;
			//get client information by product code
			$http.get(SETTINGS.APIBasePath + 'product/client/' + activeCode).then(
				function(data) {
					$scope.loadingProducts = true;
					$scope.$root.showLoader = true;
					$http
						.get(
							SETTINGS.APIBasePath + 'population/' + $scope.season + '/' + activeCode
						)
						.then(
							function(populationData) {
								$scope.osmiaTubes = populationData.data.houseInsects[0]
									? populationData.data.houseInsects[0].quantity
									: 0;
								var populationInfo = populationData.data;
								$scope.populationData = getPopulationData();
								$scope.imageUrl = populationInfo.recognisedImage;
								for (var i = 0; i < populationInfo.houseParasites.length; i++) {
									if (populationInfo.houseParasites[i].insect === 'Other parasite') {
										populationInfo.houseParasites.splice(i, 1);
									}
								}
								if (populationInfo.houseInsects.length > 0) {
									$scope.updateInsects(populationInfo.houseInsects, $scope.population);
								}
								if (populationInfo.trayInsects.length > 0) {
									$scope.updateInsects(
										populationInfo.trayInsects,
										$scope.trayPopulation
									);
								}
								if (populationInfo.trayParasites.length > 0) {
									$scope.updateInsects(populationInfo.trayParasites, $scope.parasites);
								}
								if (populationInfo.cocoons.length > 0) {
									$scope.updateInsects(populationInfo.cocoons, $scope.cocoons);
								}
								if (populationInfo.houseParasites.length > 0) {
									$scope.updateInsects(
										populationInfo.houseParasites,
										$scope.houseParasites
									);
								}
								$scope.populationNotes = populationInfo.notes;
							},
							function() {
								displayMessage('Error', 'An error has occured');
							}
						)
						.finally(function() {
							$scope.loadingProducts = false;
							$scope.$root.showLoader = false;
							defer.resolve();
						});

					$scope.showSearch = false;
					if (data.data[0]) {
						$scope.activeProduct = data.data[0];
						switch ($scope.activeProduct.PROD_NAME) {
							case 'BeeHome Observer':
								$scope.tubeLimit = 140;
								break;
							case 'BeeHome Classic':
								$scope.tubeLimit = 140;
								break;
							case 'BeeFarmer':
								$scope.tubeLimit = 1000;
								break;
							default:
								$scope.tubeLimit = 10000;
								break;
						}

						$scope.cocoonLimit = $scope.tubeLimit * 12;
						if ($scope.activeProduct.CLIENT_ID) {
							ClientFactory.getClient($scope.activeProduct.CLIENT_ID).then(function(
								client
							) {
								$scope.customer = client;
								$scope.customer.activeCode = $scope.activeCode;

								if ($scope.customer.OWNER_ID) {
									setOrganisationSettings($scope.customer.OWNER_ID);
								} else {
									setOrganisationSettings($scope.activeProduct.OWNER_ID);
								}

								if ($scope.customer.products) {
									for (var i = $scope.customer.products.length - 1; i >= 0; i--) {
										$scope.customer.products[i].dateCreated = new Date(
											$scope.customer.products[i].dateCreated
										);
										if ($scope.customer.products[i].dateModified) {
											$scope.customer.products[i].dateModified = new Date(
												$scope.customer.products[i].dateModified
											);
										} else {
											$scope.customer.products[i].dateModified =
												$scope.customer.products[i].dateCreated;
										}
										if ($scope.customer.products[i].code === $scope.activeCode) {
											$scope.activeProduct.modifiedBy =
												$scope.customer.products[i].modifiedBy;
											$scope.activeProduct.dateModified =
												$scope.customer.products[i].dateModified;
										}
									}
								}
								$scope.checkSeason();
								fetchUpdateBeecareSatuses();
							});

							$scope.harvestStatusLink =
								'/beehome/account/' + $scope.activeProduct.CLIENT_ID;
						} else {
							$scope.harvestStatusLink =
								'/harvest/product/' + $scope.activeProduct.houseCode;
						}

						$scope.popClass = 'col-sm-11 width-transition';
						$scope.searchClass = 'col-md-1 width-transition';
						$scope.openDetails();
					} else {
						$scope.productError = 'Code: ' + activeCode + ' is not found.';
						$timeout(function() {
							$('#product-code-search').select();
						}, 10);
					}
				},
				function() {
					$scope.productError = 'Code: ' + activeCode + ' is not found.';
				}
			);
			return defer.promise;
		}

		$scope.openPreview = function(image_url, image_title) {
			$mdDialog.show({
				controller: 'ImagemodalCtrl',
				image_url: image_url,
				image_title: image_title,
				templateUrl: 'views/image-modal.html',
				clickOutsideToClose: true
			});
		};

		$scope.toggleView = function(panelView) {
			return !panelView;
		};
		function getBeecareSettings(orgID) {
			settingsFactory.getBeecareSettings(orgID).then(settings => {
				savedRatios.SINGLE = settings.single_year_ratio;
				savedRatios.MIXED = settings.mixed_ratio;
				savedRatios.MULTI = settings.multi_year_ratio;
				$scope.ratioValue = savedRatios[$scope.ratio];
			});
		}
		$scope.checkSeason = function() {
			var testDate = new Date();
			if ($scope.season.toString() !== testDate.getFullYear().toString()) {
				var confirm = $mdDialog
					.confirm({
						onComplete: function afterShowAnimation() {
							var $dialog = angular.element(document.querySelector('md-dialog'));
							var $actionsSection = $dialog.find('md-dialog-actions');
							var $cancelButton = $actionsSection.children()[0];
							// eslint-disable-next-line no-unused-vars
							var $confirmButton = $actionsSection.children()[1];
							angular.element($cancelButton).addClass('md-warn');
						}
					})
					.title('Season Alert')
					.textContent(
						'You will be saving to season ' +
							$scope.season +
							', which is not the current one. Are you sure you want to continue?'
					)
					.ariaLabel('Confirm Continue')
					.ok('Yes')
					.cancel('No');
				$mdDialog.show(confirm).then(
					function() {},
					function() {
						if (Session.rights.indexOf('BeeHarvest Customer') > -1) {
							$location.path($scope.harvestStatusLink);
						} else {
							$location.path('/dashboard');
						}
					}
				);
			}
		};

		function getPopulationData() {
			return {
				productCode: $scope.activeProduct.HOUSE_CD,
				houseType: $scope.activeProduct.PROD_ID,
				houseCode: $scope.activeProduct.houseCode,
				notes: $scope.populationNotes,
				season: $scope.season,
				trackTypeID: 1
			};
		}
		function updateLifeCycleRatio() {
			let defer = $q.defer();
			let data = getPopulationData();
			$scope.ratioValue = savedRatios[$scope.ratio];
			data.ratio = $scope.ratio;

			$http
				.post(SETTINGS.APIBasePath + 'tube/ratio', data)
				.then(data => {
					if (data.error) {
						AlertUser('Something went wrong');
					}

					$mdDialog.hide();
					NotifyUser('Kokonmenge wurde angepasst.');
				})
				.finally(() => {
					defer.resolve();
				});
			return defer.promise;
		}
		function updateCocoonsFromTubes() {
			var popArray = getPopulationData();
			// insectID 1 is the combined (legacy) Osmia entry, 20/21 are the
			// separated cornuta/bicornis entries.
			var cocoonInsectIDs = [1, 20, 21];
			var updated = false;
			cocoonInsectIDs.forEach(insectID => {
				let cocoonPopulation = $scope.cocoons.find(cocoon => {
					return cocoon.insectID == insectID;
				});
				let tubePopulation = $scope.population.find(population => {
					return population.insectID == insectID;
				});
				//Do nothing if there are no tubes or population records are not pressent
				//or if the calculated value has already been set.
				if (!cocoonPopulation || !tubePopulation || !tubePopulation.quantity) {
					return;
				}
				let calculatedCocoons = Math.round(
					tubePopulation.quantity * $scope.ratioValue
				);
				cocoonPopulation.quantity = calculatedCocoons;
				updated = true;
			});
			if (!updated) {
				return $q.resolve();
			}
			popArray['cocoons'] = $scope.cocoons;

			$scope.populations = new population(popArray);
			return savePopulation();
		}
		async function calculateCocoons() {
			updateLifeCycleRatio().finally(() => {
				updateCocoonsFromTubes().finally(() => {
					setProductComplete(3).then(() => {
						location.href = '#/harvest/cocoons/' + $scope.activeProduct.HOUSE_CD;
					});
				});
			});
		}

		function savePopulation() {
			let defer = $q.defer();
			$scope.populations
				.$save()
				.then(function() {
					// Update the daily count displayed in the navbar
					Session.getDailyCount();
				})
				.finally(() => {
					fetchUpdateBeecareSatuses().finally(defer.resolve());
				});
			return defer.promise;
		}
		function continueSaving(saveFrom, callback) {
			if (saveFrom === null) {
				saveFrom = 'button';
			}
			if (
				$scope.activeProduct.PROD_CD.indexOf('_OB_') === -1 &&
				$scope.activeProduct.PROD_CD.indexOf('_DV_') === -1
			) {
				$scope.trayPopulation = [];
				$scope.parasites = [];
			}
			var popArray = getPopulationData();

			switch (saveFrom) {
				case 'tube':
					popArray['housePopulation'] = $scope.population;
					break;
				case 'tray':
					popArray['trayPopulation'] = $scope.trayPopulation;
					break;
				case 'parasites':
					popArray['parasites'] = $scope.parasites;
					break;
				case 'cocoonParasites':
					popArray['houseParasites'] = $scope.houseParasites;
					break;
				case 'cocoons':
					popArray['cocoons'] = $scope.cocoons;
					break;
				default:
					$scope.cocoons = setNumberFromWeight($scope.cocoons);
					popArray['housePopulation'] = $scope.population;
					popArray['trayPopulation'] = $scope.trayPopulation;
					popArray['parasites'] = $scope.parasites;
					popArray['houseParasites'] = $scope.houseParasites;
					popArray['cocoons'] = $scope.cocoons;
					popArray['ratio'] = $scope.ratio;
					break;
			}

			$scope.populations = new population(popArray);
			savePopulation();
			callback();
		}
		$scope.ratio = 'SINGLE';
		$scope.getClass = function(checkArray, panelName) {
			if ($scope.loadingProducts === true) {
				return '';
			}
			var className =
				$scope.saveStatus[panelName] == 'saved' ||
				$scope.saveStatus[panelName] == 'saving'
					? 'harvest-panel-saved'
					: 'harvest-panel-default';
			for (var i = 0; i < checkArray.length; i++) {
				if (!panelName) {
					if (checkArray[i]['quantity'] > 0) {
						$scope.saveStatus[panelName] = 'saved';
						className = 'harvest-panel-saved';
						break;
					}
				} else {
					if (
						checkArray[i]['quantity'] > 0 &&
						$scope.saveStatus[panelName] !== 'saving'
					) {
						$scope.saveStatus[panelName] = 'saved';
						className = 'harvest-panel-saved';
						break;
					}
				}
			}
			return className;
		};

		$scope.cellBlur = function(panelName) {
			$scope.saveStatus[panelName] = 'saving';
			continueSaving(panelName, function() {
				$timeout(function() {
					$scope.saveStatus[panelName] = 'saved';
					checkProductComplete();
				}, 500);
			});
		};
		$scope.updateCocoons = () => {
			$scope.cocoons = setNumberFromWeight($scope.cocoons);
		};

		$scope.setZeroPopulation = function(panelName) {
			$scope.saveStatus[panelName] = 'saved';
			checkProductComplete();
			$timeout(function() {
				$scope.showPanel[panelName] = false;
			}, 1);
		};

		function checkProductComplete() {
			var isProductComplete = false;
			if (
				currentStation === 2 &&
				$scope.activeProduct.PROD_CD.indexOf('_OB_') === -1 &&
				$scope.activeProduct.PROD_CD.indexOf('_DV_') === -1 &&
				$scope.saveStatus['tube'] === 'saved'
			) {
				isProductComplete = true;
			} else {
				var dssCount = Object.keys($scope.defaultSpeciesStatus).length;
				angular.forEach($scope.defaultSpeciesStatus, function(value, key) {
					if ($scope.saveStatus[key] === value) {
						dssCount--;
					}
				});
				if (dssCount === 0) {
					isProductComplete = true;
				}
			}
			if (isProductComplete) {
				setProductComplete();
			}
		}

		/**
		 * Fetch the current BeeCare status, then update it and refresh.
		 */
		function setProductComplete(step) {
			let defer = $q.defer();

			var data = {};
			if (step) {
				data['step' + step] = true;
			} else {
				switch ($scope.beecare_name) {
					case 'BEECARE_STEP2_COMPLETE':
						data = { step2: true };

						break;
					case 'BEECARE_STEP3_COMPLETE':
						data = { step3: true };
						break;
				}
			}
			$http
				.patch(
					SETTINGS.beehomeAPIBasePath +
						'beecare/' +
						$scope.activeProduct.activeHistoryID,
					data
				)
				.finally(() => {
					fetchUpdateBeecareSatuses().finally(() => {
						defer.resolve();
					});
				});

			return defer.promise;
		}

		$scope.normalizePath = function() {
			if ($scope.activeProduct !== undefined && $scope.activeProduct.Code) {
				if (currentStation === 2) {
					$location.path('/harvest/tubes/' + $scope.activeProduct.Code);
				} else {
					$location.path('/harvest/cocoons/' + $scope.activeProduct.Code);
				}
			}
		};

		$scope.isActiveStep = function(activeProductStep) {
			return (
				!(activeProductStep === null || activeProductStep === 0) ||
				activeProductStep === undefined
			);
		};

		function initialLoadWithSeason() {
			if (houseCode) {
				$scope.activeProduct = { Code: houseCode };
				if ($stateParams.autoUpdate == 1) {
					autoUpdateData($scope.activeProduct.Code);
				} else {
					lookupCode($scope.activeProduct.Code);
				}
			}
		}

		function initialLoad() {
			if ($scope.season) {
				initialLoadWithSeason();
			} else {
				var currentSeason = new Date().getFullYear();
				var confirm = $mdDialog
					.confirm({
						onComplete: function afterShowAnimation() {
							var $dialog = angular.element(document.querySelector('md-dialog'));
							var $actionsSection = $dialog.find('md-dialog-actions');
							var $cancelButton = $actionsSection.children()[0];
							// eslint-disable-next-line no-unused-vars
							var $confirmButton = $actionsSection.children()[1];
							// angular.element($confirmButton).addClass('md-raised md-warn');
							angular.element($cancelButton).addClass('md-warn');
						}
					})
					.title('Harvest Season Not Set!')
					.textContent(
						'Your harvest season is currently not set. Would you like to set it or use the default season, ' +
							currentSeason +
							'?'
					)
					.ariaLabel('Harvest Season')
					.ok('Set Harvest Season')
					.cancel('Use Default Season');
				$mdDialog.show(confirm).then(
					function() {
						location.href = '#/harvest/settings';
					},
					function() {
						Session.harvestSeason = currentSeason;
						$scope.season = Session.harvestSeason;
						initialLoadWithSeason();
					}
				);
			}
		}
		initialLoad();

		function checkCompletedSteps() {
			var previousStepsComplete = true;
			switch (currentStation) {
				case 2:
					previousStepsComplete = $scope.activeProduct.BEECARE_STEP1_COMPLETE == 1;
					break;
				case 3:
					previousStepsComplete =
						$scope.activeProduct.BEECARE_STEP1_COMPLETE == 1 &&
						$scope.activeProduct.BEECARE_STEP2_COMPLETE == 1;
					break;
			}
			return previousStepsComplete;
		}

		function messageLoad(next) {
			$translate([
				'general.warning',
				'harvest.process_abondoned',
				'general.yes',
				'general.no'
			]).then(function(translations) {
				$mdDialog
					.show(
						$scope.getConfirmDialog(
							translations['general.warning'],
							translations['harvest.process_abondoned'],
							'Incomplete',
							translations['general.yes'],
							translations['general.no']
						)
					)
					.then(
						function() {
							$scope.activeProduct = null;
							$location.path(next);
						},
						function() {
							$scope.activeProduct.Code = '';
						}
					);
			});
		}

		function setNumberFromWeight(cocoons) {
			var allSpecies = cocoons;
			if (Number($scope.season) > 2019 && Number($scope.season) < 2022) {
				for (var i = 0; i < allSpecies.length; i++) {
					var species = allSpecies[i];
					var conversion = angular.isDefined($scope.orgConversions[species.insectID])
						? $scope.orgConversions[species.insectID]
						: $scope.defaultOrgConversions[species.insectID];
					species.quantity = Math.round(species.weight * conversion);
					allSpecies[i] = species;
				}
			}
			return allSpecies;
		}

		function setOrganisationSettings(orgID) {
			getBeecareSettings(orgID);
			if (orgID && typeof orgID != undefined) {
				$http
					.get(SETTINGS.APIBasePath + 'organisation/settings/' + orgID)
					.then(function(settingsRes) {
						$scope.orgConversions = {};
						$scope.defaultOrgConversions = {};
						for (var i = 0; i < settingsRes.data.managementConversion.length; i++) {
							var conversion = settingsRes.data.managementConversion[i];
							if (conversion.SOURCE_ID == 1) {
								$scope.defaultOrgConversions[conversion.INSCT_ID] =
									conversion.CONV_FACTOR;
							}
							if (conversion.SOURCE_ID == $scope.activeProduct.CATEGORY_ID) {
								$scope.orgConversions[conversion.INSCT_ID] = conversion.CONV_FACTOR;
							}
						}
					});
			}
		}

		$scope.$on('$locationChangeStart', function(event, next) {
			if (
				$scope.activeProduct &&
				$scope.activeProduct[$scope.beecare_name] != 1 &&
				checkCompletedSteps()
			) {
				event.preventDefault();
				messageLoad(next.split('#/')[1]);
			} else {
				return true;
			}
		});
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:HarvestCheckCtrl
 * @description
 * HarvestCheckCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('HarvestCheckCtrl', function(
		$scope,
		$http,
		$q,
		AlertUser,
		Session,
		SETTINGS,
		$mdToast,
		codeValidator,
		ClientFactory,
		ContactFactory,
		AddressFactory,
		customerProducts,
		products,
		trackingNumberService,
		users,
		shopifyFactory
	) {
		$scope.scanned = '';
		$scope.items = [];
		$scope.selected = [];
		$scope.products = {};
		$scope.users = users;
		$scope.add = add;
		$scope.removeSelected = removeSelected;
		$scope.confirmSelected = confirmSelected;
		$scope.houseCodePattern = codeValidator.houseCodePattern;

		var sendMailSettings = {};
		var counter = 0;

		init();

		/**
		 * Initialize controller.
		 */
		function init() {
			console.log('initialising page');
			Session.setStream('beehome');
			Session.pageTitle = 'Harvest Check';
			angular.forEach(products, function(product) {
				$scope.products[parseInt(product.ID)] = product;
			});
		}

		/**
		 * Fetch the relevant info for a house code and add it to the list.
		 * @param houseCode
		 */
		async function add(houseCode) {
			if (houseCode) {
				if (contains(houseCode)) {
					toast('Code is already scanned.');
				} else {
					getHouse(houseCode).then(
						function(house) {
							if (house.code !== houseCode) {
								AlertUser(
									'WARNING',
									'This house code has been changed to ' + house.code,
									angular.noop
								);
								houseCode = house.code;
								if (contains(houseCode)) {
									toast('Code is already scanned.');
									return;
								}
							}
							getHarvestRecord(houseCode).then(
								function(harvestRecord) {
									if (harvestRecord && harvestRecord.BEECARE_STEP4_COMPLETE) {
										toast('House already checked.');
										return;
									}
									ClientFactory.getClient(house.client_id).then(
										async function(client) {
											var contact = ContactFactory.getBillingContact(client.contacts);
											var address = getAddress(client, house.address_id);
											var item = {
												id: counter++,
												house: house,
												product: $scope.products[house.product_id],
												harvestRecord: harvestRecord,
												client: client,
												contact: contact,
												address: address
											};
											$scope.items.push(item);
											$scope.selected.push(item);
											$scope.scanned = '';
											let BeehomeAddon = null;
											if (
												item.harvestRecord.order &&
												item.harvestRecord.order.shopify_id
											) {
												let shopifyOrder = await shopifyFactory.getOrderById(
													item.harvestRecord.order.shopify_id
												);
												if (await shopifyFactory.hasBeehomeAddon(shopifyOrder)) {
													const addons = shopifyOrder.lineItems.filter(item => {
														// currentQuantity drops to 0 when the line item is fully refunded/removed
														if (item.currentQuantity === 0) {
															return false;
														}
														const correctHouse = item.customAttributes.some(
															attr => attr.value == house.id
														);
														if (!correctHouse) {
															return false;
														}
														return item.customAttributes.some(
															attr => attr.value == 'additional_option'
														);
													});
													BeehomeAddon = addons.map(addon => addon.sku).join('<br/>');
												}
												if (BeehomeAddon) {
													AlertUser(
														'Warning',
														'This product has a beehome addon in the order.<br/>' +
															BeehomeAddon,
														() => {}
													);
												}

												console.log(shopifyOrder);
											}
										},
										function(error) {
											toast(error);
										}
									);
								},
								function(error) {
									toast(error);
								}
							);
						},
						function(error) {
							toast(error);
						}
					);
				}
			}
		}

		/**
		 * Get the harvest information for the given house code from the DB.
		 * @param houseCode
		 * @returns {*}
		 */
		function getHarvestRecord(houseCode) {
			var query = {
				order: 'code',
				limit: 20,
				page: 1,
				filter: houseCode,
				limitOptions: [20, 50, 100]
			};
			return customerProducts.fetchSingleProduct(query).then(function(result) {
				if (result.list.length > 0) {
					var data = result.list[0];
					var harvestRecord = null;
					console.log(Session.harvestSeason);
					// Find the harvest record for the current season
					angular.forEach(data.history, function(row) {
						console.log('row', row);
						if (row.SEASON == Session.harvestSeason) {
							harvestRecord = row;
						}
					});

					if (!harvestRecord) {
						return $q.reject('Could not find harvest record for this season.');
					}

					// If there's an ORDER_ID, fetch the order data before returning
					if (harvestRecord.ORDER_ID !== null) {
						return $http
							.get(SETTINGS.beehomeAPIBasePath + 'orders/' + harvestRecord.ORDER_ID)
							.then(function(response) {
								harvestRecord.order = response.data;
								return harvestRecord;
							});
					}

					// No order ID, return harvest record as is
					return harvestRecord;
				} else {
					return $q.reject('Could not find harvest record for this code.');
				}
			});
		}

		/**
		 * Get the house information for a given house code from the DB.
		 * @param code
		 * @returns {*}
		 */
		function getHouse(code) {
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'houses?code=' + code)
				.then(function(result) {
					if (result.data.items.length) {
						var house = result.data.items[0];
						if (!house.client_id) {
							return $q.reject('House not linked to a client.');
						}
						var product = $scope.products[house.product_id];
						if (product.category !== 'BeeHome') {
							return $q.reject('Product is not a BeeHome.');
						}
						return house;
					} else {
						return $q.reject('Could not find a house for this code.');
					}
				});
		}

		/**
		 * Get the house address based on id or fall back to billing address
		 * @param client
		 * @param addressId
		 * @returns {*}
		 */
		function getAddress(client, addressId) {
			if (addressId) {
				return AddressFactory.getAddressById(client.addresses, addressId);
			} else {
				return AddressFactory.getBillingAddress(client.addresses);
			}
		}

		/**
		 * Remove the selected items from the list.
		 */
		function removeSelected() {
			angular.forEach($scope.selected, function(item) {
				remove(item.house.code);
			});
			$scope.selected = [];
		}

		/**
		 * Remove a single house from the list.
		 * @param houseCode
		 */
		function remove(houseCode) {
			$scope.items = $scope.items.filter(function(x) {
				return x.house.code !== houseCode;
			});
		}

		/**
		 * Remove a single house from the list.
		 * @param houseCode
		 */
		function contains(houseCode) {
			return (
				$scope.items.filter(function(x) {
					return x.house.code === houseCode;
				}).length > 0
			);
		}

		/**
		 * Iterate selected items, mark them as complete and send confirmation email. The marking needs to happen
		 * sequentially, when houses belonging to the same order are processed in parallel we risk sending duplicate
		 * invoices.
		 */
		function confirmSelected() {
			$scope.$root.showLoader = true;
			$scope.selected
				.reduce(function(promise, item) {
					return promise.then(function() {
						return markComplete(item);
					});
				}, $q.when())
				.finally(function() {
					$scope.$root.showLoader = false;
				});
			$scope.selected = [];
			$('#scanner').focus();
		}

		/**
		 * Mark an item as step4 complete and send confirmation email. Remove item from list once email is sent.
		 */
		function markComplete(item) {
			return $http
				.patch(SETTINGS.beehomeAPIBasePath + 'beecare/' + item.harvestRecord.ID, {
					step4: true
				})
				.then(
					function() {
						item.harvestRecord.BEECARE_STEP4_COMPLETE = 1;
						return sendMail(item).then(
							function() {
								remove(item.house.code);
							},
							function(error) {
								toast(error);
							}
						);
					},
					function(error) {
						console.log(error);
						toast('Could not mark house as checked.');
					}
				);
		}

		/**
		 * Send confirmation email to client. Only if the send harvest mails setting is set.
		 * @param item
		 * @returns {*}
		 */
		function sendMail(item) {
			if (!item.contact.email) {
				return $q.reject('No email address');
			}
			return getSendMailSetting(item.client.organisation.id).then(function(
				sendMail
			) {
				if (sendMail) {
					var langId = item.contact.language === 'fr' ? 2 : 1;
					return $http.post(SETTINGS.APIBasePath + 'mail/house-complete/' + langId, {
						name: item.contact.first_name,
						email: item.contact.email,
						HOUSE_CD: item.house.code,
						PROD_CD: item.product.PROD_CD,
						TRACKING_NR: item.harvestRecord.CONSIGNMENT_NR ?? '',
						TRACKING_URL:
							trackingNumberService.getURL(item.harvestRecord.CONSIGNMENT_NR) ?? ''
					});
				} else {
					return $q.reject(
						'Sending emails is turned off. Contact an admin to turn on if required.'
					);
				}
			});
		}

		/**
		 * Get the setting whether to send the email. The setting is dependent on the organisation of the client
		 * Cache the promis, so the setting is only fetched once for each organisation.
		 * @param orgId
		 * @returns {boolean|*}
		 */
		function getSendMailSetting(orgId) {
			if (orgId in sendMailSettings) {
				return sendMailSettings[orgId];
			} else {
				sendMailSettings[orgId] = Session.getSendHarvestMails(orgId);
				return sendMailSettings[orgId];
			}
		}

		/**
		 * Show a message
		 * @param msg
		 */
		function toast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.position('top right')
				.parent(angular.element('#products'))
				.hideDelay('2000');
			$mdToast.show(toast);
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:ProductDetails
 * @description
 * # ProductDetails
 */
var previousActiveIDs = [];
angular
	.module('wildBieneHarvestApp')
	.directive('productDetails', function(
		$mdDialog,
		$http,
		$mdToast,
		$location,
		$stateParams,
		$q,
		AlertUser,
		NotifyUser,
		Session,
		printerService,
		SETTINGS,
		shippingLabel,
		startpopSettings,
		ConfirmUser,
		customerProducts,
		AddressFactory,
		ClientFactory,
		ContactFactory,
		clientNotesFactory,
		shopifyFactory
	) {
		return {
			templateUrl: 'views/product-details.html',
			scope: {
				disableEdit: '=disableEdit',
				client: '=client',
				clientProducts: '=clientProducts',
				house: '=house',
				defaultAddress: '=defaultAddress',
				users: '=',
				selectedProducts: '=selectedProducts'
			},

			link: function postLink(scope) {
				scope.clientID =
					scope.client && scope.client.id ? scope.client.id : $stateParams.cid;
				scope.apiPath = SETTINGS.APIBasePath;
				scope.historyModal = historyModal;
				scope.openNotesEditor = openNotesEditor;
				scope.updateProduct = updateProduct;
				scope.getCustomerProducts = getCustomerProducts;
				scope.editProduct = editProduct;
				scope.clearFilter = clearFilter;
				scope.addVoucher = addVoucher;
				scope.selectOneProduct = selectOneProduct;
				scope.setVoucher = setVoucher;

				AddressFactory.registerListener(data => {
					scope.client.addresses = data;
				});

				scope.currentStation = 1;

				if (scope.client) {
					Session.getSendHarvestMails(scope.client.organisation.id).then(function(
						result
					) {
						scope.sendMailsActive = result;
					});
				}

				if (Session.rights.indexOf('Cocoon') > -1) {
					scope.linkCocoon = true;
				}
				if (Session.rights.indexOf('Tube') > -1) {
					scope.linkTube = true;
				}
				if (Session.rights.indexOf('BeeHarvest Customer') > -1) {
					scope.linkCustomer = true;
				}

				function clearFilter() {
					$location.search({ house: undefined });
					scope.query.filter = '';
					previousActiveIDs = scope.selectedProducts.map(product => {
						return product.ID;
					});
				}

				/**
				 * Toggle product active / not active
				 * @param code
				 * @param active
				 */
				function setActiveCode(code, active = true) {
					if (code && active) {
						angular.forEach(scope.clientProducts, function(product) {
							if (product.code && product.code.toUpperCase() === code.toUpperCase()) {
								scope.selectedProducts = [product];
								setVoucher(product);
								Session.keyCodeString = product.code;
							}
						});
						previousActiveIDs = [];
					} else {
						//if previously active IDS were saved, re select them
						scope.selectedProducts = scope.clientProducts.filter(product => {
							return previousActiveIDs.find(id => {
								return product.ID == id;
							});
						});
						if (scope.selectedProducts.length == 1) {
							setVoucher(scope.selectedProducts[0]);
						}
						Session.keyCodeString = undefined;
					}
				}

				scope.addClientProduct = function() {
					Session.keyCodeString = '';

					$mdDialog
						.show({
							controller: 'ProductPOPCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/product-create.html',
							parent: angular.element(document.body),
							locals: {
								customer: scope.client,
								activeProduct: {}
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(updateClient, angular.noop);
				};
				function updateClient(newProduct) {
					var activeCode = null;
					if (newProduct) {
						activeCode = newProduct.code;
					} else if (scope.selectedProducts && scope.selectedProducts.length) {
						activeCode = scope.selectedProducts[0].code;
						console.warn('untested update client scenario');
					}
					getCustomerProducts(activeCode);
				}

				function editProduct() {
					$mdDialog
						.show({
							controller: 'ProductPOPCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/product-create.html',
							parent: angular.element(document.body),
							locals: {
								customer: scope.client,
								activeProduct: scope.selectedProducts[0]
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(updateClient, angular.noop);
				}

				scope.delete = function() {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Would you like to remove this house?')
						.textContent(
							'Clicking Yes will disconnect this house from its current client.'
						)
						.ok('Yes')
						.cancel('Cancel');
					$mdDialog.show(confirm).then(function() {
						scope.selectedProducts.forEach(product => {
							$http
								.patch(SETTINGS.beehomeAPIBasePath + 'houses/' + product.ID, {
									client_id: null
								})
								.then(function() {
									updateClient();
								});
						});
					});
				};
				//clears all other selected houses from the list
				function selectOneProduct(product) {
					scope.selectedProducts = [product];
					setActiveCode(product.code, true);
				}

				function printShippingLabel() {
					var addressArr = null;
					let productAddress = scope.selectedProducts.find(product => {
						return product.ADDRESS_ID;
					});
					if (productAddress && scope.selectedProducts.length == 1) {
						addressArr = AddressFactory.getAddressById(
							scope.client.addresses,
							productAddress.ADDRESS_ID
						);
					} else {
						addressArr = AddressFactory.getBillingAddress(scope.client.addresses);
					}
					if (addressArr == null) {
						NotifyUser('No address found.');
						return;
					}
					var streetArray = [0, 0];
					if (addressArr.address_1) {
						streetArray = addressArr.address_1.split(' ');
					}
					var houseNo = streetArray.pop();
					var str = streetArray.join(' ');

					var shippingData = {
						firstname: addressArr.first_name,
						lastname: addressArr.last_name,
						street: str,
						houseNo: houseNo,
						zip: addressArr.postal_code,
						city: addressArr.town,
						domicilePostOffice: addressArr.city,
						houseCode:
							scope.selectedProducts.length < 3
								? String(scope.selectedProducts.map(product => product.code))
								: 'Multiple Houses',
						title: scope.client.title,
						tel: ' ',
						address1: addressArr.address_1,
						address2: addressArr.address_2,
						companyName: addressArr.company_name
					};
					shippingLabel(shippingData).then(function(result) {
						//if no shipiing label was created, don't do anything.
						if (!result.identityCode) return;
						var consignment = {
							consignmentNumber: result.identityCode,
							houseIds: scope.selectedProducts.map(product => product.ID),
							season: Session.harvestSeason
						};
						$http
							.post(SETTINGS.APIBasePath + 'product/consignment_number', consignment)
							.then(function() {
								previousActiveIDs = scope.selectedProducts.map(item => {
									return item.ID;
								});
								getCustomerProducts();
							});
					});
				}

				scope.printShippingLabel = function() {
					let existingConsignment = scope.selectedProducts.find(product => {
						return product.CONSIGNMENT_NR;
					});
					if (existingConsignment) {
						ConfirmUser(
							'WARNING',
							'Are you sure you want to print another shipping label?',
							printShippingLabel
						);
					} else {
						printShippingLabel();
					}
				};

				scope.printQRCode = function() {
					scope.$root.showLoader = true;
					printerService('qrCode', scope.selectedProducts[0].code).then(function() {
						scope.$root.showLoader = false;
					});
				};

				/**
				 * First check if there is an existing voucher that needs to be detached from
				 * the current BeeCare record, then attach the new voucher.
				 */
				function addVoucher(newVoucher) {
					let currentVoucher = scope.selectedProducts[0].voucher;
					let current_id = currentVoucher ? currentVoucher.id : null;
					let new_id = newVoucher ? newVoucher.id : null;
					if (new_id === current_id) {
						return;
					}
					return removeCurrentVoucher(currentVoucher, newVoucher)
						.then(() => addNewVoucher(newVoucher), angular.noop)
						.finally(() => setVoucher(scope.selectedProducts[0]));
				}

				/**
				 * If there is a voucher currently attached to the BeeCare record, then detach it.
				 */
				function removeCurrentVoucher(currentVoucher) {
					if (!currentVoucher) {
						return $q.when();
					} else {
						return editVoucher(currentVoucher.id, currentVoucher.code, null, null);
					}
				}

				/**
				 * Attach a new voucher to the current BeeCare record.
				 */
				function addNewVoucher(newVoucher) {
					if (scope.selectedProducts.length != 1 || !newVoucher) {
						console.warn(
							'Too many products selected to add a voucher or there was no new Voucher'
						);
						return $q.when();
					}

					return editVoucher(
						newVoucher.id,
						newVoucher.code,
						parseInt(scope.selectedProducts[0].CLIENT_PROD_ID),
						parseInt(scope.selectedProducts[0].ORDER_ID)
					);
				}

				/**
				 * Add or remove a voucher from the BeeCare record by setting house_id and order_id
				 */
				function editVoucher(voucher_id, code, house_id, order_id) {
					return startpopSettings
						.editVoucher({
							id: voucher_id,
							house_id: house_id,
							order_id: order_id
						})
						.then(
							response => {
								scope.selectedProducts[0].voucher = response.data;
								NotifyUser('Voucher ' + code + (house_id ? ' added.' : ' removed.'));
							},
							response => {
								scope.selectedProducts[0].voucher = {}; // Trigger reloading the search box
								AlertUser('Error ' + response.data.status, response.data.detail);
								return $q.reject();
							}
						);
				}

				const checkProduct = () => {
					if (scope.selectedProducts[0].PROD_ID == null) {
						$mdDialog
							.show({
								controller: 'ProductPOPCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/product-create.html',
								parent: angular.element(document.body),
								clickOutsideToClose: true,
								locals: {
									customer: scope.client,
									activeProduct: angular.copy(scope.selectedProducts[0])
								}
							})
							.then(() => {
								getCustomerProducts(scope.selectedProducts[0].code).then(
									scope.openSnapshotModal
								);
							}, angular.noop);
						return false;
					}
					return true;
				};

				scope.openSnapshotModal = async function() {
					if (!checkProduct()) {
						return;
					}
					var BeehomeAddon = null;
					const continueSnapshot = () => {
						var contact = ContactFactory.getBillingContact(scope.client.contacts);
						var mailInformation;
						if (contact && contact.email) {
							mailInformation = {
								houseCode: scope.selectedProducts[0].code,
								name: contact.first_name,
								email: contact.email,
								language: contact.language,
								mergeVars: {
									HOUSE_CD: scope.selectedProducts[0].code,
									PROD_CD: scope.selectedProducts[0].PROD_CD,
									HOUSECODE: scope.selectedProducts[0].code // Legacy
								}
							};
						}
						$mdDialog
							.show({
								controller: 'SnapshotmodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/snapshot-modal.html',
								parent: angular.element(document.body),
								locals: {
									activeProduct: scope.selectedProducts[0],
									season: scope.selectedProducts[0].SEASON,
									mailInformation: mailInformation
								},
								fullscreen: true,
								clickOutsideToClose: true
							})
							.then(function() {
								$location.path(
									'/harvest/tubes/' + scope.selectedProducts[0].code + '/1'
								);
							});
					};
					if (
						scope.selectedProducts[0].order &&
						scope.selectedProducts[0].order.shopify_id
					) {
						const shopifyOrder = await shopifyFactory.getOrderById(
							scope.selectedProducts[0].order.shopify_id
						);
						console.log('selected product:', scope.selectedProducts[0]);
						if (await shopifyFactory.hasBeehomeAddon(shopifyOrder)) {
							console.log('selected id', scope.selectedProducts[0].ID);
							const addons = shopifyOrder.lineItems.filter(item => {
								// currentQuantity drops to 0 when the line item is fully refunded/removed
								if (item.currentQuantity === 0) {
									return false;
								}
								const correctHouse = item.customAttributes.some(
									attr => attr.value == scope.selectedProducts[0].ID
								);
								if (!correctHouse) {
									return false;
								}
								return item.customAttributes.some(
									attr => attr.value == 'additional_option'
								);
							});
							BeehomeAddon = addons.map(addon => addon.sku).join('<br/>');
						}
					}

					if (BeehomeAddon) {
						AlertUser(
							'Warning',
							'This product has a beehome addon in the order.<br/>' + BeehomeAddon,
							continueSnapshot
						);
						return;
					} else {
						continueSnapshot();
					}
				};

				scope.deleteSnapshot = function(deleteData) {
					var confirm = $mdDialog
						.confirm()
						.title('DELETE SNAPSHOT')
						.textContent('Are you sure you want to delete this snapshot?')
						.ariaLabel('DELETE SNAPSHOT')
						.ok('Yes')
						.cancel('No');
					$mdDialog.show(confirm).then(
						function() {
							$http
								.post(SETTINGS.APIBasePath + 'product/deleteSnapshot', {
									data: scope.selectedProducts[0],
									deleteData: deleteData
								})
								.then(function() {
									scope.selectedProducts[0].SNAPSHOT_FN = null;
									var toast = $mdToast
										.simple()
										.textContent('Snapshot has been successfully deleted.')
										.position('top right');
									$mdToast.show(toast).then(function() {
										updateClient();
									});
								});
						},
						function(error) {
							//TODO Handle error correctly
							console.warn('caught error', error);
						}
					);
				};

				scope.openPreview = function(image_url, image_title) {
					$mdDialog.show({
						controller: 'ImagemodalCtrl',
						image_url: image_url,
						image_title: image_title,
						templateUrl: 'views/image-modal.html',
						fullscreen: true,
						clickOutsideToClose: true
					});
				};

				function historyModal(type) {
					$mdDialog.show({
						controller: 'HistorymodalCtrl',
						controllerAs: 'ctrl',
						templateUrl: 'views/history-modal.html',
						parent: angular.element(document.body),
						locals: {
							type: type,
							id: scope.selectedProducts[0].code
						},
						resolve: {
							users: function(userService) {
								return userService.all();
							}
						},
						fullscreen: false,
						clickOutsideToClose: true
					});
				}

				function openNotesEditor(activeCode) {
					$mdDialog.show({
						controller: 'ClientNotesModalCtrl',
						controllerAs: 'ctrl',
						templateUrl: 'views/client-notes-modal.html',
						parent: angular.element(document.body),
						fullscreen: true,
						clickOutsideToClose: true,
						resolve: {
							clientID: function() {
								return scope.clientID;
							},
							clientProducts: function() {
								return scope.clientProducts;
							}
						},
						onRemoving: function() {
							clientNotesFactory.reloadNotes(scope.clientID);
						},
						activeCode: activeCode
					});
				}

				scope.query = {
					order: 'code',
					limit: 20,
					page: 1,
					filter: $location.search().house_code,
					limitOptions: [20, 50, 100]
				};

				function setbeecarestatus(house) {
					if (house.history) {
						var season = Session.harvestSeason;
						house.dateCreated = new Date(house.dateCreated);
						if (house.dateModified) {
							house.dateModified = new Date(house.dateModified);
						} else {
							house.dateModified = house.dateCreated;
						}
						var history = house.history;
						history.order = {};
						for (var x = 0; x < history.length; x++) {
							var historyRow = history[x];
							if (historyRow.SEASON == season) {
								house.SEASON = parseInt(historyRow['SEASON']);
								house.BEECARE_STEP1_COMPLETE = historyRow['BEECARE_STEP1_COMPLETE'];
								house.BEECARE_STEP1_UPD_AT = historyRow['BEECARE_STEP1_UPD_AT'];
								house.BEECARE_STEP1_UPD_BY = historyRow['BEECARE_STEP1_UPD_BY'];
								house.BEECARE_STEP2_COMPLETE = historyRow['BEECARE_STEP2_COMPLETE'];
								house.BEECARE_STEP2_UPD_AT = historyRow['BEECARE_STEP2_UPD_AT'];
								house.BEECARE_STEP2_UPD_BY = historyRow['BEECARE_STEP2_UPD_BY'];
								house.BEECARE_STEP3_COMPLETE = historyRow['BEECARE_STEP3_COMPLETE'];
								house.BEECARE_STEP3_UPD_AT = historyRow['BEECARE_STEP3_UPD_AT'];
								house.BEECARE_STEP3_UPD_BY = historyRow['BEECARE_STEP3_UPD_BY'];
								house.BEECARE_STEP4_COMPLETE = historyRow['BEECARE_STEP4_COMPLETE'];
								house.BEECARE_STEP4_UPD_AT = historyRow['BEECARE_STEP4_UPD_AT'];
								house.BEECARE_STEP4_UPD_BY = historyRow['BEECARE_STEP4_UPD_BY'];
								house.invoicedAt = historyRow.INVOICED_AT;
								house.SNAPSHOT_FN = historyRow['SNAPSHOT_FN'];
								house.CONSIGNMENT_NR = historyRow['CONSIGNMENT_NR'];
								house.activeHistoryID = historyRow['ID'];
								house.ORDER_ID = historyRow['ORDER_ID'];
								house.IS_PAID = historyRow['IS_PAID'];
								house.TRX_DATE = historyRow['TRX_DATE'];

								if (historyRow.ORDER_ID !== null) {
									$http
										.get(SETTINGS.beehomeAPIBasePath + 'orders/' + historyRow.ORDER_ID)
										.then(response => {
											house.order = response.data;
										});
								}
							}
						}
					}
					return house;
				}

				/** Get the voucher for the active BeeCare record **/
				function setVoucher(product) {
					var data = product.ORDER_ID
						? { type: 'BEECARE', order_id: product.ORDER_ID, house_id: product.ID }
						: { type: 'BEECARE', house_id: product.ID };
					return startpopSettings.getVoucherList(data).then(data => {
						// Filter vouchers by harvest season
						const validVouchers = data.items.filter(voucher => {
							if (!voucher.created_at) return true; // Include vouchers without creation date
							const year = new Date(voucher.created_at).getFullYear();
							return year >= Session.harvestSeason;
						});

						// Set the first valid voucher, or null if none exist
						product.voucher = validVouchers.length > 0 ? validVouchers[0] : null;
					});
				}

				function updateProduct(product) {
					if (product.address.id == scope.defaultAddress.id) {
						product.address = { id: null };
					}
					ClientFactory.updateClientProduct(product).then(function() {
						getCustomerProducts();
					});
				}

				function getProductAddress(addressId) {
					var productAddress = { id: null };
					angular.forEach(scope.client.addresses, function(address) {
						if (address.id == addressId && address.id !== scope.defaultAddress) {
							productAddress = address;
						}
					});
					return productAddress;
				}

				function success(data) {
					console.log('success', data);
					if (data.list) {
						if (!scope.client) {
							scope.client = {};
						}
						for (var i = 0; i < data.list.length; i++) {
							data.list[i] = setbeecarestatus(data.list[i]);
							data.list[i].user_id = scope.clientID;
							data.list[i].address = getProductAddress(data.list[i].ADDRESS_ID);
						}
						scope.clientProducts = data.list;
						scope.productCount = data.count;
						scope.fullCount = data.countAll;

						//If there is only one product returned pre select it.
						if (scope.productCount == 1) {
							scope.selectedProducts = [scope.clientProducts[0]];
							setVoucher(scope.clientProducts[0]);
						}
					}
					return true;
				}

				/**
				 * If a product filter is active, update the filter object before fetching new data
				 * @param activeCode
				 */
				function updateFilter(activeCode) {
					if (
						activeCode &&
						scope.query.filter &&
						activeCode !== scope.query.filter
					) {
						scope.query.filter = activeCode;
					}
				}

				function getCustomerProducts(activeCode) {
					var defer = $q.defer();
					if (scope.client) {
						updateFilter(activeCode);
						console.log('gcp if client');
						scope.promise = customerProducts
							.fetchCustomerProducts(scope.query, scope.clientID)
							.then(success)
							.finally(function() {
								setActiveCode(activeCode);
								defer.resolve(true);
							});
					} else {
						scope.query.filter = $stateParams.h_id;
						scope.promise = customerProducts
							.fetchSingleProduct(scope.query)
							.then(success)
							.finally(function() {
								scope.house = scope.clientProducts[0];
								setActiveCode(activeCode);
								defer.resolve(true);
							});
					}
					return defer.promise;
				}

				/**
				 * Re-populate address select after addresses have been updated
				 */
				scope.$watch('client.addresses', function(newValue, oldValue) {
					if (!angular.equals(newValue, oldValue)) {
						getCustomerProducts();
					}
				});

				getCustomerProducts($location.search().house_code);
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AdminCtrl
 * @description
 * # AdminCtrlOrganisations
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('AdminCtrlOrganisations', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		Session,
		NotifyUser
	) {
		Session.setStream('administration');
		Session.pageTitle = 'Organisations';
		$scope.searchString = '';
		$scope.rowID = 'ID';
		$scope.tableInitialized = false;
		$scope.organisations = [];
		$scope.selectedOrganisations = [];

		$scope.search = function(str) {
			$http
				.get(SETTINGS.APIBasePath + 'organisations/search/' + str)
				.then(function(result) {
					$scope.organisations = result.data;
					$scope.orgsCount = result.data.length;
				});
		};
		$scope.timeoutedSearch = function(str) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(function() {
				$scope.search(str);
			}, 250);
		};

		$scope.search($scope.searchString);

		$scope.addOrganisation = function() {
			$scope.openOrg(null, 'Add');
		};

		$scope.editOrganisation = function(orgId) {
			if (orgId) {
				$scope.selectedOrganisations = [
					$scope.organisations.find(org => {
						return org.ID == orgId;
					})
				];
			}
			location.href =
				'#/admin/organisations/' + $scope.selectedOrganisations[0].ID + '/settings';
		};

		$scope.editDocument = function() {
			$scope.openDocument();
		};

		$scope.deleteOrganisation = function() {
			var itemToDelete = $scope.selectedOrganisations[0];
			var currentlyDeleting = angular.copy(itemToDelete);
			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('Deleting Organisation')
				.textContent("Are you sure you'd like to delete " + itemToDelete.NAME + '?')
				.ariaLabel('Confirm delete')
				.ok('Yes delete ' + itemToDelete.NAME + '.')
				.cancel("No I'll think about it.");

			$mdDialog.show(confirm).then(function() {
				$http
					.delete(SETTINGS.APIBasePath + 'organisation/' + itemToDelete.ID)
					.then(function(result) {
						$scope.search($scope.searchString);
						var message =
							result.data.error.length > 0
								? result.data.error
								: 'Organisation ' +
								  currentlyDeleting.ID +
								  ' (' +
								  currentlyDeleting.NAME +
								  ') has been deleted.';
						NotifyUser(message);
					});
			});
			// .catch(() => {});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AdminCtrl
 * @description
 * # AdminCtrlProducts
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('AdminCtrlProducts', function($scope, $http, SETTINGS, Session) {
		Session.setStream('administration');
		Session.pageTitle = 'Products';

		$scope.searchString = '';
		$scope.searchStringSalesProducts = '';
		$scope.rowID = 'ID';

		$scope.products = [];
		$scope.selectedProducts = [];
		$scope.salesProducts = [];
		$scope.selectedSalesProducts = [];

		$scope.productsColumns = [
			{ data: 'ID' },
			{ data: 'ID' },
			{ data: 'PROD_CD' },
			{ data: 'DESCRIPTION' },
			{ data: 'DISPLAY_SEQUENCE' },
			{ data: 'status' },
			{ data: 'category' }
		];

		$scope.salesProductsColumns = [
			{ data: 'ID' },
			{ data: 'ID' },
			{ data: 'SPROD_CD' },
			{ data: 'SPROD_NAME' },
			{ data: 'CATEGORY' },
			{ data: 'DISPLAY_SEQUENCE' },
			{ data: 'STATUS' }
		];

		$scope.$exttable = [];
		$scope.$exttableSelected = {
			tableProducts: [],
			tableSalesProducts: []
		};

		$scope.toggle = {};
		$scope.toggle.switch = false;

		$scope.toggleSalesProducts = {};
		$scope.toggleSalesProducts.switch = false;
		$scope.tableProductsInitialized = false;
		$scope.tableSalesProductsInitialized = false;

		$scope.toggleSwitchClick = function() {
			$scope.toggle.switch = !$scope.toggle.switch;
			$scope.search($scope.searchString);
		};

		$scope.toggleSwitchSalesProductsClick = function() {
			$scope.toggleSalesProducts.switch = !$scope.toggleSalesProducts.switch;
			$scope.searchSalesProducts($scope.searchStringSalesProducts);
		};

		$scope.search = function(str) {
			var active = $scope.toggle.switch ? '?active=' + +$scope.toggle.switch : '';
			$http
				.get(SETTINGS.APIBasePath + 'products/search/' + str + active)
				.then(function(result) {
					console.log('res', result);
					$scope.products = result.data;
				});
			$;
		};
		$scope.searchSalesProducts = function(str) {
			var active = $scope.toggleSalesProducts.switch
				? '?active=' + +$scope.toggleSalesProducts.switch
				: '';
			$http
				.get(SETTINGS.APIBasePath + 'sales-products/search/' + str + active)
				.then(function(result) {
					$scope.salesProducts = result.data;
				});
		};

		$scope.search($scope.searchString);
		$scope.searchSalesProducts($scope.searchStringSalesProducts);

		$scope.addProduct = function() {
			$scope.openProduct(null, 'Add');
		};

		$scope.editProduct = function(itemToEdit) {
			$scope.openProduct(itemToEdit, 'Edit');
		};

		$scope.editSalesProduct = function(itemToEdit) {
			$scope.openSalesProduct(itemToEdit, 'Edit');
		};

		$scope.addSalesProduct = function() {
			$scope.openSalesProduct(null, 'Add');
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AdminCtrl
 * @description
 * # AdminCtrlPackaging
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('AdminCtrlPackaging', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		Session,
		NotifyUser
	) {
		Session.setStream('administration');
		Session.pageTitle = 'Packaging';

		$scope.searchString = '';

		$scope.selectedOptions = [];

		$scope.search = function(str) {
			$http
				.get(SETTINGS.APIBasePath + 'packages/search/' + str)
				.then(function(result) {
					$scope.packageOptions = result.data;
					$scope.packagesCount = result.data.length;
				});
		};

		$scope.search($scope.searchString);

		$scope.addPackage = function() {
			$scope.openPackage(null, 'Add');
		};

		$scope.editPackage = function(itemToEdit) {
			$scope.openPackage(itemToEdit, 'Edit');
		};

		$scope.openPackage = function(packageItem, action) {
			$mdDialog
				.show({
					controller: 'SalesProductsPackagingModalCtrl',
					templateUrl: 'views/sales-products-packaging-modal.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					fullscreen: false,
					locals: {
						packageItem: packageItem,
						action: action
					},
					resolve: {}
				})
				.then(function() {
					$scope.search('');
				});
			// .catch(() => {});
		};

		function removePackage(itemToDelete) {
			$http
				.delete(SETTINGS.APIBasePath + '/packages/admin/' + itemToDelete.ID)
				.then(function(result) {
					result.data.success != true
						? NotifyUser(
								'ERROR',
								'Unable to delete this package, it is currently in use.'
						  )
						: NotifyUser('Package was deleted.');
					$scope.search('');
				});
		}

		function removePackages(itemsToDelete) {
			$http
				.delete(SETTINGS.APIBasePath + '/packages-bulk/admin', {
					params: { ids: itemsToDelete.join(',') }
				})
				.then(function(result) {
					result.data.success != true
						? NotifyUser('ERROR', 'Unable to delete packages.')
						: NotifyUser('Packages were deleted.');
					$scope.search('');
				});
		}

		$scope.removePackage = function() {
			var itemsToDelete = $scope.selectedOptions;
			const confirm = $mdDialog.confirm({
				onComplete: function afterShowAnimation() {
					var $dialog = angular.element(document.querySelector('md-dialog'));
					var $actionsSection = $dialog.find('md-dialog-actions');
					var $cancelButton = $actionsSection.children()[0];
					angular.element($cancelButton).addClass('md-warn');
				}
			});

			if (itemsToDelete.length > 1) {
				var codes = [],
					ids = [];

				for (var k in itemsToDelete) {
					codes.push(itemsToDelete[k].PACKAGE_CD);
					ids.push(itemsToDelete[k].ID);
				}

				confirm
					.title('Deleting Packages')
					.textContent(
						"Are you sure you'd like to delete packages " + codes.join(', ') + '?'
					)
					.ariaLabel('Confirm delete')
					.ok('Yes, delete packages')
					.cancel("No, I'll think about it");

				$mdDialog.show(confirm).then(function() {
					removePackages(ids);
				});
			} else {
				confirm
					.title('Deleting Package')
					.textContent(
						"Are you sure you'd like to delete " + itemsToDelete[0].PACKAGE_CD + '?'
					)
					.ariaLabel('Confirm delete')
					.ok('Yes, delete package')
					.cancel("No, I'll think about it");

				$mdDialog.show(confirm).then(function() {
					removePackage(itemsToDelete[0]);
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.species
 * @description
 * # species
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('species', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'species/');
	}
]);
angular.module('wildBieneHarvestApp').factory('AllSpecies', [
	'species',
	'$q',
	function(species, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			species.query(
				function(allSpecies) {
					delay.resolve(allSpecies);
				},
				function() {
					delay.reject('unable to fetch species');
				}
			);
			return delay.promise;
		};
	}
]);

angular.module('wildBieneHarvestApp').service('parasites', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'parasites/');
	}
]);
angular.module('wildBieneHarvestApp').factory('Allparasites', [
	'parasites',
	'$q',
	function(parasites, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			parasites.query(
				function(allparasites) {
					for (var i = 0; i < allparasites.length; i++) {
						if (allparasites[i].SC_NAME == 'Other parasite') {
							allparasites.splice(i, 1);
							delay.resolve(allparasites);
						}
					}
				},
				function() {
					delay.reject('unable to fetch parasites');
				}
			);
			return delay.promise;
		};
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.userService
 * @description
 * Get the list of users
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('userService', userService);

function userService($http, SETTINGS) {
	var url =
		SETTINGS.keycloak.url + '/admin/realms/' + SETTINGS.keycloak.realm + '/users';
	var users; // cached promise

	var service = {
		all: all,
		search: search,
		get: get
	};

	return service;

	////////////////

	/**
	 * Deserializer, return User object from API record
	 * @returns Object
	 * @constructor
	 */
	function User(data) {
		return {
			id: data.id,
			firstName: data.firstName,
			lastName: data.lastName,
			fullName:
				((data.firstName || '') + ' ' + (data.lastName || '')).trim() ||
				data.username,
			email: data.email
		};
	}

	/**
	 * Deserialize API response and return dictionary of User objects
	 * @param data
	 */
	function deserialize(data) {
		var users = {};
		for (var i = 0; i < data.length; i++) {
			var user = new User(data[i]);
			users[user.id] = user;
		}
		return users;
	}

	/**
	 * Fetch list of users from DB.
	 * If users were fetched previously, return the cached promise.
	 * @returns {*}
	 */
	function all() {
		if (!users) {
			users = $http({
				url: url,
				method: 'GET',
				params: { max: 500 }
			}).then(function(response) {
				return deserialize(response.data);
			});
		}
		return users;
	}

	function search(searchTerm) {
		return $http({
			url: url,
			method: 'GET',
			params: { search: searchTerm, max: 500 }
		}).then(function(response) {
			return deserialize(response.data);
		});
	}

	/**
	 * Fetch single user from DB.
	 * all() does not return service account users but get() does,
	 * use get to explicitly add service account users.
	 * @param userId
	 */
	function get(userId) {
		all().then(function(users) {
			if (!users[userId]) {
				users[userId] = $http({
					url: url + '/' + userId,
					method: 'GET'
				}).then(function(response) {
					var user = new User(response.data);
					users[userId] = user;
				}, angular.noop);
			}
			return users[userId];
		});
	}
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.population
 * @description
 * # population
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('population', [
	'$resource',
	'SETTINGS',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'population/:id', { id: '@id' });
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.AuthInterceptor
 * @description
 * # AuthInterceptor
 * Factory in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('authInterceptor', [
	'$q',
	'Auth',
	function($q, Auth) {
		return {
			request: function(config) {
				var deferred = $q.defer();

				// Skip adding auth if config object of $http request has the skipAuthorization property set
				if (config.skipAuthorization) {
					deferred.resolve(config);
				}

				// Only resolve requests if token is available
				else if (Auth.token) {
					// Refresh token if expired or expiring
					Auth.updateToken(180).then(
						function() {
							// Pass auth token in request header
							config.headers = config.headers || {};
							config.headers.Authorization = 'Bearer ' + Auth.token;

							deferred.resolve(config);
						},
						function() {
							deferred.reject('Failed to refresh token');
						}
					);
				}
				return deferred.promise;
			},
			requestError: function(rejection) {
				return $q.reject(rejection);
			},

			response: function(response) {
				return response;
			},

			responseError: function(response) {
				if (response.status === 401) {
					console.log('session timeout?');
					Auth.logout({ redirectUri: location.origin });
				} else if (response.status === 403) {
					console.log('Forbidden' + response.config.url);
				} else if (response.status === 404) {
					console.log('Not found ' + response.config.url);
				} else if (response.status) {
					console.log(response.status);
					if (response.data && response.data.errorMessage) {
						console.log(response.data.errorMessage);
					} else {
						console.log('An unexpected server error has occurred');
					}
				} else if (response === 'Failed to refresh token') {
					Auth.logout({ redirectUri: location.origin });
				}
				return $q.reject(response);
			}
		};
	}
]);

angular.module('wildBieneHarvestApp').config(function($httpProvider) {
	$httpProvider.interceptors.push('authInterceptor');
});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:LogoutCtrl
 * @description
 * # LogoutCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('LogoutCtrl', function(Session) {
		Session.destroy();
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ProductpopCtrl
 * @description
 * # ProductpopCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ProductPOPCtrl', function(
		$q,
		$scope,
		$mdDialog,
		$http,
		ClientFactory,
		SETTINGS,
		AllProducts,
		AlertUser,
		activeProduct,
		customer
	) {
		$scope.activeProduct = activeProduct;
		$scope.title = 'Product Details';
		$scope.productStyle = productStyle;
		$scope.save = save;
		$scope.cancel = cancel;
		$scope.getRegex = getRegex;

		$scope.products = [];
		//If an existing product with no product type, Promt the user to select a product type.
		if ($scope.activeProduct.ID && $scope.activeProduct.PROD_ID == null) {
			$scope.title = 'Please Select a Product type to continue';
		}
		var productsMap = {};

		AllProducts().then(function(response) {
			$scope.products = response;
			angular.forEach($scope.products, function(product) {
				product.DISPLAY_SEQUENCE = parseInt(product.DISPLAY_SEQUENCE);
				productsMap[parseInt(product.ID)] = product;
			});
		});

		/**
		 *
		 * retrieve the regex for the active product
		 * @returns regex
		 */
		function getRegex() {
			if (!$scope.activeProduct.PROD_ID) return;
			let currentProduct = $scope.products.find(product => {
				return product.ID == $scope.activeProduct.PROD_ID;
			});
			return currentProduct.regex;
		}

		function productStyle(ind) {
			if (ind < 2) {
				return "{'font-size': 'medium'}";
			}
			return '{}';
		}

		/**
		 * Save and close the form
		 */
		function save() {
			if (activeProduct.ID) {
				update(activeProduct.ID);
			} else {
				assignOrCreate();
			}
		}

		/**
		 * Search for existing house with the same code
		 * If a house is found then show the reassign dialog, otherwise create a new house
		 */
		function assignOrCreate() {
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'houses', {
					params: { code: $scope.activeProduct.code }
				})
				.then(function(response) {
					if (response.data.items.length) {
						var existingHouse = response.data.items[0];
						getClient(existingHouse).then(function(existingClient) {
							showReallocateModal(
								customer,
								existingClient,
								$scope.activeProduct,
								existingHouse
							);
						});
					} else {
						create();
					}
				});
		}

		/**
		 * Get the client of an existing house or null if house is unassigned
		 */
		function getClient(existingHouse) {
			if (!existingHouse.client_id) {
				return $q.when(null);
			} else {
				return ClientFactory.getClient(existingHouse.client_id);
			}
		}

		/**
		 * Show the reallocation dialog to confirm
		 */
		function showReallocateModal(
			newClient,
			existingClient,
			newHouse,
			existingHouse
		) {
			return $mdDialog
				.show({
					controller: 'ReassignhousedialogCtrl',
					templateUrl: 'views/reassignhousedialog.html',
					locals: {
						newClient: newClient,
						newHouse: newHouse,
						existingClient: existingClient,
						existingHouse: existingHouse,
						products: productsMap
					},
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					fullscreen: true,
					multiple: true
				})
				.then(function() {
					update(existingHouse.id);
				}, angular.noop);
		}

		/**
		 * Create a new house and close the modal
		 */
		function create() {
			var data = {
				code: $scope.activeProduct.code,
				product_id: parseInt($scope.activeProduct.PROD_ID),
				client_id: customer ? customer.id : null
			};
			return $http.post(SETTINGS.beehomeAPIBasePath + 'houses', data).then(
				function(response) {
					updateClientTags(response.data);
					$mdDialog.hide(data);
				},
				function(response) {
					$mdDialog.hide();
					AlertUser('Error ' + response.data.status, response.data.detail);
				}
			);
		}

		/**
		 * Update an existing house and close the modal
		 */
		function update(houseId) {
			var data = {
				code: $scope.activeProduct.code,
				product_id: parseInt($scope.activeProduct.PROD_ID),
				client_id: customer ? customer.id : null,
				address_id: parseInt($scope.activeProduct.ADDRESS_ID)
			};
			$http.patch(SETTINGS.beehomeAPIBasePath + 'houses/' + houseId, data).then(
				function(response) {
					updateClientTags(response.data);
					$mdDialog.hide(response.data);
				},
				function(response) {
					$mdDialog.hide();
					AlertUser('Error ' + response.data.status, response.data.detail);
				}
			);
		}

		/**
		 * Update client tags based on the new/updated house
		 */
		function updateClientTags(newHouse) {
			if (
				newHouse &&
				productsMap[newHouse.product_id] &&
				productsMap[newHouse.product_id].category.toLowerCase() === 'beehome'
			) {
				ClientFactory.getClient(customer.id).then(function(newClient) {
					ClientFactory.addTag(newClient, 'BEEHOME');
				});
			}
		}

		function cancel() {
			$mdDialog.cancel();
		}
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:CustomerExistModalCtrl
 * @description
 * # CustomerExistModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('CustomerExistModalCtrl', function(
		$scope,
		$window,
		$http,
		$mdDialog,
		$location,
		Session,
		customer,
		newcustomer,
		$state,
		SETTINGS
	) {
		$scope.customer = customer;
		$scope.newcustomer = newcustomer;

		$scope.cancel = function() {
			$mdDialog.hide();
			$location.path('/' + Session.stream + '/account');
		};

		$scope.toggleClientEditable = function() {
			$mdDialog.hide();
			if (Session.stream === 'farmer') {
				setCategory($scope.selectedCustomer.ID);

				$state.go('contract', { fid: $scope.selectedCustomer.ID });
			} else if (Session.stream === 'beehome') {
				$state.go('client', { cid: $scope.selectedCustomer.ID });
			}
		};

		$scope.openNewClient = function() {
			$scope.newcustomer.allowDuplicate = true;
			$scope.newcustomer.$save().then(
				function(result) {
					if (result.error) {
						$mdDialog.hide(result);
					} else {
						if (result.ID) {
							$location.path('/' + Session.stream + '/account/' + result.ID);
							$mdDialog.hide(result);
						} else {
							$window.location.reload();
						}
					}
				},
				function(result) {
					$location.path('/' + Session.stream + '/account/' + result.newID);
					$mdDialog.hide();
				}
			);
		};

		$scope.selectCustomer = function(index) {
			$scope.selectedCustomer = $scope.customer[index];
			$('.customer-line').removeClass('info');
			$('.customer-line' + index).addClass('info');
		};

		function setCategory(customerId) {
			$http
				.post(SETTINGS.APIBasePath + 'client/category_update', {
					data: { id: customerId }
				})
				.then(function() {});
		}

		$scope.setCustomer = function(index) {
			var oneRow = '';
			if ($scope.customer.length == 1 && index == 0) {
				$scope.selectedCustomer = $scope.customer[index];
				oneRow = 'info';
			}
			return oneRow;
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:NavcontrollerCtrl
 * @description
 * # NavcontrollerCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('NavCtrl', function(
		$scope,
		$location,
		$state,
		Session,
		SETTINGS,
		managementSettings,
		$translate
	) {
		$scope.showLogin = false;
		$scope.showLogout = true;
		$scope.fullname = 'name';
		$scope.version = SETTINGS.version;
		$scope.stream = Session.stream;
		$scope.sidenavopen = true;
		$scope.navInfo = Session;
		$scope.language = Session.getLanguage();
		$scope.selectLanguage = function() {
			$translate.use($scope.language);
		};
		$scope.getClass = function(path) {
			return $location.path() === path ? 'active' : '';
		};
		$scope.openLeftMenu = function() {
			$scope.sidenavopen = !$scope.sidenavopen;
		};

		$scope.openSettings = function() {
			if (Session.stream == 'beehome') {
				$location.path('/harvest/settings');
			} else if (Session.stream == 'farmer') {
				$scope.season = Session.getFarmerSeason();
				$scope.season = Session.farmerSeason;
				$state.go('/farmerSettings');
			} else if (Session.stream == 'management') {
				$scope.season = Session.getManagementSeason();
				$scope.season = Session.managementSeason;
				managementSettings();
			}
		};

		function checkSession() {
			$scope.stream = Session.stream;
			$scope.fullname = Session.getName();
			$scope.organisationID = Session.getOrganisationID();
			$scope.season = Session.harvestSeason;
			if (Session.stream === 'farmer') {
				$scope.season = Session.farmerSeason;
			} else if (Session.stream === 'beehome') {
				$scope.season = Session.harvestSeason;
			} else if (Session.stream === 'management') {
				$scope.season = Session.managementSeason;
			} else {
				$scope.season = null;
			}
		}
		Session.registerObserverCallback(checkSession);

		function updateDailyCount() {
			$scope.dailyCount = Session.dailyCount;
		}
		Session.registerDailyCountCallback(updateDailyCount);
		Session.getDailyCount();
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DatasavedmodalCtrl
 * @description
 * # DatasavedmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DatasavedmodalCtrl', function($scope, $modalInstance, $state) {
		$scope.cancel = function() {
			$modalInstance.dismiss('cancel');
		};
		$scope.reload = function() {
			$state.reload();
			$modalInstance.dismiss('cancel');
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:focusMe
 * @description
 * # focusMe
 */
angular.module('wildBieneHarvestApp').directive('focusMe', function($timeout) {
	return {
		scope: {
			trigger: '@focusMe'
		},
		link: function(scope, element) {
			scope.$watch('trigger', function(value) {
				if (value === 'true') {
					$timeout(function() {
						element[0].focus();
					}, 1000);
				}
			});
		}
	};
});

angular
	.module('wildBieneHarvestApp')
	.directive('autoFocus', function($timeout) {
		return {
			link: function(scope, element, attrs) {
				attrs.$observe('autoFocus', function(newValue) {
					if (newValue === 'true')
						$timeout(function() {
							element.focus();
						});
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ErrormodalCtrl
 * @description
 * # ErrormodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ErrormodalCtrl', function(
		$scope,
		$modalInstance,
		message,
		title
	) {
		$scope.message = message;
		$scope.title = title;
		$scope.cancel = function() {
			$modalInstance.dismiss();
		};
	});

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:OrdermodalCtrl
 * @description
 * # OrdermodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('OrdermodalCtrl', function(
		$scope,
		$timeout,
		$mdDialog,
		$http,
		SETTINGS,
		$filter,
		editOrder,
		farmer,
		Session,
		selectPhrasesService,
		isOrder,
		organisationVATs,
		taxInclusive,
		defaultTax,
		NotifyUser,
		type,
		orderService,
		$q,
		defaultCurrency
	) {
		// title
		$scope.title = 'Order Details';

		// variables
		var order = angular.copy(editOrder);
		$scope.activeOrderItem = {};
		$scope.showRowEditor = true;
		$scope.addLineTitle = 'Save Line';
		$scope.activeIndex = -1;
		$scope.taxInclusive = taxInclusive;
		$scope.defaultTax = defaultTax;
		$scope.discountPercentageExists = false;
		$scope.discountFixedExists = false;
		$scope.type = type;
		$scope.orderService = orderService;

		$scope.organisationVATs = organisationVATs;
		$scope.currentFarmer = farmer;

		$scope.texts = [];
		$scope.counts = [];
		$scope.prices = [];

		var defaultOrderItemType = {};
		$scope.sortedVATs = {};
		angular.forEach(organisationVATs, function(vatData) {
			$scope.sortedVATs[vatData.salesProductID] = vatData.value;
		});

		console.log('farmer', farmer);
		var languageId = farmer.language ? farmer.language.ID : farmer.LANG_ID;
		var organisationId = farmer.organisation
			? farmer.organisation.ID
			: farmer.OWNER_ID;
		var phrases_array = $filter('selectphrases')(
			Session.allPhrases,
			languageId,
			organisationId,
			'Order'
		);

		selectPhrasesService.populate(languageId).then(function(phrases) {
			$scope.productDescriptions = phrases.products;
		});
		$scope.vatTotal = 0;
		$scope.orderTotal = 0;
		$scope.orderTotalWithoutDiscount = 0;
		$scope.minStands = 0;
		$scope.seasons = [];
		$scope.showPrice = true;
		$scope.showQuantity = true;
		$scope.isOrder = isOrder;
		var tempSeason = new Date().getFullYear() - 1;
		$scope.cul = 2016;
		for (var i = 0; i < 5; i++) {
			$scope.seasons.push(tempSeason + i);
		}
		$scope.number = 2017;
		$scope.numbers = [];
		for (var i = 0; i < 5; i++) {
			$scope.numbers.push(tempSeason + i);
		}

		$scope.$watch('activeOrderItem.type', setNewlineDefaults);

		$scope.products = farmer.allProducts;

		$scope.contractTypes = Session.allContractTypes; //data;

		$scope.setDefaultExpiryDate = function() {
			$http
				.get(
					SETTINGS.APIBasePath +
						'organisation/expiry-date/' +
						(farmer.organisation ? farmer.organisation.id : farmer.OWNER_ID)
				)
				.then(function(result) {
					$scope.order.expiryDate = result.data.expiryDate;
				});
		};

		$scope.order = {};
		if (order != null) {
			$scope.order.date = order.date;
			if (order.cultureItems) {
				$scope.order.cultureItems = order.cultureItems;
			}
			if ($scope.type === 'copy') {
				$scope.order.ERPDisplayID = null;
				$scope.order.date = moment(new Date()).format('YYYY-MM-DD');
			}
		} else {
			$scope.order.date = new Date();
			$scope.setDefaultExpiryDate();
			$scope.order.cultureItems = [];
		}

		$scope.contractTypes = Session.allContractTypes; //data;

		for (var i = 0; i < $scope.contractTypes.length; i++) {
			if (order !== null && order.contractTypeID === $scope.contractTypes[i].ID) {
				$scope.order.contractType = $scope.contractTypes[i];
			} else if ($scope.contractTypes[i].DEFLT === 'Y') {
				$scope.order.contractType = $scope.contractTypes[i];
			}
		}

		$scope.paymentTypes = Session.paymentOptions.types;

		for (var i = 0; i < $scope.paymentTypes.length; i++) {
			if (order !== null && order.paymentTypeID === $scope.paymentTypes[i].ID) {
				$scope.order.paymentType = $scope.paymentTypes[i];
				break;
			} else if ($scope.paymentTypes[i].DEFLT === 'Y') {
				$scope.order.paymentType = $scope.paymentTypes[i];
			}
		}

		$scope.paymentTerms = Session.paymentOptions.terms;

		for (var i = 0; i < $scope.paymentTerms.length; i++) {
			if (order !== null && order.paymentTermID === $scope.paymentTerms[i].ID) {
				$scope.order.paymentTerm = $scope.paymentTerms[i];
				break;
			} else if ($scope.paymentTerms[i].DEFLT === 'Y') {
				$scope.order.paymentTerm = $scope.paymentTerms[i];
			}
		}

		$scope.currencies = Session.currencies;
		for (var i = 0; i < $scope.currencies.length; i++) {
			if (order !== null && order.currency === $scope.currencies[i].code) {
				$scope.order.currency = $scope.currencies[i];
			} else if ($scope.currencies[i].DEFLT === 'Y') {
				$scope.order.currency = $scope.currencies[i];
			}
		}

		var today = new Date();
		$scope.minPaymentInvoiceDate = new Date(today);
		$scope.minPaymentInvoiceDate.setDate(
			$scope.minPaymentInvoiceDate.getDate() + 1
		);

		$scope.order.downpayment = 0.0;
		if (order !== null) {
			$scope.showRowEditor = false;
			$scope.addLineTitle = 'Add Line';
			$scope.order.numStands = Number(order.numStands);
			$scope.order.expiryDate = order.expiryDate;
			$scope.order.downpayment = parseFloat(order.downpayment);
			$scope.order.statusDescription = order.statusDescription;

			if ($scope.type === 'edit') {
				$scope.order.invoicedAt = order.invoicedAt;
				$scope.order.paymentInvoiceDate = order.paymentInvoiceDate;
				for (var i = 0; i < $scope.seasons.length; i++) {
					if (parseInt($scope.seasons[i]) === parseInt(order.season)) {
						$scope.order.season = $scope.seasons[i];
					}
				}
			} else {
				$scope.order.season = parseInt(Session.farmerSeason);
			}
			$scope.editOrderSeason = angular.copy($scope.order.season);

			$scope.order.standPrice = Number(order.standPrice);
			$scope.order.ID = order.ID;
			$scope.order.orderItems = [];
		} else {
			$scope.order.orderItems = [];
		}

		if (order === null) {
			for (var i = 0; i < $scope.currencies.length; i++) {
				if ($scope.currencies[i].code === defaultCurrency.code) {
					$scope.order.currency = $scope.currencies[i];
				}
			}
			var farmerSeason = Session.farmerSeason;
			for (var i = 0; i < $scope.seasons.length; i++) {
				if (parseInt($scope.seasons[i]) === parseInt(farmerSeason)) {
					$scope.order.season = $scope.seasons[i];
				}
			}
		}

		function setDefaultPosition() {
			for (var i = 0; i < $scope.positionTypes.length; i++) {
				if ($scope.positionTypes[i].defaultType === 'Y') {
					$scope.activeOrderItem.type = $scope.positionTypes[i];
					defaultOrderItemType = $scope.positionTypes[i];
					setNewlineDefaults();
				}
			}
		}

		$scope.clearLine = function() {
			angular.forEach($scope.order.orderItems, function(
				orderItem,
				orderItemIndex
			) {
				$scope.order.orderItems[orderItemIndex].pos = orderItemIndex + 1;
			});

			$scope.showRowEditor = false;
			$scope.activeOrderItem = {};
			$scope.activeOrderItem.type = defaultOrderItemType;
			$scope.showRowEditor = false;
			$scope.addLineTitle = 'New Line';
			$scope.quantityRequired = false;
			$scope.priceRequired = false;
			$scope.texts = [];
			$scope.counts = [];
			$scope.prices = [];
		};

		$scope.updateDescription = function(type) {
			var vatText = $scope.sortedVATs[$scope.activeOrderItem.product.ID];
			$scope.setText(
				type,
				$scope.productDescriptions[$scope.activeOrderItem.product.SPROD_CD]
			);
			$scope.activeOrderItem.text =
				$scope.productDescriptions[$scope.activeOrderItem.product.SPROD_CD];
			$scope.activeOrderItem.vat = vatText
				? parseFloat(vatText)
				: $scope.defaultTax;
		};

		$scope.setText = function(type, text) {
			$scope.texts[type] = text;
		};

		$scope.getText = function(type) {
			return $scope.texts[type] !== undefined ? $scope.texts[type] : '';
		};

		$scope.setCount = function(type, count) {
			if (type !== undefined) {
				$scope.counts[type] = count;
			}
		};

		$scope.getCount = function(type) {
			return $scope.counts[type] !== undefined ? $scope.counts[type] : null;
		};

		$scope.setPrice = function(type, price) {
			if (type !== undefined) {
				$scope.prices[type] = price;
			}
		};

		$scope.getPrice = function(type) {
			return $scope.prices[type] !== undefined ? $scope.prices[type] : null;
		};

		function setNewlineDefaults() {
			if ($scope.activeOrderItem.type) {
				$timeout(function() {
					switch ($scope.activeOrderItem.type.code.toLowerCase()) {
						case 'product':
							$timeout(function() {
								$scope.setDefaultProduct('product');
								$scope.quantityTitle = '#';
								$scope.quantityRequired = true;
								$scope.priceRequired = true;
								$scope.priceVisible = true;
								$scope.quantityVisible = true;
								$scope.priceTitle = 'EA';
								$scope.activeOrderItem.text = $scope.getText('product');
								$scope.activeOrderItem.amount = $scope.getCount('product');
								$scope.activeOrderItem.price = $scope.getPrice('product');
								$scope.setProductDescription('product');
							}, 10);
							break;
						case 'discount_perct':
							$scope.quantityVisible = false;
							$timeout(function() {
								$scope.quantityTitle = '%';
								$scope.quantityRequired = false;
								$scope.priceVisible = true;
								$scope.priceRequired = false;
								$scope.quantityVisible = false;
								$scope.priceTitle = '%';
								$scope.setText('discount_perct', phrases_array.discountPercentage);
								$scope.setCount('discount_perct', 1);
								$scope.activeOrderItem.text = $scope.getText('discount_perct');
								$scope.activeOrderItem.amount = $scope.getCount('discount_perct');
								$scope.activeOrderItem.price = $scope.getPrice('discount_perct');
							}, 10);
							break;
						case 'discount_fixed':
							$timeout(function() {
								$scope.quantityTitle = '# Units';
								$scope.quantityRequired = true;
								$scope.priceRequired = true;
								$scope.quantityVisible = false;
								$scope.priceVisible = true;
								$scope.priceTitle = 'Less';
								$scope.setText('discount_fixed', phrases_array.discountFixed);
								$scope.setCount('discount_fixed', 1);
								$scope.activeOrderItem.text = $scope.getText('discount_fixed');
								$scope.activeOrderItem.amount = $scope.getCount('discount_fixed');
								$scope.activeOrderItem.price = $scope.getPrice('discount_fixed');
							});
							break;
						case 'free':
							$scope.quantityTitle = 'Amount';
							$scope.quantityRequired = false;
							$scope.priceRequired = false;
							$scope.quantityVisible = true;
							$scope.priceVisible = true;
							$scope.priceTitle = 'Price';
							$scope.activeOrderItem.text = $scope.getText('free');
							$scope.activeOrderItem.amount = $scope.getCount('free');
							$scope.activeOrderItem.price = $scope.getPrice('free');
							break;
						case 'shipping':
							$timeout(function() {
								$scope.quantityRequired = false;
								$scope.priceRequired = true;
								$scope.quantityVisible = false;
								$scope.priceVisible = true;
								$scope.priceTitle = 'Price';
								$scope.setText('shipping', phrases_array.shipping);
								$scope.setCount('shipping', 1);
								$scope.activeOrderItem.text = $scope.getText('shipping');
								$scope.activeOrderItem.amount = $scope.getCount('shipping');
								$scope.activeOrderItem.price = $scope.getPrice('shipping');
							});
							break;
						case 'text':
							$timeout(function() {
								$scope.quantityVisible = false;
								$scope.quantityRequired = false;
								$scope.priceVisible = false;
								$scope.priceRequired = false;
								$scope.quantityVisible = false;
								$scope.setCount('text', 0);
								$scope.setPrice('text', 0);
								$scope.activeOrderItem.text = $scope.getText('text');
								$scope.activeOrderItem.amount = $scope.getCount('text');
								$scope.activeOrderItem.price = $scope.getPrice('text');
							}, 10);
							break;
						case 'replacement':
							$timeout(function() {
								$scope.setDefaultProduct('replacement');
								$scope.quantityTitle = '#';
								$scope.quantityRequired = true;
								$scope.priceRequired = true;
								$scope.priceVisible = true;
								$scope.quantityVisible = true;
								$scope.priceTitle = 'EA';
								$scope.activeOrderItem.text = $scope.getText('replacement');
								$scope.activeOrderItem.amount = $scope.getCount('replacement');
								$scope.activeOrderItem.price = $scope.getPrice('replacement');
								$scope.setProductDescription('replacement');
							}, 10);
							break;
					}
				});
			}
		}

		/**
		 * Set description on product and replacement. This is must have for product and replacement
		 * because if we change position type, product on activeOrderItem is same, but it's not updated after change
		 * @param {string} type
		 */
		$scope.setProductDescription = function(type) {
			if ($scope.activeOrderItem.product !== undefined) {
				$scope.updateDescription(type);
			}
		};

		/**
		 * Set default product from products
		 * @param {string} type
		 */
		$scope.setDefaultProduct = function(type) {
			angular.forEach($scope.products, function(product) {
				if (product.DEFLT === 'Y') {
					$scope.activeOrderItem.product = product;
					$scope.updateDescription(type);
				}
			});
		};

		$scope.updatePrice = function() {
			if ($scope.order.numStands < 3) {
				$scope.order.standPrice = 240;
			} else if ($scope.order.numStands < 6) {
				$scope.order.standPrice = 220;
			} else {
				$scope.order.standPrice = 200;
			}
		};
		$scope.updateOrderItemTotal = function(oi) {
			if (oi.type) {
				switch (oi.type.code.toLowerCase()) {
					case 'discount_perct':
						oi.subtotal = -Number(
							(Number($scope.orderTotalWithoutDiscount) *
								(Number(oi.price) / 100) *
								100) /
								100
						).toFixed(2);
						oi.percentage = Number(oi.price).toFixed(2) + '%';
						$scope.discountPercentageExists = true;
						break;
					case 'discount_fixed':
						oi.subtotal = -oi.price;
						oi.percentage =
							Number(
								(Number(oi.price) / Number($scope.orderTotalWithoutDiscount)) * 100
							).toFixed(2) + '%';
						$scope.discountFixedExists = true;
						break;
					default:
						oi.subtotal = oi.price * oi.amount;
						var discountPerc = 0;
						var discountFixed = 0;
						var fixedDiscountValue = null;

						// Firstly, we need to substract percentage discount that is directly on order item
						if (oi.discount) {
							oi.subtotal = (oi.subtotal * (100 - oi.discount)) / 100;
						}

						oi.discountedTotal = oi.subtotal;
						for (var i = 0; i < $scope.order.orderItems.length; i++) {
							if (
								$scope.order.orderItems[i].type.code.toLowerCase() === 'discount_perct'
							) {
								discountPerc = $scope.order.orderItems[i].price / 100;
							}

							if (
								$scope.order.orderItems[i].type.code.toLowerCase() === 'discount_fixed'
							) {
								discountFixed =
									Number(oi.subtotal) / Number($scope.orderTotalWithoutDiscount);
								fixedDiscountValue = Number($scope.order.orderItems[i].price);
							}
						}

						oi.discountedTotal = oi.subtotal - oi.subtotal * discountPerc;
						if (fixedDiscountValue !== null) {
							oi.discountedTotal =
								oi.discountedTotal - fixedDiscountValue * discountFixed;
						}

						if (!oi.vat) {
							oi.vat = $scope.defaultTax;
						}
						if (Number(oi.price) > 0) {
							if ($scope.taxInclusive && $scope.taxInclusive == 1) {
								oi.subvat =
									(oi.discountedTotal / (100 + Number(oi.vat.VALUE))) *
									Number(oi.vat.VALUE);
							} else {
								oi.subvat = (oi.discountedTotal / 100) * Number(oi.vat.VALUE);
							}
						}
						break;
				}
			}
		};
		$scope.addLineItem = function() {
			if ($scope.showRowEditor) {
				if (!$scope.selectedOrderItem) {
					var noi = {
						pos: $scope.order.orderItems.length + 1,
						type: $scope.activeOrderItem.type,
						product: $scope.activeOrderItem.product,
						amount: $scope.activeOrderItem.amount,
						price: $scope.activeOrderItem.price,
						text: $scope.activeOrderItem.text,
						subtotal: Number($scope.activeOrderItem.subtotal),
						percentage: null,
						vat: $scope.activeOrderItem.vat,
						discount: $scope.activeOrderItem.discount,
						components: [],
						minOrderAmount: $scope.activeOrderItem.minOrderAmount
					};

					if (
						$scope.activeOrderItem.type.code.toLowerCase() === 'shipping' ||
						$scope.activeOrderItem.type.code.toLowerCase() === 'free'
					) {
						noi.vat = $scope.defaultTax;
					}

					$scope.order.orderItems.push(noi);

					cleanupOrderItems('Shipping');
					cleanupOrderItems('Discount_perct');
					cleanupOrderItems('Discount_fixed');
					cleanupOrderItems('Text');
				} else {
					$scope.selectedOrderItem.price = $scope.activeOrderItem.price;
					$scope.selectedOrderItem.amount = $scope.activeOrderItem.amount;
					$scope.selectedOrderItem.subtotal = $scope.activeOrderItem.subtotal;
					$scope.selectedOrderItem.text = $scope.activeOrderItem.text;
					$scope.selectedOrderItem.type = $scope.activeOrderItem.type;
					$scope.selectedOrderItem.product = $scope.activeOrderItem.product;
					$scope.selectedOrderItem.percentage = $scope.activeOrderItem.percentage;
					$scope.selectedOrderItem.vat = $scope.activeOrderItem.vat;
					$scope.selectedOrderItem.discount = $scope.activeOrderItem.discount;
				}
				calculateTotal();
				$scope.clearLine();
			} else {
				$scope.showRowEditor = true;
				$scope.addLineTitle = 'Save Line';
			}
			setDefaultPosition();
			deselectItems();
		};

		// Set correct order to order items
		function cleanupOrderItems(type) {
			var itemIndex = -1;

			for (var i = 0; i < $scope.order.orderItems.length; i++) {
				if ($scope.order.orderItems[i].type.code === type) {
					itemIndex = i;
				}
			}

			if (itemIndex > -1) {
				$scope.order.orderItems.push(
					$scope.order.orderItems.splice(itemIndex, 1)[0]
				);
			}
		}

		function deselectItems() {
			$scope.selectedOrderItem = null;
			$('.order-line').removeClass('info');
		}

		$scope.updateOrderAmount = function() {
			var ordered = 0;
			for (var i = 0; i < $scope.order.orderItems.length; i++) {
				if (
					$scope.order.orderItems[i].type.code.toLowerCase() == 'product' ||
					$scope.order.orderItems[i].type.code.toLowerCase() == 'replacement' ||
					$scope.order.orderItems[i].type.code.toLowerCase() == 'shipping'
				) {
					ordered += $scope.order.orderItems[i].amount;
				}
			}
			if ($scope.selectedOrderItem && $scope.selectedOrderItem.amount) {
				ordered -= $scope.selectedOrderItem.amount;
			}
			if (
				($scope.activeOrderItem.type.code.toLowerCase() === 'product' ||
					$scope.activeOrderItem.type.code.toLowerCase() === 'replacement') &&
				$scope.activeOrderItem.amount &&
				$scope.activeOrderItem.product !== undefined
			) {
				ordered = $scope.activeOrderItem.amount;
				var largest = 0;
				for (var i = 0; i < $scope.activeOrderItem.product.prices.length; i++) {
					if (
						ordered >=
							Number($scope.activeOrderItem.product.prices[i].THRESHOLD_AMT) &&
						$scope.activeOrderItem.product.prices[i].THRESHOLD_AMT > largest
					) {
						$scope.activeOrderItem.price = Number(
							$scope.activeOrderItem.product.prices[i].PRICE_PER_PIECE
						);
						largest = Number($scope.activeOrderItem.product.prices[i].THRESHOLD_AMT);
					}
				}
				// if ($scope.activeOrderItem.product.defaultPrice !== null) {
				// 	$scope.activeOrderItem.price = $scope.activeOrderItem.product.defaultPrice;

				// }
				// if ($scope.activeOrderItem.product.bulkThreshold && $scope.activeOrderItem.product.bulkThreshold && $scope.activeOrderItem.product.bulkPrice && $scope.activeOrderItem.product.bulkPrice !== 0 && $scope.activeOrderItem.product.bulkThreshold <= ordered) {
				// 	$scope.activeOrderItem.price = $scope.activeOrderItem.product.bulkPrice;
				// }
			}

			$scope.updateOrderItemTotal($scope.activeOrderItem);
			calculateTotal();
		};
		$scope.selectProduct = function(index) {
			$scope.order.product = $scope.products[index];
			$scope.order.productCode = $scope.products[index].PROD_CD;
			$scope.order.productID = $scope.products[index].ID;
		};
		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$scope.order.taxInclusive = $scope.taxInclusive;
			$scope.farmer = farmer;
			if ($scope.type === 'edit' && $scope.order.ID) {
				// confirm save
				if ($scope.order != undefined && $scope.order.ERPDisplayID != null) {
					var confirm = $mdDialog
						.confirm()
						.clickOutsideToClose(true)
						.title('Warning')
						.textContent(
							'This order has already been invoiced. Are you sure you want to save your changes?'
						)
						.ok('Save order')
						.cancel('Cancel');
					$mdDialog.show(confirm).then(
						function() {
							orderService.saveOrder(
								$scope.order,
								type,
								$scope.farmer,
								$scope.taxInclusive
							);
						},
						function() {
							// Data passed from modal are not the same as were the data passed in so we should normalize it
							// scope.normalizeDataBeforeEdit($scope.order, type);
						}
					);
				} else {
					orderService.saveOrder(
						$scope.order,
						type,
						$scope.farmer,
						$scope.taxInclusive
					);
				}
			} else {
				orderService
					.saveOrder($scope.order, type, $scope.farmer, $scope.taxInclusive)
					.then(function(data) {
						$mdDialog.hide(data.data.orders);
					});
			}
			$mdDialog.hide($scope.order);
			// $modalInstance.close($scope.order)
		};

		$scope.deleteOrderItem = function() {
			for (var i = 0; i < $scope.order.orderItems.length; i++) {
				if ($scope.order.orderItems[i].pos === $scope.selectedOrderItem.pos) {
					$scope.order.orderItems.splice(i, 1);
				}
			}
			deselectItems();
			calculateTotal();
			$scope.clearLine();
		};
		$scope.editOrderItem = function() {
			$scope.setText(
				$scope.selectedOrderItem.type.code.toLowerCase(),
				$scope.selectedOrderItem.text
			);
			$scope.setCount(
				$scope.selectedOrderItem.type.code.toLowerCase(),
				$scope.selectedOrderItem.amount
			);
			$scope.setPrice(
				$scope.selectedOrderItem.type.code.toLowerCase(),
				$scope.selectedOrderItem.price
			);
			$scope.activeOrderItem.price = $scope.selectedOrderItem.price;
			$scope.activeOrderItem.amount = $scope.selectedOrderItem.amount;
			$scope.activeOrderItem.subtotal = $scope.selectedOrderItem.subtotal;
			$scope.activeOrderItem.text = $scope.selectedOrderItem.text;
			$scope.activeOrderItem.type = $scope.selectedOrderItem.type;
			$scope.activeOrderItem.product = $scope.selectedOrderItem.product;
			$scope.activeOrderItem.vat = $scope.selectedOrderItem.vat;
			$scope.activeOrderItem.discount = $scope.selectedOrderItem.discount;
			$scope.activeOrderItem.components = $scope.selectedOrderItem.components;
			$scope.activeOrderItem.minOrderAmount =
				$scope.selectedOrderItem.minOrderAmount;
			$scope.showRowEditor = true;
			$scope.addLineTitle = 'Save Line';
		};
		$scope.selectOrderItem = function(index) {
			$('.order-line').removeClass('info');
			$('.order-line' + index).addClass('info');
			$scope.selectedOrderItem = $scope.order.orderItems[index];
		};

		$scope.discountAlert = function(position) {
			if (
				(position.code == 'Discount_perct' && $scope.discountPercentageExists) ||
				(position.code == 'Discount_fixed' && $scope.discountFixedExists)
			) {
				var discountType =
					position.code == 'Discount_perct' ? 'percentage' : 'fixed';
				NotifyUser(
					'Unable to add a ' +
						discountType +
						' discount. Please update the existing  ' +
						discountType +
						' discount item.'
				);
			}
		};

		$scope.getMergedRatesIds = function() {
			var rates = [];
			angular.forEach($scope.order.orderItems, function(value) {
				if (
					value.type.code.toLowerCase() !== 'discount_fixed' &&
					value.type.code.toLowerCase() !== 'discount_perct' &&
					!rates.includes(value.vat.ID)
				) {
					rates.push(value.vat.ID);
				}
			});
			return rates;
		};

		$scope.valueByRateId = function(rateId) {
			var finalValue = 0;

			var percentageDiscount = null;
			var fixedDiscount = null;

			if ($scope.discountFixedExists) {
				var filteredOrderItem = $scope.order.orderItems.filter(function(value) {
					return value.type.code.toLowerCase() === 'discount_fixed';
				});

				if (filteredOrderItem.length > 0) {
					fixedDiscount = filteredOrderItem[0].price;
				}
			}

			if ($scope.discountPercentageExists) {
				var filteredOrderItem = $scope.order.orderItems.filter(function(value) {
					return value.type.code.toLowerCase() === 'discount_perct';
				});

				if (filteredOrderItem.length > 0) {
					percentageDiscount = filteredOrderItem[0].price / 100;
				}
			}
			var rate = Number($scope.getRateById(rateId).VALUE);

			angular.forEach($scope.order.orderItems, function(value) {
				if (
					value.type.code.toLowerCase() !== 'discount_perct' &&
					value.type.code.toLowerCase() !== 'discount_fixed' &&
					parseInt(value.vat.ID) === parseInt(rateId)
				) {
					var rowTotal = value.subtotal;

					if (percentageDiscount !== null) {
						rowTotal = rowTotal - rowTotal * percentageDiscount;
					}

					if (fixedDiscount !== null) {
						rowTotal =
							rowTotal -
							fixedDiscount * (value.subtotal / $scope.orderTotalWithoutDiscount);
					}

					if ($scope.taxInclusive && $scope.taxInclusive == 1) {
						// Item already contains VAT so subtract it
						finalValue += (rowTotal / (100 + rate)) * rate;
					} else {
						// Item does not contain VAT so calculate it
						finalValue += (rowTotal / 100) * rate;
					}
				}
			});
			return finalValue;
		};

		$scope.getRateById = function(rateId) {
			var test = $scope.organisationVATs.filter(function(value) {
				return parseInt(value.ID) === parseInt(rateId);
			});
			return test[0];
		};

		$scope.calculate = function() {
			calculateTotal();
		};

		$scope.selected = function(orderItemVatId, organisationVatId) {
			return parseInt(orderItemVatId) === parseInt(organisationVatId);
		};

		$scope.setPreviouslyEnteredVATAsDefault = function(order) {
			if (
				order.type.code.toLowerCase() === 'product' ||
				order.type.code.toLowerCase() === 'shipping' ||
				order.type.code.toLowerCase() === 'free'
			) {
				$scope.defaultTax = order.vat;
			}
		};

		$scope.setDefaultContractType = function() {
			if ($scope.type === 'edit' && farmer.activeSubscription.ID !== undefined) {
				$scope.order.contractType = $filter('filter')($scope.contractTypes, {
					ID: farmer.activeSubscription.TYPE_ID
				})[0];
			}
			$scope.setDefaultSeason();
		};

		function calculateTotal() {
			$scope.vatTotal = 0;
			$scope.orderTotal = 0;
			$scope.orderTotalWithoutDiscount = 0;
			$scope.discountPercentageExists = false;
			$scope.discountFixedExists = false;

			for (var i = 0; i < $scope.order.orderItems.length; i++) {
				if (
					$scope.order.orderItems[i].type.code.toLowerCase() !== 'discount_perct' &&
					$scope.order.orderItems[i].type.code.toLowerCase() !== 'discount_fixed'
				) {
					$scope.orderTotalWithoutDiscount += Number(
						$scope.order.orderItems[i].subtotal
					);
				}
			}

			for (var i = 0; i < $scope.order.orderItems.length; i++) {
				$scope.updateOrderItemTotal($scope.order.orderItems[i]);

				$scope.orderTotal += Number($scope.order.orderItems[i].subtotal);
				if ($scope.order.orderItems[i].subvat) {
					$scope.vatTotal += Number($scope.order.orderItems[i].subvat);
				}
			}

			if (!$scope.taxInclusive || $scope.taxInclusive != 1) {
				$scope.orderTotal += $scope.vatTotal;
			}
			$scope.orderTotalWithoutDiscount = $scope.orderTotalWithoutDiscount.toFixed(
				2
			);
			$scope.orderTotal = $scope.orderTotal.toFixed(2);
			$scope.vatTotal = $scope.vatTotal.toFixed(2);
		}

		function updateOrderPositionTypes() {
			var delay = $q.defer();
			$scope.order.orderItems = [];
			$scope.positionTypes = Session.allPositions.positions;
			setDefaultPosition();
			if (order != null) {
				for (var i = 0; i < order.orderItems.length; i++) {
					for (var j = 0; j < $scope.positionTypes.length; j++) {
						if ($scope.positionTypes[j].ID == order.orderItems[i].positionType) {
							order.orderItems[i].type = $scope.positionTypes[j];
						}
					}
					order.orderItems[i].amount = Number(order.orderItems[i].amount);
					order.orderItems[i].price = Number(order.orderItems[i].price);
					order.orderItems[i].discount = Number(order.orderItems[i].discount);

					setVat(i);

					for (var j = 0; j < $scope.products.length; j++) {
						if ($scope.products[j].ID == order.orderItems[i].productID) {
							order.orderItems[i].product = $scope.products[j];
						}
					}

					$scope.order.orderItems.push(order.orderItems[i]);
				}
			}
			delay.resolve(true);
			return delay.promise;
		}

		function setVat(orderItemIndex) {
			var setVat =
				order.orderItems[orderItemIndex].vat &&
				(order.orderItems[orderItemIndex].vat !== undefined ||
					order.orderItems[orderItemIndex].vat !== null)
					? order.orderItems[orderItemIndex].vat
					: $scope.defaultTax;
			order.orderItems[orderItemIndex].vat =
				order.orderItems[orderItemIndex].code.toLowerCase() !== 'discount_perct' &&
				order.orderItems[orderItemIndex].code.toLowerCase() !== 'discount_fixed' &&
				order.orderItems[orderItemIndex].code.toLowerCase() !== 'text'
					? setVat
					: null;
		}

		$scope.setDefaultSeason = function() {
			var contractTypeCode = $scope.order.contractType.code;
			$scope.contractTypeDisabled = false;
			$scope.editSeasonSelectable = {};

			if ($scope.type !== 'edit') {
				$scope.order.season = parseInt(Session.farmerSeason);
			}

			if (
				$scope.currentFarmer.subscriptionSeasonStatus &&
				$scope.currentFarmer.subscriptionSeasonStatus[contractTypeCode]
			) {
				for (var i = 0; i < $scope.seasons.length; i++) {
					var season = $scope.seasons[i];
					var subscriptionSeasonStatus =
						$scope.currentFarmer.subscriptionSeasonStatus[contractTypeCode][season];
					if ($scope.type !== 'edit') {
						if ($scope.order.season === season) {
							if (
								!subscriptionSeasonStatus ||
								subscriptionSeasonStatus.count ===
									subscriptionSeasonStatus.invoicedCount
							) {
								break;
							}
						} else {
							if ($scope.order.season < season) {
								if (!subscriptionSeasonStatus) {
									$scope.order.season = season;
									break;
								} else if (
									subscriptionSeasonStatus.count ===
									subscriptionSeasonStatus.invoicedCount
								) {
									$scope.order.season = season;
									break;
								}
							} else {
								$scope.order.season = null;
							}
						}
					} else {
						$scope.editSeasonSelectable[season] = true;
						if (subscriptionSeasonStatus && $scope.order.season !== season) {
							$scope.editSeasonSelectable[season] =
								subscriptionSeasonStatus.count ===
								subscriptionSeasonStatus.invoicedCount;
						}
					}
				}
			} else {
				if ($scope.type === 'edit') {
					$scope.contractTypeDisabled = $scope.currentFarmer.subscriptionSeasonStatus
						? false
						: true;
					for (var i = 0; i < $scope.seasons.length; i++) {
						$scope.editSeasonSelectable[$scope.seasons[i]] = true;
					}
				}
			}
		};

		$timeout(function() {
			$scope.setDefaultContractType();
			updateOrderPositionTypes().then(calculateTotal);
		});
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DashboardCtrl
 * @description
 * # DashboardCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DashboardCtrl', function(
		$location,
		$mdDialog,
		$http,
		Session,
		$scope
	) {
		Session.setStream('');
		Session.pageTitle = '';
		$scope.session = Session;
		if (Session.rights.indexOf('BeeHarvest Customer') > -1) {
			$scope.beehomeLink = '#/beehome/account';
		} else if (Session.rights.indexOf('Tube') > -1) {
			$scope.beehomeLink = '#/harvest/tubes';
		} else if (Session.rights.indexOf('Cocoon') > -1) {
			$scope.beehomeLink = '#/harvest/cocoons';
		} else if (Session.rights.indexOf('Harvest Check') > -1) {
			$scope.beehomeLink = '#/harvest/check';
		}
		if (Session.rights.indexOf('BeeFarmer') > -1) {
			$scope.farmerLink = '#/farmer/account';
		} else if (Session.rights.indexOf('Check Out') > -1) {
			$scope.farmerLink = '#/farmer/checkout';
		} else if (Session.rights.indexOf('Check In') > -1) {
			$scope.farmerLink = '#/farmer/checkin';
		}

		$scope.openHarvestSettings = function() {
			var confirm = $mdDialog
				.prompt()
				.title('Harvest Season')
				.textContent('Which season would you like to manage')
				.placeholder('Season')
				.ariaLabel('Season')
				// .initialValue('2016')
				.ok('Save')
				.cancel('Cancel');
			$mdDialog.show(confirm).then(
				function(result) {
					$scope.updateHarvestSeason(result);
				},
				function() {}
			);
		};
	});

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ContractCtrl
 * @description
 * # ContractCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ContractCtrl', function(
		$scope,
		$stateParams,
		$http,
		SETTINGS,
		$filter,
		client,
		CustomerLoader,
		Session,
		orderService,
		users,
		SubscriptionService,
		NotifyUser,
		orders,
		subscriptions,
		ContactFactory,
		languageFactory,
		SubscriptionLoader,
		OrderLoader
	) {
		$scope.barcodeLink = SETTINGS.barcodePath;
		$scope.clientID = $stateParams.cid;
		$scope.client = client;
		$scope.client.subscriptions = subscriptions;
		$scope.client.orders = orders;
		$scope.newProduct = {};
		$scope.client.seasons = [];
		$scope.today = new Date();
		$scope.currentSeason = Session.farmerSeason;
		$scope.rePopulate = rePopulate;
		$scope.initSeasons = initSeasons;

		var contactDetails = ContactFactory.getBillingContact($scope.client.contacts);
		languageFactory
			.getLanguage(contactDetails ? contactDetails.language : '')
			.then(function(data) {
				$scope.client.language = data;
			});
		// services
		$scope.orderService = orderService;
		$scope.subscriptionService = SubscriptionService;
		$scope.users = users;

		/**
		 * Initialization
		 */
		function init() {
			Session.setStream('farmer', 'Account ' + client.id, 'CLIENT_SEARCH');
			$scope.getOrganisation();
			$scope.getSalesProducts();
			initSeasons();
		}

		/**
		 * Iterate subscriptions to find list of all seasons, then filter subscriptions
		 * based on the season filter.
		 */
		function initSeasons() {
			var oldSeasons = $scope.client.seasons;
			$scope.getAllSeasons(true);
			if (oldSeasons) {
				$scope.updateSeasons(oldSeasons);
			}
			$scope.seasonSelected();
		}

		/**
		 * Re - Populate Orders and Subscriptions after client update
		 */
		function rePopulate() {
			SubscriptionLoader($scope.client.id).then(function(resSubscriptions) {
				$scope.client.subscriptions = resSubscriptions;
				OrderLoader($scope.client.id).then(function(resOrders) {
					$scope.client.orders = resOrders;
					init();
				});
			});
		}

		/**
		 * Get sales products
		 */
		$scope.getSalesProducts = function() {
			$http
				.get(
					SETTINGS.APIBasePath +
						'/sales-products/farmer/' +
						$scope.client.organisation.id
				)
				.then(function(result) {
					$scope.client.allProducts = result.data;
				});
		};

		/**
		 * Filter orders by season
		 * This is called when we select/deselect season checkbox
		 */
		$scope.seasonSelected = function() {
			$scope.client.checkedSeasons = [];
			angular.forEach($scope.client.seasons, function(season, seasonIndex) {
				if (season.show === true) {
					$scope.client.checkedSeasons.push(season.description);
				}
				angular.forEach($scope.client.subscriptions, function(
					subscription,
					subscriptionIndex
				) {
					var filteredOrders = [];
					angular.forEach(subscription.orders, function(order, orderIndex) {
						if (parseInt(season.description) === parseInt(order.season)) {
							$scope.setOrderShow(
								subscriptionIndex,
								orderIndex,
								$scope.client.seasons[seasonIndex].show
							);
						}
					});
					filteredOrders.push(orderService.getFilteredOrders(subscription.orders));
					$scope.setSubscriptionShow(
						subscriptionIndex,
						filteredOrders[filteredOrders.length - 1].length > 0
					);
				});
			});

			// show subscriptions without orders
			angular.forEach($scope.client.subscriptions, function(
				subscription,
				subscriptionIndex
			) {
				if (
					angular.isArray(subscription.orders) &&
					subscription.orders.length === 0
				) {
					$scope.setSubscriptionShow(subscriptionIndex, true);
				}
			});

			// Deselect subscription
			if (
				$scope.client.activeSubscription &&
				!$scope.client.activeSubscription.show
			) {
				$scope.client.activeSubscription = {};
			}
		};

		/**
		 * Set subscription show
		 * @param {number} index
		 * @param {boolean} value
		 */
		$scope.setSubscriptionShow = function(index, value) {
			$scope.client.subscriptions[index].show = value;
		};

		/**
		 * Set order show on subscription
		 * @param {number} subscriptionIndex
		 * @param {number} orderIndex
		 * @param {boolean} value
		 */
		$scope.setOrderShow = function(subscriptionIndex, orderIndex, value) {
			$scope.client.subscriptions[subscriptionIndex].orders[
				orderIndex
			].show = value;
		};

		/**
		 * Deselect all subscriptions, orders
		 */
		$scope.deselectAll = function() {
			$scope.client.activeSubscription = {};

			angular.forEach($scope.client.subscriptions, function(
				subscription,
				subscriptionIndex
			) {
				$scope.client.subscriptions[subscriptionIndex].selected = false;
			});
		};

		/**
		 * Get all seasons and select last season
		 */
		$scope.getAllSeasons = function(selectLast) {
			var subscriptionSeasonStatus = {};
			var seasonArray = [];
			var latestSeason = 0;
			var isSelected = $stateParams.action ? true : false;

			angular.forEach($scope.client.subscriptions, function(
				subscription,
				subscriptionIndex
			) {
				subscriptionSeasonStatus[subscription.CODE] = [];
				angular.forEach(subscription.orders, function(order, orderIndex) {
					var cSeason = parseInt(
						$scope.client.subscriptions[subscriptionIndex].orders[orderIndex].season
					);
					seasonArray.push({
						description: cSeason,
						show: isSelected
					});
					if (subscriptionSeasonStatus[subscription.CODE].indexOf(cSeason) < 0) {
						subscriptionSeasonStatus[subscription.CODE][cSeason] = {
							count: 0,
							invoicedCount: 0
						};
					}
					subscriptionSeasonStatus[subscription.CODE][cSeason].count += 1;
					if (order.invoicedAt) {
						subscriptionSeasonStatus[subscription.CODE][cSeason].invoicedCount += 1;
					}
					latestSeason = cSeason > parseInt(latestSeason) ? cSeason : latestSeason;
				});
			});

			seasonArray = $filter('uniqueArraybyId')(seasonArray, 'description');
			if (seasonArray.length === 1) {
				seasonArray[0].show = true;
			} else {
				angular.forEach(seasonArray, function(seasonValue, seasonIndex) {
					if (selectLast) {
						if (
							parseInt(seasonArray[seasonIndex].description) === parseInt(latestSeason)
						) {
							seasonArray[seasonIndex].show = true;
						}
					} else {
						seasonArray[seasonIndex].show = true;
					}
				});
			}
			$scope.client.seasons = seasonArray;
			$scope.client.subscriptionSeasonStatus = subscriptionSeasonStatus;
		};

		/**
		 * Update client
		 */
		$scope.updateClient = function() {
			CustomerLoader($scope.client.ID).then(function(newClient) {
				$scope.client = newClient;
			});
		};

		/**
		 * Get organisation
		 */
		$scope.getOrganisation = function() {
			$http
				.get(SETTINGS.APIBasePath + 'organisation/' + $scope.client.organisation.id)
				.then(function(response) {
					$scope.client.organisationVATs = response.data.rates;
					$scope.client.taxInclusive = response.data.taxInclusive;
					$scope.client.defaultTax = response.data.vat;
					$scope.client.defaultCurrency = response.data.defaultCurrency;
				});
		};

		/**
		 * Update seasons
		 */
		$scope.updateSeasons = function(oldSeasons) {
			angular.forEach($scope.client.seasons, function(
				currentSeason,
				currentSeasonIndex
			) {
				angular.forEach(oldSeasons, function(oldSeason) {
					if (
						parseInt($scope.client.seasons[currentSeasonIndex].description) ===
						parseInt(oldSeason.description)
					) {
						$scope.client.seasons[currentSeasonIndex].show = oldSeason.show;
					}
				});
			});
		};

		$scope.$watch('client', function(data) {
			if (data && !data.subscriptions) {
				rePopulate();
			}
		});
		init();
	});

/* eslint-disable no-global-assign */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:FarmersettingsCtrl
 * @description
 * # FarmersettingsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FarmersettingsCtrl', function(
		$scope,
		$http,
		$timeout,
		$interval,
		$window,
		$mdDialog,
		SETTINGS,
		farmerSettings,
		converter,
		Session
	) {
		Session.setStream('farmer');
		Session.pageTitle = 'Farmer Settings';

		$scope.season = Session.getFarmerSeason();

		var today = new Date();
		$scope.seasons = [
			today.getFullYear() - 2,
			today.getFullYear() - 1,
			today.getFullYear(),
			today.getFullYear() + 1,
			today.getFullYear() + 2
		];
		$scope.season = Session.getFarmerSeason();

		farmerSettings.getSeason().then(function(val) {
			for (var i = 0; i < $scope.seasons.length; i++) {
				if ($scope.seasons[i] == val) {
					$scope.season = $scope.seasons[i];
				}
			}
		});

		$scope.saveSeason = function() {
			farmerSettings.setSeason($scope.season);
			Session.setFarmerSeason($scope.season);
			// Session.notifyObservers();
		};
	});

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:farmerOrders
 * @description
 * # farmerOrders
 */
angular
	.module('wildBieneHarvestApp')
	.directive('farmerOrders', function(
		$http,
		$mdDialog,
		$timeout,
		$location,
		$stateParams,
		SETTINGS,
		Statuses,
		contracts,
		farmerProducts,
		printerService,
		AllPhrases,
		selectPhrasesService,
		orderService,
		ConfirmUser,
		$q,
		buttonLabelService
	) {
		return {
			templateUrl: 'views/order-panel.html',
			scope: {
				farmer: '='
			},

			link: function(scope) {
				// title
				scope.title = 'Orders';

				// variables
				scope.type = 'Order';
				scope.statuses = [];
				scope.contract = {};

				// services
				scope.orderService = orderService;
				scope.buttonLabelService = buttonLabelService;

				// state paramaters
				scope.stateParams = $stateParams;

				/**
				 * Initialization
				 */
				scope.init = function() {
					scope.selectSeason();
					scope.getStatuses();
					scope.getContracts();
					scope.setActiveOrderWatcher();
					/// TODO Is the function below necessary considering that there is a scope.selectLastOne() function that's called afterwards which means ths will be deselected ?
					// scope.preselectOrders();
					scope.deselectAllOrders();
					$timeout(function() {
						if (scope.stateParams.orderID === undefined) {
							scope.selectLastOne();
						}
						scope.getOrganisation().then(function() {
							if (scope.stateParams.orderID) {
								angular.forEach(scope.farmer.orders, function(v, k) {
									if (v.ID == scope.stateParams.orderID) {
										scope.selectOrder(k);
									}
								});
								switch (scope.stateParams.action) {
									case 'edit':
										scope.editOrder(scope.farmer.activeOrder, 'edit');
										break;
									case 'copy':
										scope.editOrder(scope.farmer.activeOrder, 'copy');
										break;
									case 'print':
										scope.printOrder();
										break;
									case 'cultures':
										scope.cultureItems();
										break;
								}
							}

							$stateParams['action'] = null;
							$stateParams['orderID'] = null;
						});
					}, 100);
				};

				/**
				 * Select season
				 */
				scope.selectSeason = function() {
					var today = new Date();
					scope.selectSeasons = [
						today.getFullYear() - 2,
						today.getFullYear(),
						today.getFullYear() + 1,
						today.getFullYear() + 2
					];
					scope.selectedSeason = today.getFullYear();
				};

				/**
				 * Update orders and select last one
				 */
				function updateOrders() {
					scope.refreshSubscriptions();
				}

				/**
				 * Get organisation
				 */
				scope.getOrganisation = function() {
					var delay = $q.defer();
					$http
						.get(
							SETTINGS.APIBasePath + 'organisation/' + scope.farmer.organisation.id
						)
						.then(
							function(response) {
								scope.organisationVATs = response.data.rates;
								scope.taxInclusive = response.data.taxInclusive;
								scope.defaultTax = response.data.vat;
								scope.defaultCurrency = response.data.defaultCurrency;
								delay.resolve(true);
							},
							function() {
								delay.reject(true);
							}
						);
					return delay.promise;
				};

				/**
				 * Deselect all orders
				 */
				scope.deselectAllOrders = function() {
					scope.farmer.activeOrder = null;
					scope.farmer.activeRequest = null;
					angular.forEach(scope.farmer.orders, function(orderValue, orderIndex) {
						scope.farmer.orders[orderIndex].selected = false;
					});
				};

				/**
				 * Check if season is selected
				 * @param orderSeason
				 * @returns {boolean}
				 */
				scope.inSeason = function(orderSeason) {
					return scope.farmer.checkedSeasons.indexOf(parseInt(orderSeason)) > -1;
				};

				/**
				 * Check if subscription is selected
				 * @param subscriptionId
				 * @returns {boolean}
				 */
				scope.isActive = function(subscriptionId) {
					return (
						scope.farmer.activeSubscription &&
						(!scope.farmer.activeSubscription.ID ||
							parseInt(subscriptionId) ===
								parseInt(scope.farmer.activeSubscription.ID))
					);
				};

				/**
				 * Get contracts
				 */
				scope.getContracts = function() {
					contracts.query(function(data) {
						scope.contracts = {};
						angular.forEach(data, function(dataValue, dataIndex) {
							scope.contracts[data[dataIndex].ID] = data[dataIndex];
						});
					});
				};

				farmerProducts.query(function() {
					scope.farmerProducts = {};
				});

				/**
				 * Print order
				 */
				scope.printOrder = function() {
					var phrase_document = scope.orderService.checkIfOrderIsOrderOrOffer(
						scope.farmer.activeOrder
					)
						? 'order'
						: 'offer';

					scope.$root.showLoader = true;
					printerService(
						phrase_document,
						scope.farmer.activeOrder,
						scope.farmer
					).then(function() {
						scope.$root.showLoader = false;
					});
				};

				/**
				 * Email order
				 */
				scope.emailOrder = function() {
					scope.$root.showLoader = true;
					var phrase_document = scope.orderService.checkIfOrderIsOrderOrOffer(
						scope.farmer.activeOrder
					)
						? 'order'
						: 'offer';

					printerService(
						phrase_document,
						scope.farmer.activeOrder,
						scope.farmer,
						true
					).then(function(documents) {
						scope.$root.showLoader = false;

						AllPhrases().then(function(docs) {
							var ph = selectPhrasesService.phrases(
								docs,
								scope.farmer.language.ID,
								scope.farmer.organisation.id,
								'EMAIL'
							).phraseList;
							var email_data = selectPhrasesService.prep_email(
								ph,
								phrase_document,
								scope.farmer.name
							).email_data;

							$mdDialog
								.show({
									controller: 'MailmodalCtrl',
									controllerAs: 'ctrl',
									templateUrl: 'views/mailmodal.html',
									parent: angular.element(document.body),
									locals: {
										farmer: scope.farmer,
										pdfLink: documents.pdfLink,
										fileName: documents.fileName,
										body: email_data.bodytext,
										subject: email_data.subject,
										docType: phrase_document,
										order: scope.farmer.activeOrder
									},
									fullscreen: true,
									clickOutsideToClose: true
								})
								.then(function(data) {
									scope.orderService.saveOrder(
										data,
										'edit',
										scope.farmer,
										scope.taxInclusive
									);
									updateOrders();
								});
						});
					});
				};

				/**
				 * Culture items modal
				 */
				scope.cultureItems = function() {
					$mdDialog
						.show({
							controller: 'OrderCulturesModalCtrl',
							templateUrl: 'views/order-cultures-modal.html',
							locals: {
								order: scope.farmer.activeOrder,
								customer: scope.farmer
							},
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: true
						})
						.then(function() {
							updateOrders();
						});
				};

				/**
				 * Normalize data before edit
				 * @param data
				 * @param {string} type
				 */
				scope.normalizeDataBeforeEdit = function(data, type) {
					var order = scope.farmer.activeOrder;

					if (
						typeof data.contractType === 'object' &&
						data.contractType !== undefined
					) {
						order.contractType = data.contractType.code;
						order.contractTypeID = data.contractType.ID;
					}

					if (typeof data.currency === 'object' && data.currency !== undefined) {
						order.currency = data.currency.code;
					}

					order.date = data.date;
					order.numStands = data.numStands;
					order.orderItems = data.orderItems;
					order.season = data.season.toString();
					order.standPrice = data.standPrice;

					return scope.editOrder(order, type);
				};

				/**
				 * Edit order
				 * @param data
				 * @param {string} type
				 */
				scope.editOrder = function(data, type) {
					var editOrder = data;
					$mdDialog
						.show({
							controller: 'OrdermodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/order-modal.html',
							parent: angular.element(document.body),
							locals: {
								editOrder: editOrder,
								farmer: scope.farmer,
								isOrder: scope.orderService.checkIfOrderIsOrderOrOffer(
									scope.farmer.activeOrder
								),
								organisationVATs: scope.organisationVATs,
								taxInclusive: scope.taxInclusive,
								defaultTax: scope.defaultTax,
								defaultCurrency: scope.defaultCurrency,
								type: type
							},
							resolve: {
								products: function(AllFarmerProductTypes) {
									return AllFarmerProductTypes();
								}
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(function() {
							updateOrders();
						});
				};

				/**
				 * Create order
				 */
				scope.createOrder = function(type) {
					$mdDialog
						.show({
							controller: 'OrdermodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/order-modal.html',
							parent: angular.element(document.body),
							locals: {
								editOrder: null,
								farmer: scope.farmer,
								isOrder: true,
								organisationVATs: scope.organisationVATs,
								taxInclusive: scope.taxInclusive,
								defaultTax: scope.defaultTax,
								defaultCurrency: scope.defaultCurrency,
								type: type
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(function() {
							// saveOrder(data);
							updateOrders();
						});
				};

				/**
				 * Select order
				 * @param {number} index
				 */
				scope.selectOrder = function(index) {
					scope.deselectAllOrders();
					angular.forEach(scope.farmer.orders, function(order) {
						if (parseInt(scope.farmer.orders[index].ID) === parseInt(order.ID)) {
							scope.farmer.orders[index].selected = true;
							scope.farmer.activeOrder = order;
						}
					});
				};

				/**
				 * Select last filtered order
				 */
				scope.selectLastOne = function() {
					var filteredOrders = orderService.getFilteredOrders(
						scope.farmer.activeSubscription.orders
					);
					if (filteredOrders !== undefined && filteredOrders.length > 0) {
						scope.selectOrder(filteredOrders.length - 1);
					}
				};

				/**
				 * Preselect order it orders table
				 */
				scope.preselectOrders = function() {
					var search = $location.search();
					if (search.order !== undefined) {
						angular.forEach(scope.farmer.activeSubscription.orders, function(order) {
							if (order.ID == search.order) {
								$timeout(function() {
									var index = $('.orders-table')
										.find('[data-orderId=' + order.ID + ']')
										.data('index');
									scope.selectOrder(index);
									$('.Offer-line').removeClass('info');
								});
							}
						});
					}
				};

				/**
				 * Delete order
				 */
				scope.deleteOrder = function() {
					ConfirmUser(
						'Deleting order',
						'Are you sure you wish to continue?',
						confirmedDeleteOrder
					);
				};

				function confirmedDeleteOrder() {
					$http
						.delete(SETTINGS.APIBasePath + 'order/' + scope.farmer.activeOrder.ID)
						.then(function() {
							scope.farmer.orders = remove_array_element(
								scope.farmer.orders,
								scope.farmer.activeOrder
							);
							scope.farmer.selectedSubscriptionIndex = null;
							scope.refreshSubscriptions();
							scope.deselectAllOrders();
						});
				}

				function remove_array_element(array, n) {
					var index = array.indexOf(n);
					if (index > -1) {
						array.splice(index, 1);
					}
					return array;
				}
				/**
				 * Set status to active order
				 * @param {number} statusId
				 * @param {number} activeOrderId
				 */
				scope.setStatus = function(statusId, activeOrderId) {
					$http
						.post(
							SETTINGS.APIBasePath +
								'/order/set-status/' +
								statusId +
								'/' +
								activeOrderId
						)
						.then(function() {
							scope.refreshSubscriptions();
						});
				};

				/**
				 * Refresh subscriptions
				 */
				scope.refreshSubscriptions = function() {
					scope.farmer.getSubscriptions(true);
				};

				/**
				 * Get all statuses
				 */
				scope.getStatuses = function() {
					Statuses.getAll().then(function(res) {
						scope.statuses = res.data;
					});
				};

				/**
				 * This function enable or disable status menu items based on selected status
				 * @param {Object} activeOrder
				 * @param {Object} status
				 * @returns {boolean}
				 */
				scope.activeStatusMenu = function(activeOrder, status) {
					return Statuses.activeStatusMenu(activeOrder, status, 'type');
				};

				/**
				 * Enable or disable email button
				 * @param {Object} activeOrder
				 * @returns {boolean}
				 */
				scope.activeEmailButton = function(activeOrder) {
					if (!activeOrder) {
						return false;
					}

					if (activeOrder.statusDescription === 'Accepted') {
						return false;
					}

					return orderService.isExpired(activeOrder);
				};

				/**
				 * Set active order watcher
				 */
				scope.setActiveOrderWatcher = function() {
					scope.$watch(
						'farmer.activeOrder',
						function() {
							scope.setCultureButton();
						},
						true
					);
				};

				/**
				 * Set culture button based on active order
				 */
				scope.setCultureButton = function() {
					if (scope.farmer.activeOrder) {
						var withNote = false;
						var orderItemsAmount = 0;
						var culturesAmount = 0;

						var orderItems = scope.orderService.getOrderItemsByPositionType(
							scope.farmer.activeOrder.orderItems,
							1
						);

						angular.forEach(orderItems, function(orderItem) {
							orderItemsAmount += parseInt(orderItem.amount);
							angular.forEach(orderItem.cultures, function(culture) {
								culturesAmount += parseInt(culture.amount);
							});
						});

						if (parseInt(orderItemsAmount) !== parseInt(culturesAmount)) {
							withNote = true;
						}

						// set culture button
						scope.culturesButtonLabel = this.buttonLabelService.setButtonLabel(
							'nature',
							'Cultures',
							withNote
						);
					}
				};

				scope.init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:orderDeliveries
 * @description
 * # orderDeliveries
 */
angular
	.module('wildBieneHarvestApp')
	.directive('requestPanel', function(
		$mdDialog,
		$timeout,
		AllSpecies,
		Session,
		$http,
		$mdToast,
		SETTINGS,
		printerService,
		farmerSettings,
		AllPhrases,
		selectPhrasesService,
		$location
	) {
		return {
			templateUrl: 'views/request-panel.html',
			scope: {
				order: '=order',
				farmer: '=farmer',
				users: '='
			},
			link: function postLink(scope) {
				scope.season = Session.farmerSeason;
				scope.organisationID = scope.farmer.organisation.id;
				AllSpecies().then(function(data) {
					scope.species = data;
				});
				var cutOff = new Date();

				farmerSettings
					.getRequestLeadTime(scope.organisationID)
					.then(function(data) {
						scope.leadTime = data;

						cutOff.setDate(cutOff.getDate() + scope.leadTime);

						if (scope.farmer.orders) {
							angular.forEach(scope.farmer.orders, function(order) {
								angular.forEach(order.requests, function(request) {
									var dDay = new Date(request.deliveryDate);
									if (dDay < cutOff && Session.rights.indexOf('Edit Request') < 0) {
										request.locked = true;
									}
								});
							});
						}
					});

				// preselect request in requests table
				var search = $location.search();
				if (search.request != 'undefined' && search.order != 'undefined') {
					angular.forEach(scope.farmer.orders, function(order) {
						if (order.ID == search.order) {
							angular.forEach(order.requests, function(request) {
								if (request.ID == search.request) {
									$timeout(function() {
										var index = $('table')
											.find('[data-request-id=' + request.ID + ']')
											.data('index');
										scope.selectRequest(index);
									});
								}
							});
						}
					});
				}

				scope.printRequest = function() {
					scope.$root.showLoader = true;
					printerService('request', scope.farmer.activeRequest, scope.farmer).then(
						function() {
							scope.$root.showLoader = false;
						}
					);

					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								// angular.element($confirmButton).addClass('md-raised md-warn');
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('GENERATING PDF, PLEASE WAIT...')
						.textContent(
							'Please confirm whether the document has been printed correctly.'
						)
						.ariaLabel('printed')
						.ok("Great it's printed")
						.cancel('Somethings gone wrong');
					$mdDialog.show(confirm).then(
						function() {
							$http
								.get(
									SETTINGS.APIBasePath +
										'request-printed/' +
										scope.farmer.activeRequest.ID
								)
								.then(function() {
									scope.farmer.activeRequest.printStatus = 3;
								});
						},
						function() {}
					);
				};

				scope.deleteRequest = function(deliveryID) {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								// angular.element($confirmButton).addClass('md-raised md-warn');
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Deleting Request')
						.textContent('Are you sure you wish to continue?')
						.ariaLabel('Lucky day')
						.ok('Please delete it!')
						.cancel('cancel');
					$mdDialog.show(confirm).then(
						function() {
							scope.farmer.activeRequest = null;
							$http
								.delete(SETTINGS.APIBasePath + 'request/' + deliveryID)
								.then(function() {
									var ind = -1;
									for (var i = 0; i < scope.order.requests.length; i++) {
										if (scope.order.requests[i].ID == deliveryID) {
											ind = i;
										}
									}
									scope.order.requests.splice(ind, 1);

									// Reload subscriptions to update requests data returned on subscriptions
									$timeout(function() {
										scope.farmer.getSubscriptions(true);
									}, 100);
								});
						},
						function() {}
					);
				};

				scope.selectRequest = function(index) {
					$('.request-line').removeClass('info');
					$('.request-line' + index).addClass('info');
					scope.farmer.activeRequest = scope.farmer.activeOrder.requests[index];
					scope.farmer.activeDelivery = null;
					scope.farmer.activeRequest.hasDelivery = false;
					if (scope.farmer.activeRequest && scope.farmer.activeRequest.deliveries) {
						for (var i = 0; i < scope.farmer.activeRequest.deliveries.length; i++) {
							scope.farmer.activeRequest.deliveries[i].creationDate = new Date(
								scope.farmer.activeRequest.deliveries[i].CRE_AT
							);
							scope.farmer.activeRequest.hasDelivery = true;
						}
					}
					scope.hasCheckout(scope.farmer.activeRequest.ID);
				};

				scope.hasCheckout = function(scanCode) {
					$http
						.get(SETTINGS.APIBasePath + 'order/requests/' + scanCode)
						.then(function(checkoutResponse) {
							if (checkoutResponse.data.res.length > 0) {
								scope.farmer.activeRequest.hasCheckout = true;
							} else {
								scope.farmer.activeRequest.hasCheckout = false;
							}
						});
				};

				scope.generateDeliveries = function() {
					$http
						.get(
							SETTINGS.APIBasePath +
								'deliveries-for-request/' +
								scope.farmer.activeRequest.ID
						)
						.then(function(response) {
							scope.farmer.activeRequest.deliveries = response.data.deliveries;
							for (var i = 0; i < scope.farmer.activeRequest.deliveries.length; i++) {
								scope.farmer.activeRequest.deliveries[i].creationDate = new Date(
									scope.farmer.activeRequest.deliveries[i].CRE_AT
								);
							}
						});
				};

				scope.editRequest = function() {
					openDialog(scope.farmer.activeRequest);
				};

				scope.schedule = function() {
					openDialog(null);
				};

				scope.modal = function() {
					$mdDialog.show({
						locals: { activeRequest: scope.farmer.activeRequest, users: scope.users },
						controller: 'RequestcheckoutmodalCtrl',
						templateUrl: 'views/request-checkout-modal.html',
						parent: angular.element(document.body),
						fullscreen: true,
						clickOutsideToClose: true
					});
				};

				scope.sendMail = function() {
					scope.$root.showLoader = true;
					printerService(
						'request',
						scope.farmer.activeRequest,
						scope.farmer,
						true
					).then(function(documents) {
						scope.$root.showLoader = false;

						AllPhrases().then(function(docs) {
							var ph = selectPhrasesService.phrases(
								docs,
								scope.farmer.language.ID,
								scope.farmer.organisation.id,
								'EMAIL'
							).phraseList;

							var email_data = selectPhrasesService.prep_email(
								ph,
								'request',
								scope.farmer.name
							).email_data;
							var filename = documents.pdfLink;
							$mdDialog.show({
								controller: 'MailmodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/mailmodal.html',
								parent: angular.element(document.body),
								locals: {
									farmer: scope.farmer,
									isOrder: scope.isOrder,
									filename: filename,
									body: email_data.bodytext,
									subject: email_data.subject
								},
								fullscreen: true,
								clickOutsideToClose: true
							});
						});
					});
				};

				function openDialog(req) {
					$mdDialog
						.show({
							templateUrl: 'views/request-modal.html',
							controller: 'RequestmodalCtrl',
							size: 'lg',
							locals: {
								request: req
							},
							resolve: {
								farmer: function() {
									return scope.farmer;
								},
								insects: function() {
									return scope.species;
								},
								daysAvailable: function(farmerSettings) {
									return farmerSettings.getDeliveryAvailableDays(scope.organisationID);
								},
								leadTime: function() {
									return scope.leadTime;
								}
							},
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: true
						})
						.then(
							function(data) {
								saveRequest(data);
							},
							function() {
								//TODO handle error
								// console.log('error');
							}
						);
				}

				function saveRequest(data) {
					if (!data) {
						return;
					}
					if (scope.order.requests == null) {
						scope.order.requests = [];
					}

					var rid = null;
					if (data && data.ID) {
						rid = data.ID;
					}

					scope.$root.showLoader = true;
					var postData = {
						ID: rid,
						ORDER_ID: scope.order.ID,
						requestItems: data.requestItems,
						DELIVERY_DATE: data.deliveryDate,
						DELIV_ADDR_COMPANY: data.COMPANY,
						DELIV_ADDR_FIRSTNAME: data.FIRSTNAME,
						DELIV_ADDR_LASTNAME: data.LASTNAME,
						DELIV_ADDR_ADDRESS1: data.ADDRESS1,
						DELIV_ADDR_ADDRESS2: data.ADDRESS2,
						DELIV_ADDR_POSTAL_CD: data.POSTAL_CD,
						DELIV_ADDR_TOWN: data.TOWN,
						DELIV_ADDR_COUNTRY_ID: data.country.ID
					};
					setRequests(postData);

					function setRequests(postData) {
						$http
							.post(SETTINGS.APIBasePath + 'request', {
								data: postData
							})
							.then(function(result) {
								scope.order.requests = result.data.requests;

								angular.forEach(scope.order.requests, function(request, requestIndex) {
									var dDay = new Date(request.deliveryDate);
									if (dDay < cutOff && Session.rights.indexOf('Edit Request') < 0) {
										scope.order.requests[requestIndex].locked = true;
									}
								});

								$timeout(function() {
									/*
								var selectedRequest = false;

								angular.forEach(scope.order.requests, function (request, requestIndex) {
									if ((scope.farmer.activeRequest !== null) && (parseInt(scope.farmer.activeRequest.ID) === parseInt(request.ID))) {
										scope.selectRequest(requestIndex);
										selectedRequest = true;
									}
								});

								if (!selectedRequest) {
									scope.selectRequest(scope.order.requests.length - 1);
								}
								 */
									scope.farmer.getSubscriptions(true);
								}, 100);
							})
							.finally(function() {
								$timeout(function() {
									scope.$root.showLoader = false;
								}, 100);
							});
					}
				}
			}
		};
	});

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DeliverymodalCtrl
 * @description
 * # DeliverymodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('RequestmodalCtrl', function(
		$scope,
		$filter,
		$mdDialog,
		Session,
		insects,
		farmer,
		$mdToast,
		request,
		daysAvailable,
		leadTime
	) {
		// title
		$scope.title = 'New Request';

		// variables
		$scope.formErrors = [];

		/**
		 * Initialize
		 */
		$scope.init = function() {
			var activeOrder = {
				orderItems: angular.copy(farmer.activeOrder.orderItems.slice(0))
			};
			$scope.requestItems =
				request !== null ? angular.copy(request.requestItems.slice(0)) : null;
			$scope.minStands = 0;
			$scope.organisationID = Session.getOrganisationID();

			$scope.setShippingAddresses(farmer.addresses);
			var editing = false;
			if (request !== null) {
				// if request exists
				editing = true;
				$scope.request = $scope.getExistingRequest(request);
				$scope.requestItems = $scope.getAllRequestItems(
					$scope.requestItems,
					activeOrder
				);
				$scope.fillEmptyRequestItem();
				$scope.populateAlreadyRequested(farmer.activeOrder);
				$scope.updateAlreadyRequested();
				$scope.populateAllAlreadyRequested($scope.requestItems);
				$scope.setAllCultureRequested();
				$scope.updateRemaining();
				$scope.setMax();
				$scope.checkCultureMin();
				$scope.updateDeliveryAmount();
				$scope.minStands = $scope.getMinStands();
			} else {
				// if it's a new request
				$scope.minStands = 1;

				$scope.request = $scope.getNewRequest(farmer);
				$scope.requestItems = $scope.getOrderItemsByPositionType(
					activeOrder.orderItems,
					1
				);
				$scope.fillEmptyRequestItem();
				$scope.populateAlreadyRequested(farmer.activeOrder);
				$scope.updateAlreadyRequested();
				$scope.populateAllAlreadyRequested($scope.requestItems);
				$scope.setAllCultureRequested();
				$scope.updateRemaining();
				$scope.setMax();
				$scope.checkCultureMin();
			}

			$scope.setMinDeliveryDate(request);

			$scope.insects = [];

			angular.forEach(insects, function(insect) {
				if (insect.SC_NAME === 'Osmia bicornis') {
					$scope.insects.push(insect);
				} else if (insect.SC_NAME === 'Osmia cornuta') {
					$scope.insects.push(insect);
				}
				if (editing && insect.ID === request.insectID) {
					$scope.request.species = $scope.insects[$scope.insects.length - 1];
				}
			});

			if (editing) {
				angular.forEach($scope.requestItems, function(
					requestItem,
					requestItemIndex
				) {
					angular.forEach($scope.insects, function(insect) {
						if (insect.ID === requestItem.insectID) {
							$scope.requestItems[requestItemIndex].species = insect;
						}
					});
				});
			}

			$scope.today = new Date();
			$scope.minDate = new Date(
				$scope.today.getFullYear(),
				$scope.today.getMonth(),
				$scope.today.getDate() + 1
			);
			if (farmer.activeOrder.deliveries == null) {
				activeOrder.deliveries = [];
			}

			$scope.culture = {};

			$scope.getCountries();
		};

		/**
		 * Fill request items with product sales
		 * @param {[Object]} requestItems
		 * @returns {*}
		 */
		$scope.fillSales = function(requestItems) {
			angular.forEach(requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					culture.sales = angular.copy(requestItem.salesProducts);

					if (culture.sales.length === 0) {
						culture.sales = [];
						var sale = {
							COMPONENT_ID: requestItem.productID,
							component: {
								SPROD_NAME: requestItem.productName,
								SPROD_CD: requestItem.productCODE,
								SPROD_STATUS_ID: requestItem.positionType
							},
							requested: 0,
							alreadyRequested: 0
						};
						culture.sales.push(sale);
					}
				});
			});
			return requestItems;
		};

		$scope.setAllCultureRequested = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					culture.allCultureRequested = 0;
					angular.forEach(culture.sales, function(sale) {
						culture.allCultureRequested += parseInt(sale.requested);
					});
				});
			});
		};

		/**
		 * Populate already requested
		 * @param {Object} activeOrder
		 */
		$scope.populateAlreadyRequested = function(activeOrder) {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						sale.alreadyRequested = 0;
						angular.forEach(activeOrder.requests, function(request) {
							angular.forEach(request.requestItems, function(fullRequestItem) {
								if (
									parseInt(requestItem.ID) === parseInt(fullRequestItem.orderItemID) &&
									parseInt(culture.cultureTypeID) ===
										parseInt(fullRequestItem.cultureID) &&
									parseInt(sale.COMPONENT_ID) === parseInt(fullRequestItem.salesProdID)
								) {
									sale.alreadyRequested += parseInt(fullRequestItem.requested);
								}
							});
						});
					});
				});
			});
		};

		/**
		 * Populate all already requested
		 * @param {[Object]} requestItems
		 */
		$scope.populateAllAlreadyRequested = function(requestItems) {
			angular.forEach(requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					culture.allAlreadyRequested = 0;
					angular.forEach(culture.sales, function(sale) {
						culture.allAlreadyRequested += parseInt(sale.alreadyRequested);
					});
				});
			});

			return requestItems;
		};

		/**
		 * Set min delivery date
		 * @param request
		 */
		$scope.setMinDeliveryDate = function(request) {
			$scope.minDeliveryDate = new Date();

			if ($scope.minDeliveryDate.getDay() + leadTime >= 6) {
				leadTime += 2;
			}

			$scope.minDeliveryDate.setDate($scope.minDeliveryDate.getDate() + leadTime);

			while (!$scope.IDontLikeMondays($scope.minDeliveryDate)) {
				$scope.minDeliveryDate.setDate($scope.minDeliveryDate.getDate() + 1);
			}

			if (!request) {
				$scope.request.deliveryDate = $scope.minDeliveryDate;
			}

			if (Session.rights.indexOf('Edit Request') > -1) {
				$scope.minDeliveryDate = new Date();
			}
		};

		/**
		 * Get min stands
		 * @return {number}
		 */
		$scope.getMinStands = function() {
			var minStands = $scope.minStands;

			angular.forEach($scope.request.deliveries, function(delivery) {
				minStands += Number(delivery.DELIVERED_AMT);
			});

			return minStands;
		};

		/**
		 * Get new request
		 * @param {Object} farmer
		 * @return {{TITLE_ID: (request.TITLE_ID|Object.TITLE_ID|number), LASTNAME: *, TOWN: *, POSTAL_CD: *, requestItems: [], FIRSTNAME: string, ADDRESS1: *, creationDate: Date, deliveryDate: Date, countryID: ($scope.request.country.ID|string|number), COMPANY: (request.COMPANY|Object.COMPANY|string), ADDRESS2: (Document.requestForm.ADDRESS2|request.ADDRESS2|Object.ADDRESS2|string)}}
		 */
		$scope.getNewRequest = function(farmer) {
			return {
				TITLE_ID: farmer.TITLE_ID,
				FIRSTNAME: farmer.FIRSTNAME,
				LASTNAME: farmer.LASTNAME,
				COMPANY: farmer.COMPANY,
				ADDRESS1: farmer.ADDRESS1,
				ADDRESS2: farmer.ADDRESS2,
				POSTAL_CD: farmer.POSTAL_CD,
				TOWN: farmer.TOWN,
				countryID: farmer.COUNTRY_ID,
				creationDate: new Date(),
				deliveryDate: new Date(),
				requestItems: []
			};
		};

		/**
		 * Get existing request
		 * @param {Object} request
		 * @return {{POSTAL_CD: *, requestItems: *, FIRSTNAME: string, creationDate: *, countryID: (request.countryID|string), COMPANY: (request.COMPANY|string), deliveries: (*|[]), TITLE_ID: (request.TITLE_ID|number), LASTNAME: *, TOWN: *, ID: *, ADDRESS1: *, deliveryDate: Date, ADDRESS2: (Document.requestForm.ADDRESS2|request.ADDRESS2|Object.ADDRESS2|string)}}
		 */
		$scope.getExistingRequest = function(request) {
			return {
				TITLE_ID: request.TITLE_ID,
				FIRSTNAME: request.FIRSTNAME,
				LASTNAME: request.LASTNAME,
				COMPANY: request.COMPANY,
				ADDRESS1: request.ADDRESS1,
				ADDRESS2: request.ADDRESS2,
				POSTAL_CD: request.POSTAL_CD,
				TOWN: request.TOWN,
				requestItems: request.requestItems.slice(0),
				countryID: request.countryID,
				deliveryDate: new Date(request.deliveryDate),
				creationDate: request.creationDate,
				ID: request.ID,
				deliveries: request.deliveries ? request.deliveries : []
			};
		};

		/**
		 * Get order items by position type ID
		 * @param {[Object]} orderItems
		 * @param {number} positionType
		 * @return {*}
		 */
		$scope.getOrderItemsByPositionType = function(orderItems, positionType) {
			return $scope.fillSales(
				$filter('filter')(orderItems, { positionType: positionType })
			);
		};

		/**
		 * Update delivery amount
		 */
		$scope.updateDeliveryAmount = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				requestItem.deliveryAmount = 0;
				angular.forEach($scope.request.deliveries, function(delivery) {
					angular.forEach(delivery.items, function(deliveryItem) {
						if (deliveryItem.REQUEST_ITEM_ID === requestItem.ID) {
							requestItem.deliveryAmount += Number(deliveryItem.DELIVERED_AMT);
						}
					});
				});
			});
		};

		/**
		 * Set max
		 */
		$scope.setMax = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						var amount =
							sale.AMOUNT === undefined || sale.AMOUNT === null
								? 1
								: parseInt(sale.AMOUNT);
						sale.max =
							parseInt(culture.amount) * amount - parseInt(sale.alreadyRequested);
					});
				});
			});
		};

		/**
		 * Update already requested.
		 */
		$scope.updateAlreadyRequested = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						sale.alreadyRequested =
							parseInt(sale.alreadyRequested) - parseInt(sale.requested);
					});
				});
			});
		};

		/**
		 * Update remaining
		 */
		$scope.updateRemaining = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						var amount =
							sale.AMOUNT === undefined || sale.AMOUNT === null
								? 1
								: parseInt(sale.AMOUNT);
						sale.remaining =
							parseInt(culture.amount) * amount -
							parseInt(sale.alreadyRequested) -
							parseInt(sale.requested);
						if (sale.remaining < 0) {
							sale.remaining = 0;
						}
					});
				});
			});
		};

		/**
		 * Fill empty request item
		 */
		$scope.fillEmptyRequestItem = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				requestItem.orderID = requestItem.ID;
				requestItem.orderItemID = requestItem.ID;
				requestItem.requestID = $scope.request.ID;
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						if (sale.requested === undefined) {
							sale.requested = 0;
							sale.alreadyRequested = 0;
						}
					});
				});
			});
		};

		/**
		 * Get all request items
		 * @param {[Object]} requestItems
		 * @param {Object} activeOrder
		 * @return {[]}
		 */
		$scope.getAllRequestItems = function(requestItems, activeOrder) {
			var orderItems = $scope.getOrderItemsByPositionType(
				activeOrder.orderItems,
				1
			);

			angular.forEach(orderItems, function(orderItem) {
				orderItem.orderID = orderItem.ID;
				orderItem.orderItemID = orderItem.ID;
				orderItem.requestID = $scope.request.ID;
				angular.forEach(requestItems, function(requestItem) {
					if (requestItem.orderItemID === orderItem.ID) {
						angular.forEach(orderItem.cultures, function(culture) {
							if (
								parseInt(culture.cultureTypeID) === parseInt(requestItem.cultureID)
							) {
								angular.forEach(culture.sales, function(sale) {
									if (
										parseInt(requestItem.salesProdID) === parseInt(sale.COMPONENT_ID)
									) {
										sale.requestItem = requestItem;
										sale.requested = parseInt(requestItem.requested);
										sale.alreadyRequested = parseInt(requestItem.alreadyRequested);
									}
								});
							}
						});
					}
				});
			});

			return orderItems;
		};

		/**
		 * Get countries
		 */
		$scope.getCountries = function() {
			$scope.countries = Session.allCountries;

			/*
			angular.forEach($scope.countries, function (country) {
				if ($scope.request && $scope.request.countryID && $scope.request.countryID === country.ID) {
					$scope.request.country = country;
					$scope.updateCountry();
				}
			});
			*/

			if (!$scope.request.country) {
				angular.forEach($scope.countries, function(country) {
					if (
						$scope.request &&
						$scope.request.countryID &&
						$scope.request.countryID === country.ID
					) {
						$scope.request.country = country;
						$scope.updateCountry();
					}
				});
			}
		};

		/**
		 * Set shipping addresses
		 * @param {[]} shippingAddresses
		 */
		$scope.setShippingAddresses = function(shippingAddresses) {
			$scope.shippingAddresses = shippingAddresses;
		};

		/**
		 * I don't like mondays
		 * @param date
		 * @return {boolean}
		 */
		$scope.IDontLikeMondays = function(date) {
			var res = false;
			if (Session.rights.indexOf('Edit Request') > -1) {
				var day = date.getDay();
				if (daysAvailable.indexOf(day.toString()) > -1) {
					res = true;
				}
			}
			return res;
		};

		/**
		 * Update country
		 */
		$scope.updateCountry = function() {
			if ($scope.request.country.code === 'CH') {
				$scope.postalCodeMaxLength = 4;
			} else {
				$scope.postalCodeMaxLength = 10;
			}
		};

		/**
		 * Save
		 */
		$scope.save = function() {
			$scope.request.requestItems = $scope.requestItems;
			$scope.request.ADDRESS = '';
			if ($scope.request.COMPANY != null) {
				$scope.request.ADDRESS += $scope.request.COMPANY + ', ';
			}
			$scope.request.ADDRESS += $scope.request.ADDRESS1;
			if ($scope.request.ADDRESS2 != null) {
				$scope.request.ADDRESS += ', ' + $scope.request.ADDRESS2;
			}

			$scope.request.COUNTRY_ID = $scope.request.country.ID;
			$scope.request.deliveryDate = moment($scope.request.deliveryDate)
				.utc(true)
				.toISOString();

			$scope.request.name =
				$scope.request.title +
				' ' +
				$scope.request.FIRSTNAME +
				' ' +
				$scope.request.LASTNAME;
			var numStands = 0;

			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					angular.forEach(culture.sales, function(sale) {
						if (sale.requested) {
							numStands += sale.requested;
						}
					});
				});
			});

			if (numStands <= 0) {
				var toast2 = $mdToast
					.simple()
					.textContent('You must request at least one stand.')
					.position('top right')
					.highlightAction(true)
					.parent(angular.element('#toastBox'))
					.hideDelay('3000');
				$mdToast.show(toast2);
			} else {
				$mdDialog.hide($scope.request);
			}
		};

		/**
		 * Send mail
		 */
		$scope.sendMail = function() {};

		/**
		 * Cancel modal
		 */
		$scope.cancel = function() {
			$scope.request = null;
			$mdDialog.hide();
		};

		/**
		 * Update address
		 * @param {Object} address
		 */
		$scope.updateAddress = function(address) {
			if (address) {
				$scope.request.FIRSTNAME = address.first_name;
				$scope.request.LASTNAME = address.last_name;
				$scope.request.COMPANY = address.company_name;

				$scope.request.ADDRESS1 = address.address_1;
				$scope.request.ADDRESS2 = address.address_2;

				$scope.request.country = $scope.countries.filter(function(item) {
					return item.code.toUpperCase() === address.country_code.toUpperCase();
				})[0];

				$scope.request.POSTAL_CD = address.postal_code;
				$scope.request.TOWN = address.town;
			}
		};

		/**
		 * Get controls from Form
		 * @param {string} formName
		 */
		$scope.getFormControls = function(formName) {
			return $scope[formName].$$controls;
		};

		/**
		 * Check culture min
		 */
		$scope.checkCultureMin = function() {
			angular.forEach($scope.requestItems, function(requestItem) {
				angular.forEach(requestItem.cultures, function(culture) {
					var highestProductSaleAmount = 0;
					angular.forEach(culture.sales, function(sale) {
						var productSaleAmount =
							(parseInt(sale.alreadyRequested) + parseInt(sale.requested)) /
							parseInt(sale.AMOUNT);
						if (productSaleAmount > highestProductSaleAmount) {
							highestProductSaleAmount = productSaleAmount;
						}
					});

					culture.min = highestProductSaleAmount;
				});
			});
		};

		/**
		 * Summarize all culture order amounts of culture request item and don't allow set
		 * more than units on order item
		 * @param {number} requestItemIndex
		 */
		$scope.checkMax = function(requestItemIndex) {
			var maxValue = 0;
			angular.forEach($scope.requestItems[requestItemIndex].cultures, function(
				culture
			) {
				maxValue += culture.amount ? culture.amount : 0;
			});

			var finalValue = $scope.requestItems[requestItemIndex].amount - maxValue;

			$scope.getFormControls('requestForm').forEach(function(value) {
				if (
					value.$name === $scope.getControlName('order_amount', requestItemIndex)
				) {
					$scope.setFormControlAsInvalid(value, finalValue < 0 || finalValue > 0);
				}
			});

			$scope.setFormError(requestItemIndex, finalValue);
		};

		/**
		 * Calculate max for this request
		 * @param {number} alreadyRequested
		 * @param {number} amount
		 */
		$scope.getMax = function(alreadyRequested, amount) {
			amount = amount === undefined ? 0 : amount;
			if (amount - alreadyRequested < 0) {
				return 0;
			}
			return amount - alreadyRequested;
		};

		/**
		 * Get control name by request item index
		 * @param {string} name
		 * @param {number} requestItemIndex
		 * @return {string}
		 */
		$scope.getControlName = function(name, requestItemIndex) {
			return name + '_' + requestItemIndex;
		};

		/**
		 * Get control name by culture item index and sale index
		 * @param {string} name
		 * @param {number} requestItemIndex
		 * @param {number} cultureItemIndex
		 * @param {number} saleIndex
		 * @return {string}
		 */
		$scope.getSaleControlName = function(
			name,
			requestItemIndex,
			cultureItemIndex,
			saleIndex
		) {
			return (
				name + '_' + requestItemIndex + '_' + cultureItemIndex + '_' + saleIndex
			);
		};

		/**
		 * Set form control as valid, or invalid
		 * @param formControl
		 * @param {boolean} valid
		 */
		$scope.setFormControlAsInvalid = function(formControl, valid) {
			formControl.$valid = !valid;
			formControl.$invalid = !!valid;
			formControl.$touched = !!valid;
		};

		/**
		 * Show error if sum amounts of culture items is not equal to request item amount
		 * @param {number} requestItemIndex
		 * @param {number} finalValue
		 */
		$scope.setFormError = function(requestItemIndex, finalValue) {
			if (finalValue < 0) {
				$scope.formErrors[requestItemIndex] =
					'Sum of split items is bigger than originally ordered';
			} else if (finalValue > 0) {
				$scope.formErrors[requestItemIndex] =
					'Sum of split items is less than originally ordered';
			} else {
				$scope.formErrors[requestItemIndex] = null;
			}
		};

		$scope.init();
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.cultures
 * @description
 * # cultures
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('cultures', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'cultures/');
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.contracts
 * @description
 * # contracts
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('contracts', function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'order/contract-types/');
	})
	.service('currencies', function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'order/currencies/');
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.orderItems
 * @description
 * # orderItems
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('orderItems', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'deliveries/:orderID', {
			orderID: '@orderID'
		});
	}
]);

angular.module('wildBieneHarvestApp').factory('monthlyRequests', [
	'$http',
	'SETTINGS',
	'$q',
	function($http, SETTINGS, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();

			$http.get(SETTINGS.APIBasePath + 'months-requests').then(
				function(data) {
					delay.resolve(data.data);
				},
				function() {
					delay.reject('unable to load monthlyRequests');
				}
			);
			return delay.promise;
		};
	}
]);

angular.module('wildBieneHarvestApp').service('orderPositionTypes', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'order-positions');
	}
]);
angular.module('wildBieneHarvestApp').factory('allOrderPositionTypes', [
	'$http',
	'SETTINGS',
	'$q',
	function($http, SETTINGS, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();

			$http.get(SETTINGS.APIBasePath + 'order-positions').then(
				function(data) {
					delay.resolve(data.data);
				},
				function() {
					delay.reject('unable to load monthlyRequests');
				}
			);
			return delay.promise;
		};
	}
]);
angular.module('wildBieneHarvestApp').service('getDeliveryNotesDetail', [
	'$resource',
	'SETTINGS',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'order/delivery-notes/:deliveryId', {
			deliveryId: '@deliveryId'
		});
	}
]);
angular.module('wildBieneHarvestApp').service('getRequestsDetail', [
	'$resource',
	'SETTINGS',
	function($resource, SETTINGS) {
		return $resource(SETTINGS.APIBasePath + 'order/requests/:requestId', {
			requestId: '@requestId'
		});
	}
]);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DeliverymanagementCtrl
 * @description
 * # DeliverymanagementCtrl
 * Controller of the wildBieneHarvestApp
 */
angular.module('wildBieneHarvestApp').controller('DeliverymanagementCtrl', [
	'$scope',
	'$timeout',
	'$http',
	'SETTINGS',
	'$mdDialog',
	'Session',
	'printerService',
	'monthsRequests',
	'monthlyRequests',
	'deliveryGenerator',
	'orderByFilter',
	'AllPhrases',
	'selectPhrasesService',
	'$location',
	'languageFactory',
	function(
		$scope,
		$timeout,
		$http,
		SETTINGS,
		$mdDialog,
		Session,
		printerService,
		monthsRequests,
		monthlyRequests,
		deliveryGenerator,
		orderBy,
		AllPhrases,
		selectPhrasesService,
		$location,
		languageFactory
	) {
		$scope.$root.showLoader = false;
		Session.setStream('farmer');
		Session.pageTitle = 'Beefarmer Deliveries';
		$scope.maxRequests = 1;
		$scope.offset = 0;
		$scope.days = [];
		$scope.yAxis = [];
		$scope.allSelected = true;
		//table sorting
		$scope.propertyName = 'deliveryID';
		$scope.sortReverse = false;

		$scope.rowID = 'ID';
		$scope.requestColumns = [
			{ data: 'ID' },
			{ data: 'ID' },
			{ data: 'ORG_NAME' },
			{ data: 'COUNTRY_CODE' },
			{ data: 'COMPANY' },
			{ data: 'FULL_NAME' },
			{ data: 'DELIV_ADDR_ADDRESS1' },
			{ data: 'REQUEST_DELIVERED_AMT' }
		];

		$scope.tableInitialized = false;
		$scope.deliveryButtonsEnabled = false;
		$scope.customerPageButtonEnabled = false;
		$scope.$exttable = [];
		$scope.$exttableSelected = {
			tableRequest: []
		};

		var deliveries;
		var languageMap = {};

		languageFactory.query(function(result) {
			for (var i = 0; i < result.length; i++) {
				languageMap[result[i].code] = result[i].ID;
			}
		});

		var today = new Date();
		$scope.today = new Date();
		$scope.deliveryDate = new Date(
			$scope.today.getFullYear(),
			$scope.today.getMonth(),
			$scope.today.getDate() + 1
		);

		$scope.sortBy = function(propertyName) {
			$scope.reverse =
				propertyName !== null && $scope.propertyName === propertyName
					? !$scope.reverse
					: false;
			$scope.propertyName = propertyName;

			$scope.deliveries = orderBy(
				$scope.deliveries,
				$scope.propertyName,
				$scope.reverse
			);
		};

		$scope.loadDeliveries = function() {
			$http.get(SETTINGS.APIBasePath + 'months-requests').then(
				function(data) {
					$scope.tempDays = [];
					$scope.tempYAxis = [];
					var monthsRequests = data.data;

					for (var i = 0; i < 30; i++) {
						var day = {};
						day.date = new Date();
						day.date.setDate(today.getDate() + i);
						var compDate = day.date.getDate();
						day.value = 0;
						day.unprinted = 0;
						for (var j = 0; j < monthsRequests.length; j++) {
							var comp2 = monthsRequests[j].deliveryDate.split('-');
							if (Number(compDate) == Number(comp2.pop())) {
								day.value = monthsRequests[j].total;
								day.unprinted = monthsRequests[j].unPrinted;
								if (Number(day.value) >= $scope.maxRequests) {
									$scope.maxRequests = Number(day.value);
								}
							}
						}
						$scope.tempDays.push(day);
					}
					// eslint-disable-next-line no-redeclare
					for (var i = $scope.maxRequests; i > 0; i--) {
						if ($scope.maxRequests > 15) {
							if (i % 5 == 0 || i == $scope.maxRequests) {
								if (i == $scope.maxRequests && i % 5 != 0) {
									$scope.tempYAxis.push(i + 5 - (i % 5));
									$scope.offset = 5 - (i % 5);
								} else {
									$scope.tempYAxis.push(i);
								}
							}
						} else {
							$scope.tempYAxis.push(i);
						}
					}
					$scope.maxRequests = $scope.maxRequests + $scope.offset;
					$scope.yAxis = $scope.tempYAxis;
					$scope.days = $scope.tempDays;
					$timeout(function() {
						var rowHeight = $('#y-spacer').height() + 13;
						$('.bar-container').height($('.y-axis').height() - rowHeight);
						$('.bar-container').css('margin-top', rowHeight + 'px');
					});
				},
				function() {
					// TODO can this code be removed?
					// eslint-disable-next-line no-undef
					delay.reject('unable to load monthlyRequests');
				}
			);
		};

		$scope.loadDeliveries();

		$scope.selectDelivery = function() {};

		$scope.setDate = function(d, preselectedValues) {
			$scope.deliveryDate = d;
			for (var i = 0; i < $scope.days.length; i++) {
				if ($scope.days[i].date == d && $scope.days[i].value) {
					$scope.generate(preselectedValues);
				}
			}
			$scope.generate(preselectedValues);
		};
		$scope.generate = function(preselectedValues) {
			$scope.$root.showLoader = true;
			var d =
				$scope.deliveryDate.getFullYear() +
				'-' +
				($scope.deliveryDate.getMonth() + 1) +
				'-' +
				$scope.deliveryDate.getDate();
			$http
				.get(SETTINGS.APIBasePath + 'requests/' + d)
				.then(function(response) {
					deliveries = Object.values(response.data.deliveries);

					for (var i = 0; i < deliveries.length; i++) {
						deliveries[i].selected = deliveries[i].printStatus != 'Printed';
						deliveries[i].ID = Number(deliveries[i].ID);
						deliveries[i].REQUEST_ID = deliveries[i].items[0].requestItem.requestID;
					}
					$scope.deliveries = orderBy(
						deliveries,
						$scope.propertyName,
						$scope.reverse
					);

					$scope.searchRequests(preselectedValues);
				})
				.finally(function() {
					$scope.$root.showLoader = false;
				});
		};
		$scope.searchRequests = function(preselectedValues) {
			$scope.$root.showLoader = true;
			var d =
				$scope.deliveryDate.getFullYear() +
				'-' +
				($scope.deliveryDate.getMonth() + 1) +
				'-' +
				$scope.deliveryDate.getDate();

			$http.get(SETTINGS.APIBasePath + 'requests/' + d).then(function(response) {
				$scope.requests = response.data.requests;
				$scope.$root.showLoader = false;
				var requestsWithoutDeliveries = [];

				angular.forEach($scope.requests, function(request, key) {
					$scope.requests[key].FULL_NAME =
						request.DELIV_ADDR_FIRSTNAME + ' ' + request.DELIV_ADDR_LASTNAME;

					var deliveredAmt = $scope.getNumberOfDeliveredItems(request.deliveries);
					var requestedAmt = $scope.getNumberOfRequestedDeliveryItems(
						request.requestItems
					);

					if (deliveredAmt < requestedAmt) {
						requestsWithoutDeliveries.push(parseInt(request.ID));
					}

					$scope.requests[key].REQUEST_DELIVERED_AMT =
						deliveredAmt + '/' + requestedAmt;
				});

				$scope.$exttable.tableRequest.rows().remove();
				$scope.$exttable.tableRequest.rows.add($scope.requests).draw();
				$scope.markRequestsWithIncompleteDeliveries(requestsWithoutDeliveries);
				$scope.selectRequestsTableItems(preselectedValues);
				$scope.selectCallback();
			});

			$timeout(function() {
				if ($scope.$exttable.tableRequest !== undefined) {
					$scope.$exttable.tableRequest.column(0).checkboxes.deselectAll();
				}
			});
		};

		$scope.tableInit = function() {
			if (!$scope.tableInitialized) {
				// on tr click
				$scope.$exttable.tableRequest.on('click', 'tbody tr', function(event) {
					var elem = event.target || event.srcElement;
					if (!$(elem).hasClass('ignore-parent-click')) {
						$(this)
							.find('td:first-child input[type=checkbox]')
							.trigger('click');
					}
				});
				$scope.tableInitialized = true;
			}
		};

		$scope.getNumberOfRequestedDeliveryItems = function(requestItems) {
			var requestedAmt = 0;
			angular.forEach(requestItems, function(delivery) {
				requestedAmt += parseInt(delivery.requested);
			});
			return requestedAmt;
		};

		$scope.getNumberOfDeliveredItems = function(deliveries) {
			var deliveredAmt = 0;
			var alreadyCounted = [];
			angular.forEach(deliveries, function(delivery) {
				// check for possible duplicates
				if (alreadyCounted.indexOf(delivery.ID) == -1) {
					alreadyCounted.push(delivery.ID);
					deliveredAmt += delivery.DELIVERED_AMT;
				}
			});

			return deliveredAmt;
		};

		$scope.selectCallback = function() {
			$timeout(function() {
				var resources = $scope.getActiveItem();
				var selectedRequests = [];
				$scope.deliveryButtonsEnabled = false;

				$('table[data-model="tableRequest"] tr').removeClass('info');

				angular.forEach(resources, function(resource) {
					var requestedAmt = $scope.getNumberOfRequestedDeliveryItems(
						resource.requestItems
					);
					var deliveredAmt = $scope.getNumberOfDeliveredItems(resource.deliveries);

					if (deliveredAmt < requestedAmt) {
						$scope.deliveryButtonsEnabled = true;
					}
					selectedRequests.push(parseInt(resource.ID));
					$('table[data-model="tableRequest"]')
						.find('tbody tr#' + resource.ID)
						.addClass('info');
				});

				$scope.customerPageButtonEnabled = resources.length == 1 ? true : false;

				$scope.showRelatedDeliveries(selectedRequests);
				$scope.tableInit();
			});
		};

		$scope.showRelatedDeliveries = function(requestIDs) {
			$('.table-deliveries tr')
				.not(':first')
				.each(function() {
					var requestId = $(this).data('request-id');
					requestIDs.indexOf(requestId) >= 0 ? $(this).show() : $(this).hide();

					angular.forEach($scope.deliveries, function(value, key) {
						$scope.deliveries[key].selected =
							requestIDs.indexOf(parseInt(value.REQUEST_ID)) >= 0 &&
							value.printStatus != 'Printed'
								? true
								: false;
					});
				});
		};

		$scope.getRowData = function(rowId) {
			return $scope.$exttable.tableRequest.row('tr#' + rowId).data();
		};

		$scope.getActiveItem = function() {
			var resources = [];
			$.each(
				$scope.$exttableSelected.tableRequest,
				function(index, rowId) {
					resources.push($scope.getRowData(rowId));
				},
				resources
			);

			return resources;
		};

		$scope.selectRequestsTableItems = function(items) {
			if (items !== null) {
				$timeout(function() {
					$.each(items, function(index, item) {
						var row = $('table[data-model="tableRequest"]').find(
							'tbody tr#' + item.ID
						);
						row.find('td:first-child input[type=checkbox]').trigger('click');
					});
				});
			}
		};

		$scope.markRequestsWithIncompleteDeliveries = function(
			requestsWithoutDeliveries
		) {
			$('.table-request tr').each(function() {
				var id = $(this).attr('id');
				if (requestsWithoutDeliveries.indexOf(id) >= 0) {
					$(this).css('color', 'red');
				}
			});
		};

		$('#checkAll').click(function() {
			var checkboxes = $scope.$exttable.tableRequest.column(0).checkboxes;

			if (!isNaN(checkboxes.selected()[0]) && $(this).prop('checked')) {
				checkboxes.deselectAll();
				$(this).prop('checked', false);
			} else {
				if (!isNaN(checkboxes.selected()[0]) || !$(this).prop('checked')) {
					checkboxes.deselectAll();
				} else {
					checkboxes.select(true);
				}
			}
		});

		$scope.confirmGenerateDeliveries = function() {
			$scope.confirmDeliveries('deliveries');
		};

		$scope.confirmGenerateSingleDeliveries = function() {
			$scope.confirmDeliveries('singleDeliveries');
		};

		$scope.confirmDeliveries = function(type) {
			var items = $scope.getActiveItem();
			var cannotCreteDeliveries = [];

			angular.forEach(items, function(item) {
				var requestedAmt = $scope.getNumberOfRequestedDeliveryItems(
					item.requestItems
				);
				var deliveredAmt = $scope.getNumberOfDeliveredItems(item.deliveries);

				if (deliveredAmt >= requestedAmt) {
					cannotCreteDeliveries.push(item.ID);
				}
			});

			if (cannotCreteDeliveries.length == 0) {
				$scope.generateDeliveries(type);
			} else if (cannotCreteDeliveries.length > 0) {
				var msg =
					'The following requests with IDs ' +
					cannotCreteDeliveries.join(', ') +
					' already have deliveries. Do you want to create deliveries for all other selected items?';
				var confirm = $mdDialog
					.confirm()
					.title('Confirm')
					.textContent(msg)
					.ariaLabel(msg)
					.ok('Ok')
					.cancel('Cancel');
				$mdDialog.show(confirm).then(function() {
					$scope.generateDeliveries(type);
				});
			}
		};

		$scope.generateDeliveries = function(type) {
			var items = $scope.getActiveItem();
			angular.forEach(items, function(value) {
				if (typeof value.ID !== 'undefined') {
					if (type === 'singleDeliveries') {
						deliveryGenerator
							.generateSingleDeliveriesForRequest(value.ID)
							.then(function() {
								$scope.setDate($scope.deliveryDate, items);
							});
					} else {
						deliveryGenerator.generateDeliveriesForRequest(value.ID).then(function() {
							$scope.setDate($scope.deliveryDate, items);
						});
					}
				}
			});
		};

		$scope.goToCustomerPage = function() {
			var resources = $scope.getActiveItem();
			$location
				.path('/farmer/account/' + resources[0].CLIENT_ID)
				.search({ order: resources[0].ORDER_ID, request: resources[0].ID });
		};

		$scope.search = function() {
			if ($scope.deliveryDate) {
				$scope.$root.showLoader = true;
				var d =
					$scope.deliveryDate.getFullYear() +
					'-' +
					($scope.deliveryDate.getMonth() + 1) +
					'-' +
					$scope.deliveryDate.getDate();

				$http.get(SETTINGS.APIBasePath + 'daily-deliveries/' + d).then(
					function(response) {
						deliveries = response.data.deliveries;
						$scope.requests = [];
						$scope.allSelected = true;
						for (var i = 0; i < response.data.deliveries.length; i++) {
							response.data.deliveries[i].selected = true;
							response.data.deliveries[i].deliveryDate = d;
							if ($scope.deliveries) {
								deliveries[i].selected = !$scope.deliveries[i].printed;
							}
							if (!deliveries[i].selected) {
								$scope.allSelected = false;
							}
						}
						$scope.generate(null);
						$scope.deliveries = orderBy(
							deliveries,
							$scope.propertyName,
							$scope.reverse
						);
					},
					function() {
						$scope.$root.showLoader = false;
					}
				);
			}
		};

		$scope.search();
		$scope.deleteSelected = function() {
			var toDelete = 0;
			for (var i = $scope.deliveries.length - 1; i >= 0; i--) {
				if ($scope.deliveries[i].selected) {
					toDelete++;
					$http
						.delete(
							SETTINGS.APIBasePath + 'delivery/' + $scope.deliveries[i].deliveryID
						)
						.then(function() {
							toDelete--;
							if (!toDelete) {
								$scope.search();
							}
						});
				}
			}
		};
		$scope.openClient = function(clientID) {
			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						// eslint-disable-next-line no-unused-vars
						var $confirmButton = $actionsSection.children()[1];
						// angular.element($confirmButton).addClass('md-raised md-warn');
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('Would you like leave this page?')
				.textContent('You are being redirected to the clients page.')
				.ariaLabel('printed')
				.ok('Yes, take me there.')
				.cancel('No thanks.');
			$mdDialog.show(confirm).then(
				function() {
					location.href = '/beeadmin/#/farmer/account/' + clientID;
				},
				function() {}
			);
		};

		AllPhrases().then(function(phrases) {
			$scope.phrases_array = phrases;
		});

		$scope.printSelected = function(ev) {
			var somePrinted = false;
			var toPrint = [];
			for (var i = $scope.deliveries.length - 1; i >= 0; i--) {
				if ($scope.deliveries[i].selected) {
					$scope.deliveries[i].phrases = selectPhrasesService.phrases(
						$scope.phrases_array,
						languageMap[$scope.deliveries[i].language],
						$scope.deliveries[i].OWNER_ID,
						'Delivery'
					).phraseList;
					toPrint.push($scope.deliveries[i]);
					if (
						$scope.deliveries[i].PRINT_STATUS_ID == 3 ||
						$scope.deliveries[i].printStatus == 'Printed'
					) {
						somePrinted = true;
					}
				}
			}

			if (toPrint.length) {
				if (somePrinted) {
					var printAnyways = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								// angular.element($confirmButton).addClass('md-raised md-warn');
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Einige Lieferscheine wurden bereits gedruckt')
						.textContent(
							'Unter den selektierten Lieferscheinen befinden sich solche, die bereits gedruckt wurden. Trotzdem drucken?'
						)
						.ariaLabel('printed')
						.targetEvent(ev)
						.ok('Yes')
						.cancel('No');
					$mdDialog.show(printAnyways).then(
						function() {
							printDeliveries(ev, toPrint);
						},
						function() {}
					);
				} else {
					printDeliveries(ev, toPrint);
				}
			} else {
				var confirm = $mdDialog
					.alert()
					.title('No Deliveries Selected.')
					.textContent('Please select the deliveries you would like to download.')
					.ariaLabel('None Selected')
					.targetEvent(ev)
					.ok('Ok');
				$mdDialog.show(confirm);
			}
		};

		function printDeliveries(ev, toPrint) {
			printDocument('multipleDeliveries', toPrint);

			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						// eslint-disable-next-line no-unused-vars
						var $confirmButton = $actionsSection.children()[1];
						// angular.element($confirmButton).addClass('md-raised md-warn');
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('GENERATING PDF, PLEASE WAIT...')
				.textContent(
					'Please confirm whether the delivery notes have been printed correctly.'
				)
				.ariaLabel('printed')
				.targetEvent(ev)
				.ok("Great they're printed")
				.cancel('Somethings gone wrong');
			$mdDialog.show(confirm).then(
				function() {
					for (var i = 0; i < $scope.deliveries.length; i++) {
						if ($scope.deliveries[i].selected) {
							$http
								.get(
									SETTINGS.APIBasePath + 'printed-delivery/' + $scope.deliveries[i].ID
								)
								.then(function(response) {
									for (var i = 0; i < $scope.deliveries.length; i++) {
										if ($scope.deliveries[i].ID == response.data.printed) {
											$scope.deliveries[i].selected = false;
											$scope.deliveries[i].printStatus = 'Printed';
										}
									}
									$scope.loadDeliveries();
								});
						}
					}
				},
				function() {}
			);
		}

		$scope.printChecklist = function() {
			var toPrint = [];
			for (var i = 0; i < $scope.deliveries.length; i++) {
				if ($scope.deliveries[i].selected) {
					toPrint.push($scope.deliveries[i]);
				}
			}
			printDocument('checklist', toPrint);
		};

		$scope.checkUncheckAll = function() {
			$timeout(function() {
				var resources = $scope.getActiveItem();
				var selectedRequests = [];

				angular.forEach(resources, function(resource) {
					selectedRequests.push(parseInt(resource.ID));
				});

				angular.forEach($scope.deliveries, function(value) {
					if (selectedRequests.indexOf(parseInt(value.REQUEST_ID)) >= 0) {
						value.selected = $scope.allSelected;
					}
				});
			});
		};

		function printDocument(type, data) {
			$scope.$root.showLoader = true;
			printerService(type, data).then(function() {
				$scope.$root.showLoader = false;
			});
		}
	}
]);

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.farmerSettings
 * @description
 * # farmerSettings
 * Service in the wildBieneHarvestApp.
 */
//TODO change shared vars to self.xxxx
angular
	.module('wildBieneHarvestApp')
	.service('farmerSettings', function($http, SETTINGS, $q) {
		var requestLeadTime = 0;
		var season = '2018';
		var defaultClientID = '';
		var defaultClientName = '';
		this.getRequestLeadTime = function(org) {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'request-lead-time/' + org)
				.then(function(response) {
					requestLeadTime = Number(response.data.leadTime);
					delay.resolve(Number(requestLeadTime));
				});
			return delay.promise;
		};
		this.getSeason = function() {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'settings/farmer-season/')
				.then(function(response) {
					season = response.data.season;
					delay.resolve(season);
				});
			return delay.promise;
		};
		this.getDefaultClient = function() {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'settings/default-client/')
				.then(function(result) {
					defaultClientID = result.data.id;
					defaultClientName = result.data.name;
					delay.resolve([defaultClientID, defaultClientName]);
				});
			return delay.promise;
		};
		this.setLeadTime = function(org, leadTime) {
			requestLeadTime = leadTime;
			$http
				.get(
					SETTINGS.APIBasePath + 'request-lead-time/' + org + '/' + requestLeadTime
				)
				.then(function(response) {
					//TODO change to toast
					// eslint-disable-next-line no-console
					console.log(response);
				});
		};
		this.setSeason = function(newSeason) {
			season = newSeason;
			$http
				.post(SETTINGS.APIBasePath + '/settings/farmer-season/', {
					season: newSeason
				})
				.then(function(response) {
					//TODO change to toast
					// eslint-disable-next-line no-console
					console.log(response);
				});
		};

		this.getDeliveryAvailableDays = function(org) {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'delivery-days-available/' + org)
				.then(function(response) {
					var days = {};
					if (response.data.days) {
						days = response.data.days.split(',');
					}
					delay.resolve(days);
				});
			return delay.promise;
		};

		this.setDeliveryAvailableDays = function(org, days) {
			$http
				.get(SETTINGS.APIBasePath + 'delivery-days-available/' + org + '/' + days)
				.then(function(response) {
					//TODO change to toast
					// eslint-disable-next-line no-console
					console.log(response);
				});
		};

		this.getSeason();
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.farmerProducts
 * @description
 * # farmerProducts
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('farmerProducts', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return $resource(SETTINGS.APIBasePath + 'sales-products/farmer');
	}
]);

angular.module('wildBieneHarvestApp').factory('AllFarmerProductTypes', [
	'farmerProducts',
	'$q',
	function(farmerProducts, $q) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function() {
			var delay = $q.defer();
			farmerProducts.query(
				function(productTypes) {
					delay.resolve(productTypes);
				},
				function() {
					delay.reject('unable to fetch product Types');
				}
			);
			return delay.promise;
		};
	}
]);

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:completedDeliveries
 * @description
 * # completedDeliveries
 */
angular
	.module('wildBieneHarvestApp')
	.directive('deliveriesPanel', function(
		AllSpecies,
		Session,
		$http,
		$mdMedia,
		$mdDialog,
		$timeout,
		SETTINGS,
		printerService,
		deliveryGenerator,
		AllPhrases,
		selectPhrasesService
	) {
		return {
			templateUrl: 'views/deliveries-panel.html',
			scope: {
				request: '=request',
				farmer: '=farmer',
				users: '='
			},
			link: function postLink(scope) {
				scope.farmer.activeDelivery = null;

				function calculateDeliveryTotals() {
					for (var i = 0; i < scope.request.deliveries.length; i++) {
						scope.request.deliveries[i].creationDate = new Date(
							scope.request.deliveries[i].CRE_AT
						);
						scope.request.deliveryTotal += Number(
							scope.request.deliveries[i].DELIVERED_AMT
						);
					}
				}

				scope.$watch('request', function() {
					if (scope.request && scope.request.deliveries) {
						scope.request.deliveryTotal = 0;
						calculateDeliveryTotals();
					}
				});
				scope.generateDeliveries = function() {
					deliveryGenerator
						.generateDeliveriesForRequest(scope.request.ID)
						.then(function(result) {
							var items = result;
							for (var i = 0; i < items.length; i++) {
								scope.request.deliveryTotal += Number(items[i].DELIVERED_AMT);
								scope.request.deliveries.push(items[i]);
							}
						});
				};
				scope.generateSingleDeliveries = function() {
					deliveryGenerator
						.generateSingleDeliveriesForRequest(scope.request.ID)
						.then(function(result) {
							var items = result;
							for (var i = 0; i < items.length; i++) {
								scope.request.deliveryTotal += Number(items[i].DELIVERED_AMT);
								scope.request.deliveries.push(items[i]);
							}
						});
				};

				scope.selectDelivery = function(index) {
					$('.delivery-line').removeClass('info');
					$('.delivery-line' + index).addClass('info');
					scope.farmer.activeDelivery = scope.request.deliveries[index];
					scope.hasCheckout(scope.farmer.activeDelivery.ID);
				};

				scope.hasCheckout = function(scanCode) {
					$http
						.post(SETTINGS.APIBasePath + 'delivery-has-checkouts', {
							columnName: 'DELIVERY_ID',
							recordValue: scanCode
						})
						.then(function(checkoutResponse) {
							scope.farmer.activeDelivery.hasCheckout =
								checkoutResponse.data.hasCheckouts;
						});
				};

				scope.downloadDeliveries = function() {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								// angular.element($confirmButton).addClass('md-raised md-warn');
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('GENERATING PDF, PLEASE WAIT...')
						.textContent(
							'Please confirm whether the delivery notes have been printed correctly.'
						)
						.ariaLabel('printed')
						.ok("Great they're printed")
						.cancel('Somethings gone wrong');
					$mdDialog.show(confirm).then(
						function() {
							for (var i = 0; i < scope.request.deliveries.length; i++) {
								$http
									.get(
										SETTINGS.APIBasePath +
											'printed-delivery/' +
											scope.request.deliveries[i].ID
									)
									.then(function(response) {
										for (var i = 0; i < scope.request.deliveries.length; i++) {
											if (scope.request.deliveries[i].ID === response.data.printed) {
												scope.request.deliveries[i].printed = true;
												scope.request.deliveries[i].printStatus = 'Printed';
											}
										}
									});
							}
						},
						function() {}
					);

					scope.$root.showLoader = true;
					printerService('delivery', scope.request, scope.farmer).then(function() {
						scope.$root.showLoader = false;
					});
				};
				scope.sendMail = function() {
					scope.$root.showLoader = true;
					printerService('delivery', scope.request, scope.farmer, true).then(
						function(documents) {
							scope.$root.showLoader = false;
							AllPhrases().then(function(docs) {
								var ph = selectPhrasesService.phrases(
									docs,
									scope.farmer.language.ID,
									scope.farmer.organisation.id,
									'EMAIL'
								).phraseList;
								var email_data = selectPhrasesService.prep_email(
									ph,
									'delivery',
									scope.farmer.name
								).email_data;

								var filename = documents.pdfLink;
								$mdDialog.show({
									controller: 'MailmodalCtrl',
									controllerAs: 'ctrl',
									templateUrl: 'views/mailmodal.html',
									parent: angular.element(document.body),
									locals: {
										farmer: scope.farmer,
										isOrder: scope.isOrder,
										filename: filename,
										body: email_data.bodytext,
										subject: email_data.subject
									},
									fullscreen: true,
									clickOutsideToClose: true
								});
							});
						}
					);
				};

				function removeDelivery(deliveryData) {
					if (!deliveryData.checkedOut) {
						var deliveryID = deliveryData.ID;
						$http
							.delete(SETTINGS.APIBasePath + 'delivery/' + deliveryID)
							.then(function() {
								var ind = -1;
								for (var j = 0; j < scope.request.deliveries.length; j++) {
									if (scope.request.deliveries[j].ID == deliveryID) {
										scope.request.deliveryTotal -=
											scope.request.deliveries[j].DELIVERED_AMT;
										ind = j;
									}
								}
								scope.request.deliveries.splice(ind, 1);

								scope.farmer.activeDelivery = null;
							});
					}
				}

				scope.deleteAll = function() {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Are you sure you want to delete all deliveries?')
						.htmlContent(
							'<span class="md-warn">WARNING:</span> There may be delivery notes that have been sent to production already.'
						)
						.ariaLabel('Lucky day')
						.ok('Please delete them!')
						.cancel('cancel');
					$mdDialog.show(confirm).then(function() {
						for (var i = 0; i < scope.request.deliveries.length; i++) {
							removeDelivery(scope.request.deliveries[i]);
						}
						$mdDialog.show(
							$mdDialog
								.alert()
								.clickOutsideToClose(true)
								.title('Deleted')
								.textContent(
									'Deliveries have been deleted. Any remaining deliveries have not been deleted because they have already been checked out.'
								)
								.ok('Okay')
						);
					});
				};

				scope.deleteDelivery = function() {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								// eslint-disable-next-line no-unused-vars
								var $confirmButton = $actionsSection.children()[1];
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Are you sure you want to delete this delivery?')
						.htmlContent(
							'<span class="md-warn">WARNING:</span> The delivery note might have been sent to production already.'
						)
						.ariaLabel('Lucky day')
						.ok('Please delete it!')
						.cancel('cancel');
					$mdDialog.show(confirm).then(function() {
						removeDelivery(scope.farmer.activeDelivery);
					});
				};

				scope.modal = function() {
					$mdDialog.show({
						locals: {
							activeDelivery: scope.farmer.activeDelivery,
							parentScope: scope,
							users: scope.users
						},
						controller: 'DeliverynotesmodalCtrl',
						templateUrl: 'views/delivery-notes-modal.html',
						parent: angular.element(document.body),
						fullscreen: true,
						clickOutsideToClose: true
					});
				};

				scope.updateDelivery = function(deliveryItem) {
					var deliveries = scope.request.deliveries;
					deliveries.forEach(function(value, index) {
						if (Number(value.ID) === Number(deliveryItem.ID)) {
							scope.request.deliveries[index] = value;
							scope.request.deliveries[index].hasCheckout =
								deliveryItem.checkedOut > 0;
							scope.selectDelivery(index);
						}
					});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DispatchCtrl
 * @description
 * # DispatchCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DispatchCtrl', function($scope) {
		$scope.checkCode = function() {
			alert('searching....');
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DeliverymodalCtrl
 * @description
 * # DeliverymodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DeliverymodalCtrl', function($scope, $mdDialog) {
		$scope.delivery = {};
		$scope.delivery.printed = 2;
		$scope.delivery.amount = 1;
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			var postData = {};
			postData.amount = $scope.delivery.amount;
			postData.deliveredDate = $scope.delivery.deliveredDate;
			postData.printStatus = $scope.delivery.printed;
			$mdDialog.hide(postData);
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ManagementsettingsCtrl
 * @description
 * # ManagementsettingsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DeliverynotesmodalCtrl', function(
		$scope,
		$state,
		SETTINGS,
		NotifyUser,
		$timeout,
		activeDelivery,
		parentScope,
		getDeliveryNotesDetail,
		$http,
		$mdDialog,
		users
	) {
		$scope.users = users;
		$scope.activeDelivery = activeDelivery;
		$scope.items = activeDelivery.items;
		$scope.loadedItems = [];

		$scope.codeString = '';

		$scope.rowID = 'CHECKOUT_ID';

		$scope.tableInitialized = false;

		$scope.$exttable = [];

		$scope.$exttableSelected = {
			delivery_notes: []
		};

		function removeCheckouts(checkoutIds) {
			$http
				.delete(SETTINGS.APIBasePath + 'order/delivery-notes/delete', {
					params: {
						ids: checkoutIds.join(','),
						deliveryId: $scope.activeDelivery.ID
					}
				})
				.then(function(result) {
					$scope.initTable($scope.activeDelivery.ID, '');
					if (result.data.res.rowCount > 0) {
						NotifyUser('Deleted.');
						parentScope.updateDelivery(result.data.deliveryItem);
					} else {
						NotifyUser('ERROR', 'Unable to delete.');
					}
				});
		}

		function removeConfirmModal(checkoutIds) {
			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('DELETING CHECKED OUT CODE')
				.textContent('Are you sure you’d like to delete scanned codes?')
				.ariaLabel('Confirm delete')
				.ok('YES DELETE')
				.cancel('NO I’LL THINK ABOUT IT.');

			$mdDialog.show(confirm).then(function() {
				removeCheckouts(checkoutIds);
			});
		}

		setTimeout(function() {
			$scope.initTable($scope.activeDelivery.ID, '');
		}, 0);

		$scope.deliveryNotesColumns = [
			{ data: 'CHECKOUT_ID' },
			{ data: 'CHECKOUT_ID' },
			{ data: 'DELIVERY_ID' },
			{ data: 'SPROD_CD' },
			{ data: 'QR_CD' },
			{ data: 'CHECKOUT_AT' },
			{ data: 'OUT_BY', searchable: false, userId: true },
			{ data: 'CHECKIN_AT' },
			{ data: 'IN_BY', searchable: false, userId: true }
		];

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.initTable = function(deliveryId, scannedCode) {
			getDeliveryNotesDetail.get(
				{ deliveryId: deliveryId, scannedCode: scannedCode },
				function(results) {
					$scope.loadedItems = results.res;

					$scope.$exttable.delivery_notes.rows().remove();
					$scope.$exttable.delivery_notes.rows.add($scope.loadedItems).draw();

					$timeout(function() {
						$scope.$exttable.delivery_notes.column(0).checkboxes.deselectAll();
					});
				}
			);
		};

		$scope.getSelectedRows = function() {
			var ids = [];
			if ($scope.$exttableSelected.delivery_notes.length) {
				$.each($scope.$exttableSelected.delivery_notes, function(index, rowId) {
					ids.push(rowId);
				});
			}
			return ids;
		};

		$scope.removeDeliveryNotes = function() {
			removeConfirmModal($scope.getSelectedRows());
		};

		$scope.checkInDeliveryNotes = function() {
			$http
				.post(SETTINGS.APIBasePath + 'order/delivery-notes/checkin', {
					data: $scope.getSelectedRows()
				})
				.then(function() {
					$scope.refreshTable();
				});
		};

		$scope.undoCheckInDeliveryNotes = function() {
			$http
				.post(SETTINGS.APIBasePath + 'order/delivery-notes/undocheckin', {
					data: $scope.getSelectedRows()
				})
				.then(function() {
					$scope.refreshTable();
				});
		};

		$scope.searchCode = function(clear) {
			if (clear === true) {
				$scope.codeString = '';
			}
			$scope.initTable($scope.activeDelivery.ID, $scope.codeString);
		};

		$scope.refreshTable = function() {
			$scope.initTable($scope.activeDelivery.ID, '');
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ManagementsettingsCtrl
 * @description
 * # ManagementsettingsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('RequestcheckoutmodalCtrl', function(
		$scope,
		SETTINGS,
		NotifyUser,
		$timeout,
		activeRequest,
		getRequestsDetail,
		$http,
		$mdDialog,
		users
	) {
		$scope.users = users;
		$scope.activeRequest = activeRequest;
		$scope.items = activeRequest.items;
		$scope.loadedItems = [];

		$scope.codeString = '';

		$scope.rowID = 'CHECKOUT_ID';

		$scope.tableInitialized = false;

		$scope.$exttable = [];

		$scope.$exttableSelected = {
			delivery_notes: []
		};

		setTimeout(function() {
			$scope.initTable($scope.activeRequest.ID, '');
		}, 0);

		$scope.deliveryNotesColumns = [
			{ data: 'CHECKOUT_ID' },
			{ data: 'DELIVERY_ID' },
			{ data: 'SPROD_CD' },
			{ data: 'QR_CD' },
			{ data: 'CHECKOUT_AT' },
			{ data: 'OUT_BY', searchable: false, userId: true },
			{ data: 'CHECKIN_AT' },
			{ data: 'IN_BY', searchable: false, userId: true }
		];

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.initTable = function(requestId, scannedCode) {
			getRequestsDetail.get(
				{ requestId: requestId, scannedCode: scannedCode },
				function(results) {
					$scope.loadedItems = results.res;

					$scope.$exttable.delivery_notes.rows().remove();
					$scope.$exttable.delivery_notes.rows.add($scope.loadedItems).draw();

					$timeout(function() {
						$scope.$exttable.delivery_notes.column(0).checkboxes.deselectAll();
					});
				}
			);
		};

		$scope.searchCode = function(clear) {
			if (clear === true) {
				$scope.codeString = '';
			}
			$scope.initTable($scope.activeRequest.ID, $scope.codeString);
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.codeValidator
 * @description
 * # codeValidator
 * Service in the wildBieneHarvestApp.
 * See https://docs.google.com/spreadsheets/d/1MvT7tv72d-tUDqoHmrKAKAcKAuMi-p7nvHwwbwm4-JY/edit?usp=sharing
 */
angular.module('wildBieneHarvestApp').service('codeValidator', codeValidator);

function codeValidator() {
	var houseCodePattern =
		'^[AXP][0-9]{2}(DE|CH|FR|IT)[0-9A-Z]{4,5}$' +
		'|^[0-9]{2}[A-Z][0-9]{4}$' +
		'|^[0-9]{2}[FOM][0-9]{6}$' +
		'|^[0-9]{2}(IN)[0-9A-Z]{4}$' +
		'|^(IN|BC|CA|NB)[0-9]{2}[0-9A-Z]{5}$' +
		'|^(BB)(DE|CH|FR|IT|ES)[0-9]{6}$';

	var startpopVoucherPattern = '^\\w{1,10}$';

	var freeCareVoucherPattern = '^FREECARE[0-9]{2}$';
	var beeCareVoucherPattern =
		'^PF[0-9]{2}-[A-Z0-9]{5}$' +
		'|^PF18-[A-Z0-9]{6}$' +
		'|' +
		freeCareVoucherPattern;
	var voucherPattern =
		startpopVoucherPattern +
		'|' +
		beeCareVoucherPattern +
		'|' +
		freeCareVoucherPattern;

	var service = {
		isHouseCode: isHouseCode,
		houseCodePattern: houseCodePattern,
		startpopVoucherPattern: startpopVoucherPattern,
		beeCareVoucherPattern: beeCareVoucherPattern,
		freeCareVoucherPattern: freeCareVoucherPattern,
		voucherPattern: voucherPattern
	};
	return service;

	//////

	function isHouseCode(code) {
		return code && code.length > 5 && code.toUpperCase().match(houseCodePattern);
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:selectOnClick
 * @description
 * # selectOnClick
 */
angular
	.module('wildBieneHarvestApp')
	.directive('selectOnClick', function($window, $timeout) {
		return {
			restrict: 'A',
			link: function postLink(scope, element) {
				var focusedElement = null;
				element.on('focus', function() {
					var self = this;
					if (focusedElement != self) {
						focusedElement = self;
						$timeout(function() {
							self.select();
						}, 10);
					}
				});

				element.on('blur', function() {
					focusedElement = null;
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ReassignhousedialogCtrl
 * @description
 * # ReassignhousedialogCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ReassignhousedialogCtrl', function(
		$scope,
		$mdDialog,
		newClient,
		existingClient,
		newHouse,
		existingHouse,
		products,
		$mdToast,
		$http,
		SETTINGS,
		AlertUser,
		NotifyUser,
		AddressFactory
	) {
		$scope.code = newHouse.code;
		$scope.newClient = newClient;
		$scope.existingClient = existingClient;
		$scope.existingHouse = existingHouse;

		$scope.oldType = products[existingHouse.product_id].PROD_NAME;
		$scope.newType = products[parseInt(newHouse.PROD_ID)].PROD_NAME;

		if (existingClient && existingHouse.address_id) {
			$scope.existingAddress = AddressFactory.getAddressById(
				existingClient.addresses,
				existingHouse.address_id
			);
		} else if (existingClient) {
			$scope.existingAddress = AddressFactory.getBillingAddress(
				existingClient.addresses
			);
		} else {
			$scope.existingAddress = null;
		}
		$scope.newAddress = newClient
			? AddressFactory.getBillingAddress(newClient.addresses)
			: null;

		$scope.assign = function() {
			$mdDialog.hide();
		};

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.harvestSettings
 * @description
 * # harvestSettings
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('harvestSettings', function($http, SETTINGS, $q) {
		// eslint-disable-next-line no-unused-vars

		this.setSeason = function(newSeason) {
			var self = this;
			$http
				.post(SETTINGS.APIBasePath + '/settings/harvest-season', {
					season: newSeason
				})
				.then(function() {
					//TODO implement Toast
					self.harvestSeason = null;
					self.getSeason();
				});
		};
		this.getSeason = function() {
			var defer = $q.defer();
			var self = this;
			if (self.harvestSeason) {
				defer.resolve(self.harvestSeason);
			} else {
				$http.get(SETTINGS.APIBasePath + 'harvest-season').then(function(result) {
					self.harvestSeason = result.data.season;
					defer.resolve(self.harvestSeason);
				});
			}
			return defer.promise;
		};
		this.setSendMails = function(sendMail) {
			$http
				.post(SETTINGS.APIBasePath + '/settings/harvest-mails/', {
					sendMail: sendMail
				})
				.then(function(response) {
					//TODO implement Toast
					// eslint-disable-next-line no-console
					console.log(response);
				});
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:phoneInput
 * @description
 * # phoneInput
 */
angular
	.module('wildBieneHarvestApp')
	.directive('phoneInput', function($filter, $browser) {
		return {
			require: 'ngModel',
			link: function($scope, $element, $attrs, ngModelCtrl) {
				var listener = function() {
					var value = $element.val().replace(/[^0-9]/g, '');
					$element.val($filter('tel')(value, false));
				};

				// This runs when we update the text field
				ngModelCtrl.$parsers.push(function(viewValue) {
					return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
				});

				// This runs when the model gets updated on the scope directly and keeps our view in sync
				ngModelCtrl.$render = function() {
					$element.val($filter('tel')(ngModelCtrl.$viewValue, false));
				};

				$element.bind('change', listener);
				$element.bind('keydown', function(event) {
					var key = event.keyCode;
					// If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
					// This lets us support copy and paste too
					if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
						return;
					}
					$browser.defer(listener); // Have to do this or changes don't get picked up properly
				});

				$element.bind('paste cut', function() {
					$browser.defer(listener);
				});
			}
		};
	})
	.filter('tel', function() {
		return function(tel) {
			if (!tel) {
				return '';
			}

			var value = tel
				.toString()
				.trim()
				.replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return tel;
			}

			var city, number;

			switch (value.length) {
				case 1:
				case 2:
				case 3:
					city = value;
					break;

				default:
					city = value.slice(0, 3);
					number = value.slice(3);
			}

			if (number) {
				if (number.length > 3) {
					number = number.slice(0, 3) + '-' + number.slice(3, 7);
				}

				return ('(' + city + ') ' + number).trim();
			} else {
				return '(' + city;
			}
		};
	});

/* eslint-disable no-undef */
(function() {
	'use strict';
	angular.module('wildBieneHarvestApp').directive('ngWebcam', ngWebcam);
	ngWebcam.$inject = [];
	/**
	 *  @ngdoc Directive
	 *  @name ng-webcam
	 *  @description
	 *
	 *  Directive for capturing images from your computer's camera, and delivery then to you as data uri
	 *  Source: https://github.com/weberamaral/ng-webcam/blob/master/src/ng-webcam.js
	 *
	 *  @usage
	 *  ```html
	 *  <ng-webcam
	 *    config="vm.config"
	 *    on-error="vm.onError(err)"
	 *    on-load="vm.onLoad()"
	 *    on-live="vm.onLive()"
	 *    on-capture-progress="vm.onCaptureProgress(src, progress)"
	 *    on-capture-complete="vm.onCaptureComplete(src)">
	 *  </ng-webcam>
	 *  ```
	 */
	function ngWebcam() {
		var directive = {
			restrict: 'E',
			template: template,
			link: link,
			bindToController: true,
			controller: ngWebcamController,
			controllerAs: 'vm',
			scope: {
				config: '=',
				onCaptureComplete: '&',
				onError: '&',
				onLoad: '&',
				onCaptureProgress: '&',
				onLive: '&'
			}
		};

		// eslint-disable-next-line no-unused-vars
		function template(element, attrs) {
			return [
				'<div class="ng-webcam no-overlay" ng-class="{\'no-overlay\' : vm.counter === 0 || vm.config.countdown === 0}">',
				'<span ng-show="vm.webcamLive === true && vm.config.countdown > 0 && vm.counter > 0" id="ng-webcam-counter">{{vm.counter}}</span>',
				'<div id="ng-webcam-container"></div>',
				'</div>'
			].join('');
		}

		function link(scope, element, attrs, ctrl) {
			ctrl.init();
			scope.$on('$destroy', function() {
				ctrl.destroy();
			});
		}

		ngWebcamController.$inject = ['$scope', '$interval'];

		function ngWebcamController($scope, $interval) {
			/*jshint validthis: true */
			var vm = this;
			var sound, snapshotTimer, countdownTimer;
			var images = [];
			vm.webcamLoaded = false;
			vm.webcamLive = false;
			vm.counter = 3;
			vm.init = init;
			vm.destroy = destroy;
			/**
			 *  @ngdoc listener
			 *  @name ngWebcam_capture
			 *  @description
			 *
			 *  Listener for capture user action
			 *
			 *  @usage
			 *  `$scope.$broadcast('ngWebcam_capture');`
			 */
			$scope.$on('ngWebcam_capture', onWebcamCapture);
			/**
			 *  @ngdoc listener
			 *  @name ngWebcam_on
			 *  @description
			 *
			 *  Listener for camera on user action
			 *
			 *  @usage
			 *  `$scope.$broadcast('ngWebcam_on');`
			 */
			$scope.$on('ngWebcam_on', onWebcamOn);
			/**
			 *  @ngdoc listener
			 *  @name ngWebcam_off
			 *  @description
			 *
			 *  Listener for camera off user action
			 *
			 *  @usage
			 *  `$scope.$broadcast('ngWebcam_off');`
			 */
			$scope.$on('ngWebcam_off', onWebcamOff);

			function init() {
				vm.config = vm.config || {};
				if (window.localStorage) window.localStorage.setItem('visited', '1');
				if (angular.isUndefined(vm.config.viewerWidth))
					vm.config.viewerWidth = 'auto';
				if (angular.isUndefined(vm.config.viewerHeight))
					vm.config.viewerHeight = 'auto';
				if (angular.isUndefined(vm.config.outputWidth)) vm.config.outputWidth = 320;
				if (angular.isUndefined(vm.config.outputHeight))
					vm.config.outputHeight = 240;
				if (angular.isUndefined(vm.config.delay)) vm.config.delay = 0;
				if (angular.isUndefined(vm.config.shots)) vm.config.shots = 1;
				// if (angular.isUndefined(vm.config.countdown)) vm.config.countdown = 0;
				configureListeners();
				configure();
			}

			function destroy() {
				if (vm.webcamLive) Webcam.reset();
				vm.webcamLive = false;
				vm.webcamLoaded = false;
				if (angular.isDefined(snapshotTimer)) {
					$interval.cancel(snapshotTimer);
					snapshotTimer = undefined;
				}
				if (angular.isDefined(countdownTimer)) {
					$interval.cancel(countdownTimer);
					countdownTimer = undefined;
				}
				vm.counter = 3;
			}

			function configure() {
				if (angular.isDefined(vm.config.shutterUrl)) {
					sound = new Audio();
					sound.autoplay = false;
					if (navigator.userAgent.match(/Firefox/)) {
						sound.src = vm.config.shutterUrl.split('.')[0] + '.ogg';
					} else {
						sound.src = vm.config.shutterUrl;
					}
				}
				Webcam.set({
					width: vm.config.viewerWidth,
					height: vm.config.viewerHeight,
					dest_width: vm.config.outputWidth,
					dest_height: vm.config.outputHeight,
					crop_width: vm.config.cropWidth,
					crop_height: vm.config.cropHeight,
					force_flash: false,
					image_format: 'jpeg',
					jpeg_quality: 100,
					flip_horiz: vm.config.flipHorizontal
				});
				if (angular.isDefined(vm.config.flashNotDetectedText)) {
					Webcam.set('flashNotDetectedText', vm.config.flashNotDetectedText);
				}
				if (angular.isDefined(vm.config.flashFallbackUrl)) {
					Webcam.setSWFLocation(vm.config.flashFallbackUrl);
				}
				Webcam.attach('#ng-webcam-container');
			}

			function configureListeners() {
				Webcam.on('load', function() {
					$scope.$apply(function() {
						vm.webcamLoaded = true;
						if (angular.isDefined(vm.onLoad)) {
							vm.onLoad();
						}
					});
				});
				Webcam.on('live', function() {
					$scope.$apply(function() {
						vm.webcamLive = true;
						if (angular.isDefined(vm.onLive)) {
							vm.onLive();
						}
					});
				});
				Webcam.on('error', function(err) {
					// If loading full res fails, then fall back to min settings
					if (vm.config.resolutionFallback) {
						vm.config.outputWidth = vm.config.resolutionFallback.outputWidth;
						vm.config.outputHeight = vm.config.resolutionFallback.outputHeight;
						vm.config.cropWidth = vm.config.resolutionFallback.cropWidth;
						vm.config.cropHeight = vm.config.resolutionFallback.cropHeight;
						vm.config.resolutionFallback = undefined;
						configure();
					} else {
						if (angular.isDefined(vm.onError)) {
							vm.onError({ err: err });
						}
					}
				});
			}

			function capture(index) {
				if (sound) {
					sound.play();
				}
				if (index === vm.config.shots - 1) {
					$interval.cancel(snapshotTimer);
				}
				Webcam.snap(function(data_uri) {
					images[index] = data_uri;
					if (
						index < vm.config.shots - 1 &&
						angular.isDefined(vm.onCaptureProgress)
					) {
						var progress = Math.round(((index + 1) * 100) / vm.config.shots);
						vm.onCaptureProgress({ src: data_uri, progress: progress });
					}
					if (
						index === vm.config.shots - 1 &&
						angular.isDefined(vm.onCaptureComplete)
					) {
						return vm.onCaptureComplete({ src: images });
					}
				});
			}

			function onWebcamCapture() {
				if (angular.isUndefined(vm.config.countdown)) {
					var count = 0;
					snapshotTimer = $interval(
						function() {
							capture(count);
							count++;
						},
						vm.config.delay * 1000,
						vm.config.shots
					);
				} else {
					if (countdownTimer !== undefined) return;
					vm.counter = 3;
					countdownTimer = $interval(
						function() {
							vm.counter = vm.counter - 1;
							if (vm.counter === 0) {
								if (countdownTimer) {
									$interval.cancel(countdownTimer);
								}
								var count = 0;
								snapshotTimer = $interval(
									function() {
										capture(count);
										count++;
									},
									vm.config.delay * 1000,
									vm.config.shots
								);
							}
						},
						1000,
						3
					);
				}
			}

			function onWebcamOn() {
				Webcam.attach('#ng-webcam-container');
			}

			function onWebcamOff() {
				destroy();
			}
		}
		return directive;
	}
})();

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:numberInput
 * @description
 * # numberInput
 */
angular
	.module('wildBieneHarvestApp')
	.directive('numberInput', function($filter, $browser) {
		return {
			require: 'ngModel',
			link: function($scope, $element, $attrs, ngModelCtrl) {
				$element.addClass('numberInput');
				var listener = function() {
					var value = $element.val().replace(/[^0-9]/g, '');
					$element.val(value);
				};
				ngModelCtrl.$parsers.push(function(viewValue) {
					return viewValue;
				});

				ngModelCtrl.$validators.max = function(modelValue) {
					if (Number(modelValue) > Number($element.attr('max'))) {
						return false;
					} else {
						return true;
					}
				};

				$element.bind('change', listener);
				$element.bind('keydown', function(event) {
					var key = event.keyCode;
					// If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
					// This lets us support copy and paste too
					if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
						return;
					}
					$browser.defer(listener); // Have to do this or changes don't get picked up properly
				});

				$element.bind('paste cut', function() {
					$browser.defer(listener);
				});
			}
		};
	});

/* eslint-disable no-global-assign */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:HarvestsettingsCtrl
 * @description
 * # HarvestsettingsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('HarvestsettingsCtrl', function(
		$scope,
		$interval,
		$mdDialog,
		$window,
		SETTINGS,
		harvestSettings,
		converter,
		Session,
		season
	) {
		Session.setStream('beehome');
		Session.pageTitle = 'Harvest Settings';
		$scope.season = season;

		var today = new Date();
		var year = today.getFullYear();
		$scope.seasons = [];

		for (var i = 0; i < year - 2015 + 3; i++) {
			$scope.seasons.push(2015 + i);
		}
		Session.getSendHarvestMails(Session.organisationID).then(function(result) {
			$scope.sendHarvestMails = result;
		});
		$scope.saveSeason = function() {
			season = $scope.season;
			Session.setHarvestSeason($scope.season);
		};
		$scope.saveMailSetting = function() {
			harvestSettings.setSendMails($scope.sendHarvestMails);
		};

		/*$scope.saveEmailExclusionList = function(exclusionList){
            harvestSettings.setEmailExclusionList(exclusionList);
            // Session.setEmailExclusionList(exclusionList);
		}*/
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:FarmercheckoutCtrl
 * @description
 * # FarmercheckoutCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FarmercheckoutCtrl', function(
		$scope,
		$http,
		$window,
		$timeout,
		$mdDialog,
		codeValidator,
		Session,
		SETTINGS,
		codeIdentifier,
		$mdToast,
		AlertUser
	) {
		Session.setStream('farmer');
		Session.pageTitle = 'Beefarmer Checkout';
		$scope.allowedTabs = 0;
		$scope.scannedBarcode = '';
		$scope.season = 0;
		$scope.totalItemsToScan = 0;
		$scope.totalItemsScanned = 0;
		$scope.houseCodePattern = codeValidator.houseCodePattern;

		Session.farmerSettings.getSeason().then(function(value) {
			$scope.season = value;
		});

		$scope.processScan = function(scannedProduct) {
			if (scannedProduct) {
				var codeResponse = codeIdentifier(scannedProduct);
				var scanCode = codeResponse.response;
				if (codeResponse.status == 'success') {
					var requestLength =
						$scope.requestedItems[$scope.productTabSelected].requested;
					for (var i = 0; i <= requestLength; i++) {
						var baseCodeType = codeResponse.type;
						var valueExists = false;
						for (var y = 0; y < $scope.requestedItems.length; y++) {
							var reqItem = $scope.requestedItems[y];
							var BreakException = {};

							for (var z = 0; z < reqItem.DELIVERED_AMT; z++) {
								try {
									Object.keys($scope.requestedItems[y].requestList[z]).forEach(function(
										value
									) {
										var editedCode = value;
										// Sanity check for codes ending with number, eg. population1
										if (!isNaN(editedCode[editedCode.length - 1])) {
											// Trim the trailing number if true
											editedCode = editedCode.substring(0, editedCode.length - 1);
										}

										if (
											editedCode == baseCodeType &&
											$scope.requestedItems[y].requestList[z][value] == scanCode
										) {
											// code already used
											valueExists = true;
											AlertUser(
												'Error',
												'Der gescannte Artikel ist bereits ausgecheckt mit Lieferschein: ' +
													scannedProduct
											);
											throw BreakException;
										}
									});
								} catch (e) {
									break;
								}
							}
						}
					}
					if (!valueExists) {
						$http
							.post(
								SETTINGS.APIBasePath + 'delivery-has-checkouts-in-current-season',
								{
									qr_cd: scanCode
								}
							)
							.then(function(result) {
								var data = result.data.res;

								if (data != null && data.ORDER_SEASON == data.FARMER_SEASON) {
									// already checked out this season
									AlertUser(
										'Error',
										'Der gescannte Artikel ist bereits ausgecheckt mit Lieferschein. <br>' +
											'Delivery ID: ' +
											data.DELIVERY_ID +
											', <br>Name: ' +
											data.FIRSTNAME +
											' ' +
											data.LASTNAME +
											', <br>ADDRESS: ' +
											data.ADDRESS1
									);
								} else {
									var found = false;
									for (
										var tabIndex = 0;
										tabIndex < $scope.requestedItems.length;
										tabIndex++
									) {
										for (
											var codeIndex = 0;
											codeIndex < $scope.requestedItems[tabIndex].requestList.length;
											codeIndex++
										) {
											if (
												$scope.requestedItems[tabIndex].requestList[codeIndex] == scanCode
											) {
												found = true;
											}
										}
									}
									if (
										!found &&
										$scope.requestedItems[$scope.productTabSelected].requestList.length <
											$scope.requestedItems[$scope.productTabSelected].DELIVERED_AMT
									) {
										$scope.requestedItems[$scope.productTabSelected].requestList.unshift(
											scanCode
										);
										$scope.totalItemsScanned++;
									} else {
										var toast = $mdToast
											.simple()
											.textContent('You have already scanned ' + scanCode)
											.position('top right')
											.parent(angular.element('#products'))
											.hideDelay('2000');
										$mdToast.show(toast);
									}
								}
								if (
									$scope.requestedItems[$scope.productTabSelected].requestList.length ==
									$scope.requestedItems[$scope.productTabSelected].DELIVERED_AMT
								) {
									$scope.nextTab();
								}
							});
					}
				} else {
					AlertUser('Error', scanCode);
				}
				$timeout($('#scannerProduct').select());
				return null;
			}
		};

		$scope.focusBarcodeInput = function() {
			focusById('scannedBarcodeInput');
		};

		$scope.focusScannerInput = function() {
			$('#scannerInput').focus();
		};

		$scope.checkDelivery = function() {
			if ($scope.scannedCode && $scope.scannedCode.length > 0) {
				var codeResponse = codeIdentifier($scope.scannedCode, 0);
				var scanCode = codeResponse.response;
				var dbColumnName = codeResponse.dbColumn;

				if (codeResponse.status === 'success') {
					$scope.$root.showLoader = true;
					$http
						.get(SETTINGS.APIBasePath + 'delivery-by-id/' + scanCode)
						.then(function(response) {
							$scope.deliveryCode = $scope.scannedCode;
							$scope.deliveryDate = response.data.deliveryDate;
							var deliveryList = [];
							if (response.data.everything !== null) {
								var Things = response.data.everything.items;
								for (var i = Things.length - 1; i >= 0; i--) {
									var deliveryItem = Things[i].requestItem;
									deliveryItem.DELIVERED_AMT = Things[i].DELIVERED_AMT;
									$scope.totalItemsToScan += Number(deliveryItem.DELIVERED_AMT);
									deliveryList.push(deliveryItem);
								}
							}
							if (deliveryList.length > 0) {
								$http
									.post(SETTINGS.APIBasePath + 'delivery-has-checkouts', {
										columnName: dbColumnName,
										recordValue: scanCode
									})
									.then(function(checkoutResponse) {
										// check if all items is filled and don't continue if it's true
										if (
											checkIfAllCodesIsFilled(
												response.data.deliveryList,
												checkoutResponse.data.checkouts
											)
										) {
											AlertUser('Error', 'Checkout has been successfull.');
											return;
										}

										$scope.checkouts = checkoutResponse.data.checkouts;
										var hasCheckouts = checkoutResponse.data.hasCheckouts;
										$scope.requestedItems = deliveryList;
										// Initialize the values to empty arrays and objects to prevent 'undefined' errors
										$scope.requestedItems.forEach(function(value) {
											value.requestList = [];
										});

										if (!hasCheckouts || hasCheckouts === 0) {
											$scope.deliveryID = scanCode;
											$scope.selectedIndex = 1;
											focusActive();
										} else {
											var countDoesntMatch = false;
											var missingCodeIndex = null;
											deliveryList.forEach(function(delivery, index) {
												var codes = $scope.checkouts.filter(function(obj) {
													return obj.REQUEST_ITEM_ID == delivery.ID;
												});
												if (codes.length != delivery.DELIVERED_AMT) {
													countDoesntMatch = true;

													// Save the first tab where the code is missing;
													if (missingCodeIndex === null) {
														missingCodeIndex = index;
													}
												}
											});
											if (countDoesntMatch === true) {
												$scope.deliveryID = scanCode;
												$scope.selectedIndex = 1;
												$scope.productTabSelected = missingCodeIndex;
												$scope.allowedTabs = missingCodeIndex;

												// Fill the form with already checked out codes
												fillForm($scope.checkouts, deliveryList);
											} else {
												// Already checked out
												AlertUser(
													'Error',
													'Die Lieferung ' + $scope.scannedCode + ' ist bereits ausgecheckt.'
												);
											}
										}
									});
							} else {
								// code not found

								AlertUser(
									'Error',
									'Die Lieferung ' + $scope.scannedCode + ' ist nicht vorhanden.'
								);
							}
							$scope.$root.showLoader = false;
						});
				} else {
					AlertUser('Error', scanCode);
				}
			} else {
				console.warn('atempted to scan an empty code.');
			}
		};

		$scope.prepareScanner = function() {
			$scope.scannedCode = null;
			focusActive();
		};
		// decrements the totalItemsScanned counter when a chip is removed
		$scope.itemRemoved = function() {
			$scope.totalItemsScanned--;
		};

		$scope.nextTab = function() {
			$scope.productTabSelected++;
			if (isLastTab()) {
				focusById('scannedBarcodeInput');
			}
		};

		$scope.confirm = function() {
			$http
				.post(SETTINGS.APIBasePath + 'delivery-checkout', {
					deliveryID: $scope.deliveryID,
					speditionCD: $scope.scannedBarcode[0],
					data: $scope.requestedItems,
					season: $scope.season
				})
				.then(function() {
					$mdDialog
						.show(
							$mdDialog
								.alert()
								.clickOutsideToClose(true)
								.title('Success')
								.textContent(
									'Delivery ' + $scope.deliveryID + ' has been checked out successfully.'
								)
								.ok('Awesome, Thanks!')
						)
						.then(function() {
							$scope.clearForm();
						});
				});
		};

		$scope.enteredProductScanCode = function($event) {
			var keyCode = $event.which || $event.keyCode;
			if (keyCode === 13) {
				angular
					.element(document.getElementById('scannerProduct'))
					.triggerHandler('blur');
			}
		};

		$scope.enteredHouseCode = function($event) {
			var keyCode = $event.which || $event.keyCode;
			if (keyCode === 13) {
				$scope.confirm();
			}
		};

		$scope.clearForm = function() {
			$scope.scannedBarcode = '';
			$scope.productScanCode = null;
			$scope.requestedItems = [];
			$scope.productTabSelected = 0;
			$scope.allowedTabs = 0;
			$scope.selectedIndex = 0;
			$scope.prepareScanner();
		};

		function focusActive() {
			if ($scope.selectedIndex === 0) {
				focusById('scannerInput');
			} else if ($scope.selectedIndex === 1) {
				focusById('scannerProduct');
			}
		}

		function isLastTab() {
			return $scope.productTabSelected === $scope.requestedItems.length;
		}

		function focusById(elementId) {
			$timeout(function() {
				var element = $window.document.getElementById(elementId);
				element.focus();
			});
		}

		$scope.clearCode = function(codeIndex) {
			$scope.requestedItems[$scope.productTabSelected].requestList.splice(
				codeIndex,
				1
			);
			focusActive();
		};
		function fillForm(checkOuts, deliveryList) {
			$scope.requestedItems = deliveryList;
			deliveryList.forEach(function(currentValue, index) {
				var codes = checkOuts.filter(function(obj) {
					return obj.REQUEST_ITEM_ID === currentValue.ID;
				});
				fillTabInputs(codes, index);
			});
		}

		function fillTabInputs(checkOuts, tabIndex) {
			checkOuts.forEach(function(value, index) {
				checkOuts[index]['CODE_IDENTIFIER'] = codeIdentifier(value.QR_CD);
				checkOuts[index]['ASSIGNED'] = false;

				var rowID = checkOuts[index].ITEM_COUNTER - 1;
				var codeType = checkOuts[index].CODE_IDENTIFIER.type;

				for (var key in $scope.displayFields) {
					var editedKey = key;

					// Check if the input type ends with number, eg. 'population1'
					if (!isNaN(editedKey[editedKey.length - 1])) {
						// Trim the trailing number if true
						editedKey = editedKey.substring(0, editedKey.length - 1);
					}

					if (editedKey === codeType && !checkOuts[index]['ASSIGNED']) {
						// Check if the current key is already assigned and if not, assign currenct code to it
						if (!$scope.requestedItems[tabIndex].requestList[rowID][key]) {
							checkOuts[index]['ASSIGNED'] = true;
							$scope.requestedItems[tabIndex].requestList[rowID][key] =
								checkOuts[index].QR_CD;
							break; // No need to iterate through remaining items as we found our missing code
						}
					}
				}
			});
		}

		function checkIfAllCodesIsFilled(deliveryList, checkouts) {
			var totalItems = 0;
			deliveryList.forEach(function(value) {
				totalItems += Number(value.orderAmount);
			});
			return totalItems === checkouts.length;
		}
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:FarmercheckinCtrl
 * @description
 * # FarmercheckinCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FarmercheckinCtrl', function(
		$scope,
		$http,
		$timeout,
		$mdDialog,
		Session,
		SETTINGS,
		codeValidator,
		codeIdentifier
	) {
		Session.setStream('farmer');
		Session.pageTitle = 'Beefarmer Checkin';
		$scope.message = 'THis is a sample error meesage.';
		$scope.showScanner = true;
		$scope.scannedItems = [];
		$scope.houseCodePattern = codeValidator.houseCodePattern;

		// function alert(message, callback) {
		// 	$mdDialog.show(
		// 		$mdDialog
		// 			.alert()
		// 			.clickOutsideToClose(true)
		// 			.title('Attention')
		// 			.textContent(message)
		// 			.ariaLabel('message')
		// 			.ok('OK')
		// 	);
		// }
		$scope.checkin = function() {
			if ($scope.code.length > 0) {
				var codeResponse = codeIdentifier($scope.code, 1);
				var scanCode = codeResponse.response;
				if (codeResponse.status == 'success') {
					$scope.scannedItems = [];
					$scope.validCode = true;
					$scope.selectedIndex++;
				} else {
					$scope.validCode = false;
					$scope.showErrorDialog(scanCode);
					// $scope.prepareScanner();
				}
			}
		};
		$scope.selectBox = function(type) {
			$scope.boxType = type;
			$scope.selectedIndex++;
		};
		$scope.confirm = function() {
			var checkInItems = [];
			var successCount = 0;
			for (var i = $scope.scannedItems.length - 1; i >= 0; i--) {
				var item = $scope.scannedItems[i];

				// If not already checked in
				if (item.status !== 'warning') {
					checkInItems.push(item);
					successCount++;
				}
			}
			if (successCount == 0) {
				$scope.showErrorDialog(
					'None of the listed items can be checked in. Please ensure that the items scanned have been checked out but not checked in yet.'
				);
			} else {
				$http
					.post(SETTINGS.APIBasePath + 'delivery-checkin', {
						data: checkInItems, //$scope.scannedItems
						defaultClientID: Session.defaultClient.id
					})
					.then(function() {
						$mdDialog
							.show(
								$mdDialog
									.alert()

									.clickOutsideToClose(true)
									.title('Success')
									.textContent(
										successCount +
											' out of ' +
											$scope.scannedItems.length +
											' items have succesfully been checked in.'
									)

									.ok('Awesome, Thanks!')
							)
							.then(function() {
								$scope.clearForm();
							});
					});
			}
		};

		$scope.processScan = function(scannedItem) {
			if (scannedItem) {
				var codeResponse = codeIdentifier(scannedItem);
				var scanCode = codeResponse.response;
				// var dbColumnName = codeResponse.dbColumn;
				// var fullComplete = false;

				if (codeResponse.status == 'success') {
					var itemExists = false;
					for (var i = $scope.scannedItems.length - 1; i >= 0; i--) {
						if ($scope.scannedItems[i].code == scannedItem) {
							itemExists = true;
							$scope.showErrorDialog(
								'The following Scan Code has already been listed: ' + scannedItem
							);
							break;
						}
					}
					if (!itemExists) {
						// $scope.scannedItems.push({code: scannedItem, status:"success", dateUpdated: new Date()});
						$http
							.post(SETTINGS.APIBasePath + 'delivery-has-checkouts', {
								columnName: 'QR_CD', //dbColumnName,
								recordValue: scanCode
							})
							.then(function(checkoutResponse) {
								var hasCheckouts = checkoutResponse.data.hasCheckouts;
								var itemStatus = 'fail';
								var dateUpd = null;
								if (hasCheckouts) {
									dateUpd =
										checkoutResponse.data.checkouts[
											checkoutResponse.data.checkouts.length - 1
										].IN_TS;
									itemStatus = 'warning';
									if (!checkoutResponse.data.checkouts[0].IN_TS) {
										itemStatus = 'success';
										dateUpd = checkoutResponse.data.checkouts[0].OUT_TS;
									}
									dateUpd = new Date(dateUpd);
								}
								$scope.scannedItems.unshift({
									code: scannedItem,
									status: itemStatus,
									dateUpdated: dateUpd
								});
							});
					}
				} else {
					$scope.showErrorDialog(scanCode);
					// $scope.prepareScanner
				}
				$timeout($('#scannerProduct').select());
				//$scope.cellColouring();
				return null;
			}
		};

		$scope.removeItem = function(index) {
			$scope.scannedItems.splice(index, 1);
		};

		$scope.enteredProductScanCode = function($event) {
			var keyCode = $event.which || $event.keyCode;
			if (keyCode === 13) {
				angular
					.element(document.getElementById('scannerProduct'))
					.triggerHandler('blur');
			}
		};

		$scope.showErrorDialog = function(msg) {
			$mdDialog
				.show(
					$mdDialog
						.alert()

						.clickOutsideToClose(true)
						.title('Error')
						.textContent(msg)

						.ok('Try again')
				)
				.then(function() {
					$scope.prepareScanner();
				});
		};

		$scope.clearForm = function() {
			$scope.scannedItems = [];
			$scope.prepareScanner();
		};

		$scope.prepareScanner = function() {
			$scope.productScanCode = null;
			$timeout($('#scannerProduct').select());
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.organisations
 * @description
 * # orginisations
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('organisations', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'organisations/all/');
		}
	])
	.service('organisation', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'organisation/:id', {
				id: '@id'
			});
		}
	])

	.factory('AllOrganisations', [
		'organisations',
		'$q',
		function(organisations, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				organisations.query(
					function(agents) {
						delay.resolve(agents);
					},
					function() {
						delay.reject('unable to fetch product Types');
					}
				);
				return delay.promise;
			};
		}
	])

	.factory('CompareOrganisations', [
		'$q',
		'Session',
		'$translate',
		'AlertUser',
		function($q, Session, $translate, AlertUser) {
			return function(orgID) {
				var delay = $q.defer();
				if (Session.organisationID != orgID) {
					$translate('general.warning').then(function(warning) {
						$translate('customer.beehome_org_mismatch').then(function(message) {
							AlertUser(warning, message);
						});
					});
				}
				delay.resolve(true);

				return delay.promise;
			};
		}
	]);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxmanagementCtrl
 * @description
 * # BoxmanagementCtrl
 * Controller of the wildBieneHarvestApp
 */
angular.module('wildBieneHarvestApp').controller('BoxmanagementCtrl', function(
	$scope,
	$state,
	$mdDialog,
	ConfirmUser,
	NotifyUser,
	AlertUser,
	Session,
	FridgeBulkLoader,
	BoxBulkLoader,
	StartpopBulkLoader,
	$stateParams,
	season,
	// DatatablesAjax,
	users
) {
	Session.setStream('management');
	Session.pageTitle = 'Search';
	$scope.season = season;
	$scope.users = users;
	$scope.page = $stateParams.page || 'fridge';

	$scope.selectedIndex = 0;

	if ($scope.page === 'box') {
		$scope.selectedIndex = 1;
	} else if ($scope.page === 'startpop') {
		$scope.selectedIndex = 2;
	}
});

/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxmoadalCtrl
 * @description
 * # BoxmoadalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BoxmodalCtrl', function(
		$scope,
		$mdDialog,
		$mdToast,
		$http,
		SETTINGS,
		AllBoxSources,
		AllSpecies,
		AllBoxTypes,
		defaultStartpopLoader,
		box,
		newCode,
		type,
		boxTypes,
		NotifyUser,
		AlertUser,
		Session,
		Box,
		Batch,
		Fridge,
		hideCheckin,
		batches,
		organisations,
		printerService,
		strains
	) {
		$scope.editing = false;
		$scope.preType = type;
		$scope.boxTypes = boxTypes;
		$scope.validCode = true; //type == 1;
		$scope.validFridgeCode = false;
		$scope.validParentCode = false;
		$scope.houses = [];
		$scope.hideCheckin = hideCheckin || false;
		$scope.defaultPop = 0;
		$scope.refresh = false;
		$scope.startpopConversionFactor = 0;
		$scope.conversionFactors = [];
		$scope.editConversion = false;
		$scope.strains = strains;
		$scope.organisations = organisations;
		$scope.getConversionFactors = getConversionFactors;
		var defaultBatch = null;
		var availableBatches = [];

		function getConversionFactors() {
			$scope.conversionFactors = [];
			if (
				$scope.box.sourceType &&
				$scope.box.sourceType.ID &&
				$scope.box.species &&
				$scope.box.species.ID
			) {
				$http
					.get(
						SETTINGS.APIBasePath +
							'organisations/conversion-factors/' +
							$scope.box.sourceType.ID +
							'/' +
							$scope.box.species.ID
					)
					.then(function(res) {
						$scope.setConversionFactors(res.data.result);
					});
			}
		}

		$scope.getDefaultStartpopLoader = function() {
			defaultStartpopLoader().then(function(res) {
				if ($scope.preType == 2) {
					$scope.defaultPop = res;
				}
			});
		};

		$scope.init = function() {
			if (box) {
				// Dummy decide if the parent is search or detail
				if (box.type) {
					// Detail
					$scope.box = {
						ID: box.ID,
						sourceType: box.sourceType,
						STRAIN_ID: box.STRAIN_ID,
						strain: box.strain,
						ORGANISATION_ID: box.ORGANISATION_ID,
						species: box.species,
						cocoons: parseInt(box.AMOUNT),
						code: box.BOX_CD,
						sourceText: box.content.SOURCE_TEXT,
						type: box.type,
						cocoonNetWeight: parseInt(Math.round(box.content.NET_WEIGHT)),
						conversion_factor: {
							CONV_FACTOR: box.content.CONV_FACTOR
						}
					};
					if (box.parent) {
						$scope.box.parent = box.parent.BOX_CD;

						$scope.box.cocoonNetWeight = parseInt(Math.round(box.NET_WEIGHT));
						$scope.box.conversion_factor = {
							CONV_FACTOR: box.CONV_FACTOR
						};
					} else {
						$scope.box.cocoonNetWeight = parseInt(Math.round(box.content.NET_WEIGHT));
						$scope.box.conversion_factor = {
							CONV_FACTOR: box.content.CONV_FACTOR
						};
					}
					if (box.content.BATCH_ID) {
						angular.forEach(batches, function(element) {
							if (element.ID == box.content.BATCH_ID) {
								$scope.selectedBatch = element;
							}
						});
					}
				} else {
					// Search
					$scope.box = {
						ID: box.ID,
						sourceType: {
							ID: box.SOURCE_ID,
							CODE: box.SOURCE
						},
						species: {
							ID: box.INSCT_ID,
							CODE: box.SPECIES
						},
						STRAIN_ID: box.STRAIN_ID,
						strain: {
							ID: box.STRAIN_ID
						},
						ORGANISATION_ID: box.ORGANISATION_ID,
						cocoons: parseInt(box.AMOUNT),
						code: box.BOX_CD,
						sourceText: box.SOURCE_TEXT,
						parent: box.PARENT_CODE,
						type: {
							ID: $scope.preType
						},
						cocoonNetWeight: parseInt(Math.round(box.NET_WEIGHT)),
						conversion_factor: {
							CONV_FACTOR: box.CONV_FACTOR
						}
					};
					$scope.originalBox = angular.copy($scope.box);
					if (box.BATCH_ID) {
						angular.forEach(batches, function(element) {
							if (element.ID == box.BATCH_ID) {
								$scope.selectedBatch = element;
							}
						});
					}
					getConversionFactors();
				}
				$scope.editing = true;
				$scope.validCode = true;
				$scope.validFridgeCode = true;
				$scope.validParentCode = true;

				$scope.originBoxCode = box.BOX_CD;

				if (typeof box.HOUSES !== 'undefined') {
					for (var i = 0; i < box.HOUSES.length; i++) {
						$scope.houses.push(box.HOUSES[i]);
					}
				}
			} else {
				$scope.box = {
					type: null,
					code: newCode
				};
			}

			if ($scope.editing || $scope.preType) {
				for (var i = 0; i < $scope.boxTypes.length; i++) {
					var element = $scope.boxTypes[i];
					if ($scope.editing && $scope.box.type.ID == element.ID) {
						$scope.box.type = element;
					} else if ($scope.preType && $scope.preType == element.ID) {
						$scope.box.type = element;
					}
				}
			}
		};

		$scope.$watch('box.type', function(val) {
			if (
				((val && val.CODE.toLowerCase() == 'startpop') || $scope.preType == 2) &&
				$scope.box.cocoons == null
			) {
				$scope.box.cocoons = Number($scope.defaultPop);
			}

			if (val && val.CODE != 'Startpop') {
				setDefaultBatch();
			}
		});

		$scope.sourceTypes = [];

		$scope.getAllSources = function() {
			AllBoxSources().then(function(results) {
				$scope.sourceTypes = results;
				if ($scope.editing && $scope.box.sourceType) {
					for (var j = 0; j < $scope.sourceTypes.length; j++) {
						var element = $scope.sourceTypes[j];
						if (element.ID == $scope.box.sourceType.ID) {
							$scope.box.sourceType = element;
						}
					}
				}
			});
		};

		$scope.getAllSpecies = function() {
			AllSpecies().then(function(result) {
				$scope.allSpecies = [];
				for (var i = 0; i < result.length; i++) {
					var element = result[i];
					if (element.PROCESS_CD === 'C') {
						$scope.allSpecies.push(element);
					}
				}

				if ($scope.editing) {
					for (var i = 0; i < $scope.allSpecies.length; i++) {
						var element = $scope.allSpecies[i];
						if ($scope.box.species && $scope.box.species.ID == element.ID) {
							$scope.box.species = element;
						}
					}
				}
			});
		};

		$scope.checkCode = function() {
			if ($scope.box.code) {
				if (!$scope.editing) {
					$scope.checkCocoonAmount();
					$http
						.get(
							SETTINGS.APIBasePath +
								'box/' +
								$scope.box.code +
								'?season=' +
								Session.managementSeason
						)
						.then(function(result) {
							if (result.data.box && result.data.box.type.CODE == 'Startpop') {
								if (result.data.box.content.SEASON == Session.managementSeason) {
									NotifyUser(
										'This box is already in use for season ' +
											Session.managementSeason +
											'.'
									);
									$scope.validCode = false;
								} else {
									$scope.validCode = true;

									$scope.box = {
										code: $scope.box.code,
										type: $scope.box.type,
										cocoons: $scope.defaultPop
									};
								}
							} else if (
								result.data.box &&
								(!result.data.box.status || result.data.box.status === 'OUT') &&
								result.data.box.AMOUNT == 0
							) {
								NotifyUser('This box has been found and is being refreshed.');

								$scope.validCode = true;
								$scope.box = {
									code: $scope.box.code,
									type: $scope.box.type,
									ID: result.data.box.ID,
									cocoons: $scope.defaultPop
								};
								$scope.refresh = true;
							} else if (result.data.box) {
								NotifyUser(
									'This box is already in use and contains cocoons, or is still checked in. Perform a checkout and empty the box to reuse it.'
								);

								$scope.validCode = false;
							} else {
								$scope.box = {
									code: $scope.box.code,
									type: $scope.box.type,
									cocoons: $scope.defaultPop
								};

								$scope.validCode = true;
							}
							if ($scope.box.type && $scope.box.type.CODE != 'Startpop') {
								setDefaultBatch();
							}
						});
				} else {
					if ($scope.originBoxCode != $scope.box.code) {
						$http
							.get(SETTINGS.APIBasePath + 'box/' + $scope.box.code)
							.then(function(result) {
								if (result.data.box) {
									NotifyUser('This box code is already in use.');
									$scope.validCode = false;
								} else {
									$scope.validCode = true;
								}
							});
					} else {
						$scope.validCode = true;
					}
				}
			} else if ($scope.box.type.ID == 2) {
				$scope.validCode = false;
			}
			$scope.setEditConversion($scope.box.conversion_factor);
		};

		$scope.checkCocoonAmount = function() {
			$scope.setCocoonAmount(0);
			if (
				$scope.box.cocoonNetWeight &&
				$scope.box.conversion_factor &&
				$scope.box.conversion_factor.CONV_FACTOR
			) {
				$scope.setCocoonAmount(
					$scope.box.cocoonNetWeight * $scope.box.conversion_factor.CONV_FACTOR
				);
			}
		};

		$scope.setCocoonAmount = function(cocoonAmount) {
			$scope.box.cocoons = Math.round(cocoonAmount);
		};

		$scope.setConversionFactors = function(conversionFactors) {
			$scope.conversionFactors = conversionFactors.filter(
				factor =>
					Number(factor.ORGANISATION_ID) === Number($scope.box.ORGANISATION_ID)
			);
			$scope.box.conversion_factor = conversionFactors.find(
				factor =>
					Number(factor.ORGANISATION_ID) === Number($scope.box.ORGANISATION_ID) &&
					factor.DEFLT === 'Y'
			);

			$scope.checkCocoonAmount();
		};

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$scope.box.season = Session.managementSeason;
			if ($scope.selectedBatch) {
				$scope.box.batch = $scope.selectedBatch.ID;
			}
			$scope.box.checkIn = $scope.checkInFridge;
			$scope.box.houses = $scope.houses;

			var urlString;
			if (!$scope.refresh) {
				urlString = SETTINGS.APIBasePath + 'box';
			} else {
				urlString = SETTINGS.APIBasePath + 'box/refresh';
			}
			$http.post(urlString, $scope.box).then(function(result) {
				if (result.data.error == true) {
					var nf = $mdDialog
						.alert()
						.clickOutsideToClose(true)
						.title('Error')
						.textContent(result.data.message)
						.ariaLabel(result.data.message)
						.ok('OK');
					$mdDialog.show(nf);
				} else {
					var printData = {
						cocoons: result.data.box.AMOUNT,
						weight: result.data.box.content.NET_WEIGHT,
						boxCode: result.data.box.BOX_CD,
						batchCode: result.data.box.content.BATCH_CD
					};
					printerService('qrCodeBox', printData);
				}
				$mdDialog.hide($scope.box);
			});
		};

		$scope.getBatches = function(query) {
			var urlString;
			if (query) {
				var urlString = SETTINGS.APIBasePath + 'batch/search?query=' + query;
				return $http.get(urlString).then(function(result) {
					availableBatches = result.data;
					return availableBatches;
				});
			} else {
				availableBatches = angular.copy(batches);
				return availableBatches;
			}
		};

		function setDefaultBatch() {
			if (defaultBatch == null && $scope.selectedBatch == null) {
				for (var i = 0; i < batches; i++) {
					if (batches[i].ID == 1) {
						defaultBatch = batches[i];
						$scope.selectedBatch = angular.copy(defaultBatch);
					}
				}
			}
		}

		$scope.createBatch = function(batch_cd) {
			Batch.save(
				{ code: batch_cd },
				function(res) {
					if (res.error) {
						NotifyUser('Unable to create batch...');
					} else {
						var newBatch = {
							ID: res.newId,
							BATCH_CD: batch_cd
						};
						availableBatches.push(newBatch);
						$scope.selectedBatch = newBatch;
					}
				},
				function() {
					NotifyUser('Unable to create batch...');
				}
			);
		};

		$scope.findParent = function() {
			if ($scope.box.parent) {
				Box.get(
					{
						id: $scope.box.parent,
						season: Session.managementSeason
					},
					function(result) {
						if (result.box) {
							$scope.validParentCode = true;
							if (result.box.content.CONV_FACTOR) {
								$scope.box.conversion_factor = {
									CONV_FACTOR: result.box.content.CONV_FACTOR
								};
							}
						} else {
							$scope.validParentCode = false;
							NotifyUser('Parent box with code ' + $scope.box.parent + ' not found.');
						}
					}
				);
			}
		};

		$scope.findFridge = function() {
			if ($scope.checkInFridgeCode) {
				Fridge.get(
					{
						id: $scope.checkInFridgeCode
					},
					function(result) {
						if (result.fridge) {
							$scope.validFridgeCode = true;
							$scope.checkInFridge = result.fridge;
						} else {
							$scope.checkInFridge = null;
							$scope.checkInFridgeCode = '';
							$scope.validFridgeCode = false;
							NotifyUser(
								'Code not found. Please create a new fridge or scan an existing one.'
							);
						}
					}
				);
			}
		};

		$scope.canBeSaved = function() {
			if ($scope.box.type.ID == 1) {
				// Storagebox
				if ($scope.shouldCheckIn && !$scope.validFridgeCode) {
					NotifyUser('Fridge code is not valid');
					return false;
				} else {
					return true;
				}
			} else {
				// Startpop
				if (
					!$scope.validCode ||
					!$scope.validParentCode ||
					($scope.shouldCheckIn && !$scope.validFridgeCode)
				) {
					NotifyUser('Originating box is not valid');
					return false;
				} else {
					return true;
				}
			}
		};

		$scope.addHouse = function() {
			var tempCode = $scope.houseCode.toUpperCase();

			for (var i = 0; i < $scope.houses.length; i++) {
				var element = $scope.houses[i];
				if (element.HOUSE_CD == tempCode) {
					NotifyUser('House ' + tempCode + ' has already been scanned.');
					return;
				}
			}

			$http
				.get(SETTINGS.APIBasePath + 'management/house/' + tempCode)
				.then(function(result) {
					$scope.houseCode = '';
					if (result.data.error) {
						NotifyUser(result.data.error_message);
					} else if (!result.data.house) {
						NotifyUser('House ' + tempCode + ' not found.');
						if (tempCode.indexOf('NB') === 0 || tempCode.indexOf('BB') === 0) {
							NotifyUser('Creating a new record');

							// set product to Bee Breeder
							let productId = 6;
							// if the code start with NB set the product to osmipro
							if (tempCode.indexOf('NB') === 0) {
								productId = 12;
							}
							//set the default customer Id for WBP;
							let DefaultCutomerId = 27398;
							// If The Org is set to gmbh, change the default customer
							if ($scope.box.ORGANISATION_ID == 3) {
								DefaultCutomerId = 27887;
							}
							const houseData = {
								client_id: DefaultCutomerId,
								code: tempCode,
								product_id: productId
							};
							$http.post(SETTINGS.beehomeAPIBasePath + 'houses', houseData).then(
								() => {
									$scope.houseCode = tempCode;
									$scope.addHouse();
								},
								() => {
									NotifyUser('Unable to create a new record');
								}
							);
						}
					} else {
						$scope.houses.push(result.data.house);
					}
				});
		};

		$scope.removeHouse = function(index) {
			$scope.houses.splice(index, 1);
		};

		$scope.setEditConversion = function(conversionFactor) {
			$scope.editConversion = !conversionFactor || !conversionFactor.CONV_FACTOR;
		};

		$scope.getDefaultStartpopLoader();
		$scope.getAllSpecies();
		$scope.getAllSources();
		$scope.init();
		$scope.checkCode();
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxesmoadalCtrl
 * @description
 * # BoxesmoadalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BoxesmodalCtrl', function(
		$scope,
		$mdDialog,
		$mdToast,
		$http,
		SETTINGS,
		AllBoxSources,
		AllSpecies,
		AllBoxTypes,
		defaultStartpopLoader,
		boxCodes,
		type,
		NotifyUser,
		Session,
		Box,
		BoxBulkLoader,
		StartpopBulkLoader,
		AlertUser
	) {
		$scope.preType = type;
		$scope.codesPretty = boxCodes.join(', ');
		$scope.boxCodes = boxCodes;
		$scope.validFridgeCode = false;
		$scope.validParentCode = false;

		var defaultPop = 0;
		defaultStartpopLoader().then(function(res) {
			if ($scope.preType == 2) {
				defaultPop = res;
			}
		});

		$scope.box = {
			type: null
		};

		$scope.$watch('box.type', function(val) {
			if (
				((val && val.CODE.toLowerCase() == 'startpop') || $scope.preType == 2) &&
				$scope.box.cocoons == null
			) {
				$scope.box.cocoons = Number(defaultPop);
			}
		});
		$scope.boxTypes = '';
		$scope.sourceTypes = [];

		AllBoxSources().then(function(results) {
			$scope.sourceTypes = results;
		});
		AllSpecies().then(function(result) {
			$scope.allSpecies = [];
			for (var i = 0; i < result.length; i++) {
				var element = result[i];
				if (element.PROCESS_CD === 'C') {
					$scope.allSpecies.push(element);
				}
			}
		});
		AllBoxTypes().then(function(result) {
			$scope.boxTypes = result;

			if (type) {
				for (var i = 0; i < $scope.boxTypes.length; i++) {
					var element = $scope.boxTypes[i];
					if (type && type == element.ID) {
						$scope.box.type = element;
					}
				}
			}
		});

		function removeEmpty(obj) {
			Object.keys(obj).forEach(function(key) {
				if (!obj[key]) delete obj[key];
			});
			return obj;
		}

		function isEmpty(obj) {
			return Object.keys(obj).length === 0;
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			var updateData = $scope.box;

			delete updateData.type;
			updateData = removeEmpty(updateData);

			updateData.season = Session.managementSeason;
			if ($scope.selectedBatch) {
				updateData.batch = $scope.selectedBatch.ID;
			}

			if (!isEmpty(updateData)) {
				if ($scope.preType === 2) {
					StartpopBulkLoader.save(
						{ codes: $scope.boxCodes.join(','), data: updateData },
						function() {
							NotifyUser('Startpops were edited succesfully');
							$mdDialog.hide();
						},
						function() {
							$mdDialog.hide();
							AlertUser('Error', 'Unable to update startpops');
						}
					);
				} else {
					BoxBulkLoader.save(
						{ codes: $scope.boxCodes.join(','), data: updateData },
						function() {
							NotifyUser('Boxes were edited succesfully');
							$mdDialog.hide();
						},
						function() {
							$mdDialog.hide();
							AlertUser('Error', 'Unable to update boxes');
						}
					);
				}
			} else {
				NotifyUser('Nothing to update...');
				$mdDialog.hide();
			}
		};
		$scope.editAlert = function() {
			$mdDialog.show(
				$mdDialog
					.alert()
					.clickOutsideToClose(true)
					.title('This is an alert title')
					.textContent('You can specify some description text in here.')
					.ariaLabel('Alert Dialog Demo')
					.ok('Got it!')
			);
		};
		$scope.getBatches = function(query) {
			var urlString;
			if (query) {
				urlString = SETTINGS.APIBasePath + 'batch/search?query=' + query;
			} else {
				urlString = SETTINGS.APIBasePath + 'batch';
			}
			return $http.get(urlString).then(function(result) {
				return result.data;
			});
		};
		$scope.createBatch = function(batch_cd) {
			//TODO Tom & Tom to discuss 'Batch'
			// eslint-disable-next-line no-undef
			Batch.save(
				{ code: batch_cd },
				function(res) {
					if (res.error) {
						NotifyUser('Unable to create batch...');
					}
				},
				function() {
					NotifyUser('Unable to create batch...');
				}
			);
		};
		$scope.findParent = function() {
			Box.get(
				{
					id: $scope.box.parent,
					season: Session.managementSeason
				},
				function(result) {
					if (result.box) {
						$scope.validParentCode = true;
					} else {
						$scope.validParentCode = false;
						NotifyUser('Parent box with code ' + $scope.box.parent + ' not found.');
					}
				}
			);
		};
		$scope.findFridge = function() {
			// eslint-disable-next-line no-undef
			Fridge.get(
				{
					id: $scope.checkInFridgeCode
				},
				function(result) {
					if (result.fridge) {
						$scope.validFridgeCode = true;
						$scope.checkInFridge = result.fridge;
					} else {
						$scope.checkInFridge = null;
						$scope.checkInFridgeCode = '';
						$scope.validFridgeCode = false;
						NotifyUser(
							'Code not found. Please create a new fridge or scan an existing one.'
						);
					}
				}
			);
		};
		$scope.canBeSaved = function() {
			if ($scope.preType === 2) {
				// Startpop
				if (!$scope.validParentCode) {
					NotifyUser('Originating box is not valid');
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ImagemodalCtrl
 * @description
 * # ImagemodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ImagemodalCtrl', function(
		$scope,
		$mdDialog,
		image_url,
		image_title
	) {
		$scope.image_url = image_url;
		$scope.image_title = image_title;
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:FridgemodalCtrl
 * @description
 * # FridgemodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FridgemodalCtrl', function(
		$scope,
		$mdDialog,
		$http,
		$timeout,
		SETTINGS,
		fridge,
		fridgeModels,
		AlertUser,
		NotifyUser
	) {
		$http.get(SETTINGS.APIBasePath + 'organisations').then(function(result) {
			$scope.organisations = result['data'];
		});

		$scope.editing = false;
		$scope.validCode = false;
		if (fridge != null) {
			$scope.editing = true;
			$scope.validCode = true;
			$scope.fridge = {
				ID: fridge.ID,
				code: fridge.FRIDGE_CD,
				model: fridge.MODEL,
				location: fridge.LOCATION,
				organisationID: fridge.ORGANISATION_ID
			};
			if (fridge.temperatures && fridge.temperatures.length) {
				$scope.fridge.temp = fridge.temperatures[0].TEMPERATURE;
			} else if (fridge.TEMPERATURE) {
				$scope.fridge.temp = fridge.TEMPERATURE;
			}
		} else {
			$scope.fridge = {};
			$scope.newCode = null;
		}
		$scope.fridgeModels = fridgeModels;
		for (var i = 0; i < $scope.fridgeModels.length; i++) {
			var element = $scope.fridgeModels[i];
			if (element.DEFLT == 'Y' && !$scope.editing) {
				$scope.fridge.model = $scope.fridgeModels[i];
			} else if ($scope.editing && fridge.MODEL_ID == element.ID) {
				$scope.fridge.model = element;
			}
		}
		$scope.addCode = function() {
			if (!$scope.editing) {
				if ($scope.fridge.code) {
					$http
						.get(SETTINGS.APIBasePath + 'check-code/' + $scope.fridge.code)
						.then(function(result) {
							if (result.data.type !== 'unused') {
								NotifyUser('this code is in use already');
								$scope.validCode = false;
							} else {
								$scope.validCode = true;
							}
						});
				} else {
					$scope.validCode = false;
				}
			}
		};
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			$http
				.post(SETTINGS.APIBasePath + 'fridge', $scope.fridge)
				.then(function(result) {
					if ($scope.editing) {
						NotifyUser('Fridge was edited successfully');
					} else {
						NotifyUser('Fridge was created successfully');
					}
					$mdDialog.hide($scope.fridge);
					if (result.data.inUse) {
						AlertUser('Error', 'This code is already in use.');
					}
				});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:FridgesmodalCtrl
 * @description
 * # FridgesmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FridgesmodalCtrl', function(
		$scope,
		$mdDialog,
		$http,
		$timeout,
		SETTINGS,
		fridgeCodes,
		fridgeModels,
		FridgeBulkLoader,
		AlertUser,
		NotifyUser
	) {
		$scope.data = {};
		$scope.codesPretty = fridgeCodes.join(', ');
		$scope.fridgeCodes = fridgeCodes;
		$scope.fridgeModels = fridgeModels;

		function removeEmpty(obj) {
			Object.keys(obj).forEach(function(key) {
				if (!obj[key]) delete obj[key];
			});
			return obj;
		}

		function isEmpty(obj) {
			return Object.keys(obj).length === 0;
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			$scope.data = removeEmpty($scope.data);

			if (!isEmpty($scope.data)) {
				FridgeBulkLoader.save(
					{ codes: $scope.fridgeCodes.join(','), data: $scope.data },
					function() {
						NotifyUser('Fridges were edited succesfully');
						$mdDialog.hide();
					},
					function() {
						$mdDialog.hide();
						AlertUser('Error', 'Unable to update fridges');
					}
				);
			} else {
				NotifyUser('Nothing to update...');
				$mdDialog.hide();
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:StartpopCtrl
 * @description
 * # StartpopCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BeehomeOrdersStateCtrl', function(
		$scope,
		Session,
		organisations,
		users
	) {
		Session.setStream('beehome');
		Session.pageTitle = 'BeeHome orders';
		$scope.organisations = organisations;
		$scope.users = users;
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:productHistory
 * @description
 * # productHistory
 */
angular.module('wildBieneHarvestApp').directive('productHistory', function() {
	return {
		templateUrl: 'views/product-history.html',
		scope: { product: '=product', activeCode: '=', disableEdit: '=?' },
		link: function postLink() {}
	};
});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxcheckinCtrl
 * @description
 * # BoxcheckinCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BoxcheckinCtrl', function(
		$scope,
		$stateParams,
		$window,
		$mdDialog,
		$mdToast,
		$http,
		$timeout,
		SETTINGS,
		Session,
		BoxLoader,
		AllBoxTypes,
		Box,
		Fridge,
		checkCode,
		AlertUser,
		NotifyUser
	) {
		Session.setStream('management');
		Session.pageTitle = 'Check In';

		$scope.boxes = $stateParams.boxes || [];
		$scope.scannedcode = '';
		$scope.showBoxes = true;

		function selectScannerInput() {
			$timeout(function() {
				$scope.scannedcode = '';
				var element = $window.document.getElementById('scannerInput');

				if (element) {
					element.focus();
				}
			}, 130);
		}
		$scope.checkin = function() {
			var tempCode = (' ' + $scope.scannedcode).slice(1).toUpperCase();
			$scope.$root.showLoader = true;
			for (var i = 0; i < $scope.boxes.length; i++) {
				var element = $scope.boxes[i];
				if (element.BOX_CD === tempCode) {
					$scope.$root.showLoader = false;
					AlertUser(
						'ERROR',
						'Box ' + element.BOX_CD + ' has been scanned already.',
						selectScannerInput
					);
					return;
				}
			}
			checkCode.get(
				{
					code: $scope.scannedcode
				},
				function(result) {
					if (result.type === 'fridge') {
						$scope.$root.showLoader = false;
						var msg = 'The scanned code is associated to a ' + result.type + '.';
						AlertUser('ERROR', msg, $scope.selectBoxInput);
						return;
					}

					Box.get(
						{
							id: $scope.scannedcode
						},
						function(result) {
							$scope.$root.showLoader = false;
							if (!result.box) {
								$mdDialog
									.show({
										controller: 'BoxmodalCtrl',
										controllerAs: 'ctrl',
										templateUrl: 'views/box-modal.html',
										parent: angular.element(document.body),
										fullscreen: true,
										clickOutsideToClose: true,
										locals: {
											box: null,
											newCode: tempCode,
											type: null,
											hideCheckin: true
										},
										resolve: {
											boxTypes: function(AllBoxTypes) {
												return AllBoxTypes();
											},
											batches: function(AllBatches) {
												return AllBatches();
											},
											strains: function(ReferencesFactory) {
												return ReferencesFactory.getStrains();
											},
											organisations: function(AllOrganisations) {
												return AllOrganisations();
											}
										}
									})
									.then(
										function() {
											BoxLoader(tempCode).then(
												function(result) {
													$scope.boxes.push(result);
													selectScannerInput();
												},
												function() {
													NotifyUser('an error has occured');
												}
											);
										},
										function() {
											selectScannerInput();
										}
									);
								NotifyUser('Code was not found. Please create a new entry.');
							} else {
								$scope.boxes.push(result.box);
								$scope.scannedcode = '';
							}
						}
					);
				}
			);
		};
		$scope.removeBox = function(ind) {
			$scope.boxes.splice(ind, 1);
		};
		$scope.completeBoxes = function() {
			$scope.selectedIndex = 2;
			$timeout(function() {
				var element = $window.document.getElementById('fridgeInput');
				if (element) {
					element.focus();
				}
			}, 300);
		};

		$scope.selectFridge = function() {
			$scope.$root.showLoader = true;
			Fridge.get(
				{
					id: $scope.scannedFridge
				},
				function(result) {
					if (result.fridge) {
						$scope.$root.showLoader = false;
						$scope.validFridgeCode = true;
						$scope.fridge = result.fridge;
						$scope.selectedIndex = 3;
					} else {
						$scope.$root.showLoader = false;
						$scope.scannedFridge = '';
						AlertUser(
							'ERROR',
							'Code not found. Please create a new Fridge or scan an existing one.',
							$scope.completeBoxes
						);
					}
				}
			);
		};
		$scope.confirmCheckin = function() {
			var checkinInfo = {
				boxes: $scope.boxes,
				fridge: $scope.fridge,
				season: Number(Session.managementSeason)
			};
			$scope.$root.showLoader = true;
			$http
				.post(SETTINGS.APIBasePath + 'box/checkin', checkinInfo)
				.then(function() {
					var toast = $mdToast
						.simple()
						.textContent(
							$scope.boxes.length +
								' boxes have been checked into ' +
								checkinInfo.fridge.FRIDGE_CD
						)
						.position('top right')
						.hideDelay('2000');
					$mdToast.show(toast);
					$scope.validFridgeCode = false;
					$scope.fridge = null;
					$scope.boxes = [];
					$scope.selectedIndex = 1;
					$scope.$root.showLoader = false;
				});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxcheckoutCtrl
 * @description
 * # BoxcheckoutCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BoxcheckoutCtrl', function(
		$scope,
		$stateParams,
		$mdDialog,
		$http,
		$timeout,
		$window,
		$mdToast,
		SETTINGS,
		Session,
		Box,
		xferReasons,
		checkCode,
		AlertUser
	) {
		Session.setStream('management');
		Session.pageTitle = 'Check Out';

		$scope.boxes = $stateParams.boxes || [];
		$scope.reasons = xferReasons;
		$scope.scannedcode = '';

		$scope.canBeConfirmed = false;

		function selectBoxInput() {
			$timeout(function() {
				$scope.scannedcode = '';
				var element = $window.document.getElementById('scannerInput');

				if (element) {
					element.focus();
				}
			}, 100);
		}
		for (var i = 0; i < $scope.reasons.length; i++) {
			if ($scope.reasons[i].DEFLT === 'Y') {
				$scope.intent = $scope.reasons[i];
			}
		}
		$scope.removeBox = function(index) {
			$scope.boxes.splice(index, 1);
		};
		$scope.submitBoxes = function() {
			$scope.selectedIndex++;
		};
		$scope.submitIntent = function() {
			$scope.canBeConfirmed = true;
			$scope.selectedIndex++;
		};
		$scope.checkout = function() {
			var tempCode = (' ' + $scope.scannedcode).slice(1).toUpperCase();
			$scope.$root.showLoader = true;

			for (var i = 0; i < $scope.boxes.length; i++) {
				var element = $scope.boxes[i];
				if (element.BOX_CD == tempCode) {
					$scope.$root.showLoader = false;
					AlertUser(
						'ERROR',
						'Box ' + tempCode + ' already been scanned.',
						selectBoxInput
					);
					return;
				}
			}

			Box.get(
				{
					id: $scope.scannedcode
				},
				function(result) {
					$scope.$root.showLoader = false;
					if (!result.box) {
						var confirm = $mdDialog
							.alert()
							.title('404')
							.textContent(
								'No Record of the box ' + $scope.scannedcode + ' was found.'
							)
							.ariaLabel('None found')
							.ok('Ok');
						$mdDialog.show(confirm);
					} else if (result.box.status != 'IN') {
						// eslint-disable-next-line no-redeclare
						var confirm = $mdDialog
							.alert()
							.title('412')
							.textContent(
								'Box ' + $scope.scannedcode + ' has not been checked in to a fridge.'
							)
							.ariaLabel('None found')
							.ok('Ok');
						$mdDialog.show(confirm);
					} else {
						$scope.boxes.push(result.box);
						$scope.scannedcode = '';
					}

					Box.get(
						{
							id: $scope.scannedcode
						},
						function(result) {
							$scope.$root.showLoader = false;
							if (!result.box) {
								AlertUser(
									'ERROR',
									'Box ' + $scope.scannedcode + ' not found.',
									selectBoxInput
								);
							} else if (result.box.status != 'IN') {
								AlertUser(
									'ERROR',
									'Box ' + $scope.scannedcode + ' has not been checked in to a fridge.',
									selectBoxInput
								);
							} else {
								$scope.boxes.push(result.box);
								$scope.scannedcode = '';
							}
						}
					);
				}
			);
		};
		$scope.confirmCheckout = function() {
			var checkoutInfo = {
				boxes: $scope.boxes,
				intent: $scope.intent.ID,
				season: Number(Session.managementSeason)
			};
			$scope.$root.showLoader = true;
			$http
				.post(SETTINGS.APIBasePath + 'box/checkout', checkoutInfo)
				.then(function() {
					$scope.$root.showLoader = false;
					var toast = $mdToast
						.simple()
						.textContent($scope.boxes.length + ' boxes have been checked out')
						.position('top right')
						.hideDelay('2000');
					$mdToast.show(toast);
					$scope.boxes = [];
					$scope.canBeConfirmed = false;
					$scope.selectedIndex = 1;
				});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:fridgeCtrl
 * @description
 * # fridgeCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('FridgeCtrl', function(
		$scope,
		$state,
		$timeout,
		fridge,
		Session,
		BoxesForFridge,
		StartpopsForFridge,
		ConfirmUser,
		AlertUser,
		NotifyUser,
		season,
		users
	) {
		Session.setStream('management');
		Session.pageTitle = 'Fridge details';
		$scope.fridge = fridge;
		$scope.season = season;
		$scope.users = users;
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BoxCtrl
 * @description
 * # BoxCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BoxCtrl', function($scope, box, Session, $state) {
		Session.setStream('management');

		$scope.box = box;

		if ($scope.box.type.ID == 1) {
			Session.pageTitle = 'Box details';
		} else if (box.type.ID == 2) {
			Session.pageTitle = 'Population details';
		}

		$scope.backToSearch = function() {
			$state.go('managementSearch', {
				page: $scope.box.type.ID == 1 ? 'box' : 'startpop'
			});
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.BoxLoader
 * @description
 * # BoxLoader
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('checkCode', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'check-code/:code', {
				code: '@code'
			});
		}
	])
	.factory('Box', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'box/:id', { id: '@id' });
		}
	])
	.factory('BoxLoader', [
		'Box',
		'$q',
		'$state',
		'$http',
		'SETTINGS',
		'AllProducts',
		'AllBoxTypes',
		function(Box, $q, $state) {
			return function(bid, season) {
				var delay = $q.defer();
				if (typeof bid === 'undefined') {
					bid = $state.params.bid;
				}

				Box.get(
					{ id: bid, season: season },
					function(box) {
						if (box.box.statusChange) {
							box.box.statusChange = new Date(box.box.statusChange);
						}
						if (box.box.status == 'OUT') {
							box.box.fridgeCode = null;
						}
						delay.resolve(box.box);
					},
					function() {
						delay.reject('unable to load box');
					}
				);
				return delay.promise;
			};
		}
	]);
angular
	.module('wildBieneHarvestApp')
	.factory('Boxes', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'box/latest/:season', {
				season: '@season'
			});
		}
	])
	.factory('BoxesLoader', [
		'Boxes',
		'$q',
		'$state',
		'$http',
		'SETTINGS',
		'AllProducts',
		'AllBoxTypes',
		function(Boxes, $q) {
			return function(season) {
				var delay = $q.defer();

				Boxes.query(
					{ season: season },
					function(boxes) {
						delay.resolve(boxes);
					},
					function() {
						delay.reject('unable to load box');
					}
				);
				return delay.promise;
			};
		}
	]);
angular
	.module('wildBieneHarvestApp')
	.factory('boxTypes', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return $resource(SETTINGS.APIBasePath + 'box/types');
		}
	])
	.factory('AllBoxTypes', [
		'boxTypes',
		'$q',
		function(boxTypes, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				boxTypes.query(
					function(allBoxTypes) {
						delay.resolve(allBoxTypes);
					},
					function() {
						delay.reject('unable to fetch box Types');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('boxSources', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return $resource(SETTINGS.APIBasePath + 'box/sources');
		}
	])
	.factory('AllBoxSources', [
		'boxSources',
		'$q',
		function(boxSources, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				boxSources.query(
					function(allBoxSources) {
						delay.resolve(allBoxSources);
					},
					function() {
						delay.reject('unable to fetch box Sources');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('defaultStartpop', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return $resource(SETTINGS.APIBasePath + 'box/default-startpop');
		}
	])
	.factory('defaultStartpopLoader', [
		'defaultStartpop',
		'$q',
		function(defaultStartpop, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				defaultStartpop.query(
					function(dflt) {
						delay.resolve(Number(dflt[0]));
					},
					function() {
						delay.reject('unable to fetch box Sources');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('BoxBulkLoader', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			var box = $resource(SETTINGS.APIBasePath + 'box-bulk', { ids: '@ids' });
			return box;
		}
	])
	.factory('StartpopBulkLoader', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			var startpop = $resource(SETTINGS.APIBasePath + 'startpop-bulk', {
				ids: '@ids'
			});
			return startpop;
		}
	])
	.factory('StartpopBulkCreator', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			var startpop = $resource(SETTINGS.APIBasePath + 'startpop-bulk/create');
			return startpop;
		}
	])
	.factory('BoxesForFridge', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'box/fridge/:id', { id: '@id' });
		}
	])
	.factory('StartpopsForFridge', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'startpop/fridge/:id', {
				id: '@id'
			});
		}
	])
	.factory('BoxFridgeHistory', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'box/:id/fridge-history', {
				id: '@id'
			});
		}
	])
	.factory('StartpopFridgeHistory', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'startpop/:id/fridge-history', {
				id: '@id'
			});
		}
	]);

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:BoxPanel
 * @description
 * # BoxPanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('boxPanel', function(
		$mdDialog,
		$state,
		AllBoxTypes,
		AlertUser,
		Box,
		BoxLoader,
		ConfirmUser,
		NotifyUser,
		printerService
	) {
		return {
			scope: {
				box: '=box'
			},
			templateUrl: 'views/box-panel.html',
			link: function(scope) {
				scope.deleteBoxDisabled = scope.box.NR_STARTPOPS ? true : false;

				scope.printBox = printBox;

				function confirmDelete() {
					Box.delete(
						{ id: scope.box.BOX_CD },
						function() {
							NotifyUser(scope.box.BOX_CD + ' has been deleted');
							$state.go('managementSearch');
						},
						function() {
							AlertUser('Error', 'Unable to delete box ' + scope.box.BOX_CD);
						}
					);
				}
				scope.deleteBox = function() {
					ConfirmUser(
						'Confirm',
						'You are about to delete ' + scope.box.BOX_CD,
						confirmDelete
					);
				};
				scope.editBox = function() {
					$mdDialog
						.show({
							controller: 'BoxmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/box-modal.html',
							parent: angular.element(document.body),
							fullscreen: true,
							clickOutsideToClose: true,
							locals: {
								box: scope.box,
								newCode: null,
								type: scope.box.type.ID,
								hideCheckin: false
							},
							resolve: {
								boxTypes: function(AllBoxTypes) {
									return AllBoxTypes();
								},
								batches: function(AllBatches) {
									return AllBatches();
								},
								strains: function(ReferencesFactory) {
									return ReferencesFactory.getStrains();
								},
								organisations: function(AllOrganisations) {
									return AllOrganisations();
								}
							}
						})
						.then(function(savedBox) {
							NotifyUser(scope.box.BOX_CD + ' has been saved');
							if (savedBox.code != scope.box.BOX_CD) {
								$state.go('managementBox', {
									bid: savedBox.code,
									season: savedBox.season
								});
							} else {
								BoxLoader(savedBox.code, savedBox.season).then(function(result) {
									scope.box = result;
								});
							}
						});
				};

				function printBox(box) {
					var printData = {
						cocoons: box.AMOUNT,
						weight: box.content.NET_WEIGHT,
						boxCode: box.BOX_CD,
						batchCode: box.content.BATCH_CD
					};

					scope.$root.showLoader = true;
					printerService('qrCodeBox', printData).finally(function() {
						scope.$root.showLoader = false;
					});
				}
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.BoxLoader
 * @description
 * # BoxLoader
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('Fridge', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			var fridge = $resource(SETTINGS.APIBasePath + 'fridge/:id', { id: '@id' });
			return fridge;
		}
	])
	.factory('FridgeBulkLoader', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			var fridge = $resource(SETTINGS.APIBasePath + 'fridge-bulk', {
				ids: '@ids'
			});
			return fridge;
		}
	])
	.factory('FridgeLoader', [
		'Fridge',
		'Session',
		'$q',
		'$state',
		'$http',
		'SETTINGS',
		'AllProducts',
		function(Fridge, Session, $q) {
			return function(fid) {
				var delay = $q.defer();

				var season = Session.managementSeason;

				Fridge.get(
					{ id: fid, season: season },
					function(result) {
						result.fridge.CRE_AT = new Date(result.fridge.CRE_AT + ' UTC');
						result.fridge.updated = new Date(result.fridge.updated + ' UTC');
						delay.resolve(result.fridge);
					},
					function() {
						delay.reject('unable to load fridge');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('fridgeModels', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return $resource(SETTINGS.APIBasePath + 'fridge/models');
		}
	])
	.factory('FridgeModelLoader', [
		'fridgeModels',
		'$q',
		function(fridgeModels, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				fridgeModels.query(
					function(allFridgeModels) {
						delay.resolve(allFridgeModels);
					},
					function() {
						delay.reject('unable to fetch fridgeModels');
					}
				);
				return delay.promise;
			};
		}
	])
	.service('XferReasons', [
		'$resource',
		'SETTINGS',
		'$q',
		function($resource, SETTINGS) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return $resource(SETTINGS.APIBasePath + 'fridge/reasons');
		}
	])
	.factory('XferReasonsLoader', [
		'XferReasons',
		'$q',
		function(XferReasons, $q) {
			// AngularJS will instantiate a singleton by calling "new" on this function
			return function() {
				var delay = $q.defer();
				XferReasons.query(
					function(allReasons) {
						delay.resolve(allReasons);
					},
					function() {
						delay.reject('unable to fetch transfer Reasons');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('Fridges', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'fridge/latest/:season', {
				season: '@season'
			});
		}
	])
	.factory('FridgesLoader', [
		'Fridges',
		'$q',
		'$state',
		'$http',
		'SETTINGS',
		'AllProducts',
		'AllBoxTypes',
		function(Fridges, $q) {
			return function(season) {
				var delay = $q.defer();
				Fridges.query(
					{ season: season },
					function(fridges) {
						delay.resolve(fridges);
					},
					function() {
						delay.reject('unable to load box');
					}
				);
				return delay.promise;
			};
		}
	])
	.factory('FridgeStatsLoader', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'fridge/stats/:id', { id: '@id' });
		}
	])
	.factory('FridgeContentLoader', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'fridge/content/:id/:season', {
				id: '@id',
				season: '@season'
			});
		}
	])
	.factory('FridgeBoxesSummary', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'fridge/summary/boxes/:id/:season', {
				id: '@id',
				season: '@season'
			});
		}
	])
	.factory('FridgeStartpopsSummary', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(
				SETTINGS.APIBasePath + 'fridge/summary/startpops/:id/:season',
				{ id: '@id', season: '@season' }
			);
		}
	]);

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:fridgePanel
 * @description
 * # fridgePanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('fridgePanel', function(
		$mdDialog,
		$state,
		FridgeModelLoader,
		Fridge,
		ConfirmUser,
		NotifyUser,
		AlertUser
	) {
		return {
			scope: {
				fridge: '=fridge'
			},
			templateUrl: 'views/fridge-panel.html',
			link: function(scope) {
				function confirmDelete() {
					Fridge.delete(
						{ id: scope.fridge.FRIDGE_CD },
						function() {
							NotifyUser(scope.fridge.FRIDGE_CD + ' has been deleted');
							$state.go('managementSearch');
						},
						function() {
							AlertUser('Error', 'Unable to delete fridge ' + scope.fridge.FRIDGE_CD);
						}
					);
				}
				scope.deleteFridge = function() {
					ConfirmUser(
						'Confirm',
						'You are about to delete ' + scope.fridge.FRIDGE_CD,
						confirmDelete
					);
				};
				scope.editFridge = function() {
					$mdDialog
						.show({
							controller: 'FridgemodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/fridge-modal.html',
							parent: angular.element(document.body),
							fullscreen: true,
							clickOutsideToClose: true,
							locals: {
								fridge: scope.fridge
							},
							resolve: {
								fridgeModels: function(FridgeModelLoader) {
									return FridgeModelLoader();
								}
							}
						})
						.then(function(savedFridge) {
							if (savedFridge.code != scope.fridge.FRIDGE_CD) {
								$state.go('managementFridge', { fid: savedFridge.code });
							} else {
								Fridge.get({ id: scope.fridge.FRIDGE_CD }, function(result) {
									scope.fridge = result.fridge;
								});
							}
						});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ManagementsettingsCtrl
 * @description
 * # ManagementsettingsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ManagementsettingsCtrl', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		Session,
		defaultStartpop
	) {
		$scope.startPopAmount = defaultStartpop;
		var today = new Date();
		$scope.seasons = [
			today.getFullYear() - 2,
			today.getFullYear() - 1,
			today.getFullYear(),
			today.getFullYear() + 1,
			today.getFullYear() + 2
		];

		Session.getManagementSeason().then(function(response) {
			var season = response;
			for (var i = 0; i < $scope.seasons.length; i++) {
				if ($scope.seasons[i] == season) {
					$scope.season = $scope.seasons[i];
				}
			}
		});

		$scope.save = function() {
			$http
				.get(SETTINGS.APIBasePath + 'box/default-startpop/' + $scope.startPopAmount)
				.then(function() {
					$http
						.post(SETTINGS.APIBasePath + '/settings/management-season/', {
							season: $scope.season
						})
						.then(function() {
							Session.setManagementSeason($scope.season);
							$mdDialog.hide();
						});
				});
		};
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.managementSettings
 * @description
 * # managementSettings
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('managementSettings', function($mdDialog) {
		return function() {
			$mdDialog.show({
				controller: 'ManagementsettingsCtrl',
				templateUrl: 'views/management-settings.html',
				parent: angular.element(document.body),
				fullscreen: true,
				clickOutsideToClose: true,
				resolve: {
					defaultStartpop: function(defaultStartpopLoader) {
						return defaultStartpopLoader();
					}
				}
			});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:CreateboxesCtrl
 * @description
 * # CreateboxesCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('CreateboxesCtrl', function(
		$scope,
		$window,
		$mdDialog,
		$http,
		$timeout,
		SETTINGS,
		Session,
		BoxLoader,
		AlertUser,
		NotifyUser,
		Box,
		Fridge,
		checkCode,
		SelectInput,
		StartpopBulkCreator
	) {
		Session.setStream('management');
		Session.pageTitle = 'Create Population';
		$scope.codes = [];
		$scope.scannedcode = '';
		$scope.showBoxes = true;

		$scope.confirmRowID = 'BOX_CD';
		$scope.$exttableSelected = {
			box: []
		};
		$scope.$exttable = [];

		$scope.boxColumns = [{ data: 'BOX_CD' }, { data: 'BOX_CD' }];

		$scope.boxes = [];

		function selectCodeInput() {
			$scope.scannedcode = '';
			SelectInput('scannerInput');
		}
		$scope.checkCodes = function() {
			var tempCode = (' ' + $scope.scannedcode).slice(1).toUpperCase();
			$scope.$root.showLoader = true;
			for (var i = 0; i < $scope.codes.length; i++) {
				var element = $scope.codes[i];
				if (element == tempCode) {
					AlertUser(
						'ERROR',
						'Box ' + element + ' has already been scanned.',
						selectCodeInput
					);
					return;
				}
			}
			checkCode.get(
				{
					code: $scope.scannedcode,
					season: Session.managementSeason
				},
				function(result) {
					$scope.$root.showLoader = false;
					if (result.type == 'unused') {
						$scope.codes.push(tempCode);
						selectCodeInput();
					} else {
						// AlertUser('ERROR', 'The code ' + $scope.scannedcode + ' is associated to a ' + result.type + '.', selectCodeInput);
						AlertUser(
							'ERROR',
							'This code has been used already in this season',
							selectCodeInput
						);
					}
				},
				function() {
					$scope.$root.showLoader = false;
					AlertUser('ERROR', 'Unknown error occured!');
				}
			);
		};
		$scope.removeBox = function(ind) {
			$scope.codes.splice(ind, 1);
		};
		$scope.completeCodes = function() {
			$scope.selectedIndex = 1;
		};

		$scope.$watch(
			'codes',
			function(val) {
				$scope.boxes = [];

				for (var i = 0; i < val.length; i++) {
					$scope.boxes.push({
						BOX_CD: val[i]
					});
				}

				$scope.$exttable.box.rows().remove();
				$scope.$exttable.box.rows.add($scope.boxes).draw();

				$timeout(function() {
					$scope.$exttable.box.column(0).checkboxes.deselectAll();
				});
			},
			true
		);

		function selectParentInput() {
			$scope.boxInfo.parent = '';
			SelectInput('boxParent');
		}
		$scope.gotoConfirm = function() {
			checkCode.get(
				{
					code: $scope.boxInfo.parent,
					season: Session.managementSeason
				},
				function(result) {
					if (result.type != 'box') {
						var msg = 'Box ' + $scope.boxInfo.parent + ' not found.';
						AlertUser('ERROR', msg, selectParentInput);
						return;
					} else {
						$scope.selectedIndex = 3;
					}
				}
			);
		};
		$scope.confirmCreate = function() {
			if ($scope.codes.length) {
				// eslint-disable-next-line no-unused-vars
				var table = $('table[data-model="box"]'),
					toCheckIn = [];

				if ($scope.$exttableSelected.box.length > 0) {
					$.each(
						$scope.$exttableSelected.box,
						function(index, rowId) {
							var rowData = $scope.$exttable.box.row('tr#' + rowId).data();

							toCheckIn.push(rowData[$scope.confirmRowID]);
						},
						toCheckIn
					);

					// Show modal wich asks about which fridge to check in
					$mdDialog
						.show({
							controller: 'CreateboxesfridgemodalCtrl',
							templateUrl: 'views/create-boxes-fridge-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true
						})
						.then(function(fridge) {
							if (fridge) {
								bulkCreateBoxes(toCheckIn, fridge);
							}
						});
				} else {
					bulkCreateBoxes(null, null);
				}
			} else {
				// This shouldn't happen but just in case reset data and go to first tab
				$scope.boxInfo = {};
				$scope.codes = [];
				$scope.selectedIndex = 1;
			}
		};

		function bulkCreateBoxes(toCheckIn, fridge) {
			$scope.$root.showLoader = true;
			StartpopBulkCreator.save(
				{
					codes: $scope.codes,
					boxInfo: $scope.boxInfo,
					checkIn: toCheckIn,
					checkInFridge: fridge,
					season: Session.managementSeason
				},
				function(result) {
					$scope.$root.showLoader = false;
					if (result.error) {
						AlertUser('Error', result.errorMessage);
					} else {
						$scope.boxInfo = {};
						$scope.codes = [];
						$scope.selectedIndex = 1;

						NotifyUser('All boxes have been created.');
					}
				},
				function() {
					$scope.$root.showLoader = false;
					AlertUser('Error', 'Unable to create populations');
				}
			);
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:boxForm
 * @description
 * # boxForm
 */
angular
	.module('wildBieneHarvestApp')
	.directive('startpopForm', function(
		Box,
		AllBoxSources,
		AllSpecies,
		AllBoxTypes,
		defaultStartpopLoader,
		NotifyUser,
		Session
	) {
		return {
			templateUrl: 'views/startpop-form.html',
			scope: {
				valid: '=valid',
				box: '=box'
			},
			link: function postLink(scope) {
				scope.valid = false;
				scope.validParentCode = false;

				scope.box = {};
				var defaultPop = 0;
				scope.$watch('boxForm.$valid', function(val) {
					scope.valid = val;
				});
				defaultStartpopLoader().then(function(res) {
					defaultPop = res;
					scope.box.cocoons = res;
				});
				AllBoxSources().then(function(results) {
					scope.sourceTypes = results;
				});
				AllSpecies().then(function(result) {
					scope.allSpecies = [];
					for (var i = 0; i < result.length; i++) {
						var element = result[i];
						if (element.PROCESS_CD == 'C') {
							scope.allSpecies.push(element);
						}
					}
				});
				AllBoxTypes().then(function(result) {
					for (var i = 0; i < result.length; i++) {
						var element = result[i];
						if (element.ID == 2) {
							scope.box.type = element;
						}
					}
				});
				scope.$watch('box.type', function(val) {
					if (val && val.CODE.toLowerCase() == 'startpop') {
						scope.box.cocoons = defaultPop;
						scope.validParentCode = false;
					} else {
						scope.validParentCode = true;
					}
				});
				scope.save = function() {};
				scope.findParent = function() {
					Box.get(
						{
							id: scope.box.parent,
							season: Session.managementSeason
						},
						function(result) {
							if (result.box) {
								scope.validParentCode = true;
								scope.box.content = result.box.content;
								scope.box.conversionFactor = result.box.content.CONV_FACTOR;
								scope.checkCocoonAmount();
							} else {
								scope.validParentCode = false;
								NotifyUser('Parent box with code ' + scope.box.parent + ' not found.');
							}
						}
					);
					scope.setCocoonAmount(0);
				};
				scope.canBeSaved = function() {
					if (scope.preType === 1) {
						// Storagebox
						// if (!scope.validCode || (scope.shouldCheckIn && !scope.validFridgeCode)) {
						// 	NotifyUser('Fridge code is not valid');
						// 	return false;
						// } else {
						return true;
						// }
					} else {
						// Startpop
						if (!scope.validParentCode) {
							NotifyUser('Originating box is not valid');
							return false;
						} else {
							return true;
						}
					}
				};
				scope.checkCocoonAmount = function() {
					scope.setCocoonAmount(0);
					if (scope.box.cocoonNetWeight && scope.box.conversionFactor) {
						scope.setCocoonAmount(
							scope.box.cocoonNetWeight * scope.box.conversionFactor
						);
					}
				};
				scope.setCocoonAmount = function(cocoonAmount) {
					scope.box.cocoons = Math.round(cocoonAmount);
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.UserAlert
 * @description
 * # UserAlert
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('AlertUser', function($mdDialog) {
		return function(title, msg, callback) {
			var template =
				'<md-dialog aria-label="' +
				(msg || '').replace(/"/g, '&quot;') +
				'">' +
				'<md-dialog-content>' +
				'<div class="md-dialog-content">' +
				'<h2>' +
				(title || '') +
				'</h2>' +
				'<div class="md-dialog-content-body">' +
				(msg || '') +
				'</div>' +
				'</div>' +
				'</md-dialog-content>' +
				'<md-dialog-actions>' +
				'<md-button ng-click="close()" ng-keydown="$event.stopPropagation(); if($event.keyCode === 13) $event.preventDefault();" class="md-primary">' +
				'Ok' +
				'</md-button>' +
				'</md-dialog-actions>' +
				'</md-dialog>';

			$mdDialog
				.show({
					template: template,
					escapeToClose: false,
					clickOutsideToClose: false,
					controller: function($scope, $mdDialog, $document) {
						$scope.close = function() {
							$mdDialog.hide();
						};

						// Global keydown handler to prevent Enter key
						var keydownHandler = function(event) {
							if (event.keyCode === 13) {
								// Enter key
								event.preventDefault();
								event.stopPropagation();
								return false;
							}
						};

						// Add the event listener to the document
						$document.on('keydown', keydownHandler);

						// Clean up event listener when dialog is destroyed
						$scope.$on('$destroy', function() {
							$document.off('keydown', keydownHandler);
						});
					}
				})
				.then(callback);
		};
	})
	.service('ConfirmUser', function($mdDialog) {
		return function(title, msg, confirmCallback, cancelCallback) {
			var confirm = $mdDialog
				.confirm()
				.title(title)
				.htmlContent(msg)
				.ariaLabel(msg)
				.ok('Ok')
				.cancel('Cancel');
			$mdDialog
				.show(confirm)
				.then(confirmCallback, cancelCallback || angular.noop);
		};
	})
	.service('NotifyUser', function($mdToast, $log) {
		var activeMsg;
		return function(msg, update) {
			if (!update) {
				activeMsg = msg;
				var toast = $mdToast
					.simple()
					.textContent(msg)
					.position('top right')
					.action('Dismiss')
					.highlightAction(true)
					.highlightClass('md-primary')
					.hideDelay('10000');
				$mdToast.show(toast).catch(function() {
					$log.log(msg);
				});
			} else {
				$mdToast.updateTextContent(activeMsg + ' \n' + msg);
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.SelectInput
 * @description
 * # SelectInput
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('SelectInput', function($timeout, $window) {
		return function(inputID) {
			$timeout(function() {
				var element = $window.document.getElementById(inputID);
				if (element) {
					element.focus();
				}
			}, 100);
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:restictAccess
 * @description
 * # restictAccess
 */
angular
	.module('wildBieneHarvestApp')
	.directive('restrictAccess', function(Session) {
		return function(scope, element, attrs) {
			function checkElement() {
				if (
					Session.rights.length > 0 &&
					Session.rights.indexOf(attrs.restrictAccess) < 0
				) {
					element.remove();
				} else if (Session.rights.indexOf(attrs.restrictAccess) > -1) {
					element.show();
				}
			}
			element.hide();
			if (Session.rights.length > 0 && attrs.restrictAccess) {
				checkElement();
			} else {
				Session.registerObserverCallback(checkElement);
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:organisationPanel
 * @description
 * # organisationPanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('organisationPanel', function(
		AllOrganisations,
		$mdDialog,
		AllPhrases,
		$timeout
	) {
		return {
			templateUrl: 'views/organisation-panel.html',
			link: function postLink(scope) {
				function getDocs() {
					AllPhrases().then(function(phrases) {
						scope.documents = phrases;
					});
				}
				getDocs();

				function getOrgs() {
					AllOrganisations().then(function(organisations) {
						scope.orgs = organisations;
					});
				}
				getOrgs();

				scope.openDocument = function(editDocument) {
					$mdDialog
						.show({
							controller: 'documentmodalCtrl',
							templateUrl: 'views/document-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false,
							locals: {
								documents: scope.documents,
								document: editDocument,
								orgs: scope.orgs
							},
							resolve: {
								document: function(AllPhrases) {
									return AllPhrases();
								}
							}
						})
						.then(function() {
							getDocs();
							scope.activeDoc = null;
							$timeout(function() {
								scope.$exttable.tableOrganisation.column(0).checkboxes.deselectAll();
							});
						});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:productsPanel
 * @description
 * # productsPanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('productsPanel', function(
		$http,
		$mdDialog,
		SETTINGS,
		AllProducts,
		AlertUser,
		$timeout,
		NotifyUser
	) {
		return {
			templateUrl: 'views/products-panel.html',
			link: function postLink(scope) {
				scope.openProduct = function(editProduct, action) {
					$mdDialog
						.show({
							controller: 'ProductsmodalCtrl',
							templateUrl: 'views/products-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false,
							locals: {
								product: editProduct,
								action: action
							},
							resolve: {
								categories: function(AllProductCategories) {
									return AllProductCategories();
								}
							}
						})
						.then(function() {
							scope.search(scope.searchString);
							$timeout(function() {
								scope.$exttable.tableProducts.column(0).checkboxes.deselectAll();
							});
						});
					// .catch(() => {});
				};

				function removeProduct(itemToDelete) {
					$http
						.delete(SETTINGS.APIBasePath + 'product/admin/' + itemToDelete.ID)
						.then(function(result) {
							result.data.success != true
								? NotifyUser(
										'ERROR',
										'Unable to deletethis product, it is currently in use.'
								  )
								: NotifyUser('Product was deleted');
							scope.search(scope.searchString);
						});
				}

				scope.deleteProduct = function(itemToDelete) {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Deleting Product')
						.textContent(
							"Are you sure you'd like to delete " + itemToDelete.PROD_CD + '?'
						)
						.ariaLabel('Confirm delete')
						.ok('Yes delete ' + itemToDelete.PROD_CD + '.')
						.cancel("No I'll think about it.");

					$mdDialog.show(confirm).then(function() {
						removeProduct(itemToDelete);
					});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:OrganisationmodalCtrl
 * @description
 * # OrganisationSettingsModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('OrganisationSettingsCtrl', function(
		$scope,
		$mdDialog,
		$http,
		AlertUser,
		Session,
		SETTINGS,
		orgId,
		organisations,
		startpopSettings,
		NotifyUser,
		$timeout,
		countries,
		currencies,
		AllBoxSources,
		AllSpecies,
		$q
	) {
		Session.setStream('administration');
		Session.pageTitle = organisations[orgId];

		$scope.org = {}; // PHP settings
		$scope.startpop = {}; // startpop settings
		$scope.excludedDateRanges = [];
		$scope.orgId = orgId;
		$scope.countries = countries;
		$scope.orgSpeciesWashStatus = orgSpeciesWashStatus;
		$scope.addExcludedDateRange = addExcludedDateRange;
		$scope.removeExcludedDateRange = removeExcludedDateRange;
		$scope.formatDate = formatDate;
		$scope.saveOrganisationSettings = saveOrganisationSettings;

		// $scope.org.managementConversion = [];
		$scope.defaultValues = ['Y', 'N'];

		AllBoxSources().then(function(results) {
			$scope.sources = results;
		});

		AllSpecies().then(function(result) {
			$scope.species = [];
			for (var i = 0; i < result.length; i++) {
				var element = result[i];
				if (element.PROCESS_CD === 'C' || Number(element.ID) === 1) {
					$scope.species.push(element);
				}
			}
		});

		$scope.currencies = [];

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.selectBoxOptions = [
			{ name: 'no', value: 0 },
			{ name: 'yes', value: 1 }
		];
		function datesToRanges() {
			console.log('dates to ranges');
		}
		function saveOrganisationSettings() {
			var orgPromise = $http.post(
				SETTINGS.APIBasePath + 'organisation/settings/' + $scope.orgId,
				$scope.org
			);

			var startpop = angular.copy($scope.startpop);
			startpop.delivery_weekdays = startpop.delivery_weekdays.map(i =>
				parseInt(i)
			);
			startpop.house_types = startpop.house_types.split(',');
			var startpopPromise = startpopSettings
				.editSetting($scope.orgId, startpop)
				.then(function() {
					var oldDates = angular.copy($scope.startpop.excluded_dates);
					var newDates = rangesToDates($scope.excludedDateRanges);
					return startpopSettings.editDates($scope.orgId, oldDates, newDates);
				})
				.then(function() {
					return startpopSettings
						.editPostalCodes(
							$scope.orgId,
							$scope.startpop.excluded_postal_codes,
							$scope.excludedPostalCodes
						)
						.then(getSettings);
				});

			$q.all([orgPromise, startpopPromise]).then(
				function() {
					$mdDialog.hide();
					NotifyUser('Settings were updated.');
				},
				function() {
					AlertUser('Something went wrong');
				}
			);
		}
		/**
		 * Convert a list of ranges to a flat list of date objects
		 * @param ranges
		 * @returns {Array}
		 */
		function rangesToDates(ranges) {
			var dates = [];

			angular.forEach(ranges, function(range) {
				var date = range.startDate.clone();
				while (date <= range.endDate) {
					dates.push(date.toDate());
					date = date.add(1, 'days');
				}
			});

			dates.sort((a, b) => a - b);
			return dates;
		}

		function addExcludedDateRange() {
			$scope.excludedDateRanges.push({
				startDate: moment($scope.excludedStartDate),
				endDate: moment($scope.excludedEndDate)
			});
		}

		function removeExcludedDateRange(ind) {
			$scope.excludedDateRanges.splice(ind, 1);
		}

		function formatDate(range) {
			return (
				range.startDate.format('DD-MM-YYYY') +
				' - ' +
				range.endDate.format('DD-MM-YYYY')
			);
		}

		$scope.saveCustomTableItems = function(data, modelName) {
			if (modelName === 'managementConversion') {
				$scope.org[modelName][data.index].DEFLT = data.MNGMNTDEFAULT;
				$scope.org[modelName][data.index].CONV_FACTOR = data.MNGMNTCONVFACTOR;
			}

			if (modelName === 'rates') {
				// It's not allowed to inactivate the default item, so reset the item and show message to user
				if (data.vat_deflt === 'Y' && data.active === 'N') {
					$scope.selectedRateItem = null;
					NotifyUser('You cannot inactivate the default item!');
					return;
				}

				if (data.VAT_DEFLT === 'Y' || data.vat_deflt === 'Y') {
					$scope.setAllRatesDefaultAsNo();
				}
				$scope.org[modelName][data.index].DESCRIPTION = data.description;
				$scope.org[modelName][data.index].VAT_DEFLT = data.vat_deflt;
				$scope.org[modelName][data.index].ACTIVE = data.active;
			}
		};

		$scope.checkIfConversionDataAreValid = function(data) {
			var isValid = false;
			$scope.org.managementConversion.forEach(function(value) {
				if (
					value.INSCT_ID === data.MNGMNTSPEC &&
					value.SOURCE_ID === data.MNGMNTSOURCE
				) {
					isValid = true;
					return;
				}
			});

			return isValid;
		};

		$scope.checkIfVatRatesDataAreValid = function(data) {
			var isValid = 0;
			if (data.VAT_DEFLT === 'Y' || data.vat_deflt === 'Y') {
				$scope.org.rates.forEach(function(value) {
					if (value.VAT_DEFLT === 'Y') {
						isValid++;
					}
				});
			}

			return isValid > 0;
		};

		$scope.addCustomTableItems = function(data, modelName) {
			if (modelName === 'rates') {
				if (data.VAT_DEFLT === 'Y' || data.vat_deflt === 'Y') {
					$scope.setAllRatesDefaultAsNo();
				}
				$scope.org[modelName].push({
					DESCRIPTION: data.DESCRIPTION,
					VALUE: data.VALUE,
					VAT_DEFLT: data.VAT_DEFLT,
					ACTIVE: data.ACTIVE
				});
				// $scope.getElementById('vat-description').value = null;
				// $scope.getElementById('vat-value').value = null;
				// $scope.getElementById('vat-default').value = $scope.defaultValues[1]; // Default is N for default
				// $scope.getElementById('vat-active').value = $scope.defaultValues[0]; // Default is Y for active
			}

			if (modelName === 'managementConversion') {
				if ($scope.checkIfConversionDataAreValid(data)) {
					NotifyUser(
						'Row with insect ' +
							$scope.getInsectNameById(data.MNGMNTSPEC) +
							' and source ' +
							$scope.getSourceNameById(data.MNGMNTSOURCE) +
							' already exists.'
					);
				} else {
					$scope.org[modelName].push({
						INSCT_ID: data.MNGMNTSPEC,
						SOURCE_ID: data.MNGMNTSOURCE,
						DEFLT: data.MNGMNTDEFAULT,
						CONV_FACTOR: data.MNGMNTCONVFACTOR
					});
					$scope.getElementById('species').value = $scope.species[0];
					$scope.getElementById('sources').value = $scope.sources[0];
					$scope.getElementById('default').value = $scope.defaultValues[0];
					$scope.getElementById('conv_factor').value = null;
				}
			}
		};

		$scope.deleteCustomTableItems = function(data, modelName) {
			if (modelName === 'rates') {
				if (data.id !== undefined && data.id !== '') {
					$scope.org.ratesToRemove.push(data.id);
				}
			}

			$scope.org[modelName].splice(data.index, 1);
		};

		$scope.getElementById = function(elementId) {
			return document.getElementById(elementId);
		};

		$scope.getInsectNameById = function(insectId) {
			var insectName = null;
			angular.forEach($scope.species, function(item) {
				if (item.ID === insectId) {
					insectName = item.SC_NAME + orgSpeciesWashStatus(item);
				}
			});
			return insectName;
		};

		$scope.getSourceNameById = function(sourceId) {
			var sourceName = null;
			angular.forEach($scope.sources, function(item) {
				if (item.ID === sourceId) {
					sourceName = item.DESCRIPTION;
				}
			});
			return sourceName;
		};

		/**
		 * Get legacy PHP settings and startpop settings
		 * @returns {*}
		 */
		function getSettings() {
			var orgPromise = $http
				.get(SETTINGS.APIBasePath + 'organisation/settings/' + $scope.orgId)
				.then(function(result) {
					$scope.org = result.data;
				});
			var startpopPromise = startpopSettings
				.getSettings($scope.orgId)
				.then(function(settings) {
					settings.house_types = settings.house_types.join(',');
					$scope.startpop = settings;
					$scope.excludedPostalCodes = angular.copy(settings.excluded_postal_codes);
					$scope.excludedDateRanges = datesToRanges($scope.startpop.excluded_dates);
				});
			return $q.all([orgPromise, startpopPromise]);
		}

		function getCurrencies() {
			$http.get(SETTINGS.APIBasePath + 'order/currencies').then(function(result) {
				$scope.currencies = result.data;
			});
		}

		$scope.setAllRatesDefaultAsNo = function() {
			$scope.org.rates.forEach(function(value, index) {
				$scope.org.rates[index].VAT_DEFLT = 'N';
			});
		};

		$scope.setActiveItem = function(selectedTableItem, selected) {
			if (selected) {
				$scope.selectedRateItem = $scope.org.rates[selectedTableItem];
				if ($scope.org.rates[selectedTableItem].ID === undefined) {
					$scope.canDeleteItem = false;
				} else {
					$scope.canDeleteItem =
						$scope.org.rates[selectedTableItem].COUNT_VATS !== null;
				}
			} else {
				$scope.selectedRateItem = null;
				$scope.canDeleteItem = false;
			}
		};

		$scope.setActiveItemConversion = function(selectedTableItem, selected) {
			if (selected) {
				$scope.selectedFactorItem =
					$scope.org.managementConversion[selectedTableItem];
			} else {
				$scope.selectedFactorItem = null;
			}
		};

		function orgSpeciesWashStatus(species) {
			if (species.ID == 1) {
				return ' (prewash)';
			}
			return '';
		}

		getCurrencies();
		getSettings();
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.GeoInfo
 * @description
 * # GeoInfo
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('countries', [
	'$resource',
	'SETTINGS',
	'$q',
	function($resource, SETTINGS) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return $resource(SETTINGS.APIBasePath + 'countries/');
	}
]);

angular.module('wildBieneHarvestApp').factory('AllCountries', [
	'countries',
	'$q',
	function(countries, $q) {
		var cachedCountries = [];
		return function() {
			var delay = $q.defer();
			if (cachedCountries.length) {
				delay.resolve(cachedCountries);
			} else {
				countries.query(
					function(countries) {
						cachedCountries = countries;
						delay.resolve(countries);
					},
					function() {
						delay.reject('unable to fetch countries');
					}
				);
			}
			return delay.promise;
		};
	}
]);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ProductsmodalCtrl
 * @description
 * # ProductsmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ProductsmodalCtrl', function(
		$http,
		$scope,
		$mdDialog,
		product,
		categories,
		SETTINGS,
		NotifyUser,
		action
	) {
		$scope.categories = categories;
		$scope.product = product;
		$scope.action = action;

		if (product == null) {
			$scope.product = {
				PROD_STATUS_ID: 1
			};
		}

		if ($scope.product.DISPLAY_SEQUENCE) {
			$scope.product.DISPLAY_SEQUENCE = parseInt($scope.product.DISPLAY_SEQUENCE);
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.saveProduct = function() {
			$http
				.post(SETTINGS.APIBasePath + 'product/admin', $scope.product)
				.then(function(response) {
					$mdDialog.hide();
					if (typeof response.data.errorMessage != 'undefined') {
						NotifyUser(response.data.errorMessage);
					} else {
						typeof $scope.product.ID == 'undefined'
							? NotifyUser('Product was added.')
							: NotifyUser('Product was updated.');
					}
				});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:UsereditmodalCtrl
 * @description
 * # UsereditmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('documentmodalCtrl', function(
		$scope,
		$mdDialog,
		$http,
		$resource,
		SETTINGS,
		documents,
		document,
		organisations,
		languageFactory,
		Session,
		orgs,
		NotifyUser
	) {
		$scope.document = document;
		if (typeof $scope.document == 'undefined') {
			$scope.document = {};
		}

		$scope.orgs = orgs;
		$scope.document.organisationID = $scope.document.ID;
		organisations.query(function(result) {
			$scope.orgs = result;
		});

		$scope.lang = [];
		$scope.document.LANG_ID = 1;
		languageFactory.query(function(result) {
			$scope.lang = result;
		});

		$scope.docs = [
			{ id: 1, name: 'Offer' },
			{ id: 2, name: 'Order' },
			{ id: 3, name: 'Request' },
			{ id: 4, name: 'Delivery' },
			{ id: 5, name: 'Email' },
			{ id: 6, name: 'Starter' }
		];
		$scope.document.selectedDocument = { id: 1, name: 'Offer' };

		$scope.$watch('document.selectedDocument', function(selectedDocument) {
			if (selectedDocument) {
				$scope.document.PHRASE_CD = selectedDocument.name;
				setPhrases();
			}
		});

		$scope.$watch('document.LANG_ID', function(langID) {
			if (langID) {
				setPhrases();
			}
		});

		$scope.$watch('document.organisationID', function(orgID) {
			if (orgID) {
				setPhrases();
			}
		});

		$scope.$watch('lang', function(languagesArray) {
			var langID = $scope.document.LANG_ID;
			if (languagesArray && langID) {
				setPhrases();
			}
		});

		function setPhrases() {
			var langID = $scope.document.LANG_ID;
			var organisationID = $scope.document.organisationID;
			var phraseCD = $scope.document.PHRASE_CD;

			$scope.document.TEXT = [];
			var fields = [];
			var missingFields = [];
			var displayedfields = [];
			if (langID && organisationID && phraseCD) {
				var phrases = Session.allPhrases; //documents;
				angular.forEach(phrases, function(value) {
					if (
						organisationID == value.ORGANISATION_ID &&
						phraseCD.toLowerCase() == value.PHRASE_CD.toLowerCase()
					) {
						if (fields.indexOf(value.TXT_CD) == -1) fields.push(value.TXT_CD);

						if (langID == value.LANG_ID) {
							$scope.document.TEXT.push(value);
							displayedfields.push(value.TXT_CD);
						}
					} else if (phraseCD.toLowerCase() == value.PHRASE_CD.toLowerCase()) {
						if (missingFields.indexOf(value.TXT_CD) == -1)
							missingFields.push(value.TXT_CD);
					}
				});

				if (fields.length == 0) fields = missingFields;
				for (var i = 0; i < fields.length; i++) {
					var field = fields[i];

					if (displayedfields.indexOf(field) == -1) {
						$scope.document.TEXT.push({ TXT_CD: field });
					}
				}
			}
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.saveDocument = function() {
			$http
				.post(SETTINGS.APIBasePath + 'document/admin', $scope.document)
				.then(function() {
					Session.resetAllPhrases();
					NotifyUser('Data were updated.');
					$mdDialog.hide();
				});
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:salesProductsPanel
 * @description
 * # salesProductsPanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('salesProductsPanel', function(
		$http,
		$mdDialog,
		SETTINGS,
		NotifyUser
	) {
		return {
			templateUrl: 'views/sales-products-panel.html',
			link: function postLink(scope) {
				function getProducts() {}
				getProducts();

				scope.openSalesProduct = function(editProduct, action) {
					$mdDialog
						.show({
							controller: 'SalesproductsmodalCtrl',
							templateUrl: 'views/sales-products-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false,
							locals: {
								product: editProduct,
								action: action
							},
							resolve: {
								categories: function(AllProductCategories) {
									return AllProductCategories();
								}
							}
						})
						.then(function() {
							scope.searchSalesProducts('');
						});
				};

				function removeProduct(itemToDelete) {
					$http
						.delete(SETTINGS.APIBasePath + 'sales-product/' + itemToDelete.ID)
						.then(function(result) {
							result.data.success != true
								? NotifyUser(
										'ERROR',
										'Unable to deletethis product, it is currently in use.'
								  )
								: NotifyUser('Product was deleted');
							scope.searchSalesProducts('');
						});
				}

				scope.deleteSalesProduct = function(itemToDelete) {
					var confirm = $mdDialog
						.confirm({
							onComplete: function afterShowAnimation() {
								var $dialog = angular.element(document.querySelector('md-dialog'));
								var $actionsSection = $dialog.find('md-dialog-actions');
								var $cancelButton = $actionsSection.children()[0];
								angular.element($cancelButton).addClass('md-warn');
							}
						})
						.title('Deleting Product')
						.textContent(
							"Are you sure you'd like to delete " + itemToDelete.SPROD_CD + '?'
						)
						.ariaLabel('Confirm delete')
						.ok('Yes delete ' + itemToDelete.SPROD_CD + '.')
						.cancel("No I'll think about it.");

					$mdDialog.show(confirm).then(function() {
						removeProduct(itemToDelete);
					});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:SalesproductsmodalCtrl
 * @description
 * # SalesproductsmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('SalesproductsmodalCtrl', function(
		$http,
		$scope,
		$mdDialog,
		product,
		categories,
		SETTINGS,
		action,
		NotifyUser,
		languageFactory
	) {
		$scope.categories = categories;
		$scope.action = action;
		$scope.product = product;

		if (product == null) {
			$scope.product = {
				SPROD_STATUS_ID: 1
			};
		}

		$http.get(SETTINGS.APIBasePath + 'organisations').then(function(result) {
			$scope.organisations = result.data;
		});

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$scope.saveProduct = function() {
			$http
				.post(SETTINGS.APIBasePath + 'sales-product/admin', $scope.product)
				.then(function(response) {
					$mdDialog.hide();
					if (typeof response.data.errorMessage != 'undefined') {
						NotifyUser(response.data.errorMessage);
					} else {
						typeof $scope.product.ID == 'undefined'
							? NotifyUser('Sales product was added.')
							: NotifyUser('Sales product was updated.');
					}
				});
		};

		languageFactory.query(function(result) {
			$scope.languages = result;
		});

		$scope.loadConnectedProducts = function() {
			$http
				.get(SETTINGS.APIBasePath + 'connected-sales-products/' + $scope.product.ID)
				.then(function(result) {
					$scope.connectedProducts = result.data;
					$scope.getSalesProducts();
				});
		};
		$scope.loadPrices = function() {
			$http
				.get(SETTINGS.APIBasePath + 'prices/' + $scope.product.ID)
				.then(function(result) {
					$scope.prices = result.data;
				});
		};
		$scope.loadRates = function() {
			$http
				.get(SETTINGS.APIBasePath + 'sales-product/rate/' + $scope.product.ID)
				.then(function(result) {
					$scope.rates = result.data;
				});
		};
		$scope.loadTranslations = function() {
			$http
				.get(
					SETTINGS.APIBasePath +
						'translations/sales-product-descriptions/' +
						$scope.product.SPROD_CD
				)
				.then(function(result) {
					$scope.translations = result.data;
				});
		};

		$scope.loadConnectedProducts();
		$scope.loadPrices();
		$scope.loadRates();
		$scope.loadTranslations();

		$scope.getSalesProducts = function() {
			$http.get(SETTINGS.APIBasePath + 'products/farmer').then(function(result) {
				$scope.products = result.data;
				// exclude salesProducts that are already associated
				angular.forEach($scope.products, function(salesProductsItem) {
					angular.forEach($scope.connectedProducts, function(
						connectedProductsItem,
						keyItem
					) {
						if (connectedProductsItem.ID === salesProductsItem.ID) {
							$scope.products.splice(keyItem, 1);
						}
					});
				});
			});
		};

		$scope.saveCustomTableItems = function(data, modelName) {
			switch (modelName) {
				case 'connectedProducts':
					$scope.saveConnectedProducts(data, 'Connected product was updated.');
					break;
				case 'prices':
					$scope.savePrice(data, 'Price was updated.');
					break;
				case 'rates':
					$scope.saveRate(data, 'VAT rate was updated.');
					break;
				case 'translations':
					$scope.saveTranslation(data, 'Translation was updated.');
					break;
			}
		};

		$scope.addCustomTableItems = function(data, modelName) {
			switch (modelName) {
				case 'connectedProducts':
					$scope.saveConnectedProducts(
						data,
						'Connected product relation was saved.'
					);
					break;
				case 'prices':
					$scope.savePrice(data, 'Price was saved.');
					break;
				case 'rates':
					$scope.saveRate(data, 'VAT rate was saved.');
					break;
				case 'translations':
					$scope.saveTranslation(data);
					break;
			}
			$('.add-table-item input.fill-input').val('');
		};

		$scope.deleteCustomTableItems = function(data, modelName) {
			var message = 'Item was deleted.';
			switch (modelName) {
				case 'connectedProducts':
					$scope.deleteConnectedProducts(data, message);
					break;
				case 'prices':
					$scope.deletePrice(data, message);
					break;
				case 'rates':
					$scope.deleteRate(data, 'VAT rate was deleted.');
					break;
				case 'translations':
					$scope.deleteTranslation(data, message);
					break;
			}
		};

		$scope.saveConnectedProducts = function(data, message) {
			$http
				.post(SETTINGS.APIBasePath + 'connected-sales-products', data)
				.then(function() {
					NotifyUser(message);
					$scope.loadConnectedProducts();
				});
		};

		$scope.deleteConnectedProducts = function(data, message) {
			$http
				.delete(
					SETTINGS.APIBasePath +
						'connected-sales-products/' +
						data['prod-sales-map-id']
				)
				.then(function() {
					NotifyUser(message);
					$scope.loadConnectedProducts();
				});
		};

		$scope.savePrice = function(data, message) {
			$http.post(SETTINGS.APIBasePath + 'prices', data).then(function() {
				NotifyUser(message);
				$scope.loadPrices();
			});
		};

		$scope.deletePrice = function(data, message) {
			$http.delete(SETTINGS.APIBasePath + 'prices/' + data['ID']).then(function() {
				NotifyUser(message);
				$scope.loadPrices();
			});
		};

		$scope.saveRate = function(data, message) {
			$http
				.post(SETTINGS.APIBasePath + 'sales-product/rate', data)
				.then(function() {
					NotifyUser(message);
					$scope.loadRates();
				});
		};

		$scope.deleteRate = function(data, message) {
			$http
				.delete(SETTINGS.APIBasePath + 'sales-product/rate/' + data['id'])
				.then(function() {
					NotifyUser(message);
					$scope.loadRates();
				});
		};

		$scope.saveTranslation = function(data) {
			$http
				.post(
					SETTINGS.APIBasePath + 'translations/sales-product-descriptions',
					data
				)
				.then(function(result) {
					result.data.error
						? NotifyUser(result.data.errorMessage)
						: NotifyUser('Translation was saved.');
					$scope.loadTranslations();
				});
		};

		$scope.deleteTranslation = function(data, message) {
			$http
				.delete(
					SETTINGS.APIBasePath +
						'translations/sales-product-descriptions/' +
						data['ID']
				)
				.then(function() {
					NotifyUser(message);
					$scope.loadTranslations();
				});
		};
	});

/* eslint-disable no-inner-declarations */
/* eslint-disable no-console */
/* eslint-disable no-redeclare */
'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.deliveryGenerator
 * @description
 * # deliveryGenerator
 * Service in the wildBieneHarvestApp.
 */
//TODO Lint propperly.
angular
	.module('wildBieneHarvestApp')
	.service('deliveryGenerator', function(
		$rootScope,
		$q,
		$http,
		SETTINGS,
		AlertUser
	) {
		this.generateSingleDeliveriesForRequest = function(requestID) {
			var delay = $q.defer();

			$http
				.get(SETTINGS.APIBasePath + 'deliveries-for-request/' + requestID)
				.then(function(response) {
					// var packages = response.data.totalPackages;

					var requestItems = response.data.requestItems;
					// var packageIndex = 0;
					var usedPackages = [];
					var items = [];
					// eslint-disable-next-line no-unused-vars
					var totalSlots = 0;
					var itemsToDeliver = 0;
					for (var i = 0; i < requestItems.length; i++) {
						var requestItem = requestItems[i];
						requestItem.standsToDeliver = Number(requestItem.standsToDeliver);
						if (requestItem.standsToDeliver) {
							itemsToDeliver += requestItem.standsToDeliver;
							items.push({
								ID: requestItem.ID,
								amount: requestItem.standsToDeliver,
								orderItemID: requestItem.orderItemID,
								productCode: requestItem.productCode,
								productName: requestItem.productName,
								slots: requestItem.slots
							});
						}
					}

					// console.log(items)
					var nextBox = {
						name: 'no box',
						ID: 6,
						packageID: 6,
						slots: 0,
						capacity: 0,
						packageIndex: 0,
						requestItems: items,
						amount: itemsToDeliver
					};

					usedPackages.push(nextBox);
					// console.log(usedPackages);

					var createdDeliveries = [];
					for (var i = 0; i < usedPackages.length; i++) {
						$http
							.post(SETTINGS.APIBasePath + 'delivery', usedPackages[i])
							.then(function(result) {
								result.data.deliveryItem.creationDate = new Date(
									result.data.deliveryItem.CRE_AT
								);
								createdDeliveries.push(result.data.deliveryItem);
								if (createdDeliveries.length === usedPackages.length) {
									delay.resolve(createdDeliveries);
								}
							});
					}
				});
			// console.log('usedPackages', usedPackages);

			return delay.promise;
		};

		this.generateDeliveriesForRequest = function(requestID) {
			var delay = $q.defer();
			$rootScope.$root.showLoader = true;
			$http
				.post(SETTINGS.APIBasePath + 'request/' + requestID + '/deliveries', {})
				.then(
					function(success) {
						$rootScope.$root.showLoader = false;
						if (success.data.deliveries.length > 0) {
							delay.resolve(success.data.deliveries);
						} else {
							AlertUser('ERROR', 'No new deliveries created.');
						}
					},
					function(error) {
						$rootScope.$root.showLoader = false;
						AlertUser('ERROR', error.data.msg);
					}
				);
			return delay.promise;
		};

		return this;
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.startpopSettings
 * @description
 * # startpopSettings
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('startpopSettings', function($http, $q, SETTINGS) {
		/**
		 * Get all startpop settings
		 * @returns {*}
		 */
		this.getSettingsList = function() {
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'settings')
				.then(function(response) {
					return response.data;
				});
		};

		/**
		 * Get startpop settings
		 * @param organisationId
		 * @returns {*}
		 */
		this.getSettings = function(organisationId) {
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId)
				.then(function(response) {
					var settings = response.data;
					settings.start_date = moment(settings.start_date).toDate();
					settings.bicornis_start_date = moment(
						settings.bicornis_start_date
					).toDate();
					settings.end_date = moment(settings.end_date).toDate();
					settings.excluded_dates = settings.excluded_dates.map(date =>
						moment(date).toDate()
					);

					return settings;
				});
		};

		/**
		 *
		 * @param organisationId
		 * @param data startpop settings
		 * @returns {*}
		 */
		this.editSetting = function(organisationId, data) {
			data = angular.copy(data);
			delete data.organisation_id;
			delete data.next_possible_date;
			delete data.excluded_dates;
			delete data.unavailable_dates;
			delete data.remaining_units;
			delete data.excluded_postal_codes;

			if (data.start_date) {
				data.start_date = moment(data.start_date).format('YYYY-MM-DD');
			}
			if (data.bicornis_start_date) {
				data.bicornis_start_date = moment(data.bicornis_start_date).format(
					'YYYY-MM-DD'
				);
			}
			if (data.end_date) {
				data.end_date = moment(data.end_date).format('YYYY-MM-DD');
			}
			if (data.bicornis_start_date) {
				data.bicornis_start_date = moment(data.bicornis_start_date).format(
					'YYYY-MM-DD'
				);
			}
			return $http.put(
				SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId,
				data
			);
		};

		/**
		 * Update the list of excluded dates
		 * @param orgId
		 * @param oldDates
		 * @param newDates
		 * @returns {Promise}
		 */
		this.editDates = function(orgId, oldDates, newDates) {
			oldDates = oldDates.map(date => moment(date).format('YYYY-MM-DD'));
			newDates = newDates.map(date => moment(date).format('YYYY-MM-DD'));
			var deleteDates = oldDates.filter(x => !newDates.includes(x));
			var addDates = newDates.filter(x => !oldDates.includes(x));
			var path =
				SETTINGS.beehomeAPIBasePath + 'settings/' + orgId + '/excluded-dates/';
			var promises = [];
			angular.forEach(deleteDates, function(date) {
				promises.push($http.delete(path + date));
			});
			angular.forEach(addDates, function(date) {
				promises.push($http.put(path + date, {}));
			});
			return $q.all(promises);
		};

		/**
		 * Compare two lists of postal codes, detect any changes and make the respective requests to update the
		 * old codes in the database.
		 * @param orgId
		 * @param oldPostalCodes
		 * @param newPostalCodes
		 * @returns {*}
		 */
		this.editPostalCodes = function(orgId, oldPostalCodes, newPostalCodes) {
			// Create dictionaries with country_code/postal_code as key
			var oldCodes = oldPostalCodes.reduce((a, x) => {
				a[x.country_code + '/' + x.postal_code] = x;
				return a;
			}, {});
			var newCodes = newPostalCodes.reduce((a, x) => {
				a[x.country_code + '/' + x.postal_code] = x;
				return a;
			}, {});

			// Compare the two dictionaries, detect which need to be deleted or added/updated
			var deleteCodes = {};
			angular.forEach(oldCodes, function(value, key) {
				if (!(key in newCodes)) {
					deleteCodes[key] = value;
				}
			});
			var putCodes = {};
			angular.forEach(newCodes, function(value, key) {
				if (!(key in oldCodes) || value.description !== oldCodes[key].description) {
					putCodes[key] = value;
				}
			});
			var path =
				SETTINGS.beehomeAPIBasePath +
				'settings/' +
				orgId +
				'/excluded-postal-codes/';
			var promises = [];
			angular.forEach(deleteCodes, function(code, key) {
				promises.push($http.delete(path + key));
			});
			angular.forEach(putCodes, function(code, key) {
				code = angular.copy(code);
				delete code.country_code;
				delete code.postal_code;
				delete code.edit;
				promises.push($http.put(path + key, code));
			});
			return $q.all(promises);
		};

		/**
		 * Add a new startpop voucher
		 * @param voucher
		 * @returns {*}
		 */
		this.addVoucher = function(voucher) {
			return $http.post(SETTINGS.beehomeAPIBasePath + 'vouchers', voucher);
		};

		/**
		 * Edit a startpop voucher
		 * @param voucher
		 * @returns {*}
		 */
		this.editVoucher = function(voucher) {
			return $http.patch(
				SETTINGS.beehomeAPIBasePath + 'vouchers/' + voucher.id,
				voucher
			);
		};

		/**
		 * Delete a list of startpop vouchers by id
		 * @param ids
		 * @returns {Promise}
		 */
		this.deleteVouchers = function(ids) {
			var promises = [];
			angular.forEach(ids, function(id) {
				promises.push($http.delete(SETTINGS.beehomeAPIBasePath + 'vouchers/' + id));
			});
			return $q.all(promises);
		};

		/**
		 * Get a list of startpop vouchers
		 * @param params
		 * @returns {*}
		 */
		this.getVoucherList = function(params) {
			params.per_page = params.per_page ? params.per_page : 200;
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'vouchers', { params: params })
				.then(function(response) {
					return response.data;
				});
		};

		/**
		 * Get a list of startpop orders
		 * @param query
		 * @returns {*}
		 */
		this.getOrderList = function(query) {
			var params = {
				q: query.q,
				page: query.page,
				per_page: query.limit,
				sort: query.order
			};
			if (query.filter.delivery_date_from) {
				query.filter.delivery_date_from = moment(
					query.filter.delivery_date_from
				).format('YYYY-MM-DD');
			}
			if (query.filter.delivery_date_to) {
				query.filter.delivery_date_to = moment(
					query.filter.delivery_date_to
				).format('YYYY-MM-DD');
			}
			angular.forEach(query.filter, function(value, key) {
				if (value !== undefined && value != null) {
					params[key] = value;
				}
			});
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'orders', {
					params: params
				})
				.then(function(response) {
					return response.data;
				});
		};

		/**
		 * Get order
		 * @param orderId
		 * @returns {*}
		 */
		this.getOrder = function(orderId) {
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'orders/' + orderId)
				.then(function(response) {
					return response.data;
				});
		};

		/**
		 * Add a startpop order
		 * @param order
		 * @returns {*}
		 */
		this.addOrder = function(order) {
			return $http.post(SETTINGS.beehomeAPIBasePath + 'orders', order);
		};

		/**
		 * Edit a startpop order
		 * @param order
		 * @returns {*}
		 */
		this.editOrder = function(order) {
			var data = angular.copy(order);
			delete data.id;
			delete data.created_at;
			delete data.created_by;
			delete data.updated_at;
			delete data.updated_by;
			delete data.bexio_id;
			delete data.bexio_nr;
			delete data.tracking_number;
			delete data.tracking_url;
			delete data.shipping_label;
			return $http.patch(SETTINGS.beehomeAPIBasePath + 'orders/' + order.id, data);
		};

		/**
		 * Delete a list of startpop orders by id
		 * @param ids
		 * @returns {Promise}
		 */
		this.deleteOrders = function(ids) {
			var promises = [];
			angular.forEach(ids, function(id) {
				promises.push($http.delete(SETTINGS.beehomeAPIBasePath + 'orders/' + id));
			});
			return $q.all(promises);
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:StartpopCtrl
 * @description
 * # StartpopCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BeehomeOrdersCtrl', function(
		$scope,
		$mdDialog,
		$location,
		$q,
		$http,
		SETTINGS,
		startpopSettings,
		AlertUser,
		NotifyUser,
		shopifyFactory
	) {
		$scope.fileName = 'StartpopOrders';
		$scope.showFilter = false;
		$scope.startpop = {};
		$scope.matches = [];
		$scope.selected = [];
		$scope.settings = {};
		$scope.query = {
			q: '',
			order: '-id',
			limit: 20,
			page: 1,
			limitOptions: [20, 50, 100, 200],
			filter: {}
		};

		$scope.getStartpopOrders = getStartpopOrders;
		$scope.newOrder = newOrder;
		$scope.editOrder = editOrder;
		$scope.cannotBeDeleted = cannotBeDeleted;
		$scope.deleteOrders = deleteOrders;
		$scope.loadPrintData = loadPrintData;
		$scope.openHistory = openHistory;

		$scope.updateBexio = updateBexio;
		// this function cycles the print status of an order so that it is
		// synced to bexio if there is an amount to pay, or marked as paid if there are vouchers for all houses
		function updateBexio(orders) {
			orders.forEach(order => {
				$http
					.get(SETTINGS.beehomeAPIBasePath + 'beecare?order_id=' + order.id)
					.then(res => {
						let uncompletedBeecareRecord = res.data.items.find(beecare => {
							return !beecare.step4;
						});
						if (uncompletedBeecareRecord) {
							NotifyUser('this order contains incomplete beecare reords');
							return;
						}
						$http
							.patch(SETTINGS.beehomeAPIBasePath + 'orders/' + order.id, {
								is_printed: false
							})
							.then(res => {
								$http
									.patch(SETTINGS.beehomeAPIBasePath + 'orders/' + res.data.id, {
										is_printed: true
									})
									.then(getStartpopOrders);
							});
					});
			});
		}

		getSettings();

		function getSettings() {
			$scope.settings = {};
			startpopSettings.getSettingsList().then(function(data) {
				angular.forEach(data, function(row) {
					$scope.settings[row.organisation_id] = row;
				});
			});
		}

		function getStartpopOrders() {
			console.log('here');
			$scope.promise = startpopSettings
				.getOrderList($scope.query)
				.then(function(data) {
					if (data.items) {
						console.log('data.items received:', data.items);

						// Process each item to fetch Shopify order tags if shopify_id exists
						var promises = [];

						data.items.forEach(function(item, index) {
							console.log(
								'Processing item',
								index + 1,
								'of',
								data.items.length,
								'- ID:',
								item.id
							);

							if (item.shopify_id) {
								console.log(
									'Item has shopify_id:',
									item.shopify_id,
									'- fetching Shopify order data'
								);

								var shopifyPromise = shopifyFactory
									.getOrderById(item.shopify_id)
									.then(function(shopifyOrder) {
										console.log(
											'Successfully fetched Shopify order for item ID:',
											item.id,
											'Shopify order:',
											shopifyOrder
										);

										// Add tags as a string to the item
										if (shopifyOrder.tags && Array.isArray(shopifyOrder.tags)) {
											item.tags = shopifyOrder.tags.join(', ');
											console.log('Added tags to item:', item.tags);
										} else if (
											shopifyOrder.tags &&
											typeof shopifyOrder.tags === 'string'
										) {
											item.tags = shopifyOrder.tags;
											console.log('Added tags to item:', item.tags);
										} else {
											item.tags = '';
											console.log('No tags found for Shopify order, set empty string');
										}

										// Check if order contains beehome addon products
										var hasBeehomeAddon = shopifyFactory.hasBeehomeAddon(shopifyOrder);
										item.hasBeehomeAddon = hasBeehomeAddon;
										console.log('Order has beehome addon products:', hasBeehomeAddon);

										// Log product details for debugging
										if (shopifyOrder.lineItems && shopifyOrder.lineItems.length > 0) {
											console.log('Line items with product info:');
											shopifyOrder.lineItems.forEach(function(lineItem, idx) {
												if (lineItem.variant && lineItem.variant.product) {
													console.log('  Line item', idx + 1, ':', {
														name: lineItem.name,
														sku: lineItem.sku,
														productTitle: lineItem.variant.product.title,
														productTags: lineItem.variant.product.tags
													});
												}
											});
										}
									})
									.catch(function(error) {
										console.error(
											'Failed to fetch Shopify order for item ID:',
											item.id,
											'shopify_id:',
											item.shopify_id,
											'Error:',
											error
										);
										item.tags = '';
									});

								promises.push(shopifyPromise);
							} else {
								console.log('Item does not have shopify_id, skipping Shopify fetch');
								item.tags = '';
							}
						});

						// Wait for all Shopify API calls to complete
						$q
							.all(promises)
							.then(function() {
								console.log(
									'All Shopify API calls completed. Final data.items:',
									data.items
								);
								$scope.matches = data.items;
								$scope.startpopOrdersCount = data.total_count;
								$scope.selected = [];
							})
							.catch(function(error) {
								console.error(
									'Some Shopify API calls failed, but continuing with available data:',
									error
								);
								$scope.matches = data.items;
								$scope.startpopOrdersCount = data.total_count;
								$scope.selected = [];
							});
					}
				});
		}

		function newOrder(type) {
			$location.path('/beehome/orders/new').search({
				client_id: $scope.clientId,
				type: type,
				house_id: $scope.houseId
			});
		}

		function editOrder(id) {
			$location.path('/beehome/orders/' + id);
		}

		function cannotBeDeleted(order) {
			return order.bexio_id > 0 || order.is_printed;
		}

		function deleteOrders() {
			var ids = [];
			angular.forEach($scope.selected, function(order) {
				ids.push(order.id);
			});

			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('Delete orders')
				.textContent(
					"Are you sure you'd like to delete orders " + ids.join(', ') + '?'
				)
				.ariaLabel('Confirm delete')
				.ok('Yes delete.')
				.cancel("No I'll think about it.");

			$mdDialog.show(confirm).then(function() {
				startpopSettings.deleteOrders(ids).then(getStartpopOrders);
			});
		}

		function checkExportWorked() {
			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						// eslint-disable-next-line no-unused-vars
						var $confirmButton = $actionsSection.children()[1];
						// angular.element($confirmButton).addClass('md-raised md-warn');
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('EXPORTING LIST, PLEASE WAIT...')
				.textContent('Do you want to mark the exported orders as printed?')
				.ok('Yes, mark them printed')
				.cancel('No');
			$mdDialog.show(confirm).then(function() {
				var batches = getBatches($scope.printedList);
				$scope.promise = batches
					.reduce(function(promise, batch) {
						return promise.then(markPrinted(batch));
					}, $q.when())
					.then(getStartpopOrders, alertError);
			}, angular.noop);
		}

		/**
		 * Mark a batch of orders as printed.
		 * This needs to be a factory so that one batch is processed sequentially after the other
		 */
		function markPrinted(batch) {
			return function() {
				var promises = [];
				angular.forEach(batch, function(order) {
					promises.push(
						startpopSettings.editOrder({ id: order.id, is_printed: true })
					);
				});
				return $q.all(promises);
			};
		}

		/**
		 * Split arbitrary array into array of arrays
		 */
		function getBatches(allItems, batchSize = 16) {
			var batches = [];
			for (var i = 0; i < allItems.length; i += batchSize) {
				batches.push(allItems.slice(i, i + batchSize));
			}
			return batches;
		}

		function alertError() {
			AlertUser('Uh oh. Something went wrong.');
		}

		function getHouseNumber(words) {
			// Get the last group of digits, dashes and slashes followed by optional non-digit characters
			var n = words.match(/[-/\d]+\D*/g);
			return n ? n[n.length - 1] : '';
		}

		function removeHouseNumber(words, houseNumber) {
			return words.substring(0, words.length - houseNumber.length);
		}

		function prepDownloadList(gridData, orgID) {
			var exportData = [
				['AMOUNT', ' ', 'COMPANY', 'NAME', 'ADDRESS', 'PLZ', 'TOWN', ' ']
			];
			if (orgID == 3) {
				exportData = [
					[
						'AMOUNT',
						'NAME',
						'ZUSATZ',
						'STRASSE',
						'NUMMER',
						'PLZ',
						'STADT',
						'LAND',
						'ADRESS_TYP'
					]
				];
			}

			for (var i = gridData.length - 1; i >= 0; i--) {
				var gridRow = gridData[i];
				if (orgID != 3) {
					exportData.push([
						'' + gridRow['amount'],
						'',
						'' + (gridRow.company_name || ''),
						'' + (gridRow.first_name || '') + ' ' + (gridRow.last_name || ''),
						'' + gridRow.address_1,
						'' + gridRow.postal_code,
						'' + gridRow.town,
						''
					]);
				} else {
					var address = gridRow.address_1;
					var houseNumber = '';
					if (address) {
						houseNumber = getHouseNumber(address);
						address = removeHouseNumber(address, houseNumber);
						houseNumber = houseNumber.trim();
						address = address.trim();
					}

					exportData.push([
						'' + gridRow['amount'],
						(gridRow.first_name || '') + ' ' + (gridRow.last_name || ''),
						'' + (gridRow.company_name || ''),
						'' + address,
						'' + houseNumber,
						'' + gridRow.postal_code,
						'' + gridRow.town,
						'DE',
						'HOUSE'
					]);
				}
			}
			return exportData;
		}

		function setPrintGrids(data) {
			var printGrids = {};
			$scope.printedList = [];
			if (data) {
				$scope.printedList = data;
				var resultCount = data.length;
				for (var i = 0; i < resultCount; i++) {
					var rowData = data[i];
					var orgID = data[i].organisation_id;
					var maxStartpops = $scope.settings[orgID].max_units_per_package
						? Number($scope.settings[orgID].max_units_per_package)
						: 2;
					if (!printGrids[orgID]) {
						printGrids[orgID] = [];
					}
					var rowAmount = Number(rowData.amount);
					if (rowAmount > maxStartpops) {
						for (var x = 1; x <= rowAmount; x++) {
							var modValue = maxStartpops;
							var modulo = x % modValue;
							var newLine = angular.copy(rowData);
							if (modulo == 0) {
								newLine.amount = modValue;
								printGrids[orgID].push(newLine);
							} else if (rowAmount == x) {
								newLine.amount = modulo;
								printGrids[orgID].push(newLine);
							}
						}
					} else {
						printGrids[orgID].push(rowData);
					}
				}
				return printGrids;
			}
			return false;
		}

		function gatherPrintData(data) {
			var printData = setPrintGrids(data);
			if (!printData) {
				return false;
			} else {
				var exportDataArray = {};
				angular.forEach(printData, function(val, key) {
					exportDataArray[key] = prepDownloadList(val, key);
				});
				return exportDataArray;
			}
		}

		function loadPrintData() {
			$scope.$root.showLoader = true;
			var delay = $q.defer();
			if ($scope.selected.length > 0) {
				var returnedData = gatherPrintData($scope.selected);
				if (returnedData === false) {
					delay.reject();
				} else {
					delay.resolve(returnedData);
				}
				$scope.$root.showLoader = false;
				checkExportWorked();
			} else {
				if (Number($scope.startpopOrdersCount) <= 10000) {
					var printQuery = angular.copy($scope.query);
					printQuery.limit = $scope.startpopOrdersCount;
					$scope.promise = startpopSettings
						.getOrderList(printQuery)
						.then(function(data) {
							var returnedData = gatherPrintData(data.items);
							if (returnedData === false) {
								delay.reject();
							} else {
								delay.resolve(returnedData);
							}
						})
						.finally(function() {
							$scope.$root.showLoader = false;
						});
					checkExportWorked();
				} else {
					$scope.$root.showLoader = false;
					AlertUser(
						'Error',
						'Cannot to export files with more than 10000 rows of data. Please make use of the search and filter options to restrict the number of rows returned.'
					);
					delay.reject();
				}
			}
			return delay.promise;
		}

		function openHistory(orderId) {
			$location.path('history/order/' + orderId);
		}
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BeehomeOrderCtrl
 * @description
 * # BeehomeOrderCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BeehomeOrderCtrl', function(
		$anchorScroll,
		$http,
		$mdDialog,
		$location,
		$scope,
		$q,
		$timeout,
		AlertUser,
		AllProducts,
		AddressFactory,
		ClientFactory,
		ContactFactory,
		houseService,
		Session,
		SETTINGS,
		startpopSettings,
		trackingNumberService,
		order,
		shopifyFactory
	) {
		Session.pageTitle = 'Order details';
		Session.setStream('beehome');

		var clientId = parseInt($location.search().client_id);
		var houseId = parseInt($location.search().house_id);
		var type = $location.search().type || 'STARTPOP';

		$scope.order = order;
		$scope.client = null;
		$scope.products = {};
		$scope.houses = {};
		$scope.housesSelected = [];
		$scope.housesPromise = null;
		$scope.vouchers = [];
		$scope.missingVouchers = [];
		$scope.vouchersSelected = [];
		$scope.vouchersPromise = null;
		$scope.settings = null;
		$scope.freeAmount = 0;
		$scope.totalAmount = 0;
		$scope.calculate = { additionalAmount: undefined };
		$scope.showClientSearch = null;
		$scope.expandAddress = null;
		$scope.expandBillingAddress = null;
		$scope.Object = Object;

		$scope.assignClient = assignClient;
		$scope.addClient = addClient;
		$scope.editClient = editClient;
		$scope.addHouse = addHouse;
		$scope.addVoucher = addVoucher;
		$scope.updateTotalPrice = updateTotalPrice;
		$scope.isDisabled = isDisabled;
		$scope.dateFilter = dateFilter;
		$scope.cancel = cancel;
		$scope.save = save;
		$scope.getTrackingLink = getTrackingLink;
		$scope.donationOptions = [];
		$scope.updateSpecies = updateSpecies;
		$scope.clearDonation = clearDonation;
		$scope.searchVouchers = searchVouchers;
		$scope.addExistingVoucher = addExistingVoucher;
		let beecareVariants = [];
		let activeBeecareVariant = null;
		init();

		/**
		 * Edit existing order if exists and load client data, or else create a new order.
		 * If a clientId is provided via the url params then load the client data
		 * Otherwise let the user pick a client first.
		 */
		function init() {
			if (order) {
				$scope.showClientSearch = false;
				ClientFactory.getClient(order.client_id).then(assignClient);
			} else if (clientId) {
				$scope.order = newOrder();
				$scope.showClientSearch = false;
				ClientFactory.getClient(clientId).then(assignClient);
			} else {
				$scope.order = newOrder();
				$scope.showClientSearch = true;
			}
			$anchorScroll('orderForm');

			AllProducts().then(response => {
				angular.forEach(response, product => {
					$scope.products[parseInt(product.ID)] = product;
				});
			});
		}

		/**
		 * Initialize an empty new order instance
		 * @returns {{order_date: string}}
		 */
		function newOrder() {
			return {
				type: type,
				order_date: moment().format('YYYY-MM-DD'),
				is_standard: true,
				total_price: 0,
				amount: 0
			};
		}

		/**
		 * Load additional data when new client is assigned
		 * @param client
		 */
		function assignClient(client) {
			$scope.client = client;
			$scope.order.client_id = client.id;
			$scope.order.organisation_id = client.organisation.id;
			$scope.showClientSearch = false;
			var contact = ContactFactory.getBillingContact($scope.client.contacts);
			if (contact) {
				$scope.order.email = contact ? contact.email : null;
				$scope.order.language = contact.language;
			}
			getSettings()
				.then(getVouchers)
				.then(() => {
					parseAddress();
					const shopifyLocale = shopifyFactory.getShopifyLocale(
						client.organisation.id,
						$scope.order.language
					);

					var productPromise =
						$scope.order.type === 'STARTPOP'
							? shopifyFactory.getProducts(shopifyLocale).then(updateStartpopPrice)
							: shopifyFactory.getBeecareProducts(shopifyLocale).then(res => {
									beecareVariants = res[0].variants;
							  });

					productPromise.then(() => {
						shopifyFactory
							.customerByEmail($scope.order.email)
							.then(
								shopifyCustomer => ($scope.order.shopifyCustomer = shopifyCustomer)
							)
							.catch(() => {
								delete $scope.order.shopifyCustomer;
								client.email = $scope.order.email;
								shopifyFactory.createShopifyCustomer(client).then(result => {
									$scope.order.shopifyCustomer = result;
								});
							});
					});

					shopifyFactory.getDonationProduct(shopifyLocale).then(donationProduct => {
						$scope.donationOptions = donationProduct.variants;
					});
				});
		}

		/**
		 * Open modal to create a new client
		 */
		function addClient(ev) {
			$mdDialog
				.show({
					controller: 'AccountSummaryModalCtrl',
					controllerAs: 'ctrl',
					templateUrl: 'views/account-modal.html',
					targetEvent: ev,
					parent: angular.element(document.body),
					locals: {
						client: null,
						certifications: null
					},
					resolve: {
						organisations: function(AllOrganisations) {
							return AllOrganisations();
						}
					}
				})
				.then(function(data) {
					ClientFactory.getClient(data.client.id).then(assignClient);
				}, angular.noop);
		}

		/**
		 * Open modal to edit existing client
		 */
		function editClient() {
			$mdDialog
				.show({
					controller: 'AccountSummaryModalCtrl',
					controllerAs: 'ctrl',
					templateUrl: 'views/account-modal.html',
					parent: angular.element(document.body),
					locals: {
						client: $scope.client,
						certifications: null
					},
					resolve: {
						organisations: function(AllOrganisations) {
							return AllOrganisations();
						}
					}
				})
				.then(function(data) {
					ClientFactory.getClient(data.client.id).then(assignClient);
				}, angular.noop);
		}

		/**
		 * Get voucher and house data
		 */
		function getVouchers() {
			getHouseData()
				.then(getVoucherData)
				.then(updateAmounts);
		}

		function getVoucherData() {
			if ($scope.order.type === 'STARTPOP') {
				$scope.voucherPromise = getStartpopVoucherData().then(
					filterVouchersBySpecies
				);
			} else if ($scope.order.type === 'BEECARE') {
				$scope.voucherPromise = getBeeCareVoucherData();
			}
			return $scope.voucherPromise;
		}

		/**
		 * Get startpop vouchers linked to the houses of the client
		 * @returns {*}
		 */
		function getStartpopVoucherData() {
			return startpopSettings
				.getVoucherList({
					client_id: $scope.client.id,
					sort: 'code'
				})
				.then(function(data) {
					$scope.vouchers = [];
					$scope.vouchersSelected = [];
					angular.forEach(data.items, function(voucher) {
						if (
							voucher.type.indexOf('STARTPOP') > -1 &&
							(voucher.is_active || voucher.order_id === $scope.order.id)
						) {
							voucher.house = $scope.houses[voucher.code];
							$scope.vouchers.push(voucher);
							if (voucher.order_id === $scope.order.id) {
								$scope.vouchersSelected.push(voucher);
							}
						}
					});
				});
		}

		/**
		 * Get vouchers attached to the existing BeeCare order
		 * @returns {*}
		 */
		function getBeeCareVoucherData() {
			console.log('hmmm');
			if (!$scope.order.id) {
				return $q.when([]);
			}
			console.log('hum');
			return startpopSettings
				.getVoucherList({
					order_id: $scope.order.id,
					type: $scope.order.type,
					sort: 'code'
				})
				.then(function(data) {
					$scope.vouchers = data.items;
					angular.forEach(data.items, function(voucher) {
						$scope.vouchersSelected.push(voucher);
					});
				});
		}

		function getHouseData() {
			$scope.housesPromise = houseService
				.getHouses({ client_id: $scope.client.id, sort: 'code' })
				.then(function(data) {
					return getBeeCareHouseData().then(function(houses) {
						$scope.houses = {};
						$scope.housesSelected = [];
						angular.forEach(data.items, function(house) {
							$scope.houses[house.code] = house;
							if (house.id === houseId || houses.includes(house.id)) {
								$scope.housesSelected.push(house);
							}
						});
					});
				});
			return $scope.housesPromise;
		}

		/**
		 * Get the list of houses attached to a BeeCare order
		 * @returns {*}
		 */
		function getBeeCareHouseData() {
			if ($scope.order.type !== 'BEECARE' || !$scope.order.id) {
				return $q.when([]);
			}
			var houses = [];
			return $http
				.get(SETTINGS.beehomeAPIBasePath + 'beecare?order_id=' + $scope.order.id)
				.then(function(response) {
					angular.forEach(response.data.items, function(beecare) {
						houses.push(beecare.house_id);
					});
					return houses;
				});
		}

		function addHouse() {
			$mdDialog
				.show({
					controller: 'ProductPOPCtrl',
					controllerAs: 'ctrl',
					templateUrl: 'views/product-create.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					locals: {
						customer: $scope.client,
						activeProduct: {}
					}
				})
				.then(getVouchers, angular.noop);
		}

		function addVoucher() {
			$mdDialog
				.show({
					controller: 'BeehomeVoucherModalCtrl',
					templateUrl: 'views/beehome-voucher-modal.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					resolve: {
						organisations: function(OrganisationFactory) {
							return OrganisationFactory.getMap();
						}
					},
					locals: {
						voucher: {
							type: $scope.order.type,
							organisation_id: $scope.order.organisation_id
						},
						codes: [],
						findExisting: true
					}
				})
				.then(function(data) {
					console.log(data.type);
					console.log($scope.order);
					if (
						data &&
						data.type.toLowerCase().indexOf($scope.order.type.toLowerCase()) > -1
					) {
						$scope.vouchers.push(data);
						$scope.vouchersSelected.push(data);
						updateTotalPrice();
					} else {
						AlertUser(
							'Error',
							'Cannot add a ' +
								data.type +
								' voucher to a ' +
								$scope.order.type +
								' order.'
						);
					}
				}, angular.noop);
		}
		/**
		 * Reload the vouchers when the species is chnaged
		 */
		function updateSpecies() {
			$scope.vouchersSelected = [];
			getStartpopVoucherData().then(() => {
				filterVouchersBySpecies();
				updateStartpopPrice();
			});
		}

		function clearDonation() {
			$scope.order.donation = null;
		}

		/**
		 * Filter the list of vouchers by species
		 */
		function filterVouchersBySpecies() {
			$scope.vouchers = $scope.vouchers.filter(voucher => {
				if (
					$scope.settings.activeSpecies == 'cornuta' &&
					voucher.type != 'STARTPOP_BC'
				) {
					return true;
				} else if (
					$scope.settings.activeSpecies == 'bicornis' &&
					voucher.type != 'STARTPOP_OC'
				) {
					return true;
				}
			});
		}

		function updateStartpopPrice() {
			const product = shopifyFactory.findProduct($scope.settings.activeSpecies);
			const paidVariant = product.variants.find(v => Number(v.price) > 0);
			console.log('updateStartpopPrice:', {
				species: $scope.settings.activeSpecies,
				product: product.title,
				paidVariant: paidVariant,
				allVariants: product.variants
			});
			$scope.order.unit_price = paidVariant ? Number(paidVariant.price) : 0;
			updateTotalPrice();
		}

		/**
		 * Get organisation settings and set the form defaults and validations based on these settings.
		 */
		function getSettings() {
			return startpopSettings
				.getSettings($scope.client.organisation.id)
				.then(function(settings) {
					if ($scope.order.type === 'STARTPOP') {
						$scope.settings = settings.startpop;

						// Set min date for delivery date picker
						var today = moment()
							.startOf('day')
							.toDate();
						$scope.settings.min_date =
							today > settings.startpop.start_date
								? today
								: settings.startpop.start_date;

						// Convert list of dates to list of string so it can be searched more easily by dateFilter
						$scope.settings.excluded_dates = settings.excluded_dates.map(date =>
							moment(date).format('YYYY-MM-DD')
						);
						//set the active species
						if (today < moment(settings.startpop.bicornis_start_date, 'YYYY-MM-DD')) {
							$scope.settings.activeSpecies = 'cornuta';
						} else {
							$scope.settings.activeSpecies = 'bicornis';
						}
						filterVouchersBySpecies();

						// Prefill delivery date
						if (!$scope.order.delivery_date) {
							$scope.order.delivery_date = settings.startpop.next_possible_date;
						}
					} else {
						$scope.settings = settings.beecare;
					}

					// Prefill currency
					if ($scope.order.currency == null) {
						$scope.order.currency = $scope.settings.currency;
					}

					// Prefill shipping price
					if ($scope.order.shipping_price == null) {
						$scope.order.shipping_price = $scope.settings.shipping_price || 0;
					}
				});
		}

		/**
		 * If its a new order, then set the default to the billing address.
		 * For existing orders read the order address fields and determine which address id
		 * this is.
		 */
		function parseAddress() {
			// Billing address
			var billingAddress = AddressFactory.getBillingAddress(
				$scope.client.addresses
			);
			if (billingAddress && billingAddress.id) {
				$scope.billingAddressId = billingAddress.id;
			} else {
				$scope.expandAddress = true;
			}

			// Delivery address
			if (!$scope.order.id) {
				$scope.order.address_id = $scope.billingAddressId;
				$scope.order.billingAddress = billingAddress;
			} else if (!$scope.order.address_id) {
				angular.forEach($scope.client.addresses, function(address) {
					if (
						address.first_name === $scope.order.first_name &&
						address.last_name === $scope.order.last_name &&
						address.company_name === $scope.order.company_name &&
						address.address_1 === $scope.order.address_1 &&
						(address.address_2 || '') === ($scope.order.address_2 || '') &&
						address.postal_code === $scope.order.postal_code &&
						address.town === $scope.order.town &&
						address.country_code === $scope.order.country_code
					) {
						$scope.order.address_id = address.id;
						$scope.order.billingAddress = address;
					}
				});

				// Deleted address
				// Create temporary address object from order address fields
				if (!$scope.order.address_id) {
					$scope.order.address_id = 0;
					$scope.startpopAddress = {
						id: 0,
						first_name: $scope.order.first_name,
						last_name: $scope.order.last_name,
						company_name: $scope.order.company_name,
						address_1: $scope.order.address_1,
						address_2: $scope.order.address_2,
						postal_code: $scope.order.postal_code,
						town: $scope.order.town,
						country_code: $scope.order.country_code
					};
					$scope.client.addresses.push($scope.startpopAddress);
				}
			}
		}

		/**
		 * Write client address fields to order.
		 */
		function dumpAddress() {
			angular.forEach($scope.client.addresses, function(address) {
				if (address.id === $scope.order.address_id) {
					$scope.order.first_name = address.first_name;
					$scope.order.last_name = address.last_name;
					$scope.order.company_name = address.company_name;
					$scope.order.address_1 = address.address_1;
					$scope.order.address_2 = address.address_2;
					$scope.order.postal_code = address.postal_code;
					$scope.order.town = address.town;
					$scope.order.country_code = address.country_code;
				}
			});
			// Remove temporary id for deleted address
			if ($scope.order.address_id === 0) {
				delete $scope.order.address_id;
			}
		}

		/**
		 * For STARTPOP orders the additional amount is given, total amount is calculated
		 * For BEECARE orders the total amount is given, additional amount is calculated
		 */
		function updateAmounts() {
			console.log('calculate.additionalAmount', $scope.calculate.additionalAmount);
			if ($scope.order.type === 'STARTPOP') {
				if ($scope.calculate.additionalAmount === undefined) {
					$scope.freeAmount = $scope.vouchersSelected.length;
					$scope.totalAmount = $scope.order.amount;
					$scope.calculate.additionalAmount = $scope.totalAmount - $scope.freeAmount;
				} else {
					$scope.freeAmount = $scope.vouchersSelected.length;
					$scope.totalAmount = $scope.freeAmount + $scope.calculate.additionalAmount;
				}
				console.log('updateAmounts STARTPOP:', {
					freeAmount: $scope.freeAmount,
					additionalAmount: $scope.calculate.additionalAmount,
					totalAmount: $scope.totalAmount,
					unitPrice: $scope.order.unit_price,
					subTotal: $scope.calculate.additionalAmount * $scope.order.unit_price
				});
			} else if ($scope.order.type === 'BEECARE') {
				$scope.freeAmount = $scope.vouchersSelected.length;
				$scope.totalAmount = $scope.housesSelected.length;
				$scope.calculate.additionalAmount = $scope.totalAmount - $scope.freeAmount;
			}
			if (
				$scope.order.type == 'BEECARE' &&
				beecareVariants &&
				beecareVariants.length
			) {
				const priceOptions = beecareVariants.filter(({ price }) => {
					return Number(price) > 0;
				});
				priceOptions.sort((a, b) => Number(b.price) - Number(a.price));
				activeBeecareVariant =
					$scope.calculate.additionalAmount < priceOptions.length
						? priceOptions[$scope.calculate.additionalAmount - 1]
						: priceOptions[priceOptions.length - 1];
				$scope.order.unit_price = Number(activeBeecareVariant.price);
			}
			$scope.subTotal =
				$scope.calculate.additionalAmount * $scope.order.unit_price +
				($scope.order.donation ? Number($scope.order.donation.price) : 0);
		}

		/**
		 * Recalculate the total price
		 * If it is marked as paid with zero price then remove the paid flag
		 */
		function updateTotalPrice() {
			if ($scope.order.is_paid && $scope.order.total_price === 0) {
				$scope.order.is_paid = false;
			}
			updateAmounts();
			$scope.order.total_price = $scope.subTotal;
			if ($scope.order.total_price === 0) {
				$scope.order.is_paid = true;
				$scope.order.psp = null;
				$scope.isInvoice = null;
			}
		}

		/**
		 * A voucher is enabled to be added to the order when it is a real voucher,
		 * and is active or already attached to the order.
		 * @param voucher
		 */
		function isDisabled(voucher) {
			return !(
				voucher.id &&
				(voucher.is_active || voucher.order_id === $scope.order.id)
			);
		}

		/**
		 * Return true if a date is a valid delivery date and should be selectable in the date picker.
		 * Check the weekday and whether a date is excluded (holidays). This does not repect the normal
		 * delivery lag or the max units per day. Boundaries (start and end of season) are handles elsehwere.
		 * @param date
		 * @returns {boolean|*}
		 */
		function dateFilter(date) {
			if (!$scope.settings) {
				return true;
			}
			return (
				$scope.settings.delivery_weekdays.includes(moment(date).isoWeekday()) &&
				!$scope.settings.excluded_dates.includes(moment(date).format('YYYY-MM-DD'))
			);
		}
		function searchVouchers(voucherCode) {
			let defer = $q.defer();
			$http
				.get(SETTINGS.beehomeAPIBasePath + 'vouchers', {
					params: { code: voucherCode }
				})
				.then(function(response) {
					if (response.data && response.data.items) {
						defer.resolve(
							response.data.items.filter(voucher => {
								return (
									voucher.is_active &&
									!voucher.client_id &&
									!$scope.vouchers.find(voucherB => voucher.code == voucherB.code)
								);
							})
						);
					} else {
						defer.resolve([]);
					}
				});
			return defer.promise;
		}
		function addExistingVoucher(voucher) {
			if (!voucher) return;
			$scope.vouchers.push(voucher);
			$scope.vouchersSelected.push(voucher);
			updateTotalPrice();
		}

		function cancel() {
			$location.path('/beehome/orders');
		}
		function save() {
			console.log(
				'scope',
				$scope.client.contacts.find(contact => contact.email)
			);
			if ($scope.client.contacts.find(contact => contact.email)) {
				console.log('shopify');
			} else {
				console.log('bexio baby');
			}
			$scope.$root.showLoader = true;
			dumpAddress();
			let orderData = angular.copy($scope.order);
			orderData.amount = $scope.totalAmount;
			orderData.vouchers = [];

			angular.forEach($scope.vouchersSelected, function(voucher) {
				orderData.vouchers.push(voucher);
			});
			if (orderData.type === 'BEECARE') {
				orderData.houses = [];
				angular.forEach($scope.housesSelected, function(house) {
					orderData.houses.push(house.id);
				});
				orderData.variant = activeBeecareVariant;
			}
			if (orderData.delivery_date) {
				orderData.delivery_date = moment(orderData.delivery_date).format(
					'DD-MM-YYYY'
				);
			}
			if (orderData.id) {
				startpopSettings.editOrder(orderData).then(
					function() {
						$scope.$root.showLoader = false;
						$location.path('/beehome/orders');
					},
					function(response) {
						$scope.$root.showLoader = false;
						AlertUser('Error ' + response.data.status, response.data.detail);
					}
				);
			} else {
				console.log('save orderData:', {
					amount: orderData.amount,
					vouchersCount: orderData.vouchers.length,
					paidItems: orderData.amount - orderData.vouchers.length,
					unitPrice: orderData.unit_price,
					totalPrice: orderData.total_price,
					type: orderData.type
				});

				$scope.$root.showLoader = false;
				let shopifOrderPromise;

				if ($scope.order.type == 'BEECARE') {
					console.log('go');
					shopifOrderPromise = shopifyFactory.draftBeecareOrder(orderData);
				} else {
					shopifOrderPromise = shopifyFactory.draftOrder(
						orderData,
						$scope.settings.activeSpecies
					);
				}
				shopifOrderPromise
					.then(data => {
						$location.path('/beehome/orders');
						$scope.$root.showLoader = false;
						let invoiceLink = new URL(data.invoiceUrl);
						$timeout(() => {
							window.open(
								invoiceLink.origin + '/admin/draft_orders/' + data.id.split('/').pop(),
								'_blank'
							);
						});
					})
					.catch(() => {
						AlertUser('Unable to create draft order');
					})
					.finally(() => {
						$scope.$root.showLoader = false;
					});
			}
		}

		function getTrackingLink(tracking_number) {
			return trackingNumberService.getURL(tracking_number);
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:beehomeOrders
 * @description
 */
angular.module('wildBieneHarvestApp').directive('beehomeOrders', function() {
	return {
		templateUrl: 'views/beehome-orders.html',
		scope: {
			clientId: '<',
			houseId: '<',
			organisations: '<',
			users: '<'
		}
	};
});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:excelExport
 * @description
 * # excelExport
 */
angular.module('wildBieneHarvestApp').directive('excelExport', function() {
	return {
		restrict: 'A',
		scope: {
			buttonText: '@',
			fileName: '@',
			printStatus: '@',
			getData: '&'
		},
		replace: true,
		template:
			'<div class="md-primary md-button" ng-click="printOut()"><i class="material-icons">get_app</i> {{buttonText}}</div>',
		link: function(scope) {
			scope.printOut = function() {
				scope
					.getData({
						status: scope.printStatus
					})
					.then(function(data) {
						if (typeof data === 'object') {
							if (data[0]) {
								scope.download(data);
							} else {
								var holdName = scope.fileName;
								angular.forEach(data, function(val, key) {
									scope.fileName = key + '-' + holdName;
									scope.download(val);
								});
								scope.fileName = holdName;
							}
						}
					});
			};

			scope.download = function(data) {
				function datenum(v, date1904) {
					if (date1904) v += 1462;
					var epoch = Date.parse(v);
					return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				}

				function getSheet(data) {
					var ws = {};
					var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
					for (var R = 0; R != data.length; ++R) {
						for (var C = 0; C != data[R].length; ++C) {
							if (range.s.r > R) range.s.r = R;
							if (range.s.c > C) range.s.c = C;
							if (range.e.r < R) range.e.r = R;
							if (range.e.c < C) range.e.c = C;
							var cell = { v: data[R][C] };
							if (cell.v == null) continue;
							var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

							if (typeof cell.v === 'number') cell.t = 'n';
							else if (typeof cell.v === 'boolean') cell.t = 'b';
							else if (cell.v instanceof Date) {
								cell.t = 'n';
								cell.z = XLSX.SSF._table[14];
								cell.v = datenum(cell.v);
							} else cell.t = 's';

							ws[cell_ref] = cell;
						}
					}
					if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
					return ws;
				}

				function Workbook() {
					if (!(this instanceof Workbook)) return new Workbook();
					this.SheetNames = [];
					this.Sheets = {};
				}

				var wb = new Workbook(),
					ws = getSheet(data);
				/* add worksheet to workbook */
				wb.SheetNames.push(scope.fileName);
				wb.Sheets[scope.fileName] = ws;
				var wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'binary'
				});

				function s2ab(s) {
					var buf = new ArrayBuffer(s.length);
					var view = new Uint8Array(buf);
					for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
					return buf;
				}
				// TODO does this work.
				// eslint-disable-next-line no-undef
				saveAs(
					new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
					scope.fileName + '.xlsx'
				);
			};
		}
	};
});

'use strict';

/**
 * @ngdoc filter
 * @name wildBieneHarvestApp.filter:setphrasevalues
 * @function
 * @description
 * # setphrasevalues
 * Filter in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').filter('setphrasevalues', function() {
	return function(arr, season, address, deliveryDate, request) {
		if (!request) {
			request = [];
		}
		var valueSet = {
			LINE_BREAK: '\n',
			SEASON: season,
			REQUESTED_PRODUCT:
				request.length == 0 ? '' : request.requestItems[0].description,
			NO_OF_UNITS: request.length == 0 ? '' : request.requestItems[0].requested,
			DELIVERY_DATE: deliveryDate,
			DELIVERY_ADDRESS: address
		};

		angular.forEach(arr, function(value, key) {
			angular.forEach(valueSet, function(replacement, searchkey) {
				if (value) {
					var search = '[' + searchkey + ']';
					value = value.split(search).join(replacement);
					arr[key] = value;
				}
			});
		});
		return arr;
	};
});

'use strict';

/**
 * @ngdoc filter
 * @name wildBieneHarvestApp.filter:selectphrases
 * @function
 * @description
 * # selectphrases
 * Filter in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').filter('selectphrases', function() {
	return function(phrases_array, langID, organisationID, phraseCD) {
		var phrase_TEXT = {};
		if (langID && organisationID && phraseCD) {
			angular.forEach(phrases_array, function(value) {
				if (
					organisationID == value.ORGANISATION_ID &&
					phraseCD == value.PHRASE_CD &&
					langID == value.LANG_ID
				) {
					phrase_TEXT[value.TXT_CD] = value.TXT_MODULE;
				}
			});
		}
		return phrase_TEXT;
	};
});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.organisations
 * @description
 * # orginisations
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('getPhrasesService', [
		'$resource',
		'SETTINGS',
		'$q',
		'$http',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'documents/');
		}
	])
	.factory('AllPhrases', [
		'$rootScope',
		'getPhrasesService',
		'$q',
		function($rootScope, getPhrasesService, $q) {
			return function() {
				var delay = $q.defer();
				var phrases = $rootScope.allPhraseList;
				if (phrases) {
					delay.resolve(phrases);
				} else {
					getPhrasesService.query(
						function(returnedPhrases) {
							delay.resolve(returnedPhrases);

							$rootScope.allPhraseList = returnedPhrases;
						},
						function() {
							delay.reject('unable to fetch phrases');
						}
					);
				}
				return delay.promise;
			};
		}
	])
	.service('selectPhrasesService', [
		'SETTINGS',
		'$http',
		'$q',
		'Session',
		function(SETTINGS, $http, $q, Session) {
			var selector = {};

			selector.phrases = function(
				phrasesArray,
				languageID,
				organisationID,
				phraseCode
			) {
				selector.phraseList = {};
				if (languageID && organisationID && phraseCode) {
					// console.log( " " + languageID + "org:" + organisationID + "   "+ phraseCode );
					angular.forEach(phrasesArray, function(value) {
						if (
							organisationID == value.ORGANISATION_ID &&
							phraseCode.toLowerCase() == value.PHRASE_CD.toLowerCase() &&
							languageID == value.LANG_ID
						) {
							selector.phraseList[value.TXT_CD] = value.TXT_MODULE;
						}
					});
				}
				// console.log('selector:',selector)
				return selector;
			};

			selector.populate = function(lang_id) {
				var delay = $q.defer();
				selector.products = {};
				$http.get(SETTINGS.APIBasePath + 'phrases/').then(function(result) {
					var allPhrases = result.data;
					for (var i = 0; i < allPhrases.length; i++) {
						if (
							allPhrases[i].PHRASE_CD == 'SALES_PRODUCTS_DESCRIPTION' &&
							allPhrases[i].LANG_ID == lang_id
						) {
							selector.products[allPhrases[i].TXT_CD] = allPhrases[i].TXT_MODULE;
						}
					}
					delay.resolve(selector);
				});
				return delay.promise;
			};

			function replaceAll(str, find, replace) {
				if (str) {
					return str.split(find).join(replace);
				}
				return str;
			}

			selector.prep_email = function(email_phrases, doc_type, client_name) {
				var bodytext = email_phrases[doc_type + '_body'];
				var subject = email_phrases[doc_type + '_subject'];

				if (!bodytext || bodytext == '') {
					bodytext = email_phrases.default_farmer_body;
				}

				if (!subject || subject == '') {
					subject = email_phrases.default_farmer_subject;
				}

				bodytext = replaceAll(bodytext, '[NAME]', client_name);
				bodytext = replaceAll(bodytext, '[AGENT]', Session.getName());
				bodytext = replaceAll(bodytext, '[DOCUMENT]', email_phrases[doc_type]);
				bodytext = replaceAll(bodytext, '[LINE_BREAK]', '\n');

				subject = replaceAll(subject, '[DOCUMENT]', email_phrases[doc_type]);
				subject = replaceAll(subject, '[NAME]', client_name);

				selector.email_data = { bodytext: bodytext, subject: subject };
				return selector;
			};
			return selector;
		}
	]);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ProductLinkCtrl
 * @description
 * # ProductLinkCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ProductLinkCtrl', function(
		$scope,
		$mdDialog,
		$http,
		$location,
		SETTINGS,
		Session
	) {
		$scope.keywords = { FIRSTNAME: '', LASTNAME: '' };
		Session.setStream('beehome');
		Session.pageTitle = 'ACCOUNT DETAILS';

		$scope.assignAccount = function(account) {
			$http
				.post(SETTINGS.APIBasePath + 'product/link', {
					data: { clientID: account.id, houseID: $scope.house.ID }
				})
				.then(function() {
					$location.path('/' + Session.stream + '/account/' + account.id);
				});
		};

		$scope.addCustomer = function(ev) {
			$mdDialog
				.show({
					controller: 'AccountSummaryModalCtrl',
					controllerAs: 'ctrl',
					templateUrl: 'views/account-modal.html',
					targetEvent: ev,
					parent: angular.element(document.body),
					locals: {
						client: null
					},
					resolve: {
						organisations: function(AllOrganisations) {
							return AllOrganisations();
						},
						certifications: function(certificationFactory) {
							return certificationFactory.getCertifications();
						}
					},
					clickOutsideToClose: true
				})
				.then(function(data) {
					if (data) {
						$http
							.post(SETTINGS.APIBasePath + 'product/link', {
								data: { clientID: data.client.id, houseID: $scope.house.ID }
							})
							.then(
								function() {
									$location.path('/beehome/account/' + data.client.id);
								},
								function() {}
							);
					}
				})
				.finally(function() {
					Session.modalOpen = false;
				});
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.codeIdentifier
 * @description
 * # codeIdentifier
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('codeIdentifier', function() {
	var codeTypes = [
		{
			pre: 'DL-',
			type: 'Delivery Note',
			gType: '',
			position: 0,
			removePre: true,
			dbColumnName: 'DELIVERY_ID'
		},
		{
			pre: 'F',
			type: 'Check In',
			gType: '',
			position: 2,
			removePre: true,
			dbColumnName: 'Unknown - Please Confirm'
		},
		{
			pre: 'CA',
			type: 'Outer Case',
			gType: 'aussenkiste',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_CA'
		},
		{
			pre: 'NB',
			type: 'Nesting Box',
			gType: 'innenbox',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_NB'
		},
		{
			pre: 'IN',
			type: 'Population',
			gType: 'population',
			position: 2,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		{
			pre: 'A',
			type: 'Population',
			gType: 'population',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		// {pre:"DE", type:"Population", gType: 'population', position:3, removePre:false, dbColumnName:"CODE_POP"}
		{
			pre: 'X',
			type: 'Population',
			gType: 'population',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		{
			pre: 'PP',
			type: 'Population',
			gType: 'population',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		{
			pre: 'PO',
			type: 'Population',
			gType: 'population',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		{
			pre: 'BC',
			type: 'Population',
			gType: 'population',
			position: 0,
			removePre: false,
			dbColumnName: 'CODE_POP'
		},
		{
			pre: 'BB',
			type: 'Bee Breeder',
			gType: '',
			position: 0,
			removePre: false,
			dbColumnName: ''
		}

		// {pre:"M", type:"Check In", gType: '', position:2, removePre:true, dbColumnName:"Unknown - Please Confirm"},
		// {pre:"O", type:"Check In", gType: '', position:2, removePre:true, dbColumnName:"Unknown - Please Confirm"},
		// {pre:"F", type:"Check In", gType: '', position:2, removePre:true, dbColumnName:"Unknown - Please Confirm"},
	];

	return function(code, index) {
		var scanCode = { status: 'error', response: 'Invalid Code' };
		if (index != null) {
			var cdType = codeTypes[index];
			if (code.indexOf(cdType.pre) == cdType.position) {
				var responseValue = cdType.removePre
					? code.substr(cdType.pre.length)
					: code;
				scanCode = {
					status: 'success',
					response: responseValue,
					dbColumn: cdType.dbColumnName
				};
			}
		} else {
			for (var i = 1; i < codeTypes.length; i++) {
				// eslint-disable-next-line no-redeclare
				var cdType = codeTypes[i];
				if (code.indexOf(cdType.pre) == cdType.position) {
					scanCode = {
						status: 'success',
						type: cdType.gType,
						response: cdType.removePre ? code.substr(cdType.pre.length) : code,
						dbColumn: cdType.dbColumnName
					};
					break;
				}
				// }
				// catch(err)
				// {
				//   break;
				// }
			}
		}
		return scanCode;
	};
});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:inputFields
 * @description
 * # inputFields
 */
angular
	.module('wildBieneHarvestApp')
	.directive('inputFields', function() {
		return {
			template: '<div></div>',
			restrict: 'E',
			link: function postLink(scope, element) {
				element.text('this is the inputFields directive');
			}
		};
	})
	.directive('capitalize', function() {
		return {
			require: 'ngModel',
			link: function(scope, element, attrs, modelCtrl) {
				var capitalize = function(inputValue) {
					if (inputValue == undefined) inputValue = '';
					var capitalized = inputValue.toUpperCase();
					if (capitalized !== inputValue) {
						// see where the cursor is before the update so that we can set it back
						var selection = element[0].selectionStart;
						modelCtrl.$setViewValue(capitalized);
						modelCtrl.$render();
						// set back the cursor after rendering
						element[0].selectionStart = selection;
						element[0].selectionEnd = selection;
					}
					return capitalized;
				};
				modelCtrl.$parsers.push(capitalize);
				capitalize(scope[attrs.ngModel]); // capitalize initial value
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:keepWidth
 * @description
 * # keepWidth
 */
angular.module('wildBieneHarvestApp').directive('keepWidth', function() {
	return function(scope, element, attrs) {
		var width = element.prop('offsetWidth');

		attrs.$set('style', 'width: ' + width + 'px;');
	};
});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.coverter
 * @description
 * # converter
 * Factory in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('converter', function() {
	this.b64toBlob = function(b64Data, contentType, sliceSize) {
		contentType = contentType || '';
		sliceSize = sliceSize || 512;

		var byteCharacters = atob(b64Data);
		var byteArrays = [];

		for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			var slice = byteCharacters.slice(offset, offset + sliceSize);

			var byteNumbers = new Array(slice.length);
			for (var i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, {
			type: contentType
		});
		return blob;
	};
});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:SnapshotmodalCtrl
 * @description
 * # SnapshotmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('SnapshotmodalCtrl', function(
		$scope,
		$mdDialog,
		$timeout,
		$log,
		$http,
		SETTINGS,
		Session,
		activeProduct,
		mailInformation
	) {
		$scope.picture = false;
		$scope.display_camera = false;
		$scope.imagesArray = [];
		$scope.activeProduct = activeProduct;
		$scope.config = {
			delay: 0,
			shots: 1,
			mirrorImage: 0,
			viewerWidth: '960',
			viewerHeight: '540',
			outputWidth: 1920,
			outputHeight: 1080,
			cropWidth: 1080,
			cropHeight: 1080,
			resolutionFallback: {
				// Fall back to this resolution if loading full res fails
				outputWidth: 1280,
				outputHeight: 720,
				cropWidth: 720,
				cropHeight: 720
			},
			jpeg_quality: 95,
			flip_horiz: false,
			flashFallbackUrl: 'bower_components/webcamjs/webcam.swf',
			upload_name: 'houseImage',
			shutterUrl: 'images/shutter.mp3',
			flashNotDetectedText:
				'Your browser does not meet the minimum requirements for using the camera. ' +
				'Install ADOBE Flash player or use browsers (Google Chrome, Firefox or Edge)'
		};
		$scope.save = save;
		$scope.uploadImage = uploadImage;

		$scope.showButtons = false;
		$scope.captureButtonEnable = false;
		$scope.progress = 0;

		$scope.handleFileSelect = function(event) {
			const file = event.target.files[0];
			if (!file) return;

			// Validate file type
			if (!file.type.startsWith('image/')) {
				$log.error('Invalid file type. Please select an image.');
				return;
			}

			$scope.$root.showLoader = true;
			rotateAndScale(file, function(img) {
				$scope.$apply(function() {
					$scope.imagesArray.push(img.toDataURL());
					save();
				});
			});
		};

		$scope.onCaptureComplete = function(src) {
			$log.log('webcamController.onCaptureComplete : ', src);
			$scope.progress = 100;
			for (var i = src.length - 1; i >= 0; i--) {
				$scope.imagesArray.push(src[i]);
			}
			$scope.inProgress = false;
			$scope.off();
			$timeout(
				// $scope.on()
				$scope.save(),
				1000
			);
		};
		$scope.onError = function(err) {
			$log.error('webcamController.onError : ', err);
			$scope.showButtons = false;
		};
		$scope.onLoad = function() {
			$scope.showButtons = true;
		};
		$scope.onLive = function() {
			$scope.captureButtonEnable = true;
		};
		$scope.onCaptureProgress = function(src, progress) {
			$scope.progress = progress;
			var result = {
				src: src,
				progress: progress
			};
			var el = document.getElementById('result');
			var img = document.createElement('img');
			img.src = src;
			img.width = 240;
			//img.height = 160;
			img.jpeg_quality = 100;
			el.appendChild(img);
			$log.info('webcamController.onCaptureProgress : ', result);
		};

		$scope.capture = function() {
			$scope.progress = 0;
			$scope.inProgress = true;
			$scope.$broadcast('ngWebcam_capture');
		};

		$scope.on = function() {
			$scope.$broadcast('ngWebcam_on');
		};
		$scope.off = function() {
			$scope.$broadcast('ngWebcam_off');
			$scope.captureButtonEnable = false;
		};

		function save() {
			$scope.$root.showLoader = true;
			var saveData = $scope.activeProduct;
			saveData.images = $scope.imagesArray;
			saveData.productCode = $scope.activeProduct.PROD_ID;
			saveData.houseID = $scope.activeProduct.houseCode
				? $scope.activeProduct.houseCode
				: $scope.activeProduct.ID;
			saveData.productName = $scope.activeProduct.PROD_NAME;
			saveData.trackTypeID = 1;
			saveData.season = Session.harvestSeason;
			saveData.email = mailInformation;
			if (mailInformation && mailInformation.language) {
				saveData.language = mailInformation.language;
			}

			$http
				.post(SETTINGS.APIBasePath + 'upload/image', {
					data: saveData
				})
				.then(function() {
					$scope.$root.showLoader = false;
					$mdDialog.hide();
				});
		}

		/**
		 * Upload file image from local machine rather than webcam snapshot
		 * Get file returned from ng-file-upload, rotate and scale then save to upload.
		 * @param file
		 */
		function uploadImage(file) {
			$scope.$root.showLoader = true;
			rotateAndScale(file, function(img) {
				$scope.imagesArray.push(img.toDataURL());
				save();
			});
		}

		/**
		 * Use the loadImage library to parse the EXIF orientation tag, rotate and scale,
		 * then pass the final image to the callback method
		 * https://stackoverflow.com/a/27206241
		 * @param evt
		 */
		function rotateAndScale(file, callback) {
			var options = {
				maxHeight: 1080,
				canvas: true
			};

			// eslint-disable-next-line no-undef
			loadImage.parseMetaData(file, function(data) {
				if (data.exif) {
					options.orientation = data.exif.get('Orientation');
				}
				// eslint-disable-next-line no-undef
				loadImage(file, callback, options);
			});
		}

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ClientNotesModalCtrl
 * @description
 * # ClientNotesModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ClientNotesModalCtrl', function(
		$scope,
		$mdDialog,
		clientID,
		clientProducts,
		activeCode
	) {
		$scope.clientID = clientID;
		$scope.clientProducts = clientProducts;
		$scope.activeCode = activeCode;

		$scope.close = function() {
			$mdDialog.hide();
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:customTable
 * @description
 * # customTable
 */
angular.module('wildBieneHarvestApp').directive('customTable', function() {
	return {
		restrict: 'A',
		scope: true,
		link: function(scope, el, attrs) {
			var modelName = attrs.modelName;

			scope.selectedTableItem = {};
			scope.editTableItemEnabled = {};
			scope.editTableItemText = { rates: 'test' };
			scope.deleteTableItemEnabled = {};
			scope.deleteTableItemText = {};
			scope.addTableItemEnabled = {};
			scope.addTableItemText = {};
			scope.addNewTableItemEnabled = {};
			scope.activeTable = {};

			scope.init = function() {
				scope.editTableItemEnabled[modelName] = false;
				scope.deleteTableItemEnabled[modelName] = false;
				scope.addTableItemEnabled[modelName] = true;
				scope.addNewTableItemEnabled[modelName] = false;
				scope.editTableItemText[modelName] = 'Edit';
				scope.addTableItemText[modelName] = 'Add';
				scope.deleteTableItemText[modelName] = 'Delete';
				scope.activeTable[modelName] = {};
			};

			scope.init();

			scope.selectTableItem = function(selectedKey) {
				if (scope.selectedTableItem[modelName].select[selectedKey]) {
					scope.disableAllCheckboxes(selectedKey);
					// set edit/delete buttons
					scope.editTableItemEnabled[modelName] = true;
					scope.editTableItemText[modelName] = 'Edit';
					scope.deleteTableItemEnabled[modelName] = true;
					// reset add button and hide new item inputs
					scope.addNewTableItemEnabled[modelName] = false;
					scope.addTableItemEnabled[modelName] = false;
					scope.addTableItemText[modelName] = 'Add';
				} else {
					scope.addTableItemEnabled[modelName] = true;
					scope.editTableItemEnabled[modelName] = false;
					scope.deleteTableItemEnabled[modelName] = false;
				}
				scope.activeTable[modelName][selectedKey] = '';
			};

			scope.disableAllCheckboxes = function(selectedKey) {
				var selectBoxes = scope.selectedTableItem[modelName];
				if (typeof selectBoxes !== 'undefined') {
					angular.forEach(selectBoxes.select, function(value, key) {
						scope.selectedTableItem[modelName].select[key] = false;
						scope.activeTable[modelName][key] = '';
					});
					if (selectedKey !== null) {
						scope.selectedTableItem[modelName].select[selectedKey] = true;
					}
				}
			};

			scope.addTableItem = function() {
				var data = {};
				if (scope.addNewTableItemEnabled[modelName] === true) {
					data = scope.prepareData(
						$('div[data-model-name="' + modelName + '"] .add-table-item td'),
						data
					);
					scope.addCustomTableItems(data, modelName);
					scope.addTableItemText[modelName] = 'Add';
				} else {
					scope.addTableItemText[modelName] = 'Save new item 2';
				}
				scope.addNewTableItemEnabled[modelName] = !scope.addNewTableItemEnabled[
					modelName
				];
				scope.disableAllCheckboxes(null);
			};

			scope.cancelAddTableItem = function() {
				scope.addTableItemText[modelName] = 'Add';
				scope.addNewTableItemEnabled[modelName] = false;
				scope.disableAllCheckboxes(null);
			};

			scope.prepareData = function(element, data) {
				$.each(element, function() {
					var elem = $(this).find('input, select');
					if (elem.data('key') !== 'undefined') {
						data[elem.data('key')] = elem.val();
					}
				});
				return data;
			};

			scope.editTableItem = function() {
				var selectBoxes = scope.selectedTableItem[modelName].select;
				var data = {};

				angular.forEach(selectBoxes, function(value, key) {
					if (value) {
						if (scope.activeTable[modelName][key] == 'active') {
							data = scope.prepareData(
								$(
									'div[data-model-name="' + modelName + '"] .table-item-' + key + ' td'
								),
								data
							);
							data.index = key;
							scope.saveCustomTableItems(data, modelName);
							scope.disableAllCheckboxes(null);

							scope.activeTable[modelName][key] = '';
							scope.editTableItemText[modelName] = 'Edit';
							scope.editTableItemEnabled[modelName] = false;
							scope.deleteTableItemEnabled[modelName] = false;
							scope.addTableItemEnabled[modelName] = true;
						} else {
							scope.activeTable[modelName][key] = 'active';
							scope.editTableItemText[modelName] = 'Save';
						}
					}
				});
			};

			scope.deleteTableItem = function() {
				var selectBoxes = scope.selectedTableItem[modelName].select;
				var data = {};

				angular.forEach(selectBoxes, function(value, key) {
					if (value) {
						data = scope.prepareData(
							$('div[data-model-name="' + modelName + '"] .table-item-' + key + ' td'),
							data
						);
						data.index = key;
						scope.deleteCustomTableItems(data, modelName);
						scope.disableAllCheckboxes(null);

						scope.activeTable[modelName][key] = '';
						scope.editTableItemText[modelName] = 'Edit';
						scope.editTableItemEnabled[modelName] = false;
						scope.deleteTableItemEnabled[modelName] = false;
						scope.addTableItemEnabled[modelName] = true;
					}
				});
			};
		}
	};
});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ManagementstatisticsCtrl
 * @description
 * # ManagementstatisticsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ManagementstatisticsCtrl', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		Session
	) {
		Session.setStream('management');
		Session.pageTitle = 'Statistics';

		$scope.selectedOrganisation = 0;
		$scope.organisations = [];
		$scope.statisticsData = [];
		$scope.totalData = [];

		$http.get(SETTINGS.APIBasePath + 'organisations').then(function(response) {
			$scope.organisations.push({ ID: 0, NAME: '-- All organisations --' });
			for (var i = 0; i < response.data.length; i++) {
				$scope.organisations.push(response.data[i]);
			}
		});

		Session.getManagementSeason().then(function(response) {
			var today = new Date();
			$scope.seasons = [
				today.getFullYear(),
				today.getFullYear() - 1,
				today.getFullYear() - 2,
				today.getFullYear() - 3,
				today.getFullYear() - 4
			];
			$scope.defaultSeason = response;
		});

		$scope.getStatistics = function(selectedOrganisation, selectedSeasons) {
			if (selectedSeasons && selectedSeasons.length > 0) {
				selectedOrganisation = selectedOrganisation ? selectedOrganisation : 0;
				selectedSeasons = selectedSeasons
					? selectedSeasons
					: [$scope.defaultSeason];
				$http
					.post(SETTINGS.APIBasePath + 'management/statistics', {
						seasons: selectedSeasons,
						organisationId: selectedOrganisation
					})
					.then(function(res) {
						$scope.statisticsData = res.data.data;
						$scope.totalData = res.data.total;
					});
			}
		};

		// add thousands separator
		$scope.addSeparator = function(value) {
			if (value == null) {
				return 0;
			}
			value += '';
			var x = value.split('.');
			var x1 = x[0];
			var x2 = x.length > 1 ? '.' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + "'" + '$2');
			}
			return x1 + x2;
		};

		$scope.showRomSum = function(organisationIndex, fridgeIndex, insectIndex) {
			return insectIndex === 2;
		};

		// todo: excel download
		//$scope.exportData = [['BOX_CNT', 'CODE',  'COUNTRY_ID',  'FRIDGE_CD', 'INSCT_COUNT', 'INSCT_NAME', 'LOCATION', 'POPULATIONS_COUNT', 'START_POP_BOX_AMOUNT']];
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ManagementlogsCtrl
 * @description
 * # ManagementlogsCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ManagementlogsCtrl', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		Session,
		users,
		userService
	) {
		Session.setStream('management');
		Session.pageTitle = 'Logs';
		$scope.users = users;

		$scope.$exttable = [];

		$scope.logsColumns = [
			{ data: 'CREATED' },
			{ data: 'XFER_STAT_ID' },
			{ data: 'TYPE' },
			{ data: 'CODE' },
			{ data: 'LOCATION' },
			{ data: 'UPD_BY', searchable: false, userId: true }
		];

		$scope.searchString = '';

		$scope.search = function(searchString) {
			if (searchString === null || searchString === '') {
				$scope.loadData('null');
			} else {
				$scope.loadData(searchString);
			}
		};

		$scope.loadData = function(searchTerm) {
			// First search users
			userService.search(searchTerm).then(function(users) {
				// Create search object to pass to logs endpoint,
				// Pass the original search term plus list of users ids
				var searchObj = {
					search: searchTerm,
					userIds: Object.keys(users)
				};

				// Hit search endpoint
				$http
					.post(SETTINGS.APIBasePath + 'logs/search', searchObj)
					.then(function(result) {
						$scope.$exttable.logs.rows().remove();
						$scope.$exttable.logs.rows.add(result.data).draw();
					});
			});
		};

		$scope.search('');
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:fridgeContentSummary
 * @description
 * # fridgeContentSummary
 */
angular
	.module('wildBieneHarvestApp')
	.directive('fridgeContentSummary', function(
		$mdDialog,
		$state,
		FridgeContentLoader,
		FridgeBoxesSummary,
		FridgeStartpopsSummary,
		Fridge,
		Session
	) {
		return {
			scope: {
				fridge: '=fridge'
			},
			templateUrl: 'views/fridge-content-summary.html',
			link: function(scope) {
				scope.content = null;
				FridgeContentLoader.get(
					{ id: scope.fridge.ID, season: Session.managementSeason },
					function(res) {
						scope.content = res.data;
						scope.boxContentSummary = res.data.reduce(function(total, val) {
							return total + Number(val.BOX_CNT);
						}, 0);
						scope.startpopContentSummary = res.data.reduce(function(total, val) {
							return total + Number(val.STARTPOP_CNT);
						}, 0);
					}
				);

				scope.boxesSummary = null;
				FridgeBoxesSummary.get(
					{ id: scope.fridge.ID, season: Session.managementSeason },
					function(res) {
						scope.boxesSummary = res.data;
						scope.boxContentSummary2 = res.data.reduce(function(total, val) {
							return total + Number(val.BOX_CNT);
						}, 0);
					}
				);

				scope.startpopsSummary = null;
				FridgeStartpopsSummary.get(
					{ id: scope.fridge.ID, season: Session.managementSeason },
					function(res) {
						scope.startpopsSummary = res.data;
						scope.startpopContentSummary2 = res.data.reduce(function(total, val) {
							return total + Number(val.STARTPOP_CNT);
						}, 0);
					}
				);
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:CreateboxesfridgemodalCtrl
 * @description
 * # CreateboxesfridgemodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('CreateboxesfridgemodalCtrl', function(
		$scope,
		$mdDialog,
		SETTINGS,
		NotifyUser,
		Fridge
	) {
		$scope.validFridgeCode = false;

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			$mdDialog.hide($scope.checkInFridge);
		};
		$scope.findFridge = function() {
			Fridge.get(
				{
					id: $scope.checkInFridgeCode
				},
				function(result) {
					if (result.fridge) {
						$scope.validFridgeCode = true;
						$scope.checkInFridge = result.fridge;
					} else {
						$scope.checkInFridge = null;
						$scope.checkInFridgeCode = '';
						$scope.validFridgeCode = false;
						NotifyUser(
							'Code not found. Please create a new fridge or scan an existing one.'
						);
					}
				}
			);
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:SalesProductsPackagingModalCtrl
 * @description
 * # SalesProductsPackagingModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('SalesProductsPackagingModalCtrl', function(
		$http,
		$scope,
		$mdDialog,
		SETTINGS,
		packageItem,
		action,
		NotifyUser
	) {
		$scope.package = packageItem;
		$scope.action = action;
		$scope.salesPackages = {};
		$scope.salesProducts = {};

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$http.get(SETTINGS.APIBasePath + 'organisations').then(function(result) {
			$scope.organisations = result.data;
		});

		$scope.getSalesPackagesMap = function() {
			$http
				.get(
					SETTINGS.APIBasePath + 'packages/sales-package-map/' + $scope.package.ID
				)
				.then(function(result) {
					$scope.salesPackages = result.data;
					$scope.getSalesProducts();
				});
		};

		$scope.getSalesProducts = function() {
			$http
				.get(SETTINGS.APIBasePath + 'sales-products/search/')
				.then(function(result) {
					$scope.salesProducts = result.data;
				});
		};

		if ($scope.package != null) {
			$scope.getSalesPackagesMap();
		}

		$scope.savePackage = function() {
			$http
				.post(SETTINGS.APIBasePath + 'packages/update', $scope.package)
				.then(function() {
					$mdDialog.hide();
					typeof $scope.package.ID == 'undefined'
						? NotifyUser('Product was added.')
						: NotifyUser('Product was updated.');
				});
		};

		$scope.saveCustomTableItems = function(data) {
			$scope.saveSalesProductsMapping(
				data,
				'Connected sales product was updated.'
			);
		};

		$scope.addCustomTableItems = function(data) {
			$scope.saveSalesProductsMapping(data, 'Connected sales product was saved.');
		};

		$scope.deleteCustomTableItems = function(data) {
			$scope.deleteSalesProductsMapping(data, 'Item was deleted.');
		};

		$scope.saveSalesProductsMapping = function(data, message) {
			$http
				.post(SETTINGS.APIBasePath + 'packages/save-sales-package-map', data)
				.then(function() {
					NotifyUser(message);
					$scope.getSalesPackagesMap();
				});
		};

		$scope.deleteSalesProductsMapping = function(data, message) {
			$http
				.delete(
					SETTINGS.APIBasePath + '/packages/save-sales-package-map/' + data['ID']
				)
				.then(function() {
					NotifyUser(message);
					$scope.getSalesPackagesMap();
				});
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:OrderculturesmodalCtrl
 * @description
 * # OrderculturesmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('OrderCulturesModalCtrl', function(
		$scope,
		$mdDialog,
		$http,
		SETTINGS,
		$state,
		Session,
		order,
		customer,
		CustomerLoader,
		ConfirmUser
	) {
		$scope.cultureOrderItems = [];
		$scope.formErrors = [];

		/**
		 * Initial
		 * Get all products from orderItems array
		 */
		$scope.loadCultures = function() {
			$scope.cultureOrderItems = order.orderItems.filter(function(orderItem) {
				return parseInt(orderItem.positionType) === 1;
			});
			$scope.changeStringToNumber($scope.cultureOrderItems);
		};

		/**
		 * Change cultures order amount to number, because input type number cannot be string
		 * @param orderItems
		 */
		$scope.changeStringToNumber = function(orderItems) {
			orderItems.forEach(function(orderItem, orderItemIndex) {
				orderItem.cultures.forEach(function(cultureItem, cultureItemIndex) {
					$scope.cultureOrderItems[orderItemIndex].cultures[
						cultureItemIndex
					].amount = parseFloat(cultureItem.amount);
				});
			});
		};

		/**
		 * Summarize all culture order amounts of culture order item and don't allow set
		 * more than units on order item
		 * @param cultureOrderItemIndex
		 */
		$scope.checkMax = function(cultureOrderItemIndex) {
			var maxValue = 0;
			$scope.cultureOrderItems[cultureOrderItemIndex].cultures.forEach(function(
				culture
			) {
				maxValue += culture.amount;
			});

			var finalValue =
				$scope.cultureOrderItems[cultureOrderItemIndex].amount - maxValue;

			$scope.getFormControls('cultureItemForm').forEach(function(value) {
				if (value.$name === 'order_amount_' + cultureOrderItemIndex) {
					$scope.setFormControlAsInvalid(value, finalValue < 0 || finalValue > 0);
				}
			});

			$scope.setFormError(cultureOrderItemIndex, finalValue);
		};

		/**
		 * Show error if sum amounts of culture items is not equal to order item amount
		 * @param {{number}} cultureOrderItemIndex
		 * @param {{number}} finalValue
		 */
		$scope.setFormError = function(cultureOrderItemIndex, finalValue) {
			if (finalValue < 0) {
				$scope.formErrors[cultureOrderItemIndex] =
					'Sum of culture items amount is bigger than order item amount';
			} else if (finalValue > 0) {
				$scope.formErrors[cultureOrderItemIndex] =
					'Sum of culture items amount is less than order item amount';
			} else {
				$scope.formErrors[cultureOrderItemIndex] = null;
			}
		};

		/**
		 * Get controls from Form
		 * @param {{string}} formName
		 */
		$scope.getFormControls = function(formName) {
			return $scope[formName].$$controls;
		};

		/**
		 * Set form control as valid, or invalid
		 * @param formControl
		 * @param {boolean} valid
		 */
		$scope.setFormControlAsInvalid = function(formControl, valid) {
			formControl.$valid = !valid;
			formControl.$invalid = !!valid;
			formControl.$touched = !!valid;
		};

		/**
		 * Reload customer data
		 * @param res
		 */
		$scope.reloadCustomer = function(res) {
			if (res) {
				CustomerLoader(res.client.id).then(function(newClient) {
					customer = newClient;
				});
			} else {
				CustomerLoader(customer.id).then(function(newClient) {
					customer = newClient;
				});
			}
			$state.reload();
		};

		/**
		 * Delete culture and reload customer after that
		 * @param cultureID
		 */
		function confirmedDelete(cultureID) {
			$http.delete(SETTINGS.APIBasePath + 'culture/' + cultureID).then(function() {
				for (var i = 0; i < customer.cultures.length; i++) {
					if (parseInt(customer.cultures[i].ID) === parseInt(cultureID)) {
						customer.cultures.splice(i, 1);
						$scope.reloadCustomer();
					}
				}
			});
		}

		/**
		 * Delete culture by ID
		 * @param cultureID
		 */
		$scope.deleteCulture = function(cultureID) {
			ConfirmUser(
				'Deleting Culture',
				'Are you sure you wish to continue? ',
				confirmedDelete(cultureID)
			);
		};

		/**
		 * Check if save button can be active
		 * @returns {boolean}
		 */
		$scope.checkSaveButton = function() {
			var orderItemUnits = 0;
			var culturesUnits = 0;

			$scope.cultureOrderItems.forEach(function(orderItemValue) {
				orderItemUnits += parseInt(orderItemValue.amount);
				orderItemValue.cultures.forEach(function(cultureValue) {
					culturesUnits += parseInt(cultureValue.amount);
				});
			});
			return orderItemUnits === culturesUnits;
		};

		$scope.getText = function(cultureOrderItem) {
			if (cultureOrderItem.text !== null && cultureOrderItem.text !== '') {
				return cultureOrderItem.text;
			}
			return cultureOrderItem.productName;
		};

		$scope.loadCultures();

		$scope.save = function() {
			$http
				.post(SETTINGS.APIBasePath + 'culture-items', {
					data: $scope.cultureOrderItems
				})
				.then(function() {
					$mdDialog.hide();
				});
		};

		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.printerService
 * @description
 * # printerService
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('printerService', function(
		Session,
		selectPhrasesService,
		$http,
		SETTINGS,
		$filter,
		$q,
		$timeout,
		languageFactory,
		AddressFactory,
		ContactFactory
	) {
		// AngularJS will instantiate a singleton by calling "new" on this function

		return function(type, toPrint, farmer, silent) {
			var delay = $q.defer();
			var dataArray = {};

			var phrases_array = Session.allPhrases;
			if (phrases_array) {
				Session.getAllPhrases();
				$timeout(function() {
					phrases_array = Session.allPhrases;
				}, 100);
			}

			switch (type) {
				case 'multipleDeliveries':
				case 'checklist':
				case 'qrCodeBox':
				case 'qrCode':
					dataArray = {
						data: toPrint,
						type: type
					};
					printPDF(dataArray, silent).then(delay.resolve, delay.reject);
					break;
				default:
					var billingContact = ContactFactory.getBillingContact(farmer.contacts);
					var languageId = 1;
					languageFactory
						.getLanguage(billingContact.language)
						.then(function(result) {
							languageId = result.ID;
						})
						.finally(function() {
							var farmerAddress = AddressFactory.getBillingAddress(farmer.addresses);

							farmer.ADDRESS1 = farmerAddress.address_1;
							farmer.ADDRESS2 = farmerAddress.address_2;
							farmer.TOWN = farmerAddress.town;
							farmer.COMPANY = farmerAddress.company_name;
							farmer.COUNTRY = farmerAddress.country_code;
							farmer.FIRSTNAME = farmerAddress.first_name;
							farmer.ID = farmer.id;
							farmer.LANG_ID = languageId;
							farmer.LASTNAME = farmerAddress.last_name;
							farmer.OWNER_ID = farmer.organisation.id;
							farmer.POSTAL_CD = farmerAddress.postal_code;

							dataArray = {
								data: toPrint,
								phrases: selectPhrasesService.phrases(
									phrases_array,
									languageId,
									farmer.organisation.id,
									$filter('titleCase')(type)
								).phraseList,
								type: type,
								farmer: farmer
							};
							printPDF(dataArray, silent).then(delay.resolve, delay.reject);
						});
					break;
			}
			return delay.promise;
		};

		function printPDF(dataArray, silent) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'pdf/print', dataArray, {
					responseType: 'blob'
				})
				.then(
					function(response) {
						delay.resolve(response.data);
						if (!silent) {
							const url = window.URL.createObjectURL(response.data);
							window.open(url);
							setTimeout(() => window.URL.revokeObjectURL(url), 100);
						}
					},
					function() {
						delay.reject('unable to print document');
					}
				);
			return delay.promise;
		}
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:MailmodalCtrl
 * @description
 * # MailmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('MailmodalCtrl', function(
		$scope,
		$http,
		$mdDialog,
		SETTINGS,
		farmer,
		docType,
		pdfLink,
		order,
		fileName,
		body,
		subject
	) {
		$scope.farmer = farmer;
		$scope.email = farmer.MAIL;
		$scope.subject = subject;
		$scope.bodytext = body;
		$scope.pdfLink = pdfLink;
		$scope.order = order;
		var sent = false;

		$scope.send = function() {
			$scope.$root.showLoader = true;
			if (!sent) {
				sent = true;
				var from = 'info@pollinature.ch';
				var template = '1-wildbiene-partner-ag';

				switch ($scope.farmer.OWNER_ID) {
					case '1':
						from = 'info@pollinature.ch';
						template = '1-wildbiene-partner-ag';
						if (docType == 'offer') {
							template = '1-wildbiene-partner-ag';
						}
						break;
					case '2':
						template = '2-ufa-to-be-approved';
						break;
					case '3':
						from = 'info@pollinature.de';
						template = '3-pollinature-gmbh';
						break;
					case '4':
						from = 'info@pollinature.it';
						template = '4-pollinature-srl';
						break;
					case '5':
						from = 'info@pollinature.ch';
						template = '5-beesharing-to-be-approved';
						break;
					case '6':
						from = 'info@pollinature.fr';
						template = '8-pollinature-sas';
						break;
					case '8':
						from = 'info@pollinature.fr';
						template = '8-pollinature-sas';
						break;

					default:
						break;
				}

				var info = {
					data: {
						fileName: fileName,
						pdfLink: pdfLink,
						language: $scope.farmer.LANG_ID,
						email: $scope.email,
						name: $scope.farmer.FIRSTNAME + ' ' + $scope.farmer.LASTNAME,
						subject: $scope.subject,
						bodytext: $scope.bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>'),
						from: from,
						template: template,
						order: $scope.order
					}
				};
				if (docType == 'offer') {
					info.data.label = 'Approve Offer';
					info.data.link = 'https://google.com';
				}
				$http.post(SETTINGS.APIBasePath + 'mail/document', info).then(function() {
					$scope.$root.showLoader = false;
					$mdDialog.hide();
				});
			}
		};
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:HistorymodalCtrl
 * @description
 * # HistorymodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('HistorymodalCtrl', function(
		$scope,
		$timeout,
		$http,
		$mdDialog,
		SETTINGS,
		type,
		id,
		users
	) {
		$scope.type = type;
		$scope.id = id;
		$scope.data = [];
		$scope.users = users;

		$scope.cancel = function() {
			$mdDialog.cancel();
		};

		$timeout(function() {
			$scope.getData();
		});

		if ($scope.type === 'customer') {
			$scope.tableOrderColNumber = 3;
		} else {
			$scope.tableOrderColNumber = 4;
		}

		$scope.getData = function() {
			$http.get($scope.getUrl() + $scope.id).then(function(result) {
				console.log('data', result.data);
				$scope.data = result.data.sort(
					(a, b) => new Date(b.SYS_VALID_FROM) - new Date(a.SYS_VALID_FROM)
				);
			});
		};

		$scope.getUrl = function() {
			var url = '';
			if ($scope.type === 'customer') {
				url = 'history/customer/';
			} else {
				url = 'history/house/';
			}
			return SETTINGS.APIBasePath + url;
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:tree
 * @description
 * # tree
 */
angular.module('wildBieneHarvestApp').directive('tree', function(treeHelper) {
	return {
		scope: {
			elem: '=',
			rights: '='
		},
		templateUrl: 'views/tree.html',
		link: function(scope) {
			scope.rowClickListener = function(elem) {
				if (elem.children !== undefined && elem.children.length) {
					elem.open = !elem.open;
				} else {
					elem.enabled = !elem.enabled;
				}
			};

			scope.bubbleEvent = function(elem) {
				bubbleEvent(elem, scope.rights);

				for (var i in scope.rights) {
					if (typeof scope.rights[i] === 'object') {
						scope.rights[i].enabled = treeHelper.validateTree(scope.rights[i]);
					}
				}
			};

			function bubbleEvent(elem, rights) {
				for (var i in rights) {
					if (rights[i].children !== undefined && rights[i].children.length) {
						if (elem.ID == rights[i].ID) {
							if (elem.enabled == true) {
								elem.open = elem.enabled;
							}

							updateStatus(elem.enabled, rights[i].children);
						} else {
							bubbleEvent(elem, rights[i].children);
						}
					}
				}
			}

			function updateStatus(status, rights) {
				for (var i in rights) {
					rights[i].enabled = status;

					if (status == true) {
						rights[i].open = status;
					}

					if (rights[i].children !== undefined && rights[i].children.length) {
						updateStatus(status, rights[i].children);
					}
				}
			}
		}
	};
});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.treeHelper
 * @description
 * # treeHelper
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('treeHelper', function() {
	this.validateTree = function(right) {
		if (right.children === undefined || !right.children.length) {
			return right.enabled;
		}

		var selected = false;

		for (var i in right.children) {
			right.children[i].enabled =
				this.validateTree(right.children[i]) || right.children[i].enabled;
			selected = right.children[i].enabled || selected;
		}

		return selected;
	};
});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.Statuses
 * @description
 * # Statuses
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('Statuses', [
	'$http',
	'SETTINGS',
	'$q',
	function($http, SETTINGS, $q) {
		this.getAll = function() {
			var delay = $q.defer();
			$http.get(SETTINGS.APIBasePath + 'statuses').then(function(response) {
				delay.resolve(response.data);
			});
			return delay.promise;
		};

		this.activeStatusMenu = function(activeOrder, status, fieldName) {
			if (activeOrder !== null && activeOrder !== undefined) {
				if (
					activeOrder[fieldName] === 'Order' ||
					activeOrder[fieldName] === 'Offer'
				) {
					if (status.DESCRIPTION === 'Draft') {
						return true;
					}
				}

				if (activeOrder[fieldName] === 'Draft') {
					if (status.DESCRIPTION === 'Open') {
						return true;
					}
				}

				if (activeOrder[fieldName] === 'Open') {
					if (
						status.DESCRIPTION === 'Draft' ||
						status.DESCRIPTION === 'Accepted' ||
						status.DESCRIPTION === 'Declined'
					) {
						return true;
					}
				}

				if (activeOrder[fieldName] === 'Accepted') {
					if (status.DESCRIPTION === 'Open' || status.DESCRIPTION === 'Cancelled') {
						return true;
					}
				}

				if (activeOrder[fieldName] === 'Declined') {
					if (status.DESCRIPTION === 'Open') {
						return true;
					}
				}

				if (activeOrder[fieldName] === 'Cancelled') {
					if (status.DESCRIPTION === 'Accepted') {
						return true;
					}
				}

				return false;
			}
		};
	}
]);

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BeehomeVoucherCtrl
 * @description
 * # BeehomeVoucherCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BeehomeVoucherCtrl', function(
		$interval,
		startpopSettings,
		$scope,
		$mdDialog,
		Session,
		StartpopVoucherUploadService,
		NotifyUser,
		houseService,
		organisations,
		users
	) {
		Session.pageTitle = 'BeeHome vouchers';
		Session.setStream('beehome');
		$scope.vouchers = [];
		$scope.selected = [];
		$scope.organisationId = Session.organisationID || 1;
		$scope.file = {};
		$scope.uploadData = [];
		$scope.voucherType = 'STARTPOP';
		$scope.organisations = organisations;
		$scope.users = users;
		$scope.query = {
			order: '-created_at',
			limit: 100,
			page: 1,
			limitOptions: [20, 50, 100]
		};
		$scope.uploadQuery = {
			limit: 100,
			page: 1,
			limitOptions: [100, 200, 500]
		};

		$scope.getVouchers = getVouchers;
		$scope.editVoucher = editVoucher;
		$scope.deleteVouchers = deleteVouchers;
		$scope.isValidForUpload = isValidForUpload;
		$scope.parseFile = parseFile;
		$scope.getUploadData = getUploadData;
		$scope.upload = upload;

		function getVouchers() {
			var params = {
				code: $scope.query.filter,
				page: $scope.query.page,
				per_page: $scope.query.limit,
				sort: $scope.query.order
			};
			$scope.promise = startpopSettings
				.getVoucherList(params)
				.then(function(data) {
					if (data.items) {
						angular.forEach(data.items, houseService.resolveHouse);
						$scope.vouchers = data.items;
						$scope.voucherCount = data.total_count;
						$scope.selected = [];
					}
					return true;
				});
		}

		function editVoucher(voucher) {
			$mdDialog
				.show({
					controller: 'BeehomeVoucherModalCtrl',
					templateUrl: 'views/beehome-voucher-modal.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					locals: {
						voucher: voucher,
						organisations: organisations,
						codes: null,
						findExisting: false
					}
				})
				.then(function() {
					$scope.getVouchers();
				});
		}

		function deleteVouchers() {
			var deleteDict = {};
			angular.forEach($scope.selected, function(voucher) {
				deleteDict[voucher.id] = voucher.code;
			});

			var confirm = $mdDialog
				.confirm({
					onComplete: function afterShowAnimation() {
						var $dialog = angular.element(document.querySelector('md-dialog'));
						var $actionsSection = $dialog.find('md-dialog-actions');
						var $cancelButton = $actionsSection.children()[0];
						angular.element($cancelButton).addClass('md-warn');
					}
				})
				.title('Deleting startpop vouchers')
				.textContent(
					"Are you sure you'd like to delete " + Object.values(deleteDict) + '?'
				)
				.ariaLabel('Confirm delete')
				.ok('Yes delete.')
				.cancel("No I'll think about it.");

			$mdDialog.show(confirm).then(function() {
				startpopSettings.deleteVouchers(Object.keys(deleteDict)).then(function() {
					$scope.getVouchers();
				});
			});
		}
		function parseFile(file) {
			resetForm();
			if (!file) {
				NotifyUser('Invalid file.');
			} else {
				$scope.file = file;
				StartpopVoucherUploadService.parse(file).then(getUploadData);
			}
		}

		function getUploadData() {
			StartpopVoucherUploadService.get($scope.uploadQuery).then(function(data) {
				$scope.uploadData = data.items;
				$scope.uploadDataCount = data.total_count;
			});
		}

		function upload() {
			if ($scope.voucherUploadForm.$valid && $scope.uploadData.length) {
				var interval = $interval(getUploadData, 1000);
				$scope.promise = StartpopVoucherUploadService.upload(
					$scope.voucherType,
					$scope.organisationId
				).then(function() {
					resetForm();
					getUploadData();
					getVouchers();
					$interval.cancel(interval);
				});
			}
		}

		function resetForm() {
			$scope.file = {};
		}

		function isValidForUpload() {
			return !!($scope.voucherUploadForm.$valid && $scope.file.name);
		}

		getVouchers();
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.shippingLabel
 * @description
 * # shippingLabel
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('shippingLabel', function($http, $q, SETTINGS, AlertUser) {
		// AngularJS will instantiate a singleton by calling "new" on this function
		return function(shippingData) {
			var delay = $q.defer();
			$http.post(SETTINGS.APIBasePath + 'swisspost/label', shippingData).then(
				function(result) {
					var returnValue;
					if (result.data.identityCode) {
						var pdfWindow = window.open('');
						pdfWindow.document.write(
							"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
								encodeURI(result.data.label) +
								"'></iframe>"
						);
						returnValue = { identityCode: result.data.identityCode };
					} else {
						var errorTitle = 'Error';
						var errorMsg = '';
						if (result.data.soapError) {
							errorTitle = result.data.soapError.faultstring;
							errorMsg = result.data.soapError.xdebug_message;
						} else {
							errorMsg = result.data.itemError;
						}
						AlertUser(errorTitle, errorMsg);
						returnValue = { Error: errorMsg };
					}
					delay.resolve(returnValue);
				},
				function(result) {
					AlertUser('Error', result.data.msg);
					delay.reject({ Error: result.data.msg });
				}
			);
			return delay.promise;
		};
	});

'use strict';

angular
	.module('wildBieneHarvestApp')
	.directive('beehomeVoucherSearch', function(
		$q,
		$mdDialog,
		codeValidator,
		houseService,
		startpopSettings
	) {
		return {
			templateUrl: 'views/beehome-voucher-search.html',
			scope: {
				ngModel: '<',
				selectedItemChange: '=',
				type: '@',
				organisationId: '<',
				pagination: '@'
			},
			link: function postLink(scope) {
				scope.search = search;
				scope.select = select;
				scope.submit = submit;

				// Cache search term and promise of the last performed search
				var last = {
					term: undefined,
					search: undefined
				};

				var modal = undefined;

				/**
				 * Search for items matching the search term.
				 */
				function search(term) {
					if (!term) {
						return $q.when([]);
					}
					if (term.toUpperCase().match(codeValidator.freeCareVoucherPattern)) {
						return $q.when([]);
					}
					if (term === last.term) {
						return last.search;
					}
					var search = startpopSettings
						.getVoucherList({ code: term, type: scope.type })
						.then(result => {
							if (!result.items.length) {
								return [];
							}
							angular.forEach(result.items, houseService.resolveHouse);
							return result.items;
						});
					last = {
						term: term,
						search: search
					};
					return search;
				}

				/**
				 * This function is triggered when the initial item is loaded or when a new item is selected/deselected.
				 * If its loading the the initial value do nothing.
				 * Otherwise validate the new record and if its valid blur the field to trigger a submit.
				 */
				function select(item) {
					if (isOriginal(item)) {
						return reset();
					}
					if (isValid(item) && item) {
						submit();
					}
				}

				/**
				 * On submit, i.e. when hitting enter or when blurring the field
				 * Do not search for the originally loaded record
				 * Otherwise make sure the search has run (but the cache is used)
				 * Once the search has run but no result has come back, then open the modal to create a new voucher
				 * Otherwise if records were returned, select the first one, then call the callback function.
				 */
				function submit() {
					if (scope.ngModel && scope.ngModel.code === scope.searchText) {
						return;
					}
					search(scope.searchText).then(result => {
						let item = result.length > 0 ? result[0] : null;
						if (scope.searchText && !item) {
							openModal(scope.searchText);
						} else if (isOriginal(item)) {
							reset();
						} else if (isValid(item)) {
							save(item);
						}
					});
				}

				/**
				 * Open the modal to create a new voucher, on save select the newly created voucher.
				 */
				function openModal(code) {
					if (modal) {
						return;
					}
					modal = true;
					$mdDialog
						.show({
							controller: 'BeehomeVoucherModalCtrl',
							templateUrl: 'views/beehome-voucher-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							resolve: {
								organisations: function(OrganisationFactory) {
									return OrganisationFactory.getMap();
								}
							},
							locals: {
								voucher: {
									type: scope.type,
									code: code.toUpperCase(),
									organisation_id: scope.organisation_id
								},
								codes: [],
								findExisting: false
							}
						})
						.then(save, angular.noop)
						.finally(() => {
							modal = false;
						});
				}

				/**
				 * Detect if the currently selected item is the originally loaded value.
				 */
				function isOriginal(item) {
					let new_id = item ? item.id : null;
					let current_id = scope.ngModel ? scope.ngModel.id : null;
					return new_id === current_id;
				}

				/**
				 * Run additional validations
				 */
				function isValid(item) {
					let valid = !(item && item.house_id);
					scope.form.autocomplete.$setValidity('alreadyUsed', valid);
					return valid;
				}

				/**
				 * Manually reset the form when a new record is loaded
				 */
				function reset() {
					scope.form.autocomplete.$setValidity('alreadyUsed', true);
					scope.form.$setPristine();
					scope.form.$setUntouched();
					scope.searchText = scope.selectedItem ? scope.selectedItem.code : null;
				}

				/**
				 * Save the item by calling the callback
				 */
				function save(item) {
					scope.selectedItem = item;
					scope.ngModel = item;
					scope.selectedItemChange(item).finally(() => {
						clearCache();
						blur();
					});
				}

				/**
				 * Blur the input field. This should trigger a submit if the form is valid.
				 */
				function blur() {
					var el = document.getElementsByName('autocomplete');
					angular.element(el).blur();
				}

				/**
				 * Clear the local cache of search results
				 */
				function clearCache() {
					last.term = undefined;
					last.search = undefined;
				}

				/**
				 * When a new record is loaded into the form the auto-complete directive immediately triggers an
				 * md-selected-item-change event. We keep a copy of the data passed to detect whether the selected Item matches
				 * the originally loaded record.
				 */
				scope.$watch(
					'ngModel',
					function(newItem, oldItem) {
						if (!angular.equals(newItem, oldItem)) {
							scope.selectedItem = newItem;
						}
					},
					true
				);
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:BeehomeVoucherModalCtrl
 * @description
 * # BeehomeVoucherModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('BeehomeVoucherModalCtrl', function(
		$scope,
		$mdDialog,
		codeValidator,
		organisations,
		Session,
		startpopSettings,
		voucher,
		codes,
		findExisting
	) {
		$scope.organisations = organisations;
		$scope.voucher = initVoucher(voucher || {}, codes);
		$scope.voucherPattern = initPattern(voucher ? voucher.type : null);

		$scope.onChangeCode = onChangeCode;
		$scope.submitVoucher = submitVoucher;
		$scope.assignClient = assignClient;
		$scope.cancel = cancel;
		$scope.generateVoucher = generateVoucher;
		$scope.clearClient = clearClient;
		$scope.expireVoucher = expireVoucher;

		function clearClient() {
			$scope.voucher.client_id;
			$scope.client = null;
		}
		function expireVoucher() {
			voucher.expiry_on = moment().format('YYYY-MM-DD');
		}
		function initVoucher(voucher, codes) {
			if (!voucher.organisation_id) {
				voucher.organisation_id = Session.organisationID || 1;
			}
			if (!voucher.code && codes) {
				voucher.code = codes[0];
			}
			if (!voucher.expiry_on) {
				voucher.expiry_on = moment()
					.add(5, 'years')
					.format('YYYY-MM-DD');
			}
			return voucher;
		}

		function initPattern(voucherType) {
			if (voucherType === 'BEECARE') {
				return codeValidator.beeCareVoucherPattern;
			} else if (voucherType === 'STARTPOP') {
				return codeValidator.startpopVoucherPattern;
			} else {
				return codeValidator.voucherPattern;
			}
		}

		/**
		 * Update the voucher type based on the pattern.
		 * If a vouchers with the same code already exists, load the existing voucher
		 * and do not create a new one.
		 */
		function onChangeCode() {
			let code = $scope.voucher.code;
			if (code && code.match(codeValidator.startpopVoucherPattern)) {
				$scope.voucher.type = 'STARTPOP';
				findExistingVoucher($scope.voucher.code);
			} else if (code && code.match(codeValidator.beeCareVoucherPattern)) {
				$scope.voucher.type = 'BEECARE';
				findExistingVoucher($scope.voucher.code);
			}
		}

		/**
		 * Find existing active voucher with the same code
		 * Disabled for FREECARE vouchers and if findExisting is set to False
		 */
		function findExistingVoucher(code) {
			if (!findExisting) {
				return;
			}
			if (code.match(codeValidator.freeCareVoucherPattern)) {
				delete $scope.voucher.id;
				return;
			}
			startpopSettings
				.getVoucherList({ code: code, is_active: true })
				.then(function(data) {
					if (data.items.length) {
						$scope.voucher = data.items[0];
					}
				});
		}

		function submitVoucher() {
			$scope.$root.showLoader = true;
			var voucher = preparedData();
			var submit = voucher.id
				? startpopSettings.editVoucher
				: startpopSettings.addVoucher;
			submit(voucher).then(
				response => {
					$scope.$root.showLoader = false;
					if (response && response.data) {
						$mdDialog.hide(response.data);
					} //TODO: HANDLE ERROR
				},
				() => {
					$mdDialog.hide();
				}
			);
		}

		function preparedData() {
			return {
				id: $scope.voucher.id,
				type: $scope.voucher.type,
				code: $scope.voucher.code,
				organisation_id: parseInt($scope.voucher.organisation_id),
				client_id: $scope.voucher.client_id,
				expiry_on: moment($scope.voucher.expiry_on).format('YYYY-MM-DD')
			};
		}
		function assignClient(client) {
			$scope.client = client;
			$scope.voucher.client_id = client.id;
		}
		function generateVoucher() {
			const usableChars = 'ACDEFGHKLMSTUWX2345679';

			const randomChar = () => {
				const rnd = Math.round(Math.random() * (usableChars.length - 1));
				return usableChars[rnd];
			};
			const now = new Date();
			const code =
				'XW' +
				(now.getFullYear() - 2020) +
				randomChar() +
				randomChar() +
				randomChar() +
				randomChar() +
				randomChar();
			startpopSettings.getVoucherList({ code: code, is_active: true }).then(
				function(data) {
					if (data.items.length) {
						generateVoucher();
					} else {
						$scope.voucher.code = code;
					}
				},
				() => {
					$scope.voucher.code = code;
				}
			);
		}

		function cancel() {
			$mdDialog.cancel();
		}
		if (!$scope.voucher.code) {
			generateVoucher();
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:clientSearch
 * @description
 * # clientSearch
 */
angular
	.module('wildBieneHarvestApp')
	.directive('clientSearch', function(
		Session,
		$location,
		clientSearchFactory,
		ContactFactory,
		AddressFactory
	) {
		return {
			templateUrl: 'views/client-search.html',
			scope: {
				keywordString: '=',
				wbpSelected: '=',
				selectedItem: '=',
				wbpFloatingLabel: '@',
				pagination: '@',
				wbpOrg: '='
			},
			link: function postLink(scope) {
				scope.search = search;
				scope.selectedAccount = selectedAccount;
				scope.submit = submit;
				scope.findBillingContact = findBillingContact;
				scope.findBillingAddress = findBillingAddress;

				// Cache term and promise of the last performed search
				var last = {
					term: undefined,
					search: undefined
				};

				if (angular.isUndefined(scope.wbpFloatingLabel)) {
					scope.wbpFloatingLabel = 'Search Accounts';
				}
				/**
				 * Searches for Accounts matching the terms
				 * @param {string} term
				 */
				function search(term) {
					if (term === last.term) {
						return last.search;
					}
					var search = clientSearchFactory
						.search(term, scope.pagination, scope.wbpOrg)
						.then(function(result) {
							if (result.items) {
								return result.items;
							} else {
								return [];
							}
						}, angular.noop);

					last = {
						term: term,
						search: search
					};
					return search;
				}

				// Either opens the account or calls the passed in function
				function selectedAccount(account) {
					if (!account) {
						return;
					}
					if (!angular.isUndefined(scope.wbpSelected)) {
						scope.wbpSelected(account);
					} else {
						clientSearchFactory.openAccountPage(account);
					}
					var el = document.getElementsByName('autocompleteField');
					angular.element(el).blur();
				}

				// Launches a more comprehensive search view, if there is more than one item found.
				// if only one item is found navigates to that item.
				function submit(term) {
					return search(term).then(function(items) {
						if (items.length === 1) {
							selectedAccount(items[0]);
						} else {
							$location.path('/' + Session.stream + '/account').search({ q: term });
						}
					});
				}

				function findBillingContact(account) {
					return account ? ContactFactory.getBillingContact(account.contacts) : null;
				}

				function findBillingAddress(account) {
					if (!account) {
						return null;
					}
					var address = AddressFactory.getBillingAddress(account.addresses);
					if (!address) {
						return null;
					}
					var addressText = address.address_1;
					addressText += address.address_2 ? '<br /.>' + address.address_2 : '';
					addressText +=
						'<br>' +
						address.country_code +
						'-' +
						address.postal_code +
						' ' +
						address.town;
					return addressText;
				}
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.clientSearchFactory
 * @description
 * # clientSearchFactory
 * Factory in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('clientSearchFactory', clientSearchFactory);

function clientSearchFactory(
	Session,
	$q,
	$http,
	AlertUser,
	codeValidator,
	SETTINGS,
	ClientFactory,
	ApiInterface,
	$location,
	$stateParams,
	$state
) {
	var service = {
		search: search,
		openAccountPage: openAccountPage,
		query: {
			q: '',
			per_page: 20,
			page: 1,
			limit: 10
		}
	};

	return service;

	/**
	 * Search for house code and return the client id.
	 * @returns {*}
	 */
	function houseCodeSearch(term) {
		var defer = $q.defer();
		$http
			.get(SETTINGS.beehomeAPIBasePath + 'houses?code=' + term)
			.then(function(data) {
				if (data.data.items.length) {
					var house = data.data.items[0];
					if (house.code.toUpperCase() !== term.toUpperCase()) {
						AlertUser(
							'WARNING',
							'This house code has been changed to ' + house.code,
							angular.noop
						);
					}
					if (house.client_id) {
						ClientFactory.getClient(house.client_id).then(function(client) {
							client.house_code = house.code;
							defer.resolve(client);
						});
					} else {
						defer.resolve(house);
					}
				} else {
					defer.reject('Could not find a house for this code.');
				}
			});
		return defer.promise;
	}
	/**
	 * Return true if query looks like a document number
	 * @returns {boolean}
	 */
	function isDocumentSearch(term) {
		var startsWithArray = ['OR-', 'RQ-', 'DL-'];
		var firstChars = term.substr(0, 3).toUpperCase();
		return startsWithArray.indexOf(firstChars) !== -1;
	}
	/**
	 * Search for documents and return the client id.
	 * @returns {*}
	 */
	function documentSearch(term) {
		var defer = $q.defer();
		$http.get(SETTINGS.APIBasePath + 'product/document-search/' + term).then(
			function(data) {
				if (data.data.clients && data.data.clients.length > 0) {
					ClientFactory.getClient(data.data.clients[0]).then(function(result) {
						defer.resolve([result]);
					});
				} else {
					defer.reject();
				}
			},
			function(error) {
				defer.reject(error);
			}
		);
		return defer.promise;
	}

	/**
	 * Perform a search via the autocomplete endpoint
	 */
	function quickSearch(query, doFullSearch) {
		var defer = $q.defer();
		var path = doFullSearch ? 'clients' : 'clients/autocomplete';
		ApiInterface.get(path, { params: query }).then(function(result) {
			if (result.items) {
				defer.resolve(result);
			} else {
				defer.resolve([]);
			}
		});
		return defer.promise;
	}

	/**
	 * Open account page for the search item returned
	 * @param item
	 */
	function openAccountPage(item) {
		if (!item) {
			return;
		}
		if (item.name && item.id) {
			const param_id = Number($stateParams.cid || $stateParams.fid);
			if (param_id && param_id === Number(item.id)) {
				$state.go($state.current, { house_code: item.house_code });
			} else {
				var path = '/' + Session.stream + '/account/' + item.id;
				$location.path(path).search({ house_code: item.house_code });
			}
		} else if (item.code) {
			$location.path('/harvest/product/' + item.code).search({ q: null });
		}
	}

	/**
	 * Update search but wait if its a document search.
	 * E.g. if user types OR-1 it we should wait until search is fully typed and submitted.
	 * @param <string> term
	 * @param <boolean> paginate
	 */
	function search(term, paginate, org) {
		var query = {
			q: term
		};
		if (org) {
			query.org = org;
		}
		if (Session.stream.toLowerCase() == 'farmer') {
			query.tags = 'osmipro';
		}
		if (paginate) {
			query.per_page = service.query.per_page;
			query.page = service.query.page;
		} else {
			query.limit = service.query.limit;
		}
		var defer = $q.defer();
		if (codeValidator.isHouseCode(term)) {
			houseCodeSearch(term).then(
				function(result) {
					//set the response values such that they can be displayed in a datatable
					query.items = [result];
					query.total_count = 1;
					query.total_pages = 1;
					defer.resolve(query);
				},
				function() {
					defer.resolve(quickSearch(query, paginate));
				}
			);
		} else if (term.length >= 3 && isDocumentSearch(term)) {
			documentSearch(term).then(function(result) {
				query.items = result;
				query.total_count = 1;
				query.total_pages = 1;
				defer.resolve(query);
			});
			// defer.resolve(documentSearch(term));
		} else {
			defer.resolve(quickSearch(query, paginate));
		}
		return defer.promise;
	}
}

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:SalesOrdersCtrl
 * @description
 * # SalesOrdersCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('SalesOrdersCtrl', function(
		$scope,
		$location,
		$state,
		$http,
		SETTINGS,
		AlertUser,
		ConfirmUser,
		NotifyUser,
		salesOrdersService,
		Statuses,
		$mdDialog,
		CustomerLoader,
		$q
	) {
		$scope.salesOrders = [];
		$scope.selected = [];
		$scope.query = {
			order: 'ID',
			limit: 20,
			page: 1,
			limitOptions: [20, 50, 100, 200],
			filterOptions: {}
		};
		$scope.toolbarShow = { main: true, filterCode: false, addCode: false };
		$scope.showFilter = false;

		$scope.fileName = 'SalesOrders';

		function success(data) {
			if (data.list) {
				$scope.salesOrders = data.list;
				$scope.salesOrdersCount = data.count;
				$scope.selected = [];
			}
			return true;
		}

		function deleteOrdersFunc(msg, deleteOrders) {
			ConfirmUser('Warning', msg, function() {
				$scope.promise = salesOrdersService
					.deleteSalesOrders(deleteOrders)
					.then(function() {
						NotifyUser('Orders have been deleted!');
						$scope.getSalesOrders();
					});
			});
		}

		function getStatuses() {
			Statuses.getAll().then(function(res) {
				$scope.statuses = res.data;
			});
		}

		$scope.setRowClass = function(orderID) {
			var isSelected = false;
			for (var i = 0; i < $scope.selected.length; i++) {
				if ($scope.selected[i].OrderId == orderID) {
					isSelected = true;
					break;
				}
			}
			return isSelected;
		};

		$scope.deleteOrders = function() {
			var deleteOrders = [];
			angular.forEach($scope.selected, function(v) {
				if (v.AmountRequested === 0) {
					deleteOrders.push(v.OrderId);
				}
			});

			if (deleteOrders.length == 0) {
				AlertUser(
					'Warning',
					'All of the selected items have requests linked to them and therefore can not be deleted.'
				);
			} else {
				var msg =
					deleteOrders.length != $scope.selected.length
						? 'Only ' +
						  deleteOrders.length +
						  ' out of ' +
						  $scope.selected.length +
						  ' orders can be deleted. Would you like to continue?'
						: 'Are you sure that you would like to delete the selected orders?';
				deleteOrdersFunc(msg, deleteOrders);
			}
		};

		$scope.changePage = function() {
			$scope.setRowClass();
			$scope.$scope.getSalesOrders();
		};

		$scope.editOrder = function(activeOrder, type) {
			$state.go('contract', {
				fid: activeOrder.ClientId,
				action: type,
				orderID: activeOrder.OrderId
			});
		};

		$scope.getSalesOrders = function() {
			$scope.promise = salesOrdersService
				.fetchSalesOrders($scope.query)
				.then(success);
		};

		$scope.activeStatusMenu = function(activeOrder, status) {
			return Statuses.activeStatusMenu(activeOrder, status, 'Status');
		};

		$scope.setStatus = function(statusId, activeOrderId) {
			$http
				.post(
					SETTINGS.APIBasePath + 'order/set-status/' + statusId + '/' + activeOrderId
				)
				.then($scope.getSalesOrders);
		};

		$scope.printExcelDocument = function(printStatus) {
			var delay = $q.defer();
			var printOrders = [];
			angular.forEach($scope.selected, function(v) {
				printOrders.push(v.OrderId);
			});
			var printData = {
				query: $scope.query,
				selected: printOrders,
				printStatus: printStatus
			};
			$scope.promise = salesOrdersService
				.printSalesOrders(printData)
				.then(function(data) {
					var list = data.list;
					var exportData = [
						[
							'Organisation',
							'Season',
							'OrderID',
							'OrderDate',
							'ClientID',
							'ContractType',
							'Firstname',
							'Lastname',
							'Company',
							'PositionType',
							'Product',
							'Description',
							'AmountOrdered',
							'Cultures',
							'Currency',
							'PricePerPiece',
							'Subtotal',
							'VATAmount',
							'SubtotalInclVAT',
							'Status'
						]
					];
					for (var i = 0; i < list.length; i++) {
						exportData.push([
							list[i].Organisation,
							list[i].Season,
							list[i].OrderId,
							list[i].OrderDate,
							list[i].ClientId,
							list[i].ContractType,
							list[i].FirstName,
							list[i].LastName,
							list[i].Company,
							list[i].PositionType,
							list[i].Product,
							list[i].Description,
							list[i].AmountOrdered,
							list[i].Cultures,
							list[i].Currency,
							list[i].PricePerPiece,
							list[i].Subtotal,
							list[i].VatAmt,
							list[i].SubtotalInclVat,
							list[i].Status
						]);
					}
					delay.resolve(exportData);
				});
			return delay.promise;
		};

		$scope.editSalesOrder = function(data) {
			CustomerLoader(data.ClientId).then(function(client) {
				var farmer = client;
				var editOrder = {};
				var activeSubscription = {};
				angular.forEach(farmer.orders, function(order) {
					if (order.ID == data.OrderId) {
						editOrder = order;
					}
				});
				angular.forEach(farmer.subscriptions, function(subscription) {
					angular.forEach(subscription.orders, function(order) {
						if (order.ID == data.OrderId) {
							activeSubscription = subscription;
						}
					});
				});
				farmer.activeOrder = editOrder;
				farmer.activeSubscription = activeSubscription;

				var organisationVATs = null;
				var taxInclusive = null;
				var defaultTax = null;
				var defaultCurrency = null;

				$http
					.get(SETTINGS.APIBasePath + 'organisation/' + farmer.OWNER_ID)
					.then(function(response) {
						organisationVATs = response.data.rates;
						taxInclusive = response.data.taxInclusive;
						defaultTax = response.data.vat;
						defaultCurrency = response.data.defaultCurrency;
					})
					.finally(function() {
						var type = 'edit';
						$mdDialog
							.show({
								controller: 'OrdermodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/order-modal.html',
								parent: angular.element(document.body),
								locals: {
									farmer: farmer,
									editOrder: editOrder,
									defaultTax: defaultTax,
									isOrder: true,
									organisationVATs: organisationVATs,
									taxInclusive: taxInclusive,
									defaultCurrency: defaultCurrency,
									type: type
								},
								resolve: {
									products: function(AllFarmerProductTypes) {
										return AllFarmerProductTypes();
									}
								},
								fullscreen: true,
								clickOutsideToClose: true
							})
							.then($scope.getSalesOrders);
					});
			});
		};

		getStatuses();
		$scope.getSalesOrders();

		$scope.filterSalesOrders = function(salesOrderFilters, dateRangeFilter) {
			$scope.query.filterOptions = salesOrderFilters;
			$scope.query.dateRangeFilter = dateRangeFilter;
			$scope.getSalesOrders();
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:productprogressindicator
 * @description
 * # productprogressindicator
 */
angular
	.module('wildBieneHarvestApp')
	.directive('productProgressIndicator', function(Session, $location) {
		return {
			templateUrl: 'views/product-progress-indicator.html',
			scope: {
				product: '=',
				clientId: '=',
				orderId: '=',
				users: '='
			},

			link: function postLink(scope) {
				scope.linkCode = null;
				if (scope.product && (scope.product.Code || scope.product.code)) {
					scope.linkCode = scope.product.Code || scope.product.code;
				}

				scope.orderLink = function(orderId) {
					return check(orderId ? '/#/beehome/orders/' + orderId : '', 'BeeStarter');
				};

				scope.customerLink = function(clientId, houseCode) {
					var link = clientId
						? '#/beehome/account/' + clientId + '?house_code=' + houseCode
						: '#/harvest/product/' + houseCode;
					return check(link, 'BeeHarvest Customer');
				};

				scope.cocoonsLink = function(houseCode) {
					return check('#/harvest/cocoons/' + houseCode, 'Cocoon');
				};

				scope.tubesLink = function(houseCode) {
					return check('#/harvest/tubes/' + houseCode, 'Tube');
				};

				scope.bexioLink = function(bexioId) {
					return bexioId
						? 'https://office.bexio.com/index.php/kb_invoice/show/id/' + bexioId
						: null;
				};

				scope.getStatusClass = function(beeStep) {
					return beeStep ? 'progress-indicator-true' : 'progress-indicator-false';
				};

				/**
				 * If the appropriate access right is present and the current location is not the link location
				 * then return the link
				 * @param link
				 * @param accessRight
				 * @returns {null|*}
				 */
				function check(link, accessRight) {
					if (Session.rights.indexOf(accessRight) > -1) {
						return link === '#' + $location.url() ? null : link;
					}
				}
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.trackingNumberService
 * @description
 */
angular
	.module('wildBieneHarvestApp')
	.factory('trackingNumberService', trackingNumberService);

function trackingNumberService() {
	var service = {
		getURL: getURL
	};

	return service;

	////////////////

	/**
	 * Construct the URL to the external tracking page
	 * @param number
	 * @returns {string|undefined}
	 */
	function getURL(number) {
		if (!number) {
			return undefined;
		} else if (number.match(/^[0-9]{18}$/)) {
			return (
				'https://www.post.ch/swisspost-tracking?formattedParcelCodes=' + number
			);
		} else if (number.match(/^(XU)[0-9]{9}(FR)$/)) {
			return (
				'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' +
				number
			);
		}
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:trackingNumber
 * @description replace tracking number with external link
 */
angular
	.module('wildBieneHarvestApp')
	.directive('trackingNumber', trackingNumber);

function trackingNumber(trackingNumberService) {
	return {
		scope: {
			number: '=number'
		},
		templateUrl: 'views/tracking-number.html',
		link: function postLink(scope) {
			scope.url = trackingNumberService.getURL(scope.number);
		}
	};
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.order
 * @description
 * # order
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('orderService', function($rootScope, $http, $filter, SETTINGS, $q) {
		/**
		 * Return true if expiry date for order is greater than current date
		 * @returns {boolean}
		 * @param order
		 * @param withStatusCheck
		 */
		this.isExpired = function(order, withStatusCheck) {
			withStatusCheck = withStatusCheck || false;
			var currentDate = moment().format('YYYY-MM-DD');
			var expiryDate = moment(order.expiryDate).format('YYYY-MM-DD');
			if (withStatusCheck === false) {
				return !moment(currentDate).isSameOrBefore(expiryDate);
			} else {
				if (order.statusDescription.toLowerCase() === 'open') {
					return !moment(currentDate).isSameOrBefore(expiryDate);
				}
			}
			return false;
		};

		/**
		 * Check if active order is order or offer. Based on order status.
		 * @returns {boolean}
		 */
		this.checkIfOrderIsOrderOrOffer = function(order) {
			var orderStatus =
				order.statusDescription !== undefined
					? order.statusDescription.toLowerCase()
					: 'draft';
			return !(
				orderStatus === 'draft' ||
				orderStatus === 'open' ||
				orderStatus === 'declined'
			);
		};

		/**
		 * Returns only orders which have show set to true
		 * @param orders
		 * @returns {*}
		 */
		this.getFilteredOrders = function(orders) {
			return $filter('filter')(orders, { show: true });
		};

		/**
		 * Clean order items
		 * @param orderItems
		 * @param {string} type
		 * @returns {*}
		 */
		this.cleanOrderItems = function(orderItems, type) {
			var items = orderItems;
			if (type === 'edit') {
				return items;
			}

			angular.forEach(items, function(value) {
				if (value.ID !== undefined) {
					delete value['ID'];
				}
			});
			return items;
		};

		$rootScope.$root.showLoader = false;
		function toggleLoader() {
			$rootScope.$root.showLoader = !$rootScope.$root.showLoader;
		}

		/**
		 * Save order
		 * @param {Object} data
		 * @param {string} type
		 * @param {Object} customer
		 * @param {string} taxInclusive
		 */
		this.saveOrder = function(data, type, customer, taxInclusive) {
			var delay = $q.defer();
			if (data !== undefined && data !== null) {
				toggleLoader();
				var postData = {};
				postData.pos = data.pos;
				postData.clientID = customer.id;
				postData.season = data.season;
				postData.taxInclusive = taxInclusive;
				postData.orderDate = moment(data.date).format('YYYY-MM-DD HH:mm:ss');
				postData.expiryDate =
					data.expiryDate !== null
						? moment(data.expiryDate).format('YYYY-MM-DD HH:mm:ss')
						: null;
				postData.contractType = data.contractType.ID;
				postData.paymentType = data.paymentType.ID;
				postData.paymentTerm = data.paymentTerm.ID;
				postData.paymentInvoiceDate = data.paymentInvoiceDate
					? moment(data.paymentInvoiceDate).format('YYYY-MM-DD HH:mm:ss')
					: null;
				postData.downpayment = data.downpayment ? data.downpayment : null;
				postData.currency = data.currency.ID;
				postData.orderItems = this.cleanOrderItems(data.orderItems, type);

				if (this.checkIfOrderIsOrderOrOffer(data)) {
					postData.statusID = 2;
				} else {
					postData.statusID = 1;
				}

				postData.aboId = customer.activeSubscription.ID;
				postData.organisationId = customer.organisation.id;

				if (type === 'edit') {
					postData.ID = data.ID;
				}

				postData.comments = '';

				$http
					.post(SETTINGS.APIBasePath + 'order', {
						data: postData
					})
					.then(function(data) {
						delay.resolve(data);
						try {
							if (type === 'new') {
								customer.selectedSubscriptionIndex = null;
							}
							customer.getSubscriptions();
						} catch (e) {
							return;
						}
					})
					.finally(function() {
						toggleLoader();
					});
			} else {
				delay.resolve(null);
			}
			return delay.promise;
		};

		/**
		 * Get order items by position type ID
		 * @param {[Object]} orderItems
		 * @param {number} positionType
		 * @return {*}
		 */
		this.getOrderItemsByPositionType = function(orderItems, positionType) {
			return $filter('filter')(orderItems, { positionType: positionType });
		};

		/**
		 * Calculate additional order properties, not returned by the API.
		 * @param order
		 */
		this.calculateAdditionalProperties = function(order) {
			this.calculateNotYetRequested(order);
			this.calculateOrderItemComponents(order);
			this.calculateMinOrderAmount(order);
			this.calculateRequestComponents(order);
		};

		/**
		 * Calculate the number of components not yet requested
		 */
		this.calculateNotYetRequested = function(order) {
			order.notYetRequested = 0;
			angular.forEach(order.orderItems, function(orderItem) {
				angular.forEach(orderItem.components, function(component) {
					order.notYetRequested += component.ordered - component.requested;
				});
			});
		};

		/**
		 * For all order items calculate the number of components units requested in each category (case, box, pop)
		 */
		this.calculateOrderItemComponents = function(order) {
			angular.forEach(order.orderItems, function(orderItem) {
				var requested = {};
				angular.forEach(orderItem.components, function(component) {
					requested['total'] =
						requested['total'] + component.requested || component.requested;
					requested[component.productCategory] =
						requested[component.productCategory] + component.requested ||
						component.requested;
				});
				orderItem.requested = requested;
			});
		};

		/**
		 * For all order items calculate the number of parent units requested
		 */
		this.calculateMinOrderAmount = function(order) {
			angular.forEach(order.orderItems, function(orderItem) {
				var min = 1;
				angular.forEach(orderItem.components, function(component) {
					var requested = component.requested / component.multiplier;
					if (requested > min) {
						min = requested;
					}
				});
				orderItem.minOrderAmount = min;
			});
		};

		/**
		 * For all requests calculate the number of components units requested in each category (case, box, pop)
		 */
		this.calculateRequestComponents = function(order) {
			angular.forEach(order.requests, function(request) {
				var requested = {};
				angular.forEach(request.requestItems, function(requestItem) {
					requested['total'] =
						requested['total'] + requestItem.requested || requestItem.requested;
					requested[requestItem.productCategory] =
						requested[requestItem.productCategory] + requestItem.requested ||
						requestItem.requested;
				});
				request.requested = requested;
			});
		};
	})

	.service('salesOrdersService', function(SETTINGS, $http, $q) {
		this.printSalesOrders = function(printOptions) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'salesorders/print', { data: printOptions })
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
		this.deleteSalesOrders = function(codes) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'salesorders/delete', { data: codes })
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
		this.getSalesOrder = function(code) {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'salesorders/salesorder?code=' + code)
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};

		this.updateSalesOrders = function(data, activeStatus) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'salesorders/update_salesorder_items', {
					list: data,
					active: activeStatus
				})
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
		this.fetchSalesOrders = function(tableSetup) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'salesorders/filtered_list', {
					data: tableSetup
				})
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
		this.getSalesOrdersFilterVariables = function(tableSetup) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'salesorders/filter_variables', {
					data: tableSetup
				})
				.then(function(response) {
					delay.resolve(response.data);
				});
			return delay.promise;
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.Batch
 * @description
 * # Batch
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	//Factory returning Batches;
	.factory('Batch', [
		'$resource',
		'SETTINGS',
		function($resource, SETTINGS) {
			return $resource(SETTINGS.APIBasePath + 'batch/:id', { id: '@id' });
		}
	])
	//returns all Batches
	.factory('AllBatches', [
		'Batch',
		'$q',
		function(Batch, $q) {
			return function() {
				var delay = $q.defer();
				Batch.query(
					function(allBatches) {
						delay.resolve(allBatches);
					},
					function() {
						delay.reject('unable to fetch batches');
					}
				);
				return delay.promise;
			};
		}
	]);

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:forceSelect
 * @description
 * # forceSelect force and md-autocomplete element to have a value from the available 
 	autocomplete options in order to valite with the required attribute.
 */
angular
	.module('wildBieneHarvestApp')
	.directive('forceSelect', ['$mdUtil', forceSelect]);

function forceSelect($mdUtil) {
	function postLink(scope, element, attrs, autoComplete) {
		var isSelected = function(item) {
			return autoComplete.matches.indexOf(item) !== -1;
		};

		$mdUtil.nextTick(function() {
			var ngModel = element.find('input').controller('ngModel');

			autoComplete.registerSelectedItemWatcher(function(selectedItem) {
				ngModel.$setValidity('forceSelect', isSelected(selectedItem));
			});

			ngModel.$viewChangeListeners.push(function() {
				$mdUtil.nextTick(function() {
					ngModel.$setValidity(
						'forceSelect',
						isSelected(autoComplete.scope.selectedItem)
					);
				});
			});
		});
	}

	return {
		link: postLink,
		require: 'mdAutocomplete',
		restrict: 'A'
	};
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:SubscriptionsPanel
 * @description
 * # SubscriptionsPanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('subscriptionsPanel', function(
		$mdDialog,
		ConfirmUser,
		NotifyUser,
		SubscriptionService,
		orderService,
		$stateParams
	) {
		return {
			templateUrl: 'views/subscriptions-panel.html',
			scope: {
				farmer: '=',
				users: '=',
				initSeasons: '&'
			},

			link: function(scope) {
				// title
				scope.title = 'Subscriptions';

				// variables
				scope.farmer.activeSubscription = {};
				scope.farmer.selectedSubscriptionIndex = null;

				// services
				scope.orderService = orderService;
				scope.subscriptionService = SubscriptionService;

				/**
				 * Initialization
				 */
				scope.init = function(selectIndex) {
					if (selectIndex === undefined) {
						scope.deselectAllSubscriptions();
					} else {
						scope.selectSubscription(scope.farmer.selectedSubscriptionIndex);
					}
				};

				function populateOrders() {
					var allOrders = [];
					angular.forEach(scope.farmer.subscriptions, function(subscription) {
						allOrders = allOrders.concat(subscription.orders);
					});

					// Reload active order
					if (scope.farmer.activeOrder) {
						angular.forEach(allOrders, function(order) {
							if (scope.farmer.activeOrder.ID === order.ID) {
								order.selected = true;
								scope.farmer.activeOrder = order;
							}
						});
					}

					scope.farmer.orders = allOrders;
				}

				/**
				 * Get subscriptions
				 * @param selectLast
				 */
				scope.getSubscriptions = function(selectLast) {
					scope.deselectAllSubscriptions();
					SubscriptionService.getAll(scope.farmer.id)
						.then(function(res) {
							scope.farmer.subscriptions = res.data;
							scope.initSeasons();
							if (selectLast) {
								scope.selectLastSubscription();
							} else if (scope.farmer.selectedSubscriptionIndex) {
								scope.selectSubscription(scope.farmer.selectedSubscriptionIndex);
							}
						})
						.then(populateOrders);
				};

				/**
				 * Set subscription as selected
				 * @param {number} index
				 */
				scope.selectSubscription = function(index) {
					scope.deselectAllSubscriptions();

					angular.forEach(scope.farmer.subscriptions, function(
						subscription,
						subscriptionIndex
					) {
						if (
							parseInt(
								SubscriptionService.getFilteredSubscriptions(
									scope.farmer.subscriptions
								)[index].ID
							) === parseInt(scope.farmer.subscriptions[subscriptionIndex].ID)
						) {
							scope.farmer.activeSubscription =
								scope.farmer.subscriptions[subscriptionIndex];
							scope.farmer.activeSubscription.selected = true;
							scope.farmer.selectedSubscriptionIndex = subscriptionIndex;
						}
					});

					// Deselect order
					if (
						scope.farmer.activeOrder &&
						parseInt(scope.farmer.activeOrder.aboID) !==
							parseInt(scope.farmer.activeSubscription.ID)
					) {
						scope.farmer.activeOrder.selected = false;
						scope.farmer.activeOrder = null;
					}
				};

				/**
				 * Deselect all subscriptions
				 */
				scope.deselectAllSubscriptions = function() {
					scope.deselectAllActives();
					angular.forEach(scope.farmer.subscriptions, function(
						subscription,
						subscriptionIndex
					) {
						scope.selectOrDeselectSubscription(subscriptionIndex, false);
					});
				};

				/**
				 * Reset active subscription, order and request. When we select subscription, we want reset
				 * active subscription, order and request before set new active subscription probably
				 */
				scope.deselectAllActives = function() {
					scope.farmer.activeSubscription = {};
					scope.farmer.activeRequest = null;
				};

				/**
				 * Select or deselect subscription
				 * @param {number} subscriptionIndex
				 * @param {boolean} type
				 */
				scope.selectOrDeselectSubscription = function(subscriptionIndex, type) {
					scope.farmer.subscriptions[subscriptionIndex].selected = type;
				};

				/**
				 * Cancel subscription
				 * Show confirm modal first and after click to ok button, call confirmCancelSubscription function
				 */
				scope.cancelSubscription = function() {
					ConfirmUser(
						'Warning',
						'Are you sure you want to cancel the subscription? ',
						confirmCancelSubscription
					);
				};

				/**
				 * This function call api request and set subscription as cancelled and then refresh all subscriptions
				 */
				function confirmCancelSubscription() {
					SubscriptionService.cancel(scope.farmer.activeSubscription.ID).then(
						function() {
							NotifyUser('Successfully cancelled');
							scope.getSubscriptions(true);
						}
					);
				}

				/**
				 * Activate subscription
				 * Show confirm modal first and after click to ok button, call confirmActiveSubscription function
				 */
				scope.activeSubscription = function() {
					ConfirmUser(
						'Warning',
						'Are you sure you want to set subscription as active? ',
						confirmActiveSubscription
					);
				};

				/**
				 * This function call api request and set subscription as active and then refresh all subscriptions
				 */
				function confirmActiveSubscription() {
					SubscriptionService.active(scope.farmer.activeSubscription.ID).then(
						function() {
							NotifyUser('Successfully activated');
							scope.getSubscriptions(true);
						}
					);
				}

				/**
				 * Select last subscription
				 */
				scope.selectLastSubscription = function() {
					var filteredSubscriptions = SubscriptionService.getFilteredSubscriptions(
						scope.farmer.subscriptions
					);
					if (filteredSubscriptions.length > 0) {
						var activeIndex = filteredSubscriptions.length - 1;
						if ($stateParams.orderID) {
							angular.forEach(scope.farmer.subscriptions, function(subscription, k) {
								angular.forEach(subscription.orders, function(order) {
									if (order.ID === $stateParams.orderID) {
										activeIndex = k;
									}
								});
							});
						}
						scope.selectSubscription(activeIndex);
					}
				};

				/**
				 * Open subscription modal
				 */
				scope.subscriptionModal = function(type) {
					return $mdDialog
						.show({
							controller: 'SubscriptionmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/subscription-modal.html',
							parent: angular.element(document.body),
							locals: {
								farmer: scope.farmer,
								activeSubscription:
									type === 'edit' ? scope.farmer.activeSubscription : null,
								type: type
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(function(subscription) {
							if (subscription !== undefined && subscription !== null) {
								scope.subscriptionService.save(subscription).then(function() {
									scope.getSubscriptions(true);
								});
							}
						});
				};

				/**
				 * Return status for subscription
				 * @param subscription
				 * @return {string}
				 */
				scope.getSubscriptionStatus = function(subscription) {
					if (subscription.END_DATE === null) {
						return 'Active';
					}

					return 'Cancelled';
				};

				scope.init();
				scope.farmer.getSubscriptions = scope.getSubscriptions;
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.Subscription
 * @description
 * # Subscription
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('SubscriptionService', function(
		$http,
		orderService,
		SETTINGS,
		$q,
		$filter
	) {
		this.getAll = getAll;
		this.cancel = cancel;
		this.active = active;
		this.save = save;
		this.getFilteredSubscriptions = getFilteredSubscriptions;

		function getAll(clientId) {
			var delay = $q.defer();
			$http
				.get(SETTINGS.APIBasePath + 'subscriptions/' + clientId)
				.then(function(result) {
					angular.forEach(result.data.data, function(subscription) {
						angular.forEach(subscription.orders, function(order) {
							orderService.calculateAdditionalProperties(order);
						});
						//TODO: correct this logic
						subscription.show = true;
					});
					delay.resolve(result.data);
				});
			return delay.promise;
		}

		function cancel(subscriptionId) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'subscriptions/cancel/' + subscriptionId)
				.then(function(result) {
					delay.resolve(result.data);
				});
			return delay.promise;
		}

		function active(subscriptionId) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'subscriptions/active/' + subscriptionId)
				.then(function(result) {
					delay.resolve(result.data);
				});
			return delay.promise;
		}

		function save(subscription) {
			var delay = $q.defer();
			$http
				.post(SETTINGS.APIBasePath + 'subscription', { subscription: subscription })
				.then(function(result) {
					delay.resolve(result.data);
				});
			return delay.promise;
		}
		/**
		 * Returns only subscriptions which have show set to true
		 * @param subscriptions
		 * @returns {*}
		 */
		function getFilteredSubscriptions(subscriptions) {
			return $filter('filter')(subscriptions, { show: true });
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:screendisplay
 * @description
 * # screendisplay
 */
angular
	.module('wildBieneHarvestApp')
	.directive('resizeTable', function($window) {
		return {
			link: link,
			restrict: 'A',
			template: '<div></div>'
		};

		function link(scope) {
			scope.displayHeight = { 'max-height': $window.innerHeight - 300 + 'px' };
			function onResize() {
				// uncomment for only fire when $window.innerWidth change
				if (scope.displayHeight !== $window.innerHeight) {
					scope.displayHeight = { 'max-height': $window.innerHeight - 300 + 'px' };
					scope.$digest();
				}
			}

			function cleanUp() {
				angular.element($window).off('resize', onResize);
			}

			angular.element($window).on('resize', onResize);
			scope.$on('$destroy', cleanUp);
		}
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:SubscriptionmodalCtrl
 * @description
 * # SubscriptionmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('SubscriptionmodalCtrl', function(
		$scope,
		$http,
		SETTINGS,
		$mdDialog,
		Session,
		farmer,
		type,
		activeSubscription
	) {
		// title
		$scope.title = 'Subscription details';

		// variables
		$scope.subscription = {};
		$scope.contractTypes = Session.allContractTypes;
		$scope.currentSeason = Session.farmerSeason;
		$scope.farmer = farmer;
		$scope.type = type;
		$scope.activeSubscription = activeSubscription;

		/**
		 * Initialization
		 */
		$scope.init = function() {
			$scope.subscription.clientId = $scope.farmer.id;
			if (type === 'edit') {
				$scope.subscription.ID = activeSubscription.ID;
				$scope.subscription.endDate =
					activeSubscription.END_DATE !== null
						? moment(activeSubscription.END_DATE).format('YYYY-MM-DD')
						: null;
				$scope.selectContractTypeById(activeSubscription.TYPE_ID);
			} else {
				$scope.subscription.endDate = null;
				$scope.selectFirstContractType();
			}
		};

		/**
		 * Get end date season
		 * @return {Session.farmerSeason|Document.farmerSeason}
		 */
		$scope.getEndDateSeason = function() {
			var currentSeason = $scope.currentSeason;
			var currentDate = moment().format('YYYY-MM-DD');
			var targetDate = moment(currentSeason + '-09-30').format('YYYY-MM-DD');

			while (moment(currentDate).isAfter(targetDate)) {
				currentSeason++;
				targetDate = moment(currentSeason + '-09-30').format('YYYY-MM-DD');
			}

			return currentSeason;
		};

		/**
		 * Cancel subscription modal
		 */
		$scope.cancel = function() {
			$mdDialog.hide();
		};

		/**
		 * Cancel subscription modal and send subscription data back
		 */
		$scope.save = function() {
			$mdDialog.hide($scope.normalizeData($scope.subscription));
		};

		/**
		 * Select first contract type
		 */
		$scope.selectFirstContractType = function() {
			if (angular.isArray($scope.contractTypes)) {
				$scope.subscription.contractType = $scope.contractTypes[0];
			}
		};

		/**
		 * Select contract type by ID
		 * @param {number} contractTypeId
		 */
		$scope.selectContractTypeById = function(contractTypeId) {
			angular.forEach($scope.contractTypes, function(
				contractType,
				contractTypeIndex
			) {
				if (contractTypeId === contractType.ID) {
					$scope.subscription.contractType = $scope.contractTypes[contractTypeIndex];
				}
			});
		};

		/**
		 * Normalize data for saving
		 * @param subscription
		 * @return {*}
		 */
		$scope.normalizeData = function(subscription) {
			subscription.endDate = moment($scope.subscription.endDate).format(
				'YYYY-MM-DD'
			);
			if (
				typeof subscription.endDate === 'string' &&
				subscription.endDate.toLowerCase() === 'invalid date'
			) {
				subscription.endDate = null;
			}

			return subscription;
		};

		$scope.init();
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.label
 * @description
 * # label
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('buttonLabelService', function() {
	// variables
	this.notifyCircleHtml = '<span class="notif-circle"></span>';

	/**
	 * Set label
	 * @param {string} materialIconName
	 * @param {string} title
	 * @param {boolean} withNote
	 */
	this.setButtonLabel = function(materialIconName, title, withNote) {
		withNote = withNote || false;

		var button =
			'<i class="material-icons">' + materialIconName + '</i> ' + title;

		if (withNote) {
			button = button + this.notifyCircleHtml;
		}

		return button;
	};
});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:filterpanel
 * @description
 * # filterpanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('filterPanel', function($mdDialog, salesOrdersService) {
		return {
			scope: {
				filterSection: '=filterSection',
				filterList: '&'
			},
			// templateUrl: 'views/'+{{filterSection}}+'-filter-panel.html',
			templateUrl: function(elem, attrs) {
				return 'views/' + attrs.filterSection + '-filter-panel.html';
			},
			link: function postLink(scope) {
				scope.filter = {};
				scope.dateRange = {};

				salesOrdersService
					.getSalesOrdersFilterVariables(scope.query)
					.then(function(results) {
						scope.filterVariables = results.list;
						scope.filterVariables['printStatuses'] = [
							{
								key: 1,
								value: 'Printed'
							},
							{
								key: 2,
								value: 'Not Printed'
							}
						];
					});

				scope.popupDateRangePicker = function() {
					$mdDialog
						.show({
							controller: 'DateRangePickerCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/date-range-picker.html',
							parent: angular.element(document.body),
							locals: {
								dateRange: scope.dateRange || {}
							},
							fullscreen: false,
							clickOutsideToClose: true
						})
						.then(function(data) {
							scope.dateRange = data;
							scope.runFilter();
						});
				};

				scope.removeFilter = function(fieldName) {
					delete scope.filter[fieldName];
					scope.runFilter();
				};

				scope.removeDateRangeFilter = function() {
					scope.dateRange = {};
					scope.runFilter();
				};

				scope.clearFilter = function() {
					scope.filter = {};
					scope.dateRange = {};
					scope.runFilter();
				};

				scope.runFilter = function() {
					scope.filterList({
						filterOptions: scope.filter,
						dateRangeFilter: scope.dateRange || {}
					});
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:beehomeOrdersFilter
 * @description
 * # startpopfilterpanel
 */
angular
	.module('wildBieneHarvestApp')
	.directive('beehomeOrdersFilter', beehomeOrdersFilter);

function beehomeOrdersFilter() {
	var directive = {
		scope: {
			organisations: '=',
			clientId: '=',
			houseId: '=',
			filter: '=',
			runFilter: '&'
		},
		templateUrl: 'views/beehome-orders-filter.html',
		link: link
	};
	return directive;

	function link(scope) {
		scope.clearFilter = clearFilter;

		defaultFilter();

		scope.runFilter();

		/**
		 * Set default filter settings
		 */
		function defaultFilter() {
			if (scope.houseId) {
				scope.filter.house_id = scope.houseId;
			}
			if (scope.clientId) {
				scope.filter.client_id = scope.clientId;
			}
		}

		/**
		 * If clientId or houseId is provided then its mandatory to filter by those values
		 * Clear all but mandatory filters and run
		 */
		function clearFilter() {
			angular.forEach(scope.filter, function(value, key) {
				if (
					!(scope.clientId && key === 'client_id') &&
					!(scope.houseId && key === 'house_id')
				) {
					scope.filter[key] = null;
				}
			});
			scope.runFilter();
		}

		scope.$watch('houseId', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				scope.filter.house_id = scope.houseId;
				scope.runFilter();
			}
		});
	}
}

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:DateRangePickerCtrl
 * @description
 * # DateRangePickerCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('DateRangePickerCtrl', function($scope, $mdDialog, dateRange) {
		$scope.startDate = dateRange.startDate
			? new Date(dateRange.startDate)
			: new Date();
		$scope.endDate = dateRange.endDate
			? new Date(dateRange.endDate)
			: new Date($scope.startDate);

		$scope.cancel = function() {
			$mdDialog.hide();
		};

		$scope.save = function() {
			$mdDialog.hide({ startDate: $scope.startDate, endDate: $scope.endDate });
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AccountSummaryModalCtrl
 * @description
 * # AccountSummaryModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('AccountSummaryModalCtrl', function(
		$scope,
		$q,
		languageFactory,
		organisations,
		client,
		$mdDialog,
		Session,
		ClientFactory,
		ContactFactory,
		AddressFactory,
		OrganisationFactory,
		certifications
	) {
		$scope.organisations = organisations;
		$scope.client = angular.copy(client);
		$scope.contact = null;
		$scope.address = null;
		if ($scope.client && $scope.client.contacts) {
			$scope.contact = ContactFactory.getBillingContact($scope.client.contacts);
		}
		if ($scope.client && $scope.client.addresses) {
			$scope.address = AddressFactory.getBillingAddress($scope.client.addresses);
		}

		if (!$scope.address) {
			$scope.address = new AddressFactory.AddressModel({
				tags: ['BILLING']
			});
		}
		if (!$scope.contact) {
			$scope.contact = { mailing_preference: 'EMAIL' };
		} else if (
			$scope.contact &&
			angular.isUndefined($scope.contact.mailing_preference)
		) {
			$scope.contact.mailing_preference = 'EMAIL';
		}
		$scope.save = save;
		$scope.cancel = cancel;
		$scope.clickedSubmitButton = clickedSubmitButton;
		$scope.checkupdateOrgRight = checkupdateOrgRight;
		$scope.updateIncludeAddress = updateIncludeAddress;
		$scope.updateCountry = updateCountry;
		$scope.certifications = certifications;
		$scope.updateAddressCompany = updateAddressCompany;

		function init() {
			$scope.updateCountry();
			if ($scope.client.type.toLowerCase() == 'company' && !$scope.address.id) {
				$scope.address.company = $scope.client.name;
			}
			$scope.existOriginalArray = {
				email: angular.copy($scope.contact.email),
				phone: angular.copy($scope.contact.phone_mobile)
			};
		}

		if (!client) {
			$scope.client = new ClientFactory.ClientModel();
			if (Session.stream.toLowerCase() == 'farmer') {
				$scope.client.tags = ['OSMIPRO'];
				$scope.client.isFarmer = true;
			}
			$scope.contact = new ContactFactory.ContactModel({
				tags: ['BILLING']
			});
			$scope.address = new AddressFactory.AddressModel({
				tags: ['BILLING']
			});
		}
		if (!$scope.contact) {
			$scope.contact = new ContactFactory.ContactModel({
				first_name: $scope.address.first_name,
				last_name: $scope.address.last_name,
				tags: ['BILLING']
			});
		}

		for (var orgIndex = 0; orgIndex < organisations.length; orgIndex++) {
			var org = organisations[orgIndex];
			if (!$scope.client.organisation && Session.organisationID == org.ID) {
				$scope.client.organisation_id = org.ID;
				$scope.countryCode = org.country;
			} else if (
				$scope.client.organisation &&
				$scope.client.organisation.id == org.ID
			) {
				$scope.client.organisation_id = org.ID;
			}
		}

		languageFactory.query(function(result) {
			$scope.languages = result;
			if ($scope.contact && $scope.contact != null && $scope.contact.language) {
				for (var i = 0; i < $scope.languages.length; i++) {
					if (
						$scope.languages[i].code.toLowerCase() ==
						$scope.contact.language.toLowerCase()
					) {
						$scope.contact.language = result[i].code;
					}
				}
			} else if ($scope.contact) {
				var defaultLang = null;
				//sets the default language to match the logged in users language, if no match is found selects the general default language
				for (var j = 0; j < result.length; j++) {
					if (result[j].code.toLowerCase() == Session.getLanguage().toLowerCase()) {
						defaultLang = result[j].code;
					} else if (!defaultLang && result[j].DEFLT == 'Y') {
						defaultLang = result[j].code;
					}
				}
				$scope.contact.language = defaultLang;
			}
		});
		function checkupdateOrgRight() {
			//if the client exists do not allow anyone to edit their org.
			if ($scope.client.id) {
				return false;
			}
			if (Session.rights.indexOf('Update ownership') > -1) {
				return true;
			} else {
				return false;
			}
		}
		function cancel() {
			$mdDialog.cancel();
		}
		function clickedSubmitButton() {
			if ($scope.accountForm.$invalid) {
				for (var control of $scope.accountForm.contactForm.$$controls) {
					control.$setTouched();
					control.$validate();
				}
			}
		}

		function save() {
			if ($scope.client.id) {
				$scope.$root.showLoader = true;
				if ($scope.client.type.toLowerCase() != 'company') {
					$scope.client.name =
						$scope.contact.first_name + ' ' + $scope.contact.last_name;
				}
				var sanitisedUpdateClient = new ClientFactory.ClientModel($scope.client);
				ClientFactory.update($scope.client.id, sanitisedUpdateClient)
					.then(saveContactAddress)
					.finally(function() {
						$scope.$root.showLoader = false;
						$mdDialog.hide({ client: $scope.client });
					});
			} else {
				$scope.$root.showLoader = true;
				var sanitisedClient = new ClientFactory.ClientModel($scope.client);
				if ($scope.address.address_1) {
					if ($scope.contact.first_name) {
						$scope.address.first_name = $scope.contact.first_name;
					}
					if ($scope.contact.last_name) {
						$scope.address.last_name = $scope.contact.last_name;
					}
					sanitisedClient.addresses = [
						new AddressFactory.AddressModel($scope.address)
					];
				}

				sanitisedClient.contacts = [
					new ContactFactory.ContactModel($scope.contact)
				];
				ClientFactory.create(sanitisedClient)
					.then(function(result) {
						$scope.client.id = result.data.id;
					})
					.finally(function() {
						$scope.$root.showLoader = false;
						$mdDialog.hide({ client: $scope.client });
					});
			}
		}
		//determines weather to update or screate contact and address records
		function saveContactAddress(client) {
			if (client && client.data && client.data.id) {
				$scope.client.id = client.data.id;
			}
			return saveAddress().then(saveContact);
		}
		function saveContact() {
			if (
				$scope.contact.id ||
				$scope.contact.email ||
				$scope.contact.phone_mobile ||
				$scope.contact.phone_business ||
				$scope.contact.phone_private ||
				$scope.contact.last_name ||
				$scope.contact.mailing_preference
			) {
				if ($scope.contact.id) {
					return updateContact();
				} else {
					return createContact($scope.client.id);
				}
			}
		}
		function saveAddress() {
			var defer = $q.defer();
			if ($scope.address.id) {
				//todo: this is not pretty but for some reason address_1 is never cleared.
				if ($scope.address.address_1 && $scope.address.address_1.length > 1) {
					defer.resolve(updateAddress($scope.client.id));
				} else {
					defer.resolve(deleteAddress($scope.client.id, $scope.address.id));
				}
			} else if ($scope.address.address_1) {
				defer.resolve(createAddress());
			} else {
				defer.resolve('nothing to save');
			}
			return defer.promise;
		}
		function updateContact() {
			$scope.contact.client_id = $scope.client.id;
			return ContactFactory.update($scope.contact.id, $scope.contact);
		}

		function createAddress() {
			$scope.address.first_name = $scope.contact.first_name;
			$scope.address.last_name = $scope.contact.last_name;
			var sanitisedAddress = new AddressFactory.AddressModel($scope.address);
			return AddressFactory.create($scope.client.id, sanitisedAddress);
		}

		function updateAddress() {
			$scope.address.first_name = $scope.contact.first_name;
			$scope.address.last_name = $scope.contact.last_name;
			var sanitisedAddress = new AddressFactory.AddressModel($scope.address);
			return AddressFactory.update(
				$scope.client.id,
				$scope.address.id,
				sanitisedAddress
			);
		}
		function deleteAddress(clientId) {
			return AddressFactory.erase(clientId, $scope.address.id).then(function() {
				$scope.address = null;
			});
		}
		function createContact(clientId) {
			$scope.contact.client_id = clientId;
			var sanitisedContact = new ContactFactory.ContactModel($scope.contact);
			return ContactFactory.create(sanitisedContact);
		}

		function updateIncludeAddress() {
			if ($scope.contact.mailing_preference.toLowerCase() == 'PAPER') {
				$scope.includeAddress = true;
			} else {
				$scope.includeAddress = false;
			}
		}
		function updateCountry() {
			OrganisationFactory.getCountryCode($scope.client.organisation_id).then(
				function(code) {
					$scope.country = code;
				}
			);
		}
		function updateClientName() {
			$scope.client.name = (
				($scope.contact.first_name || '') +
				' ' +
				($scope.contact.last_name || '')
			).trim();
		}
		function updateAddressCompany() {
			if ($scope.client.type.toLowerCase() == 'company') {
				$scope.address.company_name = $scope.client.name;
			}
		}

		$scope.$watch('contact.first_name', function() {
			if ($scope.client.type.toLowerCase() !== 'company') {
				updateClientName();
			}
		});

		$scope.$watch('contact.last_name', function() {
			if ($scope.client.type.toLowerCase() !== 'company') {
				updateClientName();
			}
		});

		init();
	});

'use strict';

/**
 * @ngdoc factory
 * @name wildBieneHarvestApp.client
 * @description
 * # clientFactory
 * factory in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('ClientFactory', clientFactory);

function clientFactory($http, $q, ApiInterface, SETTINGS, NotifyUser) {
	var factory = {
		searchClients: searchClients,
		getClient: getClient,
		update: update,
		create: create,
		erase: erase,
		addTag: addTag,
		QueryModel: QueryModel,
		ClientModel: ClientModel,
		updateClientProduct: updateClientProduct,
		activeClient: null
	};

	return factory;

	//////

	function QueryModel(q, sort, tags, per_page, page) {
		this.per_page = per_page ? per_page : 20;
		this.page = page ? page : 1;
		this.sort = sort;
		this.q = q;
		this.tags = tags;
	}

	function ClientModel(client) {
		if (!client) {
			client = {};
		}
		this.certification = client.certification ? client.certification : null;
		if (client.name) {
			this.name = client.name;
		}

		this.nr_univoco = client.nr_univoco ? client.nr_univoco : null;
		if (client.organisation && client.organisation.id) {
			client.organisation_id = client.organisation.id;
		}
		this.organisation_id = parseInt(client.organisation_id);
		this.pec_mail = client.pec_mail ? client.pec_mail : null;
		this.tags = client.tags ? client.tags : [];
		this.tax_nr_1 = client.tax_nr_1 ? client.tax_nr_1 : null;
		this.tax_nr_2 = client.tax_nr_2 ? client.tax_nr_2 : null;
		this.type = client.type ? client.type : 'PRIVATE';
		//if no blocked value is specified explicitly set is_blocked to false
		this.is_blocked = client.is_blocked ? true : false;
	}

	function getClient(id) {
		var delay = $q.defer();
		ApiInterface.get('clients/' + id).then(function(response) {
			var client = response;
			for (var tagIndex = 0; tagIndex < client.tags.length; tagIndex++) {
				var tag = client.tags[tagIndex];
				if (tag == 'OSMIPRO') {
					client.isFarmer = true;
				}
			}
			factory.activeClient = client;
			delay.resolve(client);
		});

		return delay.promise;
	}

	/**
	 * Sends a client search request to the clientsapi with the values received from the tableSetup variable
	 * and returns all the matching clients.
	 * @param {QueryModel} tableSetup:
	 * @returns {*}
	 */

	function searchClients(tableSetup) {
		return ApiInterface.get('clients', { params: tableSetup });
	}
	/**
	 * updates a client.
	 * @param {ClientModel} client:
	 * @param {int} id
	 * @returns {*}
	 */
	function update(id, client) {
		var data = new ClientModel(client);
		return ApiInterface.update('clients', id, data);
	}
	/**
	 * creates a client.
	 * @param {ClientModel} client:
	 * @returns {*}
	 */
	function create(client) {
		return ApiInterface.create('clients', client);
	}
	/**
	 * delets a client.
	 * @param {int} clientId:
	 * @returns {*}
	 */
	function erase(clientId) {
		return ApiInterface.erase('clients', clientId);
	}

	function updateClientProduct(product) {
		return $http
			.post(SETTINGS.APIBasePath + 'product/update', {
				data: product
			})
			.then(function(response) {
				return $q.resolve(response);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
				return $q.rejected(error.data.msg);
			});
	}
	/**
	 * checks to see if a client has a specified tag and adds it if its missing.
	 * @param {ClientModel} client
	 * @param {string} tag
	 * @returns void
	 */
	function addTag(client, tag) {
		if (!client.tags) {
			client.tags = [];
		}
		//check if the client has the tag
		var hasTag = false;
		for (var ci = 0; ci < client.tags.length; ci++) {
			if (client.tags[ci] == tag) {
				hasTag = true;
			}
		}
		//if the client does not have the tag, update the client to include the tag
		if (!hasTag) {
			client.tags.push(tag);
			update(client.id, client).then(
				function() {
					NotifyUser('The tag "' + tag + '" has been added to client ' + client.id);
				},
				function() {
					NotifyUser('unable to add tag "' + tag + '" to client ' + client.id, true);
					client.tags.pop();
				}
			);
		}
	}
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.language.factory.js
 * @description
 * # language.factory.js
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('languageFactory', languageFactory);

function languageFactory($http, $q, $log, SETTINGS) {
	var model = { query: query, languages: [], getLanguage: getLanguage };

	return model;

	function query(callBack) {
		var delay = $q.defer();

		if (model.languages.length) {
			callBack(model.languages);
			delay.resolve(model.languages);
			return model;
		}

		$http.get(SETTINGS.APIBasePath + 'languages').then(function(result) {
			model.languages = result.data;
			callBack(result.data);
			delay.resolve(model.languages);
		});
		return delay.promise;
	}

	function getLanguage(language) {
		var delay = $q.defer();
		query(function(result) {
			var returnLanguage, defaultLanguage;
			for (var i = 0; i < result.length; i++) {
				if (result[i].DEFLT == 'Y') {
					defaultLanguage = result[i];
				}
				if (
					language &&
					((result[i].ID && result[i].ID == language) ||
						(result[i].code &&
							result[i].code.toUpperCase() == language.toUpperCase()))
				) {
					returnLanguage = result[i];
				}
			}

			delay.resolve(returnLanguage ? returnLanguage : defaultLanguage);
		});
		return delay.promise;
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:address.directive
 * @description
 * # address.directive
 */
angular
	.module('wildBieneHarvestApp')
	.directive('badmAddress', function(
		$mdDialog,
		NotifyUser,
		ConfirmUser,
		AddressFactory,
		ClientFactory
	) {
		return {
			restrict: 'EA',
			templateUrl: 'views/address-directive.html',
			link: function postLink(scope) {
				scope.addresses = AddressFactory.getAdditionalAddresses(
					ClientFactory.activeClient.addresses
				);
				scope.editAddress = editAddress;
				scope.deleteAddress = deleteAddress;

				function editAddress(address) {
					$mdDialog
						.show({
							controller: 'AddressmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/address-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false,
							locals: {
								address: address,
								client: ClientFactory.activeClient,
								countryCode: scope.countryCode
							},
							resolve: {
								countries: function(AllCountries) {
									return AllCountries();
								}
							}
						})
						.then(function() {
							ClientFactory.getClient(ClientFactory.activeClient.id).then(function(
								client
							) {
								scope.addresses = AddressFactory.getAdditionalAddresses(
									client.addresses
								);
								AddressFactory.updateClientAddresses(client.addresses);
							});
						});
				}

				function deleteAddress(address) {
					ConfirmUser(
						'Delete Address ' + address.id,
						'Are you sure you wish to delete this <strong>' +
							address.tags +
							'</strong> address?',
						function() {
							AddressFactory.erase(ClientFactory.activeClient.id, address.id).then(
								function() {
									var addressSplice;
									for (
										var addressIndex = 0;
										addressIndex < scope.addresses.length;
										addressIndex++
									) {
										if (scope.addresses[addressIndex].id == address.id) {
											addressSplice = addressIndex;
										}
									}
									scope.addresses.splice(addressSplice, 1);
									AddressFactory.updateClientAddresses(scope.addresses);
								},
								function(error) {
									NotifyUser(error.data.detail);
								}
							);
						}
					);
				}
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.contact.factory
 * @description
 * # contact.factory
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').service('ContactFactory', ContactFactory);

function ContactFactory($q, ApiInterface, NotifyUser) {
	var factory = {
		ContactModel: ContactModel,
		getBillingContact: getBillingContact,
		getShippingContact: getShippingContact,
		create: create,
		update: update,
		erase: erase,
		searchContacts: searchContacts,
		getAdditionalContacts: getAdditionalContacts,
		checkContactExists: checkContactExists
	};
	return factory;

	function ContactModel(contact) {
		if (!contact) {
			contact = {};
		}
		this.birthday = contact.birthday
			? moment(contact.birthday).format('YYYY-MM-DD')
			: null;
		if (parseInt(contact.client_id)) {
			this.client_id = parseInt(contact.client_id);
		}
		this.email = contact.email ? contact.email : null;
		this.first_name = contact.first_name ? contact.first_name : null;
		this.language = contact.language
			? contact.language.toLowerCase() === 'en'
				? 'de'
				: contact.language.toLowerCase()
			: null;
		this.last_name = contact.last_name ? contact.last_name : null;
		this.mailing_preference = contact.mailing_preference
			? contact.mailing_preference
			: 'email';
		if (contact.phone_business) {
			this.phone_business = contact.phone_business;
		}
		if (contact.phone_mobile) {
			this.phone_mobile = contact.phone_mobile;
		}
		if (contact.phone_mobile == '') {
			this.phone_mobile = null;
		}
		if (contact.phone_private) {
			this.phone_private = contact.phone_private;
		}
		this.tags = contact.tags ? contact.tags : [];
	}
	/**
	 * creates contact.
	 * @param {ContactModel} client:
	 * @returns {*}
	 */
	function create(contact) {
		var data = new ContactModel(contact);
		return ApiInterface.create('contacts', data);
	}
	/**
	 * updates a contact.
	 * @param {ContactModel} contact:
	 * @param {int} id
	 * @returns {*}
	 */
	function update(id, contact) {
		var data = new ContactModel(contact);
		return ApiInterface.update('contacts', id, data);
	}
	/**loops through the contacts and returns the first contact tagged as the billing contact
	 * @param {[contact]} contacts
	 * @returns {*}
	 */
	function getBillingContact(contacts) {
		if (!contacts || !contacts.length) {
			return null;
		}
		for (var contactIndex = 0; contactIndex < contacts.length; contactIndex++) {
			var contact = contacts[contactIndex];
			for (var tagIndex = 0; tagIndex < contact.tags.length; tagIndex++) {
				if (contact.tags[tagIndex] == 'BILLING') {
					return contact;
				}
			}
		}
		return null;
	}
	/**loops through the contacts and returns the first contact tagged as the shipping contact
	 * @param {[contact]} contacts
	 * @returns {*}
	 */
	function getShippingContact(contacts) {
		for (var contactIndex = 0; contactIndex < contacts.length; contactIndex++) {
			var contact = contacts[contactIndex];
			for (var tagIndex = 0; tagIndex < contact.tags.length; tagIndex++) {
				if (contact.tags[tagIndex] == 'SHIPPING') {
					return contact;
				}
			}
		}
		return {};
	}
	/**
	 * Accepts and array of contacts and returns an array of all contacts that do not have a billing tag
	 * @param {array} contactList
	 * @returns {array}
	 */
	function getAdditionalContacts(contactList) {
		var additionalContacts = [];
		for (var index = 0; index < contactList.length; index++) {
			var contact = contactList[index];
			if (contact.tags.length) {
				for (var tagIndex = 0; tagIndex < contact.tags.length; tagIndex++) {
					var tag = contact.tags[tagIndex];
					if (tag.toLowerCase() != 'billing') {
						additionalContacts.push(contact);
					}
				}
			} else {
				additionalContacts.push(contact);
			}
		}
		return additionalContacts;
	}
	/**
	 * updates a contact.
	 * @param {int} id
	 * @returns {*}
	 */
	function erase(id) {
		var delay = $q.defer();
		var returnErase = ApiInterface.erase('contacts', id);
		searchContacts({ q: id }).then(function(data) {
			var deleted = true;
			angular.forEach(data.items, function(item) {
				if (item.id == id) {
					deleted = false;
				}
			});
			if (deleted === false) {
				NotifyUser('Contact delete was unsuccessful');
			} else {
				NotifyUser('Contact successfully deleted');
			}
			delay.resolve(returnErase);
		});
		return delay.promise;
	}

	/**
	 * Sends a contact search request to the clientsapi with the values received from the tableSetup variable
	 * and returns all the matching contacts.
	 * @param {QueryModel} tableSetup:
	 * @returns {*}
	 */

	function searchContacts(tableSetup) {
		return ApiInterface.get('contacts', { params: tableSetup });
	}

	function checkContactExists(filterField, filterText) {
		var delay = $q.defer();
		if (angular.isDefined(filterText) && filterText) {
			var tableSetup = {};
			if (filterField == 'phone') {
				tableSetup.phone_mobile = filterText;
			} else if (filterField == 'email') {
				tableSetup.email = filterText;
			} else {
				tableSetup.q = filterText;
			}

			searchContacts(tableSetup).then(function(data) {
				delay.resolve(data.total_count < 1);
			});
		} else {
			delay.resolve(false);
		}
		return delay.promise;
	}
}

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:AddressmodalCtrl
 * @description
 * # AddressmodalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('AddressmodalCtrl', function(
		$scope,
		$mdDialog,
		ClientFactory,
		OrganisationFactory,
		AddressFactory,
		ContactFactory,
		NotifyUser,
		address,
		client
	) {
		$scope.cancel = cancel;
		$scope.defaultCountry = 'ch';
		$scope.address = address || { tags: [] };
		$scope.saveAddress = saveAddress;

		function init() {
			if (!$scope.address.id) {
				var primaryContact = ContactFactory.getBillingContact(client.contacts);
				if (primaryContact) {
					$scope.address.first_name = primaryContact.first_name;
					$scope.address.last_name = primaryContact.last_name;
					if (client.type.toLowerCase() === 'company') {
						$scope.address.company_name = client.name;
					}
				}
				getDefaultCountry();
			} else {
				$scope.defaultCountry = $scope.address.country;
			}
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function getDefaultCountry() {
			if (client && client.organisation) {
				OrganisationFactory.getCountryCode(client.organisation.id).then(function(
					code
				) {
					$scope.defaultCountry = code;
				});
			}
		}

		function saveAddress() {
			var addressData = new AddressFactory.AddressModel($scope.address);
			if (!$scope.address.id) {
				AddressFactory.create(client.id, addressData).then(
					$mdDialog.hide,
					handleError
				);
			} else {
				var id = $scope.address.id;
				AddressFactory.update(client.id, id, addressData).then(
					$mdDialog.hide,
					handleError
				);
			}
		}

		function handleError(error) {
			NotifyUser(error.data.detail);
		}

		init();
	});

'use strict';
/**
 * @ngdoc service
 * @name wildBieneHarvestApp.AddressFactory
 * @description
 * # AddressFactory
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('AddressFactory', AddressFactory);

function AddressFactory($http, $q, ApiInterface, SETTINGS) {
	var factory = {
		AddressModel: AddressModel,
		create: create,
		update: update,
		erase: erase,
		getBillingAddress: getBillingAddress,
		getGoogleAutoComplete: getGoogleAutoComplete,
		getGoogleDetails: getGoogleDetails,
		getAdditionalAddresses: getAdditionalAddresses,
		updateClientAddresses: updateClientAddresses,
		listeners: [],
		registerListener: registerListener,
		getAddressById: getAddressById
	};
	return factory;

	function AddressModel(data) {
		if (!data) {
			data = {};
		}
		this.address_1 = data.address_1 ? data.address_1 : null;
		this.address_2 = data.address_2 ? data.address_2 : null;
		this.company_name = data.company_name ? data.company_name : null;
		this.country_code = data.country_code
			? data.country_code.toUpperCase()
			: null;
		this.first_name = data.first_name ? data.first_name : null;
		if (data.google_place_id) {
			this.google_place_id = data.google_place_id ? data.google_place_id : null;
		}
		this.last_name = data.last_name ? data.last_name : null;
		this.postal_code = data.postal_code ? data.postal_code : null;
		this.tags = data.tags ? data.tags : [];
		if (!Array.isArray(this.tags)) {
			this.tags = [this.tags];
		}
		this.town = data.town ? data.town : null;
	}
	/**
	 * creates an address.
	 * @param {AddressInfo} :
	 * @returns {*}
	 */
	function create(clientId, addressInfo) {
		var data = new AddressModel(addressInfo);
		return ApiInterface.create('clients/' + clientId + '/addresses', data);
	}
	/**
	 * updates an address.
	 * @param {AddressModel} address:
	 * @param {int} id
	 * @returns {*}
	 */
	function update(clientId, id, addressInfo) {
		return ApiInterface.update(
			'clients/' + clientId + '/addresses',
			id,
			addressInfo
		);
	}
	/**
	 * delete an address.
	 * @param {int} clientId
	 * @param {int} id
	 * @returns {*}
	 */
	function erase(clientId, id) {
		return ApiInterface.erase('clients/' + clientId + '/addresses', id);
	}

	function getBillingAddress(addressList) {
		if (!addressList) {
			return null;
		}
		for (var index = 0; index < addressList.length; index++) {
			var address = addressList[index];
			for (var tagIndex = 0; tagIndex < address.tags.length; tagIndex++) {
				var tag = address.tags[tagIndex];
				if (tag.toLowerCase() == 'billing') {
					return address;
				}
			}
		}
		return null;
	}
	function getAddressById(addressList, addressId) {
		for (var index = 0; index < addressList.length; index++) {
			var address = addressList[index];
			if (address.id == addressId) {
				return address;
			}
		}
		return null;
	}

	/**
	 * Accepts and array of addresses and returns an array of all addresses that do not have a billing tag
	 * @param {array} addressList
	 * @returns {array}
	 */
	function getAdditionalAddresses(addressList) {
		var additionalAdresses = [];
		for (var index = 0; index < addressList.length; index++) {
			var address = addressList[index];
			if (!address.tags.length) {
				additionalAdresses.push(address);
			} else {
				for (var tagIndex = 0; tagIndex < address.tags.length; tagIndex++) {
					var tag = address.tags[tagIndex];
					if (tag.toLowerCase() != 'billing') {
						additionalAdresses.push(address);
					}
				}
			}
		}
		return additionalAdresses;
	}

	/**
	 * Provides details for a google 'place' object.
	 * @param {Place} place
	 * @returns {*}
	 */

	function parseGoogleData(addressComponents) {
		var arr = {};
		addressComponents.forEach(function(value) {
			if (value.types.includes('route')) {
				arr.address = value.long_name;
			}

			if (value.types.includes('street_number')) {
				arr.street_number = value.long_name;
			}

			if (value.types.includes('postal_code')) {
				arr.postal_code = value.long_name.replace(/ /g, '');
			}

			if (value.types.includes('country')) {
				arr.country = value.short_name;
			}

			if (value.types.includes('locality')) {
				arr.town = value.long_name;
			}

			if (value.types.includes('sublocality_level_1')) {
				arr.sublocality_level_1 = value.long_name;
			}

			if (value.types.includes('administrative_area_level_1')) {
				arr.administrative_area_level_1 = value.long_name;
				arr.administrative_area_level_1_short = value.short_name;
			}

			if (value.types.includes('administrative_area_level_2')) {
				arr.administrative_area_level_2 = value.long_name;
			}

			if (value.types.includes('administrative_area_level_3')) {
				arr.administrative_area_level_3 = value.long_name;
			}
		});
		return arr;
	}

	function getGoogleAutoComplete(countries, search) {
		return $http
			.get(
				SETTINGS.v2APIBasePath +
					'google-places/autocomplete?input=' +
					search +
					'&country_code=' +
					countries
			)
			.then(function(response) {
				var towns = [];
				var status = response.data.status;
				if (status === 'OK') {
					towns = response.data.predictions;
				} else if (status === 'ZERO_RESULTS') {
					towns = [];
				}
				return towns;
			});
	}

	function getGoogleDetails(place) {
		return $http
			.get(
				SETTINGS.v2APIBasePath + 'google-places/details?place_id=' + place.place_id
			)
			.then(function(result) {
				var addressComponents = result.data.result.address_components;
				var details = parseGoogleData(addressComponents);
				return details;
			});
	}

	function registerListener(listener) {
		factory.listeners.push(listener);
	}

	function notifyListeners(data) {
		for (var i = 0; i < factory.listeners.length; i++) {
			factory.listeners[i](data);
		}
	}

	//function that should notify listeners
	function updateClientAddresses(addresses) {
		notifyListeners(addresses);
	}
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.ApiInterface.factory
 * @description
 * # ApiInterface.factory
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('ApiInterface', function($q, $http, SETTINGS, NotifyUser) {
		var factory = {
			get: get,
			phpGet: phpGet,
			create: create,
			update: update,
			fetch: fetch,
			erase: erase,
			QueryModel: QueryModel,
			PageLimitOptionsModel: PageLimitOptionsModel
		};
		var basePath = SETTINGS.v2APIBasePath;
		var phpBasePath = SETTINGS.APIBasePath;
		return factory;

		function QueryModel(q, sort, tags, per_page, page) {
			this.per_page = per_page ? per_page : 20;
			this.page = page ? page : 1;
			this.sort = sort;
			this.q = q;
			this.tags = tags;
		}

		function PageLimitOptionsModel(page_limit_options) {
			this.page_limit_options = page_limit_options
				? page_limit_options
				: [20, 50, 100];
		}

		function get(route, data) {
			var delay = $q.defer();
			$http.get(basePath + route, data).then(
				function(res) {
					delay.resolve(res.data);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}

		function phpGet(route, data) {
			var delay = $q.defer();
			$http.get(phpBasePath + route, data).then(
				function(res) {
					delay.resolve(res.data);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}
		/**
		 * creates contact.
		 * @param {ContactModel} client:
		 * @returns {*}
		 */
		function create(route, data) {
			var delay = $q.defer();
			$http.post(basePath + route, data).then(
				function(res) {
					delay.resolve(res);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}
		/**
		 * creates contact.
		 * @param {ContactModel} client:
		 * @returns {*}
		 */
		function fetch(route, data) {
			var delay = $q.defer();
			$http.post(phpBasePath + route, data).then(
				function(res) {
					delay.resolve(res);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}
		/**
		 * updates a contact.
		 * @param {int} id
		 * @returns {*}
		 */
		function update(route, id, data) {
			var delay = $q.defer();
			$http.put(basePath + route + '/' + id, data).then(
				function(res) {
					delay.resolve(res);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}
		/**
		 * Deletes the resource.
		 * @param {int} id
		 * @returns {*}
		 */
		function erase(route, id) {
			var delay = $q.defer();
			$http.delete(basePath + route + '/' + id).then(
				function(res) {
					delay.resolve(res);
				},
				function(error) {
					NotifyUser(error.data.detail);
					delay.reject(error.data);
				}
			);
			return delay.promise;
		}
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:AddressForm.directive
 * @description
 * # addressForm.directive
 */
angular
	.module('wildBieneHarvestApp')
	.directive('addressForm', function(AddressFactory, AllCountries) {
		return {
			templateUrl: 'views/address-form.html',
			restrict: 'EA',
			scope: {
				address: '=address',
				countryCode: '=countryCode',
				optionalFields: '=optionalFields'
			},
			link: function postLink(scope) {
				scope.addressAutocomplete = addressAutocomplete;
				scope.selectedPlace = selectedPlace;
				scope.checkOptionalFields = checkOptionalFields;
				//stores the value of the scope.optionalFields
				var allowOptionalFields = scope.optionalFields;
				scope.$watch('searchString', function(typedValue) {
					scope.address.address_1 = typedValue ? typedValue : null;
				});

				function init() {
					if (scope.address.address_1) {
						scope.searchString = scope.address.address_1;
					}
					AllCountries().then(function(data) {
						scope.countries = data;
						var countryCode = scope.countryCode;
						if (scope.address && scope.address.country_code) {
							countryCode = scope.address.country_code;
						}
						selectCountry(countryCode);
					});
				}
				function checkOptionalFields() {
					if (scope.address.address_1 || scope.address.postal_code) {
						scope.optionalFields = false;
					} else {
						scope.optionalFields = allowOptionalFields;
					}
				}
				function selectCountry(countryCode) {
					for (var i = 0; i < scope.countries.length; i++) {
						var element = scope.countries[i];
						if (element.code.toLowerCase() == countryCode.toLowerCase()) {
							scope.country = element;
							scope.address.country_code = element.code.toLowerCase();
						}
					}
				}
				function addressAutocomplete(searchString) {
					scope.address.address_1 = searchString;
					return AddressFactory.getGoogleAutoComplete(
						scope.address.country_code,
						searchString
					);
				}
				function selectedPlace(place) {
					if (place && place.place_id) {
						scope.address.google_place_id = place.place_id;
						scope.address.address_1 = place.structured_formatting.main_text;
						AddressFactory.getGoogleDetails(place).then(function(data) {
							scope.address.postal_code = data.postal_code;
							scope.address.town = data.town;
						});
					}
				}

				init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:customerHistory
 * @description
 * # customerHistory
 */
angular
	.module('wildBieneHarvestApp')
	.directive('historyDirective', function(
		$http,
		$stateParams,
		$timeout,
		ClientFactory,
		ApiInterface,
		userService,
		SETTINGS
	) {
		return {
			templateUrl: 'views/history-directive.html',
			scope: {
				clientId: '=',
				contacts: '=',
				onHistoryTab: '='
			},
			link: function postLink(scope) {
				scope.getHistory = getHistory;

				scope.query = new ApiInterface.QueryModel();
				scope.query.per_page = 50;
				scope.pageLimitOptions = new ApiInterface.PageLimitOptionsModel([
					5,
					10,
					20,
					50
				]).page_limit_options;

				userService.all().then(function(users) {
					scope.users = users;

					// Add firebase users to users dict
					angular.forEach(scope.contacts, function(contact) {
						scope.users[contact.firebase_id] = {
							fullName: contact.first_name + ' ' + contact.last_name
						};
					});
				});

				if ($stateParams.object) {
					getHistory();
				}

				function success(response) {
					scope.history = [];
					scope.historyCount = 0;
					if (response.data.items) {
						scope.history = response.data.items;
						scope.historyCount = response.data.total_count;
						scope.query.page = response.data.page;

						// Force fetching service accounts
						angular.forEach(scope.history, function(item) {
							userService.get(item.updated_by);
						});
					}
					return true;
				}

				function getHistory() {
					var params = {
						data_type: $stateParams.object || 'Client',
						id: $stateParams.id || scope.clientId,
						page: scope.query.page,
						per_page: scope.query.per_page
					};
					scope.promise = $http
						.get(SETTINGS.historyAPIBasePath + 'history', { params: params })
						.then(success);
				}

				scope.$watch('onHistoryTab', function(data) {
					if (data) {
						getHistory();
					}
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:clientCulture
 * @description
 * # clientCulture
 */
angular
	.module('wildBieneHarvestApp')
	.directive('clientCulturesDirective', function(
		clientCulturesFactory,
		$filter,
		$timeout,
		ConfirmUser,
		Session
	) {
		return {
			templateUrl: 'views/client-cultures-directive.html',
			scope: {
				clientId: '=',
				hasCultures: '='
			},
			link: function postLink(scope) {
				scope.cultureTypes = Session.cultureTypes;

				function init() {
					scope.selectedCulture = {};
					scope.isEditing = false;
					getClientCultures();
				}

				function success(data) {
					scope.cultures = data;
					scope.hasCultures = scope.cultures.length > 0;
					numericFormat();
					disableAll();
					return true;
				}

				function getClientCultures() {
					scope.promise = clientCulturesFactory
						.getClientCultures(scope.clientId)
						.then(success);
				}

				function numericFormat() {
					for (var i = 0; i < scope.cultures.length; i++) {
						scope.cultures[i].size = Number(scope.cultures[i].size);
					}
				}

				function disableAll() {
					for (var i = 0; i < scope.cultures.length; i++) {
						scope.cultures[i].editable = false;
					}
					scope.isEditing = false;
				}

				scope.removeCultureFocus = function(event, index) {
					if (event.keyCode == 27) {
						scope.cultures[index] = scope.selectedCulture;
						disableAll();
					}
				};

				scope.inUse = function(cultureID) {
					var arr = scope.cultures;
					if (cultureID != scope.selectedCulture.cultureTypeID) {
						for (var i = 0; i < arr.length; i++) {
							if (angular.equals(arr[i].cultureTypeID, cultureID)) {
								return true;
							}
						}
					}
					return false;
				};

				scope.querySearch = function(query, field) {
					return $filter('autoCompleteSearch')(scope.cultureTypes, query, field);
				};

				scope.editRow = function(culture) {
					if (scope.cultureForm.$valid && scope.isEditing === false) {
						var index = scope.cultures.indexOf(culture);
						disableAll();
						scope.cultures[index].editable = true;
						scope.isEditing = true;
						scope.selectedCulture = culture;
						for (var i = 0; i < scope.cultureTypes.length; i++) {
							if (scope.cultureTypes[i].ID == culture.cultureTypeID) {
								scope.selectedCulture.selectedCultureType = scope.cultureTypes[i];
							}
						}
					}
				};
				scope.addRow = function() {
					scope.cultures.unshift({});
					scope.editRow(scope.cultures[0]);
				};

				scope.saveRow = function(cultureRow) {
					if (scope.cultures == null) {
						scope.cultures = [];
					}
					if (!cultureRow.selectedCultureType) {
						cultureRow.selectedCultureType = {
							ID: 1
						};
					}
					if (!cultureRow.cropType) {
						cultureRow.cropType = {
							ID: 1
						};
					}

					var postData = {
						ID: cultureRow.ID,
						clientID: scope.clientId,
						cultureTypeID: cultureRow.selectedCultureType.ID,
						size: cultureRow.size
					};

					clientCulturesFactory.save(postData).then(init);
				};

				scope.deleteRow = function(cultureID) {
					if (cultureID) {
						ConfirmUser(
							'Deleting Culture',
							'Are you sure you wish to continue?',
							function() {
								clientCulturesFactory.remove(cultureID).then(init);
							}
						);
					} else {
						scope.cultures.splice(0, 1);
						init();
					}
				};

				$timeout(function() {
					init();
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.clientCulturesFactory
 * @description
 * # clientCulturesFactory
 * Factory in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('clientCulturesFactory', clientCulturesFactory);

function clientCulturesFactory($http, $q, NotifyUser, SETTINGS) {
	var service = {
		getClientCultures: getClientCultures,
		save: save,
		remove: remove
	};

	return service;

	function getClientCultures(id) {
		var delay = $q.defer();
		$http
			.get(SETTINGS.APIBasePath + 'cultures/' + id)
			.then(function(response) {
				var cultures = response.data.cultures;
				delay.resolve(cultures);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
	function save(culture) {
		var delay = $q.defer();
		$http
			.post(SETTINGS.APIBasePath + 'culture', {
				data: culture
			})
			.then(
				function(res) {
					delay.resolve(res.data.cultures);
				},
				function(error) {
					NotifyUser(error.data.msg);
				}
			);
		return delay.promise;
	}
	function remove(id) {
		var delay = $q.defer();
		$http
			.delete(SETTINGS.APIBasePath + 'culture/' + id)
			.then(function() {
				delay.resolve(true);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:clientNotesDirective
 * @description
 * # clientNotesDirective
 */
angular
	.module('wildBieneHarvestApp')
	.directive('clientNotesDirective', function(
		clientNotesFactory,
		$filter,
		$timeout,
		ConfirmUser,
		Session,
		filterFilter,
		userService
	) {
		return {
			templateUrl: 'views/client-notes-directive.html',
			scope: {
				clientId: '=',
				clientProducts: '=',
				hasNotes: '=',
				activeCode: '='
			},
			link: function postLink(scope) {
				scope.filterActiveCode = filterActiveCode;
				scope.addRow = addRow;
				scope.noteFilters = { category: null, tags: [] };

				var activeHouseId = null;

				if (Session.noteReferences && Session.noteReferences.length > 0) {
					scope.refTypes = Session.noteReferences;
				} else {
					Session.getNoteReferences().then(function(data) {
						scope.refTypes = data;
					});
				}

				function init() {
					scope.selectedNote = {};
					scope.isEditing = false;
					activeHouseId = scope.activeCode ? getHouseId(scope.activeCode) : null;
					loadClientNotes().then(addNewRowIfEmpty);
					clientNotesFactory.registerListener(success);
					userService.all().then(function(users) {
						scope.users = users;
					});
				}

				function setNotesUserDisplay() {
					angular.forEach(scope.notes, function(note, noteIndex) {
						var userVar = note.UPD_BY ? note.UPD_BY : note.CRE_BY;
						scope.notes[noteIndex].displayName = scope.users[userVar]
							? scope.users[userVar].fullName
							: userVar;
					});
				}

				function success(data) {
					scope.notes = data;
					angular.forEach(scope.notes, function(note) {
						note.SEASON = note.SEASON ? parseInt(note.SEASON, 10) : null;
					});
					sortNotes();
					scope.hasNotes = scope.notes.length > 0;
					setNotesUserDisplay();
					disableAll();
					setNoteDisplayFlag();
					return true;
				}

				/**
				 * When there are no existing notes for an active code
				 * then add and empty row for convenience.
				 */
				function addNewRowIfEmpty() {
					if (activeHouseId) {
						var filteredNotes = filterFilter(scope.notes, {
							HOUSE_ID: activeHouseId
						});
						if (filteredNotes.length === 0) {
							addRow();
						}
					}
				}

				function loadClientNotes() {
					scope.promise = clientNotesFactory
						.getClientNotes(scope.clientId)
						.then(success);
					return scope.promise;
				}

				function loadCategories() {
					scope.categoryDisplay = {};
					for (var i = 0; scope.refTypes.CATEGORIES.length > i; i++) {
						scope.categoryDisplay[scope.refTypes.CATEGORIES[i].ID] = {
							colour: scope.refTypes.CATEGORIES[i].COLOUR,
							text: scope.refTypes.CATEGORIES[i].DESCRIPTION
						};
					}
				}

				function loadTags() {
					scope.tagDisplay = {};
					// eslint-disable-next-line no-redeclare
					for (var i = 0; scope.refTypes.TAGS.length > i; i++) {
						scope.tagDisplay[scope.refTypes.TAGS[i].ID] = {
							text: scope.refTypes.TAGS[i].DESCRIPTION
						};
					}
				}

				function disableAll() {
					for (var i = 0; i < scope.notes.length; i++) {
						scope.notes[i].editable = false;
					}
					scope.isEditing = false;
				}

				function setNoteDisplayFlag() {
					if (scope.clientProducts) {
						var seasonStart = new Date(Session.harvestSeason, 6, 1);
						var seasonEnd = new Date(Number(Session.harvestSeason) + 1, 5, 30);
						angular.forEach(scope.clientProducts, function(product, productIndex) {
							scope.clientProducts[productIndex].displayNoteFlag = false;
							angular.forEach(scope.notes, function(note) {
								if (product.ID == note.HOUSE_ID) {
									var createdAt = new Date(note.CRE_AT);
									if (createdAt >= seasonStart && createdAt <= seasonEnd) {
										scope.clientProducts[productIndex].displayNoteFlag = true;
									}
								}
							});
						});
					}
				}

				function filterActiveCode(note) {
					return !activeHouseId || note.HOUSE_ID == activeHouseId;
				}

				/**
				 * Notes that are not yet executed come first, newest to oldest,
				 * followed by executed notes, newest to oldest.
				 */
				function sortNotes() {
					scope.notes.sort(function(a, b) {
						var aDone = a.COMPLETED_AT ? 1 : 0;
						var bDone = b.COMPLETED_AT ? 1 : 0;
						if (aDone !== bDone) {
							return aDone - bDone;
						}
						return noteTimestamp(b) - noteTimestamp(a);
					});
				}

				function noteTimestamp(note) {
					var date = note.UPD_AT || note.CRE_AT;
					return date ? new Date(date).getTime() : 0;
				}

				scope.filterNotes = function(note) {
					if (!filterActiveCode(note)) {
						return false;
					}
					if (note.editable) {
						return true;
					}
					if (
						scope.noteFilters.category &&
						parseInt(note.CATEGORY_ID) !== parseInt(scope.noteFilters.category)
					) {
						return false;
					}
					if (scope.noteFilters.tags.length > 0) {
						var selectedTagIds = scope.noteFilters.tags.map(Number);
						var hasTag = false;
						angular.forEach(note.TAGS, function(tag) {
							if (selectedTagIds.indexOf(parseInt(tag.ID)) !== -1) {
								hasTag = true;
							}
						});
						return hasTag;
					}
					return true;
				};

				scope.filterTagOption = function(tag) {
					return (
						!scope.noteFilters.category ||
						parseInt(tag.CATEGORY_ID) === parseInt(scope.noteFilters.category)
					);
				};

				scope.toggleCompleted = function(note) {
					if (!note.ID || scope.isEditing) {
						return;
					}
					note.COMPLETED_AT = note.COMPLETED_AT
						? null
						: moment().format('YYYY-MM-DD');
					clientNotesFactory
						.save({ note: note, clientID: scope.clientId })
						.then(init);
				};

				scope.removeNoteFocus = function(event, note) {
					if (event.keyCode == 27) {
						var index = scope.notes.indexOf(note);
						scope.notes[index] = scope.selectedNote;
						disableAll();
					}
				};

				scope.populateTags = function(category, note) {
					scope.refTypes.tagList = [];
					if (category) {
						if (parseInt(category.ID) !== parseInt(scope.selectedNote.CATEGORY_ID)) {
							note.TAGS = [];
						} else {
							note.TAGS = scope.selectedNote.TAGS;
						}
						// eslint-disable-next-line no-redeclare
						for (var i = 0; scope.refTypes.TAGS.length > i; i++) {
							if (
								parseInt(scope.refTypes.TAGS[i].CATEGORY_ID) === parseInt(category.ID)
							) {
								scope.refTypes.tagList.push(scope.refTypes.TAGS[i]);
							}
						}
					}
				};

				scope.isChecked = function(haystack, type, needle) {
					var exists = false;
					angular.forEach(haystack, function(bunch) {
						if (bunch[type] == needle) {
							exists = true;
						}
					});
					return exists;
				};

				scope.getHouseCode = function(hid) {
					var returnValue = '-';
					angular.forEach(scope.clientProducts, function(product) {
						if (parseInt(product.ID) === parseInt(hid)) {
							returnValue = product.code;
						}
					});
					return returnValue;
				};

				function getHouseId(houseCode) {
					var returnValue = null;
					angular.forEach(scope.clientProducts, function(product) {
						if (product.code === houseCode) {
							returnValue = product.ID;
						}
					});
					return returnValue;
				}

				scope.editRow = function(note) {
					if (scope.noteForm.$valid && scope.isEditing === false) {
						var index = scope.notes.indexOf(note);
						disableAll();
						scope.notes[index].editable = true;
						scope.isEditing = true;
						scope.selectedNote = angular.copy(note);
					}
				};

				function addRow() {
					var newRow = {};
					if (scope.activeCode) {
						newRow = { HOUSE_ID: getHouseId(scope.activeCode) };
					}
					if (Session.harvestSeason) {
						newRow.SEASON = parseInt(Session.harvestSeason, 10);
					}
					scope.notes.unshift(newRow);
					scope.editRow(scope.notes[0]);
				}

				scope.saveRow = function(noteRow) {
					if (noteRow !== scope.selectedNote) {
						if (noteRow.house) {
							noteRow.HOUSE_ID = noteRow.house.ID;
						}
						var postData = {
							note: noteRow,
							clientID: scope.clientId
						};

						clientNotesFactory.save(postData).then(init);
					}
				};

				scope.deleteRow = function(noteID) {
					if (noteID) {
						ConfirmUser(
							'Deleting Note',
							'Are you sure you wish to continue?',
							function() {
								clientNotesFactory.remove(noteID).then(init);
							}
						);
					} else {
						scope.notes.splice(0, 1);
						init();
					}
				};

				scope.$watch('clientProducts', setNoteDisplayFlag);
				scope.$watch('refTypes', function(data) {
					if (data) {
						scope.refTypes = data;
						loadCategories();
						loadTags();
					}
				});

				$timeout(init);
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.clientNotesFactory
 * @description
 * # clientNotesFactory
 * Factory in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('clientNotesFactory', clientNotesFactory);

function clientNotesFactory($http, $q, SETTINGS, NotifyUser) {
	var service = {
		getClientNotes: getClientNotes,
		save: save,
		remove: remove,
		reloadNotes: reloadNotes,
		listeners: [],
		registerListener: registerListener
	};

	return service;

	function getClientNotes(id) {
		var delay = $q.defer();
		$http
			.get(SETTINGS.APIBasePath + 'client/notes/' + id)
			.then(function(response) {
				var notes = response.data.notes;
				delay.resolve(notes);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
	function save(note) {
		var delay = $q.defer();
		$http
			.post(SETTINGS.APIBasePath + 'note', {
				data: note
			})
			.then(function() {
				delay.resolve(true);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
	function remove(id) {
		var delay = $q.defer();
		$http
			.delete(SETTINGS.APIBasePath + 'note/' + id)
			.then(function() {
				delay.resolve(true);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}

	function registerListener(listener) {
		service.listeners.push(listener);
	}

	function notifyListeners(data) {
		for (var i = 0; i < service.listeners.length; i++) {
			service.listeners[i](data);
		}
	}

	//function that should notify listeners
	function reloadNotes(id) {
		getClientNotes(id).then(function(notes) {
			notifyListeners(notes);
		});
	}
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.OrganisationFactory
 * @description
 * # OrganisationFactory
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('OrganisationFactory', OrganisationFactory);

function OrganisationFactory($q, organisations) {
	var factory = {
		getCountryCode: getCountryCode,
		query: getAll,
		getMap: getMap
	};
	var allOrganisations = [];
	return factory;

	function getCountryCode(orgId) {
		var delay = $q.defer();
		getAll().then(
			function(orgs) {
				var countryCode = '';
				for (var orgIndex = 0; orgIndex < orgs.length; orgIndex++) {
					var org = orgs[orgIndex];
					if (org.ID == orgId) {
						countryCode = org.country;
					}
				}
				delay.resolve(countryCode);
			},
			function(error) {
				delay.reject(error.data.detail);
			}
		);

		return delay.promise;
	}

	function getAll() {
		var delay = $q.defer();
		if (allOrganisations.length) {
			delay.resolve(allOrganisations);
		} else {
			organisations.query(
				function(orgs) {
					allOrganisations = orgs;
					delay.resolve(orgs);
				},
				function() {
					delay.reject('unable to fetch organisations');
				}
			);
		}
		return delay.promise;
	}

	function getMap() {
		return getAll().then(function(orgs) {
			var map = {};
			angular.forEach(orgs, function(org) {
				map[parseInt(org.ID)] = org.NAME;
			});
			return map;
		});
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:clientContactsDirective
 * @description
 * # clientContactsDirective
 */
angular
	.module('wildBieneHarvestApp')
	.directive('clientContactsDirective', function(
		ClientFactory,
		ContactFactory,
		ConfirmUser,
		$mdDialog
	) {
		return {
			templateUrl: 'views/client-contacts-directive.html',
			scope: {
				contacts: '=',
				clientId: '='
			},
			link: function postLink(scope) {
				scope.addNewContact = addNewContact;
				scope.getClientContacts = getClientContacts;
				scope.additionalContacts = ContactFactory.getAdditionalContacts(
					scope.contacts
				);

				function addNewContact() {
					var billingContact = ContactFactory.getBillingContact(
						ClientFactory.activeClient.contacts
					);
					var contact = new ContactFactory.ContactModel({
						language: billingContact ? billingContact.language : null
					});
					$mdDialog
						.show({
							controller: 'ContactModalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/contact.modal.html',
							parent: angular.element(document.body),
							locals: {
								contact: contact,
								clientId: scope.clientId
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(getClientContacts);
				}

				function success(data) {
					scope.additionalContacts = ContactFactory.getAdditionalContacts(
						data.contacts
					);
					return true;
				}

				function getClientContacts() {
					scope.promise = ClientFactory.getClient(scope.clientId).then(success);
				}

				scope.editRow = function(contact) {
					$mdDialog
						.show({
							controller: 'ContactModalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/contact.modal.html',
							parent: angular.element(document.body),
							locals: {
								contact: contact,
								clientId: scope.clientId
							},
							fullscreen: true,
							clickOutsideToClose: true
						})
						.then(getClientContacts);
				};

				scope.deleteRow = function(contactID) {
					ConfirmUser(
						'Deleting Contact',
						'Are you sure you wish to continue?',
						function() {
							ContactFactory.erase(contactID).then(getClientContacts);
						}
					);
				};
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:contactForm
 * @description
 * # contactForm
 */
angular
	.module('wildBieneHarvestApp')
	.directive('contactForm', function(
		AllOrganisations,
		languageFactory,
		ContactFactory
	) {
		return {
			templateUrl: 'views/contact.form.html',
			scope: {
				contact: '=',
				org: '=',
				farmer: '='
			},
			link: function postLink(scope) {
				var allLanguages;
				if (angular.isUndefined(scope.contact.mailing_preference)) {
					scope.contact.mailing_preference = 'EMAIL';
				}
				scope.existOriginalArray = {
					email: angular.copy(scope.contact.email),
					phone: angular.copy(scope.contact.phone_mobile)
				};
				//Set the phone number field to touched in order to show potential validation errors
				scope.contactForm.phone.$setTouched();
				scope.getInitialLanguage = getInitialLanguage;
				scope.checkContactExists = checkContactExists;
				function getInitialLanguage(language_code) {
					return (
						scope.contact.language &&
						scope.contact.language.toUpperCase() === language_code.toUpperCase()
					);
				}
				function checkContactExists(filterField, filterText) {
					scope.contactForm[filterField].$setValidity('awaitingResponse', false);
					if (
						(scope.existOriginalArray[filterField] &&
							filterText &&
							scope.existOriginalArray[filterField].toLowerCase() ==
								filterText.toLowerCase()) ||
						angular.isUndefined(filterText) ||
						!filterText
					) {
						scope.contactForm[filterField].$setValidity('awaitingResponse', true);
						scope.contactForm[filterField].$setValidity('exists', true);
						scope.contactForm[filterField].$setPristine();
					} else {
						ContactFactory.checkContactExists(filterField, filterText).then(function(
							data
						) {
							scope.contactForm[filterField].$setValidity('awaitingResponse', true);
							scope.contactForm[filterField].$setValidity('exists', data);
							scope.contactForm[filterField].$setPristine();
						});
					}
				}

				AllOrganisations().then(function(data) {
					scope.organisations = data;
				});
				function filterLanguages() {
					if (!allLanguages) {
						return;
					}
					let languagesToRemove = [];
					// Remove english from the list of languages except for german farmers
					if (!(scope.farmer && scope.org == 3)) {
						languagesToRemove.push('EN');
					}
					// Remove Italian from all orgs except SRL and Swiss Farmers
					if (!(scope.org == 4 || (scope.farmer && scope.org == 1))) {
						languagesToRemove.push('IT');
					}
					if (scope.org == 3) {
						languagesToRemove.push('FR');
					}
					scope.languages = allLanguages.filter(lang => {
						return lang.code != languagesToRemove.find(code => code == lang.code);
					});
					if (scope.org == 3 && !scope.farmer) {
						scope.contact.language = 'DE';
					}
				}
				scope.$watch('org', filterLanguages, true);

				languageFactory.query(function(data) {
					allLanguages = data;
					filterLanguages();

					//if the contact is new (does not have an ID) set the default language.
					if (!scope.contact.id && !scope.contact.language) {
						for (
							var languageIndex = 0;
							languageIndex < scope.languages.length;
							languageIndex++
						) {
							var element = scope.languages[languageIndex];
							if (element.DEFLT == 'Y') {
								scope.contact.language = element.code;
							}
						}
					}
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc function
 * @name wildBieneHarvestApp.controller:ContactModalCtrl
 * @description
 * # ContactModalCtrl
 * Controller of the wildBieneHarvestApp
 */
angular
	.module('wildBieneHarvestApp')
	.controller('ContactModalCtrl', function(
		$scope,
		$mdDialog,
		contact,
		clientId,
		ContactFactory,
		NotifyUser
	) {
		$scope.contact = angular.copy(contact);
		$scope.contact.client_id = clientId;
		$scope.cancel = cancel;
		$scope.save = save;

		function handleError(error) {
			NotifyUser(error);
		}
		function handleSuccess() {
			$mdDialog.hide();
		}

		function save() {
			if ($scope.contact.id) {
				ContactFactory.update($scope.contact.id, $scope.contact).then(
					handleSuccess,
					handleError
				);
			} else {
				var sanitisedContact = new ContactFactory.ContactModel($scope.contact);
				ContactFactory.create(sanitisedContact).then(handleSuccess, handleError);
			}
		}

		function cancel() {
			$mdDialog.cancel();
		}
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.CertificationFactory
 * @description
 * # CertificationFactory
 * Factory in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('certificationFactory', function($http, SETTINGS, $q, NotifyUser) {
		var cachedCertifications = null;
		var service = {
			getCertifications: getCertifications,
			selectCertification: selectCertification
		};
		return service;

		function getCertifications(clearCache) {
			if (clearCache) {
				cachedCertifications = null;
			}
			var delay = $q.defer();
			if (cachedCertifications) {
				delay.resolve(cachedCertifications);
			} else {
				$http.get(SETTINGS.APIBasePath + 'certifications').then(
					function(result) {
						cachedCertifications = result.data;
						delay.resolve(cachedCertifications);
					},
					function(error) {
						NotifyUser(error.data.detail);
						delay.reject(error.data);
					}
				);
			}
			return delay.promise;
		}
		function selectCertification(certificationName) {
			var delay = $q.defer();
			if (!cachedCertifications) {
				getCertifications.then(function() {
					delay.resolve(findCertification(certificationName));
				});
			} else {
				delay.resolve(findCertification(certificationName));
			}
			return delay.promise;
		}
		function findCertification(certificationName) {
			for (var index = 0; index < cachedCertifications.length; index++) {
				var element = cachedCertifications[index];
				if (element.CODE.toLowerCase == certificationName.toLowerCase()) {
					return element;
				}
			}
			return null;
		}
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.clientNotesFactory
 * @description
 * # clientNotesFactory
 * Factory in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('populationFactory', populationFactory);

function populationFactory($http, $q, SETTINGS, NotifyUser) {
	var service = {
		getPopulations: getPopulations,
		updateRecognition: updateRecognition
	};

	return service;

	function getPopulations(id) {
		var delay = $q.defer();
		$http
			.get(SETTINGS.APIBasePath + 'population/' + id)
			.then(function(response) {
				var notes = response.data.notes;
				delay.resolve(notes);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
	function updateRecognition(populationData) {
		var delay = $q.defer();
		$http
			.post(SETTINGS.APIBasePath + 'recognition/update', {
				data: populationData
			})
			.then(function() {
				delay.resolve(true);
			})
			.catch(function(error) {
				NotifyUser(error.data.msg);
			});
		return delay.promise;
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:recognitionIframeDirective
 * @description
 * # recognitionIframeDirective
 */
angular
	.module('wildBieneHarvestApp')
	.directive('recognitionIframeDirective', function(
		$sce,
		$window,
		SETTINGS,
		populationFactory
	) {
		return {
			templateUrl: 'views/recognition-iframe-directive.html',
			scope: {
				imageUrl: '=',
				populationData: '=',
				updateData: '&'
			},
			link: function postLink(scope) {
				scope.updatePopulationDetails = receiveMessage;
				scope.$watch('imageUrl', function(data) {
					if (data) {
						scope.imageLink = $sce.trustAsResourceUrl(
							SETTINGS.recognitionAPIBasePath +
								'?image_url=' +
								window.encodeURIComponent(data)
						);
					}
				});

				function receiveMessage() {
					scope.populationData['imageUrl'] = scope.imageUrl;
					populationFactory.updateRecognition(scope.populationData).then(function() {
						scope.updateData({ activeCode: scope.populationData.productCode });
					});
				}

				/**
				 * Listen for messages from recognition iframe
				 */
				function iframeListener($event) {
					if ($event.data && $event.data.annotations_updated) {
						receiveMessage();
					}
				}

				/**
				 * Add listener
				 */
				$window.addEventListener('message', iframeListener);

				/**
				 * Remove listener on destroy to avoid having multiple instances listening
				 */
				scope.$on('$destroy', function() {
					$window.removeEventListener('message', iframeListener);
				});
			}
		};
	});

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.StartpopVoucherUploadService
 * @description
 * # StartpopVoucherUploadService
 * service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.service('StartpopVoucherUploadService', startpopVoucherUploadService);

function startpopVoucherUploadService(
	codeValidator,
	NotifyUser,
	startpopSettings,
	$q
) {
	var data = [];
	var delay = undefined;

	var service = {
		parse: parse,
		get: get,
		upload: upload
	};

	return service;

	//////

	/**
	 * Parse the CSV file and load into local cache.
	 * @param file
	 * @param type
	 * @param orgId
	 * @returns {*}
	 */
	function parse(file) {
		console.log(file);
		data = [];
		delay = $q.defer();
		Papa.parse(file, {
			header: false,
			encoding: 'utf-8',
			complete: onParseComplete,
			error: function(error) {
				console.error('Error parsing file:', error);
			}
		});
		return delay.promise;
	}

	/**
	 * Load data into local cache.
	 * Skip the rows that do not look like proper voucher codes.
	 * @param results
	 */
	function onParseComplete(results) {
		angular.forEach(results.errors, function(error) {
			console.log(error);
			// UndetectableDelimiter is fine for a file with just one column
			if (error.code !== 'UndetectableDelimiter') {
				NotifyUser(error);
			}
		});

		angular.forEach(results.data, function(row, index) {
			var code = row[0];
			if (!code.match(codeValidator.voucherPattern)) {
				var message =
					'Skipping "' + code + '": Value does not look like a valid voucher code';
				// If first row is invalid, its probably a header row, no need to toast a warning
				console.log(message);
				if (index > 0) {
					NotifyUser(message);
				}
			} else {
				data.push({
					code: code,
					expiry_on: moment()
						.add(5, 'years')
						.format('YYYY-MM-DD')
				});
			}
		});

		delay.resolve(data);
	}

	/**
	 * Get a page of data from local cache
	 * @param query
	 * @returns {*}
	 */
	function get(query) {
		var start = query.limit * (query.page - 1);
		var end = query.limit * query.page;
		return $q.resolve({
			items: data.slice(start, end),
			total_count: data.length
		});
	}

	/**
	 * Upload local cache to database
	 * @param voucherType
	 * @param organisationId
	 * @returns {*}
	 */
	function upload(voucherType, organisationId) {
		var batches = getBatches(data);
		return batches.reduce(function(promise, batch) {
			return promise.then(uploadBatch(batch, voucherType, organisationId));
		}, $q.when());
	}

	/**
	 * Split arbitrary array into array of arrays
	 */
	function getBatches(allItems, batchSize = 5) {
		var batches = [];
		for (var i = 0; i < allItems.length; i += batchSize) {
			batches.push(allItems.slice(i, i + batchSize));
		}
		return batches;
	}

	/**
	 * Upload a batch of vouchers
	 * This needs to be a factory so that one batch is processed sequentially after the other
	 * @param batch
	 * 		* @param voucherType
	 * @param organisationId
	 * @returns {function(): *}
	 */
	function uploadBatch(batch, voucherType, organisationId) {
		return function() {
			var promises = [];
			angular.forEach(batch, function(voucher) {
				if (!voucher.id) {
					voucher.type = voucherType;
					voucher.organisation_id = parseInt(organisationId);
					promises.push(
						startpopSettings.addVoucher(voucher).then(function(response) {
							Object.assign(voucher, response.data);
						})
					);
				}
			});
			return $q.all(promises);
		};
	}
}

'use strict';

/**
 * @ngdoc service
 * @name wildBieneHarvestApp.country.factory.js
 * @description
 * # country.factory.js
 * Service in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('CountryFactory', CountryFactory);

function CountryFactory($http, $q, $log, SETTINGS) {
	var model = { query: query, countries: [], getCountry: getCountry };

	return model;

	function query(callBack) {
		var delay = $q.defer();

		if (model.countries.length) {
			callBack(model.countries);
			delay.resolve(model.countries);
			return model;
		}

		$http.get(SETTINGS.APIBasePath + 'countries').then(function(result) {
			model.countries = result.data;
			callBack(result.data);
			delay.resolve(model.countries);
		});
		return delay.promise;
	}

	function getCountry(country) {
		var delay = $q.defer();
		query(function(result) {
			var returnCountry, defaultCountry;
			for (var i = 0; i < result.length; i++) {
				if (result[i].deflt == 'Y') {
					defaultCountry = result[i];
				}
				if (
					country &&
					((result[i].ID && result[i].ID == country) ||
						(result[i].code &&
							result[i].code.toUpperCase() == country.toString().toUpperCase()))
				) {
					returnCountry = result[i];
				}
			}
			delay.resolve(returnCountry ? returnCountry : defaultCountry);
		});
		return delay.promise;
	}
}

'use strict';
/**
 * @ngdoc service
 * @name wildBieneHarvestApp.BoxManagementFactory
 * @description
 * # BoxManagementFactory
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('BoxManagementFactory', BoxManagementFactory);

function BoxManagementFactory(
	$state,
	ApiInterface,
	AlertUser,
	ConfirmUser,
	NotifyUser
) {
	var factory = {
		getLatestFridges: getLatestFridges,
		getLatestBoxes: getLatestBoxes,
		getLatestStartpops: getLatestStartpops,
		checkinItems: checkinItems,
		checkoutItems: checkoutItems
	};
	return factory;

	function getLatestFridges(season, data) {
		return ApiInterface.fetch('fridge/latest/' + season, data);
	}

	function getLatestBoxes(season, data) {
		return ApiInterface.fetch('box/latest/' + season, data);
	}

	function getLatestStartpops(season, data) {
		return ApiInterface.fetch('start-pop/latest/' + season, data);
	}

	function confirmedCheckin(itemsToCheckin) {
		if (itemsToCheckin.length) {
			// Redirect to check in page with codes
			$state.go('managementCheckin', {
				boxes: itemsToCheckin
			});
		} else {
			NotifyUser(
				'At least one valid item has to be selected in order to check in'
			);
		}
	}

	function confirmedCheckout(itemsToCheckout) {
		if (itemsToCheckout.length) {
			// Redirect to check out page with codes
			$state.go('managementCheckout', {
				boxes: itemsToCheckout
			});
		} else {
			NotifyUser(
				'At least one valid item has to be selected in order to check out'
			);
		}
	}

	function checkinItems(selectedRows) {
		var canCheckin = [];

		for (var i = 0; i < selectedRows.length; i++) {
			var rowData = selectedRows[i];
			canCheckin.push({
				ID: rowData.ID,
				BOX_CD: rowData['BOX_CD'],
				BOX_TYPE_ID: rowData.BOX_TYPE_ID,
				status: rowData.STATUS
			});
		}

		ConfirmUser(
			'Confirm',
			'Are you sure you want to check in all selected items? ',
			function(data) {
				if (data) {
					confirmedCheckin(canCheckin);
				}
			}
		);
	}

	function checkoutItems(selectedRows) {
		var cannotCheckout = [];
		var canCheckout = [];

		for (var i = 0; i < selectedRows.length; i++) {
			var rowData = selectedRows[i];
			if (rowData.STATUS !== 'IN') {
				cannotCheckout.push(rowData['BOX_CD']);
			} else {
				canCheckout.push({
					ID: rowData.ID,
					BOX_CD: rowData['BOX_CD'],
					BOX_TYPE_ID: rowData.BOX_TYPE_ID,
					status: rowData.STATUS
				});
			}
		}

		if (cannotCheckout.length) {
			if (canCheckout.length == 0) {
				AlertUser(
					'Warning',
					'The following codes cannot be checked out: ' +
						cannotCheckout.join(', ') +
						'.'
				);
			} else {
				ConfirmUser(
					'Confirm',
					'The following codes cannot be checked out: ' +
						cannotCheckout.join(', ') +
						'. Do you want to check out all other selected items?',
					function(data) {
						if (data) {
							confirmedCheckout(canCheckout);
						}
					}
				);
			}
		} else {
			ConfirmUser(
				'Confirm',
				'Are you sure you want to check out all selected items? ',
				function(data) {
					if (data) {
						confirmedCheckout(canCheckout);
					}
				}
			);
		}
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:boxmanagementBoxes
 * @description
 * # boxmanagementBoxes
 */
angular
	.module('wildBieneHarvestApp')
	.directive('boxmanagementBoxesDirective', function(
		$state,
		ApiInterface,
		BoxManagementFactory,
		ReferencesFactory,
		BoxBulkLoader,
		$mdDialog,
		AlertUser,
		ConfirmUser,
		NotifyUser,
		printerService
	) {
		return {
			templateUrl: 'views/boxmanagement-boxes-directive.html',
			scope: {
				season: '=',
				fridgeId: '='
			},
			link: function postLink(scope) {
				scope.getBoxes = getBoxes;
				scope.editBoxes = editBoxes;
				scope.deleteBoxes = deleteBoxes;
				scope.printBox = printBox;
				scope.addBox = addBox;
				scope.openBox = openBox;
				scope.toggleDeleteDisabled = toggleDeleteDisabled;
				scope.checkinItems = BoxManagementFactory.checkinItems;
				scope.checkoutItems = BoxManagementFactory.checkoutItems;

				scope.selected = [];

				function init() {
					scope.boxQuery = new ApiInterface.QueryModel();
					scope.pageLimitOptions = new ApiInterface.PageLimitOptionsModel().page_limit_options;
					scope.boxQuery.sort = '-BADM_BOXES_V.CRE_AT';
					scope.boxQuery.fridgeId = scope.fridgeId;
					BoxManagementFactory.getLatestBoxes(scope.season, scope.boxQuery).then(
						success
					);
				}

				function success(data) {
					data = data.data;
					if (data.list) {
						if (!scope.boxes) {
							scope.boxes = {};
						}
						scope.boxes = data.list;
						scope.boxTotal = data.countAll;
						resetHelpers();
					}
					return true;
				}

				function openBox(code) {
					$state.go('managementBox', {
						bid: code,
						season: scope.season
					});
				}

				function editBox(rowData) {
					$mdDialog
						.show({
							controller: 'BoxmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/box-modal.html',
							parent: angular.element(document.body),
							fullscreen: true,
							clickOutsideToClose: true,
							locals: {
								box: rowData,
								newCode: null,
								type: 1,
								hideCheckin: false
							},
							resolve: {
								boxTypes: function(AllBoxTypes) {
									return AllBoxTypes();
								},
								batches: function(AllBatches) {
									return AllBatches();
								},
								strains: function(ReferencesFactory) {
									return ReferencesFactory.getStrains();
								},
								organisations: function(AllOrganisations) {
									return AllOrganisations();
								}
							}
						})
						.then(getBoxes);
				}

				function editBoxes(selectedRows) {
					if (selectedRows.length === 1) {
						editBox(selectedRows[0]);
					} else {
						var codes = [];
						for (var i = 0; i < selectedRows.length; i++) {
							codes.push(selectedRows[i].BOX_CD);
						}
						$mdDialog
							.show({
								controller: 'BoxesmodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/boxes-modal.html',
								parent: angular.element(document.body),
								fullscreen: true,
								clickOutsideToClose: true,
								locals: {
									boxCodes: codes,
									type: 1
								},
								resolve: {
									boxTypes: function(AllBoxTypes) {
										return AllBoxTypes();
									}
								}
							})
							.then(getBoxes);
					}
				}
				function confirmedDelete() {
					if (scope.itemsToDelete.length) {
						// Bulk delete
						BoxBulkLoader.delete(
							{ ids: scope.itemsToDelete.join(',') },
							function() {
								if (scope.itemsToDelete.length > 1) {
									NotifyUser(
										'Boxes ' + scope.itemsToDelete.join(', ') + ' have been deleted'
									);
								} else {
									NotifyUser('Box ' + scope.itemsToDelete[0] + ' has been deleted');
								}
								getBoxes();
							},
							function() {
								resetHelpers();
								AlertUser('Error', 'Unable to delete boxes');
							}
						);
					} else {
						NotifyUser(
							'At least one valid item has to be selected in order to delete it'
						);
					}
				}

				function printBox(selectedRows) {
					var printData = {
						cocoons: selectedRows[0].AMOUNT,
						weight: selectedRows[0].NET_WEIGHT,
						boxCode: selectedRows[0].BOX_CD,
						batchCode: selectedRows[0].BATCH_CD
					};

					scope.$root.showLoader = true;
					printerService('qrCodeBox', printData).finally(function() {
						scope.$root.showLoader = false;
					});
				}

				function deleteBoxes(selectedRows) {
					var cannotDelete = [];
					var canDelete = [];

					for (var i = 0; i < selectedRows.length; i++) {
						var rowData = selectedRows[i];
						if (rowData.NR_STARTPOPS) {
							cannotDelete.push(rowData.BOX_CD);
						} else {
							canDelete.push(rowData.BOX_CD);
						}
					}

					scope.itemsToDelete = canDelete;

					if (cannotDelete.length) {
						if (canDelete.length === 0) {
							AlertUser(
								'Warning',
								'The following codes: ' +
									cannotDelete.join(', ') +
									' cannot be deleted, they have connected populations.'
							);
						} else {
							ConfirmUser(
								'Confirm',
								'The following codes: ' +
									cannotDelete.join(', ') +
									'  cannot be deleted, they have connected populations. Do you want to delete all other selected items?',
								confirmedDelete
							);
						}
					}

					if (!cannotDelete.length) {
						var confirmMessage =
							canDelete.length === 1
								? 'Are you sure you want to delete selected item?'
								: 'Are you sure you want to delete all selected items?';
						ConfirmUser('Confirm', confirmMessage, confirmedDelete);
					}
				}

				function addBox() {
					$mdDialog
						.show({
							controller: 'BoxmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/box-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							locals: {
								box: null,
								newCode: null,
								type: 1,
								hideCheckin: false
							},
							resolve: {
								boxTypes: function(AllBoxTypes) {
									return AllBoxTypes();
								},
								batches: function(AllBatches) {
									return AllBatches();
								},
								strains: function(ReferencesFactory) {
									return ReferencesFactory.getStrains();
								},
								organisations: function(AllOrganisations) {
									return AllOrganisations();
								}
							}
						})
						.then(init);
				}

				function getBoxes() {
					BoxManagementFactory.getLatestBoxes(scope.season, scope.boxQuery).then(
						success
					);
				}

				function toggleDeleteDisabled(selectedRows) {
					var cannotDelete = [];

					for (var i = 0; i < selectedRows.length; i++) {
						var rowData = selectedRows[i];
						if (rowData.NR_START_POPS) {
							cannotDelete.push(rowData.BOX_CD);
						}
					}

					if (selectedRows.length === 0) {
						scope.deleteBoxDisabled = true;
					} else if (selectedRows.length === 1) {
						scope.deleteBoxDisabled = cannotDelete.length === 1 ? true : false;
					} else {
						scope.deleteBoxDisabled = false;
					}
				}

				function resetHelpers() {
					scope.selected = [];
					scope.deleteBoxDisabled = true;
					scope.itemsToDelete = null;
				}

				init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:boxmanagementFridges
 * @description
 * # boxmanagementFridges
 */
angular
	.module('wildBieneHarvestApp')
	.directive('boxmanagementFridgesDirective', function(
		$state,
		ApiInterface,
		BoxManagementFactory,
		FridgeModelLoader,
		FridgeBulkLoader,
		$mdDialog,
		AlertUser,
		ConfirmUser,
		NotifyUser
	) {
		return {
			templateUrl: 'views/boxmanagement-fridges-directive.html',
			scope: {
				season: '=',
				users: '='
			},
			link: function postLink(scope) {
				scope.getFridges = getFridges;
				scope.editFridges = editFridges;
				scope.deleteFridges = deleteFridges;
				scope.addFridge = addFridge;
				scope.openFridge = openFridge;

				scope.selected = [];

				function init() {
					scope.fridgeQuery = new ApiInterface.QueryModel();
					scope.pageLimitOptions = new ApiInterface.PageLimitOptionsModel().page_limit_options;
					scope.fridgeQuery.sort = '-BADM_FRIDGES_V.CRE_AT';
					BoxManagementFactory.getLatestFridges(
						scope.season,
						scope.fridgeQuery
					).then(success);
				}

				function success(data) {
					data = data.data;
					if (data.list) {
						scope.fridges = data.list;
						scope.fridgeTotal = data.countAll;
						resetHelpers();
					}
					return true;
				}

				function openFridge(code) {
					$state.go('managementFridge', {
						fid: code
					});
				}

				function editFridge(rowData) {
					$mdDialog
						.show({
							controller: 'FridgemodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/fridge-modal.html',
							parent: angular.element(document.body),
							fullscreen: true,
							clickOutsideToClose: true,
							locals: {
								fridge: rowData
							},
							resolve: {
								fridgeModels: function(FridgeModelLoader) {
									return FridgeModelLoader();
								}
							}
						})
						.then(getFridges);
				}

				function editFridges(selectedRows) {
					if (selectedRows.length === 1) {
						editFridge(selectedRows[0]);
					} else {
						var codes = [];
						for (var i = 0; i < selectedRows.length; i++) {
							codes.push(selectedRows[i].FRIDGE_CD);
						}
						$mdDialog
							.show({
								controller: 'FridgesmodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/fridges-modal.html',
								parent: angular.element(document.body),
								fullscreen: true,
								clickOutsideToClose: true,
								locals: {
									fridgeCodes: codes
								},
								resolve: {
									fridgeModels: function(FridgeModelLoader) {
										return FridgeModelLoader();
									}
								}
							})
							.then(getFridges);
					}
				}

				function confirmedDelete() {
					if (scope.itemsToDelete.length) {
						// Bulk delete
						FridgeBulkLoader.delete(
							{ ids: scope.itemsToDelete.join(',') },
							function() {
								if (scope.itemsToDelete.length > 1) {
									NotifyUser(
										'Fridges ' + scope.itemsToDelete.join(', ') + ' have been deleted'
									);
								} else {
									NotifyUser('Fridge ' + scope.itemsToDelete[0] + ' has been deleted');
								}
								scope.getFridges();
							},
							function() {
								resetHelpers();
								AlertUser('Error', 'Unable to delete fridges');
							}
						);
					} else {
						NotifyUser(
							'At least one valid item has to be selected in order to delete it'
						);
					}
				}

				function deleteFridges(selectedRows) {
					var cannotDelete = [];
					var canDelete = [];

					for (var i = 0; i < selectedRows.length; i++) {
						var rowData = selectedRows[i];
						if (rowData.BOXES) {
							cannotDelete.push(rowData.FRIDGE_CD);
						} else {
							canDelete.push(rowData.FRIDGE_CD);
						}
					}

					scope.itemsToDelete = canDelete;

					if (cannotDelete.length) {
						if (canDelete.length === 0) {
							AlertUser(
								'Warning',
								'The following codes cannot be deleted: ' +
									cannotDelete.join(', ') +
									'.'
							);
						} else {
							ConfirmUser(
								'Confirm',
								'The following codes cannot be deleted: ' +
									cannotDelete.join(', ') +
									'. Do you want to delete all other selected items?',
								confirmedDelete
							);
						}
					}

					if (!cannotDelete.length) {
						var confirmMessage =
							canDelete.length === 1
								? 'Are you sure you want to delete selected item?'
								: 'Are you sure you want to delete all selected items?';
						ConfirmUser('Confirm', confirmMessage, confirmedDelete);
					}
				}

				function addFridge() {
					$mdDialog
						.show({
							controller: 'FridgemodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/fridge-modal.html',
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							locals: {
								fridge: null
							},
							resolve: {
								fridgeModels: function(FridgeModelLoader) {
									return FridgeModelLoader();
								}
							}
						})
						.then(init);
				}

				function getFridges() {
					BoxManagementFactory.getLatestFridges(
						scope.season,
						scope.fridgeQuery
					).then(success);
				}

				function resetHelpers() {
					scope.selected = [];
					scope.itemsToDelete = null;
				}

				init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:boxmanagementStartpops
 * @description
 * # boxmanagementStartpops
 */
angular
	.module('wildBieneHarvestApp')
	.directive('boxmanagementStartpopsDirective', function(
		$state,
		ApiInterface,
		BoxManagementFactory,
		StartpopBulkLoader,
		$mdDialog,
		AlertUser,
		ConfirmUser,
		NotifyUser
	) {
		return {
			templateUrl: 'views/boxmanagement-startpops-directive.html',
			scope: {
				season: '=',
				users: '=',
				fridgeId: '='
			},
			link: function postLink(scope) {
				scope.getStartpops = getStartpops;
				scope.editStartpops = editStartpops;
				scope.deleteStartpops = deleteStartpops;
				scope.openBox = openBox;
				scope.checkinItems = BoxManagementFactory.checkinItems;
				scope.checkoutItems = BoxManagementFactory.checkoutItems;

				scope.selected = [];

				function init() {
					scope.startpopQuery = new ApiInterface.QueryModel();
					scope.pageLimitOptions = new ApiInterface.PageLimitOptionsModel().page_limit_options;
					scope.startpopQuery.sort = '-BADM_STARTPOPS_V.CRE_AT';
					scope.startpopQuery.fridgeId = scope.fridgeId;
					BoxManagementFactory.getLatestStartpops(
						scope.season,
						scope.startpopQuery
					).then(success);
				}

				function success(data) {
					data = data.data;
					if (data.list) {
						scope.startpops = data.list;
						scope.startpopTotal = data.countAll;
						resetHelpers();
					}
					return true;
				}

				function openBox(code) {
					$state.go('managementBox', {
						bid: code,
						season: scope.season
					});
				}

				function getStartpops() {
					BoxManagementFactory.getLatestStartpops(
						scope.season,
						scope.startpopQuery
					).then(success);
				}

				function editStartpop(rowData) {
					$mdDialog
						.show({
							controller: 'BoxmodalCtrl',
							controllerAs: 'ctrl',
							templateUrl: 'views/box-modal.html',
							parent: angular.element(document.body),
							fullscreen: true,
							clickOutsideToClose: true,
							locals: {
								box: rowData,
								newCode: null,
								type: 2,
								hideCheckin: false
							},
							resolve: {
								boxTypes: function(AllBoxTypes) {
									return AllBoxTypes();
								},
								batches: function(AllBatches) {
									return AllBatches();
								},
								strains: function(ReferencesFactory) {
									return ReferencesFactory.getStrains();
								},
								organisations: function(AllOrganisations) {
									return AllOrganisations();
								}
							}
						})
						.then(getStartpops);
				}

				function editStartpops(selectedRows) {
					if (selectedRows.length === 1) {
						editStartpop(selectedRows[0]);
					} else {
						var codes = [];
						for (var i = 0; i < selectedRows.length; i++) {
							codes.push(selectedRows[i].BOX_CD);
						}
						$mdDialog
							.show({
								controller: 'BoxesmodalCtrl',
								controllerAs: 'ctrl',
								templateUrl: 'views/boxes-modal.html',
								parent: angular.element(document.body),
								fullscreen: true,
								clickOutsideToClose: true,
								locals: {
									boxCodes: codes,
									type: 2
								},
								resolve: {
									boxTypes: function(AllBoxTypes) {
										return AllBoxTypes();
									}
								}
							})
							.then(getStartpops);
					}
				}

				function confirmedDelete() {
					if (scope.itemsToDelete.length) {
						// Bulk delete
						StartpopBulkLoader.delete(
							{ ids: scope.itemsToDelete.join(',') },
							function() {
								if (scope.itemsToDelete.length > 1) {
									NotifyUser(
										'Populations ' + scope.itemsToDelete.join(', ') + ' have been deleted'
									);
								} else {
									NotifyUser(
										'Population ' + scope.itemsToDelete[0] + ' has been deleted'
									);
								}
								getStartpops();
							},
							function() {
								resetHelpers();
								AlertUser('Error', 'Unable to delete populations');
							}
						);
					} else {
						NotifyUser(
							'At least one valid item has to be selected in order to delete it'
						);
					}
				}

				function deleteStartpops(selectedRows) {
					var canDelete = [];

					for (var i = 0; i < selectedRows.length; i++) {
						canDelete.push(selectedRows[i].BOX_CD);
					}

					scope.itemsToDelete = canDelete;

					var confirmMessage =
						canDelete.length === 1
							? 'Are you sure you want to delete selected item?'
							: 'Are you sure you want to delete all selected items?';
					ConfirmUser('Confirm', confirmMessage, confirmedDelete);
				}

				function resetHelpers() {
					scope.selected = [];
					scope.itemsToDelete = null;
				}

				init();
			}
		};
	});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:BoxProvenienceListDirective
 * @description
 * # BoxProvenienceListDirective
 */
angular
	.module('wildBieneHarvestApp')
	.directive('boxProvenienceListDirective', function() {
		return {
			scope: {
				box: '=box'
			},
			templateUrl: 'views/box-provenience-list-directive.html'
		};
	});

'use strict';
/**
 * @ngdoc service
 * @name wildBieneHarvestApp.ReferencesFactory
 * @description
 * # ReferencesFactory
 * Service in the wildBieneHarvestApp.
 */
angular
	.module('wildBieneHarvestApp')
	.factory('ReferencesFactory', ReferencesFactory);

function ReferencesFactory(ApiInterface) {
	var factory = {
		getStrains: getStrains
	};
	return factory;

	function getStrains() {
		return ApiInterface.phpGet('references/strains');
	}
}

'use strict';

/**
 * @ngdoc factory
 * @name wildBieneHarvestApp.settingsFactory
 * @description
 * # settingsFactory
 * factory for getting and setting settings
 */
angular
	.module('wildBieneHarvestApp')
	.factory('settingsFactory', settingsFactory);

function settingsFactory($http, $q, SETTINGS) {
	var factory = {
		getGeneralSettings: getGeneralSettings,
		updateGeneralSettings: updateGeneralSettings,
		updateBeeStarterSettings: updateBeeStarterSettings,
		getBeeStarterSettings: getBeeStarterSettings,
		getBeecareSettings: getBeecareSettings,
		updateBeecareSettings: updateBeecareSettings
	};
	let savedDates = [];
	let savedPostalCodes = [];
	return factory;

	function getBeeStarterSettings(organisationId) {
		return $http
			.get(
				SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId + '/startpop'
			)
			.then(res => res.data);
	}
	function getBeecareSettings(organisationId) {
		return $http
			.get(SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId + '/beecare')
			.then(res => res.data);
	}
	/**
	 * Put starter settings
	 * @param organisationId:int
	 * @param data:{*}
	 * @returns {*}
	 */
	function updateBeeStarterSettings(organisationId, data) {
		var santisedData = angular.copy(data);
		delete santisedData.unavailable_dates;
		delete santisedData.next_possible_date;
		delete santisedData.excluded_dates;
		delete santisedData.organisation_id;
		santisedData.end_date = moment(santisedData.end_date).format('YYYY-MM-DD');
		santisedData.start_date = moment(santisedData.start_date).format(
			'YYYY-MM-DD'
		);
		santisedData.bicornis_start_date = moment(
			santisedData.bicornis_start_date
		).format('YYYY-MM-DD');
		return $http
			.put(
				SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId + '/startpop',
				santisedData
			)
			.then(res => res.data);
	}
	/**
	 * Put beecare settings
	 * @param organisationId:int
	 * @param data:{*}
	 * @returns {*}
	 */
	function updateBeecareSettings(organisationId, data) {
		var santisedData = angular.copy(data);
		console.log(santisedData);
		delete santisedData.unavailable_dates;
		delete santisedData.next_possible_date;
		delete santisedData.excluded_dates;
		delete santisedData.organisation_id;
		santisedData.end_date = moment(santisedData.end_date).format('YYYY-MM-DD');
		santisedData.start_date = moment(santisedData.start_date).format(
			'YYYY-MM-DD'
		);
		return $http
			.put(
				SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId + '/beecare',
				santisedData
			)
			.then(res => res.data);
	}
	/**
	 * Get general Settingsr
	 * @param organisationId:int
	 * @returns {*}
	 */
	function getGeneralSettings(organisationId) {
		return $http
			.get(SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId)
			.then(res => {
				savedDates = angular.copy(res.data.excluded_dates);
				savedPostalCodes = angular.copy(res.data.excluded_postal_codes);
				res.data.excluded_dates = datesToRanges(res.data.excluded_dates);

				return res.data;
			});
	}
	/**
	 * Put general Settings
	 * @param organisationId:int
	 * @param data:{*}
	 * @returns {*}
	 */
	function updateGeneralSettings(organisationId, data) {
		let sanitisedData = angular.copy(data);
		delete sanitisedData.organisation_id;
		delete sanitisedData.startpop.unavailable_dates;
		delete sanitisedData.startpop;
		delete sanitisedData.beecare;
		delete sanitisedData.excluded_dates;
		delete sanitisedData.excluded_postal_codes;
		editDates(organisationId, savedDates, rangesToDates(data.excluded_dates));
		editPostalCodes(organisationId, savedPostalCodes, data.excluded_postal_codes);
		return $http
			.put(
				SETTINGS.beehomeAPIBasePath + 'settings/' + organisationId,
				sanitisedData
			)
			.then(res => {
				res.data.excluded_dates = datesToRanges(res.data.excluded_dates);
				return res.data;
			});
	}
	/**
	 * Compare two lists of postal codes, detect any changes and make the respective requests to update the
	 * old codes in the database.
	 * @param orgId
	 * @param oldPostalCodes
	 * @param newPostalCodes
	 * @returns {*}
	 */
	function editPostalCodes(orgId, oldPostalCodes, newPostalCodes) {
		// Create dictionaries with country_code/postal_code as key
		var oldCodes = oldPostalCodes.reduce((a, x) => {
			a[x.country_code + '/' + x.postal_code] = x;
			return a;
		}, {});
		var newCodes = newPostalCodes.reduce((a, x) => {
			a[x.country_code + '/' + x.postal_code] = x;
			return a;
		}, {});

		// Compare the two dictionaries, detect which need to be deleted or added/updated
		var deleteCodes = {};
		angular.forEach(oldCodes, function(value, key) {
			if (!(key in newCodes)) {
				deleteCodes[key] = value;
			}
		});
		var putCodes = {};
		angular.forEach(newCodes, function(value, key) {
			if (!(key in oldCodes) || value.description !== oldCodes[key].description) {
				putCodes[key] = value;
			}
		});
		var path =
			SETTINGS.beehomeAPIBasePath +
			'settings/' +
			orgId +
			'/excluded-postal-codes/';
		var promises = [];
		angular.forEach(deleteCodes, function(code, key) {
			promises.push($http.delete(path + key));
		});
		angular.forEach(putCodes, function(code, key) {
			code = angular.copy(code);
			delete code.country_code;
			delete code.postal_code;
			delete code.edit;
			promises.push($http.put(path + key, code));
		});
		return $q.all(promises);
	}
	/**
	 * converts and array of strings to an array of date ranges
	 * @param dates:{*}
	 * @returns {*}
	 */
	function datesToRanges(dates) {
		if (dates.length === 0) {
			return [];
		}
		dates.sort((a, b) => a - b);

		var ranges = [];
		var startDate = moment(dates[0]);
		var previousDate = moment(dates[0]);
		angular.forEach(dates, function(date) {
			date = moment(date);
			if (date.diff(previousDate, 'days') > 1) {
				ranges.push({ startDate: startDate, endDate: previousDate });
				startDate = date;
			}
			previousDate = date;
		});
		ranges.push({
			startDate: startDate,
			endDate: moment(dates[dates.length - 1])
		});
		return ranges;
	}
	/**
	 * converts and aray of date ranges to an array of strings
	 * @param range:{*}
	 * @returns {*}
	 */
	function rangesToDates(ranges) {
		var dates = [];
		angular.forEach(ranges, function(range) {
			var date = range.startDate.clone();
			while (date <= range.endDate) {
				dates.push(date.toDate());
				date = date.add(1, 'days');
			}
		});

		dates.sort((a, b) => a - b);
		return dates;
	}
	/**
	 * Update the list of excluded dates
	 * @param orgId
	 * @param oldDates
	 * @param newDates
	 * @returns {Promise}
	 */
	function editDates(orgId, oldDates, newDates) {
		oldDates = oldDates.map(date => moment(date).format('YYYY-MM-DD'));
		newDates = newDates.map(date => moment(date).format('YYYY-MM-DD'));
		var deleteDates = oldDates.filter(x => !newDates.includes(x));
		var addDates = newDates.filter(x => !oldDates.includes(x));
		var path =
			SETTINGS.beehomeAPIBasePath + 'settings/' + orgId + '/excluded-dates/';
		var promises = [];
		angular.forEach(deleteDates, function(date) {
			promises.push($http.delete(path + date));
		});
		angular.forEach(addDates, function(date) {
			promises.push($http.put(path + date, {}));
		});
		return $q.all(promises);
	}
}

angular.module('wildBieneHarvestApp').component('organisationSettingsTabs', {
	controller: [
		'$stateParams',
		'OrganisationFactory',
		'$http',
		'Session',
		'SETTINGS',
		function($stateParams, OrganisationFactory, $http, Session, SETTINGS) {
			var ctrl = this;
			ctrl.org = null; // PHP settings

			ctrl.startpop = {}; // startpop settings
			ctrl.excludedDateRanges = [];

			ctrl.$onInit = function() {
				ctrl.orgId = $stateParams.orgId;
				OrganisationFactory.query().then(orgs => {
					ctrl.organisations = orgs;
					ctrl.organisation = ctrl.organisations.filter(
						org => org.ID == ctrl.orgId
					)[0];
					Session.pageTitle = ctrl.organisation.NAME;
					getSettings();
				});

				Session.setStream('administration');
			};

			ctrl.checkIfConversionDataAreValid = function(data) {
				var isValid = false;
				ctrl.org.managementConversion.forEach(function(value) {
					if (
						value.INSCT_ID === data.MNGMNTSPEC &&
						value.SOURCE_ID === data.MNGMNTSOURCE
					) {
						isValid = true;
						return;
					}
				});

				return isValid;
			};

			ctrl.deleteCustomTableItems = function(data, modelName) {
				if (modelName === 'rates') {
					if (data.id !== undefined && data.id !== '') {
						ctrl.org.ratesToRemove.push(data.id);
					}
				}

				ctrl.org[modelName].splice(data.index, 1);
			};

			ctrl.getElementById = function(elementId) {
				return document.getElementById(elementId);
			};

			ctrl.getInsectNameById = function(insectId) {
				var insectName = null;
				angular.forEach(ctrl.species, function(item) {
					if (item.ID === insectId) {
						insectName = item.SC_NAME + orgSpeciesWashStatus(item);
					}
				});
				return insectName;
			};

			/**
			 * Get legacy PHP settings and startpop settings
			 * @returns {*}
			 */
			function getSettings() {
				$http
					.get(SETTINGS.APIBasePath + 'organisation/settings/' + ctrl.orgId)
					.then(function(result) {
						console.log(result);
						for (let i = 0; i < result.data.managementConversion.length; i++) {
							const element = result.data.managementConversion[i];
							element.CONV_FACTOR = Number(element.CONV_FACTOR);
						}
						result.data.farmerDeliveryDays = result.data.farmerDeliveryDays.split(
							','
						);
						ctrl.org = result.data;
					});
			}

			ctrl.setAllRatesDefaultAsNo = function() {
				ctrl.org.rates.forEach(function(value, index) {
					ctrl.org.rates[index].VAT_DEFLT = 'N';
				});
			};

			ctrl.setActiveItemConversion = function(selectedTableItem, selected) {
				if (selected) {
					ctrl.selectedFactorItem = ctrl.org.managementConversion[selectedTableItem];
				} else {
					ctrl.selectedFactorItem = null;
				}
			};

			function orgSpeciesWashStatus(species) {
				if (species.ID == 1) {
					return ' (prewash)';
				}
				return '';
			}
		}
	],

	templateUrl:
		'scripts/components/admin/settings/organisation-settings/organisationSettings.template.html'
});

//const { init } = require('grunt');

angular.module('wildBieneHarvestApp').component('generalSettings', {
	bindings: { org: '=' },

	controller: [
		'$http',
		'SETTINGS',
		'NotifyUser',
		'ConfirmUser',
		'$stateParams',
		'AlertUser',
		'settingsFactory',
		'AllCountries',
		function(
			$http,
			SETTINGS,
			NotifyUser,
			ConfirmUser,
			$stateParams,
			AlertUser,
			settingsFactory,
			AllCountries
		) {
			//this.init=(){};
			this.currencies = [];
			this.editRow = editRow;
			this.addRow = addRow;
			this.deleteRow = deleteRow;
			this.disableAll = disableAll;
			this.saveGeneralSettings = saveGeneralSettings;
			this.saveRow = saveRow;
			this.selectedRate = [];
			this.defaultValues = ['Y', 'N'];
			this.selectBoxOptions = [
				{ name: 'no', value: 0 },
				{ name: 'yes', value: 1 }
			];
			this.isEditing = false;
			this.removeExcludedDateRange = removeExcludedDateRange;
			this.addExcludedDateRange = addExcludedDateRange;
			this.removePostalCode = removePostalCode;
			this.formatDate = formatDate;

			this.init = function() {
				this.isEditing = false;
				this.query = {
					order: 'ID',
					limit: 20,
					page: 1,
					limitOptions: [20, 50, 100, 200],
					filterOptions: {}
				};
			};
			this.$onInit = () => {
				this.orgId = $stateParams.orgId;

				$http.get(SETTINGS.APIBasePath + 'order/currencies').then(result => {
					this.currencies = result.data;
				});
				settingsFactory.getGeneralSettings(this.orgId).then(data => {
					this.generalSettings = data;
				});
				AllCountries().then(data => {
					this.countries = data;
				});
				this.init;
			};
			function removePostalCode(index) {
				this.generalSettings.excluded_postal_codes.splice(index, 1);
			}
			function addExcludedDateRange(excludedStartDate, excludedEndDate) {
				this.generalSettings.excluded_dates.push({
					startDate: moment(excludedStartDate),
					endDate: moment(excludedEndDate)
				});
			}
			function formatDate(range) {
				if (!range.endDate) {
					range = { startDate: range, endDate: range };
				}
				return (
					range.startDate.format('DD-MM-YYYY') +
					' - ' +
					range.endDate.format('DD-MM-YYYY')
				);
			}

			function removeExcludedDateRange(ind) {
				this.generalSettings.excluded_dates.splice(ind, 1);
			}
			function disableAll() {
				for (var i = 0; i < this.org.rates.length; i++) {
					this.org.rates[i].editable = false;
				}
				this.init();
			}

			function deleteRow(IDtoRemove) {
				if (IDtoRemove) {
					ConfirmUser('Deleting Rate', 'Are you sure you wish to continue?', () => {
						this.org.rates = this.org.rates.filter(rate => rate.ID !== IDtoRemove);
						this.init();
					});
				} else {
					this.org.rates.splice(0, 1);
					this.init();
				}
			}

			function editRow(rate) {
				if (this.isEditing === false) {
					var index = this.org.rates.indexOf(rate);
					this.disableAll();
					this.org.rates[index].editable = true;
					this.isEditing = true;
				}
			}

			function addRow() {
				var newRow = { editable: true, VAT_DEFLT: 'N', ACTIVE: 'Y' };
				this.org.rates.unshift(newRow);
				this.editRow(this.org.rates[0]);
			}
			function saveRow() {
				this.isEditing = false;
				this.disableAll();
			}
			function saveGeneralSettings() {
				console.log(this.generalSettings);
				settingsFactory
					.updateGeneralSettings(this.orgId, this.generalSettings)
					.then(result => {
						this.generalSettings = result;
					})
					.catch(error => {
						console.error(error);
					});
				$http

					.post(
						SETTINGS.APIBasePath + 'organisation/settings/' + this.orgId,
						this.org
					)
					.then(data => {
						if (data.error) {
							AlertUser('Something went wrong');
						}
						NotifyUser('Settings were updated.');
					});
			}
		}
	],
	templateUrl:
		'scripts/components/admin/settings/general-settings/general-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('beemanagementSettings', {
	bindings: { org: '=', sources: '=' },
	controller: [
		'ConfirmUser',
		'SETTINGS',
		'$http',
		'AlertUser',
		'NotifyUser',
		'$mdDialog',
		'AllSpecies',
		'AllBoxSources',
		'$stateParams',
		function(
			ConfirmUser,
			SETTINGS,
			$http,
			AlertUser,
			NotifyUser,
			$mdDialog,
			AllSpecies,
			AllBoxSources,
			$stateParams
		) {
			this.saveBeeManagmentSettings = saveBeeManagmentSettings;
			this.editRow = editRow;
			this.addRow = addRow;
			this.deleteRow = deleteRow;
			this.saveRow = saveRow;
			this.disableAll = disableAll;
			this.getSourceNameById = getSourceNameById;
			this.getInsectNameById = getInsectNameById;
			this.orgSpeciesWashStatus = orgSpeciesWashStatus;

			this.$onInit = function() {
				this.orgId = $stateParams.orgId;
				this.isEditing = false;
				this.defaultValues = ['Y', 'N'];
				AllSpecies().then(result => {
					this.species = result;
				});
				AllBoxSources().then(results => {
					//array of sources
					this.sources = results;
				});
			};
			function saveBeeManagmentSettings() {
				$http
					.post(
						SETTINGS.APIBasePath + 'organisation/settings/' + this.orgId,
						this.org
					)
					.then(data => {
						if (data.error) {
							AlertUser('Something went wrong');
						}

						$mdDialog.hide();
						NotifyUser('Settings were updated.');
					});
			}
			function saveRow() {
				this.disableAll();
			}
			function disableAll() {
				for (var i = 0; i < this.org.managementConversion.length; i++) {
					this.org.managementConversion[i].editable = false;
				}
				this.isEditing = false;
			}
			function editRow(conversion) {
				if (this.isEditing === false) {
					var index = this.org.managementConversion.indexOf(conversion);
					this.org.managementConversion[index].editable = true;
					this.isEditing = true;
					this.selectedConversion = angular.copy(conversion);
				}
			}

			function addRow() {
				var newRow = {};
				this.org.managementConversion.unshift(newRow);
				this.editRow(this.org.managementConversion[0]);
			}

			function deleteRow(conversionID) {
				if (conversionID) {
					ConfirmUser(
						'Deleting Record',
						'Are you sure you wish to continue?',
						() => {
							this.org.managementConversion = this.org.managementConversion.filter(
								item => item.ID != conversionID
							);
						}
					);
				} else {
					this.org.managementConversion.splice(0, 1);
				}
			}

			function getInsectNameById(insectId) {
				if (!insectId || !this.species) {
					return;
				}
				var insectName = null;

				this.species.filter(specie => {
					if (specie.ID == insectId) {
						insectName = specie.SC_NAME + this.orgSpeciesWashStatus(specie);
					}
				});
				return insectName;
			}
			function getSourceNameById(sourceId) {
				if (!sourceId || !this.sources) {
					return;
				}
				var sourceName = null;
				angular.forEach(this.sources, function(item) {
					if (item.ID === sourceId) {
						sourceName = item.DESCRIPTION;
					}
				});
				this.sources.filter(source => {
					if (source.ID == sourceId) {
						sourceName = source.DESCRIPTION;
					}
				});
				return sourceName;
			}

			function orgSpeciesWashStatus(specie) {
				if (specie.ID == 1) {
					return ' (prewash)';
				}
				return '';
			}
		}
	],

	templateUrl:
		'scripts/components/admin/settings/beemanagement-settings/beemanagement-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('beefarmerSettings', {
	bindings: { org: '=' },
	controller: [
		'$http',
		'SETTINGS',
		'NotifyUser',
		'$mdDialog',
		'AlertUser',
		'$stateParams',
		function($http, SETTINGS, NotifyUser, $mdDialog, AlertUser, $stateParams) {
			this.saveBeeFarmerSettings = saveBeeFarmerSettings;
			this.$onInit = function() {
				this.orgId = $stateParams.orgId;
			};

			function saveBeeFarmerSettings() {
				//convert the array to a comma seperated string so it can be stored in the settings table
				let data = angular.copy(this.org);
				data.farmerDeliveryDays = this.org.farmerDeliveryDays.toString();
				$http
					.post(SETTINGS.APIBasePath + 'organisation/settings/' + this.orgId, data)
					.then(data => {
						if (data.error) {
							AlertUser('Something went wrong');
						}

						$mdDialog.hide();
						NotifyUser('Settings were updated.');
					});
			}
		}
	],
	templateUrl:
		'scripts/components/admin/settings/beefarmer-settings/beefarmer-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('beestarterSettings', {
	bindings: { org: '=' },
	controller: [
		'$stateParams',
		'settingsFactory',
		'AlertUser',
		'NotifyUser',
		'$scope',
		'startpopSettings',
		function(
			$stateParams,
			settingsFactory,
			AlertUser,
			NotifyUser,
			$scope,
			startpopSettings
		) {
			this.saveBeeStarterSettings = saveBeeStarterSettings;

			this.$onInit = function() {
				$scope.$root.showLoader = true;
				this.orgId = $stateParams.orgId;
				startpopSettings
					.getSettings(this.orgId)
					.then(settings => {
						this.startpopSettings = settings.startpop;
					})
					.finally(() => {
						$scope.$root.showLoader = false;
					});
			};
			/**
			 * Convert flat array of dates objects to list of ranges
			 * First sort the array, then loop through the array, if there is a gap its a new range.
			 */

			function saveBeeStarterSettings() {
				settingsFactory
					.updateBeeStarterSettings(this.orgId, this.startpopSettings)
					.then(() => {
						NotifyUser('Settings were updated.');
					})
					.catch(error => {
						console.error(error);
						AlertUser('Something went wrong');
					});
			}
		}
	],
	templateUrl:
		'scripts/components/admin/settings/beestarter-settings/beestarter-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('beecareSettings', {
	bindings: { org: '=' },
	controller: [
		'$stateParams',
		'settingsFactory',
		'AlertUser',
		'NotifyUser',
		'$scope',
		function($stateParams, settingsFactory, AlertUser, NotifyUser, $scope) {
			this.saveBeecareSettings = saveBeecareSettings;

			this.$onInit = function() {
				$scope.$root.showLoader = true;
				this.orgId = $stateParams.orgId;
				settingsFactory
					.getBeecareSettings(this.orgId)
					.then(settings => {
						this.beecareSettings = settings;
					})
					.finally(() => {
						$scope.$root.showLoader = false;
					});
			};
			/**
			 * Convert flat array of dates objects to list of ranges
			 * First sort the array, then loop through the array, if there is a gap its a new range.
			 */

			function saveBeecareSettings() {
				console.log('saving beecare settings');
				settingsFactory
					.updateBeecareSettings(this.orgId, this.beecareSettings)
					.then(() => {
						NotifyUser('Settings were updated.');
					})
					.catch(error => {
						console.error(error);
						AlertUser('Something went wrong');
					});
			}
		}
	],
	templateUrl:
		'scripts/components/admin/settings/beecare-settings/beecare-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('orgSettings', {
	bindings: { organisation: '=', organisations: '=' },
	controller: [
		'$http',
		'SETTINGS',
		'NotifyUser',
		'AlertUser',
		'$stateParams',
		'AllCountries',
		function($http, SETTINGS, NotifyUser, AlertUser, $stateParams, AllCountries) {
			this.$onInit = function() {
				this.orgId = $stateParams.orgId;
				this.selectBoxOptions = [
					{ name: 'no', value: 0 },
					{ name: 'yes', value: 1 }
				];
				AllCountries().then(data => {
					this.countries = data;
				});
			};

			this.saveOrgFormSettings = () => {
				$http
					.post(SETTINGS.APIBasePath + 'organisation', this.organisation)
					.then(data => {
						if (data.error) {
							AlertUser('Something went wrong');
						}
						NotifyUser('Settings were updated.');
					});
			};
		}
	],
	templateUrl:
		'scripts/components/admin/settings/org-settings/org-settings.template.html'
});

angular.module('wildBieneHarvestApp').component('shopifyOrders', {
	controller: [
		'NotifyUser',
		'AlertUser',
		'shopifyFactory',
		'Session',
		function(NotifyUser, AlertUser, shopifyFactory, Session) {
			Session.setStream('beehome');
			Session.pageTitle = 'Shopify Orders';
			this.getOrders = getOrders;
			this.processOrder = processOrder;
			this.startTime = '00:00:00';
			this.endTime = '00:00:00';
			this.startDate = new Date('2022-08-01T16:56:05');
			this.endDate = new Date();
			this.orders = [];
			this.next = null;
			this.prev = null;
			this.selectedOrders = [];
			function getOrders(before, after) {
				this.startDate.setHours(Number(this.startTime.split(':')[0]));
				this.startDate.setMinutes(Number(this.startTime.split(':')[1]));
				this.startDate.setSeconds(Number(this.startTime.split(':')[2]));
				this.endDate.setHours(Number(this.endTime.split(':')[0]));
				this.endDate.setMinutes(Number(this.endTime.split(':')[1]));
				this.endDate.setSeconds(Number(this.endTime.split(':')[2]));
				shopifyFactory
					.getOrders(this.startDate, this.endDate, before, after)
					.then(result => {
						this.orders = result.orders;
						this.firstCursor = result.firstCursor;
						this.lastCursor = result.lastCursor;
						this.pageInfo = result.pageInfo;
					});
			}
			function processOrder(order) {
				shopifyFactory.processOrder(order);
			}
		}
	],
	templateUrl:
		'scripts/components/beehome/orders/shopify-orders/shopify-orders.template.html'
});

angular.module('wildBieneHarvestApp').component('qrcodeGenerator', {
	controller: [
		'Session',
		'printerService',
		function(Session, printerService) {
			var ctrl = this;
			Session.pageTitle = 'QR Code Generator';
			ctrl.generateQRCode = function(houseCodeInput) {
				printerService('qrCode', houseCodeInput);
			};
		}
	],

	templateUrl:
		'scripts/components/management/qrcode-generator/qrcodeGenerator.template.html'
});

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:fileModel
 * @description
 * This creates a change event on file inputs when the user has selected a file.
 */
angular.module('wildBieneHarvestApp').directive('fileModel', [
	'$parse',
	function($parse) {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				var model = $parse(attrs.fileModel);
				var modelSetter = model.assign;

				element.bind('change', function(changeEvent) {
					scope.$apply(function() {
						var file = changeEvent.target.files[0];
						modelSetter(scope, file);

						// Call the parseFile function when a file is selected
						if (attrs.onFileChange) {
							scope.$eval(attrs.onFileChange, { $file: file });
						}
					});
				});
			}
		};
	}
]);

'use strict';
/**
 * @ngdoc factory
 * @name wildBieneHarvestApp.client
 * @description
 * # clientFactory
 * factory in the wildBieneHarvestApp.
 */
angular.module('wildBieneHarvestApp').factory('shopifyFactory', shopifyFactory);
/**
 * shopifyFactory is an interface to shopify admin API's GraphQL.
 * https://shopify.dev/api/admin-graphql or explore it here
 * https://dev-shop-beehome.myshopify.com/admin/apps/5a3c93b0e9bc8d5abf63531fcd829b5d/
 */
function shopifyFactory($http, SETTINGS, $q) {
	var factory = {
		locale: 'de_CH',
		draftOrder: draftOrder,
		draftBeecareOrder: draftBeecareOrder,
		products: [],
		customerByEmail: customerByEmail,
		createShopifyCustomer: createShopifyCustomer,
		getProducts: getStartpopProducts,
		getBeecareProducts: getBeecareProducts,
		getDonationProduct: getDonationProduct,
		getShopifyLocale: getShopifyLocale,
		orders: [],
		getOrders: getShopifyOrders,
		getOrderById: getOrderById,
		hasBeehomeAddon: hasBeehomeAddon,
		processOrder: processOrder,
		findProduct: findProduct
	};

	return factory;

	function getShopifyLocale(orgID, lang) {
		const prefix = lang.toLowerCase();
		let suffix = 'CH';
		if (orgID == 3) {
			suffix = 'DE';
		}
		return prefix + '_' + suffix;
	}

	function setLocale(locale) {
		if (locale) {
			factory.locale = locale;
		}
	}
	function getOrderById(orderId) {
		let defer = $q.defer();

		if (!orderId) {
			defer.reject(new Error('Order ID is required'));
			return defer.promise;
		}

		const query = `query getOrder($id: ID!) {
			order(id: $id) {
				id,
				email,
				createdAt,
				customer {
					firstName,
					lastName,
					id,
					locale,
					phone
				},
				currentSubtotalPriceSet {
					shopMoney {
						amount
						currencyCode
					}
					presentmentMoney {
						amount
						currencyCode
					}
				},
				paymentGatewayNames,
				customAttributes {
					key,
					value
				},
				shippingAddress {
					address1,
					address2,
					name,
					city,
					company,
					country,
					zip,
					firstName,
					lastName,
					countryCodeV2
				},
				billingAddress {
					address1,
					address2,
					name,
					city,
					company,
					country,
					zip,
					firstName,
					lastName,
					countryCodeV2
				},
				lineItems(first: 100) {
					edges {
						node {
							id,
							name,
							sku,
							quantity,
							currentQuantity,
							originalUnitPriceSet {
								shopMoney {
									amount
								}
							},
							variant {
								displayName,
								price,
								sku,
								product {
									id,
									title,
									tags
								}
							},
							customAttributes {
								key,
								value
							}
						}
					}
				}
			}
		}`;

		// Add the GraphQL ID prefix if not already present
		const shopifyOrderId = orderId.startsWith('gid://shopify/Order/')
			? orderId
			: `gid://shopify/Order/${orderId}`;

		runQuery(query, { id: shopifyOrderId }).then(
			response => {
				if (response.data.data && response.data.data.order) {
					let order = response.data.data.order;

					// Strip the GraphQL ID prefix for consistency with existing code
					order.id = order.id.replace('gid://shopify/Order/', '');

					// Transform line items structure to match existing pattern
					if (order.lineItems && order.lineItems.edges) {
						order.lineItems = order.lineItems.edges.map(lineItem => {
							return lineItem.node;
						});
					}

					defer.resolve(order);
				} else {
					defer.reject(new Error('Order not found'));
				}
			},
			error => {
				let errorMessage = 'Failed to fetch Shopify order';
				if (error.data && error.data.errors) {
					errorMessage += ': ' + JSON.stringify(error.data.errors);
				}
				defer.reject(new Error(errorMessage));
			}
		);

		return defer.promise;
	}

	function hasBeehomeAddon(order) {
		if (!order || !order.lineItems || !Array.isArray(order.lineItems)) {
			return false;
		}

		return order.lineItems.some(function(lineItem) {
			// currentQuantity drops to 0 when the line item is fully refunded/removed
			if (lineItem.currentQuantity === 0) {
				return false;
			}
			if (
				lineItem.variant &&
				lineItem.variant.product &&
				lineItem.variant.product.tags
			) {
				var tags = lineItem.variant.product.tags;
				// Handle both array and string formats
				if (Array.isArray(tags)) {
					return tags.includes('beehome_addon');
				} else if (typeof tags === 'string') {
					return tags.toLowerCase().includes('beehome_addon');
				}
			}
			return false;
		});
	}

	function getShopifyOrders(startDate, endDate, before, after) {
		let defer = $q.defer();
		const condition =
			'created_at:>' +
			startDate.toISOString() +
			' created_at:<' +
			endDate.toISOString();
		const query =
			'query orderQuerry($after:String,$before:String,$condition:String) \
			{\
			orders(\
				' +
			(before ? 'last' : 'first') +
			': 10, \
				after: $after \
				before: $before \
				query: $condition \
				) {\
					pageInfo{\
						hasNextPage\
						hasPreviousPage\
					}\
					edges {\
						cursor\
						node {\
							id,\
							email,\
							createdAt,\
							customer{\
								firstName,\
								lastName,\
								id,\
								locale,\
								phone\
							},\
							currentSubtotalPriceSet{\
								shopMoney{\
									amount\
									currencyCode\
								}\
								presentmentMoney{\
									amount\
									currencyCode\
								}\
							}\
							paymentGatewayNames,\
							customAttributes{\
								key,\
								value},\
							shippingAddress{\
								address1,\
								address2,\
								name,\
								city,\
								company,\
								country,\
								address1,\
								zip,\
								firstName,\
								lastName,\
								address1,\
								countryCodeV2\
							}\
							billingAddress{\
								address1,\
								address2,\
								name,\
								city,\
								company,\
								country,\
								address1,\
								zip,\
								firstName,\
								lastName,\
								address1,\
								countryCodeV2\
							}\
							lineItems(first:10){\
								edges{\
									node{\
										id,\
										name,\
										sku,\
										quantity,\
										originalUnitPriceSet{\
											shopMoney{\
												amount\
											}\
										}\
										variant{\
											displayName,\
											price,\
											sku\
										},\
										customAttributes{\
											key,\
											value\
										}\
									}\
								}\
							}\
						}\
					}\
				}\
			}';
		runQuery(query, { after: after, before: before, condition: condition }).then(
			response => {
				// Strip out the edges and node objects from the gql return
				// Strip out the edges and node objects from the gql return
				factory.orders = response.data.data.orders.edges.map(node => {
					node.node.id = node.node.id.replace('gid://shopify/Order/', '');
					if (node.node.lineItems && node.node.lineItems.edges) {
						node.node.lineItems = node.node.lineItems.edges.map(lineItem => {
							return lineItem.node;
						});
					}

					return node.node;
				});
				defer.resolve({
					orders: factory.orders,
					pageInfo: response.data.data.orders.pageInfo,
					firstCursor:
						response.data.data.orders.edges && response.data.data.orders.edges.length
							? response.data.data.orders.edges[0].cursor
							: null,
					lastCursor:
						response.data.data.orders.edges && response.data.data.orders.edges.length
							? response.data.data.orders.edges[
									response.data.data.orders.edges.length - 1
							  ].cursor
							: null
				});
			}
		);
		return defer.promise;
	}
	//formats an order to Shopify webhook patterns and sends it to the API
	function processOrder(order) {
		order.created_at = order.createdAt;
		order.line_items = order.lineItems.map(item => {
			item.id = item.id.replace('gid://shopify/LineItem/', '');
			item.price = item.originalUnitPriceSet.shopMoney.amount;
			item.properties = item.customAttributes.map(prop => {
				prop.name = prop.key;
				return prop;
			});
			return item;
		});
		order.customer.first_name = order.customer.firstName;
		order.customer.last_name = order.customer.lastName;
		order.customer.id = order.customer.id.replace('gid://shopify/Customer/', '');
		order.shipping_address = order.shippingAddress;
		order.shipping_address.first_name = order.shippingAddress.firstName;
		order.shipping_address.last_name = order.shipping_address.lastName;
		order.shipping_address.country_code = order.shipping_address.countryCodeV2;
		order.shipping_address.postal_code = order.shipping_address.zip;
		order.billing_address = order.billingAddress;
		order.billing_address.first_name = order.billing_address.firstName;
		order.billing_address.last_name = order.billing_address.lastName;
		order.billing_address.country_code = order.billing_address.countryCodeV2;
		order.billing_address.postal_code = order.billing_address.zip;
		order.gateway = order.paymentGatewayNames.toString();
		order.total_price = order.currentSubtotalPriceSet.shopMoney.amount;
		order.currency = order.currentSubtotalPriceSet.shopMoney.currencyCode;
		return $http.post(SETTINGS.beehomeAPIBasePath + '/shopify/orderhook', order);
	}

	function getStartpopProducts(locale) {
		let defer = $q.defer();
		setLocale(locale);
		const query =
			'{\
			products(first: 5, query: "product_type:startpopulation") {\
			  edges {\
				 node {\
				  title\
				  id\
				  productType\
				  options(first:100){\
					name\
					values\
				}	\
				  variants(first:100) {\
					edges {\
					  node {\
						id\
						price\
					  }\
					}\
				  }\
				}\
			  }\
			}\
		  }';
		runQuery(query).then(response => {
			// Strip out the edges and node objects from the gql return
			// Strip out the edges and node objects from the gql return
			factory.products = response.data.data.products.edges.map(node => {
				node.node.variants = node.node.variants.edges.map(edge => edge.node);
				return node.node;
			});
			defer.resolve(factory.products);
		});
		return defer.promise;
	}
	function getBeecareProducts(locale) {
		let defer = $q.defer();
		setLocale(locale);
		const query = `{
							products(first: 1, query: "handle:beehome-beecare") {
								edges {
								node {
									title
									id
									handle
									productType
									options(first: 100) {
									name
									values
									}
									variants(first: 100) {
									edges {
										node {
										id
										price
										}
									}
									}
								}
								}
							}
						}`;
		runQuery(query).then(response => {
			console.log('product', response);
			// Strip out the edges and node objects from the gql return
			factory.products = response.data.data.products.edges.map(node => {
				node.node.variants = node.node.variants.edges.map(edge => edge.node);
				return node.node;
			});
			console.log(factory.products);
			defer.resolve(factory.products);
		});
		return defer.promise;
	}
	function getDonationProduct(locale) {
		let defer = $q.defer();
		setLocale(locale);
		const query =
			'{\
			products(first: 1, query: "title:freiwilliger beitrag") {\
			  edges {\
				 node {\
				  title\
				  id\
				  productType\
				  options(first:100){\
					name\
					values\
				}	\
				  variants(first:100) {\
					edges {\
					  node {\
						id\
						price\
					  }\
					}\
				  }\
				}\
			  }\
			}\
		  }';
		runQuery(query).then(response => {
			// Strip out the edges and node objects from the gql return
			// Strip out the edges and node objects from the gql return
			factory.donation = response.data.data.products.edges.map(node => {
				node.node.variants = node.node.variants.edges.map(edge => edge.node);
				return node.node;
			})[0];
			defer.resolve(factory.donation);
		});
		return defer.promise;
	}
	function customerByEmail(email, locale) {
		setLocale(locale);
		let defer = $q.defer();
		const query =
			'{\
			customers(first:10 query:"email:' +
			email +
			'"){\
				  edges{\
					  node{\
						  id\
						  firstName\
						  lastName\
						  addresses{\
							  address1\
							  address2\
							  company\
							  country\
							  firstName\
							  lastName\
							  city\
							  zip\
						  }\
					  }\
				  }\
			  }\
		  }';
		runQuery(query).then(result => {
			if (
				result.data.data &&
				result.data.data.customers &&
				result.data.data.customers.edges &&
				result.data.data.customers.edges.length
			) {
				defer.resolve(result.data.data.customers.edges[0].node);
			} else {
				// create the customer in shopify
				defer.reject();
			}
		});

		return defer.promise;
	}

	/**
	 * dumpShopifyCustomer.
	
	 * @param	mixed	customer	
	 * @return	Customer!
	 */
	function dumpShopifyCustomer(customer) {
		let nameArray = customer.name.split(' ');
		const firstName = nameArray.shift();
		const lastName = nameArray.join(' ');
		const shopifyData = {
			firstName: firstName,
			lastName: lastName,
			email: customer.email
		};
		return shopifyData;
	}
	/**
	 * create a customer in shopify and return the
	 * @param	mixed	customer
	 * @return	mixed
	 */
	function createShopifyCustomer(customer, locale) {
		setLocale(locale);
		let defer = $q.defer();
		const mutation =
			'mutation createCustomer($customer:CustomerInput!){\
			customerCreate (\
			  input: $customer\
			) \
			{\
			  customer {\
				id\
			  }\
			  userErrors {\
				field\
				message\
			  }\
			}\
		  }';
		const input = { customer: dumpShopifyCustomer(customer) };
		runQuery(mutation, input).then(result => {
			if (
				result.data &&
				result.data.data &&
				result.data.data.customerCreate &&
				result.data.data.customerCreate.customer
			) {
				defer.resolve(result.data.data.customerCreate.customer);
			} else {
				defer.reject();
			}
		});
		return defer.promise;
	}
	/**
	 *
	 * @param {*} species enum ["cornuta","bicornis"]
	 * @returns shopify product
	 */
	function findProduct(species) {
		console.log('selecting profuct from Shopify from factory');
		const product = factory.products.find(prod => {
			if (species.toLowerCase() == 'cornuta') {
				return prod.title.indexOf('rnte') > -1;
			} else {
				return prod.title.indexOf('rote') > -1;
			}
		});
		return product;
	}
	function parseCustomerInfoFromOrder(order) {
		let customAttributes;

		if (order.delivery_date) {
			customAttributes = [
				{
					key: 'deliveryDate',
					value: order.delivery_date.toString()
				},
				{
					key: 'seasonType',
					value: 'startpops'
				}
			];
		}

		let input = {
			customerId: order.shopifyCustomer.id,
			lineItems: [],
			customAttributes: customAttributes,
			tags: ['system_generated'],
			shippingAddress: {
				address1: order.address_1,

				city: order.town,
				countryCode: order.country_code,
				firstName: order.first_name,
				lastName: order.last_name,
				zip: order.postal_code
			}
			// billingAddress: {
			// 	address1: order.billingAddress.address_1,

			// 	city: order.billingAddress.town,
			// 	countryCode: order.billingAddress.country_code,
			// 	firstName: order.billingAddress.first_name,
			// 	lastName: order.billingAddress.last_name,
			// 	zip: order.billingAddress.postal_code
			// }
		};
		if (order.comment) {
			input.note = order.comment;
		}
		if (order.address_2) {
			input.shippingAddress.address2 = order.address_2;
		}
		if (order.company_name) {
			input.shippingAddress.company = order.company_name;
		}
		if (
			input.billingAddress &&
			order.billingAddress &&
			order.billingAddress.address_2
		) {
			input.billingAddress.address2 = order.billingAddress.address_2;
		}
		if (
			order.billingAddress &&
			order.billingAddress.company_name &&
			input.billingAddress
		) {
			input.billingAddress.company = order.billingAddress.company_name;
		}
		return input;
	}
	function draftBeecareOrder(order) {
		let defer = $q.defer();
		let input = parseCustomerInfoFromOrder(order);
		// if (order.vouchers.length) {
		// 	// startpop_oc_free doesn't exist - we should remove the ability to add vouchers in cornuta season.
		// 	const freeVariant = beecareV.find(variant => {
		// 		return variant.price == 0;
		// 	});
		// 	input.lineItems.push({
		// 		variantId: freeVariant.id,
		// 		quantity: order.vouchers.length,
		// 		customAttributes: {
		// 			key: 'vouchers',
		// 			value: order.vouchers.map(voucher => voucher.code).join(', ')
		// 		}
		// 	});
		// }
		if (order.amount && order.amount > order.vouchers.length) {
			const variant = order.variant;
			if (!variant) {
				alert('no variant foun on product ' + ' with price ' + order.unit_price);
			}
			input.lineItems.push({
				variantId: variant.id,
				quantity: order.amount - order.vouchers.length
			});
		}
		if (order.donation) {
			input.lineItems.push({
				variantId: order.donation.id,
				quantity: 1
			});
		}

		const mutation =
			'mutation draftOrderCreate($input: DraftOrderInput!) {\
			draftOrderCreate(input: $input) {\
			  draftOrder {\
				id\
				invoiceUrl\
			  }\
			}\
		  }\
		  ';
		runQuery(mutation, { input: input }).then(res => {
			if (
				res.data.data &&
				res.data.data.draftOrderCreate &&
				res.data.data.draftOrderCreate.draftOrder
			) {
				defer.resolve(res.data.data.draftOrderCreate.draftOrder);
			} else {
				console.error(res);
				defer.reject();
			}
		});
		return defer.promise;
	}

	/**
	 * Create a draft order in shopify
	 *
	 * @param	Object	order
	 * @param	String	species
	 * @return	void
	 */
	function draftOrder(order, species) {
		let defer = $q.defer();
		let input = parseCustomerInfoFromOrder(order);
		const product = findProduct(species);

		console.log('draftOrder called:', {
			species: species,
			product: product ? product.title : 'NOT FOUND',
			orderAmount: order.amount,
			vouchersCount: order.vouchers.length,
			paidQty: order.amount - order.vouchers.length,
			variants: product ? product.variants : []
		});

		if (!product) {
			alert('Unable to find a matcing product in shopify');
		}
		if (order.vouchers.length) {
			// startpop_oc_free doesn't exist - we should remove the ability to add vouchers in cornuta season.
			const freeVariant = product.variants.find(variant => {
				return variant.price == 0;
			});
			input.lineItems.push({
				variantId: freeVariant.id,
				quantity: order.vouchers.length,
				customAttributes: {
					key: 'vouchers',
					value: order.vouchers.map(voucher => voucher.code).join(', ')
				}
			});
		}

		if (order.amount && order.amount > order.vouchers.length) {
			const variant = product.variants.find(item => {
				return Number(item.price) > 0;
			});
			if (!variant) {
				alert('No paid variant found on product ' + product.title);
			}
			input.lineItems.push({
				variantId: variant.id,
				quantity: order.amount - order.vouchers.length
			});
		}
		if (order.donation) {
			input.lineItems.push({
				variantId: order.donation.id,
				quantity: 1
			});
		}

		const mutation =
			'mutation draftOrderCreate($input: DraftOrderInput!) {\
			draftOrderCreate(input: $input) {\
			  draftOrder {\
				id\
				invoiceUrl\
			  }\
			}\
		  }\
		  ';
		runQuery(mutation, { input: input }).then(res => {
			if (
				res.data.data &&
				res.data.data.draftOrderCreate &&
				res.data.data.draftOrderCreate.draftOrder
			) {
				defer.resolve(res.data.data.draftOrderCreate.draftOrder);
			} else {
				console.error(res);
				defer.reject();
			}
		});
		return defer.promise;
	}

	/**
	 * Sends a query to the beehome interface to Shopifies graphQL.
	 *
	 * @param	graphQL	query
	 * @return	mixed
	 */
	function runQuery(query, variables, locale) {
		setLocale(locale);
		return $http.post(
			SETTINGS.beehomeAPIBasePath + 'shopify-graphql?locale=' + factory.locale,
			JSON.stringify({
				query: query,
				variables: variables
			})
		);
	}
}

'use strict';

/**
 * @ngdoc directive
 * @name wildBieneHarvestApp.directive:beehomeVouchers
 * @description
 */
angular
	.module('wildBieneHarvestApp')
	.directive('beehomeAccountVouchers', function(userService, startpopSettings) {
		return {
			templateUrl: 'views/beehome-account-vouchers.html',
			scope: {
				clientId: '<'
			},
			link: function postLink(scope) {
				scope.voucherQuery = {
					limit: 100,
					page: 1,
					limitOptions: [100, 200, 300]
				};
				userService.all().then(function(users) {
					scope.users = users;
				});
				function init() {
					startpopSettings
						.getVoucherList({ client_id: scope.clientId })
						.then(data => {
							scope.vouchers = data.items.sort((a, b) => {
								if (a.created_at > b.created_at && a.is_active) {
									return -1;
								} else if (a.created_at > b.created_at && !b.is_active) {
									return -1;
								} else {
									return 1;
								}
							});
						});
				}
				init();
			}
		};
	});

angular.module('wildBieneHarvestApp').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('404.html',
    "<!DOCTYPE html> <html lang=\"en\"> <head> <meta charset=\"utf-8\"> <title>Page Not Found :(</title> <style>::-moz-selection {\n" +
    "\t\t\t\tbackground: #b3d4fc;\n" +
    "\t\t\t\ttext-shadow: none;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t::selection {\n" +
    "\t\t\t\tbackground: #b3d4fc;\n" +
    "\t\t\t\ttext-shadow: none;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\thtml {\n" +
    "\t\t\t\tpadding: 30px 10px;\n" +
    "\t\t\t\tfont-size: 20px;\n" +
    "\t\t\t\tline-height: 1.4;\n" +
    "\t\t\t\tcolor: #737373;\n" +
    "\t\t\t\tbackground: #f0f0f0;\n" +
    "\t\t\t\t-webkit-text-size-adjust: 100%;\n" +
    "\t\t\t\t-ms-text-size-adjust: 100%;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\thtml,\n" +
    "\t\t\tinput {\n" +
    "\t\t\t\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\tbody {\n" +
    "\t\t\t\tmax-width: 500px;\n" +
    "\t\t\t\tpadding: 30px 20px 50px;\n" +
    "\t\t\t\tborder: 1px solid #b3b3b3;\n" +
    "\t\t\t\tborder-radius: 4px;\n" +
    "\t\t\t\tmargin: 0 auto;\n" +
    "\t\t\t\tbox-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n" +
    "\t\t\t\tbackground: #fcfcfc;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\th1 {\n" +
    "\t\t\t\tmargin: 0 10px;\n" +
    "\t\t\t\tfont-size: 50px;\n" +
    "\t\t\t\ttext-align: center;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\th1 span {\n" +
    "\t\t\t\tcolor: #bbb;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\th3 {\n" +
    "\t\t\t\tmargin: 1.5em 0 0.5em;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\tp {\n" +
    "\t\t\t\tmargin: 1em 0;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\tul {\n" +
    "\t\t\t\tpadding: 0 0 0 40px;\n" +
    "\t\t\t\tmargin: 1em 0;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t.container {\n" +
    "\t\t\t\tmax-width: 380px;\n" +
    "\t\t\t\tmargin: 0 auto;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t/* google search */\n" +
    "\n" +
    "\t\t\t#goog-fixurl ul {\n" +
    "\t\t\t\tlist-style: none;\n" +
    "\t\t\t\tpadding: 0;\n" +
    "\t\t\t\tmargin: 0;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-fixurl form {\n" +
    "\t\t\t\tmargin: 0;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-wm-qt,\n" +
    "\t\t\t#goog-wm-sb {\n" +
    "\t\t\t\tborder: 1px solid #bbb;\n" +
    "\t\t\t\tfont-size: 16px;\n" +
    "\t\t\t\tline-height: normal;\n" +
    "\t\t\t\tvertical-align: top;\n" +
    "\t\t\t\tcolor: #444;\n" +
    "\t\t\t\tborder-radius: 2px;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-wm-qt {\n" +
    "\t\t\t\twidth: 220px;\n" +
    "\t\t\t\theight: 20px;\n" +
    "\t\t\t\tpadding: 5px;\n" +
    "\t\t\t\tmargin: 5px 10px 0 0;\n" +
    "\t\t\t\tbox-shadow: inset 0 1px 1px #ccc;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-wm-sb {\n" +
    "\t\t\t\tdisplay: inline-block;\n" +
    "\t\t\t\theight: 32px;\n" +
    "\t\t\t\tpadding: 0 10px;\n" +
    "\t\t\t\tmargin: 5px 0 0;\n" +
    "\t\t\t\twhite-space: nowrap;\n" +
    "\t\t\t\tcursor: pointer;\n" +
    "\t\t\t\tbackground-color: #f5f5f5;\n" +
    "\t\t\t\tbackground-image: -webkit-linear-gradient(rgba(255, 255, 255, 0), #f1f1f1);\n" +
    "\t\t\t\tbackground-image: -moz-linear-gradient(rgba(255, 255, 255, 0), #f1f1f1);\n" +
    "\t\t\t\tbackground-image: -ms-linear-gradient(rgba(255, 255, 255, 0), #f1f1f1);\n" +
    "\t\t\t\tbackground-image: -o-linear-gradient(rgba(255, 255, 255, 0), #f1f1f1);\n" +
    "\t\t\t\t-webkit-appearance: none;\n" +
    "\t\t\t\t-moz-appearance: none;\n" +
    "\t\t\t\tappearance: none;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-wm-sb:hover,\n" +
    "\t\t\t#goog-wm-sb:focus {\n" +
    "\t\t\t\tborder-color: #aaa;\n" +
    "\t\t\t\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n" +
    "\t\t\t\tbackground-color: #f8f8f8;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\t#goog-wm-qt:hover,\n" +
    "\t\t\t#goog-wm-qt:focus {\n" +
    "\t\t\t\tborder-color: #105cb6;\n" +
    "\t\t\t\toutline: 0;\n" +
    "\t\t\t\tcolor: #222;\n" +
    "\t\t\t}\n" +
    "\n" +
    "\t\t\tinput::-moz-focus-inner {\n" +
    "\t\t\t\tpadding: 0;\n" +
    "\t\t\t\tborder: 0;\n" +
    "\t\t\t}</style> </head> <body> <div class=\"container\"> <h1>Not found <span>:(</span></h1> <p>Sorry, but the page you were trying to view does not exist.</p> <p>It looks like this was the result of either:</p> <ul> <li>a mistyped address</li> <li>an out-of-date link</li> </ul> <script>var GOOG_FIXURL_LANG = (navigator.language || \"\").slice(0, 2),\n" +
    "\t\t\t\t\tGOOG_FIXURL_SITE = location.host;</script> <script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script> </div> </body> </html>"
  );


  $templateCache.put('index.html',
    "<!DOCTYPE html> <html> <head> <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"> <meta charset=\"utf-8\"> <title>Bee Admin</title> <meta name=\"description\" content=\"\"> <link href=\"https://fonts.googleapis.com/css?family=Hind:400,700|Bitter\" rel=\"stylesheet\" type=\"text/css\"> <link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\"> <meta name=\"viewport\" content=\"width=device-width\"> <meta http-equiv=\"Cache-control\" content=\"no-cache, no-store, must-revalidate\"> <meta http-equiv=\"Pragma\" content=\"no-cache\"> <link rel=\"icon\" href=\"images/cropped-bee-180x180.png\" sizes=\"180x180\"> <!-- build:css(.) styles/vendor.css --> <link rel=\"stylesheet\" href=\"node_modules/angular-material/angular-material.css\"> <link rel=\"stylesheet\" href=\"node_modules/intl-tel-input/build/css/intlTelInput.css\"> <link rel=\"stylesheet\" href=\"node_modules/angular-material-data-table/dist/md-data-table.css\"> <!-- endbower --> <!-- endbuild --> <link rel=\"stylesheet\" href=\"https://cdn.datatables.net/1.10.19/css/jquery.dataTables.min.css\"> <!-- build:css(.tmp) styles/main.css --> <link rel=\"stylesheet\" href=\"styles/main.css\"> <!-- endbuild --> </head> <body layout-fill layout=\"row\" ng-cloak> <!--[if lte IE 8]>\n" +
    "\t\t\t<p class=\"browsehappy\">\n" +
    "\t\t\t\tYou are using an <strong>outdated</strong> browser. Please\n" +
    "\t\t\t\t<a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your\n" +
    "\t\t\t\texperience.\n" +
    "\t\t\t</p>\n" +
    "\t\t<![endif]--> <!-- Add your site or application content here --> <div layout=\"column\" flex layout-align=\"end stretch\" ng-controller=\"NavCtrl\"> <div layout=\"row\"> <div class=\"nav-ico-holder\" ng-hide=\"navInfo.modalOpen\" layout layout-margin layout-align=\"start start\"> <a href=\"#dashboard\"><img src=\"images/Logo.png\" class=\"img-responsive\"> </a> <div flex=\"5\"></div> <div md-button class=\"md-icon-button menu-icon\" md-ink-ripple ng-click=\"openLeftMenu()\" restrict-access=\"BeeFarmer Settings\" ng-show=\"stream\" aria-label=\"settings\"> <i class=\"material-icons\">menu</i> </div> </div> <h1>{{navInfo.pageTitle}}</h1> <span flex></span> <div class=\"title-area\" layout=\"column\" flex ng-switch=\"navInfo.titleArea\" layout-align=\"center end\"> <client-search ng-switch-when=\"CLIENT_SEARCH\" selected-item=\"\" style=\"width:280px\"></client-search> </div> <div style=\"padding:20px\" restrict-access=\"Select Language\"> <md-input-container> <label>Lang</label> <md-select ng-model=\"language\" ng-change=\"selectLanguage()\"> <md-option value=\"en\">EN</md-option> <md-option value=\"de\">DE</md-option> </md-select> </md-input-container> </div> </div> <div layout=\"row\" class=\"inner-wrapper\" ng-class=\"{strip:!sidenavopen}\" layout-align=\"start stretch\" flex> <div layout=\"column\" layout-align=\"stretch start\" flex-fill> <md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-is-locked-open=\"sidenavopen\" ng-show=\"stream\" flex layout=\"column\" layout-align=\"stretch\"> <div class=\"stream-info\" layout=\"row\" layout-padding ng-show=\"stream\" layout-align=\"start center\"> <h2> {{stream}} <span ng-if=\"stream == 'beehome' || stream == 'farmer' || stream == 'management'\"> {{season}} &nbsp; </span> </h2> <md-button ng-if=\"stream=='beehome'\" class=\"md-icon-button nav-settings-icon\" md-ink-ripple ng-click=\"openSettings()\" restrict-access=\"BeeHarvest Settings\" aria-label=\"settings\"> <i class=\"material-icons\">settings</i> </md-button> <md-button ng-if=\"stream=='farmer'\" class=\"md-icon-button nav-settings-icon\" md-ink-ripple ng-click=\"openSettings()\" restrict-access=\"BeeFarmer Settings\" aria-label=\"settings\"> <i class=\"material-icons\">settings</i> </md-button> <md-button ng-if=\"stream=='management'\" class=\"md-icon-button nav-settings-icon\" md-ink-ripple ng-click=\"openSettings()\" aria-label=\"settings\"> <i class=\"material-icons\">settings</i> </md-button> </div> <div md-menu> <div md-menu-content ng-show=\"stream == 'beehome'\" layout=\"column\"> <md-button ng-class=\"getClass('/beehome/account')\" restrict-access=\"BeeHarvest Customer\"> <a ng-href=\"/#/beehome/account\"> <h4 translate=\"general.customer\">Account</h4> </a> </md-button> <md-button restrict-access=\"BeeStarter\"> <a ui-sref=\"beehome-orders\"> <h4>Orders</h4> </a> </md-button> <md-button restrict-access=\"Amend Whitelist\"> <a ui-sref=\"beehome-vouchers\"> <h4>Vouchers</h4> </a> </md-button> <md-button restrict-access=\"Tube\" ng-class=\"getClass('/harvest/tubes')\"> <a ng-href=\"/#/harvest/tubes\"> <h4 translate=\"general.tube\">Tube</h4> </a> </md-button> <md-button restrict-access=\"Cocoon\" ng-class=\"getClass('/harvest/cocoons')\"> <a ng-href=\"/#/harvest/cocoons\"> <h4 translate=\"general.cocoon\">Cocoon</h4> </a> </md-button> <md-button restrict-access=\"Harvest Check\" ng-class=\"getClass('/harvest/check')\"> <a ng-href=\"/#/harvest/check\"> <h4 translate=\"harvest.check\">Check</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/qrcode')\"> <a ui-sref=\"managementQRCode\"> <h4>QR Code</h4> </a> </md-button> </div> <div md-menu-content ng-show=\"stream == 'farmer'\" layout=\"column\"> <md-button ng-class=\"getClass('/farmer/account')\" restrict-access=\"BeeFarmer Customer\"> <a href=\"#/farmer/account\"> <h4>Account</h4> </a> </md-button> <md-button ng-class=\"getClass('/farmer/salesOrders')\" restrict-access=\"BeeFarmer Customer\"> <a href=\"#/farmer/salesOrders\"> <h4>Orders</h4> </a> </md-button> <!--<md-button ng-class=\"getClass('/farmer/deliveries')\" restrict-access=\"Customer Deliveries\">--> <md-button ng-class=\"getClass('/farmer/deliveries')\" restrict-access=\"BeeFarmer Deliveries\"> <a href=\"#/farmer/deliveries\"> <h4>Deliveries</h4> </a> </md-button> <md-button ng-class=\"getClass('/farmer/checkin')\" restrict-access=\"Check In\"> <a href=\"#/farmer/checkin\"> <h4>Check In</h4> </a> </md-button> <md-button ng-class=\"getClass('/farmer/checkout')\" restrict-access=\"Check Out\"> <a href=\"#/farmer/checkout\"> <h4>Check Out</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/qrcode')\"> <a ui-sref=\"managementQRCode\"> <h4>QR Code</h4> </a> </md-button> </div> <div md-menu-content ng-show=\"stream == 'management'\" layout=\"column\"> <md-button ng-class=\"getClass('/management/search')\" restrict-access=\"BeeManagement Search\"> <a ui-sref=\"managementSearch\"> <h4>Search</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/box/create')\" restrict-access=\"BeeManagement Create\"> <a ui-sref=\"managementCreate\"> <h4>Create population</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/checkin')\" restrict-access=\"BeeManagement Checkin\"> <a ui-sref=\"managementCheckin\"> <h4>Check In</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/checkout')\" restrict-access=\"BeeManagement Checkout\"> <a ui-sref=\"managementCheckout\"> <h4>Check Out</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/qrcode')\" restrict-access=\"BeeManagement\"> <a ui-sref=\"managementQRCode\"> <h4>QR Code</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/statistics')\" restrict-access=\"BeeManagement Statistics\"> <a href=\"#/management/statistics\"> <h4>Statistics</h4> </a> </md-button> <md-button ng-class=\"getClass('/management/logs')\" restrict-access=\"BeeManagement Logs\"> <a href=\"#/management/logs\"> <h4>Logs</h4> </a> </md-button> </div> <div md-menu-content ng-show=\"stream == 'administration'\" layout=\"column\"> <md-button ng-class=\"getClass('/admin/organisations')\" restrict-access=\"Admin\"> <a href=\"#/admin/organisations\"> <h4>ORGANISATIONS</h4> </a> </md-button> <md-button ng-class=\"getClass('/admin/products')\" restrict-access=\"Admin\"> <a href=\"#/admin/products\"> <h4>PRODUCTS</h4> </a> </md-button> <md-button ng-class=\"getClass('/admin/packaging')\" restrict-access=\"Admin\"> <a href=\"#/admin/packaging\"> <h4>PACKAGING</h4> </a> </md-button> <md-button ng-class=\"getClass('/admin/shopify/orders')\" restrict-access=\"Admin\"> <a ui-sref=\"admin-shopify-orders\"> <h4>Shopify orders</h4> </a> </md-button> </div> </div> <div flex layout-padding> <div class=\"daily-count\" ng-show=\"stream == 'beehome'\"> {{dailyCount || '0'}} </div> </div> </md-sidenav> </div> <div layout-fill style=\"overflow:auto\"> <div ui-view flex ng-class=\"{ paddedview : sidenavopen == false}\" resize-table></div> </div> </div> <div class=\"footer flex\" flex=\"\" style=\"width: 220px;\n" +
    "    min-width: 220px;\n" +
    "    max-height: 80px\"> <div layout=\"row\" layout-align=\"start start\" class=\"tiny-type\" ng-show=\"showLogout\" style=\"line-height: 11px; margin:0;padding:0\"> <span ng-show=\"sidenavopen\"> <md-icon><i class=\"material-icons\" ng-click=\"search()\">person</i></md-icon>{{fullname}} </span> <span ng-hide=\"sidenavopen\"><br>&nbsp;</span> </div> <div layout=\"row\" layout-align=\"start end\"> <md-button flex-gt-xs ng-show=\"showLogout && sidenavopen\" ng-href=\"#/logout\" style=\"text-align: left;bottom: -3px\"> Logout </md-button> <md-button flex-gt-xs ng-show=\"showLogout && !sidenavopen\" ng-href=\"#/logout\" style=\"text-align: left;bottom: -5px\"> Logout </md-button> <md-button flex-gt-xs ng-show=\"showLogin\" ng-href=\"#login\"> Login </md-button> </div> </div> <!-- <div class=\"footer\" flex layout=\"row\" >\n" +
    "\n" +
    "          <p><i class=\"material-icons\">favorite</i> <a href=\"http://notsosapien.com\">from Notsosapien</a>.</p>\n" +
    "\n" +
    "      </div> --> <div class=\"load-screen\" ng-show=\"$root.showLoader\"> <div class=\"loadbox\" layout-align=\"space-around\"> <md-progress-circular md-diameter=\"100\" md-mode=\"indeterminate\"></md-progress-circular> </div> </div> </div> <script src=\"env.js\"></script> <script src=\"https://keycloak.wildbieneundpartner.ch/auth/js/keycloak.js\"></script> <script src=\"https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js\"></script> <!-- build:js(.) scripts/vendor.js --> <script src=\"node_modules/angular/angular.js\"></script> <script src=\"node_modules/angular-aria/angular-aria.js\"></script> <script src=\"node_modules/angular-animate/angular-animate.js\"></script> <script src=\"node_modules/angular-cookies/angular-cookies.js\"></script> <script src=\"node_modules/angular-resource/angular-resource.js\"></script> <script src=\"node_modules/angular-route/angular-route.js\"></script> <script src=\"node_modules/angular-sanitize/angular-sanitize.js\"></script> <script src=\"node_modules/angular-touch/angular-touch.js\"></script> <!-- <script src=\"node_modules/object-path/index.js\"></script> --> <!-- TODO: check this --> <!-- <script src=\"node_modules/ng-autocomplete/angucomplete.js\"></script> --> <script src=\"node_modules/angular-messages/angular-messages.js\"></script> <script src=\"node_modules/angular-material/angular-material.js\"></script> <script src=\"node_modules/moment/min/moment.min.js\"></script> <script src=\"node_modules/intl-tel-input/build/js/intlTelInput.js\"></script> <script src=\"node_modules/intl-tel-input/build/js/utils.js\"></script> <script src=\"node_modules/ng-intl-tel-input/dist/ng-intl-tel-input.js\"></script> <script src=\"node_modules/angular-ui-router/release/angular-ui-router.js\"></script> <script src=\"node_modules/file-saver/dist/FileSaver.min.js\"></script> <script src=\"node_modules/json-export-excel/src/json-export-excel.js\"></script> <script src=\"node_modules/xlsx/xlsx.js\"></script> <script src=\"node_modules/jszip/dist/jszip.js\"></script> <!-- <script src=\"node_modules/js-xlsx/dist/xlsx.full.min.js\"></script> --> <script src=\"node_modules/webcamjs/webcam.js\"></script> <!-- <script src=\"node_modules/datatables/media/js/jquery.dataTables.js\"></script>\n" +
    "\t\t<script src=\"node_modules/datatables.net/js/jquery.dataTables.js\"></script>\n" +
    "\t\t<script src=\"node_modules/jquery-datatables-checkboxes/js/dataTables.checkboxes.js\"></script> --> <script src=\"node_modules/papaparse/papaparse.js\"></script> <script src=\"node_modules/ng-file-upload/dist/ng-file-upload.js\"></script> <script src=\"node_modules/ng-file-upload/dist/ng-file-upload-shim.js\"></script> <script src=\"node_modules/blueimp-load-image/js/load-image.all.min.js\"></script> <script src=\"node_modules/angular-material-data-table/dist/md-data-table.js\"></script> <script src=\"node_modules/angular-translate/dist/angular-translate.js\"></script> <script src=\"node_modules/angular-translate-loader-static-files/angular-translate-loader-static-files.js\"></script> <script src=\"node_modules/angular-fixed-table-header/src/fixed-table-header.js\"></script> <script src=\"node_modules/ng-currency/dist/ng-currency.js\"></script> <!-- endbuild --> <!-- build:js({.tmp,app}) scripts/scripts.js --> <script src=\"utils.js\"></script> <script src=\"scripts/app.js\"></script> <script src=\"scripts/ads.js\"></script> <script src=\"scripts/controllers/about.js\"></script> <script src=\"scripts/controllers/customer-search.js\"></script> <script src=\"scripts/services/houses.js\"></script> <script src=\"scripts/services/session.js\"></script> <script src=\"scripts/services/datatables-ajax.js\"></script> <script src=\"scripts/directives/account-summary.directive.js\"></script> <script src=\"scripts/directives/address-picker.js\"></script> <script src=\"scripts/directives/client-tabs.directive.js\"></script> <script src=\"scripts/directives/house-link.js\"></script> <script src=\"scripts/controllers/client.js\"></script> <script src=\"scripts/filters/cleandata.js\"></script> <script src=\"scripts/filters/delimiter.js\"></script> <script src=\"scripts/services/customer.js\"></script> <script src=\"scripts/services/producttypes.js\"></script> <script src=\"scripts/controllers/station.js\"></script> <script src=\"scripts/controllers/harvest-check.js\"></script> <script src=\"scripts/directives/productdetails.js\"></script> <script src=\"scripts/controllers/admin-organisations.js\"></script> <script src=\"scripts/controllers/admin-products.js\"></script> <script src=\"scripts/controllers/admin-packaging.js\"></script> <script src=\"scripts/services/species.js\"></script> <script src=\"scripts/services/users.js\"></script> <script src=\"scripts/services/population.js\"></script> <script src=\"scripts/services/authinterceptor.js\"></script> <script src=\"scripts/controllers/logout.js\"></script> <script src=\"scripts/controllers/productpop.js\"></script> <script src=\"scripts/controllers/customerexistmodal.js\"></script> <script src=\"scripts/controllers/navcontroller.js\"></script> <script src=\"scripts/controllers/datasavedmodal.js\"></script> <script src=\"scripts/directives/focusme.js\"></script> <script src=\"scripts/controllers/errormodal.js\"></script> <script src=\"scripts/controllers/ordermodal.js\"></script> <script src=\"scripts/controllers/dashboard.js\"></script> <script src=\"scripts/controllers/contract.js\"></script> <script src=\"scripts/controllers/farmersettings.js\"></script> <script src=\"scripts/directives/orderpanel.js\"></script> <script src=\"scripts/directives/requestpanel.js\"></script> <script src=\"scripts/controllers/requestmodal.js\"></script> <script src=\"scripts/services/cultures.js\"></script> <script src=\"scripts/services/contracts.js\"></script> <script src=\"scripts/services/orderitems.js\"></script> <script src=\"scripts/controllers/deliverymanagement.js\"></script> <script src=\"scripts/services/farmersettings.js\"></script> <script src=\"scripts/services/farmerproducts.js\"></script> <script src=\"scripts/directives/deliveriespanel.js\"></script> <script src=\"scripts/controllers/dispatch.js\"></script> <script src=\"scripts/controllers/deliverymodal.js\"></script> <script src=\"scripts/controllers/deliverynotesmodal.js\"></script> <script src=\"scripts/controllers/requestcheckoutmodalmodal.js\"></script> <script src=\"scripts/services/codevalidator.js\"></script> <script src=\"scripts/directives/selectonclick.js\"></script> <script src=\"scripts/controllers/reassignhousedialog.js\"></script> <script src=\"scripts/services/harvestsettings.js\"></script> <script src=\"scripts/directives/phoneinput.js\"></script> <script src=\"scripts/directives/ng-webcam.js\"></script> <script src=\"scripts/directives/numberinput.js\"></script> <script src=\"scripts/controllers/harvestsettings.js\"></script> <script src=\"scripts/controllers/farmercheckout.js\"></script> <script src=\"scripts/controllers/farmercheckin.js\"></script> <script src=\"scripts/services/orginisations.js\"></script> <script src=\"scripts/controllers/boxmanagement.js\"></script> <script src=\"scripts/controllers/boxmodal.js\"></script> <script src=\"scripts/controllers/boxesmodal.js\"></script> <script src=\"scripts/controllers/imagemodal.js\"></script> <script src=\"scripts/controllers/fridgemodal.js\"></script> <script src=\"scripts/controllers/fridgesmodal.js\"></script> <script src=\"scripts/controllers/beehome-orders-state.js\"></script> <script src=\"scripts/directives/producthistory.js\"></script> <script src=\"scripts/controllers/boxcheckin.js\"></script> <script src=\"scripts/controllers/boxcheckout.js\"></script> <script src=\"scripts/controllers/fridge.js\"></script> <script src=\"scripts/controllers/box.js\"></script> <script src=\"scripts/services/boxloader.js\"></script> <script src=\"scripts/directives/boxpanel.js\"></script> <script src=\"scripts/services/fridgeloader.js\"></script> <script src=\"scripts/directives/fridgepanel.js\"></script> <script src=\"scripts/controllers/managementsettings.js\"></script> <script src=\"scripts/services/managementsettings.js\"></script> <script src=\"scripts/controllers/createboxes.js\"></script> <script src=\"scripts/directives/startpop-form.js\"></script> <script src=\"scripts/services/useralert.js\"></script> <script src=\"scripts/services/selectinput.js\"></script> <script src=\"scripts/directives/restrictaccess.js\"></script> <script src=\"scripts/directives/organisationpanel.js\"></script> <script src=\"scripts/directives/productspanel.js\"></script> <script src=\"scripts/controllers/organisationsettings.js\"></script> <script src=\"scripts/services/geoinfo.js\"></script> <script src=\"scripts/services/datatables-ajax.js\"></script> <script src=\"scripts/controllers/productsmodal.js\"></script> <script src=\"scripts/controllers/documentmodal.js\"></script> <script src=\"scripts/directives/salesproductspanel.js\"></script> <script src=\"scripts/controllers/salesproductsmodal.js\"></script> <script src=\"scripts/services/deliverygenerator.js\"></script> <script src=\"scripts/services/startpopsettings.js\"></script> <script src=\"scripts/controllers/beehome-orders.js\"></script> <script src=\"scripts/controllers/beehome-order.js\"></script> <script src=\"scripts/directives/beehome-orders.js\"></script> <script src=\"scripts/directives/excelexport.js\"></script> <script src=\"scripts/filters/setphrasevalues.js\"></script> <script src=\"scripts/filters/selectphrases.js\"></script> <script src=\"scripts/services/phrases.js\"></script> <script src=\"scripts/controllers/product-link.js\"></script> <script src=\"scripts/services/codeidentifier.js\"></script> <script src=\"scripts/directives/input-fields.js\"></script> <script src=\"scripts/directives/keepwidth.js\"></script> <script src=\"scripts/services/converter.js\"></script> <script src=\"scripts/controllers/snapshotmodal.js\"></script> <script src=\"scripts/controllers/client-notes.modal.js\"></script> <script src=\"scripts/directives/customtable.js\"></script> <script src=\"scripts/controllers/managementstatistics.js\"></script> <script src=\"scripts/controllers/managementlogs.js\"></script> <script src=\"scripts/directives/fridgecontentsummary.js\"></script> <script src=\"scripts/controllers/createboxesfridgemodal.js\"></script> <script src=\"scripts/controllers/sales-products-packaging-modal.js\"></script> <script src=\"scripts/controllers/orderculturesmodal.js\"></script> <script src=\"scripts/services/printerservice.js\"></script> <script src=\"scripts/controllers/mailmodal.js\"></script> <script src=\"scripts/controllers/historymodal.js\"></script> <script src=\"scripts/directives/tree.js\"></script> <script src=\"scripts/services/treehelper.js\"></script> <script src=\"scripts/services/statuses.js\"></script> <script src=\"scripts/controllers/beehome-voucher.js\"></script> <script src=\"scripts/services/shippinglabel.js\"></script> <script src=\"scripts/directives/beehome-voucher-search.js\"></script> <script src=\"scripts/controllers/beehome-voucher.modal.js\"></script> <script src=\"scripts/directives/client-search.directive.js\"></script> <script src=\"scripts/services/client-search.factory.js\"></script> <script src=\"scripts/controllers/sales-orders.js\"></script> <script src=\"scripts/directives/productprogressindicator.js\"></script> <script src=\"scripts/services/tracking-number.js\"></script> <script src=\"scripts/directives/tracking-number.js\"></script> <script src=\"scripts/services/order.js\"></script> <script src=\"scripts/services/batch.js\"></script> <script src=\"scripts/directives/forceselect.js\"></script> <script src=\"scripts/directives/subscriptionspanel.js\"></script> <script src=\"scripts/services/subscription.js\"></script> <script src=\"scripts/directives/screendisplay.js\"></script> <script src=\"scripts/controllers/subscriptionmodal.js\"></script> <script src=\"scripts/services/buttonlabel.js\"></script> <script src=\"scripts/directives/filterpanel.js\"></script> <script src=\"scripts/directives/beehome-orders-filter.js\"></script> <script src=\"scripts/controllers/date-range-picker.js\"></script> <script src=\"scripts/controllers/account.modal.js\"></script> <script src=\"scripts/services/client.factory.js\"></script> <script src=\"scripts/services/language.factory.js\"></script> <script src=\"scripts/directives/address-modal.directive.js\"></script> <script src=\"scripts/services/contact.factory.js\"></script> <script src=\"scripts/controllers/address.modal.js\"></script> <script src=\"scripts/services/address.factory.js\"></script> <script src=\"scripts/services/apiinterface.factory.js\"></script> <script src=\"scripts/directives/address-form.directive.js\"></script> <script src=\"scripts/directives/history.directive.js\"></script> <script src=\"scripts/directives/client-cultures.directive.js\"></script> <script src=\"scripts/services/client-cultures.factory.js\"></script> <script src=\"scripts/directives/client-notes.directive.js\"></script> <script src=\"scripts/services/client-notes.factory.js\"></script> <script src=\"scripts/services/organisation.factory.js\"></script> <script src=\"scripts/directives/client-contacts.directive.js\"></script> <script src=\"scripts/directives/contact.form.js\"></script> <script src=\"scripts/controllers/contact.modal.js\"></script> <script src=\"scripts/services/certification.factory.js\"></script> <script src=\"scripts/services/population.factory.js\"></script> <script src=\"scripts/directives/recognition-iframe.directive.js\"></script> <script src=\"scripts/services/startpop.voucher.upload.js\"></script> <script src=\"scripts/services/country.factory.js\"></script> <script src=\"scripts/services/boxmanagement.factory.js\"></script> <script src=\"scripts/directives/boxmanagement-boxes.directive.js\"></script> <script src=\"scripts/directives/boxmanagement-fridges.directive.js\"></script> <script src=\"scripts/directives/boxmanagement-startpops.directive.js\"></script> <script src=\"scripts/directives/box-provenience-list.directive.js\"></script> <script src=\"scripts/services/references.factory.js\"></script> <script src=\"scripts/services/settings.factory.js\"></script> <script src=\"scripts/components/admin/settings/organisation-settings/organisation-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/general-settings/general-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/beemanagement-settings/beemanagement-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/beefarmer-settings/beefarmer-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/beestarter-settings/beestarter-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/beecare-settings/beecare-settings.component.js\"></script> <script src=\"scripts/components/admin/settings/org-settings/org-settings.component.js\"></script> <script src=\"scripts/components/beehome/orders/shopify-orders/shopify-prders.component.js\"></script> <script src=\"scripts/components/management/qrcode-generator/qrcode-generator.component.js\"></script> <script src=\"scripts/directives/file-model.js\"></script> <script src=\"scripts/services/shopify.factory.js\"></script> <script src=\"scripts/directives/beehome-vouchers.js\"></script> <!-- endbuild --> </body> </html>"
  );


  $templateCache.put('scripts/components/admin/settings/beecare-settings/beecare-settings.template.html',
    "<form class=\"form bee-starter-form\" name=\"$ctrl.beecareForm\" ng-submit=\"$ctrl.beecareForm.$valid && $ctrl.saveBeecareSettings()\"> <div class=\"layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <h4>Tube Ratios</h4> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label translate=\"tubes.singleYearRatio\">Single Year Tube Ratio</label> <input aria-label=\"Single Year Tube Ratio\" flex name=\"singleRatio\" type=\"number\" step=\"0.01\" ng-model=\"$ctrl.beecareSettings.single_year_ratio\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" required> <div ng-messages=\"$ctrl.beecareForm.singleRatio.$error\" ng-if=\"$ctrl.beecareForm.$submitted || $ctrl.beecareForm.singleRatio.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"pattern\"> Please enter a Decimal with a maximum of two trailing digits. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label translate=\"tubes.mixedRatio\">Mixed Tube Ratio</label> <input aria-label=\"Price\" flex name=\"mixedRatio\" type=\"number\" step=\"0.01\" ng-model=\"$ctrl.beecareSettings.mixed_ratio\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" required> <div ng-messages=\"$ctrl.beecareForm.mixedRatio.$error\" ng-if=\"$ctrl.beecareForm.$submitted || $ctrl.beecareForm.mixedRatio.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"pattern\"> Please enter a Decimal with a maximum of two trailing digits. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label translate=\"tubes.multiYearRatio\">Multi Year Tube Ratio</label> <input aria-label=\"Multi Ratio\" flex name=\"multiRatio\" type=\"number\" step=\"0.01\" ng-model=\"$ctrl.beecareSettings.multi_year_ratio\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" required> <div ng-messages=\"$ctrl.beecareForm.multiRatio.$error\" ng-if=\"$ctrl.beecareForm.$submitted || $ctrl.beecareForm.multRatio.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"pattern\"> Pattern doesn't match. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block left-align\" flex-gt-xs> <label>Start date</label> <md-datepicker aria-label=\"Start date\" name=\"startDate\" ng-model=\"$ctrl.beecareSettings.start_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beecareForm.startDate.$error\" ng-if=\"$ctrl.beecareForm.$submitted || $ctrl.beecareForm.startDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label>End date</label> <md-datepicker aria-label=\"End date\" name=\"endDate\" ng-model=\"$ctrl.beecareSettings.end_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beecareForm.endDate.$error\" ng-if=\"$ctrl.beecareForm.$submitted || $ctrl.beecareForm.endDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button ng-click=\"$ctrl.saveBeecareSettings()\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/beefarmer-settings/beefarmer-settings.template.html',
    "<form class=\"form organisations-form\" name=\"$ctrl.beeFarmerForm\" ng-submit=\"$ctrl.beeFarmerForm.$valid && $ctrl.saveBeeFarmerSettings()\"> <div class=\"layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Order validity period</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Order validity period\" flex type=\"number\" step=\"1\" min=\"0\" name=\"validityPeriod\" ng-model=\"$ctrl.org.validityPeriod\"> <div ng-messages=\"$ctrl.beeFarmerForm.validityPeriod.$error\" ng-if=\"$ctrl.beeFarmerForm.$submitted || $ctrl.beeFarmerForm.validityPeriod.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Available delivery days </span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-input-container class=\"md-block\" flex-gt-xs flex=\"75\"> <label>Available delivery days</label> <md-select ng-model=\"$ctrl.org.farmerDeliveryDays\" multiple> <md-option ng-value=\"1\">Monday</md-option> <md-option ng-value=\"2\">Tuesday</md-option> <md-option ng-value=\"3\">Wednesday</md-option> <md-option ng-value=\"4\">Thursday</md-option> <md-option ng-value=\"5\">Friday</md-option> </md-select> </md-input-container> <div ng-messages=\"$ctrl.beeFarmerForm.farmerDeliveryDays.$error\" ng-if=\"$ctrl.beeFarmerForm.$submitted || $ctrl.beeFarmerForm.farmerDeliveryDays.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Request lead time (days)</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Shipping Cost threshold\" flex type=\"text\" name=\"farmerLeadTime\" ng-model=\"$ctrl.org.farmerLeadTime\" required> <div ng-messages=\"$ctrl.beeFarmerForm.farmerLeadTime.$error\" ng-if=\"$ctrl.beeFarmerForm.$submitted || $ctrl.beeFarmerForm.farmerLeadTime.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Checkin client ID</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Checkin client ID\" flex type=\"text\" name=\"checkinClientId\" ng-model=\"$ctrl.org.checkinClientId\"> <div ng-messages=\"$ctrl.beeFarmerForm.checkinClientId.$error\" ng-if=\"$ctrl.beeFarmerForm.$submitted || $ctrl.beeFarmerForm.checkinClientId.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">From email</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"From email\" flex type=\"text\" name=\"fromEmail\" ng-model=\"$ctrl.org.fromEmail\"> <div ng-messages=\"$ctrl.beeFarmerForm.fromEmail.$error\" ng-if=\"$ctrl.beeFarmerForm.$submitted || $ctrl.beeFarmerForm.fromEmail.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!$ctrl.beeFarmerForm.$valid\"> Save </md-button> </md-dialog-actions> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/beemanagement-settings/beemanagement-settings.template.html',
    "<form class=\"form organisations-form\" name=\"$ctrl.beeManagmentForm\" ng-submit=\"$ctrl.beeManagmentForm.$valid && $ctrl.saveBeeManagmentSettings()\"> <div class=\"layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"md-block\" flex-gt-xs layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" flex=\"100\"> <div custom-table data-model-name=\"managementConversion\" class=\"custom-table\" flex=\"100\"> <div layout=\"row\" layout-align=\"end start\" style=\"height:35px\"> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"$ctrl.addRow()\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Add <div class=\"md-ripple-container\"></div> </md-button> </div> <table class=\"table table-hover\"> <tr class=\"border-bottom\"> <th>Insect</th> <th>Source</th> <th>Default</th> <th>Conversion factor</th> <th>Action</th> </tr> <tr ng-repeat=\"(key, conversion) in $ctrl.org.managementConversion\"> <td> <span ng-show=\"!conversion.editable\">{{$ctrl.getInsectNameById(conversion.INSCT_ID)}}</span> <div class=\"fill-input\"> <md-select ng-model=\"conversion.INSCT_ID\" ng-show=\"conversion.editable\"> <md-option ng-repeat=\"insect in $ctrl.species\" ng-value=\"insect.ID\" ng-disabled=\"$index === 1\"> {{insect.SC_NAME}} </md-option> </md-select> </div> </td> <td> <span ng-show=\"!conversion.editable\">{{$ctrl.getSourceNameById(conversion.SOURCE_ID)}}</span> <md-select aria-label=\"Default\" ng-model=\"conversion.SOURCE_ID\" ng-show=\"conversion.editable\"> <md-option ng-repeat=\"source in $ctrl.sources\" ng-value=\"source.ID\"> {{source.DESCRIPTION}} </md-option> </md-select> </td> <td> <span ng-show=\"!conversion.editable\">{{conversion.DEFLT}}</span> <div ng-show=\"conversion.editable\"> <md-select aria-label=\"Default\" class=\"fill-input\" data-key=\"MNGMNTDEFAULT\" ng-model=\"conversion.DEFLT\"> <md-option ng-repeat=\"defVal in $ctrl.defaultValues\" ng-value=\"defVal\" ng-selected=\"defVal == conversion.DEFLT\"> {{defVal}} </md-option> </md-select> </div> </td> <td> <span ng-show=\"!conversion.editable\">{{conversion.CONV_FACTOR}}</span> <md-input-container class=\"md-block\" flex-gt-sm> <input aria-label=\"Conversion factor\" data-key=\"MNGMNTCONVFACTOR\" class=\"fill-input\" type=\"number\" min=\"0\" step=\"any\" ng-show=\"conversion.editable\" ng-model=\"conversion.CONV_FACTOR\"> </md-input-container> </td> <td> <span class=\"action-primary-{{$ctrl.beeManagmentForm.$valid && !conversion.editable }}\" ng-show=\"!conversion.editable\"> <i class=\"material-icons action-icon\" ng-click=\"$ctrl.editRow(conversion)\">edit</i> </span> <span class=\"material-icons action-icon done\" ng-show=\"conversion.editable\" ng-hide=\"!conversion.editable\"> <i class=\"material-icons action-icon done\" ng-click=\"$ctrl.beeManagmentForm.$valid && $ctrl.saveRow(conversion)\" ng-class=\"{'disabled':$ctrl.beeManagmentForm.$invalid}\"> done </i> </span> <span class=\"md-warn\"> <i class=\"material-icons action-icon\" ng-click=\"$ctrl.deleteRow(conversion.ID)\">remove</i> </span> </td> </tr> <tr ng-show=\"orgSettings.managementConversion.length == 0 && !addNewTableItemEnabled.managementConversion\"> <td colspan=\"6\">No records found</td> </tr> <tr class=\"border-bottom add-table-item layout-align-center\" ng-show=\"addNewTableItemEnabled.managementConversion\"> <td> <md-button class=\"no-caps fill-bg margin-0 padding-0\" ng-click=\"$ctrl.cancelAddTableItem()\"> Cancel </md-button> </td> <td> <md-input-containers class=\"md-block\" flex-gt-xs flex=\"50\"> <select aria-label=\"Species\" class=\"fill-input\" data-key=\"MNGMNTSPEC\" id=\"species\"> <option ng-repeat=\"spec in species\" value=\"{{spec.ID}}\"> {{spec.SC_NAME+orgSpeciesWashStatus(spec)}} </option> </select> </md-input-containers> </td> <td> <md-input-containers class=\"md-block\" flex-gt-xs flex> <select aria-label=\"Source\" class=\"fill-input\" data-key=\"MNGMNTSOURCE\" nd-model=\"sources\" id=\"sources\"> <option ng-repeat=\"source in sources\" value=\"{{source.ID}}\"> {{source.DESCRIPTION}} </option> </select> </md-input-containers> </td> <td> <md-input-containers class=\"md-block\" flex-gt-xs flex> <select aria-label=\"Default\" class=\"fill-input\" data-key=\"MNGMNTDEFAULT\" id=\"default\"> <option ng-repeat=\"defVal in defaultValues\" value=\"{{defVal}}\"> {{defVal}} </option> </select> </md-input-containers> </td> <td> <md-input-containers class=\"md-block\" flex-gt-xs flex> <input aria-label=\"Conversion factor\" data-key=\"MNGMNTCONVFACTOR\" flex type=\"number\" min=\"0\" step=\"any\" id=\"conv_factor\"> </md-input-containers> </td> </tr> </table> </div> </div> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!$ctrl.beeManagmentForm.$valid\"> Save </md-button> </md-dialog-actions> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/beestarter-settings/beestarter-settings.template.html',
    "<form class=\"form bee-starter-form\" name=\"$ctrl.beeStarterForm\" ng-submit=\"$ctrl.beeStarterForm.$valid && $ctrl.saveBeeStarterSettings()\"> <div class=\"layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label>Startpop price</label> <input aria-label=\"Price\" flex name=\"starterPrice\" type=\"number\" step=\"0.01\" ng-model=\"$ctrl.startpopSettings.price\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" required> <div ng-messages=\"$ctrl.beeStarterForm.starterPrice.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.starterPrice.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"pattern\"> Pattern doesn't match. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <md-checkbox aria-label=\"Make your own price\" flex name=\"starterPriceIsSuggestion\" ng-model=\"$ctrl.startpopSettings.price_is_suggestion\" ng-init=\"$ctrl.startpopSettings.price_is_suggestion=false\">Make your own price </md-checkbox> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label>Available delivery days</label> <md-select ng-model=\"$ctrl.startpopSettings.delivery_weekdays\" multiple> <md-option ng-value=\"1\">Monday</md-option> <md-option ng-value=\"2\">Tuesday</md-option> <md-option ng-value=\"3\">Wednesday</md-option> <md-option ng-value=\"4\">Thursday</md-option> <md-option ng-value=\"5\">Friday</md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label>Lead time (days)</label> <input aria-label=\"Lead time\" flex type=\"number\" name=\"starterRequestLeadTime\" ng-model=\"$ctrl.startpopSettings.lead_time\"> <div ng-messages=\"$ctrl.beeStarterForm.starterRequestLeadTime.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.starterRequestLeadTime.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block left-align\" flex-gt-xs> <label>Start date</label> <md-datepicker aria-label=\"Start date\" name=\"startDate\" ng-model=\"$ctrl.startpopSettings.start_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beeStarterForm.startDate.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.startDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block left-align\" flex-gt-xs> <label>Bicornis Start date</label> <md-datepicker aria-label=\"Start date\" name=\"bicornisStartDate\" ng-model=\"$ctrl.startpopSettings.bicornis_start_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beeStarterForm.bicornisStartDate.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.bicornis_startDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label>End date</label> <md-datepicker aria-label=\"End date\" name=\"endDate\" ng-model=\"$ctrl.startpopSettings.end_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beeStarterForm.endDate.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.endDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <label>Maximum units per house per season</label> <input aria-label=\"Order maximum\" flex type=\"number\" name=\"starterOrderMaximum\" ng-model=\"$ctrl.startpopSettings.max_units\" required> <div ng-messages=\"$ctrl.beeStarterForm.starterOrderMaximum.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.starterOrderMaximum.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <label>Order maximum (per day)</label> <input aria-label=\"Order maximum\" flex type=\"number\" name=\"starterOrderMaximum\" ng-model=\"$ctrl.startpopSettings.max_units_per_day\" required> <div ng-messages=\"$ctrl.beeStarterForm.starterOrderMaximum.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.starterOrderMaximum.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <label>Max. startpops per package</label> <input aria-label=\"Max. startpops per package\" flex type=\"number\" name=\"maxStartpopsPerPackage\" ng-model=\"$ctrl.startpopSettings.max_units_per_package\" required> <div ng-messages=\"$ctrl.beeStarterForm.maxStartpopsPerPackage.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.maxStartpopsPerPackage.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <label>Cocoons per startpop</label> <input aria-label=\"Cocoons per startpop\" flex type=\"number\" name=\"cocoonsPerUnit\" ng-model=\"$ctrl.startpopSettings.cocoons_per_unit\" required> <div ng-messages=\"$ctrl.beeStarterForm.cocoonsPerUnit.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.cocoonsPerUnit.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-repeat=\"datesRange in $ctrl.startpopSettings.excludedDateRanges track by $index\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">&nbsp;</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex=\"70\"> <input ng-disabled=\"1\" required name=\"datesRange\" ng-model=\"datesRange\" ng-value=\"formatDate(datesRange)\"> </md-input-container> <md-button class=\"md-icon-button md-warn\" style=\"padding: 0px !important; margin: 0px !important\" flex=\"10\" ng-click=\"removeExcludedDateRange($index)\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!$ctrl.beeStarterForm.$valid\"> Save </md-button> </md-dialog-actions> </div> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/general-settings/general-settings.template.html',
    "<form class=\"form general-settings-form layout-padding\" name=\"$ctrl.generalSettingsForm\" ng-submit=\"$ctrl.generalSettingsForm.$valid && $ctrl.saveGeneralSettings()\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div> <label>Available house types</label> <md-chips ng-model=\"$ctrl.generalSettings.house_types\" md-add-on-blur=\"true\" ng-change=\"ctrl.onModelChange(ctrl.ngChangeFruitNames)\" input-aria-label=\"Available house types\" md-removable=\"true\"></md-chips> </div> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" style=\"margin-top:45x\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Allowed countries</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs=\"25\"> <md-select ng-model=\"$ctrl.generalSettings.allowed_countries\" multiple> <md-option ng-repeat=\"country in $ctrl.countries\" ng-value=\"country.code\"> {{country.country}}</md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Send auto emails</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\"> <md-select aria-label=\"Send auto emails\" class=\"fill-input\" name=\"sendAutoEmails\" ng-model=\"$ctrl.org.sendAutoEmails\" ng-init=\"$ctrl.org.sendAutoEmails\"> <md-option ng-repeat=\"option in $ctrl.selectBoxOptions\" ng-value=\"option.value\"> {{option.name}} </md-option> </md-select> <div ng-messages=\"beeHarvestForm.sendAutoEmails.$error\" ng-if=\"$ctrl.beeHarvestForm.$submitted || $ctrl.beeHarvestForm.sendAutoEmails.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Shipping Cost threshold*</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\"> <input aria-label=\"Shipping Cost threshold\" flex type=\"text\" name=\"shippingCostThreshold\" ng-model=\"$ctrl.org.shippingCostThreshold\" required focus-me=\"true\"> <div ng-messages=\"generalSettingsForm.shippingCostThreshold.$error\" ng-if=\"generalSettingsForm.$submitted || generalSettingsForm.shippingCostThreshold.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Default currency</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\"> <md-select aria-label=\"Default currency\" class=\"fill-input\" name=\"defaultCurrency\" ng-model=\"$ctrl.org.defaultCurrency\" required> <md-option ng-repeat=\"currency in $ctrl.currencies\" ng-value=\"currency.ID\"> {{currency.code}} </md-option> </md-select> <div ng-messages=\"generalSettingsForm.defaultCurrency.$error\" ng-if=\"generalSettingsForm.$submitted || generalSettingsForm.defaultCurrency.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">VAT inclusive</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\"> <md-select aria-label=\"VAT inclusive\" class=\"fill-input\" name=\"vatInclusive\" ng-model=\"$ctrl.org.vatInclusive\" ng-init=\"$ctrl.org.vatInclusive\"> <md-option ng-repeat=\"option in $ctrl.selectBoxOptions\" ng-value=\"option.value\"> {{option.name}} </md-option> </md-select> <div ng-messages=\"generalSettingsForm.vatInclusive.$error\" ng-if=\"generalSettingsForm.$submitted || generalSettingsForm.vatInclusive.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <md-divider></md-divider> <!-- start vat allocation --> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">VAT Allocation</span> </div> <div flex=\"5\"></div> <div class=\"md-block\" flex-gt-xs flex=\"80\"> <md-table-container> <table class=\"table table-hover\"> <div class=\"layout-padding\"> <div layout=\"row\" layout-align=\"end start\" style=\"height:35px\"> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"$ctrl.addRow()\" ng-disabled=\"$ctrl.isEditing\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Add VAT Rate <div class=\"md-ripple-container\"></div> </md-button> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <!-- <span class=\"padding-bottom-20\">VAT Allocation</span> --> </div> <div flex=\"5\"></div> <div class=\"md-block\" flex-gt-xs flex=\"80\"> <md-table-container> <table md-table md-row-select ng-model=\"$ctrl.selectedRate\" md-progress=\"promise\" name=\"$ctrl.rateForm\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getOrganisationRates\"> <tr md-row> <th md-column md-order-by=\"ID\" valign=\"middle\">ID</th> <th md-column md-order-by=\"DESCRIPTION\" valign=\"middle\"> Description </th> <th md-column md-order-by=\"VALUE\" valign=\"middle\">Rate</th> <th md-column md-order-by=\"ACTIVE\" valign=\"middle\">Active</th> <th md-column md-order-by=\"VAT_DEFLT\" valign=\"middle\"> Default </th> <th md-column md-order-by=\"VAT_DEFLT\" valign=\"middle\"> Action </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"(key, rate) in $ctrl.org.rates\"> <td md-cell valign=\"bottom\"> <span> {{rate.ID}}</span> </td> <td md-cell valign=\"bottom\" ng-dblclick=\"\"> <span ng-show=\"!rate.editable\"> {{rate.DESCRIPTION}} </span> <md-input-container class=\"md-block\" flex-gt-xs ng-show=\"rate.editable\"> <!-- display on edit --> <input data-key=\"DESCRIPTION\" ng-model=\"rate.DESCRIPTION\" class=\"fill-input vat-description\" flex type=\"text\" ng-show=\"rate.editable\"> </md-input-container> </td> <td md-cell valign=\"bottom\"> <span ng-show=\"!rate.editable\">{{rate.VALUE}}</span> <md-input-container class=\"md-block\" flex-gt-xs ng-show=\"rate.editable\"> <input data-key=\"DESCRIPTION\" ng-model=\"rate.VALUE\" class=\"fill-input vat-value\" flex type=\"text\" ng-show=\"rate.editable\"> </md-input-container> </td> <td md-cell valign=\"bottom\"> <span ng-show=\"!rate.editable\">{{rate.ACTIVE}}</span> <md-input-container class=\"md-block\" ng-show=\"rate.editable\" flex-gt-xs> <md-select aria-label=\"Active\" data-key=\"ACTIVE\" id=\"vat-active\" ng-model=\"rate.ACTIVE\"> <md-option ng-repeat=\"activeVal in $ctrl.defaultValues\" ng-value=\"activeVal\"> {{activeVal}} </md-option> </md-select> </md-input-container> </td> <td md-cell valign=\"bottom\"> <span ng-show=\"!rate.editable\">{{rate.VAT_DEFLT}}</span> <md-input-container class=\"md-block\" ng-show=\"rate.editable\" flex-gt-xs> <md-select aria-label=\"Default\" class=\"fill-input\" ng-model=\"rate.VAT_DEFLT\" data-key=\"VAT_DEFLT\" id=\"vat-default\"> <md-option ng-repeat=\"defVal in $ctrl.defaultValues\" ng-value=\"defVal\" ng-selected=\"defVal === 'N'\"> {{defVal}} </md-option> </md-select> </md-input-container> </td> <td md-cell> <span class=\"action-primary-{{$ctrl.rateForm.$valid && !$ctrl.isEditing }}\"> <i class=\"material-icons action-icon\" ng-click=\"$ctrl.editRow(rate)\" ng-show=\"!rate.editable\">edit</i> </span> <span class=\"action-primary-{{$ctrl.rateForm.$valid && rate.editable}}\"> <i class=\"material-icons action-icon done\" ng-click=\" $ctrl.saveRow(rate)\" ng-class=\"{'disabled':$ctrl.rateForm.$invalid}\" ng-show=\"rate.editable\"> done </i> </span> <span class=\"md-warn\"> <i class=\"material-icons action-icon\" ng-click=\"$ctrl.deleteRow(rate.ID)\">remove</i> </span> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"query.limitOptions\" md-page=\"query.page\" md-total=\"{{$ctrl.ratesCount}}\" md-page-select md-on-paginate=\"getOrganisationRates\"></md-table-pagination> </div> </div> </div> </table> </md-table-container> </div> </div> <!-- end vat rates --> <md-divider></md-divider> <!-- start excluded dates --> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" style=\"margin-top:50px\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Excluded dates</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"35\"> <label for=\"excludedStartDate\">From</label> <md-datepicker aria-label=\"Start Date\" id=\"excludedStartDate\" name=\"excludedStartDate\" ng-model=\"excludedStartDate\" md-min-date=\"$ctrl.org.start_date\" md-max-date=\"$ctrl.org.end_date\"> </md-datepicker> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"35\"> <label for=\"excludedEndDate\">To</label> <md-datepicker aria-label=\"End Date\" id=\"excludedEndDate\" name=\"excludedEndDate\" ng-model=\"excludedEndDate\" md-min-date=\"(excludedStartDate) ? excludedStartDate : $ctrl.org.start_date\" md-max-date=\"$ctrl.org.end_date\"> </md-datepicker> <div ng-messages=\"$ctrl.beeStarterForm.excludedEndDate.$error\" ng-if=\"$ctrl.beeStarterForm.$submitted || $ctrl.beeStarterForm.excludedEndDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-button class=\"md-warn\" ng-click=\"$ctrl.addExcludedDateRange(excludedStartDate,excludedEndDate)\" ng-disabled=\"!excludedEndDate || !excludedStartDate || excludedEndDate.getTime() < excludedStartDate.getTime()\" flex-gt-xs> Exclude Date Range </md-button> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-repeat=\"datesRange in $ctrl.generalSettings.excluded_dates track by $index\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">&nbsp;</span> </div> <div flex=\"5\"></div> <md-input-container class=\"md-block\" flex=\"70\"> <input ng-disabled=\"1\" required name=\"datesRange\" ng-model=\"datesRange\" ng-value=\"$ctrl.formatDate(datesRange)\"> </md-input-container> <md-button class=\"md-icon-button md-warn\" style=\"padding: 0px !important; margin: 0px !important\" ng-click=\"$ctrl.removeExcludedDateRange($index)\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> <!-- end excluded dates --> <md-divider></md-divider> <!-- start excluded postal codes --> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" style=\"margin-top:50px\"> <div class=\"flex-align-top\" flex-gt-xs flex=\"15\"> <span class=\"padding-bottom-20\">Excluded postal codes</span> </div> <div flex=\"5\"></div> <div flex=\"80\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 flex md-truncate></h2> <md-button class=\"md-primary\" ng-click=\"$ctrl.generalSettings.excluded_postal_codes.push({edit: true})\"> <i class=\"material-icons\">add</i>Add </md-button> </div> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column>Country code</th> <th md-column>Postal code</th> <th md-column>Description</th> <th md-column></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"postalCode in $ctrl.generalSettings.excluded_postal_codes track by $index\" ng-dblclick=\"$ctrl.editPostalCode(item)\"> <td md-cell> <md-select ng-model=\"postalCode.country_code\"> <md-option ng-value=\"country_code\" ng-repeat=\"country_code in $ctrl.generalSettings.allowed_countries\"> {{country_code}}</md-option> </md-select> </td> <td md-cell> <md-input-container> <input ng-model=\"postalCode.postal_code\" auto-focus=\"{{postalCode.edit}}\"> </md-input-container> </td> <td md-cell> <md-input-container> <input ng-model=\"postalCode.description\"> </md-input-container> </td> <td md-cell> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.removePostalCode($index)\" aria-label=\"cancel\"> <i class=\"material-icons\">close</i> </md-button> </td> </tr> </tbody> </table> </md-table-container> </div> </div> <div layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!$ctrl.generalSettingsForm.$valid\"> Save </md-button> </div> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/org-settings/org-settings.template.html',
    "<form class=\"form\" name=\"orgForm\" ng-submit=\"orgForm.$valid && $ctrl.saveOrgFormSettings()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Short name*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Short name\" flex type=\"text\" name=\"name\" ng-model=\"$ctrl.organisation.NAME\" required focus-me=\"true\"> <div ng-messages=\"orgForm.name.$error\" ng-if=\"orgForm.$submitted || orgForm.name.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Description*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Description\" flex type=\"text\" name=\"description\" ng-model=\"$ctrl.organisation.DESCRIPTION\" required> <div ng-messages=\"orgForm.description.$error\" ng-if=\"orgForm.$submitted || orgForm.description.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Country*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Country\" class=\"fill-input\" name=\"country\" ng-model=\"$ctrl.organisation.COUNTRY_ID\" required> <md-option ng-repeat=\"country in $ctrl.countries\" ng-value=\"country.ID\"> {{country.country}} </md-option> </md-select> <div ng-messages=\"orgForm.country.$error\" ng-if=\"orgForm.$submitted || orgForm.country.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Parent</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Parent\" class=\"fill-input\" name=\"country\" ng-model=\"$ctrl.organisation.PARENT_ID\"> <md-option value=\"{{null}}\"></md-option> <md-option ng-repeat=\"parent in $ctrl.organisations\" ng-value=\"parent.ID\"> {{parent.NAME}} </md-option> </md-select> <div ng-messages=\"orgForm.country.$error\" ng-if=\"orgForm.$submitted || orgForm.country.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!orgForm.$valid\"> Save </md-button> </md-dialog-actions> </form>"
  );


  $templateCache.put('scripts/components/admin/settings/organisation-settings/organisationSettings.template.html',
    "<div class=\"row results panel panel-default admin-section\" flex-gt-xs restrict-access=\"Admin\"> <md-dialog-content> <div class=\"layout-padding\"> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height ng-if=\"$ctrl.org\"> <md-tab> <md-tab-label>Organisation</md-tab-label> <md-tab-body> <org-settings organisation=\"$ctrl.organisation\" organisations=\"$ctrl.organisations\"></org-settings> </md-tab-body> </md-tab> <md-tab> <md-tab-label>General</md-tab-label> <md-tab-body> <general-settings org=\"$ctrl.org\"></general-settings> </md-tab-body> </md-tab> <md-tab> <md-tab-label>Farmer</md-tab-label> <md-tab-body> <beefarmer-settings org=\"$ctrl.org\"></beefarmer-settings> </md-tab-body> </md-tab> <md-tab> <md-tab-label>Starter</md-tab-label> <md-tab-body> <beestarter-settings org=\"$ctrl.org\"></beestarter-settings> </md-tab-body> </md-tab> <md-tab> <md-tab-label>Beecare</md-tab-label> <md-tab-body> <beecare-settings org=\"$ctrl.org\"></beecare-settings> </md-tab-body> </md-tab> <md-tab> <md-tab-label>Management</md-tab-label> <md-tab-body> <beemanagement-settings org=\"$ctrl.org\" species=\"$ctrl.species\" sources=\"$ctrl.sources\"></beemanagement-settings> </md-tab-body> </md-tab> </md-tabs> </div> </md-dialog-content> </div>"
  );


  $templateCache.put('scripts/components/beehome/orders/shopify-orders/shopify-orders.template.html',
    "<div restrict-access=\"BeeManagement\" layout=\"column\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block left-align\" flex-gt-xs> <label>Start date</label> <md-datepicker aria-label=\"Start date\" name=\"startDate\" ng-model=\"$ctrl.startDate\"> </md-datepicker> </md-input-container> <md-input-container class=\"md-block left-align\" flex-gt-xs> <label>End date</label> <md-datepicker aria-label=\"end date\" name=\"endDate\" ng-model=\"$ctrl.endDate\"> </md-datepicker> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label>Start Time <i>( hh:mm:ss)</i> </label> <input aria-label=\"EndTime\" flex name=\"startTime\" ng-model=\"$ctrl.startTime\" required> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label>End Time <i>( hh:mm:ss)</i> </label> <input aria-label=\"endTime\" flex name=\"endDateText\" ng-model=\"$ctrl.endTime\" required> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" layout-algin=\"space-around\"> <md-button ng-click=\"$ctrl.getOrders($ctrl.firstCursor, null)\" class=\"md-primary\" aria-label=\"getOrders\" ng-show=\"$ctrl.pageInfo.hasPreviousPage\"> Previous Page </md-button> <md-button ng-click=\"$ctrl.getOrders()\" class=\"md-primary\" aria-label=\"getOrders\"> get Orders </md-button> <md-button ng-click=\"$ctrl.getOrders(null,$ctrl.lastCursor)\" class=\"md-primary\" aria-label=\"getOrders\" ng-show=\"$ctrl.pageInfo.hasNextPage\"> Next Page </md-button> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"$ctrl.orders.length\"> <md-table-container> <table md-table md-progress=\"promise\" ng-model=\"$ctrl.selectedOrders\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getCustomerProducts\"> <tr md-row> <th> Shopify ID </th> <th>Date</th> <th>email</th> <th># Items</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"order in $ctrl.orders\" md-select-id=\"order.id\" md-select=\"order\"> <td md-cell valign=\"bottom\"> {{order.id}} </td> <td md-cell valign=\"bottom\">{{order.createdAt}}</td> <td md-cell valign=\"bottom\">{{order.email}}</td> <td md-cell valign=\"bottom\">{{order.lineItems.length}}</td> <td md-cell valign=\"bottom\"> <md-button ng-click=\"$ctrl.processOrder(order)\" class=\"md-primary\" aria-label=\"getOrders\"> process </md-button> </td> </tr> </tbody> </table> </md-table-container> </div> </div>"
  );


  $templateCache.put('scripts/components/management/qrcode-generator/qrcodeGenerator.template.html',
    "<div layout=\"row\"> <div flex-gt-xs> <form name=\"codeForm\" ng-submit=\"printQRCode(houseCodeInput)\" class=\"padding-top-20\"> <md-input-container class=\"md-block\"> <input id=\"houseCodeInput\" flex type=\"text\" name=\"houseCodeInput\" aria-label=\"House code\" ng-model=\"houseCodeInput\" style=\"text-transform:uppercase\" focus-me=\"true\"> </md-input-container> </form> </div> <md-button ng-click=\"$ctrl.generateQRCode(houseCodeInput)\" class=\"md-primary md-raised max-height-20\"> <i class=\"material-icons\">print</i> <span translate=\"harvest.print_qr\">Print QR code</span> </md-button> <div flex></div> </div>"
  );


  $templateCache.put('views/about.html',
    "<div mycustomer=\"true\"></div>"
  );


  $templateCache.put('views/account-modal.html',
    "<md-dialog id=\"basic-details-dialog\" flex=\"90\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout=\"row\" layout-padding layout-align=\"space-between\"> <h1 ng-if=\"client.id\">Account {{client.id}}</h1> <h1 ng-if=\"!client.id\">New Account</h1> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content layout-padding id=\"toaster\"> <form form name=\"accountForm\" ng-submit=\"accountForm.$valid && save()\" novalidate flex layout=\"column\" layout-fill> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" layout-padding layout-align=\"start start\"> <!-- comapny name --> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"accountName\">Account Name</label> <input name=\"accountName\" type=\"text\" ng-model=\"client.name\" tabindex=\"4\" ng-required=\"client.type.toLowerCase() == 'company'\" ng-disabled=\"client.type.toLowerCase() != 'company'\" ng-change=\"updateAddressCompany()\"><br> </md-input-container> <md-switch class=\"md-primary\" ng-model=\"client.type\" ng-true-value=\"'COMPANY'\" ng-false-value=\"'PRIVATE'\"> Company <md-tooltip md-direction=\"top\" class=\"tooltip-multiline\"> Select this option if the Account is held by a company </md-tooltip> </md-switch> <!-- Organisation --> <md-input-container class=\"md-block app-select\" flex-gt-xs=\"50\" layout-align=\"start end\"> <label for=\"ownerId\">Organisation</label> <md-select name=\"ownerId\" aria-label=\"contacts owner\" ng-model=\"client.organisation_id\" ng-required=\"checkupdateOrgRight()\" ng-disabled=\"!checkupdateOrgRight()\" ng-change=\"updateCountry()\" tabindex=\"8\"> <md-option ng-repeat=\"org in organisations\" ng-value=\"org.ID\"> {{org.NAME}} </md-option> </md-select> <div ng-messages=\"accountForm.ownerId.$error\" ng-if=\"accountForm.$submitted || accountForm.ownerId.$touched\"> <div ng-message=\"required\"> You must provide a organisation. </div> </div> </md-input-container> </div> <div layout=\"row\"> <md-subheader class=\"md-primary\" flex>Main Contact</md-subheader> </div> <div contact-form contact=\"contact\" farmer=\"client.tags.indexOf('OSMIPRO') > -1\" org=\"client.organisation_id\"></div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" layout-padding> <md-input-container class=\"md-block\" flex-gt-xs> <label class=\"input-placeholder\" for=\"taxNr1\">Tax number 1</label> <input name=\"taxNr1\" aria-label=\"Tax number 1\" type=\"text\" ng-model=\"client.tax_nr_1\" tabindex=\"14\"> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label class=\"input-placeholder\" for=\"taxNr2\">Tax number 2</label> <input name=\"taxNr2\" aria-label=\"Tax number 2\" type=\"text\" ng-model=\"client.tax_nr_2\" tabindex=\"15\"> </md-input-container> <md-input-container class=\"md-block app-select\" flex-gt-xs layout-align=\"start center\" ng-show=\"client.isFarmer\"> <label for=\"cert\">Certification</label> <md-select name=\"cert\" ng-model=\"client.certification\" tabindex=\"18\"> <md-option ng-repeat=\"cert in certifications\" ng-value=\"cert.CODE\" ng-selected=\"client.certification.toLowerCase() == cert.CODE.toLowerCase()\"> {{cert.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout=\"row\" layout-padding style=\"padding-left:0\"> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\" ng-show=\"client.type.toLowerCase() == 'company' && client.organisation_id == 4\"> <label class=\"input-placeholder\" for=\"pecEmail\">PEC Email</label> <input name=\"pecEmail\" aria-label=\"PEC Email\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/\" ng-model=\"client.pec_mail\" tabindex=\"16\"> <div ng-messages=\"accountForm.pecEmail.$error\"> <span ng-message=\"pattern\">Please enter a valid PEC Email address.</span> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\" ng-show=\"client.type.toLowerCase() == 'company' && client.organisation_id == 4\"> <label class=\"input-placeholder\" for=\"taxNr1\">Numero univoco</label> <input name=\"taxNr1\" aria-label=\"number UNIVOCO\" type=\"text\" ng-model=\"client.nr_univoco\" tabindex=\"17\"> </md-input-container> </div> <div layout=\"row\" layout-padding style=\"padding-left:0\"> <md-subheader class=\"md-primary\">Main Address</md-subheader> </div> <!-- Address form  --> <div address-form address=\"address\" country-code=\"country\" optional-fields=\"true\"></div> <div layout=\"row\" layout-align=\"space-between start\"> <md-button ng-click=\"client.is_blocked = !client.is_blocked\" class=\"md-primary\" ng-class=\"{'md-warn':!client.is_blocked}\"> <span ng-if=\"!client.is_blocked\"> <i class=\"material-icons\">not_interested</i>&nbsp;Block </span> <span ng-if=\"client.is_blocked\">unblock</span> </md-button> <div> <md-button ng-click=\"cancel()\" class=\"md-warn\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" ng-show=\"!showError\" ng-disabled=\"accountForm.$invalid\" tabindex=\"21\"><span ng-click=\"clickedSubmitButton()\">Save</span></md-button> </div> </div> </form> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/account-summary-directive.html',
    "<div layout=\"column\" layout-align=\"space-between\" style=\"height: 100%\"> <div> <table class=\"summary\"> <tr ng-if=\"billingContact.last_name\"> <th>Main contact</th> <td> {{billingContact.first_name}} {{billingContact.last_name}} </td> </tr> <tr ng-if=\"billingContact.email\"> <th>Email</th> <td>{{billingContact.email}}</td> </tr> <tr ng-if=\"billingContact.mailing_preference && billingContact.mailing_preference.toLowerCase() != 'email'\"> <th>Mailing preference</th> <td>Paper based mails</td> </tr> <tr ng-if=\"billingContact.phone_mobile || billingContact.phone_business || billingContact.phone_private\"> <th>Phone</th> <td> <i ng-if=\"billingContact.phone_mobile\" class=\"material-icons\">smartphone</i>{{billingContact.phone_mobile}} <i ng-if=\"billingContact.phone_business\" class=\"material-icons\">business</i>{{billingContact.phone_business}} <i ng-if=\"billingContact.phone_private\" class=\"material-icons\">home</i>{{billingContact.phone_private}} </td> </tr> <tr ng-if=\"billingContact.language\"> <th>Language</th> <td>{{billingContact.language}}</td> </tr> <tr ng-if=\"billingContact.birthday\"> <th>Birthday</th> <td>{{billingContact.birthday | date:'dd.MM.yyyy'}}</td> </tr> <tr> <th>Tags</th> <td> <span ng-repeat=\"tag in client.tags\" class=\"account-tag\">{{tag}}</span> </td> </tr> <tr ng-if=\"billingContact.freshdesk_id || billingContact.bexio_id\"> <th>Links</th> <td> <a ng-if=\"billingContact.freshdesk_id\" href=\"https://wildbieneundpartner.freshdesk.com/a/contacts/{{billingContact.freshdesk_id}}\" target=\"_BLANK\"> Freshdesk </a> <a ng-if=\"billingContact.bexio_id\" target=\"_BLANK\" href=\"https://office.bexio.com/index.php/kontakt/show/id/{{billingContact.bexio_id}}\"> Bexio </a> </td> </tr> <tr> <th>Main address</th> <td> <span ng-if=\"billingAddress.first_name\">{{billingAddress.first_name}}&nbsp;</span><span ng-if=\"billingAddress.last_name\">{{billingAddress.last_name}}<br> </span> <span ng-if=\"billingAddress.company_name\">{{billingAddress.company_name}} <br> </span> {{billingAddress.address_1}} <br> {{billingAddress.address_2}} <br ng-if=\"billingAddress.address_2\"> {{billingAddress.country_code}}-{{billingAddress.postal_code}}&nbsp;{{billingAddress.town}} <p ng-if=\"client.addresses.length>1\"> (<i ng-click=\"goToAddressTab()\"> +{{client.addresses.length-1}} more</i>) </p> </td> </tr> <tr ng-if=\"client.tax_nr_1\"> <th>Tax nr 1</th> <td>{{client.tax_nr_1}}</td> </tr> <tr ng-if=\"client.tax_nr_2\"> <th>Tax nr 2</th> <td>{{client.tax_nr_2}}</td> </tr> <tr ng-if=\"client.nr_univoco\"> <th>Numero univoco:</th> <td>{{client.nr_univoco}}</td> </tr> <tr ng-if=\"client.pec_mail\"> <th>PEC email:</th> <td>{{client.pec_mail}}</td> </tr> </table> </div> <div layout=\"row\"> <div flex></div> <md-button class=\"md-primary\" ng-click=\"edit()\"><i class=\"material-icons\">mode_edit</i> Edit</md-button> <div> <md-button class=\"md-warn\" ng-click=\"deleteClient()\" ng-disabled=\"customer.products.length || customer.orders.length || customer.ERP_ID != null\" restrict-access=\"Delete Customer\"><i class=\"material-icons\">remove</i>Delete </md-button> <md-tooltip md-direction=\"top\" ng-if=\"customer.products.length || customer.orders.length || customer.ERP_ID != null\"> The customer has either an ERP ID linked to it, or at least one order or house attached.</md-tooltip> </div> </div> </div>"
  );


  $templateCache.put('views/address-directive.html',
    "<div layout=\"row\" layout-align=\"end start\" style=\"height:30px\"> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"editAddress()\" tabindex=\"3\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Address <div class=\"md-ripple-container\"></div> </md-button> </div> <form name=\"cultureForm\"> <md-table-container> <table md-table md-progress=\"promise\" ng-show=\"addresses.length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column md-order-by=\"cultureType\" width=\"40\">Name</th> <th md-column width=\"20\">Address</th> <th md-column width=\"20\"> Actions </th> </tr> </thead> <tbody md-body> <tr ng-class=\"{selectedRow:selectedRowClass[item.ID]}\" md-row md-select=\"culture\" md-select-id=\"\" md-on-select=\"setRowClass\" md-on-deselect=\"setRowClass\" ng-repeat=\"(sortedIndex, address) in addresses\"> <td md-cell> <span ng-if=\"address.first_name\"> {{address.first_name}}&nbsp; </span> <span ng-if=\"address.last_name\">{{address.last_name}}<br> </span> <span ng-if=\"address.company_name\">{{address.company_name}} <br> </span> </td> <td md-cell> {{address.address_1}} <br> {{address.address_2}} <br ng-if=\"address.address_2\"> {{address.country_code}}-{{address.postal_code}}&nbsp;{{address.town}} </td> <td md-cell style=\"padding:0\" layout=\"row\"> <md-button ng-click=\"editAddress(address)\" class=\"md-primary md-icon-button small\"> <i class=\"material-icons action-icon\"> edit </i> </md-button> <md-button ng-click=\"deleteAddress(address)\" class=\"md-warn md-icon-button small\"> <i class=\"material-icons action-icon\"> remove </i> </md-button> </td> </tr> </tbody> </table> </md-table-container> </form>"
  );


  $templateCache.put('views/address-form.html',
    "<div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" layout-padding layout-align=\"start end\"> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"company\">Address Company</label> <input name=\"company\" id=\"company\" type=\"text\" ng-model=\"address.company_name\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" layout-padding layout-align=\"start end\"> <md-autocomplete flex-gt-xs layout-align=\"start center\" name=\"address_1\" class=\"md-input-container md-block app-select\" ng-required=\"!optionalFields\" md-require-match=\"false\" md-floating-label=\"Address 1\" md-input-name=\"addressInput\" md-no-cache=\"true\" md-search-text=\"searchString\" md-selected-item-change=\"selectedPlace(place, $index)\" md-item-text=\"place.structured_formatting.main_text\" md-items=\"place in addressAutocomplete(searchString, $index)\" md-min-length=\"3\" md-delay=\"200\" ng-pattern=\"/.*[0-9].*/\"> <md-item-template> <span md-highlight-text=\"address.searchString\">{{place.structured_formatting.main_text}}</span> <span class=\"italic\">{{place.structured_formatting.secondary_text}}</span> </md-item-template> <div ng-messages=\"address_1.$error\"> <div ng-message=\"required\">Adress line 1 is required</div> <div ng-message=\"pattern\">Adress line 1 is invalid</div> </div> </md-autocomplete> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"address2\">Address 2</label> <input name=\"address2\" id=\"address2\" type=\"text\" ng-model=\"address.address_2\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" layout-padding> <md-input-container class=\"md-block\" flex-gt-xs=\"10\" layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"postal_code\">Postal code</label> <input name=\"postal_code\" id=\"postal_code\" type=\"text\" ng-model=\"address.postal_code\" ng-required=\"!optionalFields\" ng-change=\"checkOptionalFields()\"> <div ng-messages=\"customerForm.postal_code.$error\"> <div ng-message=\"required\">A Postal Code is required</div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"town\">Town</label> <input name=\"town\" type=\"text\" ng-model=\"address.town\" ng-required=\"!optionalFields\" ng-change=\"checkOptionalFields()\"> <div ng-messages=\"customerForm.shippingAddressTown.$error\"> <div ng-message=\"required\">A Town is required</div> </div> </md-input-container> <md-input-container class=\"md-block app-select\" flex-gt-xs=\"50\" layout-align=\"start center\"> <label for=\"shippingAddressCountry\">Country </label> <md-select name=\"address.Country\" id=\"address.Country\" ng-model=\"address.country_code\" ng-required=\"!optionalFields\"> <md-option ng-repeat=\"country in countries\" ng-value=\"country.code.toLowerCase()\"> {{country.country}} </md-option> </md-select> <div ng-messages=\"customerForm.country.$error\"> <div ng-message=\"required\">A Country is required</div> </div> </md-input-container> </div>"
  );


  $templateCache.put('views/address-modal.html',
    "<md-dialog id=\"acount-dialog\" flex=\"90\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout=\"row\" layout-padding layout-align=\"space-between\"> <h1 ng-if=\"address.id\">Edit Address {{address.id}}</h1> <h1 ng-if=\"!address.id\">New Address</h1> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content layout-padding> <form ng-submit=\"addressform.$valid && saveAddress()\" name=\"addressform\"> <md-radio-group ng-model=\"address.tags\" layout=\"row\" layout-padding> <md-radio-button value=\"\" class=\"md-primary\"> SHIPPING </md-radio-button> <md-radio-button value=\"BILLING\" class=\"md-primary\"> BILLING </md-radio-button> </md-radio-group> <div layout-gt-xs=\"row\" layout-padding> <!-- firstname --> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"firstname\">Firstname</label> <input name=\"firstname\" type=\"text\" ng-model=\"address.first_name\" tabindex=\"1\" focus-me=\"true\"> </md-input-container> <!-- lastname --> <md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\"> <label class=\"input-placeholder\" for=\"lastname\">Lastname</label> <input name=\"lastname\" type=\"text\" ng-model=\"address.last_name\" tabindex=\"2\"> </md-input-container> </div> <!-- <div layout=\"row\" layout-padding>\n" +
    "\t\t\t\t<md-input-container class=\"md-block\" flex-gt-xs layout-align=\"start center\">\n" +
    "\t\t\t\t\t<label class=\"input-placeholder\" for=\"company\">Company</label>\n" +
    "\t\t\t\t\t<input\n" +
    "\t\t\t\t\t\tname=\"company\"\n" +
    "\t\t\t\t\t\ttype=\"text\"\n" +
    "\t\t\t\t\t\tng-model=\"address.company_name\"\n" +
    "\t\t\t\t\t\ttabindex=\"3\"\n" +
    "\t\t\t\t\t/>\n" +
    "\t\t\t\t</md-input-container>\n" +
    "\t\t\t</div> --> <div address-form address=\"address\" country-code=\"defaultCountry\" optional-fields=\"false\"></div> <div layout=\"row\" layout-align=\"end start\"> <md-button ng-click=\"cancel()\" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" ng-show=\"!showError\" ng-disabled=\"customerForm.$invalid\" tabindex=\"21\">Save</md-button> </div> </form> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/address-picker.html',
    "<div ng-hide=\"expanded\" ng-repeat=\"address in client.addresses | filter: filterSelected\"> <div> {{address.first_name}} {{address.last_name}}<br> <span ng-if=\"address.company_name\"> {{address.company_name}}<br> </span> {{address.address_1}} {{address.address_2}}<br> {{address.country_code}} - {{address.postal_code}} {{address.town}} </div> </div> <md-radio-group name=\"{{name}}\" ng-model=\"addressId\" required ng-show=\"expanded\" ng-change=\"onChange()\"> <div ng-repeat=\"address in client.addresses\"> <div flex layout=\"row\" layout-padding layout-align=\"start center\"> <md-radio-button ng-value=\"address.id\" flex> <div> {{address.first_name}} {{address.last_name}}<br> <span ng-if=\"address.company_name\"> {{address.company_name}}<br> </span> {{address.address_1}} {{address.address_2}}<br> {{address.country_code}} - {{address.postal_code}} {{address.town}} </div> </md-radio-button> <div layout=\"column\" layout-align=\"center end\" flex=\"20\"> <md-button class=\"md-primary md-icon-button\" ng-click=\"editAddress(address)\"> <i class=\"material-icons action-icon\">edit</i> </md-button> <md-button class=\"md-primary md-icon-button\" ng-click=\"deleteAddress(address)\" ng-hide=\"address.id === addressId || address.id === null\"> <i class=\"material-icons action-icon\">delete</i> </md-button> </div> </div> </div> </md-radio-group> <md-button class=\"md-primary small\" ng-show=\"expanded\" style=\"margin-left: 32px\" ng-click=\"addAddress()\"> <i class=\"material-icons ng-scope\">add</i>Add a new address </md-button> <div ng-messages=\"form[name].$error\" class=\"validation-messages\" ng-if=\"form.$submitted || form[name].$touched\"> <div ng-message=\"required\">An address is required.</div> </div>"
  );


  $templateCache.put('views/admin-packaging.html',
    "<div class=\"row results panel panel-default admin-section\" flex-gt-xs restrict-access=\"Admin\"> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"first packaking-search\" flex-gt-xs=\"50\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search(searchString)\">search</i></md-icon> <input flex type=\"text\" ng-model=\"searchString\" ng-change=\"timeoutedSearch(searchString)\" class=\"search-box\" placeholder=\"Search\" focus-me=\"true\"> </md-input-container> </md-content> <div layout-gt-xs=\"column\" flex layout-align=\"start start\"> <md-button class=\"newItemButton\" ng-click=\"addPackage()\"> <i class=\"material-icons\">add</i>&nbsp;Add Package </md-button> </div> </div> <div layout=\"row\" class=\"panel-heading\"> <h3 class=\"no-caps\">{{packagesCount}} results</h3> <div flex></div> <md-button class=\"no-caps\" ng-click=\"removePackage(selectedOptions[0])\" ng-disabled=\"!selectedOptions.length\">Delete</md-button> <md-button class=\"no-caps\" ng-click=\"editPackage(selectedOptions[0])\" ng-disabled=\"!selectedOptions.length\">Edit</md-button> </div> <md-table-container> <table md-table md-row-select ng-model=\"selectedOptions\" md-progress=\"promise\"> <thead md-head> <tr md-row> <th md-column>ID</th> <th md-column>Package CD</th> <th md-column>Supplier</th> <th md-column>Slot Amount</th> <th md-column>Description</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"box\" md-select-id=\"box.ID\" ng-repeat=\"box in packageOptions\" ng-dblclick=\"editPackage(box)\"> <td md-cell>{{box.ID}}</td> <td md-cell>{{box.PACKAGE_CD}}</td> <td md-cell>{{box.SUPPLIER}}</td> <td md-cell>{{box.SLOT_AMT}}</td> <td md-cell>{{box.DESCRIPTION}}</td> </tr> </tbody> </table> </md-table-container> </div>"
  );


  $templateCache.put('views/admin-products.html',
    "<div class=\"row results panel panel-default admin-section\" flex-gt-xs restrict-access=\"Admin\"> <md-tabs class=\"products-tabs\" md-selected=\"selectedIndex\" md-dynamic-height> <products-panel></products-panel> <sales-products-panel></sales-products-panel> </md-tabs> </div>"
  );


  $templateCache.put('views/beehome-account-vouchers.html',
    "<div restrict-access=\"BeeStarter\"> <div layout-gt-md=\"row\" class=\"form-row md-no-momentum\"> <div layout=\"row\" flex layout-align=\"start center\"> <div class=\"table-responsive\" ng-show=\"vouchers.length\"> <div class=\"panel-heading md-table-header-panel\" aria-hidden=\"true\" layout=\"row\"> <span flex></span> </div> <md-table-container> <table md-table md-progress=\"promise\" ng-model=\"selectedVouchers\"> <thead md-head md-order=\"voucherQuery.order\"> <tr md-row> <th md-column width=\"150\">Code</th> <th md-column width=\"150\" md-order-by=\"type\">Type</th> <th md-column width=\"150\" md-order-by=\"active\"> Active </th> <th md-column width=\"140\">Expiry on</th> <th md-column width=\"140\">Created on</th> <th md-column width=\"140\">Created by</th> <th md-column width=\"140\">Updated on</th> <th md-column width=\"140\">Updated by</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"item in vouchers\" md-select=\"item\" md-select-id=\"item.ID\"> <td md-cell>{{item.code}}</td> <td md-cell>{{item.type}}</td> <td md-cell> <i class=\"material-icons panel-progress-tick\" ng-show=\"item.is_active\"> done </i> <i class=\"material-icons panel-progress-tick\" ng-show=\"!item.is_active\"> clear </i> </td> <td md-cell>{{item.expiry_on | date:'yyyy-MM-dd'}}</td> <td md-cell>{{item.created_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.created_by].firstName}}</td> <td md-cell>{{item.updated_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.updated_by].firstName}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"voucherQuery.limit\" md-limit-options=\"voucherQuery.limitOptions\" md-page=\"voucherQuery.page\" md-total=\"{{vouchers.length}}\" md-page-select md-boundary-links> </md-table-pagination> </div> </div> </div> </div>"
  );


  $templateCache.put('views/beehome-order.html',
    "<form class=\"form\" id=\"orderForm\" name=\"orderForm\" ng-submit=\"orderForm.$valid && save()\" novalidate> <div layout=\"row\" layout-padding> <div layout=\"column\" flex layout-align=\"start start\"> <h3 class=\"md-primary\"> Client </h3> </div> <div layout=\"row\" flex layout-align=\"end end\" ng-hide=\"order.is_printed\"> <md-button class=\"md-primary\" ng-if=\"!showClientSearch\" ng-click=\"showClientSearch=!showClientSearch\"> <i class=\"material-icons ng-scope\">search</i>Select </md-button> <md-button class=\"md-primary\" ng-if=\"showClientSearch\" ng-click=\"showClientSearch=!showClientSearch\"> <i class=\"material-icons ng-scope\">done</i>Done </md-button> <md-button class=\"md-primary\" ng-click=\"addClient()\"> <i class=\"material-icons ng-scope\">add</i>New </md-button> <md-button class=\"md-primary\" ng-click=\"editClient()\"> <i class=\"material-icons ng-scope\">edit</i>Edit </md-button> </div> </div> <div layout=\"row\" ng-if=\"!showClientSearch\" layout-align=\"start end\" layout-padding> <div layout=\"column\"> <table class=\"summary\"> <tr> <th>Name</th> <td>{{client.name}}</td> </tr> <tr> <th>Id</th> <td> <a ng-href=\"/#/beehome/account/{{client.id}}\">{{client.id}}</a> </td> </tr> <tr> <th>Organisation</th> <td> {{client.organisation.name}} </td> </tr> <tr> <th>Email</th> <td ng-if=\"client.contacts[0].email\">{{client.contacts[0].email}}</td> <td ng-if=\"!client.contacts[0].email\"> <md-button class=\"md-warn\" ng-click=\"editClient()\"> Please add an email address </md-button> </td> </tr> <tr> <th>Language</th> <td>{{client.contacts[0].language}}</td> </tr> </table> </div> </div> <div layout=\"row\" ng-if=\"showClientSearch\" layout-align=\"start center\" layout-padding> <div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"> <client-search id=\"clientSearch\" wbp-selected=\"assignClient\" wbp-floating-label=\"Email, house code, name, ...\" selected-item=\"client\" class=\"client-search\" style=\"width:100%\"> </div> </div> <div ng-show=\"client.id\"> <div layout=\"row\" layout-padding> <div layout=\"column\" flex layout-align=\"start start\"> <h3 class=\"md-primary\"> Houses </h3> </div> <div layout=\"row\" flex layout-align=\"end end\" ng-hide=\"order.bexio_id || order.is_printed\"> <md-button class=\"md-primary\" ng-click=\"addHouse()\"> <i class=\"material-icons ng-scope\">add</i>Add house </md-button> </div> </div> <div layout=\"row\" layout-padding> <div layout=\"column\" flex-gt-md=\"33\" flex-gt-sm=\"50\" flex=\"100\"> <md-table-container> <table md-table md-row-select=\"order.type=='BEECARE'\" multiple ng-model=\"housesSelected\" md-progress=\"housesPromise\" ng-show=\"Object.keys(houses).length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column md-order-by=\"code\" width=\"150\">Code</th> <th md-column width=\"140\">House type</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"item\" md-auto-select md-on-select=\"updateTotalPrice\" md-on-deselect=\"updateTotalPrice\" ng-disabled=\"order.bexio_id || order.is_printed\" ng-repeat=\"(code, item) in houses\"> <td md-cell><house-link ng-model=\"item\"></td> <td md-cell>{{products[item.product_id].PROD_NAME}}</td> </tr> </tbody> </table> </md-table-container> </div> </div> <div layout=\"row\" layout-padding> <div layout=\"column\" flex layout-align=\"start start\"> <h3 class=\"md-primary\"> Vouchers </h3> </div> <div layout=\"row\" flex ng-if=\"!order.bexio_id || !order.is_printed\"> <md-autocomplete md-no-cache=\"true\" md-search-text=\"query\" md-input-name=\"autocompleteField\" md-items=\"voucher in searchVouchers(query)\" md-item-text=\"voucher.code\" md-selected-item=\"selectedSearchVoucher\" md-selected-item-change=\"addExistingVoucher(voucher)\" md-min-length=\"5\" md-floating-label=\"Add existing voucher\" md-delay=\"400\" md-menu-class=\"wbp-autocomplete\" flex> <md-item-template> {{voucher.code}} </md-item-template> <md-not-found> No vouchers found. </md-not-found> </md-autocomplete> <md-button class=\"md-primary\" ng-click=\"addVoucher()\"> <i class=\"material-icons ng-scope\">add</i>Add new voucher </md-button> </div> </div> <div layout=\"row\" layout-padding> <div layout=\"column\" flex> <md-table-container> <table md-table md-row-select multiple ng-model=\"vouchersSelected\" md-progress=\"vouchersPromise\" ng-show=\"vouchers.length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column md-order-by=\"code\" width=\"150\">Code</th> <th md-column width=\"140\">Type</th> <th md-column md-order-by=\"created_at\" width=\"140\">Added on</th> <th md-column md-order-by=\"created_by\" width=\"140\">Added by</th> <th md-column md-order-by=\"updated_at\" width=\"140\">Updated on</th> <th md-column md-order-by=\"order_id\" width=\"140\">Order id</th> <th md-column md-order-by=\"expiry_on\" width=\"140\">Expiry on.</th> <th md-column md-order-by=\"is_active\" width=\"40\">Active</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"item\" md-auto-select md-on-select=\"updateTotalPrice\" md-on-deselect=\"updateTotalPrice\" ng-disabled=\"isDisabled(item) || order.bexio_id || order.is_printed\" ng-repeat=\"item in vouchers\" ng-dblclick=\"editVoucher(item)\"> <td md-cell>{{item.code}}</td> <td md-cell>{{item.type}}</td> <td md-cell>{{item.created_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.created_by].firstName}}</td> <td md-cell>{{item.updated_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{item.order_id}}</td> <td md-cell>{{item.expiry_on | date:'yyyy-MM-dd'}}</td> <td md-cell> <i class=\"material-icons\" ng-show=\"item.is_active\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!item.is_active\">clear</i> </td> </tr> </tbody> </table> </md-table-container> </div> </div> <!-- END Vouchers --> <!-- STARTPOPS --> <div layout-gt-xs=\"row\" flex=\"50\" layout-padding ng-if=\"order.type == 'STARTPOP'\"> <md-input-container flex> <label>Species</label> <md-select aria-label=\"type\" class=\"fill-input\" name=\"species\" ng-model=\"settings.activeSpecies\" ng-change=\"updateSpecies()\"> <md-option ng-repeat=\"species in ['bicornis','cornuta']\" ng-value=\"species\"> {{species}} </md-option> </md-select> </md-input-container> </div> <div layout=\"row\" layout-padding> <h3 class=\"md-primary\"> Amount and price </h3> </div> <div layout-padding> <div layout-gt-xs=\"row\" flex=\"50\" ng-if=\"order.type == 'STARTPOP'\"> <md-input-container flex> <label>Free Start populations (vouchers)</label> <input flex type=\"number\" name=\"freeAmount\" ng-model=\"freeAmount\" ng-disabled=\"true\"> </md-input-container> </div> <div layout-gt-xs=\"row\" flex=\"50\" ng-if=\"order.type == 'STARTPOP'\"> <md-input-container flex> <label>Paid Start populations</label> <input flex type=\"number\" min=\"0\" name=\"additionalAmount\" ng-model=\"calculate.additionalAmount\" ng-disabled=\"order.type == 'BEECARE' || order.bexio_id || order.is_printed\" ng-change=\"updateTotalPrice()\"> </md-input-container> <md-input-container flex> <label>Unit price</label> <input type=\"number\" name=\"unit_price\" ng-model=\"order.unit_price\" ng-disabled=\"true\"> </md-input-container> </div> <div layout-gt-xs=\"row\" flex=\"50\" ng-if=\"order.type == 'STARTPOP'\"> <md-input-container flex> <label>Total number of Start populations</label> <input flex type=\"number\" min=\"1\" name=\"totalAmount\" ng-model=\"totalAmount\" ng-disabled=\"true\"> <div ng-messages=\"orderForm.totalAmount.$error\" class=\"validation-messages\" ng-if=\"orderForm.$submitted || orderForm.totalAmount.$touched\"> <div ng-message=\"min\">Minimum 1</div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" flex=\"100\"> <md-input-container flex=\"50\"> <label>Donation</label> <md-select aria-label=\"type\" class=\"fill-input\" name=\"type\" ng-model=\"order.donation\" ng-change=\"updateTotalPrice()\"> <md-option ng-repeat=\"variant in donationOptions\" ng-value=\"variant\"> {{variant.price}} </md-option> </md-select> </md-input-container> <md-input-container flex ng-show=\"order.donation\"> <md-button class=\"md-icon-button md-warn\" style=\"padding: 0px !important; margin: 0px !important\" ng-click=\"clearDonation()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </md-input-container> </div> <div layout-gt-xs=\"row\" flex=\"50\">&nbsp;</div> <div layout-gt-xs=\"row\" flex=\"50\"> <md-input-container flex> <label>Sub-total</label> <input flex type=\"number\" name=\"subTotal\" ng-model=\"subTotal\" ng-disabled=\"true\"> </md-input-container> </div> <!-- <div layout-gt-xs=\"row\" flex=\"50\">\n" +
    "\t\t\t<md-input-container flex>\n" +
    "\t\t\t\t<label>Shipping price</label>\n" +
    "\t\t\t\t<input\n" +
    "\t\t\t\t\tflex\n" +
    "\t\t\t\t\ttype=\"number\"\n" +
    "\t\t\t\t\tname=\"shipping_price\"\n" +
    "\t\t\t\t\tng-model=\"order.shipping_price\"\n" +
    "\t\t\t\t\tstep=\"0.01\"\n" +
    "\t\t\t\t\tng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"\n" +
    "\t\t\t\t\tng-disabled=\"order.bexio_id || order.is_printed\"\n" +
    "\t\t\t\t\tng-change=\"updateTotalPrice()\"\n" +
    "\t\t\t\t/>\n" +
    "\t\t\t</md-input-container>\n" +
    "\t\t</div> --> <div layout-gt-xs=\"row\" flex=\"50\" ng-if=\"order.type == 'BEECARE'\"> <md-input-container flex> <label>Donation</label> <input flex type=\"number\" ng-model=\"calculate.donation_price\" step=\"0.01\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-disabled=\"order.bexio_id || order.is_printed\" ng-change=\"updateTotalPrice()\"> </md-input-container> </div> <div layout-gt-xs=\"row\" flex> <div layout-gt-xs=\"row\" flex=\"50\"> <md-input-container flex ng-if=\"order.type != 'BEECARE'\"></md-input-container> <md-input-container flex> <label>Currency</label> <input flex type=\"text\" name=\"currency\" ng-model=\"order.currency\" ng-disabled=\"true\"> </md-input-container> <md-input-container flex> <label>Total price</label> <input flex type=\"number\" name=\"total_price\" ng-model=\"order.total_price\" step=\"0.01\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" disabled> </md-input-container> </div> <md-input-container flex=\"25\" ng-show=\"order.type == 'BEECARE'\"> <md-checkbox ng-model=\"isInvoice\" aria-label=\"psp\" ng-click=\"order.psp = order.psp == 'INVOICE'? null : 'INVOICE'\" ng-init=\"isInvoice = order.psp == 'INVOICE'\" ng-disabled=\"!order.total_price || order.bexio_id || order.is_printed\" flex> Invoice </md-checkbox> </md-input-container> </div> </div> <div layout-gt-sm=\"row\" layout-gt-md=\"row\" layout-padding> <div layout=\"column\" flex-gt-md=\"33\" flex-gt-sm=\"50\" flex=\"100\"> <h3 class=\"md-primary\"> {{order.type == 'STARTPOP' ? 'Shipping address' : 'Return address'}} <md-button class=\"md-primary md-icon-button small\" ng-click=\"expandAddress=!expandAddress\" ng-hide=\"order.is_printed\"> <i class=\"material-icons ng-scope\" ng-hide=\"expandAddress\">edit</i> <i class=\"material-icons ng-scope\" ng-show=\"expandAddress\">done</i> </md-button> </h3> <md-input-container class=\"md-block\"> <address-picker name=\"address\" ng-model=\"order.address_id\" client=\"client\" expanded=\"expandAddress\" countries=\"settings.allowed_countries\" form=\"orderForm\" required> </md-input-container> </div> </div> <div layout-gt-sm=\"row\" layout-gt-md=\"row\" layout-padding> <div layout=\"column\" flex-gt-md=\"33\" flex-gt-sm=\"50\" flex=\"100\" layout-align=\"start start\" ng-if=\"order.type == 'STARTPOP'\"> {{$scope.settings.excluded_dates}} <h3 class=\"md-primary\"> Shipping Date </h3> <md-input-container class=\"md-block\"> <md-datepicker name=\"delivery_date\" ng-model=\"order.delivery_date\" md-min-date=\"settings.min_date\" md-max-date=\"settings.end_date\" md-date-filter=\"dateFilter\" ng-disabled=\"order.is_printed\" required></md-datepicker> <div class=\"validation-messages\" ng-messages=\"orderForm.delivery_date.$error\"> <div ng-message=\"valid\">This does not look like a valid date.</div> <div ng-message=\"required\">A delivery date is required.</div> <div ng-message=\"mindate\"> Date is before season start or in the past. </div> <div ng-message=\"maxdate\">Date is after the season end.</div> <div ng-message=\"filtered\"> We do not delivery on this weekday or the date is on the holiday list. </div> </div> </md-input-container> </div> <div layout=\"column\" flex-gt-md=\"33\" flex-gt-sm=\"50\" flex=\"100\" layout-align=\"start start\"> <h3 class=\"md-primary\"> Order date </h3> <md-input-container class=\"md-block\" flex=\"50\"> <md-datepicker name=\"orderDate\" ng-model=\"order.order_date\" ng-disabled=\"true\"></md-datepicker> </md-input-container> <span flex></span> </div> </div> <div layout=\"row\" layout-padding ng-if=\"order.type == 'BEECARE'\"> <h3 class=\"md-primary\"> Shipping </h3> </div> <div layout-padding> <div layout-gt-xs=\"row\" ng-if=\"order.type == 'BEECARE'\"> <md-input-container class=\"md-block\" flex=\"50\"> <label>Shipping label</label> <input type=\"text\" ng-model=\"order.shipping_label\" aria-label=\"ShippingLabel\" disabled ng-click=\"order.shipping_label\" flex> <md-icon class=\"search-img md-primary\" ng-if=\"order.shipping_label\"> <a class=\"general-link\" ng-href=\"{{order.shipping_label}}\" target=\"_blank\"><i class=\"material-icons\">launch</i></a> </md-icon> </md-input-container> <md-input-container class=\"md-block\" flex=\"25\"> <label>Tracking number</label> <input type=\"text\" ng-model=\"order.tracking_number\" aria-label=\"TrackingNumber\" disabled flex> <md-icon class=\"search-img md-primary\" ng-if=\"order.tracking_number\"> <a class=\"general-link\" ng-href=\"{{ getTrackingLink(order.tracking_number) }}\" target=\"_blank\"><i class=\"material-icons\">launch</i></a> </md-icon> </md-input-container> </div> <div layout-gt-xs=\"row\"> <md-input-container class=\"md-block\" flex=\"50\"> <label>Comment (internal)</label> <input type=\"text\" ng-model=\"order.comment\" aria-label=\"Comment\" class=\"md-primary md-align-top-left\" flex> </md-input-container> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"save\"> Continue </md-button> </md-dialog-actions> </div> </form>"
  );


  $templateCache.put('views/beehome-orders-filter.html',
    "<form id=\"toastBox\" name=\"startpopFilterForm\" class=\"form-inline\" ng-submit=\"startpopFilterForm.$valid && save()\" ng-novalidate> <md-dialog-content> <div class=\"layout-padding\"> <md-subheader layout-padding> <div class=\"layout-gt-xs-row form-row\"> <span flex></span> <span class=\"general-link\" style=\"padding-top: 12px\" ng-click=\"clearFilter()\" ng-show=\"filter\" layout-align=\"end center\"><i class=\"material-icons\">clear</i> Clear All</span> </div> </md-subheader> <div> <div layout=\"column\" layout-gt-sm=\"row\" class=\"form-row\"> <md-input-container layout-align=\"start end\" flex-gt-xs> <label>From</label> <md-datepicker ng-model=\"filter.delivery_date_from\" ng-change=\"filter.delivery_date_to = filter.delivery_date_from; runFilter()\" md-hide-icons=\"calendar\"></md-datepicker> </md-input-container> <md-input-container layout-align=\"start end\" flex-gt-xs> <label>To</label> <md-datepicker ng-model=\"filter.delivery_date_to\" md-min-date=\"filter.delivery_date_to\" ng-change=\"runFilter()\" md-hide-icons=\"calendar\"></md-datepicker> </md-input-container> <md-input-container class=\"filter-field md-block\" flex-gt-xs> <label>Type</label> <md-select name=\"type\" ng-model=\"filter.type\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-repeat=\"type in ['Startpop', 'Beecare']\" ng-value=\"type.toUpperCase()\"> {{type}} </md-option> </md-select> </md-input-container> <md-input-container class=\"filter-field md-block\" flex-gt-xs> <label>Organisation</label> <md-select name=\"organisation\" ng-model=\"filter.organisation_id\" ng-change=\"runFilter()\" ng-disabled=\"clientId\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-repeat=\"(id, name) in organisations\" ng-value=\"id\"> {{name}} </md-option> </md-select> </md-input-container> </div> <div layout=\"column\" layout-gt-sm=\"row\" class=\"form-row\"> <md-input-container class=\"filter-field md-block\" layout-align=\"start center\" flex-gt-xs> <label>Paid</label> <md-select name=\"status\" ng-model=\"filter.is_paid\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-value=\"true\">Yes</md-option> <md-option ng-value=\"false\">No</md-option> </md-select> </md-input-container> <md-input-container class=\"filter-field md-block\" layout-align=\"start center\" flex-gt-xs> <label>Has bexio ID</label> <md-select name=\"bexioIdSelect\" ng-model=\"filter.has_bexio_id\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-value=\"true\">Yes</md-option> <md-option ng-value=\"false\">No</md-option> </md-select> </md-input-container> <md-input-container class=\"filter-field md-block\" layout-align=\"start center\" flex-gt-xs> <label>Is Invoice</label> <md-select name=\"invoiceSelect\" ng-model=\"filter.is_invoice\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-value=\"true\">Yes</md-option> <md-option ng-value=\"false\">No</md-option> </md-select> </md-input-container> <md-input-container class=\"filter-field md-block\" layout-align=\"start center\" flex-gt-xs> <label>Standard</label> <md-select name=\"status\" ng-model=\"filter.is_standard\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-value=\"true\">Yes</md-option> <md-option ng-value=\"false\">No</md-option> </md-select> </md-input-container> <md-input-container class=\"filter-field md-block\" layout-align=\"start center\" flex-gt-xs> <label>Printed</label> <md-select name=\"status\" ng-model=\"filter.is_printed\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-value=\"\">[All]</md-option> <md-option ng-value=\"true\">Yes</md-option> <md-option ng-value=\"false\">No</md-option> </md-select> </md-input-container> </div> </div> </div> </md-dialog-content> </form>"
  );


  $templateCache.put('views/beehome-orders.html',
    "<div restrict-access=\"BeeStarter\" ng-controller=\"BeehomeOrdersCtrl\"> <div layout-gt-md=\"row\" class=\"form-row md-no-momentum\"> <div layout=\"row\" flex-gt-md=\"50\" layout-align=\"start center\"> <form role=\"form\" class=\"form-inline\" flex ng-hide=\"clientId\"> <md-content layout=\"column\" id=\"product-search\" class=\"first product-code-search\"> <md-input-container class=\"md-block\" md-no-float flex-gt-sm> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search()\">search</i></md-icon> <input flex type=\"text\" name=\"keywords\" ng-model=\"query.q\" ng-model-options=\"{ debounce: 250 }\" ng-change=\"getStartpopOrders()\" class=\"search-box\" placeholder=\"Search\" focus-me=\"{{!clientId}}\"> </md-input-container> </md-content> </form> <div layout=\"column\"> <md-input-container> <md-button ng-click=\"showFilter=!showFilter\" class=\"md-primary\"> <i class=\"material-icons\">filter_list</i> <span ng-show=\"!showFilter\">Filter</span><span ng-show=\"showFilter\">Hide Filter</span> </md-button> </md-input-container> </div> </div> </div> <div layout=\"row\"> <span flex></span> </div> <div class=\"table-responsive\"> <beehome-orders-filter ng-show=\"showFilter\" organisations=\"organisations\" client-id=\"clientId\" house-id=\"houseId\" filter=\"query.filter\" run-filter=\"getStartpopOrders()\"></beehome-orders-filter> </div> <div layout=\"row\" flex layout-align=\"end end\"> <md-button class=\"md-primary\" ng-click=\"newOrder('STARTPOP')\"> <i class=\"material-icons\">add</i>Add Startpop order </md-button> <md-button ng-click=\"deleteOrders()\" class=\"md-warn\" ng-disabled=\"selected.length==0 || (selected | filter:cannotBeDeleted).length > 0\"> <i class=\"material-icons\">remove</i> Delete </md-button> <md-button class=\"md-primary\" ng-click=\"editOrder(selected[0].id)\" ng-disabled=\"selected.length!=1\"> <i class=\"material-icons\">mode_edit</i> Edit </md-button> <div excel-export get-data=\"loadPrintData()\" print-status=\"all\" button-text=\"Export\" file-name=\"{{fileName}}\" restrict-access=\"Download Addresses\" ng-hide=\"clientId\"></div> <md-button class=\"md-primary\" ng-click=\"openHistory(selected[0].id)\" ng-disabled=\"selected.length!=1\"> <i class=\"material-icons\">history</i> History </md-button> <md-button class=\"md-primary\" ng-click=\"updateBexio(selected)\" ng-disabled=\"!selected.length\"> <i class=\"material-icons\">sync</i>push to bexio </md-button> </div> <div> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getStartpopOrders\"> <tr md-row> <th md-column md-order-by=\"id\">Id</th> <th md-column md-order-by=\"order_date\">Order date</th> <th md-column md-order-by=\"type\">Type</th> <th md-column md-order-by=\"organisation_id\" ng-hide=\"clientId\"> Organisation </th> <th md-column md-order-by=\"client_id\" ng-hide=\"clientId\">Client id</th> <th md-column md-order-by=\"first_name\" ng-hide=\"clientId\">First name</th> <th md-column md-order-by=\"last_name\" ng-hide=\"clientId\">Last name</th> <th md-column md-order-by=\"amount\">Amount</th> <th md-column>Addon</th> <th md-column md-order-by=\"delivery_date\">Delivery date</th> <th md-column md-order-by=\"address_1\">Delivery address</th> <th md-column md-order-by=\"total_price\">Total price</th> <th md-column md-order-by=\"psp\">PSP</th> <th md-column md-order-by=\"is_paid\">Is paid</th> <th md-column md-order-by=\"is_standard\">Is standard</th> <th md-column md-order-by=\"is_printed\">Is printed</th> <th md-column md-order-by=\"bexio_nr\">Invoice nr</th> <th md-column>Comment</th> <th md-column md-order-by=\"created_at\">Created on</th> <th md-column md-order-by=\"created_by\">Created by</th> <th md-column md-order-by=\"updated_at\">Updated on</th> <th md-column md-order-by=\"updated_by\">Updated by</th> <th md-column>Shopify</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"order\" md-select-id=\"order.id\" md-auto-select ng-repeat=\"order in matches\" ng-dblclick=\"editOrder(order.id)\"> <td md-cell>{{order.id}}</td> <td md-cell>{{order.order_date | date:'dd/MM/yyyy'}}</td> <td md-cell>{{order.type}}</td> <td md-cell ng-hide=\"clientId\"> {{organisations[order.organisation_id] || '-'}} </td> <td md-cell ng-hide=\"clientId\"> <a class=\"general-link\" ui-sref=\"client({cid:order.client_id})\">{{order.client_id}}</a> </td> <td md-cell ng-hide=\"clientId\">{{order.first_name}}</td> <td md-cell ng-hide=\"clientId\">{{order.last_name}}</td> <td md-cell>{{order.amount}}</td> <td md-cell> <i class=\"material-icons\" ng-show=\"order.hasBeehomeAddon\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!order.hasBeehomeAddon && order.shopify_id\">clear</i> <span ng-if=\"!order.shopify_id\" style=\"color: lightgray\">N/A</span> </td> <td md-cell>{{order.delivery_date | date:'dd/MM/yyyy'}}</td> <td md-cell>{{order.address_1}}</td> <td md-cell>{{order.total_price}}</td> <td md-cell>{{order.psp}}</td> <td md-cell> <i class=\"material-icons\" ng-show=\"order.is_paid\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!order.is_paid\">clear</i> </td> <td md-cell> <i class=\"material-icons\" ng-show=\"order.is_standard\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!order.is_standard\">clear</i> </td> <td md-cell> <i class=\"material-icons\" ng-show=\"order.is_printed\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!order.is_printed\">clear</i> </td> <td md-cell>{{order.bexio_nr}}</td> <td md-cell md-truncate style=\"max-width: 150px\"> <md-tooltip ng-if=\"order.comment\">{{order.comment}}</md-tooltip> {{order.comment}} </td> <td md-cell>{{order.created_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[order.created_by].firstName}}</td> <td md-cell>{{order.updated_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[order.updated_by].firstName}}</td> <td md-cell> <a ng-if=\"order.shopify_id\" href=\"https://admin.shopify.com/store/beehome-ch/orders/{{order.shopify_id}}\" target=\"_blank\" style=\"color: #1976d2\"> <i class=\"material-icons\">link</i> </a> <order-line-items ng-if=\"order.shopify_id\" order=\"order\"></order-line-items> <span ng-if=\"!order.shopify_id\" style=\"color: lightgray\">-</span> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination ng-show=\"matches.length > 8\" showfirstlastbuttons md-limit=\"query.limit\" md-limit-options=\"query.limitOptions\" md-page=\"query.page\" md-total=\"{{startpopOrdersCount}}\" md-page-select md-on-paginate=\"getStartpopOrders\" md-boundary-links> </md-table-pagination> </div> <!-- </div> --> </div>"
  );


  $templateCache.put('views/beehome-tubes.html',
    "<div class=\"searchdetails\"> <form name=\"productSearchForm\" role=\"form\" ng-submit=\"normalizePath()\" flex-gt-xs=\"50\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"product-code-search layout-gt-xs-row form-row md-no-momentum\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"normalizePath()\">search</i></md-icon> <input flex type=\"text\" name=\"product-code-search\" class=\"search-box\" translate-attr=\"{ placeholder: 'harvest.search_product_code' }\" ng-model=\"activeProduct.Code\"> </md-input-container> </md-content> <span class=\"md-warn\" ng-show=\"!showSearch\" translate=\"general.code_not_found\">Code not found</span> </form> </div> <div ng-class=\"popClass\" flex-gt-xs ng-show=\"activeProduct.PROD_ID\"> <div class=\"section\"> <h3 translate=\"general.house\">House</h3> <table class=\"table\"> <tr> <th class=\"product-head\" valign=\"middle\" translate=\"tubes.code\">Code</th> <th class=\"product-head\" valign=\"middle\" translate=\"tubes.product\"> Product </th> <th class=\"product-head\" valign=\"middle\" translate=\"harvest.beecare_status\"> BeeCare Status </th> </tr> <tr> <td valign=\"bottom\">{{activeProduct.HOUSE_CD}}</td> <td valign=\"bottom\">{{activeProduct.PROD_NAME}}</td> <td valign=\"bottom\"> <div product-progress-indicator product=\"activeProduct\" client-id=\"activeProduct.CLIENT_ID\" users=\"users\"></div> </td> </tr> </table> <div layout=\"row\"> <div flex></div> <md-button class=\"md-primary\" ng-click=\"printQRCode()\"> <i class=\"material-icons\">print</i> <span translate=\"harvest.print_qr\">Print QR code</span> </md-button> </div> </div> <div class=\"section\"> <h3 translate=\"general.population\">Population</h3> <div layout=\"row\"> <div layout=\"column\" flex=\"70\"> <recognition-iframe-directive style=\"position: relative; width: 100%; padding-top: calc(100% + 50px)\" image-url=\"imageUrl\" population-data=\"populationData\" update-data=\"autoUpdateData(activeCode)\"></recognition-iframe-directive> </div> <div layout=\"column\" flex=\"30\"> <div class=\"panel panel-default\" ng-class=\"getClass(population, 'ratio')\"> <div class=\"panel-heading panel-accordion ng-cloak\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.ratio=toggleView(showPanel.ratio)\" ng-cloak> <h4 translate=\"tubes.categories\">Categories</h4> <span flex></span> <md-button class=\"zero-tubes-btn\" ng-click=\"calculateCocoons()\"> <span translate=\"tubes.catculateCocoons\">Calculate Cocoons</span> </md-button> </div> <div class=\"panel-body\" ng-show=\"showPanel.ratio\"> <md-radio-group ng-model=\"ratio\" ng-change=\"updateLifeCycleRatio()\"> <md-radio-button aria-label=\"Annual\" flex value=\"SINGLE\" class=\"md-primary\"> <span translate=\"tubes.singleYearRatio\">Single Year</span> </md-radio-button> <md-radio-button aria-label=\"mixed\" flex value=\"MIXED\" class=\"md-primary\"> <span translate=\"tubes.mixedRatio\">Mixed</span> </md-radio-button> <md-radio-button aria-label=\"multi Annual\" flex value=\"MULTI\" class=\"md-primary\"> <span translate=\"tubes.multiYearRatio\">Multi Year</span> </md-radio-button> </md-radio-group> </div> </div> <div class=\"panel panel-default\" ng-class=\"getClass(population, 'tube')\"> <div class=\"panel-heading panel-accordion ng-cloak\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.tube=toggleView(showPanel.tube)\" ng-cloak> <h4 style=\"display: inline-block\" translate=\"general.box\">Box</h4> <md-progress-circular class=\"panel-progress-circle\" md-diameter=\"15px\" md-mode=\"indeterminate\" ng-show=\"saveStatus.tube=='saving'\"></md-progress-circular> <i class=\"material-icons panel-progress-tick\" ng-show=\"saveStatus.tube=='saved'\">done</i> <span flex></span> <md-button class=\"zero-tubes-btn\" ng-click=\"setZeroPopulation('tube')\" ng-show=\"saveStatus.tube!='saved' && saveStatus.tube!='saving'\" translate=\"tubes.zero_tubes\">Zero Tubes</md-button> </div> <div class=\"panel-body\" ng-show=\"showPanel.tube\"> <ng-form action=\"\" name=\"popform\"> <div layout=\"row\"> <div layout=\"column\" flex=\"50\"> <strong translate=\"general.name\">Name</strong> </div> <div layout=\"column\" layout-align=\"center end\" flex=\"50\"> <strong translate=\"tubes.inhabited\">Inhabited Tubes</strong> </div> </div> <div class=\"tube_species_list\" layout=\"row\" ng-repeat=\"tube in population\"> <div layout=\"column\" flex=\"90\" layout-align=\"center stretch\"> <span>{{tube.insect + ' (' + tube.latin_name + ')'}} <i class=\"material-icons general-link\" tabindex=\"-1\" ng-click=\"openPreview('dynamic-images/' + tube.filename, tube.insect)\">open_in_new</i></span> </div> <div layout=\"column\" flex=\"10\" layout-align=\"center end\"> <md-input-container class=\"inhabited_tubes\" flex> <input name=\"qty{{$index}}\" id=\"input{{$index}}\" aria-label=\"quantity\" type=\"text\" number-input ng-pattern=\"/^[0-9]{1,7}$/\" ng-model=\"tube.quantity\" min=\"0\" max=\"{{tubeLimit}}\" class=\"qty\" select-on-click focus-me=\"{{showPanel.tube && $index==0}}\" ng-blur=\"popform['qty' + $index].$valid && popform['qty' + $index].$dirty && cellBlur('tube')\" ng-disabled=\"!editable\"> <div ng-messages=\"popform['qty' + $index].$error\"> <div ng-message=\"max\" translate=\"harvest.exceeded_max\"> you have exceeded the maximum. </div> </div> </md-input-container> </div> </div> </ng-form> </div> </div> <div class=\"panel panel-default observer-info\" ng-class=\"getClass(trayPopulation, 'tray')\" ng-show=\"activeProduct.PROD_CD.indexOf('_OB_') > -1 || activeProduct.PROD_CD.indexOf('_DV_') > -1\"> <div class=\"panel-heading panel-accordion\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.tray=toggleView(showPanel.tray)\" ng-cloak> <h4 style=\"display: inline-block\" translate=\"general.tray\">Tray</h4> <md-progress-circular class=\"panel-progress-circle\" md-diameter=\"15px\" md-mode=\"indeterminate\" ng-show=\"saveStatus.tray=='saving'\"></md-progress-circular> <i class=\"material-icons panel-progress-tick\" ng-show=\"saveStatus.tray=='saved'\">done</i> <span flex></span> <md-button class=\"zero-tubes-btn pull-right\" ng-click=\"setZeroPopulation('tray')\" ng-show=\"saveStatus.tray!='saved' && saveStatus.tray!='saving'\" translate=\"tubes.zero_tubes\"> Zero Tubes </md-button> </div> <div class=\"panel-body\" ng-show=\"showPanel.tray\"> <ng-form action=\"\" name=\"observerTubeForm\"> <div layout=\"row\"> <div layout=\"column\" flex=\"50\"> <strong translate=\"general.name\">Name</strong> </div> <div layout=\"column\" layout-align=\"center end\" flex=\"50\"> <strong translate=\"tubes.inhabited\">Inhabited Tubes</strong> </div> </div> <div class=\"tube_species_list\" layout=\"row\" ng-repeat=\"tray in trayPopulation\"> <div layout=\"column\" flex=\"90\" layout-align=\"center stretch\"> <span>{{tray.insect + ' (' + tray.latin_name + ')'}}<i class=\"material-icons general-link\" ng-click=\"openPreview('dynamic-images/' + tray.filename, tray.insect)\" tabindex=\"-1\">open_in_new</i></span> </div> <div layout=\"column\" flex=\"10\" layout-align=\"center end\"> <md-input-container class=\"inhabited_tubes\" flex> <input aria-label=\"quantity\" name=\"qty{{$index}}\" type=\"text\" number-input ng-pattern=\"/^[0-9]{1,7}$/\" ng-model=\"tray.quantity\" min=\"0\" max=\"{{tubeLimit}}\" class=\"qty\" select-on-click ng-blur=\"observerTubeForm['qty' + $index].$valid && observerTubeForm['qty' + $index].$dirty && cellBlur('tray')\"> <div ng-messages=\"observerTubeForm['qty' + $index].$error\"> <div ng-message=\"max\" translate=\"harvest.exceeded_max\"> You have exceeded the maximum. </div> </div> </md-input-container> </div> </div> </ng-form> </div> </div> </div> </div> <div class=\"panel panel-default observer-info\" ng-class=\"getClass(parasites, 'parasites')\" ng-show=\"activeProduct.PROD_CD.indexOf('_OB_') > -1 || activeProduct.PROD_CD.indexOf('_DV_') > -1\"> <div class=\"panel-heading panel-accordion\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.parasites=toggleView(showPanel.parasites)\" ng-cloak> <h4 style=\"display: inline-block\" translate=\"tubes.parasites_in_tray\"> Parasites in Tray </h4> <md-progress-circular class=\"panel-progress-circle\" md-diameter=\"15px\" md-mode=\"indeterminate\" ng-show=\"saveStatus.parasites=='saving'\"></md-progress-circular> <i class=\"material-icons panel-progress-tick\" ng-show=\"saveStatus.parasites=='saved'\">done</i> <span flex></span> <md-button class=\"zero-tubes-btn\" ng-click=\"setZeroPopulation('parasites')\" ng-show=\"saveStatus.parasites!='saved' && saveStatus.parasites!='saving'\" translate=\"harvest.zero_parasites\">Zero Parasites</md-button> </div> <div class=\"panel-body\" ng-show=\"showPanel.parasites\"> <form action=\"\" name=\"parasiteForm \"> <table class=\"table table-hover\"> <tr> <th width=\"200\" translate=\"general.name\">Name</th> <th></th> <th flex translate=\"general.description\">Description</th> <th width=\"200\" translate=\"harvest.presence\">Presence</th> </tr> <tr ng-repeat=\"species in parasites\"> <td class=\"insect-label-td\"> <span class=\"insect-label\">{{species.insect + ' (' + species.latin_name + ')'}}</span> </td> <td width=\"100\"> <img ng-src=\"dynamic-images/{{species.filename}}\" alt=\"\" class=\"thumbnail\" ng-click=\"openPreview('dynamic-images/' + species.filename, species.insect)\" tabindex=\"-1\"> </td> <td>{{species.description}}</td> <td class=\"text-right\"> <md-radio-group name=\"qty{{$index}}\" ng-model=\"species.quantity\" layout=\"row\" ng-blur=\"parasiteForm['qty' + $index].$dirty && cellBlur('parasites')\"> <span flex></span> <md-radio-button value=\"0\" class=\"md-primary\"><span translate=\"harvest.none\">None</span></md-radio-button><md-radio-button value=\"1\" class=\"red-bg\"> <span translate=\"harvest.present\">Present</span> </md-radio-button> </md-radio-group> </td> </tr> </table> </form> </div> </div> </div> </div>"
  );


  $templateCache.put('views/beehome-voucher-modal.html',
    "<md-dialog aria-label=\"delivery\" flex=\"90\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1 ng-if=\"!voucher.id\">Create voucher</h1> <h1 ng-if=\"voucher.id\">Edit voucher</h1> </div> </md-toolbar> <form name=\"voucherForm\" ng-submit=\"voucherForm.$valid && submitVoucher()\" novalidate> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Code</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Code\" flex type=\"text\" name=\"codeString\" ng-model=\"voucher.code\" required focus-me=\"true\" ng-change=\"onChangeCode()\" capitalize ng-disabled=\"true\"> <div ng-messages=\"voucherForm.codeString.$error\" ng-if=\"voucherForm.$submitted || voucherForm.codeString.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"pattern\"> Not a valid voucher code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Type*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"type\" class=\"fill-input\" name=\"type\" ng-model=\"voucher.type\" required> <md-option ng-repeat=\"type in ['Startpop', 'BeeCare', 'Startpop_OC', 'Startpop_BC']\" ng-value=\"type.toUpperCase()\"> {{type}} </md-option> </md-select> <div ng-messages=\"voucherForm.type.$error\" ng-if=\"voucherForm.$submitted || voucherForm.type.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Organisation*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"organisation\" class=\"fill-input\" name=\"orgList\" ng-model=\"voucher.organisation_id\" ng-change=\"clearClient()\" required> <md-option ng-repeat=\"(id, name) in organisations\" ng-value=\"id\"> {{name}} </md-option> </md-select> <div ng-messages=\"voucherForm.orgList.$error\" ng-if=\"voucherForm.$submitted || voucherForm.orgList.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Expiry date</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"20\"> <md-datepicker id=\"expiryDate\" name=\"expiryDate\" ng-model=\"voucher.expiry_on\" ng-required=\"true\"></md-datepicker> <div ng-messages=\"voucherForm.expiryDate.$error\" ng-if=\"voucherForm.$submitted || voucherForm.expiryDate.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container ng-if=\"voucher.id\"> <md-button ng-click=\"expireVoucher()\" class=\"md-warn md-hue-1\">Expire Voucher</md-button> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Account</span> </div> <p ng-if=\"client.name\">{{client.name}}</p> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <client-search id=\"clientSearch\" wbp-selected=\"assignClient\" wbp-floating-label=\"Email, house code, name, ...\" wbp-org=\"voucher.organisation_id\" selected-item=\"client\" class=\"client-search\" style=\"width:100%\"> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn md-hue-1\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\">Save </md-button> </md-dialog-actions> </form> </md-dialog>"
  );


  $templateCache.put('views/beehome-voucher-search.html',
    "<form name=\"form\" ng-submit=\"submit()\" width=\"100%\"> <div layout=\"row\" layout-align=\"center center\" md-autocomplete-snap=\"width\"> <md-icon class=\"search-img\"><i class=\"material-icons\" style=\"position: relative;top: -12px\" ng-click=\"search()\">search</i></md-icon> <md-autocomplete md-input-name=\"autocomplete\" md-search-text=\"searchText\" md-items=\"item in search(searchText)\" md-selected-item=\"selectedItem\" md-item-text=\"item.code\" md-selected-item-change=\"select(item)\" md-no-cache=\"true\" md-autoselect=\"true\" md-require-match=\"true\" md-min-length=\"3\" md-clear-button=\"true\" md-floating-label=\"Code\" md-delay=\"200\" md-menu-class=\"wbp-autocomplete\" ng-blur=\"submit()\" flex> <md-item-template> <div disabled> <strong> {{item.code}} </strong><br> <small>{{item.type}} <span ng-if=\"item.house\" class=\"md-warn pull-right\">Assigned to {{item.house.code}}</span></small> </div> <div class=\"clearfix\"></div> </md-item-template> <md-not-found> <div ng-click=\"submit()\"> <strong>Not found</strong><br> <small>Click or press ENTER to create a new voucher.</small> </div> </md-not-found> <div ng-messages=\"form.$dirty && form.autocomplete.$error\"> <div ng-message=\"md-require-match\">Please select a valid voucher.</div> <div ng-message=\"alreadyUsed\"> This voucher is already assigned to house <strong>{{selectedItem.house.code}}.</strong> </div> </div> </md-autocomplete> </div> </form>"
  );


  $templateCache.put('views/beehome-vouchers.html',
    "<md-tabs md-dynamic-height layout-padding> <md-tab id=\"search-tab\"> <md-tab-label>Search</md-tab-label> <md-tab-body> <div class=\"layout-gt-sm-row form-row md-no-momentum\" style=\"background: #FFF\"> <form role=\"form\" class=\"form-inline\" flex-gt-sm=\"50\"> <md-content layout-gt-sm=\"row\" id=\"product-search\" class=\"first product-code-search\"> <md-input-container class=\"md-block\" md-no-float flex-gt-sm> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search()\">search</i></md-icon> <input flex type=\"text\" name=\"search\" aria-label=\"Search code\" ng-model=\"query.filter\" ng-model-options=\"{ debounce: 250 }\" ng-change=\"getVouchers()\" class=\"search-box\" placeholder=\"Search code\" focus-me=\"true\"> </md-input-container> </md-content> </form> <div layout=\"column\" flex-gt-sm=\"50\"> <div layout-gt-sm=\"row\" layout-align=\"end center\"> <md-button class=\"md-primary no-caps\" ng-click=\"editVoucher()\" layout-align=\"start\"> <i class=\"material-icons\">add</i> New </md-button> <md-button class=\"no-caps\" ng-click=\"editVoucher(selected[0])\" ng-disabled=\"selected.length!=1\"> <i class=\"material-icons\">edit</i> Edit </md-button> <md-button class=\"md-warn no-caps\" ng-click=\"deleteVouchers()\" ng-disabled=\"selected.length==0 || (selected | filter:{order_id:''}).length > 0\"> <i class=\"material-icons\">remove</i>Delete </md-button> </div> </div> </div> <div class=\"table-responsive\"> <div class=\"panel-heading md-table-header-panel\" aria-hidden=\"true\" layout=\"row\"> <span flex></span> </div> <md-table-container> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\"> <thead md-head md-order=\"uploadQuery.order\" md-on-reorder=\"getVouchers\"> <tr md-row> <th md-column md-order-by=\"code\" width=\"150\">Code</th> <th md-column md-order-by=\"type\" width=\"140\">Type</th> <th md-column md-order-by=\"organisation_id\" width=\"150\"> Organisation </th> <th md-column md-order-by=\"order_id\" width=\"140\">Order</th> <th md-column width=\"140\">House</th> <th md-column width=\"140\">Client</th> <th md-column md-order-by=\"expiry_on\" width=\"140\">Expiry on</th> <th md-column md-order-by=\"is_active\" width=\"40\">Active</th> <th md-column md-order-by=\"created_at\" width=\"140\">Created on</th> <th md-column md-order-by=\"created_by\" width=\"140\">Created by</th> <th md-column md-order-by=\"updated_at\" width=\"140\">Updated on</th> <th md-column md-order-by=\"updated_by\" width=\"140\">Updated by</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"item\" md-select-id=\"item.ID\" md-auto-select ng-repeat=\"item in vouchers\" ng-dblclick=\"editVoucher(item)\"> <td md-cell style=\"white-space: pre\">{{item.code}}</td> <td md-cell>{{item.type}}</td> <td md-cell>{{organisations[item.organisation_id] || '-'}}</td> <td md-cell> <a class=\"general-link\" ui-sref=\"beehome-orders-edit({orderId:item.order_id})\">{{item.order_id}}</a> </td> <td md-cell> <house-link ng-model=\"item.house\" house-id=\"item.house_id\"> </td> <td md-cell> <a ng-if=\"item.client_id\" href=\"{{'#/beehome/account/' + item.client_id}}\"> {{item.client_id}} </a> </td> <td md-cell>{{item.expiry_on | date:'yyyy-MM-dd'}}</td> <td md-cell> <i class=\"material-icons\" ng-show=\"item.is_active\">done</i> <i class=\"material-icons md-warn\" ng-show=\"!item.is_active\">clear</i> </td> <td md-cell>{{item.created_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.created_by].firstName}}</td> <td md-cell>{{item.updated_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.updated_by].firstName}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"query.limit\" md-limit-options=\"query.limitOptions\" md-page=\"query.page\" md-total=\"{{voucherCount}}\" md-page-select md-on-paginate=\"getVouchers\" md-boundary-links> </md-table-pagination> </div> </md-tab-body> </md-tab> <md-tab id=\"upload-tab\" label=\"Upload\" restrict-access=\"Upload Whitelist\"> <md-content class=\"md-padding\" flex> <form name=\"voucherUploadForm\" ng-submit=\"upload()\" class=\"form-inline\" layout=\"row\" flex novalidate> <div class=\"flex-align-middle\" flex-gt-xs flex=\"25\" style=\"margin-top: -5px\"> <input id=\"input-file\" type=\"file\" file-model=\"file\" on-file-change=\"parseFile($file)\" accept=\"text/csv\" class=\"ng-hide\" required> <label for=\"input-file\" class=\"md-button md-primary\"> <span ng-show=\"!file.name\">Select file</span> <span ng-show=\"file.name\">{{file.name}}</span> </label> <div ng-messages=\"voucherUploadForm.whitelistFile.$error\" ng-if=\"voucherUploadForm.$submitted || voucherUploadForm.whitelistFile.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"25\"> <md-select aria-label=\"voucherType\" class=\"fill-input\" name=\"voucherType\" ng-model=\"voucherType\" required> <md-option ng-repeat=\"type in ['Startpop', 'BeeCare', 'Startpop_OC', 'Startpop_BC']\" ng-value=\"type.toUpperCase()\"> {{type}} </md-option> </md-select> <div ng-messages=\"voucherUploadForm.voucherType.$error\" ng-if=\"voucherType.$submitted || voucherUploadForm.voucherType.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"25\"> <md-select aria-label=\"organisation\" class=\"fill-input\" name=\"orgList\" ng-model=\"organisationId\" required> <md-option ng-repeat=\"(id, name) in organisations\" ng-value=\"id\"> {{name}} </md-option> </md-select> <div ng-messages=\"voucherUploadForm.orgList.$error\" ng-if=\"voucherUploadForm.$submitted || voucherUploadForm.orgList.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"25\"> <md-button type=\"submit\" class=\"md-primary\" ng-disabled=\"!isValidForUpload()\">Upload</md-button> </md-input-container> </form> <div class=\"table-responsive\" ng-show=\"uploadData.length\"> <div class=\"panel-heading md-table-header-panel\" aria-hidden=\"true\" layout=\"row\"> <span flex></span> </div> <md-table-container> <table md-table md-progress=\"promise\"> <thead md-head> <tr md-row> <th md-column width=\"150\">Code</th> <th md-column width=\"150\">Type</th> <th md-column width=\"150\"> Organisation </th> <th md-column width=\"140\">Expiry on</th> <th md-column width=\"140\">Created on</th> <th md-column width=\"140\">Created by</th> <th md-column width=\"140\">Updated on</th> <th md-column width=\"140\">Updated by</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"item in uploadData\"> <td md-cell>{{item.code}}</td> <td md-cell>{{item.type}}</td> <td md-cell>{{organisations[item.organisation_id] || '-'}}</td> <td md-cell>{{item.expiry_on | date:'yyyy-MM-dd'}}</td> <td md-cell>{{item.created_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.created_by].firstName}}</td> <td md-cell>{{item.updated_at | date:'yyyy-MM-dd'}}</td> <td md-cell>{{users[item.updated_by].firstName}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"uploadQuery.limit\" md-limit-options=\"uploadQuery.limitOptions\" md-page=\"uploadQuery.page\" md-total=\"{{uploadDataCount}}\" md-page-select md-boundary-links md-on-paginate=\"getUploadData\"> </md-table-pagination> </div> </md-content> </md-tab> </md-tabs>"
  );


  $templateCache.put('views/box-checkin.html',
    "<div restrict-access=\"BeeManagement Checkin\"> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height> <md-tab id=\"codes-tab\"> <md-tab-label>Codes</md-tab-label> <md-tab-body> <div class=\"row results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div flex-gt-xs> <form name=\"codeForm\" ng-submit=\"codeForm.$valid && checkin()\" class=\"padding-top-20\"> <md-input-container class=\"md-block\"> <input id=\"scannerInput\" type=\"text\" name=\"scannerInput\" ng-model=\"scannedcode\" focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(BC|bc)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(A|a)[0-9]{2}[a-z,A-Z]{2}[0-9,a-z,A-Z]{4}$|^(CH|DE|FR|IT|ES)[0-9]{2}[A-Z]{7}[0-9]{4}$/\" style=\"text-transform: uppercase\" placeholder=\"Scan box / population code\"> <div ng-messages=\"codeForm.$error\" aria-label=\"Box / population code\" ng-if=\"codeForm.$submitted || codeForm.scannerInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </form> </div> <md-button ng-click=\"completeBoxes()\" class=\"md-primary md-raised max-height-20\" ng-disabled=\"!boxes.length\">Done</md-button> <div flex></div> </div> <div layout=\"row\"> <h3 class=\"no-caps\">{{boxes.length}} codes scanned</h3> </div> <div layout=\"row\" layout-gt-md=\"row\" class=\"table-responsive\" flex=\"30\" ng-show=\"boxes.length\"> <table class=\"table table-hover\"> <thead> <tr> <th>Code</th> </tr> </thead> <tbody> <tr ng-repeat=\"box in boxes\" valign=\"middle\"> <td> <md-input-container> <span class=\"uppercase\"> {{box.BOX_CD}} <md-button ng-click=\"removeBox($index)\"><i class=\"material-icons\">clear</i></md-button></span> </md-input-container> </td> </tr> </tbody> </table> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"fridge-tab\" ng-disabled=\"!boxes.length\"> <md-tab-label>Fridge</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\" layout-padding> <div layout=\"row\"> <div flex-gt-xs> <form name=\"fridgeCodeForm\" ng-submit=\"fridgeCodeForm.$valid && selectFridge()\" class=\"padding-top-20\"> <md-input-container class=\"md-block\"> <input id=\"fridgeInput\" aria-label=\"Fridge code\" type=\"text\" name=\"fridgeInput\" ng-model=\"scannedFridge\" style=\"text-transform:uppercase\" focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}|(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$/\" placeholder=\"Scan a fridge\"> <div ng-messages=\"fridgeInput.$error\" ng-if=\"fridgeCodeForm.$submitted || fridgeCodeForm.fridgeInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </form> </div> <md-button id=\"button-id\" type=\"submit\" ng-click=\"selectFridge()\" class=\"md-primary md-raised max-height-20\" ng-disabled=\"!fridgeCodeForm.$valid\" aria-label=\"submit\">Done</md-button> <div flex></div> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"confirm-tab\" ng-disabled=\"!boxes.length || !validFridgeCode\"> <md-tab-label>Confirm</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div flex=\"45\"> <h3 class=\"no-caps\"> {{boxes.length}} boxes will be checked into {{scannedFridge}}? </h3> <span flex></span> </div> <md-button ng-click=\"confirmCheckin()\" class=\"md-primary md-raised max-height-20\">Done</md-button> </div> <div layout=\"row\"> <table class=\"table table-hover\" flex=\"20\"> <thead> <tr> <th>Code</th> </tr> </thead> <tbody> <tr ng-repeat=\"box in boxes\" valign=\"middle\"> <td style=\"text-transform: uppercase\"> <span class=\"md-primary uppercase\"> {{box.BOX_CD}} </span> </td> </tr> </tbody> </table> </div> </div> </div> </md-tab-body> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/box-checkout.html',
    "<div restrict-access=\"BeeManagement Checkout\"> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height> <md-tab id=\"codes-tab\"> <md-tab-label>Codes</md-tab-label> <md-tab-body> <div class=\"row results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div flex-gt-xs> <form name=\"codeForm\" ng-submit=\"codeForm.$valid && checkout()\" class=\"padding-top-20\"> <md-input-container class=\"md-block\"> <input id=\"scannerInput\" aria-label=\"Box / population code\" type=\"text\" name=\"scannerInput\" ng-model=\"scannedcode\" focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(BC|bc)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(A|a)[0-9]{2}[a-z,A-Z]{2}[0-9,a-z,A-Z]{4}$|^(CH|DE|FR|IT|ES)[0-9]{2}[A-Z]{7}[0-9]{4}$/\" style=\"text-transform: uppercase\" placeholder=\"Scan box / population code\"> <div ng-messages=\"codeForm.$error\" ng-if=\"codeForm.$submitted || codeForm.scannerInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </form> </div> <md-button ng-click=\"submitBoxes()\" class=\"md-primary md-raised max-height-20\" ng-disabled=\"!boxes.length\">Done</md-button> <div flex></div> </div> <div layout=\"row\"> <h3 class=\"no-caps\">{{boxes.length}} codes scanned</h3> </div> <div layout=\"row\" layout-gt-md=\"row\" class=\"table-responsive\" flex=\"30\" ng-show=\"boxes.length\"> <table class=\"table table-hover\"> <thead> <tr> <th>Code</th> </tr> </thead> <tbody> <tr ng-repeat=\"box in boxes\" valign=\"middle\"> <td> <md-input-container> <span class=\"uppercase\"> {{box.BOX_CD}} <md-button ng-click=\"removeBox($index)\"><i class=\"material-icons\">clear</i></md-button></span> </md-input-container> </td> </tr> </tbody> </table> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"reason-tab\" ng-disabled=\"!boxes.length\"> <md-tab-label>Reason</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\" layout-padding> <div layout=\"row\"> <div flex=\"50\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Reason</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <form ng-submit=\"selectFridge()\"> <md-select name=\"intentSelect\" aria-label=\"Reason\" ng-model=\"intent\"> <md-option ng-repeat=\"intent in reasons\" ng-value=\"intent\"> {{intent.CODE}} </md-option> </md-select> </form> </md-input-container> </div> </div> <md-button ng-click=\"submitIntent()\" class=\"md-primary md-raised max-height-20\" ng-disabled=\"!boxes.length\">Done</md-button> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"confirm-tab\" ng-disabled=\"!boxes.length || !canBeConfirmed\"> <md-tab-label>Confirm</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div flex=\"45\"> <h3 class=\"no-caps\"> Check {{boxes.length}} <span ng-if=\"boxes.length == 1\">box</span><span ng-if=\"boxes.length > 1\">boxes</span> out of fridge for {{intent.CODE}}? </h3> <span flex></span> </div> <md-button ng-click=\"confirmCheckout()\" class=\"md-primary md-raised max-height-20\">Done</md-button> </div> <div layout=\"row\"> <table class=\"table table-hover\" flex=\"20\"> <thead> <tr> <th>Code</th> </tr> </thead> <tbody> <tr ng-repeat=\"box in boxes\" valign=\"middle\"> <td style=\"text-transform: uppercase\"> <span class=\"md-primary uppercase\"> {{box.BOX_CD}} </span> </td> </tr> </tbody> </table> </div> </div> </div> </md-tab-body> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/box-modal.html',
    "<md-dialog aria-label=\"boxs\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 ng-if=\"!editing\" class=\"no-caps\"> Add {{box.type.ID == 1 ? 'box' : 'population'}} </h2> <h2 ng-if=\"editing\" class=\"no-caps\"> Edit {{box.type.ID == 1 ? 'box' : 'population'}} {{box.code}} </h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"boxForm\" ng-submit=\"boxForm.$valid && canBeSaved() && save()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Code</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"codeInput\" aria-label=\"Code\" ng-model=\"box.code\" focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(BC|bc)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(A|a)[0-9]{2}[a-z,A-Z]{2}[0-9,a-z,A-Z]{4}$|^[a-z,A-Z]{2}[0-9]{2}[a-z,A-Z]{7}[0-9]{4}$/\" ng-change=\"checkCode()\" style=\"text-transform:uppercase\" ng-required=\"box.type.ID==2\"> <div ng-messages=\"boxForm.codeInput.$error\" ng-if=\"boxForm.$submitted || boxForm.codeInput.$touched\"> <div ng-message=\"required\"> You must provide a code. </div> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"preType==1\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Organisation</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"boxOrganisation\" aria-label=\"Box organisation\" ng-model=\"box.ORGANISATION_ID\" ng-disabled=\"!validCode\" ng-required=\"box.type.CODE != 'Startpop'\" ng-change=\"getConversionFactors()\"> <md-option ng-repeat=\"org in organisations\" ng-value=\"org.ID\"> {{org.NAME}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"!preType\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Type</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"boxType\" aria-label=\"Box type\" ng-model=\"box.type\" ng-disabled=\"!validCode\" ng-required=\"!preType\"> <md-option ng-repeat=\"bType in boxTypes\" ng-value=\"bType\"> {{bType.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Source</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"sourceType\" aria-label=\"Source type\" ng-model=\"box.sourceType\" ng-disabled=\"!validCode\" ng-change=\"getConversionFactors()\" ng-required=\"box.type.CODE != 'Startpop'\"> <md-option ng-repeat=\"sType in sourceTypes\" ng-value=\"sType\" ng-required=\"box.type.CODE != 'Startpop'\"> {{sType.DESCRIPTION}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" ng-show=\"box.type.CODE != 'Startpop' && box.sourceType.CODE == 'Procurement'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Source Information</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input name=\"sourceText\" aria-label=\"Source information\" ng-model=\"box.sourceText\" type=\"text\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Batch</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-autocomplete name=\"batchInput\" id=\"batchInput\" aria-label=\"Batch\" ng-disabled=\"!validCode\" md-no-cache=\"true\" md-selected-item=\"selectedBatch\" md-search-text=\"searchBatch\" md-items=\"item in getBatches(searchBatch)\" md-item-text=\"item.BATCH_CD\" md-clear-button=\"false\" md-min-length=\"0\" ng-required=\"box.type.CODE != 'Startpop'\" md-select-on-match=\"true\" md-match-case-insensitive=\"true\" force-select> <md-item-template> <span md-highlight-text=\"searchBatch\">{{item.BATCH_CD}}</span> </md-item-template> </md-autocomplete> <div ng-messages=\"boxForm\" ng-if=\"boxForm.$error.forceSelect\"> <div> Please select an existing batch, or create a new one. </div> </div> </md-input-container> <md-input-container> <md-button ng-disabled=\"selectedBatch || !searchBatch\" ng-click=\"createBatch(searchBatch)\" class=\"md-primary\"> Create New Batch </md-button> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Species</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"boxSpecies\" aria-label=\"Species\" ng-change=\"getConversionFactors()\" ng-model=\"box.species\" ng-disabled=\"!validCode\" ng-required=\"box.type.CODE != 'Startpop'\"> <md-option ng-repeat=\"insect in allSpecies\" ng-value=\"insect\"> {{insect.SC_NAME}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"preType==1\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Strain</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"boxStrain\" aria-label=\"Box strain\" ng-model=\"box.strain\" ng-disabled=\"!validCode\" ng-required=\"box.type.CODE != 'Startpop'\"> <md-option ng-repeat=\"strain in strains\" ng-value=\"strain\" ng-selected=\"box.strain && box.strain.ID == strain.ID\"> {{strain.DESCRIPTION + \" (\" + strain.CODE + \")\"}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE == 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Originating box</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"boxParent\" aria-label=\"Originating box\" ng-disabled=\"!validCode\" ng-model=\"box.parent\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^[0-9]{5}$|^[a-z,A-Z]{2}[0-9]{2}[a-z,A-Z]{7}[0-9]{4}$/\" ng-change=\"findParent()\" style=\"text-transform:uppercase\" ng-required=\"box.type.CODE == 'Startpop'\"> <div ng-messages=\"boxForm.boxParent.$error\" ng-if=\"boxForm.$submitted || boxForm.boxParent.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Cocoon Net Weight</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"number\" step=\"any\" aria-label=\"Cocoon Net Weight\" name=\"cocoonNetWeight\" ng-disabled=\"!validCode\" min=\"0\" ng-model=\"box.cocoonNetWeight\" ng-change=\"checkCocoonAmount()\" ng-required=\"true\"> <div ng-messages=\"boxForm.cocoonNetWeight.$error\" ng-if=\"boxForm.$submitted || boxForm.cocoonNetWeight.$touched\"> <div ng-message=\"required\"> You must provide a cocoon net weight. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Conversion factor</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\" ng-show=\"!editConversion || box.type.CODE === 'Startpop'\"> <input flex aria-label=\"Conversion factor\" name=\"conversion_factor\" ng-disabled=\"!validCode\" ng-model=\"box.conversion_factor.CONV_FACTOR\" ng-required=\"!editConversion || box.type.CODE === 'Startpop'\" ng-change=\"checkCocoonAmount()\"> <div ng-messages=\"boxForm.conversion_factor.$error\" ng-if=\"boxForm.$submitted || boxForm.conversion_factor.$touched\"> <div ng-message=\"required\"> You must provide a conversion factor. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\" ng-show=\"editConversion && box.type.CODE !== 'Startpop'\"> <md-select name=\"conversion\" aria-label=\"Conversion factor\" ng-change=\"checkCocoonAmount()\" ng-model=\"box.conversion_factor\" ng-disabled=\"!validCode\" ng-required=\"editConversion && box.type.CODE !== 'Startpop'\"> <md-option ng-repeat=\"conversionFactor in conversionFactors\" ng-value=\"conversionFactor\"> {{conversionFactor.CONV_FACTOR}} [{{conversionFactor.ORGANIZATION_NAME}}] </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Cocoon amount</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"number\" aria-label=\"Cocoon amount\" name=\"cocoons\" ng-disabled=\"true\" min=\"0\" ng-model=\"box.cocoons\" ng-required=\"true\"> <div ng-messages=\"boxForm.cocoons.$error\" ng-if=\"boxForm.$submitted || boxForm.cocoons.$touched\"> <div ng-message=\"required\"> You must provide a cocoon amount. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"!editing && !hideCheckin\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Check in?</span> <md-checkbox class=\"pull-right-flex\" aria-label=\"Check in?\" ng-model=\"shouldCheckIn\"></md-checkbox> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeCodeInput\" aria-label=\"Fridge code input for check in\" ng-model=\"checkInFridgeCode\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$/\" ng-change=\"findFridge()\" style=\"text-transform:uppercase\" ng-disabled=\"!validCode || !shouldCheckIn\"> <div ng-messages=\"boxForm.fridgeCodeInput.$error\" ng-if=\"boxForm.$submitted || boxForm.fridgeCodeInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> </div> </form> <div class=\"form-section layout-padding\" ng-show=\"box.type.CODE != 'Startpop'\"> <div layout=\"row\"> <h3 class=\"no-caps\">Provenience</h3> </div> <form name=\"codeForm\" ng-submit=\"codeForm.$valid && addHouse()\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs flex=\"30\"> <input flex type=\"text\" name=\"houseCodeInput\" aria-label=\"House code\" ng-model=\"houseCode\" style=\"text-transform:uppercase\" ng-disabled=\"!validCode\"> <div ng-messages=\"codeForm.houseCodeInput.$error\" ng-if=\"codeForm.$submitted || codeForm.houseCodeInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> <div class=\"flex-align-middle\" flex-gt-xs flex=\"70\"> <span class=\"padding-bottom-20\">Scan house code to add to list</span> </div> </div> </form> <div layout=\"row\" layout-gt-md=\"row\" class=\"table-responsive\" flex=\"30\" ng-show=\"houses.length\"> <table class=\"table table-hover\"> <tr ng-repeat=\"house in houses\" valign=\"middle\"> <td> <md-input-container> <span class=\"uppercase\"> {{house.HOUSE_CD}} <md-button ng-click=\"removeHouse($index)\"><i class=\"material-icons\">clear</i></md-button></span> </md-input-container> </td> </tr> </table> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" ng-disabled=\"!boxForm.$valid\" ng-click=\"canBeSaved() && save()\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/box-panel.html',
    "<div class=\"box-detail\"> <div layout=\"row\"> <h3 class=\"no-caps\">{{box.type.ID == 1 ? 'Box' : 'Population'}}</h3> <div flex></div> <md-button ng-click=\"deleteBox()\" ng-disabled=\"deleteBoxDisabled\" class=\"md-primary no-caps\" restrict-access=\"BeeManagement Delete\">Delete</md-button> <md-button ng-click=\"editBox()\" class=\"md-primary no-caps\">Edit</md-button> <md-button ng-click=\"printBox(box)\" ng-show=\"box.type.ID == 1\" class=\"md-primary no-caps\">Print</md-button> </div> <table class=\"table\"> <tr> <th valign=\"middle\">ID</th> <td flex valign=\"bottom\">{{box.ID}}</td> <th valign=\"middle\">Source</th> <td flex valign=\"bottom\">{{box.sourceType.DESCRIPTION}}</td> </tr> <tr> <th valign=\"middle\">Code</th> <td flex valign=\"bottom\">{{box.BOX_CD}}</td> <th valign=\"middle\">Species</th> <td flex valign=\"bottom\">{{box.species.SC_NAME}}</td> </tr> <tr> <th valign=\"middle\">Strain</th> <td flex valign=\"bottom\">{{box.strain.CODE}}</td> <th valign=\"middle\">Organisation</th> <td flex valign=\"bottom\">{{box.ORGANISATION}}</td> </tr> <tr> <th ng-show=\"box.type.ID == 2\" valign=\"middle\">Originating box</th> <td flex ng-show=\"box.type.ID == 2\" valign=\"bottom\"> {{box.parent.BOX_CD}} </td> <th ng-show=\"box.type.ID != 2\"></th> <td flex ng-show=\"box.type.ID != 2\"></td> <th valign=\"middle\">Cocoon amount</th> <td flex valign=\"bottom\">{{box.AMOUNT | delimiter}}</td> </tr> <tr> <th valign=\"middle\">Status</th> <td flex valign=\"bottom\">{{box.status}}</td> <th valign=\"middle\">Status change</th> <td flex valign=\"bottom\"> {{box.statusChange | date:'yyyy-MM-dd H:mm:ss'}} </td> </tr> <tr ng-show=\"box.type.ID == 1 && box.status=='OUT'\"> <th valign=\"middle\"> Reason </th> <td flex valign=\"bottom\"> {{box.reason}} </td> <th ng-show=\"box.type.ID != 2\"></th> <td flex ng-show=\"box.type.ID != 2\"></td> </tr> </table> </div>"
  );


  $templateCache.put('views/box-provenience-list-directive.html',
    "<div layout=\"row\"> <h3 class=\"no-caps\">Provenience</h3> </div> <div layout=\"row\" layout-gt-md=\"row\" class=\"table-responsive\" flex=\"30\"> <table class=\"table table-hover\"> <tr ng-repeat=\"house in box.HOUSES\" valign=\"middle\"> <td> <md-input-container> <span class=\"uppercase\"> {{house.HOUSE_CD}} </span> </md-input-container> </td> </tr> </table> </div>"
  );


  $templateCache.put('views/box.html',
    "<md-button ng-click=\"backToSearch()\" class=\"md-primary\"><i class=\"material-icons\">search</i> back to search</md-button> <div box-panel box=\"box\"></div> <div class=\"row\">&nbsp;</div> <div temperature-chart box=\"box\" type=\"box.type.ID == 1 ? 'box' : 'population'\"></div> <div box-provenience-list-directive box=\"box\" ng-if=\"box.type.ID == 1 && box.HOUSES.length\"></div>"
  );


  $templateCache.put('views/boxes-modal.html',
    "<md-dialog aria-label=\"boxes\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 class=\"no-caps\">Edit fridges {{codesPretty}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"boxForm\" ng-submit=\"boxForm.$valid && canBeSaved() && save()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"!preType\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Type</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Type\" name=\"boxType\" ng-model=\"box.type\" placeholder=\"Multiple values\"> <md-option ng-repeat=\"boxType in boxTypes\" ng-value=\"boxType\"> {{boxType.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Source</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Source\" name=\"sourceType\" ng-model=\"box.sourceType\" placeholder=\"Multiple values\"> <md-option ng-repeat=\"sType in sourceTypes\" ng-value=\"sType\"> {{sType.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Batch</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-autocomplete aria-label=\"Batch\" md-no-cache=\"true\" md-selected-item=\"selectedBatch\" md-search-text=\"searchBatch\" md-items=\"item in getBatches(searchBatch)\" md-item-text=\"item.BATCH_CD\" md-clear-button=\"false\" md-min-length=\"0\"> <md-item-template> <span md-highlight-text=\"searchBatch\">{{item.BATCH_CD}}</span> </md-item-template> <md-not-found> No batches matching \"{{searchBatch}}\" were found. <a class=\"btn btn-xs btn-default\" role=\"button\" ng-click=\"createBatch(searchBatch)\">Create a new one!</a> </md-not-found> </md-autocomplete> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE != 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Species</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Species\" name=\"boxSpecies\" ng-model=\"box.species\" placeholder=\"Multiple values\"> <md-option ng-repeat=\"insect in allSpecies\" ng-value=\"insect\"> {{insect.SC_NAME}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\" ng-show=\"box.sourceType.CODE == 'Procurement'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Source Information</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Source information\" name=\"sourceText\" ng-model=\"box.SOURCE_TEXT\" type=\"text\" placeholder=\"Multiple values\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"box.type.CODE == 'Startpop'\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Originating box</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"boxParent\" aria-label=\"Originating box\" ng-model=\"box.parent\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(BC|bc)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(A|a)[0-9]{2}[a-z,A-Z]{2}[0-9,a-z,A-Z]{4}|^[a-z,A-Z]{2}[0-9]{2}[a-z,A-Z]{7}[0-9]{4}$/\" ng-change=\"findParent()\" style=\"text-transform:uppercase\" placeholder=\"Multiple values\"> <div ng-messages=\"boxForm.boxParent.$error\" ng-if=\"boxForm.$submitted || boxForm.boxParent.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Cocoon Net Weight</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"number\" name=\"cocoons\" aria-label=\"Cocoon amount\" min=\"0\" ng-model=\"box.weight\" placeholder=\"Multiple values\"> <div ng-messages=\"boxForm.weight.$error\" ng-if=\"boxForm.$submitted || boxForm.weight.$touched\"> <div ng-message=\"required\"> You must provide a net weight. </div> </div> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/boxmanagement-boxes-directive.html',
    "<div class=\"form-row md-no-momentum\" class=\"form-row md-no-momentum\" layout-gt-sm=\"row\" layout-align=\"space-between\"> <div layout=\"column\"> <div layout=\"row\"> <div layout-gt-xs=\"column\" id=\"box-search\" class=\"first product-search\" flex-gt-sm=\"50\" style=\"min-width: 290px\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"getBoxes()\">search</i> </md-icon> <input flex type=\"text\" aria-label=\"Box search input\" ng-model=\"boxQuery.q\" ng-model-options=\"{ debounce: 250 }\" ng-change=\"getBoxes()\" class=\"search-box\" placeholder=\"Search\"> </md-input-container> </div> </div> </div> <div layout=\"column\"> <div layout-gt-xs=\"row\" layout-align=\"end center\"> <md-button class=\"no-caps\" ng-click=\"addBox()\"> Create </md-button> <md-button class=\"no-caps\" ng-click=\"checkinItems(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Checkin\">Check In</md-button> <md-button class=\"no-caps\" ng-click=\"checkoutItems(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Checkout\">Check Out</md-button> <md-button class=\"no-caps\" ng-click=\"deleteBoxes(selected)\" ng-disabled=\"deleteBoxDisabled\" restrict-access=\"BeeManagement Delete\">Delete</md-button> <md-button class=\"no-caps\" ng-click=\"editBoxes(selected)\" ng-disabled=\"!selected.length\">Edit </md-button> <md-button class=\"no-caps\" ng-click=\"printBox(selected)\" ng-disabled=\"selected.length!=1\">Print </md-button> </div> </div> </div> <div layout-padding class=\"table-responsive row\"> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\"> <thead md-head md-order=\"boxQuery.sort\" md-on-reorder=\"getBoxes\" fix-head> <tr md-row> <th md-column md-order-by=\"BADM_BOXES_V.ID\">ID</th> <th md-column md-order-by=\"BADM_BOXES_V.BOX_CD\">Code</th> <th md-column md-order-by=\"BADM_ORGANISATIONS_V.NAME\">Organisation</th> <th md-column md-order-by=\"BADM_REF_COC_SOURCES_V.DESCRIPTION\">Source</th> <th md-column md-order-by=\"BADM_BATCHES_V.BATCH_CD\">Batch</th> <th md-column md-order-by=\"BADM_INSECTS_V.SC_NAME\">Species</th> <th md-column md-order-by=\"BADM_REF_STRAINS_V.CODE\">Strain</th> <th md-column md-order-by=\"BADM_BOX_CONTENTS_V.AMOUNT\">Amount</th> <th md-column md-order-by=\"BADM_REF_XFER_STATI_V.CODE\">Status</th> <th md-column md-order-by=\"BADM_FRIDGES_V.FRIDGE_CD\">Fridge</th> <th md-column md-order-by=\"BADM_FRIDGES_V.LOCATION\">Location</th> <th md-column md-order-by=\"MODIFIED\" ng-show=\"fridgeId\">Check in at</th> <th md-column md-order-by=\"MODIFIED_BY\" ng-show=\"fridgeId\">Check in by</th> <th md-column md-order-by=\"BADM_BOX_CONTENTS_V.CRE_AT\" ng-hide=\"fridgeId\"> Created at </th> <th md-column md-order-by=\"MODIFIED\" ng-hide=\"fridgeId\">Last Modified</th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"box\" md-select-id=\"box.ID\" md-on-select=\"toggleDeleteDisabled(selected)\" md-on-deselect=\"toggleDeleteDisabled(selected)\" md-auto-select ng-repeat=\"box in boxes\" ng-click=\"\" ng-dblclick=\"openBox(box.BOX_CD)\"> <td md-cell>{{box.ID}}</td> <td md-cell>{{box.BOX_CD}}</td> <td md-cell>{{box.ORGANISATION}}</td> <td md-cell>{{box.SOURCE}}</td> <td md-cell>{{box.BATCH_CD}}</td> <td md-cell>{{box.SPECIES}}</td> <td md-cell>{{box.STRAIN}}</td> <td md-cell>{{box.CUSTOM_AMOUNT}}</td> <td md-cell>{{box.STATUS}}</td> <td md-cell>{{box.FRIDGE_CD}}</td> <td md-cell>{{box.LOCATION}}</td> <td md-cell ng-show=\"fridgeId\">{{box.MODIFIED | date:'dd/MM/yyyy'}}</td> <td md-cell ng-show=\"fridgeId\">{{users[box.MODIFIED_BY.firstName]}}</td> <td md-cell ng-hide=\"fridgeId\">{{box.CRE_AT | date:'dd/MM/yyyy'}}</td> <td md-cell ng-hide=\"fridgeId\">{{box.MODIFIED | date:'dd/MM/yyyy'}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"boxQuery.per_page\" md-limit-options=\"pageLimitOptions\" md-page=\"boxQuery.page\" md-total=\"{{boxTotal}}\" md-page-select md-on-paginate=\"getBoxes\" md-boundary-links> </md-table-pagination> </div>"
  );


  $templateCache.put('views/boxmanagement-fridges-directive.html',
    "<div class=\"form-row md-no-momentum\" layout-gt-sm=\"row\" layout-align=\"space-between\"> <div layout=\"column\"> <div layout=\"row\"> <div layout-gt-xs=\"column\" id=\"fridge-search\" class=\"first product-search\" flex-gt-sm=\"50\" style=\"min-width: 290px\"> <md-input-container class=\"md-block\" md-no-float> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"getFridges()\">search</i> </md-icon> <input flex type=\"text\" aria-label=\"Fridge search input\" ng-model=\"fridgeQuery.q\" ng-model-options=\"{ debounce: 250 }\" ng-change=\"getFridges()\" class=\"search-box\" placeholder=\"Search\"> </md-input-container> </div> </div> </div> <div layout=\"column\"> <div layout=\"row\" layout-align=\"end center\"> <md-button class=\"no-caps\" ng-click=\"addFridge()\"> Create </md-button> <md-button class=\"no-caps\" ng-click=\"deleteFridges(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Delete\"> Delete </md-button> <md-button class=\"no-caps\" ng-click=\"editFridges(selected)\" ng-disabled=\"!selected.length\">Edit</md-button> </div> </div> </div> <div class=\"row table-responsive\" layout-padding> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\" ng-change=\"setVoucher\"> <thead md-head md-order=\"fridgeQuery.sort\" md-on-reorder=\"getFridges\"> <tr md-row> <th md-column md-order-by=\"BADM_FRIDGES_V.ID\">ID</th> <th md-column md-order-by=\"BADM_FRIDGES_V.FRIDGE_CD\">Code</th> <th md-column md-order-by=\"BADM_ORGANISATIONS_V.NAME\">Organisation</th> <th md-column md-order-by=\"BADM_FRIDGES_V.LOCATION\">Location</th> <th md-column md-order-by=\"BADM_FRIDGE_TEMPS_V.TEMPERATURE\"> Temperature </th> <th md-column md-order-by=\"BOX_COUNT_V.CNT\">Boxes</th> <th md-column md-order-by=\"STARTPOP_COUNT_V.POPULATIONS_COUNT\"> Startpops </th> <th md-column md-order-by=\"BADM_FRIDGES_V.UPD_AT\">Last modified</th> <th md-column md-order-by=\"BADM_FRIDGES_V.UPD_BY\">Modified by</th> </tr> </thead> <tbody md-body> <tr ng-class=\"md-table-row\" md-row md-select=\"fridge\" md-select-id=\"fridge.ID\" md-auto-select ng-repeat=\"fridge in fridges\" ng-click=\"\" ng-dblclick=\"openFridge(fridge.FRIDGE_CD)\"> <td md-cell>{{fridge.ID}}</td> <td md-cell>{{fridge.FRIDGE_CD}}</td> <td md-cell>{{fridge.ORGANISATION}}</td> <td md-cell>{{fridge.LOCATION}}</td> <td md-cell>{{fridge.TEMPERATURE}}</td> <td md-cell>{{fridge.BOXES}}</td> <td md-cell>{{fridge.START_POPS_COUNT}}</td> <td md-cell>{{fridge.MODIFIED | date:'dd/MM/yyyy'}}</td> <td md-cell>{{users[fridge.MODIFIED_BY].firstName}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"fridgeQuery.per_page\" md-limit-options=\"pageLimitOptions\" md-page=\"fridgeQuery.page\" md-total=\"{{fridgeTotal}}\" md-page-select md-on-paginate=\"getFridges\" md-boundary-links> </md-table-pagination> </div>"
  );


  $templateCache.put('views/boxmanagement-startpops-directive.html',
    "<div class=\"form-row md-no-momentum\" layout-gt-sm=\"row\" layout-align=\"space-between\"> <div layout=\"column\"> <div layout=\"row\"> <div layout-gt-xs=\"column\" id=\"startpop-search\" class=\"first product-search\" flex-gt-sm=\"50\" style=\"min-width: 290px\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"getStartpops()\">search</i> </md-icon> <input flex type=\"text\" aria-label=\"Population search input\" ng-model=\"startpopQuery.q\" ng-model-options=\"{ debounce: 250 }\" ng-change=\"getStartpops()\" class=\"search-box\" placeholder=\"Search\"> </md-input-container> </div> </div> </div> <div layout=\"column\"> <div layout=\"row\" layout-align=\"end center\"> <md-button class=\"no-caps\" restrict-access=\"BeeManagement Create\"> <a ui-sref=\"managementCreate\"> Create </a> </md-button> <md-button class=\"no-caps\" ng-click=\"checkinItems(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Checkin\">Check In </md-button> <md-button class=\"no-caps\" ng-click=\"checkoutItems(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Checkout\">Check Out </md-button> <md-button class=\"no-caps\" ng-click=\"deleteStartpops(selected)\" ng-disabled=\"!selected.length\" restrict-access=\"BeeManagement Delete\">Delete </md-button> <md-button class=\"no-caps\" ng-click=\"editStartpops(selected)\" ng-disabled=\"!selected.length\">Edit</md-button> </div> </div> </div> <div layout-padding class=\"table-responsive row\"> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\"> <thead md-head md-order=\"startpopQuery.sort\" md-on-reorder=\"getStartpops\" fix-head> <tr md-row> <th md-column md-order-by=\"BADM_STARTPOPS_V.ID\">ID</th> <th md-column md-order-by=\"BADM_STARTPOPS_V.STARTPOP_CD\">Code</th> <th md-column md-order-by=\"BADM_ORGANISATIONS_V.NAME\">Organisation</th> <th md-column md-order-by=\"BADM_REF_COC_SOURCES_V.DESCRIPTION\">Source</th> <th md-column md-order-by=\"BADM_BOXES_V.BOX_CD\">Originating Box</th> <th md-column md-order-by=\"BADM_BATCHES_V.BATCH_CD\">Batch</th> <th md-column md-order-by=\"BADM_INSECTS_V.SC_NAME\">Species</th> <th md-column md-order-by=\"BADM_REF_STRAINS_V.CODE\">Strain</th> <th md-column md-order-by=\"BADM_STARTPOPS_V.AMOUNT\">Amount</th> <th md-column md-order-by=\"BADM_REF_XFER_STATI_V.CODE\">Status</th> <th md-column md-order-by=\"BADM_FRIDGES_V.FRIDGE_CD\">Fridge</th> <th md-column md-order-by=\"MODIFIED\"> <span ng-hide=\"fridgeId\">Last Modified</span><span ng-show=\"fridgeId\">Check in at</span> </th> <th md-column md-order-by=\"MODIFIED_BY\"> <span ng-hide=\"fridgeId\">Modified</span><span ng-show=\"fridgeId\">Check in</span> by </th> </tr> </thead> <tbody md-body> <tr ng-class=\"md-table-row\" md-row md-select=\"startpop\" md-select-id=\"startpop.ID\" md-auto-select ng-repeat=\"startpop in startpops\" ng-click=\"\" ng-dblclick=\"openBox(startpop.BOX_CD)\"> <td md-cell>{{startpop.ID}}</td> <td md-cell>{{startpop.BOX_CD}}</td> <td md-cell>{{startpop.ORGANISATION}}</td> <td md-cell>{{startpop.SOURCE}}</td> <td md-cell>{{startpop.PARENT_CODE}}</td> <td md-cell>{{startpop.BATCH_CD}}</td> <td md-cell>{{startpop.SPECIES}}</td> <td md-cell>{{startpop.STRAIN}}</td> <td md-cell>{{startpop.AMOUNT}}</td> <td md-cell>{{startpop.STATUS}}</td> <td md-cell>{{startpop.FRIDGE_CD}}</td> <td md-cell>{{startpop.MODIFIED | date:'dd/MM/yyyy'}}</td> <td md-cell>{{users[startpop.MODIFIED_BY].firstName}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"startpopQuery.per_page\" md-limit-options=\"pageLimitOptions\" md-page=\"startpopQuery.page\" md-total=\"{{startpopTotal}}\" md-page-select md-on-paginate=\"getStartpops\" md-boundary-links> </md-table-pagination> </div>"
  );


  $templateCache.put('views/boxmanagement.html',
    "<div restrict-access=\"BeeManagement Search\"> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height> <md-tab id=\"fridge-tab\"> <md-tab-label>Fridge</md-tab-label> <md-tab-body> <div class=\"row results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <boxmanagement-fridges-directive class=\"row\" season=\"season\" users=\"users\"> </boxmanagement-fridges-directive> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"box-tab\"> <md-tab-label>Box</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <boxmanagement-boxes-directive class=\"row\" season=\"season\" users=\"users\"> </boxmanagement-boxes-directive> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"startpop-tab\"> <md-tab-label>Population</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <boxmanagement-startpops-directive class=\"row\" season=\"season\" users=\"users\"> </boxmanagement-startpops-directive> </div> </div> </md-tab-body> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/client-contacts-directive.html',
    "<div layout=\"row\" layout-align=\"end start\" style=\"height:35px\"> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"addNewContact()\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Contact <div class=\"md-ripple-container\"></div> </md-button> </div> <form name=\"contactForm\"> <md-table-container> <table md-table md-progress=\"promise\" ng-show=\"additionalContacts.length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column md-order-by=\"id\" width=\"5\">ID</th> <th md-column md-order-by=\"first_name\" width=\"20\">FirstName</th> <th md-column md-order-by=\"last_name\" width=\"20\">LastName</th> <th md-column md-order-by=\"email\" width=\"25\">Email</th> <th md-column width=\"5\">Action</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"(sortedIndex, contact) in additionalContacts | orderBy:query.order\"> <td md-cell>{{contact.id}}</td> <td md-cell>{{contact.first_name}}</td> <td md-cell>{{contact.last_name}}</td> <td md-cell>{{contact.email}}</td> <td md-cell> <span class=\"action-primary-true\"> <i class=\"material-icons action-icon\" ng-click=\"editRow(contact)\">edit</i> </span> <span class=\"md-warn\"> <i class=\"material-icons action-icon\" ng-click=\"deleteRow(contact.id)\">remove</i> </span> </td> </tr> </tbody> </table> </md-table-container> </form>"
  );


  $templateCache.put('views/client-cultures-directive.html',
    "<div layout=\"row\" layout-align=\"end start\" style=\"height:35px\"> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"addRow()\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Culture <div class=\"md-ripple-container\"></div> </md-button> </div> <form name=\"cultureForm\"> <md-table-container> <table md-table md-progress=\"promise\" ng-show=\"cultures.length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column md-order-by=\"cultureType\" width=\"40\">CultureType</th> <th md-column md-order-by=\"size\" width=\"40\">Size</th> <th md-column width=\"20\">Action</th> </tr> </thead> <tbody md-body> <tr ng-class=\"{selectedRow:selectedRowClass[item.ID]}\" md-row md-select=\"culture\" md-select-id=\"culture.ID\" md-on-select=\"setRowClass\" md-on-deselect=\"setRowClass\" ng-repeat=\"(sortedIndex, culture) in cultures\" ng-keyup=\"removeCultureFocus($event, $index)\"> <td md-cell> <span ng-if=\"!culture.editable\">{{culture.cultureType}}</span> <span ng-if=\"culture.editable\"> <md-autocomplete class=\"no-loader\" md-no-cache=\"true\" md-require-match=\"true\" ng-required=\"culture.size\" md-select-on-match=\"true\" md-selected-item=\"selectedCulture.selectedCultureType\" md-search-text=\"selectedCulture.searchCultureTypeText\" md-selected-item-change=\"selectedCultureTypeChange(cultureType)\" md-input-name=\"autocompleteField\" md-items=\"cultureType in querySearch(selectedCulture.searchCultureTypeText, 'code')\" md-item-text=\"cultureType.code\" md-min-length=\"0\" md-floating-label=\"Culture type\" md-no-stretch=\"true\" flex-gt-xs ng-required=\"true\"> <md-item-template>{{cultureType.code}}</md-item-template> <div ng-messages=\"cultureForm.autocompleteField.$error\" ng-if=\"cultureForm.autocompleteField.$touched\"> <div ng-message=\"required\">This field is required.</div> <div ng-message=\"md-require-match\"> Please select an existing culture type. </div> </div> <md-not-found> No culture type matching \"{{selectedCulture.searchCultureTypeText}}\" was found. </md-not-found> </md-autocomplete> </span> </td> <td md-cell> <span ng-if=\"!culture.editable\">{{culture.size}}</span> <span ng-if=\"culture.editable\"> <md-input-container class=\"md-block\"> <label>Size (ha)</label> <input flex type=\"number\" name=\"sizer\" ng-model=\"culture.size\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" flex-gt-xs required> </md-input-container> </span> </td> <td md-cell> <span class=\"action-primary-{{cultureForm.$valid && !isEditing }}\"> <i class=\"material-icons action-icon\" ng-click=\"editRow(culture)\" ng-show=\"!culture.editable\">edit</i> </span> <span class=\"action-primary-{{cultureForm.$valid && culture.editable}}\"> <i class=\"material-icons action-icon done\" ng-click=\"cultureForm.$valid && saveRow(culture)\" ng-class=\"{'disabled':cultureForm.$invalid}\" ng-show=\"culture.editable\"> done </i> </span> <span class=\"md-warn\"> <i class=\"material-icons action-icon\" ng-click=\"deleteRow(culture.ID)\">remove</i> </span> </td> </tr> </tbody> </table> </md-table-container> </form>"
  );


  $templateCache.put('views/client-notes-directive.html',
    "<div layout=\"row\" layout-align=\"start center\" class=\"note-filters\"> <md-input-container class=\"md-block note-filter-select\"> <label>Filter category</label> <md-select ng-model=\"noteFilters.category\" ng-change=\"noteFilters.tags = []\" aria-label=\"filter category\"> <md-option ng-value=\"null\">All</md-option> <md-option ng-repeat=\"category in refTypes.CATEGORIES\" ng-value=\"category.ID\"> <span class=\"note-category-dot\" style=\"background:{{categoryDisplay[category.ID].colour}}\"> </span> {{category.DESCRIPTION}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block note-filter-select\"> <label>Filter tags</label> <md-select ng-model=\"noteFilters.tags\" multiple aria-label=\"filter tags\"> <md-option ng-repeat=\"tag in refTypes.TAGS | filter:filterTagOption | orderBy:'DESCRIPTION'\" ng-value=\"tag.ID\"> {{tag.DESCRIPTION}} </md-option> </md-select> </md-input-container> <div flex></div> <md-button class=\"newItemButton md-primary\" type=\"button\" ng-click=\"addRow()\"> <i class=\"material-icons ng-scope\">add</i>&nbsp;Note <div class=\"md-ripple-container\"></div> </md-button> </div> <form name=\"noteForm\"> <md-table-container> <table md-table md-progress=\"promise\" class=\"compressed\" ng-show=\"notes.length\"> <thead md-head md-order=\"query.order\"> <tr md-row> <th md-column width=\"70\" md-order-by=\"\">Date</th> <th md-column width=\"6\" md-order-by=\"\">Category</th> <th md-column width=\"5\" md-order-by=\"\">Tags</th> <th md-column width=\"5\" md-order-by=\"\">House Code</th> <th md-column width=\"6\" md-order-by=\"\">Season</th> <th md-column fx-flex md-order-by=\"\">Note</th> <th md-column width=\"5\" md-order-by=\"\">Executed</th> <th width=\"4\" md-column md-order-by=\"\">Action</th> </tr> </thead> <tbody md-body> <tr ng-class=\"{selectedRow:selectedRowClass[item.ID], 'note-completed':note.COMPLETED_AT}\" md-row md-select=\"note\" md-select-id=\"note.ID\" md-on-select=\"setRowClass\" md-on-deselect=\"setRowClass\" ng-repeat=\"note in notes | filter:filterNotes\" ng-keyup=\"removeNoteFocus($event, note)\"> <td md-cell> <span ng-if=\"note.UPD_AT || note.CRE_AT\">{{(note.UPD_AT || note.CRE_AT) | parseDate | date:'yyyy&#8209;MM&#8209;dd'}}</span> <span ng-if=\"!note.UPD_AT && !note.CRE_AT\">-</span> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\"> <span translate=\"general.modified_by\">Modified By:</span> <span>{{note.displayName}}</span> <br> <span translate=\"general.modified_at\">Modified At:</span> <span>{{note.UPD_AT || note.CRE_AT}}</span> </md-tooltip> </td> <td md-cell> <md-input-container class=\"md-block\" ng-if=\"note.editable\" flex> <md-select name=\"category\" ng-model=\"note.category\" ng-model-options=\"{trackBy: '$value.ID'}\" tabindex=\"{{$index+5}}\" ng-change=\"populateTags(note.category, note);\" required aria-label=\"category\"> <md-option ng-repeat=\"category in refTypes.CATEGORIES\" ng-value=\"category\" ng-selected=\"category.ID==note.CATEGORY_ID\"> <span class=\"note-category-dot\" style=\"background:{{categoryDisplay[category.ID].colour}}\"> </span> {{category.DESCRIPTION}} </md-option> </md-select> </md-input-container> <div class=\"note-label note-category\" style=\"background:{{categoryDisplay[note.CATEGORY_ID].colour}}\" ng-if=\"!note.editable\"> {{categoryDisplay[note.CATEGORY_ID].text}} </div> </td> <td md-cell> <md-input-container class=\"md-block\" flex ng-if=\"note.editable\"> <md-select name=\"tags\" ng-model=\"note.TAGS\" ng-model-options=\"{trackBy: '$value.ID'}\" tabindex=\"{{$index+6}}\" multiple md-on-open=\"selectOpened = true\" md-on-close=\"selectOpened = false\" ng-disabled=\"!note.category\" required> <md-option ng-repeat=\"tag in refTypes.tagList | orderBy:'DESCRIPTION'\" ng-value=\"tag\" ng-selected=\"isChecked(note.TAGS,'ID',tag.ID)\"> {{tag.DESCRIPTION}} </md-option> </md-select> </md-input-container> <div class=\"note-label note-tags\" ng-repeat=\"tag in note.TAGS | orderBy:'DESCRIPTION'\" ng-if=\"!note.editable\"> {{tag.CODE}} </div> </td> <td md-cell> <md-input-container class=\"md-block\" flex-gt-xs ng-if=\"note.editable\"> <md-select name=\"house\" ng-model=\"note.house\" ng-model-options=\"{trackBy: '$value.ID'}\" tabindex=\"{{$index+7}}\" ng-disabled=\"!clientProducts.length\"> <md-option ng-repeat=\"house in clientProducts\" ng-value=\"house\" ng-selected=\"house.ID==note.HOUSE_ID\">{{house.code}}</md-option> </md-select> </md-input-container> <span ng-if=\"!note.editable\"> {{getHouseCode(note.HOUSE_ID)}} </span> </td> <td md-cell> <md-input-container class=\"md-block\" flex-gt-xs ng-if=\"note.editable\"> <input type=\"number\" name=\"season\" ng-model=\"note.SEASON\" min=\"2000\" max=\"2100\" step=\"1\" tabindex=\"{{$index+8}}\" aria-label=\"season\"> </md-input-container> <span ng-if=\"!note.editable\">{{note.SEASON || '-'}}</span> </td> <td md-cell> <md-input-container class=\"md-block\" flex-gt-xs ng-if=\"note.editable\"> <textarea flex name=\"keywords\" ng-model=\"note.NOTE\" tabindex=\"{{$index+9}}\"></textarea> </md-input-container> <span ng-if=\"!note.editable\">{{note.NOTE}}</span> </td> <td md-cell class=\"note-completed-cell\"> <md-checkbox class=\"note-completed-checkbox\" aria-label=\"executed\" ng-checked=\"!!note.COMPLETED_AT\" ng-click=\"toggleCompleted(note)\" ng-disabled=\"!note.ID || isEditing\"></md-checkbox> <md-tooltip ng-if=\"note.COMPLETED_AT\" md-direction=\"top\"> Executed: {{note.COMPLETED_AT | parseDate | date:'yyyy-MM-dd'}} </md-tooltip> </td> <td md-cell> <span class=\"action-primary-{{noteForm.$valid && !isEditing }}\"> <i class=\"material-icons action-icon\" ng-click=\"editRow(note)\" ng-show=\"!note.editable\">edit</i> </span> <span class=\"action-primary-{{noteForm.$valid && note.editable}}\"> <i class=\"material-icons action-icon done\" ng-click=\"noteForm.$valid && saveRow(note)\" ng-class=\"{'disabled':noteForm.$invalid}\" ng-show=\"note.editable\"> done </i> </span> <span class=\"md-warn\"> <i class=\"material-icons action-icon\" ng-click=\"deleteRow(note.ID)\">remove</i> </span> </td> </tr> </tbody> </table> </md-table-container> </form>"
  );


  $templateCache.put('views/client-notes-modal.html',
    "<md-dialog aria-label=\"notes\" flex=\"100\" flex-gt-sm=\"90\" flex-gt-md=\"80\" ng-keypress=\"removeNoteFocus($event)\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>Customer Notes</h1> <div flex></div> <md-button class=\"md-icon-button\" ng-click=\"close()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <br> <div client-notes-directive client-id=\"clientID\" client-products=\"clientProducts\" has-notes=\"hasNotes\" is-blacklisted=\"isBlacklisted\" active-code=\"activeCode\"></div> <div layout=\"row\" layout-align=\"end\"> <md-button ng-click=\"close() \" class=\"md-primary\">Done</md-button> </div> </md-dialog>"
  );


  $templateCache.put('views/client-search.html',
    "<form ng-submit=\"submit(query)\" name=\"accountSearchFrorm\" width=\"100%\"> <div layout=\"row\" layout-align=\"center center\" md-autocomplete-snap=\"width\"> <md-icon class=\"search-img\"><i class=\"material-icons\" style=\"position: relative;top: -12px\" ng-click=\"search()\">search</i></md-icon> <md-autocomplete md-no-cache=\"true\" md-search-text=\"query\" md-input-name=\"autocompleteField\" md-items=\"account in search(query)\" md-item-text=\"account.name\" md-selected-item=\"selectedItem\" md-selected-item-change=\"selectedAccount(account)\" md-min-length=\"3\" md-floating-label=\"{{wbpFloatingLabel}}\" md-clear-button=\"true\" md-delay=\"400\" md-menu-class=\"wbp-autocomplete\" flex> <md-item-template> <div ng-show=\"account.name\"> <p> <i class=\"material-icons\" ng-if=\"account.type != 'PRIVATE'\"> corporate_fare </i> <i class=\"material-icons\" ng-if=\"account.type == 'PRIVATE'\">home</i> <strong> {{account.name}} </strong> </p> <p ng-bind-html=\"findBillingAddress(account)\" style=\"margin-left:18px; min-height:3rem\"></p> <p ng-bind-html=\"findBillingContact(account).email\" style=\"margin-left:18px; min-height:3rem\"></p> </div> <div ng-show=\"!account.name\"> <strong>{{account.code}}</strong> (No Account) </div> <div class=\"clearfix\"></div> </md-item-template> <md-not-found> No accounts found. </md-not-found> </md-autocomplete> </div> </form>"
  );


  $templateCache.put('views/client-tabs.html',
    "<div layout=\"column\" ng-class=\"{'blocked': client.is_blocked}\"> <div layout=\"row\" layout-align=\"start end\" layout-gap=\"10px\" layout-padding> <span ng-if=\"client.type == 'PRIVATE'\" style=\"font-size: 25px; color:#666; padding:0; margin:0; line-height:25px\"> <i class=\"material-icons\">home</i> </span> <span ng-if=\"client.type == 'COMPANY'\" style=\"font-size: 25px; color:#666; padding:0; margin:0; line-height:25px\"> <i class=\"material-icons\">corporate_fare</i> </span> <h3 style=\"margin-bottom: 0;padding-bottom: 0\"> {{client.name}} <i class=\"material-icons\" ng-show=\"client.is_blocked\">not_interested</i> </h3> <span style=\"margin-bottom: 0; padding-bottom: 0; font-size: 12px; line-height: 1rem\">{{client.organisation.name}}</span> </div> <md-tabs md-dynamic-height class=\"account-tabs\" md-selected=\"selectedTabIndex\"> <md-tab label=\"Summary\"> <md-content class=\"md-padding\" flex layout> <account-summary client=\"client\" client-products=\"clientProducts\" selected-tab-index=\"selectedTabIndex\" flex></account-summary> </md-content> </md-tab> <md-tab> <md-tab-label>Notes <span ng-if=\"hasNotes\"><i class=\"material-icons hasFlagDot\">lens</i></span></md-tab-label> <md-tab-body> <md-content class=\"md-padding\"> <div client-notes-directive client-id=\"client.id\" client-products=\"clientProducts\" has-notes=\"hasNotes\" active-code=\"\"></div></md-content> </md-tab-body> </md-tab> <md-tab ng-if=\"client.isFarmer\"> <!--\t\t<md-tab ng-if=\"isFarmer\">--> <md-tab-label>Cultures <span ng-if=\"!hasCultures\"><i class=\"material-icons hasFlagDot\">lens</i></span></md-tab-label> <md-tab-body><md-content class=\"md-padding\"> <div client-cultures-directive client-id=\"client.id\" has-cultures=\"hasCultures\"></div> </md-content></md-tab-body> </md-tab> <md-tab label=\"Additional Contacts\"> <md-content class=\"md-padding\"> <div client-contacts-directive contacts=\"client.contacts\" client-id=\"client.id\"></div> </md-content> </md-tab> <md-tab label=\"Additional Addresses\"> <md-content class=\"md-padding\"> <div badm-address addresses=\"client.addresses\"></div> </md-content> </md-tab> <md-tab label=\"History\" md-on-select=\"onHistoryTab=true\" md-on-deselect=\"onHistoryTab=false\"> <md-content class=\"md-padding\"> <div history-directive client-id=\"client.id\" contacts=\"client.contacts\" on-history-tab=\"onHistoryTab\"></div> </md-content> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/client.html',
    "<!--<div md-button href=\"#/beehome/account\" class=\"md-primary\"><i class=\"material-icons\">search</i> New search</div>--> <div style=\"padding-right: 50px\"> <div client-tabs client=\"clientInfo\" client-products=\"clientProducts\" primary-contact=\"primaryContact\" show-edit=\"true\"></div> <div product-details client=\"clientInfo\" client-products=\"clientProducts\" default-address=\"defaultAddress\" users=\"$resolve.users\" selected-products=\"selectedProducts\"></div> <md-tabs md-dynamic-height ng-if=\"clientProducts.length\"> <md-tab label=\"Harvest data\" ng-if=\"selectedProducts.length==1 && selectedProducts[0].history.length\"> <md-content class=\"md-padding\"> <div product-history ng-show=\"selectedProducts[0].history.length\" product=\"selectedProducts[0]\" restrict-access=\"Product History\"></div> </md-content> </md-tab> <md-tab label=\"Orders\"> <md-content class=\"md-padding\"> <div beehome-orders client-id=\"clientInfo.id\" house-id=\"selectedProducts[0].ID\" organisations=\"$resolve.organisations\" users=\"$resolve.users\" restrict-access=\"BeeStarter\"></div> </md-content> </md-tab> <md-tab label=\"Vouchers\"> <md-content class=\"md-padding\"> <div beehome-account-vouchers client-id=\"clientInfo.id\" restrict-access=\"BeeStarter\"></div> </md-content> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/confirm-dialog.html',
    "<md-dialog aria-label=\"delivery\" flex-gt-sm=\"80\" flex-gt-lg=\"60\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>Please confirm</h1> </div> </md-toolbar> <div layout-gt-xs=\"row \" layout-padding> <p>Are you sure you want to create a code without a customer?</p> </div> <div layout-gt-xs=\"row \" class=\"layout-gt-xs-row pull-right\" layout-padding> <div flex></div> <md-button ng-click=\"cancel() \" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button class=\"md-primary\" ng-click=\"confirm()\">Confirm</md-button> </div> </md-dialog>"
  );


  $templateCache.put('views/confirmmodal.html',
    "<div class=\"modal-content\"> <div class=\"modal-header\"> <h4>{{title}}</h4> </div> <div class=\"modal-body\"> <p ng-bind-html=\"message\" class=\"text-center\"></p> </div> <div class=\"modal-footer\"> <a type=\"submit\" class=\"btn btn-danger\" data-dismiss=\"modal-content\" ng-click=\"cancel()\">NO</a> <a type=\"submit\" class=\"btn btn-success\" data-dismiss=\"modal-content\" ng-click=\"accept()\">YES</a> </div> </div>"
  );


  $templateCache.put('views/contact.form.html',
    "<ng-form name=\"contactForm\"> <div layout-gt-xs=\"row\" layout-padding> <!-- firstname --> <md-input-container class=\"md-block\" flex-gt-xs=\"50\"> <label class=\"input-placeholder\">Firstname</label> <input name=\"firstname\" type=\"text\" ng-model=\"contact.first_name\" tabindex=\"1\" focus-me=\"true\" ng-required=\"clientType!=='COMPANY'\"> </md-input-container> <!-- lastname --> <md-input-container class=\"md-block\" flex-gt-xs=\"50\"> <label class=\"input-placeholder\">Lastname</label> <input name=\"lastname\" type=\"text\" ng-model=\"contact.last_name\" tabindex=\"2\" ng-required=\"clientType!=='COMPANY'\"> </md-input-container> </div> <div layout-gt-xs=\"row\" layout-padding> <!-- email --> <md-input-container class=\"md-block\" flex> <label class=\"input-placeholder\">Email</label> <input name=\"email\" type=\"text\" ng-model=\"contact.email\" tabindex=\"3\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"contactForm.email.$dirty && checkContactExists('email', contact.email)\" ng-required=\"contact.mailing_preference.toUpperCase() == 'EMAIL'\"> <span ng-messages=\"contactForm.email.$error\"> <span ng-message=\"pattern\">Please enter a valid Email address.</span> <span ng-message=\"required\">An Email Address is required</span> <span ng-message=\"exists\">A contact with the entered Email Address already exists</span> </span> </md-input-container> <md-switch class=\"md-warn\" ng-model=\"contact.mailing_preference\" ng-true-value=\"'PAPER'\" ng-false-value=\"'EMAIL'\" flex-gt-xs=\"10\"> Paper <md-tooltip md-direction=\"top\" class=\"tooltip-multiline\"> Select this option if the client prefers to receive paper based mails.<br> (Grey means they will receive them via email) </md-tooltip> </md-switch> <!-- Mobile Phone --> <md-input-container class=\"md-block\" flex-gt-xs=\"50\"> <label class=\"md-no-float\" style=\"font-size: 10px\"> Mobile phone </label> <input id=\"phone\" name=\"phone\" ng-intl-tel-input type=\"tel\" ng-model=\"contact.phone_mobile\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"checkContactExists('phone', contact.phone_mobile)\" data-initial-country=\"{{defaultCountry}}\" tabindex=\"5\"> <span ng-messages=\"contactForm.phone.$error\"> <span ng-message=\"pattern\">Please enter a valid phone number.</span> <span ng-message=\"exists\"> A contact with the entered phone number already exists. </span> <span ng-message=\"ngIntlTelInput\">Please enter a valid phone number.</span> </span> </md-input-container> </div> <div layout-gt-xs=\"row\" layout-padding> <!-- Language --> <md-input-container class=\"md-block app-select\" flex-gt-xs layout-align=\"start end\"> <label for=\"lang\">Language</label> <md-select name=\"lang\" ng-model=\"contact.language\" tabindex=\"9\" required> <md-option ng-repeat=\"language in languages\" ng-value=\"language.code\" ng-selected=\"getInitialLanguage(language.code)\"> {{language.description}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block app-select\" flex-gt-xs layout-align=\"start end\"> <label>Birthday</label> <md-datepicker name=\"birthday\" ng-model=\"contact.birthday\" md-placeholder=\"Birthday\" tabindex=\"10\"></md-datepicker> </md-input-container> </div> </ng-form>"
  );


  $templateCache.put('views/contact.modal.html',
    "<md-dialog id=\"contact-dialog\" flex=\"90\" ng-submit=\"contactFormValid && save()\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout=\"row\" layout-padding layout-align=\"space-between\"> <h1 ng-if=\"contact.id\">Contact {{contact.id}}</h1> <h1 ng-if=\"!contact.id\">New Contact</h1> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content layout-padding id=\"toaster\"> <form name=\"contactForm\"> <div contact-form contact=\"contact\"></div> <div layout=\"row\" layout-align=\"end start\"> <md-button ng-click=\"cancel()\" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" ng-show=\"!showError\" ng-disabled=\"!contactForm.$valid\" ng-click=\"save()\">Save</md-button> </div> </form> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/create-boxes-fridge-modal.html',
    "<md-dialog aria-label=\"fridge-check-in\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 class=\"no-caps\">Check In Fridge</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"fridgeForm\" ng-submit=\"fridgeForm.$valid && validFridgeCode && save()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-show=\"!editing\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Fridge</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeCodeInput\" ng-model=\"checkInFridgeCode\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$/\" ng-change=\"findFridge()\" style=\"text-transform:uppercase\"> <div ng-messages=\"fridgeForm.fridgeCodeInput.$error\" ng-if=\"fridgeForm.$submitted || fridgeForm.fridgeCodeInput.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/createboxes.html',
    "<div restrict-access=\"BeeManagement Create\"> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height> <md-tab id=\"codes-tab\"> <md-tab-label>Codes</md-tab-label> <md-tab-body> <div class=\"row results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div flex-gt-xs> <form name=\"codeForm\" ng-submit=\"codeForm.$valid && checkCodes()\" class=\"padding-top-20\"> <md-input-container class=\"md-block\"> <input id=\"scannerInput\" type=\"text\" name=\"scannerInput\" ng-model=\"scannedcode\" focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(BC|bc)[0-9]{2}[0-9,a-z,A-Z]{5}$|^(A|a)[0-9]{2}[a-z,A-Z]{2}[0-9,a-z,A-Z]{4}$/\" style=\"text-transform: uppercase\" placeholder=\"Scan population code\"> <div ng-messages=\"boxForm.$error\" ng-if=\"boxForm.$submitted || boxForm.code-$index.$touched\"> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </form> </div> <md-button ng-click=\"completeCodes()\" class=\"md-primary md-raised max-height-20\" ng-disabled=\"!codes.length\">Done</md-button> <div flex></div> </div> <div layout=\"row\"> <h3 class=\"no-caps\">{{codes.length}} codes scanned</h3> </div> <div layout=\"row\" layout-gt-md=\"row\" class=\"table-responsive\" flex=\"30\" ng-show=\"codes.length\"> <table class=\"table table-hover\"> <thead> <tr> <th>Code</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"code in codes\" valign=\"middle\"> <td> <md-input-container> <span class=\"uppercase\"> {{code}} <md-button ng-click=\"removeBox($index)\"><i class=\"material-icons\">clear</i></md-button></span> </md-input-container> </td> </tr> </tbody> </table> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"settings-tab\" ng-disabled=\"!codes.length\"> <md-tab-label>Settings</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\" layout-padding> <div startpop-form valid=\"boxFormValid\" box=\"boxInfo\"></div> <div layout=\"row\"> <div flex></div> <md-button class=\"md-primary\" aria-label=\"Done\" ng-click=\"gotoConfirm()\" ng-disabled=\"!boxFormValid\">Done</md-button> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"confirm-tab\" ng-disabled=\"!codes.length || !boxFormValid\"> <md-tab-label>Confirm</md-tab-label> <md-tab-body> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <div layout=\"row\"> <div layout-padding class=\"table-responsive\" flex=\"40\"> <h3 class=\"no-caps\">{{codes.length}} population will be created</h3> <h3 class=\"no-caps\">Check the populations you want to check in</h3> <div layout=\"row\"> <table id=\"box-table\" class=\"table table-hover\" extended-table data-model=\"box\" data-row-id=\"{{confirmRowID}}\" data-clickable=\"false\" data-checkboxes=\"true\" data-columns-data=\"{{boxColumns}}\" data-ordering=\"false\" data-paging=\"false\" flex=\"30\"> <thead> <tr> <th>Check In?</th> <th>Code</th> </tr> </thead> </table> </div> </div> <md-button ng-click=\"confirmCreate()\" class=\"md-primary md-raised max-height-20\">Done</md-button> </div> <div flex></div> </div> </div> </md-tab-body> </md-tab> </md-tabs> </div>"
  );


  $templateCache.put('views/customer-exist-modal.html',
    "<md-dialog id=\"customer-dialog\" aria-label=\"delivery\" flex-gt-sm=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>Duplicate Warning</h1> <div flex></div> </div> </md-toolbar> <div layout-gt-xs=\"row \" class=\"layout-gt-xs-row\" layout-padding> <table class=\"table table-hover\"> <tr> <th>ID</th> <th>First Name</th> <th>Last Name</th> <th>Company</th> <th>Address Line 1</th> <th>PostalCode</th> <th>City</th> <th>Country</th> </tr> <tr ng-repeat=\"existing in customer\" ng-click=\"selectCustomer($index)\" class=\"customer-line customer-line{{$index}}\" ng-class=\"setCustomer($index)\"> <td>{{existing.ID}}</td> <td>{{existing.FIRSTNAME}}</td> <td>{{existing.LASTNAME}}</td> <td>{{existing.COMPANY}}</td> <td>{{existing.ADDRESS1}}</td> <td>{{existing.POSTAL_CD}}</td> <td>{{existing.TOWN}}</td> <td>{{existing.country}}</td> </tr> </table> </div> <div layout=\"row\"> <div flex></div> <md-button ng-click=\"cancel()\" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button ng-click=\"toggleClientEditable()\" class=\"md-primary\" ng-disabled=\"customer.length > 0 && !selectedCustomer\">Use existing</md-button> <md-button ng-click=\"openNewClient()\" class=\"md-green\">Continue</md-button> </div> </md-dialog>"
  );


  $templateCache.put('views/customer-search.html',
    "<div ng-cloak> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <form role=\"form\" class=\"form-inline\" ng-submit=\"submit(searchTerm, matches)\" flex-gt-xs=\"50\"> <md-content layout-gt-xs=\"row\" id=\"product-search\" class=\"first product-code-search\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"submit(searchTerm)\">search</i></md-icon> <input flex type=\"text\" id=\"keywords\" name=\"keywords\" ng-model=\"searchTerm\" ng-change=\"searchInputChanged(searchTerm)\" class=\"search-box\" placeholder=\"Search keywords\" ng-model-options=\"{ debounce: 250 }\" tabindex=\"1\" focus-me=\"true\"> </md-input-container> </md-content> </form> <div layout-gt-xs=\"column\" flex layout-align=\"start start\"> <md-button class=\"newItemButton\" ng-click=\"addCustomer()\" tabindex=\"3\"> <i class=\"material-icons\">add</i>&nbsp;New </md-button> </div> </div> <div layout=\"row\">&nbsp;</div> <div ng-show=\"searchTerm.length >= 3 && totalMatches === 0\" style=\"position:absolute; margin-top:-20px\"> <p>Your search returned no matching clients or houses.</p> </div> <div ng-show=\"searchTerm.length >= 3 && totalMatches !== 0\"> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table multiple md-progress=\"promise\"> <thead md-head md-order=\"query.sort\" md-on-reorder=\"searchInputChanged\"> <tr md-row> <th md-column md-order-by=\"id\">Id</th> <th md-column md-order-by=\"type\">Type</th> <th md-column md-order-by=\"name\">Name</th> <th md-column>Main contact</th> <th md-column>Main address</th> <th md-column md-order-by=\"organisation.name\">Owner</th> </tr> </thead> <tbody md-body> <tr class=\"clickable\" md-row md-select=\"item\" md-select-id=\"item.id\" md-auto-select ng-repeat=\"item in matches\" ng-dblclick=\"open(item)\"> <td md-cell>{{item.id}}</td> <td md-cell> <i class=\"material-icons\" ng-if=\"item.type != 'PRIVATE'\">corporate_fare</i> <i class=\"material-icons\" ng-if=\"item.type == 'PRIVATE'\">home</i> </td> <td md-cell>{{item.name}}</td> <td md-cell>{{getBillingContact(item.contacts, item.pec_mail)}}</td> <td md-cell ng-init=\"address=getBillingAddress(item.addresses)\"> <p> {{address.address_1}}<br> <span ng-if=\"address.address_2\">{{address.address_2}}<br></span> {{address.country_code}}-{{address.postal_code}} {{address.town}} </p> <p ng-if=\"item.addresses.length>1\"> (+{{item.addresses.length-1}} more) </p> </td> <td md-cell>{{item.organisation.name}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"query.per_page\" md-limit-options=\"limitOptions\" md-page=\"query.page\" md-total=\"{{totalMatches}}\" md-page-select md-on-paginate=\"searchInputChanged\" md-boundary-links> </md-table-pagination> </div> </div>"
  );


  $templateCache.put('views/dashboard.html',
    "<div layout-gt-xs=\"row\" layout-margin layout-align=\"center center\" layout-wrap style=\"max-width: 760px; margin:auto\"> <div class=\"dash-block\" flex-gt-xs=\"33\" restrict-access=\"BeeManagement\"> <a ui-sref=\"managementSearch\"> <div layout=\"row\"> <div md-block flex> <img src=\"images/paradise.png\" alt=\"\" class=\"img-responsive\"> </div> </div> <div layout=\"row\" class=\"block-title\"> <h3>BeeManagement</h3> </div> </a> </div> <div class=\"dash-block\" flex-gt-xs=\"33\" restrict-access=\"BeeFarmer\"> <a ng-href=\"{{farmerLink}}\"> <div layout=\"row\"> <div md-block flex> <img src=\"images/farmer-illustration.jpg\" alt=\"\" class=\"img-responsive\"> </div> </div> <div layout=\"row\" class=\"block-title\"> <h3>BeeFarmer</h3> </div> </a> </div> <div class=\"dash-block\" flex-gt-xs=\"33\" restrict-access=\"BeeHarvest\"> <a ng-href=\"{{beehomeLink}}\"> <div layout=\"row\"> <div md-block flex> <img src=\"images/classic-illustration-b.jpg\" alt=\"\" class=\"img-responsive\"> </div> </div> <div class=\"block-title\"> <h3>BeeHome</h3> </div> </a> </div> <div class=\"dash-block\" flex-gt-xs=\"33\" restrict-access=\"Admin\"> <a ng-href=\"#/admin/organisations\"> <div layout=\"row\"> <div md-block flex> <img src=\"images/user.png\" alt=\"\" class=\"img-responsive\"> </div> </div> <div class=\"block-title\"> <h3>Admin</h3> </div> </a> </div> </div>"
  );


  $templateCache.put('views/date-range-picker.html',
    "<md-dialog aria-label=\"dateRangePicker\" flex=\"30\"> <form id=\"toastBox\" name=\"dateRangePickerForm\" style=\"\" ng-submit=\"save()\" novalidate> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Date Range</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"layout-padding\"> <div layout-padding> <br> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-input-container class=\"md-block\" flex=\"50\"> <label for=\"startDate\">From</label> <md-datepicker aria-label=\"Start Date\" id=\"startDate\" name=\"startDate\" ng-model=\"startDate\" ng-change=\"endDate=startDate\" ng-required=\"1\"></md-datepicker> </md-input-container> <md-input-container class=\"md-block\" flex=\"50\"> <label for=\"endDate\">To</label> <md-datepicker aria-label=\"End Date\" id=\"endDate\" name=\"endDate\" ng-model=\"endDate\" md-min-date=\"startDate\" ng-required=\"1\"> </md-datepicker> </md-input-container> </div> <md-divider></md-divider> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"save\"> Save </md-button> </md-dialog-actions> </div> </div> </md-dialog-content> </form> </md-dialog>"
  );


  $templateCache.put('views/deliveries-panel.html',
    "<div class=\"section\"> <div layout=\"row\"> <h3>Delivery notes</h3> <div flex></div> <div md-button class=\"md-primary\" ng-click=\"generateSingleDeliveries()\" ng-show=\"request\" ng-disabled=\"request.deliveries.length\"> <i class=\"material-icons\">add</i> Generate Single delivery </div> <div md-button class=\"md-primary\" ng-click=\"generateDeliveries()\" ng-show=\"request\" ng-disabled=\"request.deliveryTotal >= request.requested.total\"> <i class=\"material-icons\">add</i> Generate deliveries </div> </div> <div class=\"client-products\" ng-show=\"request.deliveries.length\"> <!--  ng-show=\"request.deliveries.length\" --> <span>{{request.deliveryTotal || 0}} of {{request.requested.total}} requested components have a delivery</span><span flex></span> <table class=\"table table-hover\"> <tr> <th>ID</th> <!-- <th>ID (bexio)</th>\t --> <th>Creation Date</th> <!-- <th>Species</th>\t --> <th># items</th> <th>Printed</th> <th>Package</th> <th>Shipping Label</th> </tr> <tr ng-repeat=\"delivery in request.deliveries\" ng-click=\"selectDelivery($index)\" class=\"delivery-line delivery-line{{$index}}\"> <td>{{delivery.ID}}</td> <!-- <td>{{delivery.ERP_ID}}</td> --> <td>{{delivery.creationDate | date:'dd/MM/yyyy'}}</td> <!-- <td>{{delivery.species}}</td> --> <td>{{delivery.DELIVERED_AMT}}</td> <td> <i class=\"material-icons\" ng-show=\"delivery.printStatus == 'Unprinted'\">clear</i> <i class=\"material-icons\" ng-show=\"delivery.printStatus == 'Printed'\">done</i> </td> <td>{{delivery.packageCode}}</td> <td> <tracking-number number=\"delivery.CONSIGNMENT_NR\"> </td> </tr> </table> </div> <div class=\"customer-product-actions\" layout=\"row\"> <div flex></div> <md-button type=\"button\" class=\"md-warn\" ng-click=\"deleteDelivery(farmer.activeDelivery.ID)\" ng-show=\"farmer.activeDelivery\" ng-disabled=\"farmer.activeDelivery.hasCheckout\"> <i class=\"material-icons\">remove</i> Delete </md-button> <md-button type=\"button\" class=\"md-warn\" ng-click=\"deleteAll()\" ng-disabled=\"!request.deliveries.length\"> <i class=\"material-icons\">remove</i> Delete All </md-button> <md-button type=\"button\" class=\"md-primary\" ng-disabled=\"!request.deliveries.length\" ng-click=\"downloadDeliveries()\"> <i class=\"material-icons\">file_download</i> Download deliveries </md-button> <md-button type=\"button\" class=\"md-primary\" restrict-access=\"Email Documents\" ng-disabled=\" !request.deliveries.length\" ng-click=\"sendMail()\"> <i class=\"material-icons\">email</i> Email </md-button> <md-button ng-show=\"farmer.activeDelivery && farmer.activeDelivery.hasCheckout\" class=\"md-primary\" ng-click=\"modal()\" restrict-access=\"Edit Check Out\"> <i class=\"material-icons\">check</i> Edit Check Out </md-button> </div> </div>"
  );


  $templateCache.put('views/delivery-modal.html',
    "<md-dialog aria-label=\"delivery\" ng-cloak> <form name=\"deliveryForm\" ng-submit=\"deliveryForm.$valid && save()\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>New delivery</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout-padding> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-subheader> <span>There are {{activeRequest}} stands without delivery notes for the selected request.</span> </md-subheader> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"amount\">Delivery amount</label> <md-select name=\"amount\" ng-model=\"delivery.amount\" required> <md-option ng-value=\"1\"> 1 </md-option> <md-option ng-value=\"3\"> 3 </md-option> </md-select> <div ng-messages=\"deliveryForm.amount.$error\" ng-if=\"deliveryForm.$submitted || deliveryForm.amount.$touched\"> <div ng-message=\"required\"> You must select a container size. </div> </div> </md-input-container> <div class=\"md-block\" flex-gt-xs=\"5\"></div> <div class=\"md-block\" flex-gt-xs> <label for=\"deliveryDate\">Delivered date</label> <md-datepicker name=\"deliveryDate \" ng-model=\"delivery.deliveryDate \" md-placeholder=\"Enter date \"> </md-datepicker> <div class=\"validation-messages\" ng-messages=\"requestForm.deliveryDate.$error \" ng-if=\"requestForm.$submitted || requestForm.deliveryDate.$touched \"> <div ng-message=\"valid \">The entered value is not a date!</div> </div> </div> <div layout-gt-xs=\"row \" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"printed \">Printed</label> <md-select name=\"printed \" ng-model=\"delivery.printed \" required> <md-option ng-value=\"3 \"> <i class=\"material-icons\">done</i> </md-option> <md-option ng-value=\"2 \"> <i class=\"material-icons\">clear</i> </md-option> </md-select> <div ng-messages=\"requestForm.species.$error \" ng-if=\"requestForm.$submitted || requestForm.species.$touched \"> <div ng-message=\"required \"> You must select a print status. </div> </div> </md-input-container> <div class=\"md-block\" flex-gt-xs=\"5 \"></div> </div> <md-dialog-actions layout=\"row \"> <!-- <md-button class=\"md-primary \">\n" +
    "                    Save and print\n" +
    "                </md-button> --> <span flex></span> <md-button ng-click=\"cancel() \" class=\"md-warn\"> Cancel </md-button> <md-button type=\"submit \" class=\"md-primary\"> Save </md-button> </md-dialog-actions> </div> </div> </md-dialog-content> </form> </md-dialog>"
  );


  $templateCache.put('views/delivery-notes-modal.html',
    "<md-dialog aria-label=\"order\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Checkouts</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout-padding> <div layout=\"row\"> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <form role=\"form\" class=\"form-inline\" ng-submit=\"searchCode()\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"product-code-search\" flex-gt-xs> <md-input-container class=\"md-block\" md-no-float flex> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"searchCode(true)\">search</i></md-icon> <input flex type=\"text\" name=\"codeString\" ng-model=\"codeString\" class=\"search-box\" placeholder=\"Search Code\"> </md-input-container> </md-content> </form> </div> <div flex></div> <md-button class=\"md-primary no-caps\" ng-click=\"removeDeliveryNotes()\" ng-disabled=\"!$exttableSelected.delivery_notes.length\">Delete </md-button> <md-button class=\"md-primary no-caps\" ng-click=\"undoCheckInDeliveryNotes()\" ng-disabled=\"!$exttableSelected.delivery_notes.length\">Undo check in </md-button> <md-button class=\"md-primary no-caps\" ng-click=\"checkInDeliveryNotes()\" ng-disabled=\"!$exttableSelected.delivery_notes.length\">Check in </md-button> </div> <div class=\"table-responsive\"> <table id=\"delivery-notes-table\" class=\"table table-hover\" extended-table data-model=\"delivery_notes\" data-row-id=\"{{rowID}}\" data-clickable=\"false\" data-checkboxes=\"true\" data-columns-data=\"{{deliveryNotesColumns}}\" data-order=\"[[ 1, &quot;desc&quot; ]]\"> <thead> <tr> <th></th> <th>ID</th> <th>Delivery ID</th> <th>Requested item</th> <th>Code</th> <th>Checked out at</th> <th>Checked out by</th> <th>Checked in at</th> <th>Checked in by</th> </tr> </thead> </table> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/deliverymanagement.html',
    "<div layout=\"row\"> <div class=\"results panel panel-default left-col\" flex-gt-xs=\"20\"> <h3>Shipping date</h3> <form name=\"options\" ng-submit=\"updateOptions()\" layout-padding novalidate> <div layout-gt-xs=\"row\" class=\"mini\"> <md-block class=\"md-block\" flex-gt-sm layout=\"column\"> <md-block> <label for=\"deliveryDate\">Shipping date</label> <md-datepicker name=\"deliveryDate\" ng-model=\"deliveryDate\" md-placeholder=\"Enter date\" ng-change=\"search()\"> </md-datepicker> </md-block> </md-block> </div> </form> </div> <div class=\"results panel panel-default\" flex-gt-xs> <h3>Units Requested</h3> <md-content> <div class=\"no-scroll bar-container-wrapper\" layout=\"row\" layout-padding> <div class=\"y-axis yAxis-holder\" flex layout=\"column\"> <md-block flex id=\"y-spacer\"></md-block> <md-block flex ng-repeat=\"label in yAxis\" class=\"tiny-text\">{{label}}<span class=\"chart-line\"></span> </md-block> </div> <div class=\"bar-container\" flex ng-repeat=\"day in days\" ng-click=\"setDate(day.date)\"> <div class=\"bar bar--printed\" layout layout-align=\"center bottom\" style=\"height:{{day.value/maxRequests * 100}}%\"> <div class=\"bar\" layout layout-align=\"center bottom\" style=\"height:{{day.unprinted/day.value * 100}}%\"></div> </div> <div class=\"bar-label\"> {{day.date | date:'dd/MM'}} </div> <div class=\"bar-label-bottom\" ng-show=\"day.value > 0\"> {{day.value}} </div> </div> </div> </md-content> </div> </div> <div class=\"results panel panel-default\" flex-gt-xs style=\"margin: 40px auto\"> <div layout=\"row\"> <h3>Requests for {{deliveryDate | date:'dd/MM/yyyy'}}</h3> <div flex></div> <div md-button ng-click=\"goToCustomerPage()\" class=\"md-primary\" ng-show=\"requests.length\" ng-disabled=\"!customerPageButtonEnabled\"> Go to customer page </div> <md-button class=\"md-primary\" ng-click=\"confirmGenerateSingleDeliveries()\" ng-show=\"requests.length\" ng-disabled=\"!deliveryButtonsEnabled\">Create single delivery</md-button> <div md-button ng-click=\"confirmGenerateDeliveries()\" class=\"md-primary\" ng-show=\"requests.length\" ng-disabled=\"!deliveryButtonsEnabled\"> Create delivery </div> </div> <div layout=\"row\" class=\"mini table-request-wrapper\" layout-padding> <md-block flex> <div ng-show=\"requests.length\"> <div ng-show=\"requests.length > 20\"> <input type=\"checkbox\" id=\"checkAll\"><label for=\"checkAll\">Check all items</label> </div> <table class=\"table table-hover table-request\" extended-table data-model=\"tableRequest\" data-row-id=\"{{rowID}}\" data-checkboxes=\"true\" data-clickable=\"true\" data-columns-data=\"{{requestColumns}}\" data-selectallbutton=\"true\"> <thead> <tr> <th>ID</th> <th>Request ID</th> <th>Organisation</th> <th>Country</th> <th>Company</th> <th>Name</th> <th>Address</th> <th># of units</th> </tr> </thead> </table> </div> <span class=\"lg-text\" layout=\"row\" ng-show=\"!requests.length\">There are no requests for {{deliveryDate | date:'dd/MM/yyyy'}}</span> </md-block> </div> </div> <div class=\"results panel panel-default\" flex-gt-xs> <div layout=\"row\"> <h3>Shipping on {{deliveryDate | date:'dd/MM/yyyy'}}</h3> <div flex></div> <md-button class=\"md-primary\" ng-click=\"printSelected()\" ng-show=\"deliveries.length\">Print selected</md-button> <div md-button ng-click=\"printChecklist()\" class=\"md-primary\" ng-show=\"deliveries.length\"> <i class=\"material-icons\">file_download</i> Download Checklist </div> </div> <div layout=\"row\" class=\"mini\" layout-padding> <md-block flex> <table class=\"table center-table table-responsive table-deliveries\" layout-padding ng-show=\"deliveries.length\"> <tr> <th style=\"width: 5%\"> <md-checkbox ng-model=\"allSelected\" ng-click=\"checkUncheckAll()\"></md-checkbox> </th> <th>#</th> <th> <a href=\"\" ng-click=\"sortBy('ID')\"> Delivery ID <i ng-show=\"sortType == 'deliveryID' && !sortReverse\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"sortType == 'deliveryID' && sortReverse\" class=\"material-icons\">keyboard_arrow_down</i> </a> </th> <th> <a href=\"\" ng-click=\"sortBy('REQUEST_ID')\"> Request ID <i ng-show=\"sortType == 'REQUEST_ID' && !sortReverse\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"sortType == 'REQUEST_ID' && sortReverse\" class=\"material-icons\">keyboard_arrow_down</i> </a> </th> <th> <a href=\"\" ng-click=\"sortBy('DELIVERED_AMT')\"> # of units <i ng-show=\"sortType == 'DELIVERED_AMT' && !sortReverse\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"sortType == 'DELIVERED_AMT' && sortReverse\" class=\"material-icons\">keyboard_arrow_down</i> </a> </th> <th> <a> Box Type <i ng-show=\"sortType == 'BOX_TYPE' && !sortReverse\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"sortType == 'BOX_TYPE' && sortReverse\" class=\"material-icons\">keyboard_arrow_down</i> </a> </th> <th> <a href=\"\" ng-click=\"sortBy('printed')\"> Printed <i ng-show=\"sortType == 'printed' && !sortReverse\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"sortType == 'printed' && sortReverse\" class=\"material-icons\">keyboard_arrow_down</i> </a> </th> </tr> <tr ng-repeat=\"delivery in deliveries\" ng-dblclick=\"openClient(delivery.customerID)\" data-request-id=\"{{delivery.REQUEST_ID}}\"> <td> <md-checkbox ng-model=\"delivery.selected\" aria-label=\"Checkbox 1\"></md-checkbox> </td> <td> {{$index + 1}} </td> <td>{{delivery.ID}}</td> <td>{{delivery.REQUEST_ID}}</td> <td>{{delivery.DELIVERED_AMT}}</td> <td>{{delivery.packageCode}}</td> <td> <i class=\"material-icons\" ng-show=\"delivery.printStatus == 'Printed'\">done</i> <i class=\"material-icons md-warn\" ng-show=\"delivery.printStatus != 'Printed'\">clear</i> </td> </tr> </table> <span class=\"lg-text\" layout=\"row\" ng-show=\"!deliveries.length\">There are no deliveries requested for {{deliveryDate | date:'dd/MM/yyyy'}}</span> </md-block> </div> </div>"
  );


  $templateCache.put('views/dispatch.html',
    "<div layout=\"column\" flex-offset-xs=\"1\" flex-offset-sm=\"5\" flex-xs=\"98\" flex-sm=\"90\" flex-md=\"80\" flex-offset-md=\"10\" flex-offset-gt-md=\"10\" flex-gt-md=\"80\"> <md-whiteframe class=\"md-whiteframe-1dp\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h3>Delivery Dispatch</h3> <!-- fill up the space between left and right area --> <span flex></span> </div> </md-toolbar> <md-content> <div layout-gt-xs=\"row\"> <div layout layout-padding flex-gt-xs=\"60\"> <img src=\"/images/scanner.jpg\" alt=\"\" class=\"img-responsive\"> </div> <div flex-gt-xs=\"40\"> <md-subheader class=\"md-primary\" layout=\"row\"> <h2>Scan your delivery note!</h2> <span flex></span> </md-subheader> <md-block layout=\"row\"> <form ng-submit=\"checkCode()\"> <div layout-gt-xs=\"row\" class=\"form-row\"> <md-input-container class=\"md-block\" flex-gt-xs=\"60\"> <label for=\"code\">Delivery Code</label> <input id=\"code\" type=\"text\" ng-model=\"delivery.code\"> </md-input-container> <md-block flex-gt-xs layout=\"center center\"> <md-button type=\"submit\" class=\"md-primary md-raised\">Submit</md-button> </md-block> </div> </form> </md-block> <!-- <div layout-gt-xs=\"row\">\n" +
    "\t\t\t\t<form ng-submit=\"checkCode()\" >\n" +
    "\t\t\t\t\t<div layout-gt-xs=\"row\" class=\"form-row\">\n" +
    "\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-xs=\"60\">\n" +
    "\t\t\t\t\t\t\t<label for=\"code\">Delivery Code</label>\n" +
    "\t\t\t\t\t\t\t<input id=\"code\" type=\"text\" ng-model=\"delivery.code\"/>\n" +
    "\t\t\t\t\t\t</md-input-container>\n" +
    "\t\t\t\t\t\t<md-block flex-gt-xs layout layout=\"center center\">\n" +
    "\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\">Submit</md-button>\n" +
    "\t\t\t\t\t\t</md-block>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</form>\n" +
    "\t\t\t</div> --> </div> </div> </md-content> </md-whiteframe> </div>"
  );


  $templateCache.put('views/document-modal.html',
    "<md-dialog aria-label=\"Organisation\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\" class=\"org-translations\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Document Translation</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <br> <form name=\"docForm\" ng-submit=\"docForm.$valid && saveDocument()\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <input flex type=\"hidden\" name=\"orgList\" ng-model=\"document.organisationID\"> <table class=\"table table-hover\"> <tr> <td> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"langList\">Language</label> <md-select name=\"langList\" ng-model=\"document.LANG_ID\"> <md-option ng-repeat=\"lan in lang\" ng-value=\"lan.ID\"> {{lan.description}} </md-option> </md-select> </md-input-container> </td> <td> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"docType\">Document Type</label> <md-select name=\"docType\" ng-model=\"document.selectedDocument\" ng-model-options=\"{trackBy: '$value.id'}\"> <md-option ng-repeat=\"doc in docs\" ng-value=\"doc\"> {{doc.name}} </md-option> </md-select> </md-input-container> </td> </tr> </table> </div> <div class=\"layout-padding\"> <div class=\"form-section layout-padding\" ng-switch=\"document.selectedDocument.id\"> <div ng-switch-when=\"1\">Offer</div> <div ng-switch-when=\"2\">Order</div> <div ng-switch-when=\"3\">Request</div> <div ng-switch-when=\"4\">Delivery</div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-repeat=\"phrase in document.TEXT\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"30\"> <label for=\"name\">{{phrase.TXT_CD}}</label> </div> <md-input-container class=\"md-block margin-0\" flex-gt-xs flex=\"70\"> <input aria-label=\"{{phrase.TXT_CD}}\" flex type=\"text\" name=\"name\" ng-model=\"phrase.TXT_MODULE\"> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </div> </form> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/errormodal.html',
    "<div class=\"modal-content modal-danger\"> <div class=\"modal-header\"> <h4>{{title}}</h4> </div> <div class=\"modal-body\"> <p ng-bind-html=\"message\" class=\"text-center\"></p> </div> <div class=\"modal-footer\"> <a type=\"submit\" class=\"btn btn-info\" data-dismiss=\"modal-content\" ng-click=\"cancel()\">OK</a> </div> </div>"
  );


  $templateCache.put('views/farmer-customer.html',
    "<div client-tabs client=\"client\"></div> <div class=\"results panel panel-default\" ng-show=\"client.seasons.length > 1\"> <h3>Seasons</h3> <div class=\"panel-body\" ng-show=\"client.seasons.length > 1\"> Please select the seasons for which you would like to display data. </div> <div class=\"panel-body\" ng-show=\"client.seasons.length == 1\"> There is only information for the following season. </div> <form action=\"updateSeason()\"> <div class=\"layout layout-padding\"> <p> <md-checkbox aria-label=\"Finished?\" ng-disabled=\"client.seasons.length < 2\" ng-repeat=\"season in client.seasons | orderBy:'description'\" ng-model=\"season.show\" ng-change=\"seasonSelected(true)\"> {{season.description}} </md-checkbox> </p> </div> </form> </div> <div subscriptions-panel farmer=\"client\" users=\"users\" init-seasons=\"initSeasons()\" ng-if=\"client.subscriptions\"></div> <div farmer-orders farmer=\"client\"></div> <div request-panel order=\"client.activeOrder\" farmer=\"client\" ng-show=\"client.activeOrder.ID\" users=\"$resolve.users\"></div> <div deliveries-panel request=\"client.activeRequest\" farmer=\"client\" ng-show=\"client.activeRequest\" restrict-access=\"Customer Deliveries\" users=\"$resolve.users\"></div>"
  );


  $templateCache.put('views/farmercheckin.html',
    "<md-content id=\"toastBox\"> <div layout-padding> <h2>Bitte Code der Rücksendung scannen</h2> <!-- <img src=\"images/scanner-box.png\" alt=\"\" class=\"img-responsive\" ng-click=\"prepareScanner()\"> --> <div layout=\"row\" flex=\"100\"> <form name=\"productForm\" ng-submit=\"productForm.$valid\"> <md-input-container> <label for=\"productScanCode\">Scan Code</label> <input name=\"productScanCode\" id=\"scannerProduct\" ng-blur=\"productScanCode=processScan(productScanCode)\" ng-keypress=\"enteredProductScanCode($event)\" ng-model=\"productScanCode\" ng-pattern=\"houseCodePattern\" focus-me=\"true\" capitalize> <div ng-messages=\"productForm.$error\" role=\"alert\" multiple> <div ng-message=\"pattern\" ng-if=\"productForm.$error.pattern\"> Der gescannte Code ist kein gültiger BeeFarmer Code. </div> </div> </md-input-container> </form> </div> <div layout=\"row\" ng-repeat=\"item in scannedItems track by $index\"> <md-input-container flex=\"50\"> <input ng-disabled=\"1\" required name=\"item.code\" ng-model=\"item.code\"> </md-input-container> <!-- <img class=\"x-input\" ng-click=\"removeItem($index)\" src=\"images/cross.png\"> --> <md-button class=\"md-icon-button\" ng-click=\"removeItem($index)\" style=\"color:black\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> <div class=\"checkin-msg\"> <div style=\"color:red\" ng-if=\"item.status=='fail'\"> Kein Checkout vorhanden </div> <div style=\"color:green\" ng-if=\"item.status=='success'\"> Ausgecheckt am {{item.dateUpdated | date:'dd.MM.yyyy'}}. </div> <div style=\"color:red\" ng-if=\"item.status=='warning'\"> Bereits eingecheckt am {{item.dateUpdated | date:'dd.MM.yyyy'}}. </div> </div> </div> </div> <md-footer> <md-button class=\"md-primary pull-right\" ng-disabled=\"scannedItems.length<1\" ng-click=\"confirm();\">Save</md-button> </md-footer> </md-content>"
  );


  $templateCache.put('views/farmercheckout.html',
    "<div layout-padding id=\"deliveryScanner\" ng-show=\"!selectedIndex\"> <form name=\"scannerForm\" ng-submit=\"checkDelivery()\"> <md-input-container class=\"product-scan\"> <label for=\"scannerInput\" class=\"scanner-input-label\">Scan Code {{scannedCode}}</label> <input id=\"scannerInput\" type=\"text\" name=\"scannerInput\" capitalize focus-me=\"true\" aria-label=\"scan code\" ng-model=\"scannedCode\" ng-pattern=\"/^DL-[0-9]/\"> <div ng-messages=\"scannerForm.$error\" role=\"alert\" multiple> <div ng-message=\"pattern\" ng-if=\"scannerForm.$error.pattern\"> Dies ist kein gültiger Lieferscheincode. </div> </div> </md-input-container> <p class=\"scanner-form-label\">Lieferschein scannen</p> </form> </div> <div layout-padding id=\"products\" ng-show=\"selectedIndex == 1\" layout=\"column\" layout-align=\"center stretch\"> <div layout=\"row\" flex layout-align=\"space-between center\"> <div ng-show=\"productTabSelected!=requestedItems.length\" layout-xs=\"row\" layout-sm=\"row\" flex-gt-sm=\"60\"> <form name=\"productForm\" class=\"product-form\" ng-submit=\"productForm.$valid\"> <md-input-container class=\"product-scan\"> <label for=\"scannerProduct\">Scan Code</label> <input name=\"productScanCode\" id=\"scannerProduct\" focus-me=\"true\" capitalize aria-label=\"scan code\" ng-blur=\"productScanCode=processScan(productScanCode)\" ng-keypress=\"enteredProductScanCode($event)\" ng-model=\"productScanCode\" ng-pattern=\"houseCodePattern\"> <div ng-messages=\"productForm.$error\" role=\"alert\" multiple> <div ng-message=\"pattern\" ng-if=\"productForm.$error.pattern\"> Der gescannte Code ist kein gültiger Osmipro Code. </div> </div> </md-input-container> </form> </div> <div ng-show=\"productTabSelected==requestedItems.length\" layout-xs=\"row\" layout-sm=\"row\" flex-gt-sm=\"60\"> <form name=\"submitForm\" ng-submit=\"scannedBarcode=[scannedBarcodeInput]; scannedBarcodeInput=''\"> <md-input-container class=\"barcode-scan\"> <label class=\"scanned-barcode-label\" for=\"scannedBarcodeInput\">Consignment Code</label> <input id=\"scannedBarcodeInput\" type=\"text\" name=\"scannedBarcodeInput\" focus-me=\"true\" ng-model=\"scannedBarcodeInput\"> <div ng-messages=\"submitForm.scannedBarcodeInput.$error\" role=\"alert\" multiple> <div ng-show=\"submitForm.scannedBarcodeInput.$error.pattern\"> Consignment Code must be only number </div> </div> </md-input-container> </form> </div> <div layout=\"column\" style=\"margin-left:40px\"> <h3 layout-xs=\"row\" layout-sm=\"row\"> Lieferschein-Nr: {{deliveryCode}} </h3> <h3 layout-xs=\"row\" layout-sm=\"row\"> Lieferdatum: {{deliveryDate | date:'dd.MM.yyyy'}} </h3> </div> </div> <md-tabs ng-model=\"productTabs\" md-selected=\"productTabSelected\" md-dynamic-height> <md-tab id=\"tab_product_{{item.ID}}\" class=\"product-tab\" ng-repeat=\"(i, item) in requestedItems\" md-on-select=\"setTabDisplay()\"> <md-tab-label> <span ng-class=\"{ complete:item.requestList.length == item.DELIVERED_AMT }\">{{item.productName}}</span> </md-tab-label> <md-tab-body> <div layout-padding> <div layout=\"row\"> <p> {{item.requestList.length}}/{{item.DELIVERED_AMT}} {{item.productName}} scanned. </p> </div> <!-- htmlmin:ignore -->\n" +
    "\t\t\t\t\t<md-chips ng-model=\"item.requestList\" md-on-remove=\"itemRemoved()\" readonly=\"true\" md-removable=\"true\" layout=\"column\"></md-chips>\n" +
    "\t\t\t\t\t<!-- htmlmin:ignore --> </div> </md-tab-body> </md-tab> <md-tab id=\"tab_barcode\" ng-disabled=\"totalItemsScanned != totalItemsToScan\" md-on-select=\"focusBarcodeInput()\"> <md-tab-label>Code Postlabel</md-tab-label> <md-tab-body> <div style=\"margin-top: 20px\"> <div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"> <!-- htmlmin:ignore -->\n" +
    "\t\t\t\t\t\t<md-chips ng-model=\"scannedBarcode\" readonly=\"true\" md-removable=\"true\" layout=\"column\">\n" +
    "\t\t\t\t\t\t</md-chips>\n" +
    "\t\t\t\t\t\t<!-- htmlmin:ignore --> </div> </div> </md-tab-body> </md-tab> </md-tabs> <md-progress-linear class=\"md-primary\" md-mode=\"determinate\" value=\"{{totalItemsScanned/totalItemsToScan*100}}\"> </md-progress-linear> <div layout=\"row\" flex layout-align=\"end center\"> <div flex-gt-xs=\"40\"></div> <md-button class=\"back-button md-warn\" ng-click=\"clearForm()\">Abbrechen</md-button> <md-button class=\"next-button\" ng-show=\"productTabSelected==requestedItems.length\" ng-click=\"confirm()\">Abschliessen</md-button> <md-button class=\"next-button\" ng-show=\"productTabSelected!=requestedItems.length\" ng-click=\"nextTab()\" ng-disabled=\"productTabSelected >= allowedTabs\">Weiter</md-button> </div> </div>"
  );


  $templateCache.put('views/farmersettings.html',
    "<form name=\"farmerSeason\" ng-submit=\"saveSeason()\" layout-padding novalidate restrict-access=\"BeeFarmer Settings\"> <div layout-gt-xs=\"row \" layout-padding> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"season\"><span class=\"required-asterisk\">Season</span></label> <md-select name=\"season\" id=\"season\" ng-model=\"season\" required focus-me=\"true\"> <md-option ng-repeat=\"season in seasons\" ng-value=\"season\"> {{season}} </md-option> </md-select> <div ng-messages=\"harvestForm.season.$error\" ng-if=\"harvestForm.$submitted || harvestForm.season.$touched\"> <div ng-message=\"required\"> You must select a season. </div> </div> </md-input-container> <div class=\"md-block\" layout flex-gt-xs></div> <md-block flex-gt-xs=\"20\" layout layout-align=\"center center\"> <md-button type=\"submit\" class=\"md-raised md-hue-1 md-primary\">Update</md-button> </md-block> </div> </form>"
  );


  $templateCache.put('views/fridge-content-summary.html',
    "<div class=\"fridge-content-summary\"> <div class=\"row\"> <h3 class=\"no-caps\">Content summary</h3> </div> <table class=\"table content-summary\"> <tr> <th valign=\"middle\">Boxes</th> <td flex valign=\"bottom\">{{boxContentSummary2 | delimiter}}</td> <th class=\"content-summary-border-bottom\" valign=\"middle\" ng-repeat-start=\"item in boxesSummary\"> {{item.BOX_INSCT_NAME}} </th> <td class=\"content-summary-border-bottom\" flex valign=\"bottom\" ng-repeat-end> {{item.BOX_INSCT_COUNT | delimiter}} </td> </tr> <tr> <th valign=\"middle\">Populations</th> <td flex valign=\"bottom\">{{startpopContentSummary2 | delimiter}}</td> <th valign=\"middle\" ng-repeat-start=\"item in startpopsSummary\"> {{item.STARTPOP_INSCT_NAME}} </th> <td flex valign=\"bottom\" ng-repeat-end> {{item.STARTPOP_INSCT_COUNT | delimiter}} </td> </tr> </table> </div>"
  );


  $templateCache.put('views/fridge-modal.html',
    "<md-dialog aria-label=\"boxs\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 ng-if=\"!editing\" class=\"no-caps\">Add fridge</h2> <h2 ng-if=\"editing\" class=\"no-caps\">Edit fridge {{fridge.code}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"boxForm\" ng-submit=\"boxForm.$valid && save()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Code</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" aria-label=\"Code\" name=\"codeInput\" ng-model=\"fridge.code\" required focus-me=\"true\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}$/\" ng-change=\"addCode()\" style=\"text-transform:uppercase\" ng-disabled=\"editing\"> <div ng-messages=\"boxForm.codeInput.$error\" ng-if=\"boxForm.$submitted || boxForm.codeInput.$touched\"> <div ng-message=\"required\"> You must provide a code. </div> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Organisation</span> </div> <md-input-container class=\"md-block\" flex-gt-xs> <md-select name=\"fridgeOrganisation\" aria-label=\"Organisation\" ng-model=\"fridge.organisationID\" ng-disabled=\"!validCode\" required> <md-option ng-repeat=\"organisation in organisations\" ng-value=\"organisation.ID\" ng-selected=\"{{ organisation.ID == fridge.organisationID ? 'true' : '' }}\"> {{organisation.NAME}} </md-option> </md-select> <div ng-messages=\"boxForm.fridgeOrganisation.$error\" ng-if=\"boxForm.$submitted || boxForm.fridgeOrganisation.$touched\"> <div ng-message=\"required\"> You must provide a organisation. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span>Model</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"fmodel\" aria-label=\"Model\" ng-model=\"fridge.model\" ng-disabled=\"!validCode\"> <md-option ng-repeat=\"model in fridgeModels\" ng-value=\"model\"> {{model.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Temperature</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeTemp\" aria-label=\"Temperature\" ng-model=\"fridge.temp\" required ng-disabled=\"!validCode\"> <div ng-messages=\"boxForm.fridgeTemp.$error\" ng-if=\"boxForm.$submitted || boxForm.fridgeTemp.$touched\"> <div ng-message=\"required\"> You must provide a temperature. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Location</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeLocation\" aria-label=\"Location\" ng-model=\"fridge.location\" ng-disabled=\"!validCode\"> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/fridge-panel.html',
    "<div class=\"fridge-detail\"> <div layout=\"row\"> <h3 class=\"no-caps\">Fridge</h3> <div flex></div> <md-button ng-click=\"deleteFridge()\" class=\"md-primary no-caps\" ng-disabled=\"fridge.boxes || fridge.startpops\" restrict-access=\"BeeManagement Delete\">Delete</md-button> <md-button ng-click=\"editFridge()\" class=\"md-primary no-caps\">Edit</md-button> </div> <table class=\"table\"> <tr> <th valign=\"middle\">ID</th> <td flex valign=\"bottom\">{{fridge.ID}}</td> <th valign=\"middle\">Model</th> <td flex valign=\"bottom\">{{fridge.model.CODE}}</td> </tr> <tr> <th valign=\"middle\">Code</th> <td flex valign=\"bottom\">{{fridge.FRIDGE_CD}}</td> <th valign=\"middle\">Location</th> <td flex valign=\"bottom\">{{fridge.LOCATION}}</td> </tr> <tr> <th valign=\"middle\">Current Temp</th> <td flex valign=\"bottom\">{{fridge.temperatures[0].TEMPERATURE}}</td> <th valign=\"middle\">Organisation</th> <td flex valign=\"bottom\">{{fridge.organisation}}</td> </tr> </table> </div>"
  );


  $templateCache.put('views/fridge.html',
    "<div md-button href=\"#/management/search\" class=\"md-primary\"> <i class=\"material-icons\">search</i> back to search </div> <div fridge-panel fridge=\"fridge\"></div> <div class=\"row\">&nbsp;</div> <div fridge-content-summary fridge=\"fridge\"></div> <div class=\"row\">&nbsp;</div> <h3 class=\"no-caps\">Fridge contents</h3> <md-tabs md-selected=\"selectedIndex\" md-dynamic-height> <md-tab id=\"boxes-tab\"> <md-tab-label>Boxes</md-tab-label> <md-tab-body> <div class=\"fridge-boxes\"> <div class=\"results panel panel-default\" flex-gt-xs> <div class=\"panel-body\"> <boxmanagement-boxes-directive class=\"row\" season=\"season\" users=\"users\" fridge-id=\"fridge.ID\"> </boxmanagement-boxes-directive> </div> </div> </div> </md-tab-body> </md-tab> <md-tab id=\"populations-tab\"> <md-tab-label>Populations</md-tab-label> <md-tab-body> <div class=\"fridge-startpop results panel panel-default panel-body\" flex-gt-xs> <boxmanagement-startpops-directive class=\"row\" season=\"season\" users=\"users\" fridge-id=\"fridge.ID\"> </boxmanagement-startpops-directive> </div> </md-tab-body> </md-tab> </md-tabs>"
  );


  $templateCache.put('views/fridges-modal.html',
    "<md-dialog aria-label=\"boxs\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2 class=\"no-caps\">Edit fridges {{codesPretty}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"boxForm\" ng-submit=\"boxForm.$valid && save()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span>Model</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select name=\"fmodel\" ng-model=\"data.model\" placeholder=\"Multiple values\"> <md-option ng-repeat=\"model in fridgeModels\" ng-value=\"model.ID\"> {{model.CODE}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Temperature</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeTemp\" ng-model=\"data.temp\" placeholder=\"Multiple values\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Location</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"fridgeLocation\" ng-model=\"data.location\" placeholder=\"Multiple values\"> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/harvest-check.html',
    "<div layout-padding id=\"products\" layout=\"column\" layout-align=\"center stretch\"> <div layout=\"row\" flex layout-align=\"space-between center\"> <div layout-xs=\"row\" layout-sm=\"row\" flex-gt-sm=\"60\"> <form name=\"scannerForm\" class=\"product-form\" ng-submit=\"scannerForm.$valid && add(scanned)\"> <md-input-container class=\"product-scan\"> <label for=\"scanner\">Scan house code</label> <input name=\"scanner\" id=\"scanner\" focus-me=\"true\" capitalize aria-label=\"Scan house code\" ng-model=\"scanned\" ng-pattern=\"houseCodePattern\"> <div ng-messages=\"scannerForm.$error\" role=\"alert\" multiple> <div ng-message=\"pattern\" ng-if=\"scannerForm.$error.pattern\"> Dieser code scheint kein gültiger Häuschen code zu sein. </div> </div> </md-input-container> </form> </div> </div> <div class=\"client-products\" ng-show=\"items.length\"> <div class=\"panel-heading md-table-header-panel\" aria-hidden=\"true\" layout=\"row\"> <span flex></span> <md-button type=\"button\" class=\"md-warn\" ng-click=\"removeSelected()\" ng-disabled=\"selected.length==0\"> <i class=\"material-icons\">remove</i>Remove </md-button> <md-button type=\"button\" class=\"md-primary\" ng-click=\"confirmSelected()\" ng-disabled=\"selected.length==0\"> <i class=\"material-icons\">check</i>Done </md-button> </div> <md-table-container> <table md-table md-row-select multiple ng-model=\"selected\"> <thead md-head> <tr md-row> <th class=\"product-head\" md-column valign=\"middle\"> Code </th> <th class=\"product-head\" md-column valign=\"middle\"> Product </th> <th class=\"product-head\" md-column valign=\"middle\">BeeCare Status</th> <th class=\"product-head\" md-column valign=\"middle\"> Label </th> <th class=\"product-head\" md-column valign=\"middle\"> Shipping address </th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"item\" md-select-id=\"item.id\" md-auto-select ng-repeat=\"item in items | orderBy:'-id'\"> <td md-cell valign=\"bottom\">{{item.house.code}}</td> <td md-cell valign=\"bottom\">{{item.product.PROD_NAME}}</td> <td md-cell valign=\"bottom\"> <div product-progress-indicator product=\"item.harvestRecord\" client-id=\"item.house.client_id\" users=\"users\"></div> </td> <td md-cell valign=\"bottom\"> <tracking-number number=\"item.harvestRecord.CONSIGNMENT_NR\"> </td> <td md-cell valign=\"bottom\"> <span ng-show=\"item.address.first_name || item.address.last_name\">{{item.address.first_name + \" \" + item.address.last_name}}<br></span> <span ng-show=\"item.address.company_name\">{{item.address.company_name}}<br></span> {{item.address.address_1}}<br> <span ng-if=\"item.address.address_2\">{{item.address.address_2}}<br></span> {{item.address.country_code}}-{{item.address.postal_code}} {{item.address.town}} </td> </tr> </tbody> </table> </md-table-container> </div> </div>"
  );


  $templateCache.put('views/harvestsettings.html',
    "<form name=\"harvestForm\" ng-submit=\"harvestForm.$valid && saveSeason()\" novalidate restrict-access=\"BeeHarvest Settings\"> <div layout-gt-xs=\"row \" layout-padding> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"season\"><span class=\"required-asterisk\">Season</span></label> <md-select name=\"season\" id=\"season\" ng-model=\"season\" required focus-me=\"true\"> <md-option ng-repeat=\"season in seasons\" ng-value=\"season\"> {{season}} </md-option> </md-select> <div ng-messages=\"harvestForm.season.$error\" ng-if=\"harvestForm.$submitted || harvestForm.season.$touched\"> <div ng-message=\"required\"> You must select a season. </div> </div> </md-input-container> <div class=\"md-block\" layout flex-gt-xs></div> <md-block flex-gt-xs=\"20\" layout layout-align=\"center center\"> <md-button type=\"submit\" class=\"md-raised md-hue-1 md-primary\">Update</md-button> </md-block> </div> </form>"
  );


  $templateCache.put('views/history-directive.html',
    "<form name=\"historyForm\"> <md-table-container> <table md-table md-progress=\"promise\"> <thead md-head md-on-reorder=\"getHistory\"> <tr md-row> <th md-column width=\"10\">Id</th> <th md-column width=\"10\">Object</th> <th md-column width=\"10\">Field</th> <th md-column width=\"45\">Change</th> <th md-column width=\"20\">Modified By</th> <th md-column width=\"25\">Modified At</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"(sortedIndex, historyItem) in history\"> <td md-cell>{{historyItem.id}}</td> <td md-cell>{{historyItem.object}}</td> <td md-cell>{{historyItem.field}}</td> <td md-cell> {{ historyItem.field ? (historyItem.original || \"null\") + \" => \" + (historyItem.new || \"null\") : historyItem.object + \" created\"}} </td> <td md-cell> {{ users[historyItem.updated_by].fullName || historyItem.updated_by}} </td> <td md-cell> {{historyItem.timestamp | date:'dd/MM/yyyy HH:mm:ss'}} </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"query.per_page\" md-limit-options=\"pageLimitOptions\" md-page=\"query.page\" md-total=\"{{historyCount}}\" md-page-select md-on-paginate=\"getHistory\" md-boundary-links> </md-table-pagination> </form>"
  );


  $templateCache.put('views/history-modal.html',
    "<md-dialog aria-label=\"History\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{type === 'customer' ? 'Customer' : 'House' }} history</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"row\"> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-progress=\"promise\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getStartpopOrders\"> <tr md-row> <th md-column md-order-by=\"CHANGE_LOG\">Change log</th> <th md-column md-order-by=\"OPERATION\">Operation</th> <th md-column md-order-by=\"UPD_BY\">Modified by</th> <th md-column md-order-by=\"SYS_VALID_FROMd\"> Modified at </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"entry in data\"> <td md-cell>{{entry.CHANGE_LOG}}</td> <td md-cell>{{entry.OPERATION}}</td> <td md-cell>{{users[entry.UPD_BY].firstName}}</td> <td md-cell ng-hide=\"clientId\"> {{entry.SYS_VALID_FROM | date:'dd/MM/yyyy'}} </td> </tr> </tbody> </table> </md-table-container> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/image-modal.html',
    "<md-dialog flex=\"100\" aria-label=\"boxes\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{image_title}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <div layout=\"row\" flex></div> <md-dialog-content class=\"image-holder\"> <img class=\"img-responsive\" src=\"{{image_url}}\"> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/logoutmodal.html',
    "<md-dialog aria-label=\"delivery\" flex-gt-sm=\"30\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>Logout</h1> </div> </md-toolbar> <md-dialog-content layout-padding> You have been logged out of the system </md-dialog-content> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\"> Ok </md-button> </md-dialog-actions> </md-dialog>"
  );


  $templateCache.put('views/mailmodal.html',
    "<md-dialog aria-label=\"Organisation\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Mail</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <form name=\"mailForm\" ng-submit=\"mailForm.$valid && send()\"> <div class=\"layout-padding\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"to\">To</label> <input flex type=\"text\" name=\"to\" ng-model=\"email\" required> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"cropType\">Subject</label> <input flex type=\"text\" name=\"to\" ng-model=\"subject\" required> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"body\">Text</label> <textarea flex ng-model=\"bodytext\" rows=\"5\" required></textarea> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <md-button class=\"md-primary\" ng-href=\"{{pdfLink}}\" target=\"_BLANK\"> <i class=\"material-icons\">visibility</i> Preview Document </md-button> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\"> Send </md-button> </md-dialog-actions> </div> </div> </form> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/management-logs.html',
    "<div class=\"row\" restrict-access=\"BeeManagement Logs\"> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"first product-code-search\" flex-gt-xs=\"50\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search(searchString)\">search</i></md-icon> <input flex type=\"text\" name=\"logsSearchInput\" ng-model=\"searchString\" ng-change=\"search(searchString)\" class=\"search-box\" placeholder=\"Search: Action / Type / Location / Code\" focus-me=\"true\" aria-label=\"Search action / type / location / code\"> </md-input-container> </md-content> </div> <div layout-padding class=\"table-responsive\"> <h3>Transaction history</h3> <table id=\"logs-table\" class=\"table table-hover\" extended-table data-model=\"logs\" data-checkboxes=\"false\" data-clickable=\"false\" data-columns-data=\"{{logsColumns}}\"> <thead> <tr> <th>Created</th> <th>Action</th> <th>Type</th> <th>Code</th> <th>Location</th> <th>Modified by</th> </tr> </thead> </table> </div> </div>"
  );


  $templateCache.put('views/management-settings.html',
    "<md-dialog aria-label=\"delivery\" flex-gt-sm=\"80\" flex-gt-lg=\"60\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>Management Settings</h1> </div> </md-toolbar> <!-- {{prodform.$valid}} - {{activeProduct.type}} --> <form name=\"managementForm\" ng-submit=\"managementForm.$valid && save() \" novalidate> <div layout-gt-xs=\"row \" layout-padding> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"season\"><span class=\"required-asterisk\">Season</span></label> <md-select aria-label=\"Season\" name=\"season\" id=\"season\" ng-model=\"season\" required focus-me=\"true\"> <md-option ng-repeat=\"season in seasons\" ng-value=\"season\"> {{season}} </md-option> </md-select> <div ng-messages=\"harvestForm.season.$error\" ng-if=\"harvestForm.$submitted || harvestForm.season.$touched\"> <div ng-message=\"required\"> You must select a season. </div> </div> </md-input-container> <div class=\"md-block\" layout flex-gt-xs> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"startPop\"><span>Default StartPop Amount</span></label> <input name=\"startpop\" ng-model=\"startPopAmount\" type=\"number\" min=\"0\" aria-label=\"Default startpop amount\"> </md-input-container> </div> </div> <div layout-gt-xs=\"row \" class=\"layout-gt-xs-row pull-right\" layout-padding> <div flex></div> <md-button ng-click=\"cancel() \" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button type=\"submit \" class=\"md-primary\">Save</md-button> </div> </form> </md-dialog>"
  );


  $templateCache.put('views/management-statistics.html',
    "<div class=\"row\" restrict-access=\"BeeManagement Statistics\"> <h3>Current stock</h3> <div layout-padding class=\"table-responsive\"> <table> <tr> <td> <md-select aria-label=\"Organisation\" ng-model=\"selectedOrganisation\" ng-change=\"getStatistics(selectedOrganisation, selectedSeasons)\" ng-value=\"organisation.ID\"> <md-option ng-repeat=\"organisation in organisations\" ng-value=\"organisation.ID\" ng-selected=\"{{ organisation.ID == 0 ? 'true' : '' }}\"> {{organisation.NAME}} </md-option> </md-select> </td> <td> &nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;Season: &nbsp;&nbsp; <md-input-container> <label>Season</label> <md-select ng-model=\"selectedSeasons\" ng-change=\"getStatistics(selectedOrganisation, selectedSeasons)\" aria-label=\"Seasons\" multiple> <md-option ng-repeat=\"season in seasons\" ng-value=\"season\" ng-selected=\"{{ season == defaultSeason ? 'true' : '' }}\"> {{season}} </md-option> </md-select> </md-input-container> </td> </tr> </table> </div> <!--<br />--> <!--<div class=\"document_export\" excel-export export-data=\"exportData\" file-name=\"test\"></div>--> </div> <div layout-padding ng-show=\"statisticsData && statisticsData.length\"> <table id=\"statistics-table\" class=\"table table-sticky table-hover statistics-table\"> <thead> <tr> <th>Organisation</th> <th>Fridge</th> <th>Location</th> <th>Species</th> <th>Boxes</th> <th>Total Bees</th> <th>Populations</th> <th>Total Bees</th> </tr> </thead> <tbody> <tr ng-if=\"false\" ng-repeat-start=\"(organisationIndex, organisation) in statisticsData\"></tr> <tr ng-if=\"false\" ng-repeat-start=\"(fridgeIndex, fridge) in organisation.FRIDGES\"></tr> <tr ng-repeat=\"(insectIndex, insect) in fridge.INSECTS\"> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> <span ng-show=\"(fridgeIndex === 0) && (insectIndex === 0)\">{{organisation.ORGANISATION}}</span> </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> <span ng-show=\"insectIndex === 0\">{{fridge.FRIDGE_CD}}</span> </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> <span ng-show=\"insectIndex === 0\">{{fridge.LOCATION}}</span> </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> {{insect.NAME}} </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> {{addSeparator(insect.BOXES_COUNT)}} </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> {{addSeparator(insect.BOXES_BEES_TOTAL)}} </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> {{addSeparator(insect.POPULATIONS_COUNT)}} </td> <td ng-class=\"{'row-sum': showRomSum(organisationIndex, fridgeIndex, insectIndex)}\"> {{addSeparator(insect.POPULATIONS_BEES_TOTAL)}} </td> </tr> <tr ng-if=\"$last\"> <td class=\"row-sum-country\" colspan=\"3\">{{organisation.ORGANISATION}}</td> <td class=\"row-sum-country\">Total</td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_TOTAL.TOTAL_BOXES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_TOTAL.TOTAL_BOXES_BEES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_TOTAL.TOTAL_POPULATIONS)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_TOTAL.TOTAL_POPULATIONS_BEES)}} </td> </tr> <tr ng-if=\"$last\"> <td class=\"row-sum-country\" colspan=\"3\"></td> <td class=\"row-sum-country\">Osmia cornuta</td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_CORNUTA_TOTAL.TOTAL_BOXES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_CORNUTA_TOTAL.TOTAL_BOXES_BEES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_CORNUTA_TOTAL.TOTAL_POPULATIONS)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_CORNUTA_TOTAL.TOTAL_POPULATIONS_BEES)}} </td> </tr> <tr ng-if=\"$last\"> <td class=\"row-sum-country\" colspan=\"3\"></td> <td class=\"row-sum-country\">Osmia bicornis</td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_BICORNIS_TOTAL.TOTAL_BOXES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_BICORNIS_TOTAL.TOTAL_BOXES_BEES)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_BICORNIS_TOTAL.TOTAL_POPULATIONS)}} </td> <td class=\"row-sum-country\"> {{addSeparator(organisation.ORGANISATION_OSMIA_BICORNIS_TOTAL.TOTAL_POPULATIONS_BEES)}} </td> </tr> <tr ng-if=\"false\" ng-repeat-end></tr> <tr ng-if=\"false\" ng-repeat-end></tr> <tr> <td class=\"row-sum-country\" colspan=\"4\">Σ</td> <td class=\"row-sum-country\">{{addSeparator(totalData.ALL.BOXES)}}</td> <td class=\"row-sum-country\">{{addSeparator(totalData.ALL.BOXES_BEES)}}</td> <td class=\"row-sum-country\">{{addSeparator(totalData.ALL.POPULATIONS)}}</td> <td class=\"row-sum-country\"> {{addSeparator(totalData.ALL.POPULATIONS_BEES)}} </td> </tr> </tbody> </table> <!--<br />--> <!--<div class=\"document_export\" excel-export export-data=\"exportData\" file-name=\"test\"></div>--> </div>"
  );


  $templateCache.put('views/order-cultures-modal.html',
    "<md-dialog aria-label=\"cultures\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Cultures</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <form name=\"cultureItemForm\"> <div class=\"layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <table class=\"table table-hover order-item-table\"> <tr> <th>Order item</th> <th>No. of units ordered</th> <th>Culture</th> <th>No. of units allocated</th> </tr> <tr ng-if=\"false\" ng-repeat-start=\"(cultureOrderItemIndex, cultureOrderItem) in cultureOrderItems\"></tr> <tr ng-repeat=\"(cultureIndex, culture) in cultureOrderItem.cultures\"> <td ng-class=\"{'without-border': cultureIndex !== 0}\"> <span ng-show=\"cultureIndex === 0\">{{getText(cultureOrderItem)}}</span> </td> <td ng-class=\"{'without-border': cultureIndex !== 0}\"> <span ng-show=\"cultureIndex === 0\">{{cultureOrderItem.amount}}</span> </td> <td ng-class=\"{'without-border': cultureIndex !== 0}\"> {{culture.cultureType}} </td> <td ng-class=\"{'without-border': cultureIndex !== 0}\"> <md-input-container class=\"md-block\" flex-gt-sm> <input id=\"order_amount\" type=\"number\" name=\"order_amount_{{cultureOrderItemIndex}}\" ng-model=\"cultureOrderItems[cultureOrderItemIndex].cultures[cultureIndex].amount\" min=\"0\" ng-change=\"checkMax(cultureOrderItemIndex)\"> </md-input-container> </td> </tr> <tr ng-if=\"formErrors[cultureOrderItemIndex] !== undefined && formErrors[cultureOrderItemIndex] !== null\"> <td colspan=\"4\" class=\"without-border\"> <div class=\"validation-messages text-right\"> <div>{{formErrors[cultureOrderItemIndex]}}</div> </div> </td> </tr> <tr ng-if=\"false\" ng-repeat-end></tr> </table> </div> </div> </form> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-if=\"false\" ng-click=\"manageCultures()\" class=\"md-primary\" aria-label=\"New Culture\"> <i class=\"material-icons\">add</i> New Culture </md-button> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button ng-click=\"save()\" class=\"md-primary\" aria-label=\"Save\" ng-disabled=\"!checkSaveButton()\"> Save </md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/order-line-items-modal.html',
    "<md-dialog aria-label=\"Order Line Items\" class=\"order-line-items-modal\"> <md-dialog-content> <div class=\"md-dialog-content\"> <h2>Order Line Items</h2> <md-list> <md-list-item ng-repeat=\"item in order.lineItems\" class=\"md-3-line\"> <div class=\"md-list-item-text\" layout=\"column\"> <h3>{{item.name}}</h3> <h4 ng-if=\"item.sku\">SKU: {{item.sku}}</h4> <p ng-if=\"item.variant.product.title\"> Product: {{item.variant.product.title}} </p> <div ng-if=\"item.variant.product.tags.length > 0\"> <md-chips> <md-chip ng-repeat=\"tag in item.variant.product.tags\"> {{tag}} </md-chip> </md-chips> </div> </div> </md-list-item> </md-list> </div> </md-dialog-content> <md-dialog-actions> <md-button ng-click=\"closeDialog()\" class=\"md-primary\"> Close </md-button> </md-dialog-actions> </md-dialog>"
  );


  $templateCache.put('views/order-modal.html',
    "<md-dialog aria-label=\"order\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{title}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout-padding> <form name=\"orderForm\" class=\"\" ng-submit=\"orderForm.$valid && save()\"> <br> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"contractType\">Contract Type</label> <md-select id=\"contractType\" name=\"contractType\" ng-model=\"order.contractType\" ng-change=\"setDefaultSeason()\" ng-disabled=\"contractTypeDisabled || order.invoicedAt\"> <md-option ng-value=\"contract\" ng-repeat=\"contract in contractTypes\"> {{contract.code}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"orderSeason\">Season {{order.season}}</label> <md-select id=\"orderSeason\" name=\"orderSeason\" ng-model=\"order.season\" ng-disabled=\"contractTypeDisabled || order.invoicedAt\"> <md-option ng-value=\"season\" ng-repeat=\"season in seasons\" ng-disabled=\"(type!=='edit' && currentFarmer.subscriptionSeasonStatus[order.contractType.code][season].count!==currentFarmer.subscriptionSeasonStatus[order.contractType.code][season].invoicedCount) || (type==='edit' && !editSeasonSelectable[season])\"> {{season}} </md-option> </md-select> </md-input-container> <md-input-container ng-if=\"order.statusDescription.toLowerCase() === 'open' || order.statusDescription.toLowerCase() === 'draft' || order.statusDescription === undefined\" class=\"md-block\" flex-gt-xs> <label for=\"expiryDate\">Expiry Date</label> <md-datepicker ng-class=\"{'expired': orderService.isExpired(order)}\" id=\"expiryDate\" name=\"expiryDate\" ng-model=\"order.expiryDate\" md-placeholder=\"Enter date\" ng-disabled=\"order.invoicedAt\"></md-datepicker> </md-input-container> <md-input-container ng-if=\"order.statusDescription.toLowerCase() !== 'open' && order.statusDescription.toLowerCase() !== 'draft' && order.statusDescription !== undefined\" class=\"md-block\" flex-gt-xs> <label for=\"orderDate\">Order Date</label> <input name=\"orderDate\" id=\"orderDate\" name=\"orderDate\" type=\"text\" ng-model=\"order.date\" md-placeholder=\"Enter date\" ng-disabled=\"true\"> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"currency\">Currency</label> <md-select id=\"currency\" name=\"currency\" ng-model=\"order.currency\" ng-disabled=\"order.invoicedAt\"> <md-option ng-value=\"currency\" ng-repeat=\"currency in currencies\"> {{currency.code}} </md-option> </md-select> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"paymentType\">Payment Type</label> <md-select id=\"paymentType\" name=\"paymentType\" ng-model=\"order.paymentType\" ng-disabled=\"order.invoicedAt\"> <md-option ng-value=\"payType\" ng-repeat=\"payType in paymentTypes\"> {{payType.DESCRIPTION}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"paymentTerm\">Payment Term</label> <md-select id=\"paymentTerm\" name=\"paymentTerm\" ng-model=\"order.paymentTerm\" ng-disabled=\"order.invoicedAt\"> <md-option ng-value=\"payTerm\" ng-repeat=\"payTerm in paymentTerms\"> {{payTerm.DESCRIPTION}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"paymentInvoiceDate\">Invoice Date</label> <md-datepicker id=\"paymentInvoiceDate\" name=\"paymentInvoiceDate\" md-min-date=\"minPaymentInvoiceDate\" ng-model=\"order.paymentInvoiceDate\" md-placeholder=\"Enter date\" ng-disabled=\"order.invoicedAt\"></md-datepicker> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs ng-show=\"order.paymentType.CODE=='downpayment'\"> <label for=\"downpayment\">Down Payment</label> <input id=\"downpayment\" name=\"downpayment\" flex type=\"number\" min=\"0\" step=\".01\" name=\"downpayment\" ng-model=\"order.downpayment\" ng-disabled=\"order.invoicedAt\"> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs ng-show=\"order.paymentType.CODE!=='downpayment'\"> </md-input-container> </div> </form> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-subheader> Line Items </md-subheader> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-block flex> <div ng-show=\"order.orderItems.length\"> <table class=\"table table-hover\"> <tr> <th>Type</th> <th>Pos.</th> <th>Product</th> <th>Text</th> <th>#ordered</th> <th ng-if=\"isOrder\">#req cases</th> <th ng-if=\"isOrder\">#req boxes</th> <th ng-if=\"isOrder\">#req pops</th> <th class=\"text-right\">Price</th> <th class=\"text-right\">Discount in %</th> <th class=\"text-right\">VAT</th> <th class=\"text-right\">Total</th> <th class=\"text-right text-grey\">%</th> </tr> <tr ng-repeat=\"orderItem in order.orderItems\" ng-click=\"selectOrderItem($index)\" class=\"order-line order-line{{$index}}\"> <td ng-switch=\"orderItem.type.code\" class=\"center-align\"> <span ng-switch-when=\"Product\"><img src=\"images/product.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Discount_perct\"><img src=\"images/percentage-discount.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Discount_fixed\"><img src=\"images/fixed-discount.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Free\"><img src=\"images/free-line.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Shipping\"><img src=\"images/shipping.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Text\"><img src=\"images/text.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Replacement\"><img src=\"images/replacement.png\" alt=\"\" width=\"20\"></span> </td> <td>{{orderItem.pos}}</td> <td ng-switch=\"orderItem.type.code\" colspan=\"{{orderItem.type.code.toLowerCase() === 'text' ? 2 : 1}}\"> <span ng-switch-when=\"Product\">{{orderItem.product.SPROD_CD}}</span> <span ng-switch-when=\"Replacement\">{{orderItem.product.SPROD_CD}}</span> <span ng-switch-when=\"Text\">{{orderItem.text}}</span> <span ng-switch-default>-</span> </td> <td ng-if=\"orderItem.type.code.toLowerCase() !== 'text'\"> {{orderItem.text}} </td> <td><span ng-show=\"orderItem.amount\">{{orderItem.amount}}</span></td> <td ng-if=\"isOrder\"> <span ng-show=\"orderItem.type.code.toLowerCase() == 'product'\">{{orderItem.requested.case}}</span> </td> <td ng-if=\"isOrder\"> <span ng-show=\"orderItem.type.code.toLowerCase() == 'product'\">{{orderItem.requested.box}}</span> </td> <td ng-if=\"isOrder\"> <span ng-show=\"orderItem.type.code.toLowerCase() == 'product'\">{{orderItem.requested.pop}}</span> </td> <td class=\"text-right\"> <span ng-show=\"orderItem.type.code.toLowerCase() !== 'discount_perct' && orderItem.type.code.toLowerCase() !== 'text'\">{{orderItem.price | number : 2}}</span> </td> <td class=\"text-right\"> <span ng-show=\"orderItem.type.code.toLowerCase() === 'discount_perct'\">{{orderItem.price | number : 2}} %</span><span ng-show=\"orderItem.type.code.toLowerCase() !== 'discount_perct' && orderItem.discount\">{{orderItem.discount | number : 2}} %</span> </td> <td class=\"text-right\"> <span ng-show=\"orderItem.type.code.toLowerCase() !== 'text'\">{{orderItem.vat.VALUE}}</span> </td> <td class=\"text-right\"> <span ng-show=\"orderItem.type.code.toLowerCase() !== 'text'\">{{orderItem.subtotal | number : 2}}</span> </td> <td class=\"text-right text-grey text-bold\">{{orderItem.percentage}}</td> </tr> <tr class=\"order-total\" ng-repeat=\"rateId in getMergedRatesIds()\" style=\"text-align: right\"> <td colspan=\"5\"></td> <td colspan=\"3\" ng-if=\"isOrder\"></td> <td colspan=\"2\"></td> <td> <span class=\"text-right\" ng-show=\"taxInclusive==1\">VAT Incl. {{getRateById(rateId).VALUE}}%:</span> <span class=\"text-right\" ng-show=\"taxInclusive!=1\">VAT Excl. {{getRateById(rateId).VALUE}}%:</span> </td> <td><span>{{valueByRateId(rateId) | number: 2}}</span></td> <td></td> </tr> <tr class=\"order-total\" ng-show=\"vatTotal && getMergedRatesIds().length > 1\" style=\"text-align: right\"> <td colspan=\"5\"></td> <td colspan=\"3\" ng-if=\"isOrder\"></td> <td colspan=\"2\"></td> <td> <span class=\"text-right\">VAT Total</span> </td> <td><span>{{vatTotal}}</span></td> <td></td> </tr> <tr class=\"order-total\" ng-show=\"orderTotal\" style=\"text-align: right\"> <td colspan=\"5\"></td> <td colspan=\"3\" ng-if=\"isOrder\"></td> <td colspan=\"2\"></td> <td><span class=\"text-right text-bold\">Total</span></td> <td><span class=\"text-bold\">{{orderTotal}}</span></td> <td></td> </tr> </table> </div> <div class=\"customer-product-actions\" layout=\"row\"> <md-button type=\"button\" class=\"md-warn\" ng-click=\"deleteOrderItem()\" ng-show=\"selectedOrderItem  && !order.invoicedAt\" ng-disabled=\"selectedOrderItem.requested.total > 0\"> <i class=\"material-icons\">remove</i> Delete </md-button> <md-button type=\"button\" class=\"md-primary\" ng-click=\"editOrderItem()\" ng-show=\"selectedOrderItem && !order.invoicedAt\"> <i class=\"material-icons\">mode_edit</i> Edit </md-button> </div> </md-block> </div> <form id=\"lineform\" name=\"lineform\" role=\"form\" ng-submit=\"lineform.$valid && addLineItem()\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\" ng-if=\"showRowEditor\"> <md-input-container class=\"md-block\"> <label for=\"positionType\">Position Type</label> <md-select id=\"positionType\" name=\"positionType\" ng-model=\"activeOrderItem.type\" ng-disabled=\"selectedOrderItem\" ng-change=\"updateOrderAmount()\"> <md-option ng-value=\"position\" ng-repeat=\"position in positionTypes\" ng-disabled=\"(position.code=='Discount_perct' && discountPercentageExists) || (position.code=='Discount_fixed' && discountFixedExists)\" ng-click=\"discountAlert(position)\"> <div ng-switch=\"position.code\"> <span ng-switch-when=\"Product\"><img src=\"images/product.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Discount_perct\"><img src=\"images/percentage-discount.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Discount_fixed\"><img src=\"images/fixed-discount.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Free\"><img src=\"images/free-line.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Shipping\"><img src=\"images/shipping.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Text\"><img src=\"images/text.png\" alt=\"\" width=\"20\"></span> <span ng-switch-when=\"Replacement\"><img src=\"images/replacement.png\" alt=\"\" width=\"20\"></span> </div> </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs ng-if=\"activeOrderItem.type.code.toLowerCase() === 'product' || activeOrderItem.type.code.toLowerCase() === 'replacement'\"> <label for=\"contractType\">Product</label> <md-select name=\"contractType\" ng-model=\"activeOrderItem.product\" ng-change=\"updateDescription(activeOrderItem.type.code.toLowerCase());updateOrderAmount()\"> <md-option ng-value=\"product\" ng-repeat=\"product in products | filter: { SPROD_STATUS_ID: '1' }\"> {{product.SPROD_NAME}} <!-- ({{product.SPROD_CD}}) --> </md-option> </md-select> </md-input-container> <md-input-container flex-gt-xs> <label>Description</label> <input flex type=\"text\" name=\"descriptionInput\" ng-model=\"activeOrderItem.text\"> </md-input-container> <div ng-if=\"quantityVisible\" flex-gt-xs=\"10\"> <md-input-container> <label>{{quantityTitle}}</label> <input flex type=\"number\" name=\"quantity\" id=\"quantity\" ng-model=\"activeOrderItem.amount\" ng-required=\"quantityVisible\" min=\"{{activeOrderItem.minOrderAmount}}\" ng-change=\"setPrice(activeOrderItem.type.code.toLowerCase(), activeOrderItem.price);setCount(activeOrderItem.type.code.toLowerCase(), activeOrderItem.amount);updateOrderAmount();updateOrderItemTotal(activeOrderItem)\"> <div ng-messages=\"lineform.$error\" ng-if=\"lineform.$submitted || lineform.quantity.$touched\"> <div ng-message=\"min\"> Cannot be smaller than units already requested or one. </div> </div> </md-input-container> </div> <md-input-container flex-gt-xs=\"10\" ng-if=\"priceVisible\"> <label>{{priceTitle}}</label> <input flex type=\"text\" name=\"price\" ng-pattern=\"/^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$/\" ng-model=\"activeOrderItem.price\" ng-required=\"priceVisible\" ng-change=\"setPrice(activeOrderItem.type.code.toLowerCase(), activeOrderItem.price);updateOrderItemTotal(activeOrderItem)\"> </md-input-container> <md-input-container flex-gt-xs=\"10\" ng-if=\"activeOrderItem.type.code.toLowerCase() != 'discount_perct' && activeOrderItem.type.code.toLowerCase() != 'discount_fixed' && activeOrderItem.type.code.toLowerCase() != 'text'\"> <label>Discount in %</label> <input flex type=\"text\" name=\"discount\" ng-pattern=\"/^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$/\" ng-model=\"activeOrderItem.discount\" ng-change=\"updateOrderItemTotal(activeOrderItem)\"> </md-input-container> <md-input-container flex-gt-xs=\"10\" ng-if=\"activeOrderItem.type.code.toLowerCase() != 'discount_perct' && activeOrderItem.type.code.toLowerCase() != 'discount_fixed' && activeOrderItem.type.code.toLowerCase() != 'text'\"> <label>VAT</label> <md-select name=\"vat\" ng-model=\"activeOrderItem.vat\" ng-model-options=\"{trackBy: '$value.ID'}\"> <md-option ng-repeat=\"organisationVAT in organisationVATs\" ng-value=\"organisationVAT\"> {{organisationVAT.VALUE}} </md-option> </md-select> </md-input-container> <md-input-container flex-gt-xs=\"10\" ng-if=\"activeOrderItem.type.code.toLowerCase() !== 'text'\"> <label>Total</label> <input flex type=\"number\" name=\"size\" ng-model=\"activeOrderItem.subtotal\" ng-disabled=\"true\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div flex></div> <md-button class=\"md-primary\" type=\"button\" ng-click=\"clearLine()\" ng-if=\"showRowEditor\"> <i class=\"material-icons\">remove</i> cancel </md-button> <md-button class=\"md-primary\" type=\"submit\" ng-show=\"showRowEditor\"> <i class=\"material-icons\">add</i> {{addLineTitle}} </md-button> </div> </form> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div flex></div> <md-button type=\"button\" class=\"md-primary\" ng-click=\"addLineItem()\" ng-show=\"!showRowEditor && !order.invoicedAt\"> <i class=\"material-icons\">add</i> {{addLineTitle}} </md-button> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button ng-click=\"save()\" class=\"md-primary\" ng-disabled=\"showRowEditor || order.invoicedAt\" aria-label=\"save\"> Save </md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/order-panel.html',
    "<div class=\"section\"> <div layout=\"row\"> <h3>{{title}}</h3> <div flex></div> <div md-button ng-click=\"createOrder('new')\" class=\"md-primary\"> <i class=\"material-icons\">add</i> Add an {{type}} </div> </div> <div class=\"client-products\" ng-show=\"farmer.orders.length\"> <table class=\"table table-hover orders-table\"> <tr> <th>Order ID</th> <th>Season</th> <th>Order date</th> <th>Contract Type</th> <th>Units</th> <th>Total</th> <th>Requested</th> <th>ERP ID</th> <th>Invoiced at</th> <th>Status</th> </tr> <tr ng-repeat=\"(orderIndex, order) in farmer.orders\" ng-click=\"selectOrder(orderIndex)\" ng-dblclick=\"editOrder(farmer.activeOrder, 'edit')\" class=\"{{type}}-line {{type}}-line{{orderIndex}}\" data-orderid=\"{{order.ID}}\" data-index=\"{{orderIndex}}\" ng-class=\"{'info': order.selected}\" ng-if=\"inSeason(order.season) && isActive(order.aboID)\"> <td class=\"text-center\">{{order.ID}}</td> <td class=\"text-center\">{{order.season}}</td> <td>{{order.date | date:'dd/MM/yyyy' }}</td> <td>{{order.contractType}}</td> <td class=\"text-center\">{{order.numStands}}</td> <td class=\"text-center\">{{order.totalPrice}}</td> <td class=\"text-center\"> <i class=\"material-icons md-primary\" ng-hide=\"order.notYetRequested === undefined || order.notYetRequested > 0\">done</i> <i class=\"material-icons md-warn\" ng-show=\"order.notYetRequested === undefined || order.notYetRequested > 0\">clear</i> </td> <td class=\"text-center\">{{order.ERPDisplayID}}</td> <td class=\"text-center\"> {{order.invoicedAt.replace(\" \",\"T\") | date:'dd/MM/yyyy' }} </td> <td class=\"text-center\"> <span ng-class=\"{'md-warn': orderService.isExpired(order, true)}\">{{order.statusDescription}}</span> </td> </tr> </table> </div> <alert type=\"danger\" close=\"closeAlert()\" ng-show=\"errorMSG != null\"> {{errorMSG}} </alert> <div class=\"customer-product-actions\" layout=\"row\"> <div flex></div> <div md-button ng-click=\"deleteOrder(farmer.farmer.activeOrder.ID)\" class=\"md-warn\" ng-show=\"farmer.activeOrder\" ng-disabled=\"farmer.activeOrder.requests.length\"> <i class=\"material-icons\">remove</i> Delete </div> <div md-button ng-click=\"editOrder(farmer.activeOrder, 'edit')\" class=\"md-primary\" ng-show=\"farmer.activeOrder\" ng-disabled=\"farmer.activeOrder.invoicedAt!==null\"> <i class=\"material-icons\">mode_edit</i> Edit </div> <md-button ng-click=\"cultureItems()\" class=\"md-primary\" ng-show=\"farmer.activeOrder\" ng-disabled=\"(farmer.activeOrder && farmer.activeOrder.cultureItems.length === 0)\" ng-bind-html=\"culturesButtonLabel\"> </md-button> <div md-button ng-click=\"printOrder()\" class=\"md-primary\" ng-show=\"farmer.activeOrder\"> <i class=\"material-icons\">file_download</i> PDF </div> <div md-button ng-click=\"emailOrder()\" class=\"md-primary\" ng-show=\"activeEmailButton(farmer.activeOrder)\" restrict-access=\"Email Documents\"> <i class=\"material-icons\">email</i> Email </div> <div ng-show=\"farmer.activeOrder\"> <md-menu> <md-button aria-label=\"Open demo menu\" class=\"md-primary\" ng-click=\"$mdMenu.open($event)\"> <i class=\"material-icons\">arrow_drop_down</i> Status </md-button> <md-menu-content width=\"3\"> <md-menu-item ng-repeat=\"status in statuses\"> <md-button ng-click=\"setStatus(status.ID, farmer.activeOrder.ID)\" ng-disabled=\"!activeStatusMenu(farmer.activeOrder, status)\"> {{status.DESCRIPTION}} </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <div md-button ng-click=\"editOrder(farmer.activeOrder, 'copy')\" class=\"md-primary\" ng-show=\"farmer.activeOrder\"> <i class=\"material-icons\">file_copy</i> Copy </div> </div> </div>"
  );


  $templateCache.put('views/organisation-panel.html',
    "<div class=\"row results panel panel-default admin-section\" flex-gt-xs restrict-access=\"Admin\"> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"first product-code-search\" flex-gt-xs=\"50\"> <md-input-container class=\"md-block block\"> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search(searchString)\">search</i></md-icon> <input flex type=\"text\" ng-model=\"searchString\" ng-change=\"timeoutedSearch(searchString)\" class=\"search-box\" placeholder=\"Search\" focus-me=\"true\"> </md-input-container> <div layout-gt-xs=\"column\" flex layout-align=\"start start\"></div> </md-content> </div> <div layout=\"row\" class=\"panel-heading\"> <h3 class=\"no-caps\">{{orgsCount}} results</h3> <div flex></div> <md-button id=\"organisation-settings\" class=\"no-caps\" ng-click=\"editOrganisation()\" ng-disabled=\"selectedOrganisations.length != 1\">Settings</md-button> <md-button class=\"no-caps\" ng-click=\"editDocument()\" ng-disabled=\"selectedOrganisations.length != 1\">Text modules</md-button> <md-button class=\"no-caps\" ng-click=\"deleteOrganisation()\" ng-disabled=\"selectedOrganisations.length != 1\">Delete</md-button> </div> <md-table-container> <table md-table md-row-select ng-model=\"selectedOrganisations\" md-progress=\"promise\"> <thead md-head> <tr md-row> <th md-column><span>ID</span></th> <th md-column><span>Short Name</span></th> <th md-column><span>Description</span></th> <th md-column><span>Country</span></th> <th md-column><span>Parent Organisation</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"org\" md-select-id=\"org.ID\" ng-repeat=\"org in organisations\" ng-dblclick=\"editOrganisation(org.ID)\"> <td md-cell>{{org.ID}}</td> <td md-cell>{{org.NAME}}</td> <td md-cell>{{org.DESCRIPTION}}</td> <td md-cell>{{org.country}}</td> <td md-cell>{{org.parent}}</td> </tr> </tbody> </table> </md-table-container> </div>"
  );


  $templateCache.put('views/product-create.html',
    "<md-dialog aria-label=\"delivery\" flex-gt-sm=\"80\" flex-gt-lg=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1>{{title}}</h1> </div> </md-toolbar> <!-- {{prodform.$valid}} - {{activeProduct.type}} --> <form name=\"prodform\" ng-submit=\"prodform.$valid && save() \" novalidate> <div layout=\"row\">&nbsp;</div> <div layout-gt-xs=\"row \" layout-padding ng-show=\"!showConfirmation\"> <md-input-container class=\"md-block\" flex-gt-xs> <label><span class=\"required-asterisk\">Product {{prodStyle}}</span></label> <md-select name=\"productId\" id=\"productId\" ng-model=\"activeProduct.PROD_ID\" required focus-me=\"true\"> <md-option ng-repeat=\"product in products | orderBy : ['DISPLAY_SEQUENCE', 'ID']\" ng-value=\"product.ID\"> <span ng-style=\"{{productStyle($index)}}\">{{product.PROD_NAME}} ({{product.PROD_CD}})</span> </md-option> </md-select> <div ng-messages=\"prodform.productId.$error\" ng-if=\"prodform.$submitted || prodform.productId.$touched\"> <div ng-message=\"required\"> You must select a product. </div> </div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label>House code</label> <input id=\"code\" name=\"code\" type=\"text\" ng-model=\"activeProduct.code\" ng-pattern=\"getRegex()\" required capitalize> <div ng-messages=\"prodform.$error\" ng-if=\"prodform.$submitted || prodform.code.$touched\"> <div ng-message=\"required\"> You must provide a code. </div> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> <!--  <span class=\"alert alert-warning input-group \" style=\"margin-bottom: 25px \" ng-show=\"productform.productCode.$error.pattern && showError \">\n" +
    "\t\t\t\t\t\tthe code must be exactly 7 digits long, the 3rd position must be a letter, all other positions must be numbers.\n" +
    "\t\t\t\t</span>\t --> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row pull-right\" layout-padding> <div flex></div> <md-button ng-click=\"cancel()\" class=\"md-warn md-hue-1\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\">Save</md-button> <md-button class=\"md-primary\" tabindex=\"13\" ng-show=\"showConfirmation\">Confirm</md-button> </div> </form> </md-dialog>"
  );


  $templateCache.put('views/product-details.html',
    "<div class=\"section\"> <div layout=\"row\"> <h3> Products<br><span style=\"font-size: x-small\" ng-if=\"productCount!=fullCount\"><span class=\"md-warn\">Listing {{productCount}} Of {{fullCount}} Customer Products</span>&nbsp;&nbsp;&nbsp;<span class=\"general-link\" ng-click=\"clearFilter()\"><i class=\"material-icons\">add</i>Show All</span></span> </h3> <div flex></div> <div layout=\"top\" md-button ng-click=\"addClientProduct()\" class=\"md-primary\" ng-hide=\"disableEdit==1\" style=\"max-height: 41px\"> <i class=\"material-icons\">add</i> Add {{disableEdit}} </div> </div> <div class=\"client-products\" ng-show=\"clientProducts.length\"> <md-table-container> <table md-table md-row-select multiple ng-model=\"selectedProducts\" md-progress=\"promise\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getCustomerProducts\"> <tr md-row> <th class=\"product-head\" md-column md-order-by=\"code\" valign=\"middle\"> Code </th> <th class=\"product-head\" md-column md-order-by=\"name\" valign=\"middle\"> Product </th> <th class=\"product-head\" md-column valign=\"middle\">BeeCare Status</th> <th class=\"product-head\" md-column md-order-by=\"CONSIGNMENT_NR\" valign=\"middle\"> Label </th> <th class=\"product-head\" md-column valign=\"middle\"> Notes </th> <th class=\"product-head\" md-column valign=\"middle\"> Address </th> <th class=\"product-head\" md-column md-order-by=\"createdBy\" valign=\"middle\"> Created By </th> <th class=\"product-head\" md-column md-order-by=\"dateCreated\" valign=\"middle\"> Created At </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"product in clientProducts\" md-select-id=\"product.code\" md-select=\"product\" md-auto-select ng-dblclick=\"selectOneProduct(product)\" md-on-select=\"setVoucher\"> <td md-cell valign=\"bottom\"> {{product.code}}<br>{{product.beehomeName}} </td> <td md-cell valign=\"bottom\">{{product.name}}</td> <td md-cell valign=\"bottom\"> <div product-progress-indicator product=\"product\" client-id=\"client.id\" users=\"users\"></div> </td> <td md-cell valign=\"bottom\"> <tracking-number number=\"product.CONSIGNMENT_NR\"> </td> <td md-cell valign=\"bottom\"> <span class=\"general-link\"> <md-button class=\"md-icon-button\" ng-click=\"openNotesEditor(product.code)\" aria-label=\"Edit notes\"> <i class=\"material-icons\">chat_bubble_outline</i> <span ng-if=\"product.displayNoteFlag\" style=\"position: absolute; top: 2px; right: 5px\"><i class=\"material-icons hasFlagDot\">lens</i></span> </md-button> </span> </td> <td md-cell valign=\"bottom\"> <span class=\"general-link\"> <md-select name=\"address\" ng-model=\"product.address\" ng-model-options=\"{trackBy: '$value.id'}\" md-on-open=\"openValue = product.address.id\" md-on-close=\"product.address.id !== openValue && updateProduct(product)\" placeholder=\"[Main Address]\"> <md-option style=\"min-height: 6em\" ng-repeat=\"address in client.addresses\" ng-value=\"address\"> <span ng-if=\"defaultAddress.id != address.id\"> <span ng-show=\"address.first_name || address.last_name\">{{address.first_name + \" \" + address.last_name}}<br></span> <span ng-show=\"address.company_name\">{{address.company_name}}<br></span> {{address.address_1}}<br> <span ng-if=\"address.address_2\">{{address.address_2}}<br></span> {{address.country_code}}-{{address.postal_code}} {{address.town}} </span> <span ng-if=\"defaultAddress.id==address.id\">[Main Address]</span> </md-option> </md-select> </span> </td> <td md-cell valign=\"bottom\">{{users[product.CRE_BY].firstName}}</td> <td md-cell valign=\"bottom\"> {{product.dateCreated | date:'dd/MM/yyyy'}} </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"query.limitOptions\" md-page=\"query.page\" md-total=\"{{productCount}}\" md-page-select md-on-paginate=\"getCustomerProducts\"></md-table-pagination> <div class=\"customer-product-actions pull-right\" layout=\"row\" ng-show=\"!disableEdit\"> <div class=\"md-block\" flex-gt-sm> <md-button class=\"md-primary\" ng-click=\"historyModal('product')\" ng-disabled=\"selectedProducts.length != 1\"> <i class=\"material-icons\">history</i> History </md-button> </div> <div class=\"md-block\" flex-gt-sm> <md-button class=\"md-primary\" ng-click=\"printShippingLabel()\" ng-disabled=\"!selectedProducts.length\"> <i class=\"material-icons\">local_shipping</i> Print New Shipping Label </md-button> </div> <div class=\"md-block\" flex-gt-sm> <md-button class=\"md-primary\" ng-click=\"printQRCode()\" ng-disabled=\"selectedProducts.length != 1\"> <i class=\"material-icons\">print</i> Print QR Code </md-button> </div> <div class=\"md-block\" flex-gt-sm layout-align=\"left center\"> <md-button class=\"md-primary\" ng-click=\"editProduct()\" ng-disabled=\"selectedProducts.length != 1\"><i class=\"material-icons\">edit</i> Edit </md-button> </div> <div class=\"md-block\" flex-gt-sm restrict-access=\"Delete House\"> <md-button class=\"md-warn\" ng-click=\"delete()\" ng-show=\"selectedProducts.length\"> <i class=\"material-icons\">remove</i> Delete </md-button> </div> </div> </div> <br> <alert type=\"danger\" close=\"closeAlert()\" ng-show=\"errorMSG != null\"> {{errorMSG}} </alert> </div> <div class=\"section\"> <div class=\"row\" ng-show=\"selectedProducts.length == 1\"> <div layout=\"column\" flex=\"100\"> <h3>Voucher</h3> <beehome-voucher-search ng-model=\"selectedProducts[0].voucher\" selected-item-change=\"addVoucher\" type=\"BEECARE\" organisation-id=\"client.organisation.id\" style=\"max-width: 400px\"></beehome-voucher-search> </div> </div> </div> <div class=\"section\"> <div class=\"row\" ng-show=\"selectedProducts.length == 1\"> <h3> Snapshot <i class=\"material-icons action-primary-true\" ng-show=\"sendMailsActive\" style=\"padding-bottom:2px;padding-left:12px\">mail_outline <md-tooltip md-direction=\"top\"> Auto emails are enabled</md-tooltip> </i> </h3> <div class=\"client-products\" layout=\"row\"> <div layout=\"column\" ng-repeat=\"snapshot in selectedProducts[0].SNAPSHOTS\"> <md-card md-theme-watch class=\"snapshot_img\"> <md-card-title> <md-card-title-media> <div class=\"md-media-lg card-media\" style=\"background:url('{{snapshot.SNAPSHOT_URL}}')\" ng-dblclick=\"openPreview(snapshot.SNAPSHOT_URL, selectedProducts[0].code)\" flex layout=\"row\" layout-align=\"end\"> <div class=\"snapshot-actions\"> <button class=\"md-fab md-fab-mini md-warn md-mini md-button\"> <i class=\"material-icons action-icon\" ng-click=\"deleteSnapshot(snapshot)\" role=\"button\">remove</i> </button> </div> </div> </md-card-title-media> </md-card-title> </md-card> </div> <div layout=\"column\"> <md-card ng-click=\"openSnapshotModal()\" md-theme-watch> <md-card-title> <md-card-title-media> <div class=\"md-media-lg card-media snapshot_img\"> <i class=\"material-icons add_image\">add</i> </div> </md-card-title-media> </md-card-title> </md-card> </div> </div> </div> </div>"
  );


  $templateCache.put('views/product-history.html',
    "<div layout-gt-md=\"row\" class=\"table-responsive\"> <table class=\"table table-hover\"> <tr> <td><strong>Season</strong></td> <td><strong>Transaction</strong></td> <td><strong>Product</strong></td> <td><strong>Code</strong></td> <td><strong>Processed on</strong></td> <td><strong translate=\"tubes.inhabited\">Tubes</strong></td> <td><strong translate=\"general.cocoons\">Cocoons</strong></td> </tr> <tr ng-repeat=\"event in product.history | orderBy:'-CRE_AT'\"> <td>{{event.SEASON}}</td> <td>{{event.transaction}}</td> <td>{{event.product}}</td> <td>{{event.code}}</td> <td>{{event.CRE_AT | date:'dd/MM/yyyy'}}</td> <td>{{event.tubes}}</td> <td>{{event.cocoons}}</td> </tr> </table> </div>"
  );


  $templateCache.put('views/product-link.html',
    "<div class=\"section\"> <div layout=\"row\"> <h3>Customer</h3> <div flex></div> <md-button class=\"md-primary\" ng-click=\"addCustomer()\"> <i class=\"material-icons\">add</i>&nbsp;Add New </md-button> <client-search wbp-selected=\"assignAccount\" ng-hide=\"startpoporder.ID || startpoporder.CLIENT_ID\" wbp-floating-label=\"Assign existing client\" selected-item=\"\"> </client-search> </div> <div> House {{house.code}} is not associated to a Customer </div> </div> <div class=\"section\"> <div product-details house=\"house\" client=\"\" client-products=\"\" defaultaddress=\"\" disableedit=\"\" users=\"$resolve.users\"></div> </div>"
  );


  $templateCache.put('views/product-progress-indicator.html',
    "<div style=\"min-width: 475px\"> <span class=\"progress-indicator\" ng-class=\"{\n" +
    "\t\t'progress-indicator-true': product.ORDER_ID,\n" +
    "\t\t'ticket': product.order && (!product.order.psp || product.order.created_by.length !== 28)\n" +
    "\t\t}\"> <a class=\"progress-indicator-text\" ng-href=\"{{orderLink(product.ORDER_ID)}}\"><span translate=\"beecare.registration\">Registration</span></a> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\"> <span translate=\"beecare.registered_on\">Registered on </span>{{product.TRX_DATE | date:'dd/MM/yyyy'}} </md-tooltip> </span> <span class=\"progress-indicator\" ng-class=\"getStatusClass(product.BEECARE_STEP1_COMPLETE)\"> <a class=\"progress-indicator-text\" ng-href=\"{{customerLink(clientId, linkCode)}}\" translate=\"general.customer\">Customer</a> </span> <span class=\"progress-indicator\" ng-class=\"getStatusClass(product.BEECARE_STEP2_COMPLETE)\"> <a class=\"progress-indicator-text\" ng-href=\"{{tubesLink(linkCode)}}\"><span translate=\"general.tube\">Tube</span></a> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\"> <span translate=\"general.modified_by\">Modified By:</span> <span ng-if=\"product.BEECARE_STEP2_UPD_BY\">{{users[product.BEECARE_STEP2_UPD_BY].fullName}}</span><span ng-if=\"!product.BEECARE_STEP2_UPD_BY\"><span translate=\"general.na\">n/a</span></span> <br> <span translate=\"general.modified_at\">Modified At:</span> <span ng-if=\"product.BEECARE_STEP2_UPD_AT\">{{product.BEECARE_STEP2_UPD_AT | date:'dd/MM/yyyy'}}</span><span ng-if=\"!product.BEECARE_STEP2_UPD_AT\"><span translate=\"general.na\">n/a</span></span> </md-tooltip> </span> <span class=\"progress-indicator\" ng-class=\"getStatusClass(product.BEECARE_STEP3_COMPLETE)\"> <a class=\"progress-indicator-text\" ng-href=\"{{cocoonsLink(linkCode)}}\"><span translate=\"general.cocoon\">Cocoon</span></a> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\"> <span translate=\"general.modified_by\">Modified By:</span> <span ng-if=\"product.BEECARE_STEP3_UPD_BY\">{{users[product.BEECARE_STEP3_UPD_BY].fullName}}</span><span ng-if=\"!product.BEECARE_STEP3_UPD_BY\"><span translate=\"general.na\">n/a</span></span> <br> <span translate=\"general.modified_at\">Modified At:</span> <span ng-if=\"product.BEECARE_STEP3_UPD_AT\">{{product.BEECARE_STEP3_UPD_AT | date:'dd/MM/yyyy'}}</span><span ng-if=\"!product.BEECARE_STEP3_UPD_AT\"><span translate=\"general.na\">n/a</span></span> </md-tooltip> </span> <span class=\"progress-indicator\" ng-class=\"getStatusClass(product.BEECARE_STEP4_COMPLETE)\" ng-hide=\"product.season < 2020 || product.SEASON < 2020\"> <a class=\"progress-indicator-text\"><span translate=\"harvest.check\">Check</span></a> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\"> <span translate=\"general.modified_by\">Modified By:</span> <span ng-if=\"product.BEECARE_STEP4_UPD_BY\">{{users[product.BEECARE_STEP4_UPD_BY].fullName}}</span><span ng-if=\"!product.BEECARE_STEP4_UPD_BY\"><span translate=\"general.na\">n/a</span></span> <br> <span translate=\"general.modified_at\">Modified At:</span> <span ng-if=\"product.BEECARE_STEP4_UPD_AT\">{{product.BEECARE_STEP4_UPD_AT | date:'dd/MM/yyyy'}}</span><span ng-if=\"!product.BEECARE_STEP4_UPD_AT\"><span translate=\"general.na\">n/a</span></span> </md-tooltip> </span> <span class=\"progress-indicator invoice\" ng-class=\"{\n" +
    "\t\t'progress-indicator-true': product.order && product.order.bexio_id,\n" +
    "\t\t'ticket': product.order && product.order.total_price == 0\n" +
    "\t\t}\" ng-hide=\"product.order && product.order.psp && product.order.psp != 'INVOICE'\"> <a class=\"progress-indicator-text\" ng-href=\"{{bexioLink(product.order.bexio_id)}}\" target=\"_BLANK\" ng-hide=\"product.order && product.order.total_price == 0\"> <span translate=\"general.invoice\">Invoice</span> </a> <span class=\"progress-indicator-text\" ng-show=\"product.order && product.order.total_price == 0\"> <span translate=\"general.ticket\">Ticket</span> </span> <md-tooltip class=\"tooltip-multiline\" md-direction=\"top\" ng-if=\"product.order.bexio_nr\"> <span translate=\"general.invoice\">Invoice</span> <span>{{product.order.bexio_nr}}</span> <br> </md-tooltip> </span> </div>"
  );


  $templateCache.put('views/products-modal.html',
    "<md-dialog aria-label=\"Organisation\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\" class=\"products-modal\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{action}} Product</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"productForm\" ng-submit=\"productForm.$valid && saveProduct()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Product code*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Product code\" flex type=\"text\" name=\"code\" ng-model=\"product.PROD_CD\" required focus-me=\"true\"> <div ng-messages=\"productForm.code.$error\" ng-if=\"productForm.$submitted || productForm.code.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Name*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Product name\" flex type=\"text\" name=\"name\" ng-model=\"product.PROD_NAME\" required> <div ng-messages=\"productForm.name.$error\" ng-if=\"productForm.$submitted || productForm.name.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Description*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"description\" flex type=\"text\" name=\"description\" ng-model=\"product.DESCRIPTION\" required> <div ng-messages=\"productForm.description.$error\" ng-if=\"productForm.$submitted || productForm.description.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Display sequence*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Name\" flex type=\"number\" name=\"display_sequence\" ng-model=\"product.DISPLAY_SEQUENCE\" min=\"0\" required> <div ng-messages=\"productForm.display_sequence.$error\" ng-if=\"productForm.$submitted || productForm.display_sequence.$touched\"> <div ng-message=\"required\"> This field is required. </div> <div ng-message=\"min\"> Value must be 0 or more. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Version*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"version\" flex type=\"text\" name=\"prod_ver\" ng-model=\"product.PROD_VER\" required> <div ng-messages=\"productForm.prod_ver.$error\" ng-if=\"productForm.$submitted || productForm.prod_ver.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Category*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Category\" class=\"fill-input\" name=\"category\" ng-model=\"product.CATEGORY_ID\" required> <md-option ng-repeat=\"cat in categories\" ng-value=\"cat.ID\"> {{cat.CODE}} </md-option> </md-select> <div ng-messages=\"productForm.category.$error\" ng-if=\"productForm.$submitted || productForm.category.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Active</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-checkbox ng-model=\"product.PROD_STATUS_ID\" aria-label=\"active\" ng-true-value=\"1\" ng-false-value=\"2\" ng-checked=\"product.PROD_STATUS_ID == 1\" name=\"status\"> </md-checkbox> <div ng-messages=\"productForm.status.$error\" ng-if=\"productForm.$submitted || productForm.status.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!productForm.$valid\">Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/products-panel.html',
    "<md-tab id=\"product-tab\"> <md-tab-label>Products</md-tab-label> <md-tab-body> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <md-content layout-gt-xs=\"row\" id=\"sales-product-code-search\" class=\"first sales-product-code-search\" flex-gt-xs=\"50\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search(searchString)\">search</i></md-icon> <input flex type=\"text\" ng-model=\"searchString\" ng-change=\"timeoutedSearch(searchString)\" class=\"search-box\" placeholder=\"Search\" focus-me=\"true\"> </md-input-container> </md-content> <div layout-gt-xs=\"column\" flex layout-align=\"start start\"> <md-button class=\"newItemButton\" ng-click=\"addProduct()\"> <i class=\"material-icons\">add</i>&nbsp;Add Product </md-button> </div> </div> <div layout=\"row\" class=\"panel-heading\"> <h3 class=\"no-caps\">{{products.length}} results</h3> <div class=\"btn-switch-wrapper\" ng-model=\"toggle.switch\" ng-click=\"toggleSwitchClick()\"> <div class=\"btn-switch\" ng-class=\"{'btn-switch--on':toggle.switch}\"> <div class=\"btn-switch-circle\" ng-class=\"{'btn-switch-circle--on':toggle.switch}\"></div> </div> </div> <h3 class=\"no-caps\"> Show {{toggle.switch ? 'only active' : 'all' }} entries </h3> <div flex></div> <md-button class=\"no-caps\" ng-click=\"deleteProduct(selectedProducts[0])\" ng-disabled=\"!selectedProducts.length\">Delete</md-button> <md-button class=\"no-caps\" ng-click=\"editProduct(selectedProducts[0])\" ng-disabled=\"!selectedProducts.length\">Edit</md-button> </div> <md-table-container> <table md-table md-row-select ng-model=\"selectedProducts\" md-progress=\"promise\"> <thead md-head> <tr md-row> <th md-column><span>ID</span></th> <th md-column><span>Code</span></th> <th md-column><span>Description</span></th> <th md-column><span>Display Sequence</span></th> <th md-column><span>Active</span></th> <th md-column><span>Category</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"product\" md-select-id=\"products.ID\" ng-repeat=\"product in products\" ng-dblclick=\"editProduct(product)\"> <td md-cell>{{product.ID}}</td> <td md-cell>{{product.PROD_CD}}</td> <td md-cell>{{product.DESCRIPTION}}</td> <td md-cell>{{product.DISPLAY_SEQUENCE}}</td> <td md-cell>{{product.status}}</td> <td md-cell>{{product.category}}</td> </tr> </tbody> </table> </md-table-container> <!-- <md-table-pagination md-limit=\"20\" md-limit-options=\"[5, 10, 20]\" md-page=\"1\" md-total=\"{{organisations.length}}\"  md-page-select></md-table-pagination> --> </md-tab-body> </md-tab>"
  );


  $templateCache.put('views/reassignhousedialog.html',
    "<md-dialog aria-label=\"delivery\" flex-gt-sm=\"80\" flex-gt-lg=\"60\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools\"> <h1 ng-if=\"existingClient\">House code {{code}} is already assigned</h1> <h1 ng-if=\"!existingClient\">House code {{code}} already exists</h1> </div> </md-toolbar> <md-dialog-content> <div class=\"md-dialog-content\"> <div layout=\"row\"> <span ng-if=\"existingClient\">Do you want to reassign {{code}} from {{existingClient.name}} to {{newClient.name}}?</span> <span ng-if=\"!existingClient\">Do you want to assign {{code}} to {{newClient.name}}?</span> </div> <div layout=\"row\"> <span>&nbsp;</span> </div> <div layout=\"row\" layout-align=\"left center\"> <div flex></div> <div> <md-block> <strong>{{oldType}}</strong> <br> <span>{{existingClient.name}} <br> <span ng-show=\"existingAddress.company_name\">{{existingAddress.company_name}} <br></span> {{existingAddress.address_1}} <br> <span ng-show=\"existingAddress.address_2\">{{existingAddress.address_2}} <br></span> {{existingAddress.country_code}}-{{existingAddress.postal_code}}&nbsp;{{existingAddress.town}} </span> </md-block> </div> <div flex=\"5\"></div> <div> <h1><i class=\"material-icons\">arrow_forward</i></h1> </div> <div flex=\"5\"></div> <div> <strong>{{newType}}</strong> <br> <span>{{newClient.name}} <br> <span ng-show=\"newAddress.company_name\">{{newAddress.company_name}} <br></span> {{newAddress.address_1}} <br> <span ng-show=\"newAddress.address_2\">{{newAddress.address_2}} <br></span> {{newAddress.country_code}}-{{newAddress.postal_code}}&nbsp;{{newAddress.town}} </span> </div> <div flex></div> </div> </div> </md-dialog-content> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\"> Cancel </md-button> <md-button ng-click=\"assign()\" class=\"md-primary\"> Confirm </md-button> </md-dialog-actions> </md-dialog>"
  );


  $templateCache.put('views/recognition-iframe-directive.html',
    "<iframe class=\"recognition-iframe\" ng-src=\"{{imageLink}}\"></iframe>"
  );


  $templateCache.put('views/request-checkout-modal.html',
    "<md-dialog aria-label=\"order\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>CHECKOUTS</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout-padding> <div layout=\"row\"> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <form role=\"form\" class=\"form-inline\" ng-submit=\"searchCode()\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"product-code-search\" flex-gt-xs> <md-input-container class=\"md-block\" md-no-float flex> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"searchCode(true)\">search</i></md-icon> <input flex type=\"text\" name=\"codeString\" ng-model=\"codeString\" class=\"search-box\" placeholder=\"Search Code\"> </md-input-container> </md-content> </form> </div> </div> <div class=\"table-responsive\"> <table id=\"delivery-notes-table\" class=\"table table-hover\" extended-table data-model=\"delivery_notes\" data-row-id=\"{{rowID}}\" data-clickable=\"false\" data-checkboxes=\"false\" data-columns-data=\"{{deliveryNotesColumns}}\" data-order=\"[[ 1, &quot;desc&quot; ]]\"> <thead> <tr> <th>ID</th> <th>Delivery ID</th> <th>Requested item</th> <th>Code</th> <th>Checked out at</th> <th>Checked out by</th> <th>Checked in at</th> <th>Checked in by</th> </tr> </thead> </table> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/request-modal.html',
    "<md-dialog aria-label=\"culture\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <form id=\"toastBox\" name=\"requestForm\" ng-submit=\"requestForm.$valid && save()\" novalidate> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{title}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"layout-padding\"> <div layout-padding> <br> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"deliveryDate\">Shipping Date</label> <md-datepicker id=\"deliveryDate\" name=\"deliveryDate\" id=\"deliveryDate\" ng-model=\"request.deliveryDate\" md-date-filter=\"IDontLikeMondays\" md-placeholder=\"Enter date\" md-min-date=\"minDeliveryDate\"></md-datepicker> <div class=\"validation-messages\" ng-messages=\"requestForm.deliveryDate.$error\" ng-if=\"requestForm.$submitted || requestForm.deliveryDate.$touched\"> <div ng-message=\"valid\">The entered value is not a date!</div> <div ng-message=\"required\">This date is required!</div> <div ng-message=\"mindate\">Date is too early!</div> <div ng-message=\"maxdate\">Date is too late!</div> <div ng-message=\"filtered\"> The selected day is unavailable for deliveries. </div> </div> </md-input-container> </div> </div> <md-divider></md-divider> <md-subheader> <h4>Order Items</h4> </md-subheader> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <div ng-show=\"requestItems\" flex> <table class=\"table table-hover order-item-table\"> <tr> <th>Order Item ID</th> <th>Culture</th> <th>Split</th> <th>Component</th> <th>Already requested</th> <th>This Request</th> <th>Remaining</th> </tr> <tr ng-if=\"false\" ng-repeat-start=\"(requestItemIndex, requestItem) in requestItems\"></tr> <tr ng-if=\"false\" ng-repeat-start=\"(cultureIndex, culture) in requestItem.cultures\"></tr> <tr ng-repeat=\"(saleIndex, sale) in culture.sales\"> <td ng-class=\"{'without-border': saleIndex !== 0}\"> <span ng-if=\"saleIndex === 0 && cultureIndex === 0\">{{requestItem.orderItemID}}</span> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\"> <span ng-if=\"saleIndex === 0\">{{culture.cultureType}}</span> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\"> <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"saleIndex === 0\"> <input ng-model=\"requestItems[requestItemIndex].cultures[cultureIndex].amount\" min=\"{{culture.min}}\" ng-change=\"updateRemaining();setAllCultureRequested();checkMax(requestItemIndex);setMax();checkCultureMin()\" name=\"{{getControlName('order_amount', requestItemIndex)}}\"> </md-input-container> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\" flex> {{sale.component.SPROD_NAME}}<br><span class=\"disabled\"><i>{{sale.component.SPROD_CD}}</i></span> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\" flex> <span ng-if=\"sale.alreadyRequested > 0\">{{sale.alreadyRequested}}</span> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\"> <md-input-container class=\"md-block\" flex-gt-sm ng-show=\"true\"> <input type=\"number\" ng-model=\"requestItems[requestItemIndex].cultures[cultureIndex].sales[saleIndex].requested\" ng-change=\"updateRemaining();setAllCultureRequested();setMax();checkCultureMin()\" min=\"0\" max=\"{{sale.max}}\" name=\"{{getSaleControlName('sale_amount', requestItemIndex, cultureIndex, saleIndex)}}\"> <!--  <div class=\"validation-messages\" ng-messages=\"requestForm.amt{{$index}}.$error\" ng-if=\"requestForm.$submitted \">\n" +
    "\n" +
    "                                            <div ng-message=\"min\">\n" +
    "                                                Please enter a value higher than the number of requested deliveries.\n" +
    "                                            </div>\n" +
    "                                        </div> --> </md-input-container> </td> <td ng-class=\"{'without-border': saleIndex !== 0}\" flex> {{sale.remaining || 0}} </td> </tr> <tr ng-if=\"formErrors[requestItemIndex] !== undefined && formErrors[requestItemIndex] !== null\"> <td colspan=\"3\" class=\"without-border\"> <div class=\"validation-messages text-right\"> <div>{{formErrors[requestItemIndex]}}</div> </div> </td> <td colspan=\"4\" class=\"without-border\"></td> </tr> <tr ng-if=\"false\" ng-repeat-end></tr> <tr ng-if=\"false\" ng-repeat-end></tr> </table> </div> </div> <md-subheader layout-padding> <div class=\"layout-gt-xs-row form-row\"> <h4>Delivery address</h4> <span flex></span> <md-input-container class=\"md-block padding-top-10\" flex-gt-xs=\"50\"> <label for=\"shippingAddressSelect\">Select a shipping address</label> <md-select id=\"shippingAddressSelect\" name=\"shippingAddressSelect\" ng-model=\"shippingAddress\" ng-change=\"updateAddress(shippingAddress)\"> <md-option ng-repeat=\"address in shippingAddresses\" ng-value=\"address\"> {{address.address_1}}, {{address.postal_code}} {{address.town}}, {{address.country_code}} </md-option> </md-select> </md-input-container> </div> </md-subheader> <div layout-padding> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-sm> <label for=\"firstname\">Firstname</label> <input id=\"firstname\" type=\"text\" ng-model=\"request.FIRSTNAME\"> <div ng-messages=\"requestForm.firstname.$error\" role=\"alert\" multiple></div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-sm> <label for=\"lastname\">Lastname</label> <input id=\"lastname\" type=\"text\" ng-model=\"request.LASTNAME\"> </md-input-container> <md-input-container class=\"md-block\" flex-gt-sm> <label for=\"company\">Company</label> <input id=\"company\" type=\"text\" ng-model=\"request.COMPANY\"> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"ADDRESS1\">Adress Line 1</label> <input id=\"ADDRESS1\" type=\"text\" ng-model=\"request.ADDRESS1\" required> <div ng-messages=\"requestForm.ADDRESS1.$error\" role=\"alert\" multiple></div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"ADDRESS1\">Adress line 2</label> <input name=\"ADDRESS2\" id=\"ADDRESS2\" type=\"text\" ng-model=\"request.ADDRESS2\"> <div ng-messages=\"requestForm.ADDRESS2.$error\" role=\"alert\" multiple></div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs=\"25\"> <label for=\"country\">Country</label> <md-select name=\"country\" id=\"country\" ng-model=\"request.country \" tabindex=\"1\" ng-change=\"updateCountry()\" ng-required=\"true\"> <md-option ng-repeat=\"country in countries \" ng-value=\"country\"> {{country.code}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"TOWN\">City</label> <input id=\"TOWN\" type=\"text\" ng-model=\"request.TOWN\" required> <div ng-messages=\"requestForm.TOWN.$error\" role=\"alert\" multiple></div> </md-input-container> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"POSTAL_CD\">Postal code</label> <input id=\"POSTAL_CD\" type=\"text\" ng-model=\"request.POSTAL_CD\" required> <div ng-messages=\"requestForm.POSTAL_CD.$error\" role=\"alert\" multiple></div> </md-input-container> </div> </div> <md-dialog-actions layout=\"row\"> <!-- <md-button class=\"md-primary\">\n" +
    "                Save and print\n" +
    "            </md-button> --> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"save\"> Save </md-button> </md-dialog-actions> </div> </md-dialog-content> </form> </md-dialog>"
  );


  $templateCache.put('views/request-panel.html',
    "<div class=\"section\"> <div layout=\"row\"> <h3>Requests</h3> <div flex></div> <div> <div md-button type=\"button\" class=\"md-primary\" ng-click=\"schedule()\" ng-disabled=\"order.statusDescription != 'Accepted'\"> <i class=\"material-icons\">add</i> New Request </div> <md-tooltip ng-if=\"order.statusDescription != 'Accepted'\" md-direction=\"top\">Order needs to be Accepted to place a request.</md-tooltip> </div> </div> <div class=\"client-products\" ng-show=\"order.requests.length\"> <table class=\"table table-hover\"> <tr> <th>ID</th> <th>Creation Date</th> <!-- <th>#</th> --> <th>Shipping Date</th> <th>Delivery address</th> <th>Cases</th> <th>Boxes</th> <th>Pops</th> <th>Printed</th> </tr> <tr ng-repeat=\"request in order.requests\" ng-click=\"selectRequest($index)\" class=\"request-line request-line{{$index}}\" data-request-id=\"{{request.ID}}\" data-index=\"{{$index}}\" ng-dblclick=\"editRequest(farmer.activeRequest.ID)\"> <td>{{request.ID}}</td> <td>{{request.creationDate | date:'dd/MM/yyyy' }}</td> <td>{{request.deliveryDate | date:'dd/MM/yyyy' }}</td> <td> <span ng-show=\"request.COMPANY\">{{request.COMPANY}} <br></span> <span ng-show=\"request.FIRSTNAME\">{{request.FIRSTNAME}} </span><span ng-show=\"request.LASTNAME\">{{request.LASTNAME }}<br></span> {{request.ADDRESS1}} <br> {{request.ADDRESS2}} <br ng-show=\"request.ADDRESS2\"> {{request.POSTAL_CD}} {{request.TOWN}} <br> </td> <td> {{request.requested.case}} </td> <td> {{request.requested.box}} </td> <td> {{request.requested.pop}} </td> <td class=\"text-center\"> <i class=\"material-icons md-primary\" ng-show=\"request.printStatus == 3\">done</i> <i class=\"material-icons md-warn\" ng-show=\"request.printStatus != 3\">clear</i> </td> </tr> </table> </div> <div class=\"customer-product-actions\"> <md-block flex layout=\"row\"> <div flex></div> <div md-button ng-click=\"deleteRequest(farmer.activeRequest.ID)\" class=\"md-warn\" ng-show=\"farmer.activeRequest\" ng-disabled=\"farmer.activeRequest.deliveries.length || farmer.activeRequest.locked\"> <i class=\"material-icons\">remove</i> Delete </div> <div md-button ng-click=\"editRequest(farmer.activeRequest.ID)\" class=\"md-primary\" ng-show=\"farmer.activeRequest \" ng-disabled=\"farmer.activeRequest.locked || farmer.activeRequest.deliveries.length\"> <i class=\"material-icons\">mode_edit</i> Edit </div> <div md-button ng-click=\"printRequest()\" class=\"md-primary\" ng-show=\"farmer.activeRequest\"> <i class=\"material-icons\">file_download</i> PDF </div> <div md-button ng-click=\"sendMail()\" class=\"md-primary\" restrict-access=\"Email Documents\" ng-show=\"farmer.activeRequest\" ng-disabled=\"farmer.activeRequest.printStatus != 3\"> <i class=\"material-icons\">email</i> Email </div> <div md-button ng-show=\"farmer.activeRequest && farmer.activeRequest.hasCheckout\" class=\"md-primary\" ng-click=\"modal()\"> <i class=\"material-icons\">check</i> View Check Out </div> </md-block> </div> </div>"
  );


  $templateCache.put('views/sales-order-filter-panel.html',
    "<form id=\"toastBox\" name=\"salesOrderFilterForm\" style=\"\" ng-submit=\"salesOrderFilterForm.$valid && save()\" novalidate> <md-dialog-content> <div class=\"layout-padding\"> <md-subheader layout-padding> <div class=\"layout-gt-xs-row form-row\"> <h4>Filter Sales Orders</h4> <span flex></span> <span class=\"general-link\" style=\"padding-top: 12px\" ng-click=\"clearFilter()\" ng-show=\"filter\" layout-align=\"end center\"><i class=\"material-icons\">clear</i> Clear All</span> <!--<div md-button ng-click=\"clearFilter()\" class=\"md-warn\" ng-hide=\"filter.length<1\">\n" +
    "\t\t\t\t\t\t<i class=\"material-icons\">clear</i> Clear All\n" +
    "\t\t\t\t\t</div>--> </div> </md-subheader> <div layout-padding style=\"border: #f1f1f1 solid 1px\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"filter-field md-block padding-top-10\" flex-gt-xs> <label for=\"organisation\">Organisation</label> <md-select multiple name=\"organisation\" ng-model=\"filter.Organisation\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-repeat=\"organisation in filterVariables.Organisation\" ng-value=\"organisation.Organisation\"> {{organisation.Organisation}} </md-option> </md-select> <span class=\"clear-filter-field\" flex ng-click=\"removeFilter('Organisation')\" ng-show=\"filter.Organisation\"><i class=\"material-icons\">clear</i></span> </md-input-container> <md-input-container class=\"filter-field md-block padding-top-10\" flex-gt-xs> <label for=\"season\">Season</label> <md-select multiple name=\"season\" ng-model=\"filter.Season\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-repeat=\"season in filterVariables.Season\" ng-value=\"season.Season\"> {{season.Season}} </md-option> </md-select> <span class=\"clear-filter-field\" flex ng-click=\"removeFilter('Season')\" ng-show=\"filter.Season\"><i class=\"material-icons\">clear</i></span> </md-input-container> <md-input-container class=\"filter-field md-block padding-top-10\" flex-gt-xs> <label for=\"status\">Status</label> <md-select multiple name=\"status\" ng-model=\"filter.Status\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-repeat=\"status in filterVariables.Status\" ng-value=\"status.Status\"> {{status.Status}} </md-option> </md-select> <span class=\"clear-filter-field\" flex ng-click=\"removeFilter('Status')\" ng-show=\"filter.Status\"><i class=\"material-icons\">clear</i></span> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"filter-field md-block padding-top-10\" flex-gt-xs> <label for=\"currency\">Currency</label> <md-select multiple name=\"currency\" ng-model=\"filter.Currency\" ng-change=\"runFilter()\" flex=\"90\"> <md-option ng-repeat=\"currency in filterVariables.Currency\" ng-value=\"currency.Currency\"> {{currency.Currency}} </md-option> </md-select> <span class=\"clear-filter-field\" flex ng-click=\"removeFilter('Currency')\" ng-show=\"filter.Currency\"><i class=\"material-icons\">clear</i></span> </md-input-container> <md-input-container class=\"md-block padding-top-10\" flex-gt-xs> <span ng-click=\"popupDateRangePicker()\"><i class=\"material-icons\">date_range</i> {{dateRange.startDate ? (dateRange.startDate | date:'dd/MM/yyyy')+\" - \"+(dateRange.endDate | date:'dd/MM/yyyy') : 'Order Date'}}</span><span flex></span> <span class=\"clear-filter-field\" ng-click=\"removeDateRangeFilter()\" ng-show=\"dateRange.startDate\"><i class=\"material-icons\">clear</i></span> </md-input-container> <md-input-container class=\"md-block padding-top-10\" flex-gt-xs>&nbsp;</md-input-container> </div> </div> </div> </md-dialog-content> </form>"
  );


  $templateCache.put('views/sales-orders.html',
    "<div class=\"layout-gt-xs-row form-row md-no-momentum panel-heading\"> <form name=\"filterform\" role=\"form\" class=\"form-inline\" ng-submit=\"query.filter.length>0 && getSalesOrders()\" flex-gt-xs=\"50\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"first product-code-search\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"search()\">search</i></md-icon> <input flex type=\"text\" id=\"queryFilter\" ng-change=\"getSalesOrders()\" ng-model=\"query.filter\" ng-model-options=\"filter.options\" class=\"search-box ng-valid ng-touched ng-pristine search-box\" aria-invalid=\"false\" focus-me=\"true\" placeholder=\"Search\"> </md-input-container> </md-content> </form> <div layout-gt-xs=\"column\" layout-align=\"start start\"> <md-button ng-click=\"showFilter=!showFilter\" class=\"md-primary\"> <i class=\"material-icons\">filter_list</i> <span ng-show=\"!showFilter\">Show</span><span ng-show=\"showFilter\">Hide</span> Filter </md-button> </div> </div> <div class=\"table-responsive\"> <filter-panel ng-show=\"showFilter\" filter-section=\"sales-order\" filter-list=\"filterSalesOrders(filterOptions, dateRangeFilter)\"></filter-panel> <div class=\"panel-heading md-table-header-panel\" aria-hidden=\"true\" layout=\"row\"> <span flex></span> <div md-button ng-click=\"deleteOrders()\" class=\"md-warn\" ng-show=\"selected.length>0\"> <i class=\"material-icons\">remove</i> Delete </div> <div md-button ng-click=\"editOrder(selected[0], 'edit')\" class=\"md-primary\" ng-show=\"selected.length==1\"> <i class=\"material-icons\">mode_edit</i> Edit </div> <div md-button ng-click=\"editOrder(selected[0], 'cultures')\" class=\"md-primary\" ng-show=\"selected.length==1\" ng-disabled=\"!selected[0].Cultures\"> <i class=\"material-icons\">nature</i> Cultures </div> <div md-button ng-click=\"editOrder(selected[0], 'print')\" class=\"md-primary\" ng-show=\"selected.length==1\"> <i class=\"material-icons\">file_download</i> PDF </div> <div ng-show=\"selected.length==1\"> <md-menu> <md-button aria-label=\"Open demo menu\" class=\"md-primary\" ng-click=\"$mdMenu.open($event)\"> <i class=\"material-icons\">arrow_drop_down</i> Status </md-button> <md-menu-content width=\"3\"> <md-menu-item ng-repeat=\"status in statuses\"> <md-button ng-click=\"setStatus(status.ID, selected[0].OrderId)\" ng-disabled=\"!activeStatusMenu(selected[0], status)\"> {{status.DESCRIPTION}} </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <div md-button ng-click=\"editOrder(selected[0], 'copy')\" class=\"md-primary\" ng-show=\"selected.length==1\"> <i class=\"material-icons\">file_copy</i> Copy </div> <div excel-export get-data=\"printExcelDocument(status)\" print-status=\"all\" button-text=\"EXPORT ALL\" ng-disabled=\"salesOrders.length<1\" file-name=\"{{fileName}}\"></div> <div excel-export get-data=\"printExcelDocument(status)\" print-status=\"selected\" button-text=\"EXPORT SELECTED\" ng-disabled=\"selected.length===0\" file-name=\"{{fileName}}\"></div> </div> </div> <div> <md-table-container style=\"overflow: auto\" ng-style=\"displayHeight\"> <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\"> <thead md-head md-order=\"query.order\" md-on-reorder=\"getSalesOrders\" fix-head> <tr md-row> <th md-column md-order-by=\"Organisation\">Organisation</th> <th md-column md-order-by=\"Season\">Season</th> <th md-column md-order-by=\"OrderId\">Order ID</th> <th md-column md-order-by=\"OrderDate\">Order Date</th> <th md-column md-order-by=\"ClientId\">Customer ID</th> <th md-column md-order-by=\"FirstName\">Firstname</th> <th md-column md-order-by=\"LastName\">Lastname</th> <th md-column md-order-by=\"Company\">Company</th> <th md-column md-order-by=\"Currency\">Currency</th> <th md-column md-order-by=\"AmountOrdered\">Amount</th> <th md-column>Requested</th> <th md-column md-order-by=\"Status\">Status</th> </tr> </thead> <tbody md-body> <tr ng-class=\"(setRowClass(item.OrderId)) ? 'activeCode' : ''\" md-row md-select=\"item\" md-select-id=\"item.OrderId\" md-auto-select ng-repeat=\"item in salesOrders\" ng-dblclick=\"editSalesOrder(item)\"> <td md-cell>{{item.Organisation}}</td> <td md-cell>{{item.Season}}</td> <td md-cell> <span class=\"general-link\" ng-click=\"editOrder(item, 'edit')\">{{\"OR-\"+item.OrderId}}</span> </td> <td md-cell>{{item.OrderDate | date:'dd/MM/yyyy' }}</td> <td md-cell> <a class=\"general-link\" ui-sref=\"contract({fid:item.ClientId, action:'view', orderID:item.OrderId})\">{{item.ClientId}}</a> </td> <td md-cell>{{item.FirstName}}</td> <td md-cell>{{item.LastName}}</td> <td md-cell>{{item.Company}}</td> <td md-cell>{{item.Currency}}</td> <td md-cell>{{item.SubtotalInclVat}}</td> <td md-cell class=\"text-center\"> <i class=\"material-icons md-primary\" ng-hide=\"item.requested === undefined || item.ordered > item.requested\">done</i> <i class=\"material-icons md-warn\" ng-show=\"item.requested === undefined || item.ordered > item.requested\">clear</i> </td> <td md-cell>{{item.Status}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination showfirstlastbuttons md-limit=\"query.limit\" md-limit-options=\"query.limitOptions\" md-page=\"query.page\" md-total=\"{{salesOrdersCount}}\" md-page-select md-on-paginate=\"getSalesOrders\" md-boundary-links> </md-table-pagination> </div>"
  );


  $templateCache.put('views/sales-products-modal.html',
    "<md-dialog aria-label=\"Organisation\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\" class=\"products-modal\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{action}} Sales Product</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"productForm\" ng-submit=\"saveProduct()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Code*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Code\" flex type=\"text\" name=\"code\" ng-model=\"product.SPROD_CD\" required focus-me=\"true\"> <div ng-messages=\"productForm.code.$error\" ng-if=\"productForm.$submitted || productForm.code.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Name*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Name\" flex type=\"text\" name=\"name\" ng-model=\"product.SPROD_NAME\" required> <div ng-messages=\"productForm.name.$error\" ng-if=\"productForm.$submitted || productForm.name.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Category*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-select aria-label=\"Category\" class=\"fill-input\" name=\"category\" ng-model=\"product.CATEGORY_ID\" required> <md-option ng-repeat=\"cat in categories\" ng-value=\"cat.ID\"> {{cat.CODE}} </md-option> </md-select> <div ng-messages=\"productForm.category.$error\" ng-if=\"productForm.$submitted || productForm.category.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Display sequence*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Name\" flex type=\"text\" name=\"display_sequence\" ng-model=\"product.DISPLAY_SEQUENCE\" required> <div ng-messages=\"productForm.display_sequence.$error\" ng-if=\"productForm.$submitted || productForm.display_sequence.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Active</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <md-checkbox aria-label=\"active\" ng-model=\"product.SPROD_STATUS_ID\" ng-checked=\"product.SPROD_STATUS_ID == 1\" ng-true-value=\"1\" ng-false-value=\"2\" class=\"md-primary md-align-top-left\"> </md-checkbox> </md-input-container> </div> <div ng-show=\"action == 'Add'\"> <p> <b>Please save sales product to add Connected products, Prices or Translations.</b> </p> </div> <div ng-show=\"action == 'Edit'\"> <h2>Connected Products</h2> <div custom-table data-model-name=\"connectedProducts\" class=\"custom-table\"> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"addTableItem()\" ng-disabled=\"!addTableItemEnabled.connectedProducts\">{{addTableItemText.connectedProducts}} </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"deleteTableItem()\" ng-disabled=\"!deleteTableItemEnabled.connectedProducts\">Delete </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"editTableItem()\" ng-disabled=\"!editTableItemEnabled.connectedProducts\">{{editTableItemText.connectedProducts}} </md-button> <table class=\"table table-hover\"> <tr class=\"border-bottom\"> <th></th> <th>ID</th> <th>Code</th> <th>Description</th> <th>Active</th> <th>Amt</th> </tr> <tr ng-repeat=\"(key, cProduct) in connectedProducts\" class=\"border-bottom items {{activeTable.connectedProducts[key]}} table-item-{{key}}\"> <td> <input type=\"checkbox\" ng-change=\"selectTableItem(key)\" ng-model=\"selectedTableItem.connectedProducts.select[key]\"> </td> <td> {{cProduct.ID}}<input data-key=\"ID\" class=\"fill-input\" type=\"hidden\" value=\"{{cProduct.ID}}\"> </td> <td class=\"d-none\"> {{cProduct.PROD_SALES_MAP_ID}}<input data-key=\"prod-sales-map-id\" class=\"fill-input\" type=\"hidden\" value=\"{{cProduct.PROD_SALES_MAP_ID}}\"> </td> <td> <span>{{cProduct.PROD_CD}}</span> <div class=\"fill-input\">{{cProduct.PROD_CD}}</div> </td> <td> <span>{{cProduct.PROD_NAME}}</span> <div class=\"fill-input\">{{cProduct.PROD_NAME}}</div> </td> <td> <span>{{cProduct.STATUS}}</span> <div class=\"fill-input\">{{cProduct.STATUS}}</div> </td> <td> <span>{{cProduct.AMOUNT}}</span><input data-key=\"amount\" class=\"fill-input\" flex type=\"text\" value=\"{{cProduct.AMOUNT}}\"> </td> </tr> <tr ng-show=\"connectedProducts.length == 0 && !addNewTableItemEnabled.connectedProducts\"> <td colspan=\"6\">No records found</td> </tr> <tr class=\"border-bottom add-table-item\" ng-show=\"addNewTableItemEnabled.connectedProducts\"> <td></td> <td> <md-button class=\"no-caps fill-bg margin-0 padding-0\" ng-click=\"cancelAddTableItem()\">Cancel </md-button> </td> <td class=\"d-none\"> <input data-key=\"sales_prod_id\" type=\"hidden\" value=\"{{product.ID}}\"> </td> <td colspan=\"2\"> <select aria-label=\"product\" class=\"fill-input\" data-key=\"product_id\"> <option ng-repeat=\"option in products\" ng-value=\"option.ID\"> {{option.PROD_CD + ' - ' + option.PROD_NAME}} </option> </select> </td> <td></td> <td> <input data-key=\"amount\" class=\"fill-input\" flex type=\"text\"> </td> </tr> </table> </div> <h2>Bulk prices</h2> <div custom-table data-model-name=\"prices\" class=\"custom-table\"> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"addTableItem()\" ng-disabled=\"!addTableItemEnabled.prices\">{{addTableItemText.prices}} </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"deleteTableItem()\" ng-disabled=\"!deleteTableItemEnabled.prices\">Delete </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"editTableItem()\" ng-disabled=\"!editTableItemEnabled.prices\">{{editTableItemText.prices}} </md-button> <table class=\"table table-hover\"> <tr class=\"border-bottom\"> <th></th> <th>ID</th> <th>Organisation</th> <th>Threshold amount</th> <th>Price per piece</th> </tr> <tr ng-repeat=\"(key, price) in prices\" class=\"border-bottom items {{activeTable.prices[key]}} table-item-{{key}}\"> <td> <input type=\"checkbox\" ng-change=\"selectTableItem(key)\" ng-model=\"selectedTableItem.prices.select[key]\"> </td> <td> {{price.ID}}<input data-key=\"ID\" class=\"fill-input\" type=\"hidden\" name=\"price-id\" value=\"{{price.ID}}\"> </td> <td> <span>{{price.NAME}}</span> <div class=\"fill-input\">{{price.NAME}}</div> </td> <td> <span>{{price.THRESHOLD_AMT}}</span><input data-key=\"THRESHOLD_AMT\" class=\"fill-input\" flex type=\"text\" value=\"{{price.THRESHOLD_AMT}}\"> </td> <td> <span>{{price.PRICE_PER_PIECE}}</span><input data-key=\"PRICE_PER_PIECE\" class=\"fill-input\" flex type=\"text\" value=\"{{price.PRICE_PER_PIECE}}\"> </td> </tr> <tr ng-show=\"prices.length == 0 && !addNewTableItemEnabled.prices\"> <td colspan=\"5\">No records found</td> </tr> <tr class=\"border-bottom add-table-item\" ng-show=\"addNewTableItemEnabled.prices\"> <td></td> <td> <md-button class=\"no-caps fill-bg margin-0 padding-0\" ng-click=\"cancelAddTableItem()\">Cancel </md-button> </td> <td class=\"d-none\"> <input data-key=\"SALES_PROD_ID\" type=\"hidden\" value=\"{{product.ID}}\"> </td> <td> <select aria-label=\"prices organisation\" class=\"fill-input\" data-key=\"ORGANISATION_ID\"> <option ng-repeat=\"option in organisations\" ng-value=\"option.ID\"> {{option.NAME}} </option> </select> </td> <td> <input data-key=\"THRESHOLD_AMT\" class=\"fill-input\" flex type=\"text\"> </td> <td> <input data-key=\"PRICE_PER_PIECE\" class=\"fill-input\" flex type=\"text\"> </td> </tr> </table> </div> <h2>Translations</h2> <div custom-table data-model-name=\"translations\" class=\"custom-table\"> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"addTableItem()\" ng-disabled=\"!addTableItemEnabled.translations\">{{addTableItemText.translations}} </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"deleteTableItem()\" ng-disabled=\"!deleteTableItemEnabled.translations\">Delete </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"editTableItem()\" ng-disabled=\"!editTableItemEnabled.translations\">{{editTableItemText.translations}} </md-button> <table class=\"table table-hover\"> <tr class=\"border-bottom\"> <th></th> <th>ID</th> <th>Organisation</th> <th>Language</th> <th>Product Name</th> </tr> <tr ng-repeat=\"(key, translation) in translations\" class=\"border-bottom items {{activeTable.translations[key]}} table-item-{{key}}\"> <td> <input type=\"checkbox\" ng-change=\"selectTableItem(key)\" ng-model=\"selectedTableItem.translations.select[key]\"> </td> <td> {{translation.ID}}<input data-key=\"ID\" class=\"fill-input\" type=\"hidden\" value=\"{{translation.ID}}\"> </td> <td> {{translation.NAME}}<input data-key=\"ORGANISATION_ID\" class=\"fill-input\" type=\"hidden\" value=\"{{translation.ORGANISATION_ID}}\"> </td> <td> {{translation.LANGUAGE}}<input data-key=\"LANG_ID\" class=\"fill-input\" type=\"hidden\" value=\"{{translation.LANG_ID}}\"> </td> <td> <span>{{translation.TXT_MODULE}}</span><input data-key=\"TXT_MODULE\" class=\"fill-input\" flex type=\"text\" value=\"{{translation.TXT_MODULE}}\"> </td> </tr> <tr ng-show=\"translations.length == 0 && !addNewTableItemEnabled.translations\"> <td colspan=\"5\">No records found</td> </tr> <tr class=\"border-bottom add-table-item\" ng-show=\"addNewTableItemEnabled.translations\"> <td></td> <td> <md-button class=\"no-caps fill-bg margin-0 padding-0\" ng-click=\"cancelAddTableItem()\">Cancel </md-button> </td> <td class=\"d-none\"> <input data-key=\"TXT_CD\" type=\"hidden\" value=\"{{product.SPROD_CD}}\"> </td> <td> <select aria-label=\"organisation\" class=\"fill-input\" data-key=\"ORGANISATION_ID\"> <option ng-repeat=\"option in organisations\" ng-value=\"option.ID\"> {{option.NAME}} </option> </select> </td> <td> <select aria-label=\"organisation\" class=\"fill-input\" data-key=\"LANG_ID\"> <option ng-repeat=\"option in languages\" ng-value=\"option.ID\"> {{option.description}} </option> </select> </td> <td> <input data-key=\"TXT_MODULE\" class=\"fill-input\" flex type=\"text\"> </td> </tr> </table> </div> </div> <md-dialog-actions layout=\"row\" style=\"border: none\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!productForm.$valid\">Save </md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/sales-products-packaging-modal.html',
    "<md-dialog aria-label=\"Packaging\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\" class=\"packaging-modal\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{action}} package</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"layout-padding\"> <form name=\"packageForm\" ng-submit=\"packageForm.$valid && savePackage()\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Code*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Code\" flex type=\"text\" name=\"package_cd\" ng-model=\"package.PACKAGE_CD\" required focus-me=\"true\"> <div ng-messages=\"packageForm.package_cd.$error\" ng-if=\"packageForm.$submitted || packageForm.package_cd.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Description*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"description\" flex type=\"text\" name=\"description\" ng-model=\"package.DESCRIPTION\" required> <div ng-messages=\"packageForm.description.$error\" ng-if=\"packageForm.$submitted || packageForm.description.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Supplier</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"supplier\" flex type=\"text\" name=\"supplier\" ng-model=\"package.SUPPLIER\"> <div ng-messages=\"packageForm.supplier.$error\" ng-if=\"packageForm.$submitted || packageForm.supplier.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Slot amount*</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input aria-label=\"Slot amount\" flex type=\"text\" name=\"slot_amt\" ng-model=\"package.SLOT_AMT\" required> <div ng-messages=\"packageForm.slot_amt.$error\" ng-if=\"packageForm.$submitted || packageForm.slot_amt.$touched\"> <div ng-message=\"required\"> This field is required. </div> </div> </md-input-container> </div> <div ng-show=\"action == 'Add'\"> <p><b>To add Sales product mapping, first save the package.</b></p> </div> <div ng-show=\"action == 'Edit'\"> <h2>Sales product mapping</h2> <div custom-table data-model-name=\"salesPackagesMap\" class=\"custom-table\"> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"addTableItem()\" ng-disabled=\"!addTableItemEnabled.salesPackagesMap\">{{addTableItemText.salesPackagesMap}} </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"deleteTableItem()\" ng-disabled=\"!deleteTableItemEnabled.salesPackagesMap\">Delete </md-button> <md-button class=\"no-caps fill-bg padding-0\" ng-click=\"editTableItem()\" ng-disabled=\"!editTableItemEnabled.salesPackagesMap\">{{editTableItemText.salesPackagesMap}} </md-button> <table class=\"table table-hover\"> <tr class=\"border-bottom\"> <th></th> <th>ID</th> <th>Organisation</th> <th>Sales product code</th> <th>Product name</th> <th>Slots used</th> <th>Max slot difference</th> </tr> <tr ng-repeat=\"(key, item) in salesPackages\" class=\"border-bottom items {{activeTable.salesPackagesMap[key]}} table-item-{{key}}\"> <td> <input type=\"checkbox\" ng-change=\"selectTableItem(key)\" ng-model=\"selectedTableItem.salesPackagesMap.select[key]\"> </td> <td> {{item.ID}}<input data-key=\"ID\" class=\"fill-input\" type=\"hidden\" value=\"{{item.ID}}\"> </td> <td> <span>{{item.NAME}}</span> <select aria-label=\"organisation\" class=\"fill-input\" data-key=\"ORGANISATION_ID\" ng-model=\"item.ORGANISATION_ID\"> <option ng-repeat=\"option in organisations\" value=\"{{option.ID}}\"> {{option.NAME}} </option> </select> </td> <td> <span>{{item.SPROD_CD}}</span> <div class=\"fill-input\">{{item.SPROD_CD}}</div> </td> <td> <span>{{item.SPROD_NAME}}</span> <div class=\"fill-input\">{{item.SPROD_NAME}}</div> </td> <td> <span>{{item.SLOTS_USED}}</span><input data-key=\"SLOTS_USED\" class=\"fill-input\" value=\"{{item.SLOTS_USED}}\"> </td> <td> <span>{{item.MAX_SLOT_DIFF}}</span><input data-key=\"MAX_SLOT_DIFF\" class=\"fill-input\" value=\"{{item.MAX_SLOT_DIFF}}\"> </td> </tr> <tr ng-show=\"salesPackages.length == 0 && !addNewTableItemEnabled.salesPackagesMap\"> <td colspan=\"7\">No records found</td> </tr> <tr class=\"border-bottom add-table-item\" ng-show=\"addNewTableItemEnabled.salesPackagesMap\"> <td></td> <td> <md-button class=\"no-caps fill-bg margin-0 padding-0\" ng-click=\"cancelAddTableItem()\">Cancel </md-button> </td> <td class=\"d-none\"> <input data-key=\"PACKAGING_UNIT_ID\" type=\"hidden\" value=\"{{package.ID}}\"> </td> <td> <select aria-label=\"organisation\" class=\"fill-input\" data-key=\"ORGANISATION_ID\"> <option ng-repeat=\"option in organisations\" value=\"{{option.ID}}\"> {{option.NAME}} </option> </select> </td> <td> <select aria-label=\"sales SALE\" class=\"fill-input\" data-key=\"SALES_PROD_ID\"> <option ng-repeat=\"option in salesProducts\" value=\"{{option.ID}}\"> {{option.SPROD_CD}} </option> </select> </td> <td></td> <td> <input data-key=\"SLOTS_USED\" class=\"fill-input\" flex type=\"text\"> </td> <td> <input data-key=\"MAX_SLOT_DIFF\" class=\"fill-input\" flex type=\"text\"> </td> </tr> </table> </div> </div> <md-dialog-actions layout=\"row\" style=\"border: none\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\">Cancel</md-button> <md-button type=\"submit\" class=\"md-primary\" aria-label=\"new\" ng-disabled=\"!packageForm.$valid\">Save</md-button> </md-dialog-actions> </div> </form> </div> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/sales-products-panel.html',
    "<md-tab id=\"sales-products-tab\"> <md-tab-label>Sales products</md-tab-label> <md-tab-body> <div class=\"layout-gt-xs-row form-row md-no-momentum\"> <md-content layout-gt-xs=\"row\" id=\"sales-product-code-search\" class=\"first sales-product-code-search\" flex-gt-xs=\"50\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"searchSalesProducts(searchStringSalesProducts)\">search</i></md-icon> <input flex type=\"text\" ng-model=\"searchStringSalesProducts\" ng-change=\"timeoutedSalesProductsSearch(searchStringSalesProducts)\" class=\"search-box\" placeholder=\"Search\" focus-me=\"true\"> </md-input-container> </md-content> <div layout-gt-xs=\"column\" flex layout-align=\"start start\"> <md-button class=\"newItemButton\" ng-click=\"addSalesProduct()\"> <i class=\"material-icons\">add</i>&nbsp;Add Product </md-button> </div> </div> <div layout=\"row\" class=\"panel-heading\"> <h3 class=\"no-caps\">{{salesProductsCount}} results</h3> <div class=\"btn-switch-wrapper\" ng-model=\"toggleSalesProducts.switch\" ng-click=\"toggleSwitchSalesProductsClick()\"> <div class=\"btn-switch\" ng-class=\"{'btn-switch--on':toggleSalesProducts.switch}\"> <div class=\"btn-switch-circle\" ng-class=\"{'btn-switch-circle--on':toggleSalesProducts.switch}\"></div> </div> </div> <h3 class=\"no-caps\"> Show {{toggleSalesProducts.switch ? 'only active' : 'all' }} entries </h3> <div flex></div> <md-button class=\"no-caps\" ng-click=\"deleteSalesProduct(selectedSalesProducts[0])\" ng-disabled=\"!selectedSalesProducts.length\">Delete</md-button> <md-button class=\"no-caps\" ng-click=\"editSalesProduct(selectedSalesProducts[0])\" ng-disabled=\"!selectedSalesProducts.length\">Edit</md-button> </div> <div layout-padding class=\"table-responsive\"> <md-table-container> <table md-table md-row-select ng-model=\"selectedSalesProducts\" md-progress=\"promise\"> <thead md-head> <tr md-row> <th md-column><span>ID</span></th> <th md-column><span>Code</span></th> <th md-column><span>Description</span></th> <th md-column><span>Display Sequence</span></th> <th md-column><span>Active</span></th> <th md-column><span>Category</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=\"product\" md-select-id=\"products.ID\" ng-repeat=\"product in salesProducts\" ng-dblclick=\"editSalesProduct(product)\"> <td md-cell>{{product.ID}}</td> <td md-cell>{{product.SPROD_CD}}</td> <td md-cell>{{product.SPROD_NAME}}</td> <td md-cell>{{product.DISPLAY_SEQUENCE}}</td> <td md-cell>{{product.STATUS}}</td> <td md-cell>{{product.CATEGORY}}</td> </tr> </tbody> </table> </md-table-container> </div> </md-tab-body> </md-tab>"
  );


  $templateCache.put('views/snapshot-modal.html',
    "<md-dialog flex=\"100\" ng-init=\"display_camera=true; inProgress=false;\"> <form id=\"toastBox\" name=\"snapshotForm\" style=\"\" ng-submit=\"save()\" novalidate> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>Upload picture {{activeProduct.HOUSE_CD}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-progress-linear md-mode=\"determinate\" ng-show=\"inProgress\" ng-value=\"progress\"></md-progress-linear> <md-dialog-content> <main class=\"app container\" id=\"main-image-container\"> <div class=\"row\" style=\"text-align: center\"> <ng-webcam ng-if=\"display_camera\" config=\"config\" on-error=\"onError(err)\" on-load=\"onLoad()\" on-live=\"onLive()\" on-capture-progress=\"onCaptureProgress(src, progress)\" on-capture-complete=\"onCaptureComplete(src)\"> </ng-webcam> </div> <div style=\"text-align: center\" layout-align=\"center center\" id=\"result\" class=\"row\"></div> </main> </md-dialog-content> <md-dialog-actions> <md-button ng-if=\"showButtons\" class=\"md-button\" layout-align=\"start center\"> <input type=\"file\" accept=\"image/*\" style=\"display: none\" onchange=\"angular.element(this).scope().handleFileSelect(event)\" id=\"fileInput\"> <label for=\"fileInput\" style=\"cursor: pointer; display: flex; align-items: center\"> <i class=\"material-icons\">folder_open</i> From file </label> </md-button> <md-button ng-if=\"showButtons\" class=\"md-button snap-icon md-primary\" type=\"button\" ng-click=\"capture()\"> <i class=\"material-icons\">photo_camera</i> Snapshot </md-button> </md-dialog-actions> </form> </md-dialog>"
  );


  $templateCache.put('views/startpop-form.html',
    "<div class=\"layout-padding\"> <form name=\"boxForm\" ng-submit=\"boxForm.$valid && canBeSaved() && save()\" flex=\"50\"> <div class=\"form-section layout-padding\"> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Originating box</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"text\" name=\"boxParent\" ng-model=\"box.parent\" ng-pattern=\"/^[0-9]{2}(IN|in)[0-9,a-z,A-Z]{4}$|^(IN|in)[0-9]{2}[0-9,a-z,A-Z]{5}|^[a-z,A-Z]{2}[0-9]{2}[a-z,A-Z]{7}[0-9]{4}$/\" ng-change=\"findParent()\" style=\"text-transform:uppercase\" ng-required=\"true\" focus-me=\"true\"> <div ng-messages=\"boxForm.boxParent.$error\" ng-if=\"boxForm.$submitted || boxForm.boxParent.$touched\"> <div ng-message=\"required\"> You must provide a code. </div> <div ng-message=\"pattern\"> Please enter a valid code. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Cocoon Net Weight</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"number\" step=\"any\" aria-label=\"Cocoon Net Weight\" name=\"cocoonNetWeight\" min=\"0\" ng-model=\"box.cocoonNetWeight\" ng-change=\"checkCocoonAmount()\" ng-required=\"true\" ng-disabled=\"!validParentCode\"> <div ng-messages=\"boxForm.cocoonNetWeight.$error\" ng-if=\"boxForm.$submitted || boxForm.cocoonNetWeight.$touched\"> <div ng-message=\"required\"> You must provide a cocoon net weight. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Conversion factor</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex aria-label=\"Conversion factor\" name=\"conversion_factor\" ng-model=\"box.conversionFactor\" ng-disabled=\"!validParentCode\" ng-change=\"checkCocoonAmount()\" ng-required=\"true\"> <div ng-messages=\"boxForm.conversion_factor.$error\" ng-if=\"boxForm.$submitted || boxForm.conversion_factor.$touched\"> <div ng-message=\"required\"> You must provide a conversion factor. </div> </div> </md-input-container> </div> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <div class=\"flex-align-middle\" flex-gt-xs flex=\"20\"> <span class=\"padding-bottom-20\">Cocoon amount</span> </div> <md-input-container class=\"md-block\" flex-gt-xs flex=\"80\"> <input flex type=\"number\" aria-label=\"Cocoon amount\" name=\"cocoons\" ng-disabled=\"true\" min=\"0\" ng-model=\"box.cocoons\" ng-required=\"true\"> <div ng-messages=\"boxForm.cocoons.$error\" ng-if=\"boxForm.$submitted || boxForm.cocoons.$touched\"> <div ng-message=\"required\"> You must provide a cocoon amount. </div> </div> </md-input-container> </div> </div> </form> </div>"
  );


  $templateCache.put('views/station3.html',
    "<div class=\"searchdetails\"> <form name=\"productSearchForm\" role=\"form\" ng-submit=\"normalizePath()\" flex-gt-xs=\"50\"> <md-content layout-gt-xs=\"row\" id=\"product-code-search\" class=\"product-code-search layout-gt-xs-row form-row md-no-momentum\"> <md-input-container class=\"md-block\" md-no-float flex-gt-xs> <md-icon class=\"search-img\"><i class=\"material-icons\" ng-click=\"normalizePath()\">search</i></md-icon> <input flex type=\"text\" name=\"product-code-search\" class=\"search-box\" placeholder=\"Search Product Code\" translate-attr=\"{ placeholder: 'harvest.search_product_code' }\" focus-me=\"true\" ng-model=\"activeProduct.Code\" autofocus> </md-input-container> </md-content> <span class=\"md-warn\" ng-show=\"!showSearch\" translate=\"general.code_not_found\">Code not found</span> </form> </div> <div ng-class=\"popClass\" ng-show=\"activeProduct.PROD_ID\" flex> <div class=\"section\"> <h3 translate=\"general.house\">House</h3> <table class=\"table\" ng-show=\"activeProduct.PROD_ID\"> <tr> <th class=\"product-head\" valign=\"middle\" translate=\"general.code\">Code</th> <th class=\"product-head\" valign=\"middle\" translate=\"general.product\"> Product </th> <th class=\"product-head\" valign=\"middle\" translate=\"harvest.beecare_status\"> BeeCare Status </th> </tr> <tr> <td valign=\"bottom\">{{activeProduct.HOUSE_CD}}</td> <td valign=\"bottom\">{{activeProduct.PROD_NAME}}</td> <td valign=\"bottom\"> <div product-progress-indicator product=\"activeProduct\" client-id=\"activeProduct.CLIENT_ID\" users=\"$resolve.users\"></div> </td> </tr> </table> <div layout=\"row\"> <div flex></div> <md-button class=\"md-primary\" ng-click=\"printQRCode()\"> <i class=\"material-icons\">print</i> <span translate=\"harvest.print_qr\">Print QR code</span> </md-button> </div> </div> <div class=\"section\"> <h3 translate=\"general.population\">Population</h3> <div class=\"panel panel-primary\" ng-class=\"getClass(cocoons, 'cocoons')\"> <div class=\"panel-heading panel-accordion\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.cocoons=toggleView(showPanel.cocoons)\"> <h4 style=\"display: inline-block\" translate=\"general.cocoons\">Cocoons</h4> <md-progress-circular class=\"panel-progress-circle\" md-diameter=\"15px\" md-mode=\"indeterminate\" ng-show=\"saveStatus.cocoons=='saving'\"></md-progress-circular> <i class=\"material-icons panel-progress-tick\" ng-show=\"saveStatus.cocoons=='saved'\">done</i> <span flex></span> <button class=\"zero-tubes-btn\" ng-click=\"setZeroPopulation('cocoons')\" ng-show=\"saveStatus.cocoons!='saved' && saveStatus.cocoons!='saving'\"> <span translate=\"cocoons.zero_cocoons\">Zero Cocoons</span> </button> </div> <div class=\"panel-body\" ng-show=\"showPanel.cocoons\"> <ng-form action=\"\" name=\"cocoonForm\"> <div class=\"table-responsive\"> <table class=\"table table-hover centered\"> <tr> <th width=\"200\"><strong translate=\"general.name\">Name</strong></th> <th></th> <th translate=\"general.description\">Description</th> <th width=\"120\" ng-if=\"season > 2019 && season < 2022\"> <strong translate=\"cocoons.weight-g\">Weight</strong> </th> <th width=\"120\" ng-if=\"season > 2021\"> <strong translate=\"cocoons.originalValue\">Original Value</strong> </th> <th width=\"120\"> <strong translate=\"cocoons.number_of_cocoons\">No. of Cocoons</strong> </th> </tr> <tr valign=\"middle\" ng-repeat=\"species in cocoons\" height=\"80\"> <td> <span>{{species.insect + ' (' + species.latin_name + ')'}}</span> </td> <td width=\"100\"> <img ng-src=\"dynamic-images/{{species.filename}}\" alt=\"\" class=\"thumbnail\" ng-click=\"openPreview('dynamic-images/' + species.filename, species.insect)\" tabindex=\"-1\"> </td> <td>{{species.description}}</td> <td ng-if=\"season > 2021\"> <md-input-container class=\"md-block\" flex> {{(osmiaTubes*1 * ratioValue*1) | number : 0}} </md-input-container> </td> <td ng-if=\"season > 2019 && season < 2022\"> <div layout=\"row\"> <md-input-container class=\"md-block\" flex> <input aria-label=\"weight\" name=\"weight{{$index}}\" type=\"text\" ng-model=\"species.weight\" ng-currency currency-symbol=\"\" fraction=\"1\" select-on-click ng-blur=\"cocoonForm['weight' + $index].$dirty && cellBlur('cocoons')\" focus-me=\"{{showPanel.cocoons && $index==0}}\" ng-change=\"updateCocoons()\"> </md-input-container> <!-- Display a waringin if there are more than 6000 cocoons and the product is not a beebreeder --> <span class=\"md-warn warning-icon\" ng-if=\"cocoonForm['weight' + $index].$dirty && species.quantity > 6000 && activeProduct.PROD_ID != 16 && population[0].quantity > 0\"> <md-tooltip md-direction=\"top\">Whoa, That's a lot of cocoons!</md-tooltip> <i class=\"material-icons\">error_outline</i> </span> <!--Show warning when cocoons / tubes > 10 or 0.5 this assumes tha population[0] is the tube record for cornuta--> <span class=\"md-warn warning-icon\" ng-if=\"cocoonForm['weight' + $index].$dirty && species.quantity < 6000 && population[0].quantity && (species.quantity/population[0].quantity > 13 || species.quantity/population[0].quantity < 0.5)\"> <md-tooltip md-direction=\"top\">Cocoons per tubes ratio seems strange.</md-tooltip> <i class=\"material-icons md-warn\">error_outline</i> </span> <!--Show warning when cocoons > 0 and there are no tubes--> <span class=\"md-warn warning-icon\" ng-if=\"species.quantity > 0 && population[0].quantity < 1\"> <md-tooltip md-direction=\"top\">There were no tubes recorded for this species.</md-tooltip> <i class=\"material-icons\">error_outline</i> </span> </div> </td> <td> <md-input-container class=\"md-block\" flex> <input aria-label=\"quantity\" name=\"qty{{$index}}\" type=\"text\" number-input ng-pattern=\"/^[0-9]{1,7}$/\" ng-model=\"species.quantity\" min=\"0\" max=\"{{cocoonLimit}}\" class=\"qty\" ng-disabled=\"season > 2019 && season < 2022\" select-on-click focus-me=\"{{showPanel.cocoons && $index==0 && season < 2020}}\" ng-blur=\"cocoonForm['qty' + $index].$valid && cocoonForm['qty' + $index].$dirty && cellBlur('cocoons')\"> <div ng-messages=\"cocoonForm['qty' + $index].$error\"> <div ng-message=\"max\" translate=\"harvest.exceeded_max\"> you have exceeded the maximum. </div> </div> </md-input-container> </td> <td></td> </tr> </table> </div> </ng-form> </div> </div> <div ng-if=\"seasosn < 2022\" class=\"panel panel-danger\" ng-class=\"getClass(houseParasites, 'cocoonParasites')\"> <div class=\"panel-heading panel-accordion\" layout=\"row\" layout-align=\"start center\" ng-click=\"showPanel.cocoonParasites=toggleView(showPanel.cocoonParasites)\"> <h4 style=\"display: inline-block\" translate=\"harvest.parasites\"> Parasites </h4> <md-progress-circular class=\"panel-progress-circle\" md-diameter=\"15px\" md-mode=\"indeterminate\" ng-show=\"saveStatus.cocoonParasites=='saving'\"></md-progress-circular> <i class=\"material-icons panel-progress-tick\" ng-show=\"saveStatus.cocoonParasites=='saved'\">done</i> <span flex></span> <button class=\"zero-tubes-btn\" ng-click=\"setZeroPopulation('cocoonParasites')\" ng-show=\"saveStatus.cocoonParasites!='saved' && saveStatus.cocoonParasites!='saving'\"> <span translate=\"harvest.zero_parasites\">Zero Parasites</span> </button> </div> <div class=\"panel-body\" ng-show=\"showPanel.cocoonParasites\"> <form action=\"\" name=\"parasiteForm\"> <table class=\"table table-hover\"> <tr> <th width=\"200\" translate=\"general.name\">Name</th> <th></th> <th flex translate=\"general.description\">Description</th> <th width=\"200\" translate=\"harvest.presence\">Presence</th> </tr> <tr ng-repeat=\"species in houseParasites\"> <td class=\"insect-label-td\"> <span>{{species.insect + ' (' + species.latin_name + ')'}}</span> </td> <td width=\"100\"> <img ng-src=\"dynamic-images/{{species.filename}}\" alt=\"\" class=\"thumbnail\" ng-click=\"openPreview('dynamic-images/' + species.filename, species.insect)\" tabindex=\"-1\"> </td> <td>{{species.description}}</td> <td class=\"text-right\"> <md-radio-group name=\"qty{{$index}}\" ng-model=\"species.quantity\" layout=\"row\" focus-me=\"{{showPanel.cocoonParasites && $index==0}}\" ng-blur=\"parasiteForm['qty' + $index].$dirty && cellBlur('cocoonParasites')\"> <md-radio-button value=\"0\" class=\"md-primary\"><span translate=\"harvest.none\">None</span></md-radio-button> <md-radio-button value=\"1\" class=\"red-bg\"> <span translate=\"harvest.present\">Present</span> </md-radio-button> </md-radio-group> </td> </tr> </table> </form> </div> </div> </div> </div>"
  );


  $templateCache.put('views/subscription-modal.html',
    "<md-dialog flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"> <md-toolbar> <div class=\"md-toolbar-tools\"> <h2>{{title}}</h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"cancel\"> <i class=\"material-icons\">clear</i> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout-padding> <br> <div layout-gt-xs=\"row\" class=\"layout-gt-xs-row form-row\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"contractType\">Contract Type</label> <md-select id=\"contractType\" ng-model=\"subscription.contractType\"> <md-option ng-value=\"contract\" ng-repeat=\"contract in contractTypes\"> {{contract.code}} </md-option> </md-select> </md-input-container> <div flex></div> <div class=\"float-right\"> <md-input-container class=\"md-block\" flex-gt-xs> <label for=\"endDate\">End [Season]</label> <md-datepicker id=\"endDate\" ng-model=\"subscription.endDate\" md-placeholder=\"Enter date\"></md-datepicker> </md-input-container> </div> </div> </div> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button ng-click=\"cancel()\" class=\"md-warn\" aria-label=\"cancel\"> Cancel </md-button> <md-button ng-click=\"save()\" class=\"md-primary\" aria-label=\"new\"> Save </md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>"
  );


  $templateCache.put('views/subscriptions-panel.html',
    "<div class=\"section\" id=\"subscription\"> <div layout=\"row\"> <h3>Subscriptions</h3> <div flex></div> <div md-button ng-click=\"subscriptionModal('new')\" class=\"md-primary\"> <i class=\"material-icons\">add</i> New subscription </div> </div> <div class=\"client-products\" ng-if=\"farmer.subscriptions && farmer.subscriptions.length\"> <table class=\"table table-hover\"> <tr> <th>Abo ID</th> <th>Begin</th> <th>End</th> <th>Contract Type</th> <th>Status</th> <th>Cancelled at</th> <th>Cancelled by</th> </tr> <tr ng-repeat=\"(subscriptionIndex, subscription) in subscriptionService.getFilteredSubscriptions(farmer.subscriptions)\" ng-click=\"selectSubscription(subscriptionIndex)\" ng-dblclick=\"subscriptionModal('edit')\" ng-class=\"{'info': subscription.selected}\"> <td class=\"text-center\">{{subscription.ID}}</td> <td>{{subscription.BEGIN_DATE | date:'dd/MM/yyyy'}}</td> <td>{{subscription.END_DATE | date:'dd/MM/yyyy'}}</td> <td class=\"text-center\">{{subscription.CODE}}</td> <td class=\"text-center\">{{getSubscriptionStatus(subscription)}}</td> <td class=\"text-center\">{{subscription.CANC_AT | date:'dd/MM/yyyy'}}</td> <td class=\"text-center\">{{users[subscription.CANC_BY].firstName}}</td> </tr> </table> </div> <div layout=\"row\"> <div flex></div> <div ng-show=\"farmer.activeSubscription.ID\"> <md-menu> <md-button aria-label=\"Open demo menu\" class=\"md-primary\" ng-click=\"$mdMenu.open($event)\"> <i class=\"material-icons\">arrow_drop_down</i> Status </md-button> <md-menu-content width=\"3\"> <md-menu-item> <md-button ng-click=\"cancelSubscription()\" ng-disabled=\"farmer.activeSubscription.END_DATE !== null\">Cancelled</md-button> </md-menu-item> <md-menu-item> <md-button ng-click=\"activeSubscription()\" ng-disabled=\"farmer.activeSubscription.END_DATE === null\">Active</md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <div md-button ng-click=\"subscriptionModal('edit')\" class=\"md-primary\" ng-if=\"farmer.activeSubscription.ID\"> <i class=\"material-icons\">edit</i> Edit </div> </div> </div>"
  );


  $templateCache.put('views/temperature-chart.html',
    "<div class=\"temperature-chart\"> <div layout=\"row\"> <h3 class=\"no-caps\">History</h3> </div> <div class=\"table-responsive\" ng-show=\"chartData.length\" layout-padding> <div id=\"container\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div> <!--<table class=\"table table-hover\">--> <!--<tr>--> <!--<th>Fridge</th>--> <!--<th>Date</th>--> <!--<th>Temperature</th>--> <!--</tr>--> <!--<tr ng-repeat=\"data in chartData\">--> <!--<td>{{data.fridge}}</td>--> <!--<td>{{data.date}}</td>--> <!--<td>{{data.temperature}}</td>--> <!--</tr>--> <!--</table>--> </div> </div>"
  );


  $templateCache.put('views/tracking-number.html',
    "<span ng-if=\"url\"><a class=\"general-link\" href=\"{{url}}\" target=\"_blank\"><i class=\"material-icons\">launch</i></a></span> <span ng-if=\"!url\">{{number}}</span>"
  );


  $templateCache.put('views/tree.html',
    "<md-list-item ng-click=\"rowClickListener(elem)\"> <md-block> <md-checkbox ng-model=\"elem.enabled\" aria-label=\"{{elem.name}}\" ng-change=\"bubbleEvent(elem)\"> <md-tooltip ng-if=\"elem.description\" md-direction=\"top\">{{elem.description}}</md-tooltip> <h3 class=\"padding-top-10\">{{elem.name}}</h3> </md-checkbox> </md-block> <span flex></span> <md-button aria-label=\"button-label\" class=\"md-mini md-primary\" ng-click=\"elem.open = !elem.open\" ng-show=\"elem.children.length > 0\"> <h3> <i ng-show=\"!elem.open\" class=\"material-icons\">keyboard_arrow_down</i> <i ng-show=\"elem.open\" class=\"material-icons\">keyboard_arrow_up</i> </h3> </md-button> </md-list-item> <ul ng-show=\"elem.open\" class=\"tree animated\"> <li ng-repeat=\"children in elem.children\"> <tree elem=\"children\" rights=\"rights\"> </li> </ul>"
  );

}]);
